import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSTimestamp: { input: number; output: number; }
  AWSEmail: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSURL: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
};

export type Query = {
  __typename?: 'Query';
  /** only admin can access the blocked email */
  blockedEmail?: Maybe<BlockedEmail>;
  /** The max number of first is 30 */
  blockedEmails?: Maybe<BlockedEmailConnection>;
  broadcast: Broadcast;
  browseCatalog: BrowseCatalogResponse;
  browseCatalogForChat: BrowseCatalogForChatResponse;
  bulkOrderPdf: Scalars['String']['output'];
  buyer?: Maybe<Buyer>;
  buyerFacets?: Maybe<Array<BuyerFacetsResponse>>;
  buyerStockCount: BuyerStockCountResponse;
  buyerStockCounts: BuyerStockCountsResponse;
  buyerStockInventory: BuyerStockInventoryResponse;
  buyerStockInventoryExportUrl: BuyerStockInventoryExportUrlResponse;
  buyerUser?: Maybe<BuyerUser>;
  buyerUsers: Array<BuyerUser>;
  /** get the cart */
  cart?: Maybe<CartResponse>;
  /** Query to get the current status of a catalog import job. */
  catalogImportStatus: CatalogImportStatusResponse;
  /** Query to get the catalog import template. */
  catalogImportTemplate: CatalogImportTemplateResponse;
  /** Query to get the list of catalog imports. */
  catalogImports: CatalogImportsResponse;
  categoryProducts: Array<CategoryProducts>;
  chat?: Maybe<Chat>;
  chatHasSupplierEmailSupport: ChatHasSupplierEmailSupportResponse;
  /** Get supplier chat-level notification preferences */
  chatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  chatProducts?: Maybe<Array<Product>>;
  /**
   * return a sub catalog of chat, ACL: chat user
   * @deprecated use browseCatalogForChat query instead
   */
  chatSubCatalogProducts: ChatSubCatalogProductsResponse;
  /** Get chatUsers by chatId XOR userId */
  chatUsers: Array<ChatUser>;
  /**
   * If you're logged in as an admin you need to provide a userId
   * If you're logged in as a Choco user, it returns the requested chats for _your_ userId
   */
  chats: UserChatConnection;
  /**
   * For use during the by a supplier invitation flow
   * Returns true if there is no buyer with a matching googlePlaceId
   * Returns true if there is a buyer with a matching googlePlaceId
   * and the supplier does not have a chat with that buyer
   * Returns false if a buyer exists with a matching googlePlaceId
   * and the supplier already has a chat with that buyer
   */
  checkInviteeGooglePlace: Scalars['Boolean']['output'];
  countSupplierChats: Scalars['Int']['output'];
  exportSupplierProducts: Array<Product>;
  fetchBuyerReportDownloadUrl: FetchBuyerReportDownloadUrlResponse;
  fetchCatalogCategories: Array<CatalogCategory>;
  fetchCatalogCategoriesForChat: FetchCatalogCategoriesForChatResponse;
  fetchOrderGuide: OrderGuideResponse;
  fetchProductVariantsForBuyer?: Maybe<Array<Product>>;
  /** Generate the quicksight embed dashboard url for an anonymous user */
  generateEmbedDashboardUrl: EmbedDashboardUrlResponse;
  /** Fetch all buyer report schedules created by user */
  getAllBuyerReportSchedules: GetAllBuyerReportSchedulesResponse;
  /**
   * Returns the deliverySetting that is used for a specific chat.
   * This query is used by mobile applications.
   *
   * If there is only a chat setting, the chat setting will be returned.
   * If there is only a supplier setting, the supplier setting will be returned.
   * if there are both, a supplier and a chat setting, the cutoffTimes will correspond to the chat setting,
   * while the exceptions will be an aggregate of supplier and chat setting.
   *
   * If no setting exists for this chat, a default setting will be returned.
   * On this default setting, every weekday will be of type 'NoCutoff'
   */
  getAppliedChatDeliverySetting?: Maybe<AppliedChatDeliverySettingResponse>;
  /** Accepts promotion title and message and returns a list of suggested by AI products */
  getBroadcastProductsSuggestions?: Maybe<SuggestedProductResult>;
  getCatalogUploadUrl: GetCatalogUploadUrlResponse;
  /** Get the number of chats that have an email as an additionalEmail */
  getChatCountByCCEmail: GetChatCountByCcEmailResponse;
  getChatSuppliersByLocations: GetChatSuppliersByLocationsResponse;
  getChatsForSubCatalog: GetChatsForSubCatalogResponse;
  getConnectedAccounts: GetConnectedAccountsResponse;
  getConnectedIntegrationAdapters: GetConnectedIntegrationAdaptersResponse;
  /** @deprecated we no longer support it */
  getCurrentPayment: CurrentPaymentResponse;
  getEmailLists: GetEmailListsResponse;
  getFeatureFlags: GetFeatureFlagsResponse;
  getGroup?: Maybe<GroupResponse>;
  getGroupEntities?: Maybe<GetGroupEntitiesResponse>;
  getGroupUsers?: Maybe<GetGroupUsersResponse>;
  getIntegrationAdapters: GetIntegrationAdaptersResponse;
  /** Invite Transmission Status */
  getInviteTransmissionStatus: GetInviteTransmissionStatusResponse;
  /**
   * As a supplier: check if an invitee already has a choco account
   * If no: returns UserNotFound type
   * If yes: returns paginated list of buyers the invitee is connected to
   * that the supplier does not have a chat with.
   */
  getInviteeBuyers?: Maybe<GetInviteeBuyersResponse>;
  getInvoiceAttachment?: Maybe<InvoiceAttachment>;
  /** @deprecated we no longer support it */
  getKyc?: Maybe<Kyc>;
  getLastMessageFromChat?: Maybe<MessagesFromChatResult>;
  getLocationsBySupplier: LocationsBySupplierResponse;
  getMarketingMessageSuggestions: MarketingMessageSuggestionsResult;
  getOmniChannelOrder: GetOmniChannelOrderResponse;
  getOmniChannelOrderV2: GetOmniChannelOrderResponse;
  getOnboardingChecklist: GetOnboardingChecklistResponse;
  getOrderChanges?: Maybe<OrderChange>;
  /** Fetch entire delivery check */
  getOrderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  getOrderExcelUrl?: Maybe<Scalars['String']['output']>;
  /** For internal use, retrieves the order preference of a supplier */
  getOrderPreference?: Maybe<OrderPreference>;
  getProductsForChat: GetProductsForChatResponse;
  getQboCustomersAndOrderGuidesToImport: GetQboCustomersAndOrderGuidesToImportResponse;
  getReconciliationRequestPlanBySupplierId?: Maybe<GetReconciliationRequestPlanBySupplierIdResponse>;
  getReferral?: Maybe<GetReferralResponse>;
  getRequestsToJoin: GetRequestsToJoinResponse;
  getSmsMessageByMessageSid: GetSmsMessageByMessageSidResponse;
  getSmsMessagesFromPhoneNumber: GetSmsMessagesFromPhoneNumberResponse;
  getSubCatalog?: Maybe<GetSubCatalogResponse>;
  getSubCatalogsForChat: GetSubCatalogsForChatResponse;
  getSupplierApplications: GetSupplierApplicationsResponse;
  getSupplierProducts: GetSupplierProductsResponse;
  /**
   * For internal use, submit list of buyer ids and a supplier id
   * Returns which buyers the supplier does not have a chat with
   */
  getUnconnectedBuyerIds: GetUnconnectedBuyerIdsResult;
  getUserIntercomCredentials: UserIntercomCredentialsResponse;
  getWhatsAppMessageByMessageSid: GetWhatsAppMessageByMessageSidResponse;
  hasUserCompletedDeliveryCheck: HasUserCompletedDeliveryCheckResponse;
  inventoryDownloadJobs: InventoryDownloadJobsResponse;
  inventorySuppliers: InventorySuppliersResponse;
  inventoryUploadJob: InventoryUploadJobResponse;
  inventoryUploadTemplate: InventoryUploadTemplateResponse;
  isUserInChat: Scalars['Boolean']['output'];
  /** @deprecated we no longer support it */
  listPaymentAccounts: ListPaymentAccountsResponse;
  listSubCatalogProducts?: Maybe<ListSubCatalogProductsResponse>;
  /**
   * ACL: Choco Admin, SupplierAdmins && SupplierSalesReps
   * supplierEntityId can be undefined when it's requested by a supplier user
   */
  listSubCatalogs?: Maybe<ListSubCatalogsResponse>;
  lookupPhoneNumbers: LookupPhoneNumbersResponse;
  message?: Maybe<Message>;
  messages: ChatMessageConnection;
  /**
   * For internal use,
   * - fetch list of messages which are not sent via email and chat
   * - fetch last messages from chat
   * This two queries are executed from choco-notification only
   * Return type is kept exactly similar to the table schema since it is used as is in choco-notification
   */
  messagesNotSentViaEmailAndChat: Array<MessagesFromChatResult>;
  metaLobby?: Maybe<MetaLobbyResponse>;
  /**
   * Get individual order by id or referenceId
   * Only one identifier should be provided
   */
  order?: Maybe<Order>;
  orderGuideV2Categories: OrderGuideV2CategoriesResponse;
  orderGuideV2ItemUnits: OrderGuideV2ItemUnitsResponse;
  ordersToReview: OrdersToReviewResponse;
  /** @deprecated we no longer support it */
  paymentOptions: PaymentOptionsResponse;
  product?: Maybe<Product>;
  productListCategories?: Maybe<Array<ProductCategory>>;
  /** @deprecated use searchProducts/supplierSearch/userSearch query instead */
  search: SearchResult;
  /**
   * Query used to detect existing buyers.
   * Returns a list of buyers based on the provided criteria.
   * Does not support pagination - input parameter "first" will be ignored.
   */
  searchBuyer: SearchBuyerResponse;
  searchGroups?: Maybe<SearchGroupsResponse>;
  searchOrder: SearchOrderResponse;
  searchOrderDeskCustomer: SearchOrderDeskCustomerResponse;
  /** @deprecated use browseCatalog query instead */
  searchProducts?: Maybe<SearchProductsResponse>;
  searchTaxonomyLabels?: Maybe<SearchTaxonomyLabelsResponse>;
  sendSampleSmsMessage: SendSampleSmsMessageResponse;
  sharedBroadcastProducts?: Maybe<SharedBroadcastProducts>;
  stockCountSessions: StockCountSessionsResponse;
  stockCountUsers: StockCountUsersResponse;
  storageAreas: StorageAreasResponse;
  supplier?: Maybe<Supplier>;
  supplierAssortments: SupplierAssortments;
  supplierChatLabels?: Maybe<Array<ChatLabelsResult>>;
  /** Returns the available delivery dates, used in the checkout process when creating an order. */
  supplierDeliveryDateSettings?: Maybe<SupplierDeliveryDateSettingsResponse>;
  /**
   * Returns the deliverySetting for a supplier.
   * The input can be a chat- or supplier-id.
   * If the input is a chatId, the return value will be a chat-setting or null.
   */
  supplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  supplierSearch: SupplierSearchResponse;
  supplierSearchV2: SupplierSearchResponse;
  /** Get all transmission events of an order (ofId=orderId). Sorted by timestamp (descending). */
  transmissionEvents: Array<TransmissionEvent>;
  user?: Maybe<User>;
  /** The query will currently be used to obtain chats for both buyer chats and user chats */
  userChats: UserChatsResponse;
  userSearch: UserSearchResponse;
  validateProductsAvailability: ValidateProductsAvailabilityResponse;
  /**
   * Looks up vendor catalog categories for a given chat based on the provided filters.
   * This query returns only the categories that are visible to the buyer and have at least one item available for this chat.
   * The results are ordered by the translated category name.
   */
  vendorItemCategoriesForChat: VendorItemCategoriesForChatResponse;
  /** Returns vendor items by their ids */
  vendorItems: VendorItemsResponse;
  /**
   * Returns count of vendor items for a given chat based on the provided filters.
   * Note that only one item per variant group is considered.
   * This corresponds to the result of the `vendorItemsForChat` query.
   */
  vendorItemsCountForChat: VendorItemsCountForChatResponse;
  /**
   * Looks up vendor items for a given chat based on the provided filters.
   * This query returns only the default units for each item, and only the default item variant for each variant group.
   * The results are ordered by the translated item name.
   */
  vendorItemsForChat: VendorItemsForChatResponse;
  /**
   * Looks up vendor items for a given vendor based on the provided filters.
   * This query returns all units for each item without the grouping by variantGroupCode or id.
   */
  vendorItemsForVendor: VendorItemsForVendorResponse;
};


export type QueryBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryBlockedEmailsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBroadcastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrowseCatalogArgs = {
  input: BrowseCatalogInput;
};


export type QueryBrowseCatalogForChatArgs = {
  input: BrowseCatalogForChatInput;
};


export type QueryBulkOrderPdfArgs = {
  orderIds: Array<Scalars['ID']['input']>;
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuyerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuyerStockCountArgs = {
  input: GetBuyerStockCountInput;
};


export type QueryBuyerStockCountsArgs = {
  input: GetBuyerStockCountsInput;
};


export type QueryBuyerStockInventoryArgs = {
  filter: GetBuyerStockInventoryProductsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};


export type QueryBuyerStockInventoryExportUrlArgs = {
  input: GetBuyerStockInventoryExportUrlInput;
};


export type QueryBuyerUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBuyerUsersArgs = {
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryCatalogImportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCatalogImportsArgs = {
  input: CatalogImportsInput;
};


export type QueryCategoryProductsArgs = {
  chatId: Scalars['ID']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryChatHasSupplierEmailSupportArgs = {
  chatId: Scalars['ID']['input'];
  checkExcludedSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatNotificationPreferencesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatProductsArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatSubCatalogProductsArgs = {
  input?: InputMaybe<ChatSubCatalogProductsInput>;
};


export type QueryChatUsersArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
};


export type QueryCheckInviteeGooglePlaceArgs = {
  googlePlaceId: Scalars['String']['input'];
};


export type QueryCountSupplierChatsArgs = {
  supplierEntityId: Scalars['String']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  chatStatus?: InputMaybe<ChatStatus>;
};


export type QueryExportSupplierProductsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFetchBuyerReportDownloadUrlArgs = {
  input: FetchBuyerReportDownloadUrlInput;
};


export type QueryFetchCatalogCategoriesArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFetchCatalogCategoriesForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryFetchOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
  product: OrderGuideProductArgs;
};


export type QueryFetchProductVariantsForBuyerArgs = {
  chatId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetAllBuyerReportSchedulesArgs = {
  input: GetAllBuyerReportSchedulesInput;
};


export type QueryGetAppliedChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetBroadcastProductsSuggestionsArgs = {
  title?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QueryGetCatalogUploadUrlArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetChatCountByCcEmailArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type QueryGetChatSuppliersByLocationsArgs = {
  input: GetChatSuppliersByLocationsInput;
};


export type QueryGetChatsForSubCatalogArgs = {
  subCatalogId: Scalars['ID']['input'];
};


export type QueryGetConnectedAccountsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<ConnectedAccountInput>;
};


export type QueryGetConnectedIntegrationAdaptersArgs = {
  input: GetConnectedIntegrationAdaptersInput;
};


export type QueryGetCurrentPaymentArgs = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEmailListsArgs = {
  input: GetEmailListsInput;
};


export type QueryGetGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetGroupEntitiesArgs = {
  input: GetGroupEntitiesInput;
};


export type QueryGetGroupUsersArgs = {
  input: GetGroupUsersInput;
};


export type QueryGetIntegrationAdaptersArgs = {
  input: GetIntegrationAdaptersInput;
};


export type QueryGetInviteTransmissionStatusArgs = {
  input: GetInviteTransmissionStatus;
};


export type QueryGetInviteeBuyersArgs = {
  phone: Scalars['String']['input'];
};


export type QueryGetInvoiceAttachmentArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetKycArgs = {
  buyerId: Scalars['ID']['input'];
};


export type QueryGetLastMessageFromChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetLocationsBySupplierArgs = {
  supplierEntityId: Scalars['ID']['input'];
};


export type QueryGetMarketingMessageSuggestionsArgs = {
  currentMessage: Scalars['String']['input'];
};


export type QueryGetOmniChannelOrderArgs = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOmniChannelOrderV2Args = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOnboardingChecklistArgs = {
  buyerId: Scalars['ID']['input'];
};


export type QueryGetOrderChangesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrderDeliveryCheckArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderExcelUrlArgs = {
  orderId: Scalars['ID']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrderPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductsForChatArgs = {
  input: GetProductsForChatInput;
};


export type QueryGetQboCustomersAndOrderGuidesToImportArgs = {
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReconciliationRequestPlanBySupplierIdArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetReferralArgs = {
  input: GetReferralInput;
};


export type QueryGetRequestsToJoinArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: GetRequestsToJoinInput;
};


export type QueryGetSmsMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryGetSmsMessagesFromPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
};


export type QueryGetSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubCatalogsForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetSupplierApplicationsArgs = {
  query?: InputMaybe<GetSupplierApplicationsInput>;
};


export type QueryGetSupplierProductsArgs = {
  input: GetSupplierProductsInput;
};


export type QueryGetUnconnectedBuyerIdsArgs = {
  buyerIds: Array<Scalars['String']['input']>;
  supplierId: Scalars['String']['input'];
  ignoreDisabledChats?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWhatsAppMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryHasUserCompletedDeliveryCheckArgs = {
  chatId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInventoryDownloadJobsArgs = {
  input: InventoryDownloadJobsInput;
};


export type QueryInventorySuppliersArgs = {
  input: InventorySuppliersInput;
};


export type QueryInventoryUploadJobArgs = {
  input: InventoryUploadJobInput;
};


export type QueryInventoryUploadTemplateArgs = {
  input: InventoryUploadTemplateInput;
};


export type QueryIsUserInChatArgs = {
  userId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};


export type QueryListPaymentAccountsArgs = {
  owner?: InputMaybe<PaymentAccountOwnerInput>;
};


export type QueryListSubCatalogProductsArgs = {
  input: ListSubCatalogProductsInput;
};


export type QueryListSubCatalogsArgs = {
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLookupPhoneNumbersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  chatId: Scalars['ID']['input'];
  groupBy?: InputMaybe<MessageGroupFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessagesNotSentViaEmailAndChatArgs = {
  chatId: Scalars['ID']['input'];
  isSupplier: Scalars['Boolean']['input'];
};


export type QueryMetaLobbyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderGuideV2CategoriesArgs = {
  input: OrderGuideV2CategoriesInput;
};


export type QueryOrderGuideV2ItemUnitsArgs = {
  input: OrderGuideV2ItemUnitsInput;
};


export type QueryOrdersToReviewArgs = {
  input: OrdersToReviewInput;
};


export type QueryPaymentOptionsArgs = {
  input: PaymentOptionsInput;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductListCategoriesArgs = {
  chatId: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  query: SearchInput;
};


export type QuerySearchBuyerArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SearchBuyerInput;
};


export type QuerySearchGroupsArgs = {
  input: SearchGroupsInput;
};


export type QuerySearchOrderArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query: SearchOrderInput;
  sort?: InputMaybe<Sort>;
};


export type QuerySearchOrderDeskCustomerArgs = {
  input: SearchOrderDeskCustomerInput;
};


export type QuerySearchProductsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  input: SearchProductsInput;
};


export type QuerySearchTaxonomyLabelsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  input: SearchTaxonomyLabelsInput;
};


export type QuerySendSampleSmsMessageArgs = {
  input: SendSampleSmsMessageInput;
};


export type QuerySharedBroadcastProductsArgs = {
  broadcastId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};


export type QueryStockCountSessionsArgs = {
  input: StockCountSessionsInput;
  pagination?: InputMaybe<StockCountSessionsPaginationInput>;
};


export type QueryStockCountUsersArgs = {
  input: StockCountUsersInput;
};


export type QueryStorageAreasArgs = {
  input: StorageAreasInput;
};


export type QuerySupplierArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  botUserId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierChatLabelsArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  asBotUser?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupplierDeliveryDateSettingsArgs = {
  chatId: Scalars['ID']['input'];
};


export type QuerySupplierDeliverySettingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  query: SupplierSearchInput;
};


export type QuerySupplierSearchV2Args = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinateInput;
  filter?: InputMaybe<SupplierSearchV2Filter>;
};


export type QueryTransmissionEventsArgs = {
  ofId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query: UserSearchInput;
};


export type QueryValidateProductsAvailabilityArgs = {
  input: ValidateProductsAvailabilityInput;
};


export type QueryVendorItemCategoriesForChatArgs = {
  input: VendorItemCategoriesForChatInput;
};


export type QueryVendorItemsArgs = {
  input: VendorItemsInput;
};


export type QueryVendorItemsCountForChatArgs = {
  input: VendorItemsCountForChatInput;
};


export type QueryVendorItemsForChatArgs = {
  input: VendorItemsForChatInput;
};


export type QueryVendorItemsForVendorArgs = {
  input: VendorItemsForVendorInput;
};

export type BlockedEmail = Node & {
  __typename?: 'BlockedEmail';
  id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type BlockedEmailConnection = Connection & {
  __typename?: 'BlockedEmailConnection';
  edges?: Maybe<Array<BlockedEmailEdge>>;
};

export type Connection = {
  edges?: Maybe<Array<Edge>>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type BlockedEmailEdge = Edge & {
  __typename?: 'BlockedEmailEdge';
  cursor: Scalars['String']['output'];
  node: BlockedEmail;
};

export type Broadcast = Node & {
  __typename?: 'Broadcast';
  analytics?: Maybe<BroadcastAnalytics>;
  attachment?: Maybe<BroadcastMediaAttachment>;
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
  chatLabels?: Maybe<Array<Scalars['String']['output']>>;
  chats?: Maybe<Array<Chat>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  customerPerformance?: Maybe<BroadcastCustomerPerformanceResult>;
  endsAt?: Maybe<BroadCastEndsAt>;
  id: Scalars['ID']['output'];
  media?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextScheduledDispatch?: Maybe<Scalars['AWSTimestamp']['output']>;
  pdfName?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  productPerformance?: Maybe<BroadcastProductPerformanceResult>;
  products?: Maybe<Array<Product>>;
  recipientCount?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<OneTimeBroadcastSchedule>;
  sendToAll?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<User>;
  senderUserId?: Maybe<Scalars['ID']['output']>;
  status: BroadcastStatus;
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type BroadcastChatsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type BroadcastCustomerPerformanceArgs = {
  sort?: InputMaybe<Sort>;
  filter?: InputMaybe<BroadcastCustomerPerformanceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type BroadcastProductPerformanceArgs = {
  sort?: InputMaybe<Sort>;
};


export type BroadcastProductsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BroadcastAnalytics = {
  __typename?: 'BroadcastAnalytics';
  numChats: Scalars['Int']['output'];
  numChatsOpened: Scalars['Int']['output'];
  numChatsClicked: Scalars['Int']['output'];
  numChatsAddedProductsToOrderGuide: Scalars['Int']['output'];
  numChatsProductsOrdered: Scalars['Int']['output'];
  hasProducts: Scalars['Boolean']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  reportUpdatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type BroadcastMediaAttachment = {
  __typename?: 'BroadcastMediaAttachment';
  image?: Maybe<BroadcastMedia>;
  pdf?: Maybe<BroadcastPdfMedia>;
};

export type BroadcastMedia = {
  __typename?: 'BroadcastMedia';
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BroadcastPdfMedia = {
  __typename?: 'BroadcastPdfMedia';
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  pdfName?: Maybe<Scalars['String']['output']>;
};

export type Chat = Node & {
  __typename?: 'Chat';
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  additionalEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated use supplierEntityId instead */
  botUserId?: Maybe<Scalars['ID']['output']>;
  buyer?: Maybe<Buyer>;
  cart?: Maybe<Cart>;
  chatName?: Maybe<Scalars['String']['output']>;
  churn?: Maybe<ChatChurn>;
  createdBy?: Maybe<CreatedBy>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** delivery settings of chat which was previously used from supplierDeliveryDateSettings query */
  deliveryDateSettings?: Maybe<SupplierDeliveryDateSettings>;
  enabled: Scalars['Boolean']['output'];
  hasMessages?: Maybe<Scalars['Boolean']['output']>;
  hasOrderTransmission?: Maybe<Scalars['Boolean']['output']>;
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  hasRequestedOrderGuide?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true if there is at least one vendor catalog item in the scope of visibility of this chat.
   * This does not include custom vendor items.
   */
  hasVendorCatalog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<InviteTransmission>;
  /** Status of the most advanced invite sent for this chat; there could be many invites for one chat, but we pick the most advanced invote */
  inviteStatus?: Maybe<InviteStatus>;
  /** True if chat is a test chat on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isUserInChat?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  messages: ChatMessageConnection;
  orderGuide?: Maybe<OrderGuideV2Ref>;
  products?: Maybe<Array<Product>>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  sendBuyerOrderConfirmation?: Maybe<Scalars['Boolean']['output']>;
  status: ChatStatus;
  subCatalog?: Maybe<SubCatalog>;
  subCatalogId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated use supplierEntity instead */
  supplier?: Maybe<User>;
  supplierCustomerName?: Maybe<Scalars['String']['output']>;
  supplierEntity?: Maybe<Supplier>;
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<ChatType>;
  users: ChatUserConnection;
};


export type ChatIsUserInChatArgs = {
  userId: Scalars['ID']['input'];
};


export type ChatMessagesArgs = {
  groupBy?: InputMaybe<MessageGroupFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

export type Buyer = Node & {
  __typename?: 'Buyer';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  fullAddress: Scalars['String']['output'];
  addressSource: AddressSource;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  googlePlaceAddressId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** offset from UTC in minutes */
  utcOffset?: Maybe<Scalars['Int']['output']>;
  deliveryComment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  users?: Maybe<BuyerUserConnection>;
  profileImage?: Maybe<ProfileImage>;
  chats?: Maybe<BuyerChatConnection>;
  invoiceRecipientEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  rolesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** True if buyer is a test buyer on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevelOne?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated we no longer support it */
  kyc?: Maybe<Kyc>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  createdContext?: Maybe<BuyerCreatedContext>;
  status?: Maybe<BuyerStatus>;
};


export type BuyerUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type BuyerChatsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

export enum AddressSource {
  Google = 'google',
  Custom = 'custom'
}

export type BuyerUserConnection = Connection & {
  __typename?: 'BuyerUserConnection';
  edges: Array<BuyerUserEdge>;
};

export type BuyerUserEdge = Edge & {
  __typename?: 'BuyerUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
  role?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  /** filename of image for internal use only */
  image?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  hasAcceptedTermsAndConditions: Scalars['Boolean']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  buyers?: Maybe<UserBuyerConnection>;
  chats: UserChatConnection;
  /** @deprecated user {Query.buyerUsers} relationship instead */
  businessName?: Maybe<Scalars['String']['output']>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  /** @deprecated use user { paginatedContacts } instead */
  contacts?: Maybe<Array<Maybe<User>>>;
  supplier: Scalars['Boolean']['output'];
  /** To enable user login with daily code */
  chocoUser?: Maybe<Scalars['Boolean']['output']>;
  suppliers?: Maybe<Array<Maybe<User>>>;
  paginatedContacts: UserUserConnection;
  paginatedSuppliers: UserUserConnection;
  orderPreference?: Maybe<OrderPreference>;
  supplierId?: Maybe<Scalars['String']['output']>;
  botUser?: Maybe<Scalars['Boolean']['output']>;
  profileImage?: Maybe<ProfileImage>;
  role?: Maybe<Array<Maybe<Role>>>;
  linkedSupplier?: Maybe<Supplier>;
  /** this flag is to enable proper data report on a user */
  isTest?: Maybe<Scalars['Boolean']['output']>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy: Scalars['Boolean']['output'];
  /** @deprecated not supported due to the migration to Invite Flow V2 */
  inviteData?: Maybe<InviteInfo>;
  translationLanguage?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['AWSDate']['output']>;
  referral?: Maybe<GetReferralResponse>;
  hasRequestedToBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** submittedGetIntouchRequest: always false if the user is a buyer user, and true if the user is a supplier user and has made a request to be contacted for premium details at least once */
  submittedGetIntouchRequest?: Maybe<Scalars['Boolean']['output']>;
  createdContext?: Maybe<UserCreatedContext>;
  inviteTransmissions?: Maybe<Array<InviteTransmission>>;
  challengeByEmail?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberType?: Maybe<UserPhoneType>;
};


export type UserBuyersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type UserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
};


export type UserPaginatedContactsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};


export type UserPaginatedSuppliersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

export type UserBuyerConnection = Connection & {
  __typename?: 'UserBuyerConnection';
  edges: Array<UserBuyerEdge>;
};

export type UserBuyerEdge = Edge & {
  __typename?: 'UserBuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
  role?: Maybe<Scalars['String']['output']>;
};

export enum ChatStatus {
  Active = 'active',
  Archived = 'archived',
  Pending = 'pending',
  Requested = 'requested'
}

export type UserChatConnection = Connection & {
  __typename?: 'UserChatConnection';
  edges?: Maybe<Array<UserChatEdge>>;
};

export type UserChatEdge = Edge & {
  __typename?: 'UserChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type UserUserConnection = Connection & {
  __typename?: 'UserUserConnection';
  edges?: Maybe<Array<UserUserEdge>>;
};

export type UserUserEdge = Edge & {
  __typename?: 'UserUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type OrderPreference = {
  __typename?: 'OrderPreference';
  pdf?: Maybe<Scalars['Boolean']['output']>;
  xlsx?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated fax is no longer supported */
  fax?: Maybe<Scalars['String']['output']>;
  sms?: Maybe<Scalars['String']['output']>;
  whatsApp?: Maybe<Scalars['String']['output']>;
  welcomeNotificationSent?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  /** url to put new profile image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded profile image */
  url?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of profile image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of profile image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 900x900 pixel crop of profile image */
  largeSquare?: Maybe<Scalars['String']['output']>;
  /** url of 60x60 pixel crop of profile image */
  smallThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 120x120 pixel crop of profile image */
  mediumThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 180x180 pixel crop of profile image */
  largeThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 1125 x 600 crop of cover photo, this is only valid for supplier coverPhoto */
  largeRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 750 x 400 crop of cover photo, this is only valid for supplier coverPhoto */
  mediumRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 375 x 200 crop of cover photo, this is only valid for supplier coverPhoto */
  smallRectangle?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  SupplierSalesReps = 'supplierSalesReps',
  SupplierAdmins = 'supplierAdmins'
}

export type Supplier = Node & {
  __typename?: 'Supplier';
  accessPackage: AccessPackage;
  allowCustomProducts: Scalars['Boolean']['output'];
  allowCustomerAcquisition?: Maybe<Scalars['Boolean']['output']>;
  allowOnlyOneActiveVariant?: Maybe<Scalars['Boolean']['output']>;
  /** Returns Supplier Level or Buyer Level MOV */
  appliedMinimumOrderValue?: Maybe<MinimumOrderValueResponse>;
  botUser?: Maybe<User>;
  botUserId: Scalars['String']['output'];
  catalogProductsCount?: Maybe<Scalars['Int']['output']>;
  contactEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  coverPhoto?: Maybe<ProfileImage>;
  customerNumberMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: Maybe<Scalars['String']['output']>;
  defaultSubCatalog?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  deliveryDateMandatory: Scalars['Boolean']['output'];
  /** delivery settings of suppliers which was previously used from supplierDeliverySetting query */
  deliverySetting?: Maybe<SupplierDeliverySetting>;
  deliveryZones?: Maybe<Array<DeliveryZone>>;
  /** short description of supplier to be shown during supplier discovery */
  description?: Maybe<Scalars['String']['output']>;
  hasCoverPhoto?: Maybe<Scalars['Boolean']['output']>;
  hasEnabledCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  hasEnabledFractionalUnits?: Maybe<Scalars['Boolean']['output']>;
  hasProfilePhoto?: Maybe<Scalars['Boolean']['output']>;
  /** this value is duplicate of hasEnabledCatalogProducts, added for data analysis */
  hasValidCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  integration: Array<IntegrationOption>;
  /** indicates whether a supplier can be discovered via search */
  isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled: Scalars['Boolean']['output'];
  isIntegrated?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled: Scalars['Boolean']['output'];
  /** True if supplier is a test supplier on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  minOrder?: Maybe<MinOrder>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noDefaultCatalog?: Maybe<Scalars['Boolean']['output']>;
  orderExportFormat?: Maybe<OrderExportConfigFormat>;
  orderExportUpload?: Maybe<OrderExportUploadOption>;
  /**
   * Auth: admins and supplier admins
   * @deprecated we no longer support it
   */
  paymentAccounts: ListPaymentAccountsResponse;
  phone?: Maybe<Scalars['String']['output']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: Maybe<PriceSetting>;
  primaryAssortment?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  secondaryAssortments?: Maybe<Array<Scalars['String']['output']>>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Paginated list of users connected to the supplier */
  users?: Maybe<SupplierUserConnection>;
};


export type SupplierAppliedMinimumOrderValueArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type SupplierUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum AccessPackage {
  Trial = 'trial',
  Free = 'free',
  Verified = 'verified',
  Premium = 'premium',
  LeadGen = 'leadGen'
}

export type MinimumOrderValueResponse = MinimumOrderValue | MinimumOrderValueFailure | AuthorizationFailure | InputValidationFailure;

export type MinimumOrderValue = {
  __typename?: 'MinimumOrderValue';
  type?: Maybe<MinimumOrderValueType>;
  minimumOrderValue?: Maybe<MinOrder>;
  formattedMinimumOrderValue?: Maybe<Scalars['String']['output']>;
};

export enum MinimumOrderValueType {
  SupplierLevel = 'supplierLevel',
  CustomerLevel = 'customerLevel'
}

export type MinOrder = {
  __typename?: 'MinOrder';
  price?: Maybe<Money>;
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
};

export type MinimumOrderValueFailure = {
  __typename?: 'MinimumOrderValueFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ResponseType {
  Success = 'success',
  Error = 'error'
}

export type AuthorizationFailure = AppsyncResponse & AppsyncError & {
  __typename?: 'AuthorizationFailure';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type AppsyncResponse = {
  responseType: ResponseType;
};

export type AppsyncError = {
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type InputValidationFailure = AppsyncResponse & AppsyncError & {
  __typename?: 'InputValidationFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  invalidFields?: Maybe<Array<FieldValidationError>>;
};

export type FieldValidationError = {
  __typename?: 'FieldValidationError';
  fieldName: Scalars['String']['output'];
  /** Computer readable error message */
  reason: Scalars['String']['output'];
};

export type SupplierDeliverySetting = {
  __typename?: 'SupplierDeliverySetting';
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['output'];
  /** @deprecated Use cutoffTimes & cutoffType */
  cutOffTime?: Maybe<CutOffTime>;
  /**
   * Sunday - Saturday : 0 - 6
   * @deprecated Use cutoffTimes
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  /** @deprecated Use scope */
  type: SupplierDeliverySettingType;
  scope: SupplierDeliverySettingScope;
  cutoffTimes: WeekdayBasedCutoffSettings;
  /** This field aggregates the cutoffType for each provided day. If the type is not the same for all the provided days, it will be null. */
  cutoffType?: Maybe<CutOffTimeType>;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
  exceptions?: Maybe<Array<DeliverySettingException>>;
};

export type CutOffTime = {
  __typename?: 'CutOffTime';
  type: CutOffTimeType;
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['output'];
};

export enum CutOffTimeType {
  Strict = 'strict',
  Flexible = 'flexible',
  NoCutoff = 'noCutoff'
}

export enum SupplierDeliverySettingType {
  Supplier = 'supplier',
  Chat = 'chat'
}

export enum SupplierDeliverySettingScope {
  Supplier = 'supplier',
  Chat = 'chat'
}

export type WeekdayBasedCutoffSettings = {
  __typename?: 'WeekdayBasedCutoffSettings';
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  mon?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  tue?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  wed?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  thu?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  fri?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sat?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sun?: Maybe<CutoffSetting>;
};

export type CutoffSetting = NoCutoffSetting | WithCutoffSetting;

export type NoCutoffSetting = {
  __typename?: 'NoCutoffSetting';
  type: NoCutoffType;
};

export enum NoCutoffType {
  NoCutoff = 'noCutoff'
}

export type WithCutoffSetting = {
  __typename?: 'WithCutoffSetting';
  type: WithCutoffType;
  /** in days */
  leadTime: Scalars['Int']['output'];
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime: Scalars['AWSTime']['output'];
};

export enum WithCutoffType {
  Strict = 'strict',
  Flexible = 'flexible'
}

export type DeliverySettingException = SingleDayDeliveryExceptionWithCutoff | SingleDayDeliveryExceptionWithoutCutoff | NoDeliveryException;

export type SingleDayDeliveryExceptionWithCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithCutoff';
  type: SingleDayDeliveryExceptionType;
  date: Scalars['AWSDate']['output'];
  cutoffType: WithCutoffType;
  leadTimeAdjustedCutoff: Scalars['AWSDateTime']['output'];
  updateBehavior: DeliverySettingExceptionUpdateBehavior;
};

export enum SingleDayDeliveryExceptionType {
  SingleDayDeliveryException = 'singleDayDeliveryException'
}

export enum DeliverySettingExceptionUpdateBehavior {
  CutoffChanged = 'cutoffChanged',
  AdditionalDelivery = 'additionalDelivery'
}

export type SingleDayDeliveryExceptionWithoutCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithoutCutoff';
  type: SingleDayDeliveryExceptionType;
  date: Scalars['AWSDate']['output'];
  cutoffType: NoCutoffType;
  updateBehavior: DeliverySettingExceptionUpdateBehavior;
};

export type NoDeliveryException = {
  __typename?: 'NoDeliveryException';
  type: NoDeliveryExceptionType;
  date: Scalars['AWSDate']['output'];
};

export enum NoDeliveryExceptionType {
  NoDeliveryException = 'noDeliveryException'
}

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  name: Scalars['String']['output'];
  points: Array<Coordinate>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type IntegrationOption = IntegrationSmsOption | IntegrationEmailOption | IntegrationFaxOption | IntegrationWhatsAppOption;

export type IntegrationSmsOption = {
  __typename?: 'IntegrationSmsOption';
  type: IntegrationType;
  phone: Scalars['String']['output'];
};

export enum IntegrationType {
  Sms = 'sms',
  Email = 'email',
  /** @deprecated fax is no longer supported */
  Fax = 'fax',
  WhatsApp = 'whatsApp'
}

export type IntegrationEmailOption = {
  __typename?: 'IntegrationEmailOption';
  type: IntegrationType;
  /** @deprecated emailAddress is deprecated and will be removed in the future; use complaintEmails, orderEmails or messageEmails */
  emailAddress?: Maybe<Scalars['String']['output']>;
  xlsx: Scalars['Boolean']['output'];
  pdf: Scalars['Boolean']['output'];
  complaintEmails?: Maybe<Array<Scalars['String']['output']>>;
  orderEmails?: Maybe<Array<Scalars['String']['output']>>;
  messageEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type IntegrationFaxOption = {
  __typename?: 'IntegrationFaxOption';
  type: IntegrationType;
  phone: Scalars['String']['output'];
};

export type IntegrationWhatsAppOption = {
  __typename?: 'IntegrationWhatsAppOption';
  type: IntegrationType;
  phone: Scalars['String']['output'];
};

export type OrderExportConfigFormat = OrderExportConfigCsvFormat | OrderExportConfigEdiFormat | OrderExportConfigLobsterFormat;

export type OrderExportConfigCsvFormat = {
  __typename?: 'OrderExportConfigCsvFormat';
  type: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  quotedString?: Maybe<Scalars['Boolean']['output']>;
  header?: Maybe<Scalars['Boolean']['output']>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
};

export type OrderExportConfigEdiFormat = {
  __typename?: 'OrderExportConfigEdiFormat';
  type: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  choco?: Maybe<OrderExportChocoEdiFormat>;
  supplier?: Maybe<OrderExportSupplierEdiFormat>;
};

export type OrderExportChocoEdiFormat = {
  __typename?: 'OrderExportChocoEdiFormat';
  qualifier: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderExportSupplierEdiFormat = {
  __typename?: 'OrderExportSupplierEdiFormat';
  qualifier: Scalars['String']['output'];
  value: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productIdQualifier?: Maybe<Scalars['String']['output']>;
  nameReferenceQualifier?: Maybe<Scalars['String']['output']>;
};

export type OrderExportConfigLobsterFormat = {
  __typename?: 'OrderExportConfigLobsterFormat';
  type: Scalars['String']['output'];
};

export type OrderExportUploadOption = OrderExportChocoSftpUpload | OrderExportExternalSftpUpload | OrderExportLobsterUpload;

export type OrderExportChocoSftpUpload = {
  __typename?: 'OrderExportChocoSftpUpload';
  type: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type OrderExportExternalSftpUpload = {
  __typename?: 'OrderExportExternalSftpUpload';
  type: Scalars['String']['output'];
  host: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  forceIPv4?: Maybe<Scalars['Boolean']['output']>;
  readyTimeout?: Maybe<Scalars['Int']['output']>;
  forceIPv6?: Maybe<Scalars['Boolean']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  passphrase?: Maybe<Scalars['String']['output']>;
};

export type OrderExportLobsterUpload = {
  __typename?: 'OrderExportLobsterUpload';
  type: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type ListPaymentAccountsResponse = PaymentAccountsList | AuthorizationFailure | InputValidationFailure;

export type PaymentAccountsList = AppsyncResponse & {
  __typename?: 'PaymentAccountsList';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  accounts: Array<Maybe<PaymentAccount>>;
};

export type PaymentAccount = Node & {
  __typename?: 'PaymentAccount';
  id: Scalars['ID']['output'];
  method: PaymentMethod;
  lastUsedAt: Scalars['AWSTimestamp']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  modifiedAt: Scalars['AWSTimestamp']['output'];
  /** @deprecated no longer supported */
  expiration?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** 2-digit ISO-3166 country code */
  country: Scalars['String']['output'];
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['output'];
  /**
   * Possible values:
   *   - active
   *   - inactive
   *   - blocked
   *   - suspicious
   *   - deleted
   */
  status?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer supported (returns empty string). Use 'psp.accountId' instead */
  token?: Maybe<Scalars['String']['output']>;
  psp: PaymentAccountPsp;
  details: PaymentAccountDetails;
};

export enum PaymentMethod {
  CreditCard = 'creditCard',
  BankAccount = 'bankAccount'
}

export type PaymentAccountPsp = {
  __typename?: 'PaymentAccountPsp';
  id?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountDetails = BankAccountDetails | CreditCardDetails | BalanceVendorBankDetails | BalanceBuyerBankDetails | WalletDetails | PayoutDetails;

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  bankName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberType: Scalars['String']['output'];
};

export type CreditCardDetails = {
  __typename?: 'CreditCardDetails';
  cardNumber: Scalars['String']['output'];
  processor: Scalars['String']['output'];
  cardType?: Maybe<CardType>;
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
};

export enum CardType {
  Debit = 'debit',
  Credit = 'credit',
  Other = 'other'
}

export type BalanceVendorBankDetails = {
  __typename?: 'BalanceVendorBankDetails';
  /** @deprecated no longer supported */
  vendorId: Scalars['String']['output'];
};

export type BalanceBuyerBankDetails = {
  __typename?: 'BalanceBuyerBankDetails';
  /** @deprecated no longer supported */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type WalletDetails = {
  __typename?: 'WalletDetails';
  reference: Scalars['String']['output'];
};

export type PayoutDetails = {
  __typename?: 'PayoutDetails';
  paymentType: Scalars['String']['output'];
  externalAccountId?: Maybe<Scalars['String']['output']>;
};

export type PriceSetting = {
  __typename?: 'PriceSetting';
  /** displays price of catalog products to potential buyer(s) on the Marketplace */
  displayInMarketplace: Scalars['Boolean']['output'];
  /** displays price of catalog products to buyer(s) in same chat with supplier */
  displayToCustomers: Scalars['Boolean']['output'];
};

export type SupplierUserConnection = Connection & {
  __typename?: 'SupplierUserConnection';
  edges?: Maybe<Array<SupplierUserEdge>>;
};

export type SupplierUserEdge = Edge & {
  __typename?: 'SupplierUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type InviteInfo = {
  __typename?: 'InviteInfo';
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  inviterUserId?: Maybe<Scalars['String']['output']>;
  googlePlaceName?: Maybe<Scalars['String']['output']>;
  googleFullAddress?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type GetReferralResponse = Referral | NotFoundError;

export type Referral = {
  __typename?: 'Referral';
  responseType: ResponseType;
  referrerUserId: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  referralLink: Scalars['String']['output'];
  supplier?: Maybe<Supplier>;
};

export type NotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'NotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UserCreatedContext {
  CustomerMassAccountCreator = 'customerMassAccountCreator',
  OrganicSignUp = 'organicSignUp',
  SupplierInvitesBuyer = 'supplierInvitesBuyer',
  UserCreatedFromAdmin = 'userCreatedFromAdmin',
  BuyerInviteTeam = 'buyerInviteTeam',
  SupplierInviteTeam = 'supplierInviteTeam',
  AddSalesRep = 'addSalesRep',
  BuyerConcierge = 'buyerConcierge'
}

export type InviteTransmission = Node & {
  __typename?: 'InviteTransmission';
  id: Scalars['ID']['output'];
  inviteeId: Scalars['String']['output'];
  inviteeName?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  invitedToEntityId: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  inviteeEntityId?: Maybe<Scalars['String']['output']>;
  inviteeEntityName?: Maybe<Scalars['String']['output']>;
  invitorId?: Maybe<Scalars['String']['output']>;
  invitorUserName?: Maybe<Scalars['String']['output']>;
  invitorEntityName: Scalars['String']['output'];
  channel: InviteChannel;
  status: InviteStatus;
  createdAt: Scalars['AWSTimestamp']['output'];
  transmissionEvents: Array<TransmissionEvent>;
};

export enum InviteChannel {
  Sms = 'SMS',
  Email = 'Email',
  Whatsapp = 'Whatsapp'
}

export enum InviteStatus {
  Delivered = 'delivered',
  Sent = 'sent',
  Initiated = 'initiated',
  Failed = 'failed'
}

export type TransmissionEvent = Node & {
  __typename?: 'TransmissionEvent';
  /** A concatenation of ofId:timestamp:toType:to:newState (NOT a UUID), which uniquely IDs every transmission */
  id: Scalars['ID']['output'];
  /** e.g. an orderId for ofIdType: order */
  ofId: Scalars['ID']['output'];
  ofIdType: TransmissionOfType;
  /** e.g. an email address for toType: email */
  to: Scalars['String']['output'];
  toType: TransmissionToType;
  /** e.g. Send, Delivery, Bounce, Read, ... */
  newState: Scalars['String']['output'];
  isDeliveryEvent?: Maybe<Scalars['Boolean']['output']>;
  isFailureEvent?: Maybe<Scalars['Boolean']['output']>;
  timestamp: Scalars['AWSDateTime']['output'];
  /** arbitrary metadata, e.g. email bounce details */
  metaData?: Maybe<Scalars['AWSJSON']['output']>;
};

export enum TransmissionOfType {
  Order = 'order'
}

export enum TransmissionToType {
  Email = 'email',
  Sms = 'sms',
  Whatsapp = 'whatsapp',
  Lobster = 'lobster',
  Integrations = 'integrations'
}

export enum UserPhoneType {
  Mobile = 'mobile',
  Landline = 'landline',
  Voip = 'voip',
  Noinfo = 'noinfo'
}

export type BuyerChatConnection = Connection & {
  __typename?: 'BuyerChatConnection';
  edges: Array<BuyerChatEdge>;
};

export type BuyerChatEdge = Edge & {
  __typename?: 'BuyerChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type Kyc = {
  __typename?: 'Kyc';
  id: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  /** pending (open, pending, inReview, inAudit), rejected (rejected), approved (accepted) */
  status: Scalars['String']['output'];
  tin: Scalars['String']['output'];
  city: Scalars['String']['output'];
  /** Alpha-2 ISO 3166‑1 */
  country: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  administrativeAreaLevelOne: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export enum BuyerCreatedContext {
  AddAnotherBusiness = 'addAnotherBusiness',
  CustomerMassAccountCreator = 'customerMassAccountCreator',
  OrganicSignUp = 'organicSignUp',
  SupplierInvitesBuyer = 'supplierInvitesBuyer',
  BuyerCreatedFromAdmin = 'buyerCreatedFromAdmin',
  BuyerCreatedFromChocoAi = 'buyerCreatedFromChocoAi',
  BuyerConcierge = 'buyerConcierge'
}

export enum BuyerStatus {
  Active = 'active',
  Pending = 'pending'
}

export type Cart = {
  __typename?: 'Cart';
  /** One cart per chat. the cart id is the same as the id of its parent chat */
  id: Scalars['ID']['output'];
  lineItems: Array<Maybe<CartLineItem>>;
  /** the version number of the cart for managing concurrency */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** computed field; returns true if the cart has non-empty lineItems */
  isOpen: Scalars['Boolean']['output'];
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  product?: Maybe<Product>;
  /** @deprecated is ignored in the backend, will always return null */
  productId: Scalars['ID']['output'];
  /** @deprecated is ignored in the backend, will always return null */
  productMeta?: Maybe<CartProductMetadata>;
  amount: Scalars['Float']['output'];
};

export type Product = Node & {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  supplierId?: Maybe<Scalars['ID']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ProductCategory>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: Maybe<Scalars['Int']['output']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: Maybe<Scalars['String']['output']>;
  primaryCatalogCategory?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  inProductList?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The number of days required for a supplier to first order a product
   * from a manufacturer before it can become available for order fulfilment
   */
  leadTime?: Maybe<Scalars['Int']['output']>;
  /**
   * Shows the earliest delivery date of a product and whether the clients should display it.
   * Can be calculate as 'earliestDeliveryDate = today + leadTime'
   * I.e. if today is the 2023-01-01 and leadTime is 2 days, then the
   * earliestDeliveryDate would be 2023-01-03.
   * If a product can not be delivered at the first available delivery date,
   * according to a supplier's delivery settings, 'showEarliestDeliveryDate' will be true.
   */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  /** Place order for product on or before cutOffTime to ensure next day delivery */
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /** An optional description of the product */
  description?: Maybe<Scalars['String']['output']>;
  subCatalogs?: Maybe<Array<Scalars['String']['output']>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  minimumFractionalAmount?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['AWSURL']['output']>;
  variantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Price of item in catalog and not price that buyer will pay */
  listPrice?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  uploadID?: Maybe<Scalars['String']['output']>;
  displayImage?: Maybe<ProductImage>;
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  /**
   * Adding supplier here as we need to obtain supplier details of each catalog product
   * This is meant to be used only Marketplace for now.
   */
  supplier?: Maybe<Supplier>;
  supplierNegotiatedPrice?: Maybe<SupplierNegotiatedPrice>;
  /** Timestamps to verify product version for order creation */
  versionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** resolved in getProductsForChat */
  negotiatedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** resolved in getProductsForChat */
  discountedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** resolved in getProductsForChat */
  variantsInCatalog?: Maybe<Array<Product>>;
  variantsInProductList?: Maybe<Array<Product>>;
  /** price either for chat or catalog depending on the context it is returned */
  appliedCatalogPrice?: Maybe<Scalars['Int']['output']>;
  /** discounted price for catalog product */
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  baseUnit?: Maybe<Scalars['String']['output']>;
  isSelectedInOrderGuide?: Maybe<IsSelectedInOrderGuideResponse>;
  hasVariantsInCatalog?: Maybe<Scalars['Boolean']['output']>;
};


export type ProductDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductSupplierNegotiatedPriceArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductDerivedPriceForOrderGuideArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductIsSelectedInOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
};

export type ProductCategory = Node & {
  __typename?: 'ProductCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductDeliveryDateCondition = {
  __typename?: 'ProductDeliveryDateCondition';
  /** earliestDeliveryDate is sent in the timezone of the supplier */
  earliestDeliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  showEarliestDeliveryDate: Scalars['Boolean']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  /** url to put new product image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded product image */
  url?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of product image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of product image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 900x900 pixel crop of product image */
  largeSquare?: Maybe<Scalars['String']['output']>;
};

export type BuyerInventoryProduct = {
  __typename?: 'BuyerInventoryProduct';
  chatId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  price?: Maybe<Money>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

export type SupplierNegotiatedPrice = {
  __typename?: 'SupplierNegotiatedPrice';
  price: Money;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

export type DerivedPriceForOrderGuideResponse = AuthorizationFailure | DerivedPriceForOrderGuide | InputValidationFailure;

export type DerivedPriceForOrderGuide = {
  __typename?: 'DerivedPriceForOrderGuide';
  price: Money;
  priceBeforeDiscount?: Maybe<Money>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type IsSelectedInOrderGuideResponse = IsSelectedInOrderGuide | InputValidationFailure | AuthorizationFailure;

export type IsSelectedInOrderGuide = {
  __typename?: 'IsSelectedInOrderGuide';
  value: Scalars['Boolean']['output'];
};

export type CartProductMetadata = {
  __typename?: 'CartProductMetadata';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ChatChurn = {
  __typename?: 'ChatChurn';
  status: ChatChurnStatus;
  lastOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  predictedNextOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastOrderId?: Maybe<Scalars['String']['output']>;
};

export enum ChatChurnStatus {
  Active = 'active',
  ChurnRisk = 'churnRisk',
  Churned = 'churned',
  NonActive = 'nonActive'
}

export type CreatedBy = {
  __typename?: 'CreatedBy';
  createdContext?: Maybe<CreatedContext>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum CreatedContext {
  SupplierInvitesBuyer = 'supplierInvitesBuyer',
  BuyerAddSupplier = 'buyerAddSupplier',
  ChatCreatedFromAdmin = 'chatCreatedFromAdmin',
  BuyerAddsVerifiedSupplierNewCustomer = 'buyerAddsVerifiedSupplierNewCustomer',
  BuyerRequestsSupplierExistingCustomer = 'buyerRequestsSupplierExistingCustomer',
  BuyerRequestsSupplierNewCustomer = 'buyerRequestsSupplierNewCustomer',
  InviteLink = 'inviteLink',
  /** @deprecated please use BuyerCreatedContext when creating buyers */
  AddAnotherBusiness = 'addAnotherBusiness',
  CustomerMassAccountCreator = 'customerMassAccountCreator',
  ChatCreatedFromChocoAi = 'chatCreatedFromChocoAi',
  ChatCreatedFromBuyerConcierge = 'chatCreatedFromBuyerConcierge'
}

export type SupplierDeliveryDateSettings = {
  __typename?: 'SupplierDeliveryDateSettings';
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
  /**
   * CutOffTime configuration for supplier
   * @deprecated Use 'availableDeliveryDates'
   */
  cutOffTime?: Maybe<CutOffTime>;
  /**
   * Available delivery dates for supplier within the next 30 days in UTC && YYYY-MM-DD format
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  /**
   * delivery days of the week -> Sunday - Saturday : 0 - 6
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  availableDeliveryDates: Array<AvailableDeliveryDate>;
};

export type AvailableDeliveryDate = {
  __typename?: 'AvailableDeliveryDate';
  /**
   * date is in format YYYY-MM-DD
   * dates are not subject to timezone conversion
   */
  date: Scalars['AWSDate']['output'];
  type: CutOffTimeType;
  /**
   * leadTimeAdjustedCutoff is in format YYYY-MM-DDThh:mm:ss.sssZ
   * leadTimeAdjustedCutoff is created in supplier TZ, adjusted by leadTime and returned in UTC
   * leadTimeAdjustedCutoff is the deadline for the order submission
   */
  leadTimeAdjustedCutoff?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type MessageGroupFilter = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatMessageConnection = Connection & {
  __typename?: 'ChatMessageConnection';
  edges?: Maybe<Array<ChatMessageEdge>>;
};

export type ChatMessageEdge = Edge & {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type Message = Node & {
  __typename?: 'Message';
  id: Scalars['ID']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  user: User;
  order?: Maybe<Order>;
  chat: Chat;
  attachment?: Maybe<Attachment>;
  broadcastId?: Maybe<Scalars['ID']['output']>;
};

export type Order = Node & {
  __typename?: 'Order';
  body?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Buyer>;
  chat?: Maybe<Chat>;
  chatId?: Maybe<Scalars['String']['output']>;
  confirmationSource?: Maybe<ConfirmationSource>;
  confirmationTime?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  estimatedOrderTotal?: Maybe<Money>;
  id: Scalars['ID']['output'];
  invoice: OrderInvoice;
  invoicedProducts?: Maybe<Array<Maybe<InvoicedProduct>>>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  omnichannelOrder?: Maybe<OmnichannelOrder>;
  orderChanges?: Maybe<OrderChangeResponse>;
  orderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  orderProducts?: Maybe<Array<Maybe<OrderProduct>>>;
  /** @deprecated use status instead */
  orderSupplierStatus?: Maybe<Scalars['String']['output']>;
  orderedProducts?: Maybe<Array<Maybe<OrderedProduct>>>;
  /** AWS S3 signed-url associated with the pdf for the order. */
  pdf?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<OrderRestaurant>;
  status?: Maybe<OrderStatus>;
  supplier?: Maybe<User>;
  supplierRefId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


export type OrderPdfArgs = {
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};

export enum ConfirmationSource {
  Sms = 'sms',
  Email = 'email',
  Whatsapp = 'whatsapp',
  Web = 'web',
  Android = 'android',
  Ios = 'ios',
  Lobster = 'lobster'
}

export type OrderInvoice = Invoice | OrderHasNoInvoice | OrderHasOnlyAttachment | InputValidationFailure | AuthorizationFailure;

export type Invoice = Node & {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  /** total amount of invoice in cents */
  total: Scalars['Int']['output'];
  issueDate: Scalars['AWSTimestamp']['output'];
  uploadedAt: Scalars['String']['output'];
  modifiedAt: Scalars['String']['output'];
  /**
   * Possible values:
   *   - none
   *   - paid
   *   - scheduled
   *   - processing
   *   - failed
   *   - canceled
   *   - returned
   */
  paymentStatus: Scalars['String']['output'];
  paymentTerms: Scalars['AWSTimestamp']['output'];
  /** @deprecated use attachment instead */
  pdfAttachment: InvoiceFileUrls;
  attachment: InvoiceAttachment;
  notes?: Maybe<Scalars['String']['output']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['output'];
  /** @deprecated use attachment.status instead */
  attachmentState: AttachmentState;
  currentPayment: CurrentPaymentResponse;
};

export type InvoiceFileUrls = {
  __typename?: 'InvoiceFileUrls';
  pdfUrl?: Maybe<Scalars['String']['output']>;
  pdfUploadUrl: Scalars['String']['output'];
};

export type InvoiceAttachment = {
  __typename?: 'InvoiceAttachment';
  /** signed url to download attachment */
  downloadUrl: Scalars['String']['output'];
  /** signed url to upload attachment */
  uploadUrl: Scalars['String']['output'];
  /** status of attachment */
  status: AttachmentStatus;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentStatus {
  None = 'none',
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected'
}

/** deprecated: use attachment.status instead */
export enum AttachmentState {
  None = 'none',
  Pending = 'pending',
  Completed = 'completed',
  Rejected = 'rejected'
}

export type CurrentPaymentResponse = PaymentResponse | InvoiceHasNoPayment | AuthorizationFailure | InputValidationFailure;

export type PaymentResponse = AppsyncResponse & {
  __typename?: 'PaymentResponse';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  id: Scalars['ID']['output'];
  scheduledFor?: Maybe<Scalars['AWSTimestamp']['output']>;
  paymentAccount: PaymentAccountResponse;
};

export type PaymentAccountResponse = SecuredPaymentAccount | PaymentAccountNotFound | AuthorizationFailure;

export type SecuredPaymentAccount = {
  __typename?: 'SecuredPaymentAccount';
  method: PaymentMethod;
  lastUsedAt: Scalars['AWSTimestamp']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  modifiedAt: Scalars['AWSTimestamp']['output'];
  /** @deprecated no longer supported */
  expiration?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** 2-digit ISO-3166 country code */
  country: Scalars['String']['output'];
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['output'];
  /**
   * Possible values:
   *   - active
   *   - inactive
   *   - blocked
   *   - suspicious
   *   - deleted
   */
  status?: Maybe<Scalars['String']['output']>;
  psp: PaymentAccountPsp;
  details: PaymentAccountDetails;
};

export type PaymentAccountNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'PaymentAccountNotFound';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InvoiceHasNoPayment = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoiceHasNoPayment';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderHasNoInvoice = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderHasNoInvoice';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<InvoiceAttachment>;
};

export type OrderHasOnlyAttachment = AppsyncResponse & {
  __typename?: 'OrderHasOnlyAttachment';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  attachment?: Maybe<InvoiceAttachment>;
};

export type InvoicedProduct = {
  __typename?: 'InvoicedProduct';
  orderId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoicedPrice?: Maybe<Money>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OmnichannelOrder = Node & {
  __typename?: 'OmnichannelOrder';
  id: Scalars['ID']['output'];
  status: OmnichannelOrderStatus;
  supplier: Supplier;
  originalOrderMediaLink: Scalars['String']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  parsedOrder: ParsedOrder;
  order?: Maybe<Order>;
  chat?: Maybe<Chat>;
  attachments?: Maybe<Array<OmnichannelOrderAttachment>>;
  orderDeskReviewer?: Maybe<OrderDeskReviewer>;
  acceptedBy?: Maybe<User>;
};

export enum OmnichannelOrderStatus {
  Accepted = 'accepted',
  UnderReview = 'underReview',
  ToReview = 'toReview',
  Declined = 'declined'
}

export type ParsedOrder = {
  __typename?: 'ParsedOrder';
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  orderReviewReason: Array<ReviewReason>;
  /** @deprecated Use products */
  matchedProducts: Array<OmnichannelProduct>;
  /** @deprecated Use products */
  unmatchedProducts: Array<OmnichannelProduct>;
  products: Array<Maybe<OmnichannelOrderProduct>>;
  comment?: Maybe<Scalars['String']['output']>;
  PONumber?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  restaurantAddress?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
};

export enum ReviewReason {
  DeliveryDateMatching = 'deliveryDateMatching',
  ChatMatching = 'chatMatching',
  ProductMatching = 'productMatching',
  Unexpected = 'unexpected',
  ReviewRequired = 'reviewRequired'
}

export type OmnichannelProduct = {
  __typename?: 'OmnichannelProduct';
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use amount in OmnichannelOrderProduct */
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  supplierProductId?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  additionalAttributes?: Maybe<Scalars['String']['output']>;
  parsedProductId: Scalars['ID']['output'];
  lineItemId: Scalars['ID']['output'];
  catalogProduct?: Maybe<Product>;
  chatProduct?: Maybe<Product>;
};

export type OmnichannelOrderProduct = {
  __typename?: 'OmnichannelOrderProduct';
  amount: Scalars['Float']['output'];
  product: OmnichannelProduct;
};

export type OmnichannelOrderAttachment = Node & {
  __typename?: 'OmnichannelOrderAttachment';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  transcript?: Maybe<AudioTranscript>;
};

export type AudioTranscript = {
  __typename?: 'AudioTranscript';
  transcript: Scalars['String']['output'];
  words: Array<Word>;
};

export type Word = {
  __typename?: 'Word';
  start: StartOffSet;
  word: Scalars['String']['output'];
};

export type StartOffSet = {
  __typename?: 'StartOffSet';
  milliseconds: Scalars['Int']['output'];
};

export type OrderDeskReviewer = {
  __typename?: 'OrderDeskReviewer';
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderChangeResponse = OrderChange | NoOrderChange | OrderChangeReverted | OrderChangeError;

export type OrderChange = Node & {
  __typename?: 'OrderChange';
  id: Scalars['ID']['output'];
  editVersion: Scalars['Int']['output'];
  changeData?: Maybe<OrderChangeData>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderChangeData = {
  __typename?: 'OrderChangeData';
  orderProducts?: Maybe<Array<OrderProduct>>;
  removedProducts?: Maybe<Array<OrderProduct>>;
  addedProducts?: Maybe<Array<OrderProduct>>;
  originalProductCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  product: Product;
  amount: Scalars['Float']['output'];
};

export type NoOrderChange = {
  __typename?: 'NoOrderChange';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderChangeReverted = {
  __typename?: 'OrderChangeReverted';
  responseType: ResponseType;
};

export type OrderChangeError = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderChangeError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
};

export type GetOrderDeliveryCheckResponse = OrderDeliveryCheckDetails | InputValidationFailure | CreatedOrCompletedByNotFound | AuthorizationFailure;

export type OrderDeliveryCheckDetails = {
  __typename?: 'OrderDeliveryCheckDetails';
  orderId: Scalars['ID']['output'];
  status?: Maybe<OrderDeliveryCheckStatus>;
  orderedProducts: Array<Maybe<OrderedProductDeliveryCheck>>;
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<User>;
  deliveryCheckReconciliationRequest?: Maybe<DeliveryCheckReconciliationRequest>;
};

/** Order delivery check service definitions. */
export enum OrderDeliveryCheckStatus {
  Draft = 'draft',
  Completed = 'completed'
}

export type OrderedProductDeliveryCheck = {
  __typename?: 'OrderedProductDeliveryCheck';
  orderId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<OrderDeliveryCheckImage>>>;
  amountOrdered?: Maybe<Scalars['Float']['output']>;
  /** @deprecated use deliveryCheckProblems[<item.amountDelivered>] instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  orderedProductMetadata?: Maybe<OrderedProductMetadata>;
  deliveryCheckProblems?: Maybe<Array<Maybe<DeliveryCheckProblem>>>;
};

export type OrderDeliveryCheckImage = {
  __typename?: 'OrderDeliveryCheckImage';
  imageId: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageUploadStatus: OrderDeliveryCheckImageUploadStatus;
};

export enum OrderDeliveryCheckImageUploadStatus {
  Pending = 'pending',
  Completed = 'completed'
}

export type OrderedProductMetadata = {
  __typename?: 'OrderedProductMetadata';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type DeliveryCheckProblem = {
  __typename?: 'DeliveryCheckProblem';
  problemType?: Maybe<OrderedProductDeliveryCheckProblemType>;
  /** @deprecated use imageUrls instead */
  image?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** @deprecated use value instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum OrderedProductDeliveryCheckProblemType {
  /** @deprecated spelling: use defective instead */
  Defected = 'defected',
  Defective = 'defective',
  IncorrectQuantity = 'incorrectQuantity',
  Missing = 'missing',
  Other = 'other'
}

export type DeliveryCheckReconciliationRequest = {
  __typename?: 'DeliveryCheckReconciliationRequest';
  id: Scalars['ID']['output'];
  type: DeliveryCheckReconciliationRequestType;
  status: DeliveryCheckReconciliationRequestStatus;
  statusHistory?: Maybe<Array<Maybe<DeliveryCheckReconciliationRequestStatusHistory>>>;
  comment?: Maybe<Scalars['String']['output']>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use dateOfDelivery instead */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  dateOfDelivery?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum DeliveryCheckReconciliationRequestType {
  CreditNote = 'creditNote',
  Replacement = 'replacement',
  Other = 'other'
}

export enum DeliveryCheckReconciliationRequestStatus {
  Requested = 'requested',
  Confirmed = 'confirmed'
}

export type DeliveryCheckReconciliationRequestStatusHistory = {
  __typename?: 'DeliveryCheckReconciliationRequestStatusHistory';
  timestamp: Scalars['AWSTimestamp']['output'];
  status: DeliveryCheckReconciliationRequestStatus;
};

export type CreatedOrCompletedByNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'CreatedOrCompletedByNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderedProduct = {
  __typename?: 'OrderedProduct';
  productId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  supplierPrice?: Maybe<Money>;
  buyerPrice?: Maybe<Money>;
  displayPrice?: Maybe<Money>;
  /**
   * If the property 'displayPriceBeforeDiscount' is undefined, there is no discount.
   * If it is present, the discounted price can be read from the 'displayPrice' property.
   */
  displayPriceBeforeDiscount?: Maybe<Money>;
};

export type OrderRestaurant = Node & {
  __typename?: 'OrderRestaurant';
  id: Scalars['ID']['output'];
  restaurantName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
};

export enum OrderStatus {
  /** @deprecated use pending instead */
  Created = 'created',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Delivered = 'delivered'
}

export type Attachment = Event | Media | BroadcastAttachment;

export type Event = {
  __typename?: 'Event';
  /** @deprecated use chatEventType instead */
  eventType?: Maybe<EventType>;
  chatEventType: ChatEventTypes;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export enum EventType {
  UserRemovedFromChat = 'userRemovedFromChat',
  /** @deprecated we no longer support it */
  ChatNameUpdated = 'chatNameUpdated',
  UserAddedToChat = 'userAddedToChat',
  ChatCreated = 'chatCreated',
  /** @deprecated added only for backwards compatibility */
  ReconciliationRequestConfirmed = 'reconciliationRequestConfirmed'
}

export type ChatEventTypes = RequestedChatCreated | RequestedChatActivated | UserAddedToChat | ChatNameUpdated | UserRemovedFromChat | ChatCreated | CartOpened | CartUpdated | CartSubmitted | CartCanceled | OrderEdited | OrderGuideRequested | OrderGuideCreated | ReconciliationRequestConfirmed;

export type RequestedChatCreated = {
  __typename?: 'RequestedChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type RequestedChatActivated = {
  __typename?: 'RequestedChatActivated';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserAddedToChat = {
  __typename?: 'UserAddedToChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatNameUpdated = {
  __typename?: 'ChatNameUpdated';
  /** @deprecated we no longer support it */
  name?: Maybe<Scalars['String']['output']>;
};

export type UserRemovedFromChat = {
  __typename?: 'UserRemovedFromChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatCreated = {
  __typename?: 'ChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type CartOpened = {
  __typename?: 'CartOpened';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
};

export type EventUser = {
  __typename?: 'EventUser';
  id?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartUpdated = {
  __typename?: 'CartUpdated';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
};

export type CartSubmitted = {
  __typename?: 'CartSubmitted';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
};

export type CartCanceled = {
  __typename?: 'CartCanceled';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderEdited = {
  __typename?: 'OrderEdited';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideRequested = {
  __typename?: 'OrderGuideRequested';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideCreated = {
  __typename?: 'OrderGuideCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type ReconciliationRequestConfirmed = {
  __typename?: 'ReconciliationRequestConfirmed';
  name?: Maybe<Scalars['String']['output']>;
};

export type EventTarget = EventUser | EventChat | EventOrder | EventDeliveryCheckReconciliationRequest;

export type EventChat = {
  __typename?: 'EventChat';
  chatId?: Maybe<Scalars['ID']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<EventUser>;
};

export type EventOrder = {
  __typename?: 'EventOrder';
  comment?: Maybe<Scalars['String']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
  orderCreatedAt?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
};

export type EventDeliveryCheckReconciliationRequest = {
  __typename?: 'EventDeliveryCheckReconciliationRequest';
  orderId?: Maybe<Scalars['ID']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
  reconciliationRequestType?: Maybe<DeliveryCheckReconciliationRequestType>;
};

export type Media = {
  __typename?: 'Media';
  url?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
};

export type BroadcastAttachment = {
  __typename?: 'BroadcastAttachment';
  media?: Maybe<Media>;
  attachment?: Maybe<BroadcastMediaAttachment>;
  products?: Maybe<Array<Product>>;
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
};

/** Order guide reference */
export type OrderGuideV2Ref = RefEdge & {
  __typename?: 'OrderGuideV2Ref';
  id: Scalars['ID']['output'];
  node?: Maybe<OrderGuideV2>;
};

/**
 * This interface defines a common schema for the reference objects.
 * A reference object can be used when there is a many-to-one relationship between entities,
 * and only the ID of the referenced object is known.
 *
 * For example:
 * If a Chat entity has a link to a Supplier, the Chat type could have
 * a field "supplier: SupplierRef" where "SupplierRef implements RefEdge".
 * The query that returns a Chat will only return "supplier: { id: chat.supplierId }" and not the full Supplier object.
 * The full Supplier object can be queried through "node" field of the "SupplierRef".
 * The resolver for the "node" field would be implemented in the supplier service.
 *
 * Using this pattern brings two benefits:
 * 1. Performance control. If the client only needs Id, it can decide not to query the "node" field.
 * 2. Domain separation. We don't need to implement the "Chat.supplier" resolver in the supplier service,
 *   and therefore keep the Supplier service unaware of the existence of the Chat›.
 */
export type RefEdge = {
  /** The ID of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<Node>;
};

/** Order guide */
export type OrderGuideV2 = Node & {
  __typename?: 'OrderGuideV2';
  /** We are only exposing the Id for now */
  id: Scalars['ID']['output'];
};

export type SubCatalog = Node & {
  __typename?: 'SubCatalog';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplierEntityId: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum ChatType {
  Ordering = 'ordering',
  Support = 'support'
}

export type ChatUserConnection = Connection & {
  __typename?: 'ChatUserConnection';
  edges?: Maybe<Array<ChatUserEdge>>;
};

export type ChatUserEdge = Edge & {
  __typename?: 'ChatUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type Sort = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export enum SortOrder {
  Desc = 'desc',
  Asc = 'asc'
}

export type BroadcastCustomerPerformanceFilterInput = {
  hasOrdersWithProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isClicked?: InputMaybe<Scalars['Boolean']['input']>;
  isOpened?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input parameters for a cursor paginated query that can be traversed in both directions.
 * Only provide the parameters for the direction you want to traverse:
 * - when querying the next page, provide `first` and `after`
 * - when querying the previous page, provide `last` and `before`
 */
export type PaginationInput = {
  /** Maximum number of items to return in the page when querying forward */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return in the page when querying backward */
  last?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Cursor from which the query should start when querying forward.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Cursor from which the query should start when querying backward.
   * Normally would be set to the `startCursor` of the next page or the cursor of the first item.
   */
  before?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastCustomerPerformanceResult = {
  __typename?: 'BroadcastCustomerPerformanceResult';
  data: Array<BroadcastCustomerPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastCustomerPerformance = {
  __typename?: 'BroadcastCustomerPerformance';
  chat: Chat;
  chatId: Scalars['String']['output'];
  countOrdersWithProducts: Scalars['Int']['output'];
  isChatFirstOrder: Scalars['Boolean']['output'];
  isClicked: Scalars['Boolean']['output'];
  isOpened: Scalars['Boolean']['output'];
  isReactivatedChat: Scalars['Boolean']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type BroadCastEndsAt = {
  __typename?: 'BroadCastEndsAt';
  date?: Maybe<Scalars['AWSDate']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type BroadcastProductPerformanceResult = {
  __typename?: 'BroadcastProductPerformanceResult';
  data: Array<BroadcastProductPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastProductPerformance = {
  __typename?: 'BroadcastProductPerformance';
  countOrdersWithProducts: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type OneTimeBroadcastSchedule = {
  __typename?: 'OneTimeBroadcastSchedule';
  nextScheduledTimestamp: Scalars['AWSTimestamp']['output'];
  timezone: Scalars['String']['output'];
  broadcastScheduleType: BroadcastScheduleType;
};

export enum BroadcastScheduleType {
  OneTimeBroadcast = 'oneTimeBroadcast'
}

export enum BroadcastStatus {
  Draft = 'draft',
  Processing = 'processing',
  Sent = 'sent',
  Archived = 'archived',
  Scheduled = 'scheduled',
  Cancelled = 'cancelled'
}

export type BrowseCatalogInput = {
  supplierId: Scalars['String']['input'];
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  filter?: InputMaybe<BrowseCatalogFilterInput>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogFilterInput = {
  subCatalogIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
};

export type BrowseCatalogResponse = CatalogProductsConnection | AuthorizationFailure;

export type CatalogProductsConnection = Connection & {
  __typename?: 'CatalogProductsConnection';
  total: Scalars['Int']['output'];
  edges: Array<CatalogProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type CatalogProductsEdge = Edge & {
  __typename?: 'CatalogProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  endCursor: Scalars['String']['output'];
};

export type BrowseCatalogForChatInput = {
  chatId: Scalars['String']['input'];
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  filter?: InputMaybe<BrowseCatalogForChatFilterInput>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogForChatFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
};

export type BrowseCatalogForChatResponse = CatalogProductsConnection | CatalogNotFound | AuthorizationFailure;

export type CatalogNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'CatalogNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerFacetsResponse = {
  __typename?: 'BuyerFacetsResponse';
  country?: Maybe<Scalars['String']['output']>;
  cities?: Maybe<Array<CityWithOffsets>>;
};

export type CityWithOffsets = {
  __typename?: 'CityWithOffsets';
  city?: Maybe<Scalars['String']['output']>;
  utcOffsets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type GetBuyerStockCountInput = {
  buyerId: Scalars['String']['input'];
  status: Array<BuyerStockCountStatus>;
  stockCountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum BuyerStockCountStatus {
  Draft = 'draft',
  Completed = 'completed'
}

export type BuyerStockCountResponse = BuyerStockCountSuccess | BuyerStockCountFailure | InputValidationFailure | AuthorizationFailure;

export type BuyerStockCountSuccess = {
  __typename?: 'BuyerStockCountSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  products?: Maybe<Array<BuyerStockCountProduct>>;
};

export type BuyerStockCountProduct = {
  __typename?: 'BuyerStockCountProduct';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  buyerId: Scalars['ID']['output'];
  supplierId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  stockQuantity: Scalars['Float']['output'];
  stockInventoryProductId: Scalars['ID']['output'];
  status: BuyerStockCountStatus;
  createdBy: Scalars['ID']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  displayImage?: Maybe<ProductImage>;
  stockCountId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Money>;
  estimatedTotalValue?: Maybe<Money>;
};

export type BuyerStockCountFailure = {
  __typename?: 'BuyerStockCountFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetBuyerStockCountsInput = {
  filter: GetBuyerStockCountFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};

export type GetBuyerStockCountFilterInput = {
  buyerId: Scalars['ID']['input'];
  status: Array<BuyerStockCountStatus>;
};

export type BuyerStockCountsResponse = BuyerStockCountsSuccess | BuyerStockCountsFailure | InputValidationFailure | AuthorizationFailure;

export type BuyerStockCountsSuccess = {
  __typename?: 'BuyerStockCountsSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  stockCounts: BuyerStockCountConnection;
};

export type BuyerStockCountConnection = Connection & {
  __typename?: 'BuyerStockCountConnection';
  edges?: Maybe<Array<BuyerStockCountEdge>>;
  total: Scalars['Int']['output'];
  pageInfo: PageInfo;
};

export type BuyerStockCountEdge = Edge & {
  __typename?: 'BuyerStockCountEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockCount;
};

export type BuyerStockCount = Node & {
  __typename?: 'BuyerStockCount';
  id: Scalars['ID']['output'];
  buyerId: Scalars['ID']['output'];
  createdById: Scalars['ID']['output'];
  createdBy?: Maybe<User>;
  countedProducts?: Maybe<Scalars['Int']['output']>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<BuyerStockCountStatus>;
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type BuyerStockCountsFailure = {
  __typename?: 'BuyerStockCountsFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetBuyerStockInventoryProductsFilterInput = {
  buyerId: Scalars['ID']['input'];
};

export type BuyerStockInventoryResponse = BuyerStockInventory | InputValidationFailure | AuthorizationFailure | BuyerStockInventoryNotFound | BuyerStockInventoryFailure;

export type BuyerStockInventory = {
  __typename?: 'BuyerStockInventory';
  buyerId: Scalars['String']['output'];
  totalProducts?: Maybe<Scalars['Int']['output']>;
  lastCountedById?: Maybe<Scalars['ID']['output']>;
  lastCountedBy?: Maybe<User>;
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  status?: Maybe<BuyerStockInventoryGenerationStatus>;
  products: BuyerStockInventoryProductConnection;
};

export enum BuyerStockInventoryGenerationStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed'
}

export type BuyerStockInventoryProductConnection = Connection & {
  __typename?: 'BuyerStockInventoryProductConnection';
  edges?: Maybe<Array<BuyerStockInventoryProductEdge>>;
  total: Scalars['Int']['output'];
  pageInfo: PageInfo;
};

export type BuyerStockInventoryProductEdge = Edge & {
  __typename?: 'BuyerStockInventoryProductEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockInventoryProduct;
};

export type BuyerStockInventoryProduct = Node & {
  __typename?: 'BuyerStockInventoryProduct';
  id: Scalars['ID']['output'];
  buyerId: Scalars['ID']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  supplier?: Maybe<Supplier>;
  productId?: Maybe<Scalars['ID']['output']>;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  displayImage?: Maybe<ProductImage>;
  price?: Maybe<Money>;
  estimatedTotalValue?: Maybe<Money>;
  orderGuideCategories: Array<ProductCategory>;
  type: BuyerStockInventoryProductType;
  chatId?: Maybe<Scalars['String']['output']>;
};

export enum BuyerStockInventoryProductType {
  CustomInventoryProduct = 'customInventoryProduct',
  OrderGuideProduct = 'orderGuideProduct',
  CatalogProduct = 'catalogProduct'
}

export type BuyerStockInventoryNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerStockInventoryNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerStockInventoryFailure = {
  __typename?: 'BuyerStockInventoryFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetBuyerStockInventoryExportUrlInput = {
  buyerId: Scalars['ID']['input'];
};

export type BuyerStockInventoryExportUrlResponse = BuyerStockInventoryExportUrlSuccess | InputValidationFailure | AuthorizationFailure | BuyerStockInventoryNotFound | BuyerStockInventoryExportUrlFailure;

export type BuyerStockInventoryExportUrlSuccess = {
  __typename?: 'BuyerStockInventoryExportUrlSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  url: Scalars['String']['output'];
};

export type BuyerStockInventoryExportUrlFailure = {
  __typename?: 'BuyerStockInventoryExportUrlFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerUser = {
  __typename?: 'BuyerUser';
  buyerId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Buyer>;
  user?: Maybe<User>;
};

export type CartResponse = Cart | AuthorizationFailure;

export type CatalogImportStatusResponse = CatalogImportStatusResult | InputValidationFailure | AuthorizationFailure;

export type CatalogImportStatusResult = AppsyncResponse & {
  __typename?: 'CatalogImportStatusResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The catalog import job. */
  job: CatalogImportJob;
};

/**
 * Known failure codes:
 * - InvalidFile
 */
export type CatalogImportJob = JobWaitingForInput | JobInProgress | JobFailed | CatalogImportJobSucceeded;

/** Represents a job waiting for the input file upload to start the process. */
export type JobWaitingForInput = {
  __typename?: 'JobWaitingForInput';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** URL where the input file for the job should be uploaded. */
  inputUploadUrl: Scalars['String']['output'];
};

/** Represents a job that is currently in progress. */
export type JobInProgress = {
  __typename?: 'JobInProgress';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Represents a job that has failed completely. */
export type JobFailed = {
  __typename?: 'JobFailed';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Detailed information about the failure of the job, including a failure code and message. */
  failure: JobFailure;
};

/** Provides detailed information about the failure of a job, including a specific error code and message. */
export type JobFailure = {
  __typename?: 'JobFailure';
  /** A code that identifies the type of failure that occurred. */
  code: Scalars['String']['output'];
  /** A human-readable message describing the failure. */
  message: Scalars['String']['output'];
  /** Additional JSON-formatted information about the failure, which may include details such as the fields that caused validation errors. */
  extra?: Maybe<Scalars['AWSJSON']['output']>;
};

/** Represents a catalog import job that succeeded, including partial successes. */
export type CatalogImportJobSucceeded = {
  __typename?: 'CatalogImportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Indicates whether the import was a partial success, such as some items failing to import due to validation errors. */
  isPartialSuccess: Scalars['Boolean']['output'];
  /** URL where the output file of the import job can be downloaded. */
  outputDownloadUrl: Scalars['String']['output'];
  /** A summary response of the import job detailing the outcome of the import process. */
  response: CatalogImportJobResponse;
};

/** Summarizes the import process, providing details about the items processed during the import. */
export type CatalogImportJobResponse = {
  __typename?: 'CatalogImportJobResponse';
  /** The number of new vendor item units created during the import. */
  itemsCreated: Scalars['Int']['output'];
  /** The number of vendor item units marked as out of stock during the import. */
  itemsMarkedOutOfStock: Scalars['Int']['output'];
  /** The number of vendor item units updated during the import. */
  itemsUpdated: Scalars['Int']['output'];
  /** The number of vendor item units that failed to import due to validation errors. */
  itemsWithErrors: Scalars['Int']['output'];
};

export type CatalogImportTemplateResponse = CatalogImportTemplateResult | AuthorizationFailure;

/** The response type for CatalogImport Template. */
export type CatalogImportTemplateResult = AppsyncResponse & {
  __typename?: 'CatalogImportTemplateResult';
  /** URL for the catalog import template. */
  url: Scalars['AWSURL']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CatalogImportsInput = {
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<CatalogImportsFilter>;
  /** Pagination filter. */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type CatalogImportsFilter = {
  status?: InputMaybe<Array<JobStatus>>;
};

/** JobStatus enum */
export enum JobStatus {
  /** Job is waiting for input file to be uploaded. */
  WaitingForInput = 'WaitingForInput',
  /** Job is queued and will soon be executed. */
  Queued = 'Queued',
  /** Job is in progress. */
  InProgress = 'InProgress',
  /** Job has failed. */
  Failed = 'Failed',
  /** Job has succeeded. */
  Succeeded = 'Succeeded'
}

/** Input parameters for a cursor paginated query that can be traversed in both directions. */
export type PaginationInputV2 = {
  /**
   * Cursor from which the query should start querying.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item for the forward direction,
   * or to the `startCursor` of the next page or the cursor of the first item for the backward direction.
   * If not provided, the query starts from the beginning or end depending on the direction.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of items to return in the page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Direction of the query: forward to get the next page, backward to get the previous page. */
  direction?: InputMaybe<PaginationDirection>;
};

export enum PaginationDirection {
  Forward = 'forward',
  Backward = 'backward'
}

export type CatalogImportsResponse = CatalogImportsResult | InputValidationFailure | AuthorizationFailure;

export type CatalogImportsResult = AppsyncResponse & Page & Connection & {
  __typename?: 'CatalogImportsResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Pagination information */
  pageInfo: PageInfo;
  /** The edges of the response. */
  edges: Array<CatalogImportsResultEdge>;
};

/** A single page response for a paginated query */
export type Page = {
  /** Information about the page */
  pageInfo: PageInfo;
  /** Items included in the page */
  edges: Array<Edge>;
};

export type CatalogImportsResultEdge = Edge & {
  __typename?: 'CatalogImportsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** A "CatalogImportsResultEdge" node containing the actual data. */
  node: CatalogImportNode;
};

export type CatalogImportNode = Node & {
  __typename?: 'CatalogImportNode';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** The details about the catalog import job. */
  job: CatalogImportJob;
};

export type CategoryProducts = Node & {
  __typename?: 'CategoryProducts';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Product>>;
};

export type ChatHasSupplierEmailSupportResponse = ChatHasSupplierEmailSupportResult | ChatNotFoundError | InputValidationFailure | AuthorizationFailure;

export type ChatHasSupplierEmailSupportResult = {
  __typename?: 'ChatHasSupplierEmailSupportResult';
  hasEmailSupport: Scalars['Boolean']['output'];
};

export type ChatNotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'ChatNotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

/** supplier new order and new message notification preferences on a chat level */
export type ChatNotificationPreferences = {
  __typename?: 'ChatNotificationPreferences';
  /** chat ID */
  id: Scalars['ID']['output'];
  newOrder?: Maybe<ChatNotificationUserLists>;
  /** API defaults this to newOrder prefs */
  newMessage?: Maybe<ChatNotificationUserLists>;
};

export type ChatNotificationUserLists = {
  __typename?: 'ChatNotificationUserLists';
  /** the users who are deselected from the supplier's chat-level notification preferences */
  deselectedUsersList: Array<Scalars['ID']['output']>;
  deselectedUsers: Array<User>;
  /** the users who want to receive new order/message notifications but are not a supplier */
  extraUsersList?: Maybe<Array<Scalars['ID']['output']>>;
  extraUsers?: Maybe<Array<User>>;
};

export type ChatSubCatalogProductsInput = {
  chatId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<Sort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFilter = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  subCatalogs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ChatSubCatalogProductsResponse = ChatNotFoundError | ValidationError | ChatSubCatalogProductsError | ProductSearchResult;

export type ValidationError = AppsyncResponse & AppsyncError & {
  __typename?: 'ValidationError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  invalidFields?: Maybe<Array<FieldValidationError>>;
};

export type ChatSubCatalogProductsError = AppsyncResponse & AppsyncError & {
  __typename?: 'ChatSubCatalogProductsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProductSearchResult = {
  __typename?: 'ProductSearchResult';
  total: Scalars['Int']['output'];
  hits: Array<Product>;
};

export type ChatUser = {
  __typename?: 'ChatUser';
  userId?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
};

export type FetchBuyerReportDownloadUrlInput = {
  id: Scalars['String']['input'];
};

export type FetchBuyerReportDownloadUrlResponse = BuyerReport | BuyerReportGenerationError | BuyerReportNotFoundError | InputValidationFailure | AuthorizationFailure;

export type BuyerReport = {
  __typename?: 'BuyerReport';
  id: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  type: BuyerReportType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  buyerReportUploadStatus: BuyerReportUploadStatus;
};

export enum BuyerReportType {
  Product = 'product',
  Order = 'order',
  Delivery = 'delivery'
}

export enum BuyerReportUploadStatus {
  Pending = 'pending',
  Failed = 'failed',
  Completed = 'completed'
}

export type BuyerReportGenerationError = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerReportGenerationError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerReportNotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerReportNotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  name: Scalars['String']['output'];
  clientImageKey?: Maybe<Scalars['String']['output']>;
  primaryCatalogCategories?: Maybe<Array<Scalars['String']['output']>>;
};

export type FetchCatalogCategoriesForChatResponse = CatalogCategoriesResponse | CatalogNotFound;

export type CatalogCategoriesResponse = {
  __typename?: 'CatalogCategoriesResponse';
  catalogCategories: Array<CatalogCategory>;
};

export type OrderGuideProductArgs = {
  batchSize: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuideResponse = OrderGuide | OrderGuideFailure | AuthorizationFailure | InputValidationFailure;

export type OrderGuide = {
  __typename?: 'OrderGuide';
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<OrderGuideCategory>>;
  products: OrderGuideProduct;
};

export type OrderGuideCategory = Node & {
  __typename?: 'OrderGuideCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideProduct = {
  __typename?: 'OrderGuideProduct';
  items?: Maybe<Array<OrderGuideProductItem>>;
  nextCursors?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderGuideProductItem = Node & {
  __typename?: 'OrderGuideProductItem';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  displayImage?: Maybe<ProductImage>;
  leadTime?: Maybe<Scalars['Int']['output']>;
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
};


export type OrderGuideProductItemBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type OrderGuideProductItemDerivedPriceForOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type OrderGuideProductItemDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};

export type OrderGuideFailure = {
  __typename?: 'OrderGuideFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type EmbedDashboardUrlResponse = {
  __typename?: 'EmbedDashboardUrlResponse';
  embedUrl: Scalars['String']['output'];
};

export type GetAllBuyerReportSchedulesInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type GetAllBuyerReportSchedulesResponse = BuyerReportSchedules | InputValidationFailure | AuthorizationFailure;

export type BuyerReportSchedules = {
  __typename?: 'BuyerReportSchedules';
  result: Array<BuyerReportSchedule>;
};

export type BuyerReportSchedule = {
  __typename?: 'BuyerReportSchedule';
  id: Scalars['String']['output'];
  supplierIds: Array<Scalars['String']['output']>;
  buyerIds: Array<Scalars['String']['output']>;
  type: BuyerReportType;
  createdBy: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  startAt: Scalars['AWSTimestamp']['output'];
  nextExecutionAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  frequency: ScheduledBuyerReportFrequency;
  timeframe: ScheduledBuyerReportFrequency;
  timeframeType: ScheduledBuyerReportTimeframeType;
  emailRecipients: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
};

export enum ScheduledBuyerReportFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly'
}

export enum ScheduledBuyerReportTimeframeType {
  Absolute = 'absolute',
  Relative = 'relative'
}

export type AppliedChatDeliverySettingResponse = AppliedChatDeliverySetting | NotFoundError;

export type AppliedChatDeliverySetting = {
  __typename?: 'AppliedChatDeliverySetting';
  cutoffTimes: WeekdayBasedCutoffSettings;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
  exceptions?: Maybe<Array<DeliverySettingException>>;
};

export type SuggestedProductResult = SuggestedProductSuccessResponse | GetSuggestedProductsErrorResponse | AuthorizationFailure | InputValidationFailure;

export type SuggestedProductSuccessResponse = AppsyncResponse & {
  __typename?: 'SuggestedProductSuccessResponse';
  responseType: ResponseType;
  products: SuggestedProductConnection;
};

export type SuggestedProductConnection = Connection & {
  __typename?: 'SuggestedProductConnection';
  total: Scalars['Int']['output'];
  edges?: Maybe<Array<SuggestedProductEdge>>;
};

export type SuggestedProductEdge = Edge & {
  __typename?: 'SuggestedProductEdge';
  cursor: Scalars['String']['output'];
  node: SuggestedProduct;
};

export type SuggestedProduct = Node & {
  __typename?: 'SuggestedProduct';
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
};

export type GetSuggestedProductsErrorResponse = AppsyncError & {
  __typename?: 'GetSuggestedProductsErrorResponse';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCatalogUploadUrlResponse = SupplierNotFound | GetCatalogUploadUrlResult;

export type SupplierNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetCatalogUploadUrlResult = {
  __typename?: 'GetCatalogUploadUrlResult';
  catalogUploadToken?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type GetChatCountByCcEmailResponse = GetChatCountByCcEmailReport | AuthorizationFailure;

export type GetChatCountByCcEmailReport = {
  __typename?: 'GetChatCountByCCEmailReport';
  numberOfChats: Scalars['Int']['output'];
};

export type GetChatSuppliersByLocationsInput = {
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetChatSuppliersByLocationsResponse = ChatSuppliersByLocations | InputValidationFailure | AuthorizationFailure;

export type ChatSuppliersByLocations = {
  __typename?: 'ChatSuppliersByLocations';
  total?: Maybe<Scalars['Int']['output']>;
  supplierIds: Array<Maybe<Scalars['ID']['output']>>;
  result?: Maybe<Array<Maybe<SupplierDetails>>>;
};

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  supplier?: Maybe<Supplier>;
};

export type GetChatsForSubCatalogResponse = GetChatsForSubCatalogResult | SubCatalogNotFoundError | AuthorizationFailure;

export type GetChatsForSubCatalogResult = {
  __typename?: 'GetChatsForSubCatalogResult';
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type SubCatalogNotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'SubCatalogNotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectedAccountInput = {
  refId: Scalars['ID']['input'];
};

export type GetConnectedAccountsResponse = ConnectedAccountConnection | InputValidationFailure | AuthorizationFailure;

export type ConnectedAccountConnection = Connection & {
  __typename?: 'ConnectedAccountConnection';
  edges: Array<ConnectedAccountEdge>;
};

export type ConnectedAccountEdge = Edge & {
  __typename?: 'ConnectedAccountEdge';
  cursor: Scalars['String']['output'];
  node: ConnectedAccount;
};

export type ConnectedAccount = Node & {
  __typename?: 'ConnectedAccount';
  id: Scalars['ID']['output'];
  appName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
};

export type GetConnectedIntegrationAdaptersInput = {
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType>;
};

export enum ChocoEntityType {
  Supplier = 'SUPPLIER'
}

export type GetConnectedIntegrationAdaptersResponse = IntegrationAdapterConnectionBaseResultConnection | IntegrationAdapterConnectionAdminResultConnection | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterConnectionBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionBaseResultConnection';
  edges: Array<IntegrationAdapterConnectionBaseResultEdge>;
};

export type IntegrationAdapterConnectionBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionBaseResult;
};

export type IntegrationAdapterConnectionBaseResult = Node & {
  __typename?: 'IntegrationAdapterConnectionBaseResult';
  id: Scalars['ID']['output'];
  adapterId: Scalars['ID']['output'];
  status: IntegrationAdapterConnectionStatus;
  scope?: Maybe<Array<Scalars['String']['output']>>;
  authorizationCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
};

export enum IntegrationAdapterConnectionStatus {
  /**  Connection has been initiated but has not finished yet. Can transition to any other state  */
  Pending = 'PENDING',
  /**  Connection is live and operational. Can transition to DISCONNECTED or ERROR  */
  Connected = 'CONNECTED',
  /**  Connection was stuck in a pending state for too long. Final state  */
  Expired = 'EXPIRED',
  /**  Connection was disconnected by user. Final state  */
  Disconnected = 'DISCONNECTED',
  /**  There is a problem with this connection and it needs to be reconnected. Final state  */
  Error = 'ERROR'
}

export enum ActionExportMethod {
  Polling = 'POLLING',
  Webhook = 'WEBHOOK'
}

export type IntegrationAdapterConnectionAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionAdminResultConnection';
  edges: Array<IntegrationAdapterConnectionAdminResultEdge>;
};

export type IntegrationAdapterConnectionAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionAdminResult;
};

export type IntegrationAdapterConnectionAdminResult = Node & {
  __typename?: 'IntegrationAdapterConnectionAdminResult';
  id: Scalars['ID']['output'];
  adapterId: Scalars['ID']['output'];
  status: IntegrationAdapterConnectionStatus;
  scope?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  chocoEntityId: Scalars['ID']['output'];
  chocoEntityType: ChocoEntityType;
  creatorUserId?: Maybe<Scalars['ID']['output']>;
  webhook?: Maybe<IntegrationAdapterConnectionWebhook>;
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
};

export type IntegrationAdapterConnectionWebhook = {
  __typename?: 'IntegrationAdapterConnectionWebhook';
  deliveryUrl: Scalars['String']['output'];
};

export type GetEmailListsInput = {
  types: Array<OrderDestEmailListType>;
  supplierId: Scalars['String']['input'];
};

export enum OrderDestEmailListType {
  Allow = 'allow',
  Block = 'block'
}

export type GetEmailListsResponse = EmailLists | AuthorizationFailure;

export type EmailLists = {
  __typename?: 'EmailLists';
  emailLists: Array<EmailList>;
};

export type EmailList = {
  __typename?: 'EmailList';
  type: OrderDestEmailListType;
  emails: Array<Scalars['String']['output']>;
};

export type GetFeatureFlagsResponse = FeatureFlags | AuthorizationFailure;

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  flags: Array<Maybe<FeatureFlag>>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type GroupResponse = GroupResponseSuccess | GroupResponseError | AuthorizationFailure;

export type GroupResponseSuccess = AppsyncResponse & {
  __typename?: 'GroupResponseSuccess';
  responseType: ResponseType;
  group: Group;
};

export type Group = Node & {
  __typename?: 'Group';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdContext?: Maybe<GroupCreatedContext>;
  createdBy?: Maybe<GroupCreatedBy>;
  buyers?: Maybe<Array<Buyer>>;
  suppliers?: Maybe<Array<Supplier>>;
  users?: Maybe<Array<User>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum GroupCreatedContext {
  Admin = 'admin'
}

export type GroupCreatedBy = {
  __typename?: 'GroupCreatedBy';
  userId: Scalars['ID']['output'];
  /** True if the user is a choco admin */
  isAdmin: Scalars['Boolean']['output'];
};

export type GroupResponseError = AppsyncError & {
  __typename?: 'GroupResponseError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetGroupEntitiesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: GetGroupEntitiesFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupId: Scalars['ID']['input'];
};

export type GetGroupEntitiesFilterInput = {
  entityType: GroupEntityType;
};

export enum GroupEntityType {
  Supplier = 'supplier',
  Buyer = 'buyer'
}

export type GetGroupEntitiesResponse = GetGroupEntitiesSuccessResponse | GetGroupEntitiesErrorResponse | AuthorizationFailure;

export type GetGroupEntitiesSuccessResponse = AppsyncResponse & {
  __typename?: 'GetGroupEntitiesSuccessResponse';
  entities: GroupEntityConnection;
  responseType: ResponseType;
};

export type GroupEntityConnection = {
  __typename?: 'GroupEntityConnection';
  edges?: Maybe<Array<GroupEntityEdge>>;
  total: Scalars['Int']['output'];
};

export type GroupEntityEdge = {
  __typename?: 'GroupEntityEdge';
  cursor: Scalars['String']['output'];
  node: GroupEntityNode;
};

export type GroupEntityNode = GroupEntityBuyer | GroupEntitySupplier;

export type GroupEntityBuyer = GroupEntity & {
  __typename?: 'GroupEntityBuyer';
  buyer?: Maybe<Buyer>;
  createdAt: Scalars['AWSTimestamp']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type GroupEntity = {
  createdAt: Scalars['AWSTimestamp']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type GroupEntitySupplier = GroupEntity & {
  __typename?: 'GroupEntitySupplier';
  createdAt: Scalars['AWSTimestamp']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  supplier?: Maybe<Supplier>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type GetGroupEntitiesErrorResponse = AppsyncError & {
  __typename?: 'GetGroupEntitiesErrorResponse';
  errorCode?: Maybe<GetGroupEntitiesErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export enum GetGroupEntitiesErrorCode {
  Unexpected = 'unexpected'
}

export type GetGroupUsersInput = {
  groupId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

export type GetGroupUsersResponse = GetGroupUsersSuccessResponse | GetGroupUsersErrorResponse | AuthorizationFailure;

export type GetGroupUsersSuccessResponse = AppsyncResponse & {
  __typename?: 'GetGroupUsersSuccessResponse';
  responseType: ResponseType;
  users: GroupUserConnection;
};

export type GroupUserConnection = Connection & {
  __typename?: 'GroupUserConnection';
  total: Scalars['Int']['output'];
  edges?: Maybe<Array<GroupUserEdge>>;
};

export type GroupUserEdge = Edge & {
  __typename?: 'GroupUserEdge';
  cursor: Scalars['String']['output'];
  node: GroupUser;
};

export type GroupUser = Node & {
  __typename?: 'GroupUser';
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
  role: GroupUserRole;
  user?: Maybe<User>;
};

export enum GroupUserRole {
  GroupAdmin = 'groupAdmin'
}

export type GetGroupUsersErrorResponse = AppsyncError & {
  __typename?: 'GetGroupUsersErrorResponse';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetIntegrationAdaptersInput = {
  type: IntegrationAdapterType;
};

export enum IntegrationAdapterType {
  Plugin = 'PLUGIN',
  Custom = 'CUSTOM'
}

export type GetIntegrationAdaptersResponse = IntegrationAdapterBaseResultConnection | IntegrationAdapterAdminResultConnection | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterBaseResultConnection';
  edges: Array<IntegrationAdapterBaseResultEdge>;
};

export type IntegrationAdapterBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterBaseResult;
};

export type IntegrationAdapterBaseResult = Node & {
  __typename?: 'IntegrationAdapterBaseResult';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  type: IntegrationAdapterType;
  scope: Array<Maybe<Scalars['String']['output']>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  auth: IntegrationAdapterAuthBase;
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
};

export type IntegrationAdapterAuthBase = IntegrationAdapterAuthorizationCodeAuthBase | IntegrationAdapterClientCredentialsAuthBase | IntegrationAdapterApiKeyAuthBase;

export type IntegrationAdapterAuthorizationCodeAuthBase = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuthBase';
  type: IntegrationAdapterAuthenticationType;
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Scalars['String']['output']>;
  signoutUrl: Scalars['String']['output'];
};

export enum IntegrationAdapterAuthenticationType {
  AuthorizationCode = 'AUTHORIZATION_CODE',
  ClientCredentials = 'CLIENT_CREDENTIALS',
  ApiKey = 'API_KEY'
}

export type IntegrationAdapterClientCredentialsAuthBase = {
  __typename?: 'IntegrationAdapterClientCredentialsAuthBase';
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterApiKeyAuthBase = {
  __typename?: 'IntegrationAdapterAPIKeyAuthBase';
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterAdminResultConnection';
  edges: Array<IntegrationAdapterAdminResultEdge>;
};

export type IntegrationAdapterAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterAdminResult;
};

export type IntegrationAdapterAdminResult = Node & {
  __typename?: 'IntegrationAdapterAdminResult';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: IntegrationAdapterType;
  scope: Array<Maybe<Scalars['String']['output']>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  auth: IntegrationAdapterAuth;
  webhook?: Maybe<IntegrationAdapterWebhook>;
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
};

export type IntegrationAdapterAuth = IntegrationAdapterAuthorizationCodeAuth | IntegrationAdapterClientCredentialsAuth | IntegrationAdapterApiKeyAuth;

export type IntegrationAdapterAuthorizationCodeAuth = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuth';
  type: IntegrationAdapterAuthenticationType;
  secret: Scalars['String']['output'];
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Maybe<Scalars['String']['output']>>;
  signoutUrl: Scalars['String']['output'];
};

export type IntegrationAdapterClientCredentialsAuth = {
  __typename?: 'IntegrationAdapterClientCredentialsAuth';
  type: IntegrationAdapterAuthenticationType;
  secret: Scalars['String']['output'];
};

export type IntegrationAdapterApiKeyAuth = {
  __typename?: 'IntegrationAdapterAPIKeyAuth';
  type: IntegrationAdapterAuthenticationType;
  apiKey: Scalars['String']['output'];
};

export type IntegrationAdapterWebhook = {
  __typename?: 'IntegrationAdapterWebhook';
  deliveryUrl: Scalars['String']['output'];
  auth: IntegrationAdapterWebhookAuth;
};

export type IntegrationAdapterWebhookAuth = IntegrationAdapterWebhookBasicAuth | IntegrationAdapterWebhookSignatureAuth;

export type IntegrationAdapterWebhookBasicAuth = {
  __typename?: 'IntegrationAdapterWebhookBasicAuth';
  type: WebhookAuthenticationType;
  username: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export enum WebhookAuthenticationType {
  Basic = 'BASIC',
  Signature = 'SIGNATURE'
}

export type IntegrationAdapterWebhookSignatureAuth = {
  __typename?: 'IntegrationAdapterWebhookSignatureAuth';
  type: WebhookAuthenticationType;
  token: Scalars['String']['output'];
};

export type GetInviteTransmissionStatus = {
  chatId: Scalars['ID']['input'];
};

export type GetInviteTransmissionStatusResponse = InviteTransmissionStatus | AuthorizationFailure | InputValidationFailure;

export type InviteTransmissionStatus = {
  __typename?: 'InviteTransmissionStatus';
  inviteStatus?: Maybe<InviteStatus>;
};

export type GetInviteeBuyersResponse = InviteeNotFound | InviteeBuyers;

/**
 * Error thrown by getInviteeBuyers when user is not found
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type InviteeNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'InviteeNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InviteeBuyers = {
  __typename?: 'InviteeBuyers';
  /** User Id of Invitee */
  id: Scalars['ID']['output'];
  /**
   * Invitee Buyers which the invitor does not have a chat with
   * Param first: number of user's buyers to check for connections
   * Param after: pagination cursor from UserBuyerEdge
   */
  unconnectedBuyers: UserBuyerConnection;
};


export type InviteeBuyersUnconnectedBuyersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

/**
 * For internal use,
 * This type is kept exactly similar to the message table schema since it is used as is in choco-notification
 */
export type MessagesFromChatResult = {
  __typename?: 'MessagesFromChatResult';
  id: Scalars['String']['output'];
  body: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  userId: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  supplierOptIn?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<MessageStatus>;
  media?: Maybe<Scalars['Boolean']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaContentType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MessageType>;
  event?: Maybe<MessageEvent>;
  broadcastId?: Maybe<Scalars['String']['output']>;
};

export enum MessageStatus {
  Delivered = 'delivered',
  ReadyForDelivery = 'readyForDelivery',
  PendingAttachment = 'pendingAttachment'
}

export enum MessageType {
  Text = 'text',
  Media = 'media',
  OrderConfirmation = 'orderConfirmation',
  Broadcast = 'broadcast',
  Event = 'event',
  EmailMessage = 'emailMessage',
  Order = 'order',
  DeliveryCheckReconciliationRequestConfirmed = 'deliveryCheckReconciliationRequestConfirmed'
}

export type MessageEvent = {
  __typename?: 'MessageEvent';
  eventType?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export type LocationsBySupplierResponse = LocationsBySupplierSuccess | InputValidationFailure | AuthorizationFailure;

export type LocationsBySupplierSuccess = {
  __typename?: 'LocationsBySupplierSuccess';
  result?: Maybe<Array<Maybe<LocationBySupplier>>>;
};

export type LocationBySupplier = {
  __typename?: 'LocationBySupplier';
  chatId: Scalars['ID']['output'];
  buyerEntityId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
};

export type MarketingMessageSuggestionsResult = MarketingMessageSuggestionsSuccess | MarketingMessageSuggestionsError | MarketingMessageSuggestionsErrorNoSuggestions | MarketingMessageSuggestionsErrorThrottling | InputValidationFailure;

export type MarketingMessageSuggestionsSuccess = AppsyncResponse & {
  __typename?: 'MarketingMessageSuggestionsSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  tips: Array<MarketingMessageRefinementTip>;
  improvedText: Scalars['String']['output'];
};

export type MarketingMessageRefinementTip = {
  __typename?: 'MarketingMessageRefinementTip';
  tip: Scalars['String']['output'];
};

export type MarketingMessageSuggestionsError = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type MarketingMessageSuggestionsErrorNoSuggestions = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorNoSuggestions';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type MarketingMessageSuggestionsErrorThrottling = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorThrottling';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type GetOmniChannelOrderInput = {
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetOmniChannelOrderResponse = OmnichannelOrder | NotFoundError | AuthorizationFailure;

export type GetOnboardingChecklistResponse = OnboardingChecklist | AuthorizationFailure;

export type OnboardingChecklist = {
  __typename?: 'OnboardingChecklist';
  id: Scalars['ID']['output'];
  buyerId: Scalars['String']['output'];
  rewardClaimedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  items: Array<OnboardingChecklistItem>;
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  version: Scalars['String']['output'];
};

export type OnboardingChecklistItem = {
  __typename?: 'OnboardingChecklistItem';
  fallbackTranslation: Scalars['String']['output'];
  articleId: Scalars['String']['output'];
  value: OnboardingChecklistItemValue;
  key: Scalars['String']['output'];
};

export type OnboardingChecklistItemValue = OnboardingChecklistBooleanValue | OnboardingChecklistNumericValue;

export type OnboardingChecklistBooleanValue = {
  __typename?: 'OnboardingChecklistBooleanValue';
  booleanCurrent: Scalars['Boolean']['output'];
};

export type OnboardingChecklistNumericValue = {
  __typename?: 'OnboardingChecklistNumericValue';
  numericCurrent: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
};

export type GetProductsForChatInput = {
  chatId: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<GetProductsForChatFilter>;
};

export type GetProductsForChatFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetProductsForChatResponse = GetProductsForChatResult | ChatNotFoundError | AuthorizationFailure | SupplierNotFound;

export type GetProductsForChatResult = {
  __typename?: 'GetProductsForChatResult';
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
  invalidProducts?: Maybe<Array<InvalidProduct>>;
};

export type InvalidProduct = {
  __typename?: 'InvalidProduct';
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type GetQboCustomersAndOrderGuidesToImportResponse = QboCustomersAndOrderGuidesToImport | InputValidationFailure | AuthorizationFailure;

export type QboCustomersAndOrderGuidesToImport = {
  __typename?: 'QboCustomersAndOrderGuidesToImport';
  fileUrl: Scalars['String']['output'];
};

export type GetReconciliationRequestPlanBySupplierIdResponse = ReconciliationRequestPlan | InputValidationFailure | ReconciliationRequestPlanBySupplierIdNotFound;

export type ReconciliationRequestPlan = {
  __typename?: 'ReconciliationRequestPlan';
  supplierId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  plan: ReconciliationRequestPlanType;
};

export enum ReconciliationRequestPlanType {
  Premium = 'premium',
  Free = 'free'
}

export type ReconciliationRequestPlanBySupplierIdNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'ReconciliationRequestPlanBySupplierIdNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetReferralInput = {
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referrerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type GetRequestsToJoinInput = {
  /** One of the following two parameters must be provided */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetRequestsToJoinFilter>;
};

export type GetRequestsToJoinFilter = {
  status?: InputMaybe<JoinRequestStatus>;
};

export enum JoinRequestStatus {
  Approved = 'approved',
  AutoApproved = 'autoApproved',
  Denied = 'denied',
  Pending = 'pending'
}

export type GetRequestsToJoinResponse = RequestsToJoinConnection | InputValidationFailure | AuthorizationFailure;

export type RequestsToJoinConnection = Connection & {
  __typename?: 'RequestsToJoinConnection';
  total: Scalars['Int']['output'];
  edges: Array<UserRequestToJoinEdge>;
};

export type UserRequestToJoinEdge = Edge & {
  __typename?: 'UserRequestToJoinEdge';
  cursor: Scalars['String']['output'];
  node: UserRequestToJoin;
};

export type UserRequestToJoin = Node & {
  __typename?: 'UserRequestToJoin';
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
  user: User;
  requestType?: Maybe<UserRequestToJoinType>;
  buyerId?: Maybe<Scalars['String']['output']>;
  supplierEntityId?: Maybe<Scalars['String']['output']>;
  status: JoinRequestStatus;
  salesRepInput?: Maybe<SalesRepDetails>;
  reviewerUserId?: Maybe<Scalars['String']['output']>;
  isReviewerAdmin?: Maybe<Scalars['Boolean']['output']>;
  requestedBy: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export enum UserRequestToJoinType {
  AddSalesRep = 'addSalesRep',
  JoinBuyer = 'joinBuyer'
}

export type SalesRepDetails = {
  __typename?: 'SalesRepDetails';
  chatId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderPreference: Array<AddSalesRepOrderPref>;
  email?: Maybe<Scalars['String']['output']>;
};

export enum AddSalesRepOrderPref {
  Sms = 'sms',
  Email = 'email',
  WhatsApp = 'whatsApp'
}

export type GetSmsMessageByMessageSidResponse = GetSmsMessageByMessageSidSuccess | AuthorizationFailure;

export type GetSmsMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessageByMessageSidSuccess';
  responseType: ResponseType;
  smsMessage?: Maybe<SmsMessage>;
};

export type SmsMessage = {
  __typename?: 'SmsMessage';
  smsMessageId: Scalars['String']['output'];
  messageSid: Scalars['String']['output'];
  accountSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  body: Scalars['String']['output'];
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  mediaElements?: Maybe<Array<SmsMessageMedia>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  toCity?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  smsStatus?: Maybe<Scalars['String']['output']>;
  apiVersion?: Maybe<Scalars['String']['output']>;
};

export type SmsMessageMedia = {
  __typename?: 'SmsMessageMedia';
  downloadUrl: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type GetSmsMessagesFromPhoneNumberResponse = GetSmsMessagesFromPhoneNumberSuccess | AuthorizationFailure;

export type GetSmsMessagesFromPhoneNumberSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessagesFromPhoneNumberSuccess';
  responseType: ResponseType;
  messages?: Maybe<Array<SmsMessage>>;
};

export type GetSubCatalogResponse = SubCatalog | NotFoundError;

export type GetSubCatalogsForChatResponse = GetSubCatalogsForChatResult | ChatNotFoundError | AuthorizationFailure;

export type GetSubCatalogsForChatResult = {
  __typename?: 'GetSubCatalogsForChatResult';
  subCatalogs: Array<SubCatalog>;
};

export type GetSupplierApplicationsInput = {
  refId: Scalars['ID']['input'];
};

export type GetSupplierApplicationsResponse = SupplierApplications | InputValidationFailure | AuthorizationFailure;

export type SupplierApplications = {
  __typename?: 'SupplierApplications';
  apps: Array<ApplicationData>;
};

export type ApplicationData = {
  __typename?: 'ApplicationData';
  appName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  data?: Maybe<CredentialsData>;
};

export type CredentialsData = QbdCredentials;

export type QbdCredentials = {
  __typename?: 'QbdCredentials';
  fileUrl: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type GetSupplierProductsInput = {
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetSupplierProductsResponse = GetSupplierProductsResult | AuthorizationFailure;

export type GetSupplierProductsResult = {
  __typename?: 'GetSupplierProductsResult';
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
  invalidProducts?: Maybe<Array<InvalidProduct>>;
};

export type GetUnconnectedBuyerIdsResult = UnconnectedBuyers | NoUnconnectedBuyers;

export type UnconnectedBuyers = {
  __typename?: 'UnconnectedBuyers';
  /** List of buyer ids supplier is not connected with */
  buyerIds: Array<Scalars['String']['output']>;
};

export type NoUnconnectedBuyers = AppsyncResponse & AppsyncError & {
  __typename?: 'NoUnconnectedBuyers';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserIntercomCredentialsResponse = UserIntercomCredentialsSuccess | UserIntercomCredentialsFailure;

export type UserIntercomCredentialsSuccess = {
  __typename?: 'UserIntercomCredentialsSuccess';
  webHash: Scalars['String']['output'];
  iosHash: Scalars['String']['output'];
  androidHash: Scalars['String']['output'];
};

export type UserIntercomCredentialsFailure = AppsyncResponse & AppsyncError & {
  __typename?: 'UserIntercomCredentialsFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetWhatsAppMessageByMessageSidResponse = GetWhatsAppMessageByMessageSidSuccess | AuthorizationFailure;

export type GetWhatsAppMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetWhatsAppMessageByMessageSidSuccess';
  responseType: ResponseType;
  whatsAppMessage?: Maybe<WhatsAppMessage>;
};

export type WhatsAppMessage = {
  __typename?: 'WhatsAppMessage';
  whatsAppMessageId: Scalars['String']['output'];
  messageSid: Scalars['String']['output'];
  accountSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  body: Scalars['String']['output'];
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  mediaElements?: Maybe<Array<WhatsAppMessageMedia>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  toCity?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  whatsappId?: Maybe<Scalars['String']['output']>;
  forwarded?: Maybe<Scalars['Boolean']['output']>;
  frequentlyForwarded?: Maybe<Scalars['Boolean']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  originalRepliedMessageSender?: Maybe<Scalars['String']['output']>;
  originalRepliedMessageSid?: Maybe<Scalars['String']['output']>;
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
  apiVersion?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppMessageMedia = {
  __typename?: 'WhatsAppMessageMedia';
  downloadUrl: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
};

export type HasUserCompletedDeliveryCheckResponse = HasCompletedDeliveryCheckResult | OrderNotFound | InputValidationFailure | AuthorizationFailure;

export type HasCompletedDeliveryCheckResult = {
  __typename?: 'HasCompletedDeliveryCheckResult';
  hasCompletedDeliveryCheck: Scalars['Boolean']['output'];
  latestOrderId?: Maybe<Scalars['ID']['output']>;
  earliestOrderId?: Maybe<Scalars['ID']['output']>;
};

export type OrderNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InventoryDownloadJobsInput = {
  buyerId: Scalars['String']['input'];
  filter?: InputMaybe<InventoryDownloadJobsFilter>;
};

export type InventoryDownloadJobsFilter = {
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<InventoryDownloadJobStatus>>;
};

export enum InventoryDownloadJobStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed'
}

export type InventoryDownloadJobsResponse = InventoryDownloadJobsSuccess | InventoryDownloadJobsFailure | AuthorizationFailure | InputValidationFailure;

export type InventoryDownloadJobsSuccess = {
  __typename?: 'InventoryDownloadJobsSuccess';
  jobs: Array<InventoryDownloadJob>;
};

export type InventoryDownloadJob = {
  __typename?: 'InventoryDownloadJob';
  id: Scalars['ID']['output'];
  status: InventoryDownloadJobStatus;
  report?: Maybe<InventoryDownloadJobReport>;
};

export type InventoryDownloadJobReport = InventoryDownloadJobCompleted | InventoryDownloadJobFailed;

export type InventoryDownloadJobCompleted = {
  __typename?: 'InventoryDownloadJobCompleted';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  downloadUrl: Scalars['String']['output'];
};

export type InventoryDownloadJobFailed = {
  __typename?: 'InventoryDownloadJobFailed';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type InventoryDownloadJobsFailure = {
  __typename?: 'InventoryDownloadJobsFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type InventorySuppliersInput = {
  buyerId: Scalars['ID']['input'];
};

export type InventorySuppliersResponse = InventorySuppliersSuccess | InputValidationFailure | AuthorizationFailure | InventorySuppliersFailure;

export type InventorySuppliersSuccess = {
  __typename?: 'InventorySuppliersSuccess';
  responseType?: Maybe<ResponseType>;
  suppliers: Array<InventorySupplier>;
};

export type InventorySupplier = {
  __typename?: 'InventorySupplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InventorySuppliersFailure = {
  __typename?: 'InventorySuppliersFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type InventoryUploadJobInput = {
  buyerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type InventoryUploadJobResponse = InventoryUploadJobSuccess | InventoryUploadJobFailure | AuthorizationFailure | InputValidationFailure;

export type InventoryUploadJobSuccess = {
  __typename?: 'InventoryUploadJobSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  jobId: Scalars['ID']['output'];
  status: InventoryUploadJobStatus;
  rawReport?: Maybe<Scalars['String']['output']>;
};

export enum InventoryUploadJobStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  TemplateValidation = 'TemplateValidation',
  ItemsValidation = 'ItemsValidation',
  DuplicatesValidation = 'DuplicatesValidation',
  ItemsCreation = 'ItemsCreation',
  Completed = 'Completed',
  Failed = 'Failed'
}

export type InventoryUploadJobFailure = {
  __typename?: 'InventoryUploadJobFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type InventoryUploadTemplateInput = {
  buyerId: Scalars['ID']['input'];
};

export type InventoryUploadTemplateResponse = InventoryUploadTemplateResponseSuccess | InventoryUploadTemplateResponseFailure | AuthorizationFailure | InputValidationFailure;

export type InventoryUploadTemplateResponseSuccess = {
  __typename?: 'InventoryUploadTemplateResponseSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  downloadUrl: Scalars['String']['output'];
};

export type InventoryUploadTemplateResponseFailure = {
  __typename?: 'InventoryUploadTemplateResponseFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type PaymentAccountOwnerInput = {
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListSubCatalogProductsInput = {
  subCatalogId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<Sort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSubCatalogProductsResponse = ProductSearchResult | ListSubCatalogProductsError;

export type ListSubCatalogProductsError = AppsyncResponse & AppsyncError & {
  __typename?: 'ListSubCatalogProductsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ListSubCatalogsResponse = SubCatalogConnection | ValidationError;

export type SubCatalogConnection = Connection & {
  __typename?: 'SubCatalogConnection';
  edges: Array<SubCatalogEdge>;
};

export type SubCatalogEdge = Edge & {
  __typename?: 'SubCatalogEdge';
  cursor: Scalars['String']['output'];
  node: SubCatalog;
};

export type LookupPhoneNumbersResponse = LookupPhoneNumbersSuccess | LookupPhoneNumbersError;

export type LookupPhoneNumbersSuccess = {
  __typename?: 'LookupPhoneNumbersSuccess';
  lookups: Array<PhoneNumberLookup>;
};

export type PhoneNumberLookup = PhoneNumberLookupSuccess | PhoneNumberLookupError;

export type PhoneNumberLookupSuccess = {
  __typename?: 'PhoneNumberLookupSuccess';
  phoneNumber: Scalars['String']['output'];
  lineType: PhoneNumberLineType;
};

export enum PhoneNumberLineType {
  LandLine = 'landLine',
  Mobile = 'mobile',
  Voip = 'voip',
  Unsupported = 'unsupported'
}

export type PhoneNumberLookupError = {
  __typename?: 'PhoneNumberLookupError';
  phoneNumber: Scalars['String']['output'];
  errorCode: PhoneNumberLookupErrorCode;
  message: Scalars['String']['output'];
};

export enum PhoneNumberLookupErrorCode {
  GenericError = 'genericError',
  InvalidPhoneNumber = 'invalidPhoneNumber'
}

export type LookupPhoneNumbersError = AppsyncResponse & AppsyncError & {
  __typename?: 'LookupPhoneNumbersError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  errorCode?: Maybe<LookupPhoneNumbersErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum LookupPhoneNumbersErrorCode {
  GenericError = 'genericError'
}

export type MetaLobbyResponse = MetaLobbyResult | InvalidCursor;

export type MetaLobbyResult = {
  __typename?: 'MetaLobbyResult';
  buyers: UserLobbyBuyerConnection;
  others?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserLobbyBuyerConnection = Connection & {
  __typename?: 'UserLobbyBuyerConnection';
  edges?: Maybe<Array<UserLobbyBuyerEdge>>;
};

export type UserLobbyBuyerEdge = Edge & {
  __typename?: 'UserLobbyBuyerEdge';
  cursor: Scalars['String']['output'];
  node: LobbyBuyer;
};

export type LobbyBuyer = Node & {
  __typename?: 'LobbyBuyer';
  id: Scalars['ID']['output'];
  buyer: Buyer;
  chatIds: Array<Scalars['String']['output']>;
};

export type InvalidCursor = AppsyncResponse & AppsyncError & {
  __typename?: 'InvalidCursor';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideV2CategoriesInput = {
  orderGuideId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInputV2>;
};

export type OrderGuideV2CategoriesResponse = OrderGuideV2CategoriesResult | InputValidationFailure | AuthorizationFailure;

export type OrderGuideV2CategoriesResult = AppsyncResponse & Page & Connection & {
  __typename?: 'OrderGuideV2CategoriesResult';
  responseType: ResponseType;
  pageInfo: PageInfo;
  edges: Array<OrderGuideV2CategoriesResultEdge>;
};

export type OrderGuideV2CategoriesResultEdge = Edge & {
  __typename?: 'OrderGuideV2CategoriesResultEdge';
  cursor: Scalars['String']['output'];
  node: OrderGuideV2Category;
};

/** Represents a category in the order guide. */
export type OrderGuideV2Category = Node & {
  __typename?: 'OrderGuideV2Category';
  /** The unique identifier for the order guide category. */
  id: Scalars['ID']['output'];
  /** The name of the order guide category. */
  name: Scalars['String']['output'];
};

/** Input for the `orderGuideItemUnits` query */
export type OrderGuideV2ItemUnitsInput = {
  /** The ID of the order guide to get the units for. */
  orderGuideId: Scalars['ID']['input'];
  /** Additional filters to narrow down the output */
  filter?: InputMaybe<OrderGuideV2ItemUnitsFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
};

/** Filter input for the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsFilter = {
  /**
   * The ID of the order guide category to filter by.
   * If provided, only items in the specified category will be returned.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether to include uncategorized items.
   * If true, only units for `uncategorized` items are returned.
   * If false, then this field is ignored and only units for `categorized` items are returned.
   */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderGuideV2ItemUnitsResponse = OrderGuideV2ItemUnitsResult | InputValidationFailure | AuthorizationFailure;

/** Success response of the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsResult = AppsyncResponse & Page & Connection & {
  __typename?: 'OrderGuideV2ItemUnitsResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Pagination information */
  pageInfo: PageInfo;
  /** The edges of the response. */
  edges: Array<OrderGuideV2ItemUnitsResultEdge>;
};

/** One item of the `OrderGuideV2ItemUnits` query result page */
export type OrderGuideV2ItemUnitsResultEdge = Edge & {
  __typename?: 'OrderGuideV2ItemUnitsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** An order guide item unit reference */
  node: OrderGuideV2ItemUnit;
};

/** Represents a vendor item unit. */
export type OrderGuideV2ItemUnit = Node & {
  __typename?: 'OrderGuideV2ItemUnit';
  /** The unique identifier for the vendor item unit. */
  id: Scalars['ID']['output'];
  /** The vendor item unit. */
  orderGuideCategory?: Maybe<OrderGuideV2CategoryRef>;
  vendorItemUnit: VendorItemUnitRef;
};

/**
 * Reference to the OrderGuideV2Category.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type OrderGuideV2CategoryRef = RefEdge & {
  __typename?: 'OrderGuideV2CategoryRef';
  /** The ID of the referenced object. */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<OrderGuideV2Category>;
};

/**
 * Reference to the VendorItemUnit.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemUnitRef = RefEdge & {
  __typename?: 'VendorItemUnitRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemUnit>;
};

/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnit = Node & {
  __typename?: 'VendorItemUnit';
  /** Intended for buyer facing frontends: Frontend-specific availability/orderability status of the unit. */
  availabilityStatus: VendorItemUnitAvailabilityStatus;
  /** The base unit of item. */
  baseUnit?: Maybe<VendorItemUnit>;
  /**
   * Convenient short code of the unit.
   * Note that this is not a technical property and it can be filled by humans.
   */
  code: Scalars['String']['output'];
  /**
   * Conversion factor of this unit.
   * E.g. if one unit is "g" with a factor "1" and another unit is "kg" with a factor "1000", then 1 kg is 1000 g.
   */
  factor: Rational;
  /**
   * For approximate conversion factors, the deviation is the half of the variability interval.
   * E.g. if one unit is "kg" with a factor "1" and another unit is "piece" with a factor "2" and a deviation "0.5", then 1 piece is between 1.5 and 2.5 kg.
   * If the conversion factor is exact, the deviation is set to "0".
   */
  factorDeviation: Rational;
  id: Scalars['ID']['output'];
  /** The images associated with the vendor item unit. */
  images: Array<VendorItemUnitImage>;
  /** Flags if the unit is the base unit for the vendor item */
  isBase: Scalars['Boolean']['output'];
  /** Queries the given order guide by Id to determine if the unit is added to it. */
  isInOrderGuide: Scalars['Boolean']['output'];
  /** Flags if the unit is available for ordering by buyers. */
  isOrdering: Scalars['Boolean']['output'];
  /**
   * More elaborate name of the unit intended for display to buyers.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  name: Scalars['String']['output'];
  orderGuideItemUnit?: Maybe<OrderGuideV2ItemUnit>;
  /**
   * Formerly, "packSize", describes the content of one unit in more detail.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  packagingDescription: Scalars['String']['output'];
  /** The price of the unit, null is returned if the price is not defined or the user do not have access to it */
  price?: Maybe<VendorItemUnitPriceSet>;
  /** Intended for vendor facing frontends: The stock status of the unit. */
  stockStatus: VendorItemUnitStockStatus;
  /** Reference to a vendor item that this unit belongs to. */
  vendorItem: VendorItemRef;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitIsInOrderGuideArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitOrderGuideItemUnitArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitPriceArgs = {
  input?: InputMaybe<VendorItemUnitPriceInput>;
};

/** Computed availability status for the VendorItemUnit that is intended for buyer facing frontends */
export enum VendorItemUnitAvailabilityStatus {
  /** This unit is available for ordering but the stock status is unknown */
  Available = 'Available',
  /** This unit is available for ordering and is in stock */
  InStock = 'InStock',
  /** This unit is not available for ordering for the unknown reason */
  Unavailable = 'Unavailable',
  /** This unit is not available for ordering because it is out of stock */
  OutOfStock = 'OutOfStock',
  /**
   * This unit is not available for ordering because it is discontinued
   * and will not return to the catalog in the observable future.
   */
  Discontinued = 'Discontinued'
}

/**
 * Exactly represents mathematical fraction: numerator/denominator.
 * Compared to Float does not have the precision issues when dealing with exact fractions.
 */
export type Rational = {
  __typename?: 'Rational';
  numerator: Scalars['Int']['output'];
  denominator: Scalars['Int']['output'];
};

/**
 * VendorItemUnitImage represents VendorItemUnit image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemUnitImage = {
  __typename?: 'VendorItemUnitImage';
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  /**
   * The resolver returns a read URL of the image asset for a given size and device pixel ratio.
   * The image is resized in the 'contain' mode, preserving the aspect-ratio, so the final image size might not match the requested size.
   * If none of the parameters are passed, the default size is returned.
   * In case of an error, null can be returned in which case the client should handle gracefully e.g. by falling back to a default broken image icon.
   */
  url?: Maybe<ImageAssetUrl>;
};


export type ImageAssetUrlArgs = {
  width?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  devicePixelRatio?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageAssetUrl = {
  __typename?: 'ImageAssetUrl';
  /** The URL of the image asset */
  url: Scalars['AWSURL']['output'];
};

export type VendorItemUnitPriceInput = {
  /** If the price is queried by a buyer user, this field must be populated with the buyer ID, otherwise the price will be returned as null */
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** A chat in which context the price is requested */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided, only returns prices which are valid at the requested datetime, if not provided, only the prices valid now are returned */
  validityDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type VendorItemUnitPriceSet = Node & {
  __typename?: 'VendorItemUnitPriceSet';
  /** VendorItemUnitPriceSet ID */
  id: Scalars['ID']['output'];
  /** The display price for the unit */
  displayPrice: MoneyV2;
  /** The display price before applying the discount */
  displayPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The display catalog price for the unit */
  displayCatalogPrice?: Maybe<MoneyV2>;
  /** The display catalog price before applying the discount */
  displayCatalogPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The buyer price for the unit */
  buyerPrice?: Maybe<MoneyV2>;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  decimalPlaces: Scalars['Int']['output'];
};

/** Stock status of the vendor item unit. */
export enum VendorItemUnitStockStatus {
  InStock = 'InStock',
  OutOfStock = 'OutOfStock',
  Discontinued = 'Discontinued'
}

/**
 * Reference to the VendorItem.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemRef = RefEdge & {
  __typename?: 'VendorItemRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItem>;
};

/** Represents a specific item in a vendor catalog. */
export type VendorItem = Node & {
  __typename?: 'VendorItem';
  id: Scalars['ID']['output'];
  /**
   * Formerly, "externalId", this is a short code for the item which is meaningful to the vendor.
   * Note that this is not a technical property and it can be filled by humans.
   */
  productCode?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the item.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  name: Scalars['String']['output'];
  /**
   * Extended description of the item.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  description: Scalars['String']['output'];
  /** ISO 3166 alpha-2 country code of the country where the item came from. */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  /**
   * Brand name of the item.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /** Set to true if the item was created by the buyer, not vendor. */
  isCustomVendorItem: Scalars['Boolean']['output'];
  /** Variant group that this item belongs to as an item variant. */
  variantGroup?: Maybe<VendorItemVariantGroup>;
  /** Set to true if the item has more variants */
  hasVariants: Scalars['Boolean']['output'];
  /** Count of units that this item has */
  unitsCount: Scalars['Int']['output'];
  /** Returns the units of the item according to the provided filter */
  units: Array<VendorItemUnit>;
  /** Returns the most nested category that this item belongs to */
  categories: Array<VendorItemCategory>;
  /** @deprecated Use the `categories` field instead */
  category?: Maybe<VendorItemCategory>;
};


/** Represents a specific item in a vendor catalog. */
export type VendorItemUnitsArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};

/** A variant group is a set of items that are similar to each other but have different properties. */
export type VendorItemVariantGroup = Node & {
  __typename?: 'VendorItemVariantGroup';
  id: Scalars['ID']['output'];
  /**
   * Code of the variant group that is meaningful to the vendor.
   * Note that this is not a technical property and it can be filled by humans.
   */
  code: Scalars['String']['output'];
};

/** Filter input for the `VendorItem.units` field */
export type VendorItemUnitsFilter = {
  /**
   * When provided and set to true, returns only the units that are available for ordering.
   * Does nothing if set to false.
   */
  isOrdering?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a category in a vendor catalog. */
export type VendorItemCategory = Node & {
  __typename?: 'VendorItemCategory';
  id: Scalars['ID']['output'];
  /**
   * Name of the category.
   * Can be stored in multiple languages. The returned language is determined by considering the Accept-Language header and available translations.
   */
  name: Scalars['String']['output'];
  /** Reference to a parent category in case of the nested category structure. */
  parentCategory?: Maybe<VendorItemCategoryRef>;
  /**
   * Reference to the The list of all parents of the current category up to the root category,
   * starting from the direct parent.
   */
  parentCategoryChain: Array<VendorItemCategory>;
  /**
   * The number of category items including the items of all nested subcategories.
   * Only one item from each variant group is counted which corresponds
   * to the result of the vendorItemsForChat query.
   */
  itemsCountForChat: Scalars['Int']['output'];
  /** The image associated with the vendor item category. */
  image?: Maybe<VendorItemCategoryImage>;
};


/** Represents a category in a vendor catalog. */
export type VendorItemCategoryItemsCountForChatArgs = {
  chatId: Scalars['ID']['input'];
};

/**
 * Reference to the VendorItemCategory.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemCategoryRef = RefEdge & {
  __typename?: 'VendorItemCategoryRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemCategory>;
};

/**
 * VendorItemCategoryImage represents VendorItemCategory image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemCategoryImage = {
  __typename?: 'VendorItemCategoryImage';
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
};

export type OrdersToReviewInput = {
  supplierEntityId: Scalars['ID']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};

export type OrdersToReviewResponse = OrdersToReviewConnection | InputValidationFailure;

export type OrdersToReviewConnection = Connection & {
  __typename?: 'OrdersToReviewConnection';
  edges: Array<OrdersToReviewEdge>;
  pageInfo: PageInfo;
};

export type OrdersToReviewEdge = Edge & {
  __typename?: 'OrdersToReviewEdge';
  cursor: Scalars['String']['output'];
  node: OmnichannelOrder;
};

export type PaymentOptionsInput = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  /** Allowed values – plaid, cyberSource */
  psp: Scalars['String']['input'];
  /** Allowed values – ios, android, web */
  platform: Scalars['String']['input'];
};

export type PaymentOptionsResponse = PublicToken | Redirect | InputValidationFailure | AuthorizationFailure;

export type PublicToken = AppsyncResponse & {
  __typename?: 'PublicToken';
  /** Always ResponseType.success */
  responseType: ResponseType;
  paymentToken: Scalars['String']['output'];
};

export type Redirect = AppsyncResponse & {
  __typename?: 'Redirect';
  /** Always ResponseType.success */
  responseType: ResponseType;
  redirectURL: Scalars['String']['output'];
};

export type SearchInput = {
  search: Scalars['String']['input'];
  type?: InputMaybe<SearchEntityType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
  sort?: InputMaybe<Sort>;
};

export enum SearchEntityType {
  User = 'user',
  Chat = 'chat',
  Message = 'message',
  Order = 'order',
  Supplier = 'supplier',
  Product = 'product',
  Broadcast = 'broadcast',
  Buyer = 'buyer'
}

export type SearchFilter = {
  user?: InputMaybe<UserFilter>;
  product?: InputMaybe<ProductFilter>;
  chat?: InputMaybe<ChatFilter>;
  broadcast?: InputMaybe<BroadcastFilter>;
  order?: InputMaybe<OrderFilter>;
  buyer?: InputMaybe<BuyerFilter>;
  supplier?: InputMaybe<SupplierFilter>;
};

export type UserFilter = {
  isSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatFilter = {
  chatName?: InputMaybe<Scalars['String']['input']>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** used in conjunction with labels filter and used by infra to fetch supplier chatLabels */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  /** userId for salesReps and botUserId for supplierAdmins; applicable for infra or admin */
  userId?: InputMaybe<Scalars['String']['input']>;
  additionalEmail?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChatStatus>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastFilter = {
  status?: InputMaybe<Array<InputMaybe<BroadcastStatus>>>;
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderFilter = {
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
};

export type BuyerFilter = {
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierFilter = {
  coordinates?: InputMaybe<CoordinateInput>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  total: Scalars['Int']['output'];
  hits: Array<SearchItem>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  id: Scalars['ID']['output'];
  type: SearchEntityType;
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<SearchEntity>;
};

export type SearchEntity = User | Chat | Message | Order | Supplier | Product | Broadcast | Buyer;

export type SearchBuyerInput = {
  filter?: InputMaybe<SearchBuyerFilter>;
  filterV2?: InputMaybe<SearchBuyerFilterV2>;
};

export type SearchBuyerFilter = {
  googlePlaceAddressId: Scalars['String']['input'];
  googlePlaceEstablishment?: InputMaybe<GooglePlaceEstablishment>;
};

export type GooglePlaceEstablishment = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export type SearchBuyerFilterV2 = {
  name: Scalars['String']['input'];
  /** Buyers will be filtered by distance to a reference coordinate */
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type SearchBuyerResponse = SearchBuyerConnection | InputValidationFailure | AuthorizationFailure;

export type SearchBuyerConnection = Connection & {
  __typename?: 'SearchBuyerConnection';
  total: Scalars['Int']['output'];
  edges: Array<BuyerEdge>;
};

export type BuyerEdge = Edge & {
  __typename?: 'BuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
};

export type SearchGroupsInput = {
  filter?: InputMaybe<SearchGroupsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
};

export type SearchGroupsFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SearchGroupsResponse = SearchGroupsSuccessResponse | SearchGroupsErrorResponse | AuthorizationFailure;

export type SearchGroupsSuccessResponse = AppsyncResponse & {
  __typename?: 'SearchGroupsSuccessResponse';
  responseType: ResponseType;
  groups: GroupConnection;
};

export type GroupConnection = Connection & {
  __typename?: 'GroupConnection';
  total: Scalars['Int']['output'];
  edges: Array<GroupEdge>;
};

export type GroupEdge = Edge & {
  __typename?: 'GroupEdge';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type SearchGroupsErrorResponse = AppsyncError & {
  __typename?: 'SearchGroupsErrorResponse';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<SearchGroupsErrorCode>;
};

export enum SearchGroupsErrorCode {
  Unexpected = 'unexpected'
}

export type SearchOrderInput = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  fromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryFromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  deliveryToTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type SearchOrderResponse = SearchOrderConnection | InputValidationFailure | AuthorizationFailure;

export type SearchOrderConnection = Connection & {
  __typename?: 'SearchOrderConnection';
  total: Scalars['Int']['output'];
  edges: Array<SearchOrderEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type SearchOrderEdge = Edge & {
  __typename?: 'SearchOrderEdge';
  cursor: Scalars['String']['output'];
  node: Order;
};

export type SearchOrderDeskCustomerInput = {
  searchTerm: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
};

export type SearchOrderDeskCustomerResponse = OrderDeskChatsConnection | InputValidationFailure | AuthorizationFailure;

export type OrderDeskChatsConnection = Connection & {
  __typename?: 'OrderDeskChatsConnection';
  total: Scalars['Int']['output'];
  edges: Array<OrderDeskChatsEdge>;
  pageInfo: PageInfo;
};

export type OrderDeskChatsEdge = Edge & {
  __typename?: 'OrderDeskChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type SearchProductsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilter>;
  sort?: InputMaybe<Sort>;
};

export type SearchProductsResponse = SearchProductsConnection | SearchProductsError;

export type SearchProductsConnection = Connection & {
  __typename?: 'SearchProductsConnection';
  total: Scalars['Int']['output'];
  edges: Array<SearchProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type SearchProductsEdge = Edge & {
  __typename?: 'SearchProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type SearchProductsError = AppsyncResponse & AppsyncError & {
  __typename?: 'SearchProductsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SearchTaxonomyLabelsInput = {
  search: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type SearchTaxonomyLabelsResponse = SearchTaxonomyLabelsConnection | SearchTaxonomyLabelsError;

export type SearchTaxonomyLabelsConnection = Connection & {
  __typename?: 'SearchTaxonomyLabelsConnection';
  total: Scalars['Int']['output'];
  edges: Array<SearchTaxonomyLabelsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type SearchTaxonomyLabelsEdge = Edge & {
  __typename?: 'SearchTaxonomyLabelsEdge';
  cursor: Scalars['String']['output'];
  node: TaxonomyLabel;
};

export type TaxonomyLabel = Node & {
  __typename?: 'TaxonomyLabel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SearchTaxonomyLabelsError = AppsyncResponse & AppsyncError & {
  __typename?: 'SearchTaxonomyLabelsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

/** Input to sendSampleSmsMessage */
export type SendSampleSmsMessageInput = {
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
  /** Body of the sms to send. */
  messageBody: Scalars['String']['input'];
  /** Optional media attachments */
  mediaUrls?: InputMaybe<Array<SendSampleSmsMessageMediaInput>>;
};

export type SendSampleSmsMessageMediaInput = {
  mediaUrl: Scalars['String']['input'];
};

export type SendSampleSmsMessageResponse = SendSampleSmsMessageSuccess | SendSampleSmsMessageFailure | InputValidationFailure | AuthorizationFailure;

export type SendSampleSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageSuccess';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  messageSid: Scalars['String']['output'];
};

export type SendSampleSmsMessageFailure = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageFailure';
  responseType: ResponseType;
  errorMessage: Scalars['String']['output'];
};

export type SharedBroadcastProducts = {
  __typename?: 'SharedBroadcastProducts';
  categories?: Maybe<Array<ProductCategory>>;
  productCountInProductList?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Product>>;
};

export type StockCountSessionsInput = {
  buyerId: Scalars['ID']['input'];
  filter?: InputMaybe<StockCountSessionsFilter>;
};

export type StockCountSessionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If status is not provided then all buyer sessions (draft and completed) will be returned.
   * If status "draft" is provided then only draft sessions for the corresponding user will be returned.
   * If status "completed" is provided then only completed sessions for all users of the requested buyer will be returned.
   */
  status?: InputMaybe<Array<StockCountSessionEnum>>;
};

export enum StockCountSessionEnum {
  Draft = 'draft',
  Completed = 'completed'
}

export type StockCountSessionsPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type StockCountSessionsResponse = AuthorizationFailure | InputValidationFailure | StockCountSessionsSuccess;

export type StockCountSessionsSuccess = {
  __typename?: 'StockCountSessionsSuccess';
  responseType?: Maybe<ResponseType>;
  stockCountSessions: Array<StockCountSession>;
  paginationInfo: StockCountSessionsPaginationInfo;
};

export type StockCountSession = {
  __typename?: 'StockCountSession';
  countDetails?: Maybe<CountDetails>;
  id: Scalars['ID']['output'];
  itemsCounted: Scalars['Int']['output'];
  itemsTotal: Scalars['Int']['output'];
  status: StockCountSessionEnum;
  submittedById?: Maybe<Scalars['ID']['output']>;
  submittedDate?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type CountDetails = {
  __typename?: 'CountDetails';
  estimatedValues: Array<StockItemPrice>;
  stockCountItems: Array<StockItem>;
};

export type StockItemPrice = {
  __typename?: 'StockItemPrice';
  currency: Scalars['String']['output'];
  priceInCents: Scalars['Int']['output'];
};

export type StockItem = {
  __typename?: 'StockItem';
  estimatedValueInCents?: Maybe<StockItemPrice>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<StockItemPrice>;
  quantity: Scalars['Float']['output'];
  storageItemId: Scalars['ID']['output'];
  unit: Scalars['String']['output'];
};

export type StockCountSessionsPaginationInfo = {
  __typename?: 'StockCountSessionsPaginationInfo';
  currentPage: Scalars['Int']['output'];
  lastPage: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StockCountUsersInput = {
  buyerId: Scalars['ID']['input'];
};

export type StockCountUsersResponse = StockCountUsersSuccess | AuthorizationFailure;

export type StockCountUsersSuccess = {
  __typename?: 'StockCountUsersSuccess';
  users: Array<StockCountUser>;
};

export type StockCountUser = {
  __typename?: 'StockCountUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StorageAreasInput = {
  buyerId: Scalars['ID']['input'];
};

export type StorageAreasResponse = StorageAreasSuccess | InputValidationFailure | AuthorizationFailure;

export type StorageAreasSuccess = {
  __typename?: 'StorageAreasSuccess';
  responseType?: Maybe<ResponseType>;
  storageAreas: Array<StorageArea>;
};

export type StorageArea = {
  __typename?: 'StorageArea';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  storageItems: Array<StorageItem>;
};


export type StorageAreaStorageItemsArgs = {
  input?: InputMaybe<StorageAreaStorageItemsInput>;
};

export type StorageAreaStorageItemsInput = {
  filter?: InputMaybe<StorageItemsFilter>;
};

export type StorageItemsFilter = {
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StorageItem = {
  __typename?: 'StorageItem';
  id: Scalars['ID']['output'];
  position: Scalars['Float']['output'];
  inventoryItem: InventoryItem;
  price?: Maybe<ItemPrice>;
  unit?: Maybe<ItemUnit>;
  count?: Maybe<StorageItemCount>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'vendor' instead */
  supplierId?: Maybe<Scalars['ID']['output']>;
  vendor?: Maybe<ItemVendor>;
};

export type ItemVendor = ChocoVendor | BuyerExternalVendor;

export type ChocoVendor = {
  __typename?: 'ChocoVendor';
  id: Scalars['ID']['output'];
};

export type BuyerExternalVendor = {
  __typename?: 'BuyerExternalVendor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ItemPrice = {
  __typename?: 'ItemPrice';
  id: Scalars['ID']['output'];
  priceInCents: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

export type ItemUnit = {
  __typename?: 'ItemUnit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StorageItemCount = {
  __typename?: 'StorageItemCount';
  inStock: Scalars['Float']['output'];
  dateCounted: Scalars['AWSTimestamp']['output'];
};

export type SupplierAssortments = {
  __typename?: 'supplierAssortments';
  assortments: Array<Scalars['String']['output']>;
};

export type ChatLabelsResult = {
  __typename?: 'ChatLabelsResult';
  label?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type SupplierDeliveryDateSettingsResponse = SupplierDeliveryDateSettings | SupplierNotFound | SupplierDeliverySettingsNotFound;

export type SupplierDeliverySettingsNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierDeliverySettingsNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierSearchInput = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
};

export type SupplierSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierSearchResponse = SearchSupplierConnection | InputValidationFailure | AuthorizationFailure;

export type SearchSupplierConnection = Connection & {
  __typename?: 'SearchSupplierConnection';
  total: Scalars['Int']['output'];
  edges: Array<SupplierSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type SupplierSearchEdge = Edge & {
  __typename?: 'SupplierSearchEdge';
  cursor: Scalars['String']['output'];
  node: Supplier;
};

export type SupplierSearchV2Filter = {
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
  assortments?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCompanyName?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocale?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderTransmission?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserChatsResponse = UserChatConnection | UserChatsError;

/**
 * Errors thrown by userChats
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type UserChatsError = AppsyncResponse & AppsyncError & {
  __typename?: 'UserChatsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UserSearchInput = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserSearchFilter>;
};

export type UserSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSearchResponse = UserSearchConnection | InputValidationFailure | AuthorizationFailure;

export type UserSearchConnection = Connection & {
  __typename?: 'UserSearchConnection';
  total: Scalars['Int']['output'];
  edges: Array<UserSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
};

export type UserSearchEdge = Edge & {
  __typename?: 'UserSearchEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ValidateProductsAvailabilityInput = {
  chatId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type ValidateProductsAvailabilityResponse = ValidateProductsAvailabilityResult | ChatNotFoundError | SupplierNotFound | InputValidationFailure | AuthorizationFailure;

export type ValidateProductsAvailabilityResult = {
  __typename?: 'ValidateProductsAvailabilityResult';
  unavailableForSupplier?: Maybe<Array<Scalars['ID']['output']>>;
  unavailableForChat?: Maybe<Array<Scalars['ID']['output']>>;
  notFound?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input parameters for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatInput = {
  /** Id of the vendor whose catalog categories are being queried */
  vendorId: Scalars['ID']['input'];
  /**
   * Chat determines the context of the query.
   * Only the categories that have at least one visible item for a given chat
   * via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filter to narrow down the list of the returned categories */
  filter?: InputMaybe<VendorItemCategoriesForChatFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
};

/** Filter input for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatFilter = {
  /** If provided, only returns categories which are the direct children of the provided category. */
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided and set to true, only returns top-level categories, i.e. the ones which do not have a parent.
   * If set to false, does nothing.
   */
  rootCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, only returns categories that have items directly assigned to them or assigned to any of the child/nested categories. */
  withItemsNested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorItemCategoriesForChatResponse = VendorItemCategoriesForChatSuccess | InputValidationFailure | AuthorizationFailure;

/** Success response of the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatSuccess = AppsyncResponse & Page & Connection & {
  __typename?: 'VendorItemCategoriesForChatSuccess';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  pageInfo: PageInfo;
  edges: Array<VendorItemCategoriesForChatResultEdge>;
};

/** One category of the `vendorItemCategoriesForChat` query result page */
export type VendorItemCategoriesForChatResultEdge = Edge & {
  __typename?: 'VendorItemCategoriesForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemCategory;
};

/** Input parameters for the `vendorItems` query */
export type VendorItemsInput = {
  /** An array of the item ids to fetch. Maximum 50 items can be fetched at a time. */
  ids: Array<Scalars['ID']['input']>;
};

export type VendorItemsResponse = VendorItemsSuccess | InputValidationFailure | AuthorizationFailure;

/** Success response of the `vendorItems` query */
export type VendorItemsSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsSuccess';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /**
   * Items that are fetched.
   * If the item is not found, it is not included in the list.
   */
  items: Array<VendorItem>;
};

/** Input parameters for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatInput = {
  /** Id of the vendor whose catalog items are being counted */
  vendorId: Scalars['ID']['input'];
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat
   * via a custom catalog or default catalog relationship are counted.
   */
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsCountForChatFilter>;
};

/** Filter input for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatFilter = {
  /**
   * if true only counts items without a category
   * if false returns the total count of vendor items in the chat
   */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorItemsCountForChatResponse = VendorItemsCountForChatSuccess | InputValidationFailure | AuthorizationFailure;

/** Success response of the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsCountForChatSuccess';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  count: Scalars['Int']['output'];
};

/** Input parameters for the `vendorItemsForChat` query */
export type VendorItemsForChatInput = {
  /** Id of the vendor whose items are being queried */
  vendorId: Scalars['ID']['input'];
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<VendorItemsForChatFilterInput>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
};

/** Filter input for the `vendorItemsForChat` query */
export type VendorItemsForChatFilterInput = {
  /**
   * If the value is "00000000-0000-0000-0000-000000000000", only items that are not linked to any category are returned;
   * else only items directly linked to this category will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided, only items with the given `variantGroupCode` will be returned. */
  variantGroupCode?: InputMaybe<Scalars['String']['input']>;
};

export type VendorItemsForChatResponse = VendorItemsForChatSuccess | InputValidationFailure | AuthorizationFailure;

/** Success response of the `vendorItemsForChat` query */
export type VendorItemsForChatSuccess = AppsyncResponse & Page & Connection & {
  __typename?: 'VendorItemsForChatSuccess';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  pageInfo: PageInfo;
  edges: Array<VendorItemsForChatResultEdge>;
};

/** One item of the `vendorItemsForChat` query result page */
export type VendorItemsForChatResultEdge = Edge & {
  __typename?: 'VendorItemsForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

/** Input parameters for the `vendorItemsForVendor` query */
export type VendorItemsForVendorInput = {
  vendorId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsForVendorFilter>;
  sort?: InputMaybe<VendorItemsForVendorSort>;
  pagination?: InputMaybe<PaginationInputV2>;
};

/** The filter can be applied to vendor items.  */
export type VendorItemsForVendorFilter = {
  /**
   * If the array has the value "00000000-0000-0000-0000-000000000000", items that are not linked to any category are also returned;
   * else only items directly linked to the given categories will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When specified, only items that are linked to the given custom catalog will be returned. */
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /** When specified, only items that have the given stock status will be returned. */
  status?: InputMaybe<VendorItemUnitStockStatus>;
  /** When specified, returns items based on their hidden by default status, including those hidden or not hidden depending on the value provided. */
  isHiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sorting parameters for VendorItems, indicating the field and the direction of order. */
export type VendorItemsForVendorSort = {
  field: VendorItemsForVendorSortField;
  order: SortOrder;
};

/** Sort fields available for organizing VendorItems results. */
export enum VendorItemsForVendorSortField {
  Name = 'name',
  ProductCode = 'productCode',
  UnitName = 'unitName'
}

export type VendorItemsForVendorResponse = VendorItemsForVendorResult | InputValidationFailure | AuthorizationFailure;

/** Success response of the `vendorItemsForVendor` query */
export type VendorItemsForVendorResult = AppsyncResponse & Page & Connection & {
  __typename?: 'VendorItemsForVendorResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The total number of items matching the filter criteria. */
  totalCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  edges: Array<VendorItemsForVendorResultEdge>;
};

export type VendorItemsForVendorResultEdge = Edge & {
  __typename?: 'VendorItemsForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrder: AcceptOrderResponse;
  /** @deprecated we no longer support it */
  activateSuppliersPaymentAccount: ActivateSuppliersPaymentAccountResponse;
  addBuyerStockInventoryProduct: AddBuyerStockInventoryProductResponse;
  addCatalogProductsToProductList: Array<CategoryProducts>;
  addEntitiesToGroup?: Maybe<AddEntitiesToGroupResponse>;
  addInvoice: AddInvoiceResponse;
  addLabelToChats: Scalars['Boolean']['output'];
  /** Ensure that products are in catalog, then add them */
  addMarketingProductsToCart?: Maybe<AddMarketingProductsToCartResponse>;
  /** @deprecated we no longer support it */
  addPaymentAccount: AddPaymentAccountResponse;
  addProductsToOrderGuides: AddProductsToOrderGuidesResponse;
  addSalesRep: AddSalesRepRequestToJoinResponse;
  /** Buyer Add Supplier Request */
  addSupplierRequest: BuyerAddSupplierResponse;
  /** @deprecated we no longer support it */
  addSuppliersPaymentAccount: AddSuppliersPaymentAccountResponse;
  addUserToChats: Scalars['Boolean']['output'];
  addUsersToGroup?: Maybe<AddUsersToGroupResponse>;
  /** @deprecated we no longer support it */
  adminAddPaymentAccount: AddPaymentAccountResponse;
  assignOrderToUserForReview: AssignOrderToUserForReviewResponse;
  batchOrderConfirm?: Maybe<BatchOrderConfirmResponse>;
  /**
   * For internal use, to update the supplier of
   * all orders associated with a chat
   */
  batchUpdateOrderSupplier?: Maybe<BatchUpdateOrderSupplier>;
  broadcastCreate: Broadcast;
  broadcastUpdate: Broadcast;
  broadcastUpdatePurpose?: Maybe<BroadcastUpdatePurposeResult>;
  bulkSendInviteTransmission: BulkSendInviteTransmissionResponse;
  bulkSubmitOrderedProductDeliveryCheck?: Maybe<BulkOrderedProductDeliveryCheckSubmissionResponse>;
  buyerAddUser: BuyerUser;
  buyerBulkAddUser: Array<Maybe<BuyerUser>>;
  buyerCreate: Buyer;
  buyerDisableRoles: BuyerDisableRolesResponse;
  buyerRemoveUser: BuyerUser;
  buyerUpdate: Buyer;
  /** Cancel the cart. This empties out the lineItems. */
  cancelCart?: Maybe<CancelCartResponse>;
  /** Mutation to start a catalog import job. */
  catalogImportStart: CatalogImportStartResponse;
  categoryCreate: ProductCategory;
  categoryDelete: Array<Maybe<Scalars['ID']['output']>>;
  categoryProductSort: Array<CategoryProducts>;
  categoryUpdate: ProductCategory;
  chatCreate: Chat;
  chatDisable: Scalars['Boolean']['output'];
  chatInviteUsers: Chat;
  chatLeave?: Maybe<Scalars['ID']['output']>;
  /**
   * Admin only,
   * to update the main supplier of a chat
   * - migrate order to new supplier (bot user)
   * - add the new supplier into the chat
   * - remove the old supplier out the chat
   */
  chatMainSupplierMigrate: Scalars['Boolean']['output'];
  chatRemoveUsers: Chat;
  chatUpdate: Chat;
  /**
   * For internal use, to update the supplier of
   * a chat
   */
  chatUpdateMainSupplier: Scalars['Boolean']['output'];
  claimOnboardingChecklistReward: ClaimOnboardingChecklistRewardResponse;
  confirmDeliveryCheckReconciliationRequest?: Maybe<ConfirmDeliveryCheckReconciliationResponse>;
  connectAccount: ConnectAccountResponse;
  /**
   * connectIntegrationAdapter is legacy mutation that should be used only by Harel untill end of Hydra migration
   * In order to create new Lobster and other CUSTOM integration connections use integrationAdapterConnectionCreate instead
   */
  connectIntegrationAdapter: ConnectIntegrationAdapterResponse;
  contactsCreate?: Maybe<Array<Maybe<User>>>;
  /** Create buyer report schedule */
  createBuyerReportSchedule: CreateBuyerReportScheduleResponse;
  createGroup?: Maybe<GroupResponse>;
  createOrderDeliveryCheck?: Maybe<OrderDeliveryCheckCreationResponse>;
  createOrderDeliveryCheckImageUploadUrl?: Maybe<OrderDeliveryCheckImageUploadUrlResponse>;
  createOrderDeskEmailList: CreateEmailListResponse;
  createProfile: CreateProfileResponse;
  /** create endpoint for receiving mobile push notifications */
  createPushEndpoint?: Maybe<PushEndpointResponse>;
  createReferral?: Maybe<CreateReferralResponse>;
  createStorageItem: CreateStorageItemResponse;
  createSubCatalog?: Maybe<CreateSubCatalogResponse>;
  createSupplierContact: CreateSupplierContactResponse;
  /** par and category are forbidden */
  createSupplierProduct: CreateUpdateSupplierProductResponse;
  createSupplierProductV2: CreateUpdateSupplierProductResponse;
  /** @deprecated we no longer support it */
  deactivateSuppliersPaymentAccount: DeactivateSuppliersPaymentAccountResponse;
  /** Delete buyer report schedule */
  deleteBuyerReportSchedule: DeleteBuyerReportScheduleResponse;
  deleteBuyerStockInventoryProducts: DeleteBuyerStockInventoryProductsResponse;
  /**
   * Deletes a deliverySetting if it is scoped to a specific chat.
   * If the mutation was a success, it returns the ID of the deleted deliverySetting.
   * If the deliverySetting was not scoped to a chat, it will return an error.
   */
  deleteChatDeliverySetting?: Maybe<DeletedChatSetting>;
  /**
   * Allow admin to remove entire supplier products, the return number is meaningless
   * Be aware: the operation is an async processing. The products will be removed in background one by one.
   */
  deleteEntireSupplierProduct?: Maybe<Scalars['Int']['output']>;
  deleteProductImage?: Maybe<Scalars['Int']['output']>;
  deleteProfileImage?: Maybe<User>;
  deleteSubCatalog?: Maybe<DeleteSubCatalogResponse>;
  deleteSupplierNegotiatedPrices?: Maybe<DeletedSupplierNegotiatedPriceResponse>;
  deleteSupplierProduct?: Maybe<Array<Scalars['ID']['output']>>;
  disconnectAccount: DisconnectAccountResponse;
  disconnectIntegrationAdapter: DisconnectIntegrationAdapterResponse;
  /** Edit buyer report schedule */
  editBuyerReportSchedule: EditBuyerReportScheduleResponse;
  /** Generate buyer report */
  generateBuyerReport: GenerateBuyerReportResponse;
  getClientDebuggableArtifactUploadUrl: GetClientDebuggableArtifactUploadUrlResponse;
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlResponse;
  /** @deprecated use importSupplierProductsV2 instead */
  importSupplierProducts: ImportSupplierProductsReport;
  importSupplierProductsV2: ImportSupplierProductsReport;
  initInventoryDownload: InitInventoryDownloadResponse;
  initInventoryUpload: InitInventoryUploadResponse;
  /**
   * Generates a token that the clients can use to checkout
   * Supported types are: 'balance'
   * @deprecated we no longer support it
   */
  initiateCheckout: InitiateCheckoutResponse;
  integrationAdapterConnectionAuth: IntegrationAdapterConnectionAuthResponse;
  integrationAdapterConnectionConsent: IntegrationAdapterConnectionConsentResponse;
  integrationAdapterConnectionCreate: IntegrationAdapterConnectionCreateResponse;
  integrationAdapterConnectionUpdate: IntegrationAdapterConnectionUpdateResponse;
  integrationAdapterCreate: IntegrationAdapterCreateResponse;
  integrationAdapterUpdate: IntegrationAdapterUpdateResponse;
  integrationWebhookRetry: IntegrationWebhookRetryResponse;
  internalInviteUsers: InternalInviteUsersResponse;
  /** @deprecated use inviteUserToBuyer instead */
  inviteNonChocoUserToBuyer?: Maybe<InviteNonChocoUserToBuyerResponse>;
  inviteNonChocoUserToChat?: Maybe<Chat>;
  inviteUserToBuyer: InviteUserToBuyerResponse;
  /** @deprecated we no longer support it */
  kycCreate: KycCreateResponse;
  messageCreate: Message;
  notificationCreate?: Maybe<Notification>;
  notificationPreferencesUpdate?: Maybe<NotificationPreferences>;
  orderConfirm?: Maybe<Message>;
  orderCreate: Order;
  orderCreateV2?: Maybe<OrderCreatedResponse>;
  orderEdit?: Maybe<OrderEditedResponse>;
  orderExportConfigCreate: OrderExportConfig;
  orderExportConfigDelete: Scalars['Boolean']['output'];
  orderExportConfigUpdate: OrderExportConfig;
  orderGuideCreated: OrderGuideCreatedResponse;
  orderGuideRequest: OrderGuideRequestResponse;
  orderGuideV2ItemUnitsAdd: OrderGuideV2ItemUnitsAddResponse;
  orderGuideV2ItemUnitsRemove: OrderGuideV2ItemUnitsRemoveResponse;
  /** @deprecated we no longer support it */
  paymentAuthorize: PaymentAuthorizeResponse;
  productBatchCreate: Scalars['String']['output'];
  productCreate: Product;
  productDelete: Array<Maybe<Scalars['ID']['output']>>;
  productSort: Array<Maybe<Scalars['ID']['output']>>;
  productUpdate: Product;
  productUpdateCategory: UpdatedCategoryProduct;
  productUpdateExternalId: Product;
  referUser?: Maybe<ReferUserResponse>;
  refreshOrderDesk: OmnichannelOrdersSubcriptionResponse;
  rejectOrder: RejectOrderResponse;
  rejectOrdersById: RejectOrdersByIdResponse;
  /** Only admin can remove the blocked email and the return is a null */
  removeBlockedEmail?: Maybe<Scalars['Int']['output']>;
  /** Remove an email from the 'chat.additionalEmails' list across all chats */
  removeCCEmailFromChats: RemoveCcEmailFromChatsReport;
  removeEmailFromBuyerReportSchedule?: Maybe<RemoveEmailFromBuyerReportScheduleResponse>;
  removeEntitiesFromGroup?: Maybe<RemoveEntitiesFromGroupResponse>;
  removeInvoice: RemoveInvoiceResponse;
  removeInvoiceAttachment: RemoveInvoiceAttachmentResponse;
  removeLabelFromChats: Scalars['Boolean']['output'];
  removeOrderDeskEmail: OrderDeskRemovedEmailResponse;
  /** @deprecated we no longer support it */
  removePaymentAccount: RemovePaymentAccountResponse;
  removeProductsFromOrderGuides: RemoveProductsFromOrderGuidesResponse;
  removeSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  removeUserFromChats: Scalars['Boolean']['output'];
  removeUsersFromGroup?: Maybe<RemoveUsersFromGroupResponse>;
  requestToJoinBuyer: RequestToJoinBuyerResponse;
  selectProductForOrderGuide: SelectProductForOrderGuideResponse;
  selectProductsForOrderGuide: SelectProductsForOrderGuideResponse;
  /** Invite Transmission */
  sendInviteTransmission: SendInviteTransmissionResponse;
  sendSyntheticSmsMessage: SendSyntheticSmsMessageResponse;
  sendSyntheticWhatsAppMessage: SendSyntheticWhatsAppMessageResponse;
  /**
   * Sets the isTest field of order to true. You cannot set the value back to false.
   * Is accessible only by admin
   */
  setOrderAsTest: SetOrderAsTestResponse;
  shortenUrl: Scalars['String']['output'];
  submitBuyerStockCount: BuyerStockCountResponse;
  /** Submit the cart for checkout. This creates an order from the line items in the cart. */
  submitCart?: Maybe<CartSubmissionResponse>;
  submitOrderDeliveryCheck?: Maybe<OrderDeliveryCheckSubmissionResponse>;
  submitOrderedProductDeliveryCheck?: Maybe<OrderedProductDeliveryCheckSubmissionResponse>;
  submitStockCountSession: SubmitStockCountSessionResponse;
  /** @deprecated With the successful rollout of BAS + “Add sales rep” flow in place, it is time to deprecate the Add Supplier Form and replace it with a much simpler contact customer support UX. */
  supplierAddRequest: SupplierAddRequestResponse;
  supplierCreate: Supplier;
  /** Get in touch form for suppliers to request a callback from Ops for contracts. */
  supplierGetInTouchRequest?: Maybe<SupplierGetInTouchRequestResponse>;
  supplierInviteUser: SupplierInviteUserResponse;
  supplierInviteUsers: SupplierInviteUserResponse;
  /** Allow SupplierAdmins to remove user (supplierAdmin/SalesReps) from team */
  supplierRemoveUser: User;
  supplierUpdate: Supplier;
  /** API for vendor team management */
  supplierUserCreate?: Maybe<User>;
  supplierUserRemove: SupplierUserRemoveResponse;
  triggerProductMatching: TriggerProductMatchingResponse;
  unassignUserFromOrderToReview: UnassignUserFromOrderToReviewResponse;
  undoMultiLocationOrderGuideTransaction: UndoMultiLocationOrderGuideTransactionResponse;
  updateBuyerInventoryProduct: UpdateBuyerInventoryProductResponse;
  updateBuyerStockInventoryProduct: UpdateBuyerStockInventoryProductResponse;
  /** update the cart items */
  updateCart?: Maybe<CartUpdateResponse>;
  updateChatEnabled: Scalars['Boolean']['output'];
  updateChatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  updateInventoryItem: UpdateInventoryItemResponse;
  updateInvoice: UpdateInvoiceResponse;
  /** Update invoiced product */
  updateInvoicedProduct: UpdateInvoicedProductResponse;
  /**
   * For internal use, to update a users
   * notificationPreferences ID when a users role is updated
   */
  updateNotificationUserId?: Maybe<NotificationPreferences>;
  updatePendingUser: UpdatePendingUserResponse;
  updateProductVariantsInOrderGuide: UpdateProductVariantsInOrderGuideResponse;
  updateRequestToJoin: UpdateJoinRequestResponse;
  updateStorageItem: UpdateStorageItemResponse;
  updateSubCatalog?: Maybe<UpdateSubCatalogResponse>;
  updateSubCatalogChats: UpdateSubCatalogChatsResponse;
  updateSupplierAccessPackage: SupplierUpdateAccessPackageResponse;
  updateSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  /** Admin/Supplier Admin only */
  updateSupplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  updateSupplierProduct: CreateUpdateSupplierProductResponse;
  updateSupplierProductV2: CreateUpdateSupplierProductResponse;
  updateSupplierUserChats: SupplierUserUpdateChatsResponse;
  updateSupplierUserRoles?: Maybe<User>;
  /** @deprecated use uploadSubCatalogProductsV2 instead */
  uploadSubCatalogProducts: UploadSubCatalogProductsResponse;
  uploadSubCatalogProductsV2: UploadSubCatalogProductsResponse;
  upsertStockCountSessionItems?: Maybe<UpsertStockCountSessionItemsResponse>;
  /** @deprecated use updateSupplierUserRoles instead */
  userAddRole?: Maybe<User>;
  /** Admin Only, confirm pending users on cognito */
  userConfirm: Scalars['Boolean']['output'];
  userCreate?: Maybe<User>;
  userLeadCreate?: Maybe<UserLead>;
  /** @deprecated use updateSupplierUserRoles instead */
  userRemoveRole?: Maybe<User>;
  userRequestToDelete: UserRequestToDeleteResponse;
  userUpdate?: Maybe<User>;
  vendorItemUnitUpdate: VendorItemUnitUpdateResponse;
};


export type MutationAcceptOrderArgs = {
  id: Scalars['ID']['input'];
  acceptedOrder: AcceptOrderInput;
};


export type MutationActivateSuppliersPaymentAccountArgs = {
  input: ActivateSuppliersPaymentAccountInput;
};


export type MutationAddBuyerStockInventoryProductArgs = {
  input: AddBuyerStockInventoryProductInput;
};


export type MutationAddCatalogProductsToProductListArgs = {
  chatId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  catalogProductList: Array<ProductsCategoryInput>;
};


export type MutationAddEntitiesToGroupArgs = {
  input: AddEntitiesToGroupInput;
};


export type MutationAddInvoiceArgs = {
  input: AddInvoiceInput;
};


export type MutationAddLabelToChatsArgs = {
  label: Scalars['String']['input'];
  chatIds: Array<Scalars['ID']['input']>;
};


export type MutationAddMarketingProductsToCartArgs = {
  chatId: Scalars['ID']['input'];
  products: Array<AddMarketingProductsToCartInput>;
};


export type MutationAddPaymentAccountArgs = {
  account: PaymentAccountInput;
};


export type MutationAddProductsToOrderGuidesArgs = {
  input: AddProductsToOrderGuidesInput;
};


export type MutationAddSalesRepArgs = {
  input?: InputMaybe<AddSalesRepRequestToJoinInput>;
};


export type MutationAddSupplierRequestArgs = {
  input: BuyerAddSupplierInput;
};


export type MutationAddSuppliersPaymentAccountArgs = {
  input: AddSuppliersPaymentAccountInput;
};


export type MutationAddUserToChatsArgs = {
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']>;
};


export type MutationAddUsersToGroupArgs = {
  input: AddUsersToGroupInput;
};


export type MutationAdminAddPaymentAccountArgs = {
  account: PaymentAccountInput;
  owner: PaymentAccountOwnerInput;
};


export type MutationAssignOrderToUserForReviewArgs = {
  input: AssignOrderToUserForReviewInput;
};


export type MutationBatchOrderConfirmArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchUpdateOrderSupplierArgs = {
  input: BatchUpdateOrderSupplierInput;
};


export type MutationBroadcastCreateArgs = {
  broadcastInput: BroadcastInput;
};


export type MutationBroadcastUpdateArgs = {
  id: Scalars['ID']['input'];
  broadcastInput: BroadcastInput;
};


export type MutationBroadcastUpdatePurposeArgs = {
  id: Scalars['ID']['input'];
  purpose: BroadcastPurposeInput;
};


export type MutationBulkSendInviteTransmissionArgs = {
  input: BulkSendInviteTransmissionInput;
};


export type MutationBulkSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<BulkSubmitOrderedProductDeliveryCheckInput>;
};


export type MutationBuyerAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  input?: InputMaybe<BuyerUserInput>;
};


export type MutationBuyerBulkAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  userRoles: Array<BuyerUserRoleInput>;
};


export type MutationBuyerCreateArgs = {
  buyer: BuyerCreateInput;
};


export type MutationBuyerDisableRolesArgs = {
  buyerId: Scalars['ID']['input'];
};


export type MutationBuyerRemoveUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationBuyerUpdateArgs = {
  id: Scalars['ID']['input'];
  buyer: BuyerUpdateInput;
};


export type MutationCancelCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CancelCartOptionsInput;
};


export type MutationCatalogImportStartArgs = {
  input: CatalogImportStartInput;
};


export type MutationCategoryCreateArgs = {
  chatId: Scalars['ID']['input'];
  category: CategoryInput;
};


export type MutationCategoryDeleteArgs = {
  chatId: Scalars['ID']['input'];
  categoryIds: Array<Scalars['ID']['input']>;
};


export type MutationCategoryProductSortArgs = {
  chatId: Scalars['ID']['input'];
  categorizedProductList: Array<ProductsCategoryInput>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCategoryUpdateArgs = {
  chatId: Scalars['ID']['input'];
  category: CategoryInput;
};


export type MutationChatCreateArgs = {
  chat: ChatCreateInput;
};


export type MutationChatDisableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatInviteUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationChatLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatMainSupplierMigrateArgs = {
  chatId: Scalars['ID']['input'];
  supplierUserId: Scalars['ID']['input'];
};


export type MutationChatRemoveUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationChatUpdateArgs = {
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
};


export type MutationChatUpdateMainSupplierArgs = {
  chatId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationClaimOnboardingChecklistRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmDeliveryCheckReconciliationRequestArgs = {
  orderId: Scalars['ID']['input'];
  deliveryCheckReconciliationRequestId: Scalars['ID']['input'];
};


export type MutationConnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationConnectIntegrationAdapterArgs = {
  input: ConnectIntegrationAdapterInput;
};


export type MutationContactsCreateArgs = {
  numbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateBuyerReportScheduleArgs = {
  input: CreateBuyerReportScheduleInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateOrderDeliveryCheckArgs = {
  input: CreateOrderDeliveryCheckInput;
};


export type MutationCreateOrderDeliveryCheckImageUploadUrlArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCreateOrderDeskEmailListArgs = {
  input: CreateOrderDeskEmailList;
};


export type MutationCreateProfileArgs = {
  user: CreateProfileInput;
};


export type MutationCreatePushEndpointArgs = {
  input?: InputMaybe<CreatePushEndpointInput>;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateStorageItemArgs = {
  input: CreateStorageItemInput;
};


export type MutationCreateSubCatalogArgs = {
  name: Scalars['String']['input'];
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSupplierContactArgs = {
  supplierContact: CreateSupplierContactInput;
};


export type MutationCreateSupplierProductArgs = {
  product: ProductInput;
};


export type MutationCreateSupplierProductV2Args = {
  product: SupplierProductInput;
};


export type MutationDeactivateSuppliersPaymentAccountArgs = {
  input: DeactivateSuppliersPaymentAccountInput;
};


export type MutationDeleteBuyerReportScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteBuyerStockInventoryProductsArgs = {
  input: DeleteBuyerStockInventoryProductsInput;
};


export type MutationDeleteChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteEntireSupplierProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductImageArgs = {
  input: DeleteProductImageInput;
};


export type MutationDeleteProfileImageArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierNegotiatedPricesArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  buyerId: Scalars['ID']['input'];
};


export type MutationDeleteSupplierProductArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDisconnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationDisconnectIntegrationAdapterArgs = {
  input: DisconnectIntegrationAdapterInput;
};


export type MutationEditBuyerReportScheduleArgs = {
  input: EditBuyerReportScheduleInput;
};


export type MutationGenerateBuyerReportArgs = {
  input: GenerateBuyerReportInput;
};


export type MutationGetClientDebuggableArtifactUploadUrlArgs = {
  getClientDebuggableArtifactUploadUrl: GetClientDebuggableArtifactUploadUrlInput;
};


export type MutationGetOrderGuideUploadUrlArgs = {
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlInput;
};


export type MutationImportSupplierProductsArgs = {
  supplierId: Scalars['ID']['input'];
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
};


export type MutationImportSupplierProductsV2Args = {
  supplierId: Scalars['ID']['input'];
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
};


export type MutationInitInventoryDownloadArgs = {
  input: InitInventoryDownloadInput;
};


export type MutationInitInventoryUploadArgs = {
  input: InitInventoryUploadInput;
};


export type MutationInitiateCheckoutArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentAccountId: Scalars['ID']['input'];
};


export type MutationIntegrationAdapterConnectionAuthArgs = {
  input: IntegrationAdapterConnectionAuthInput;
};


export type MutationIntegrationAdapterConnectionConsentArgs = {
  input: IntegrationAdapterConnectionConsentInput;
};


export type MutationIntegrationAdapterConnectionCreateArgs = {
  input: IntegrationAdapterConnectionCreateInput;
};


export type MutationIntegrationAdapterConnectionUpdateArgs = {
  input: IntegrationAdapterConnectionUpdateInput;
};


export type MutationIntegrationAdapterCreateArgs = {
  input: IntegrationAdapterCreateInput;
};


export type MutationIntegrationAdapterUpdateArgs = {
  input: IntegrationAdapterUpdateInput;
};


export type MutationIntegrationWebhookRetryArgs = {
  input: IntegrationWebhookRetryInput;
};


export type MutationInternalInviteUsersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
  invitorUserId: Scalars['ID']['input'];
  botUserId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInviteNonChocoUserToBuyerArgs = {
  phone: Scalars['String']['input'];
  buyerId: Scalars['ID']['input'];
  input?: InputMaybe<InviteUserToBuyerInput>;
};


export type MutationInviteNonChocoUserToChatArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
};


export type MutationInviteUserToBuyerArgs = {
  buyerId: Scalars['ID']['input'];
  input: InviteUserToBuyerInputV2;
};


export type MutationKycCreateArgs = {
  input: KycCreateInput;
};


export type MutationMessageCreateArgs = {
  chatId: Scalars['ID']['input'];
  message: MessageInput;
  order?: InputMaybe<OrderInput>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNotificationCreateArgs = {
  userId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};


export type MutationNotificationPreferencesUpdateArgs = {
  input?: InputMaybe<NotificationPreferencesInput>;
};


export type MutationOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderCreateArgs = {
  chatId: Scalars['ID']['input'];
  order: OrderInput;
};


export type MutationOrderCreateV2Args = {
  chatId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  order: OrderCreateV2Input;
};


export type MutationOrderEditArgs = {
  orderId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  editedOrderInput: OrderEditInput;
};


export type MutationOrderExportConfigCreateArgs = {
  supplierId: Scalars['ID']['input'];
  orderConfig: OrderExportConfigCreateInput;
};


export type MutationOrderExportConfigDeleteArgs = {
  supplierId: Scalars['ID']['input'];
};


export type MutationOrderExportConfigUpdateArgs = {
  supplierId: Scalars['ID']['input'];
  orderConfig: OrderExportConfigUpdateInput;
};


export type MutationOrderGuideCreatedArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationOrderGuideRequestArgs = {
  orderGuideRequest: OrderGuideRequestInput;
};


export type MutationOrderGuideV2ItemUnitsAddArgs = {
  input: OrderGuideV2ItemUnitsAddInput;
};


export type MutationOrderGuideV2ItemUnitsRemoveArgs = {
  input: OrderGuideV2ItemUnitsRemoveInput;
};


export type MutationPaymentAuthorizeArgs = {
  input: PaymentAuthorizeInput;
};


export type MutationProductBatchCreateArgs = {
  chatId: Scalars['ID']['input'];
  products?: InputMaybe<Array<AdminProductInput>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enableCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProductCreateArgs = {
  chatId: Scalars['ID']['input'];
  product: ProductInput;
};


export type MutationProductDeleteArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductSortArgs = {
  chatId: Scalars['ID']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductUpdateArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};


export type MutationProductUpdateCategoryArgs = {
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
};


export type MutationProductUpdateExternalIdArgs = {
  id: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
  chatId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReferUserArgs = {
  input: ReferUserInput;
};


export type MutationRefreshOrderDeskArgs = {
  supplierId: Scalars['ID']['input'];
  omnichannelOrderId: Scalars['ID']['input'];
};


export type MutationRejectOrderArgs = {
  input: RejectOrderInput;
};


export type MutationRejectOrdersByIdArgs = {
  input: RejectOrdersByIdInput;
};


export type MutationRemoveBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRemoveCcEmailFromChatsArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type MutationRemoveEmailFromBuyerReportScheduleArgs = {
  emailToRemove: Scalars['AWSEmail']['input'];
  scheduleId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveEntitiesFromGroupArgs = {
  input: RemoveEntitiesFromGroupInput;
};


export type MutationRemoveInvoiceArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRemoveInvoiceAttachmentArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRemoveLabelFromChatsArgs = {
  label: Scalars['String']['input'];
  chatIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveOrderDeskEmailArgs = {
  input: RemoveOrderDeskEmail;
};


export type MutationRemovePaymentAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveProductsFromOrderGuidesArgs = {
  input: RemoveProductsFromOrderGuidesInput;
};


export type MutationRemoveSupplierBuyerMovArgs = {
  input: Array<RemoveSupplierBuyerMovInput>;
};


export type MutationRemoveUserFromChatsArgs = {
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveUsersFromGroupArgs = {
  input?: InputMaybe<RemoveUsersFromGroupInput>;
};


export type MutationRequestToJoinBuyerArgs = {
  buyerId: Scalars['String']['input'];
};


export type MutationSelectProductForOrderGuideArgs = {
  input: SelectProductForOrderGuideInput;
};


export type MutationSelectProductsForOrderGuideArgs = {
  input: SelectProductsForOrderGuideInput;
};


export type MutationSendInviteTransmissionArgs = {
  input: SendInviteTransmissionRequest;
};


export type MutationSendSyntheticSmsMessageArgs = {
  input: SendSyntheticSmsMessageInput;
};


export type MutationSendSyntheticWhatsAppMessageArgs = {
  input: SendSyntheticWhatsAppMessageInput;
};


export type MutationSetOrderAsTestArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationShortenUrlArgs = {
  longUrl: Scalars['String']['input'];
};


export type MutationSubmitBuyerStockCountArgs = {
  input: SubmitBuyerStockCountInput;
};


export type MutationSubmitCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CartSubmissionOptions;
};


export type MutationSubmitOrderDeliveryCheckArgs = {
  input: SubmitOrderDeliveryCheckInput;
};


export type MutationSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<SubmitOrderedProductDeliveryCheckInput>;
};


export type MutationSubmitStockCountSessionArgs = {
  input: SubmitStockCountSessionInput;
};


export type MutationSupplierAddRequestArgs = {
  supplierAddRequest: SupplierAddRequestInput;
};


export type MutationSupplierCreateArgs = {
  supplier: SupplierCreateInput;
};


export type MutationSupplierGetInTouchRequestArgs = {
  input: SupplierGetInTouchRequestInput;
};


export type MutationSupplierInviteUserArgs = {
  invitee: ChatInviteRecipient;
  chat: ChatInviteInput;
};


export type MutationSupplierInviteUsersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
  chat: ChatInviteInput;
};


export type MutationSupplierRemoveUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSupplierUpdateArgs = {
  supplier: SupplierUpdateInput;
};


export type MutationSupplierUserCreateArgs = {
  input: SupplierUserCreateInput;
};


export type MutationSupplierUserRemoveArgs = {
  input: SupplierUserRemoveInput;
};


export type MutationTriggerProductMatchingArgs = {
  input: TriggerProductMatchingInput;
};


export type MutationUnassignUserFromOrderToReviewArgs = {
  input: UnassignUserFromOrderToReviewInput;
};


export type MutationUndoMultiLocationOrderGuideTransactionArgs = {
  input: UndoMultiLocationOrderGuideTransactionInput;
};


export type MutationUpdateBuyerInventoryProductArgs = {
  input: UpdateBuyerInventoryProductInput;
};


export type MutationUpdateBuyerStockInventoryProductArgs = {
  input: UpdateBuyerStockInventoryProductInput;
};


export type MutationUpdateCartArgs = {
  chatId: Scalars['ID']['input'];
  lineItems: Array<CartLineItemUpdateInput>;
};


export type MutationUpdateChatEnabledArgs = {
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateChatNotificationPreferencesArgs = {
  input?: InputMaybe<ChatNotificationInput>;
};


export type MutationUpdateInventoryItemArgs = {
  input: UpdateInventoryItemInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoicedProductArgs = {
  input: Array<InputMaybe<InvoicedProductInput>>;
};


export type MutationUpdateNotificationUserIdArgs = {
  oldUserId: Scalars['ID']['input'];
  newUserId: Scalars['ID']['input'];
};


export type MutationUpdatePendingUserArgs = {
  input: UpdatePendingUserInput;
};


export type MutationUpdateProductVariantsInOrderGuideArgs = {
  input: UpdateProductVariantsInOrderGuideInput;
};


export type MutationUpdateRequestToJoinArgs = {
  input: UpdateJoinRequestInput;
};


export type MutationUpdateStorageItemArgs = {
  input: UpdateStorageItemInput;
};


export type MutationUpdateSubCatalogArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSubCatalogChatsArgs = {
  create: Array<SubCatalogChatInput>;
  remove: Array<SubCatalogChatInput>;
};


export type MutationUpdateSupplierAccessPackageArgs = {
  suppliers: Array<SupplierUpdateAccessPackageInput>;
};


export type MutationUpdateSupplierBuyerMovArgs = {
  input: Array<UpdateSupplierBuyerMovInput>;
};


export type MutationUpdateSupplierDeliverySettingArgs = {
  input: SupplierDeliverySettingInput;
};


export type MutationUpdateSupplierProductArgs = {
  id: Scalars['ID']['input'];
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};


export type MutationUpdateSupplierProductV2Args = {
  product: UpdateSupplierProductV2Input;
};


export type MutationUpdateSupplierUserChatsArgs = {
  input: SupplierUserUpdateChatsInput;
};


export type MutationUpdateSupplierUserRolesArgs = {
  input?: InputMaybe<UpdateSupplierUserRolesInput>;
};


export type MutationUploadSubCatalogProductsArgs = {
  subCatalogId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
};


export type MutationUploadSubCatalogProductsV2Args = {
  subCatalogId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
};


export type MutationUpsertStockCountSessionItemsArgs = {
  input: UpsertStockCountSessionItemsInput;
};


export type MutationUserAddRoleArgs = {
  userId: Scalars['String']['input'];
  role: Role;
};


export type MutationUserConfirmArgs = {
  phone: Scalars['String']['input'];
  newUserPool: Scalars['Boolean']['input'];
};


export type MutationUserCreateArgs = {
  user: UserCreateInput;
};


export type MutationUserLeadCreateArgs = {
  userLead: UserLeadInput;
};


export type MutationUserRemoveRoleArgs = {
  userId: Scalars['String']['input'];
  role: Role;
};


export type MutationUserRequestToDeleteArgs = {
  input: UserRequestToDeleteInput;
};


export type MutationUserUpdateArgs = {
  user: UserUpdateInput;
};


export type MutationVendorItemUnitUpdateArgs = {
  input: VendorItemUnitUpdateInput;
};

export type AcceptOrderInput = {
  orderId: Scalars['ID']['input'];
  deliveryDate: Scalars['AWSTimestamp']['input'];
  products?: InputMaybe<Array<OrderedProductInput>>;
  acceptedProducts?: InputMaybe<Array<AcceptedProductInput>>;
  supplierId: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  acceptedPONumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductInput = {
  productId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type AcceptedProductInput = {
  id: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  parsedProductId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type AcceptOrderResponse = Order | OrderAlreadyAccepted | OrderCreatedError | AuthorizationFailure | InputValidationFailure;

export type OrderAlreadyAccepted = {
  __typename?: 'OrderAlreadyAccepted';
  message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  acceptedBy?: Maybe<User>;
};

export type OrderCreatedError = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderCreatedError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UnavailableProductType = {
  __typename?: 'UnavailableProductType';
  id?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Scalars['String']['output']>;
};

export type ActivateSuppliersPaymentAccountInput = {
  supplierId: Scalars['String']['input'];
  paymentAccountId: Scalars['String']['input'];
};

export type ActivateSuppliersPaymentAccountResponse = SuppliersPaymentAccount | AuthorizationFailure | InputValidationFailure | PaymentAccountNotFound | ExternalAccountDetailsMissed | ExternalAccountNotFound | SupplierHasActivePaymentAccountAlready;

export type SuppliersPaymentAccount = Node & {
  __typename?: 'SuppliersPaymentAccount';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type ExternalAccountDetailsMissed = AppsyncResponse & AppsyncError & {
  __typename?: 'ExternalAccountDetailsMissed';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ExternalAccountNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'ExternalAccountNotFound';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierHasActivePaymentAccountAlready = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierHasActivePaymentAccountAlready';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type AddBuyerStockInventoryProductInput = {
  buyerId: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
};

/** Amount should be passed with the lowest denominations/cents */
export type MoneyInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type AddBuyerStockInventoryProductResponse = AddBuyerStockInventoryProductFailure | AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound;

export type AddBuyerStockInventoryProductFailure = {
  __typename?: 'AddBuyerStockInventoryProductFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProductNotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'ProductNotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProductsCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type AddEntitiesToGroupInput = {
  groupId: Scalars['ID']['input'];
  entities?: InputMaybe<Array<GroupEntityInput>>;
};

export type GroupEntityInput = {
  entityId: Scalars['ID']['input'];
  entityType: GroupEntityType;
};

export type AddEntitiesToGroupResponse = AddEntitiesToGroupResponseSuccess | AddEntitiesToGroupResponseError | AuthorizationFailure;

export type AddEntitiesToGroupResponseSuccess = AppsyncResponse & {
  __typename?: 'AddEntitiesToGroupResponseSuccess';
  responseType: ResponseType;
};

export type AddEntitiesToGroupResponseError = AppsyncError & {
  __typename?: 'AddEntitiesToGroupResponseError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<AddEntitiesToGroupErrorCode>;
};

export enum AddEntitiesToGroupErrorCode {
  Unexpected = 'unexpected'
}

export type AddInvoiceInput = {
  invoiceNumber: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  /** total amount of invoice in cents */
  total: Scalars['Int']['input'];
  issueDate: Scalars['AWSTimestamp']['input'];
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['input'];
  paymentTerms: Scalars['AWSTimestamp']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AddInvoiceResponse = Invoice | InputValidationFailure | AuthorizationFailure | ChatHasNoSupplierEntity | OrderAlreadyHasInvoice;

export type ChatHasNoSupplierEntity = AppsyncResponse & AppsyncError & {
  __typename?: 'ChatHasNoSupplierEntity';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderAlreadyHasInvoice = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderAlreadyHasInvoice';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type AddMarketingProductsToCartInput = {
  /** The id of the product */
  productId: Scalars['ID']['input'];
  /** The amounts of products items to add or remove from the cart */
  amount: Scalars['Float']['input'];
};

export type AddMarketingProductsToCartResponse = AddMarketingProductsToCartSuccess | AuthorizationFailure | InputValidationFailure;

export type AddMarketingProductsToCartSuccess = {
  __typename?: 'AddMarketingProductsToCartSuccess';
  responseType: ResponseType;
  teamCartData: AddMarketingProductsToCartTeamCartData;
};

export type AddMarketingProductsToCartTeamCartData = TeamCartExists | TeamCartNotFound;

export type TeamCartExists = {
  __typename?: 'TeamCartExists';
  /** The current team cart for this chat, including updated item counts */
  cart: Cart;
};

export type TeamCartNotFound = {
  __typename?: 'TeamCartNotFound';
  /** Dummy message to make type nonempty, can be ignored */
  dummyMessage?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountInput = {
  token: Scalars['String']['input'];
  psp?: InputMaybe<Scalars['String']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** 2-digit ISO-3166 country code */
  country: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  expiration?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  method?: InputMaybe<PaymentMethod>;
  ccDetails?: InputMaybe<CreditCardDetailsInput>;
  bankAccountDetails?: InputMaybe<BankAccountDetailsInput>;
};

export type CreditCardDetailsInput = {
  lastDigits: Scalars['String']['input'];
  network: CreditCardNetwork;
  bankName: Scalars['String']['input'];
};

export enum CreditCardNetwork {
  Visa = 'visa',
  Mastercard = 'mastercard'
}

export type BankAccountDetailsInput = {
  bankName: Scalars['String']['input'];
};

export type AddPaymentAccountResponse = PaymentAccount | PaymentMethodNotAvailableForUser | SupplierPaymentAccountAlreadyExists | AuthorizationFailure | InputValidationFailure | PaymentAccountAlreadyExists;

export type PaymentMethodNotAvailableForUser = AppsyncResponse & AppsyncError & {
  __typename?: 'PaymentMethodNotAvailableForUser';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  userType: PaymentAccountOwnerType;
  paymentMethod: PaymentMethod;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export enum PaymentAccountOwnerType {
  Buyer = 'buyer',
  Supplier = 'supplier',
  User = 'user'
}

export type SupplierPaymentAccountAlreadyExists = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierPaymentAccountAlreadyExists';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountAlreadyExists = AppsyncResponse & AppsyncError & {
  __typename?: 'PaymentAccountAlreadyExists';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type AddProductsToOrderGuidesInput = {
  sourceChatId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']>;
  products: Array<AddProductToOrderGuidesInput>;
};

export type AddProductToOrderGuidesInput = {
  productId: Scalars['ID']['input'];
  categoryName?: InputMaybe<Scalars['String']['input']>;
};

export type AddProductsToOrderGuidesResponse = AddProductsToOrderGuidesResult | InputValidationFailure | AuthorizationFailure;

export type AddProductsToOrderGuidesResult = AppsyncResponse & {
  __typename?: 'AddProductsToOrderGuidesResult';
  responseType: ResponseType;
  transactionId: Scalars['String']['output'];
  locations: Array<LocationProductsResult>;
};

export type LocationProductsResult = {
  __typename?: 'LocationProductsResult';
  locationId: Scalars['String']['output'];
  products: Array<LocationProductResult>;
};

export type LocationProductResult = {
  __typename?: 'LocationProductResult';
  productId: Scalars['String']['output'];
  successfulOperation: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
};

export type AddSalesRepRequestToJoinInput = {
  chatId: Scalars['String']['input'];
  salesRepDetails: AddSalesRepDetailsInput;
};

export type AddSalesRepDetailsInput = {
  phoneNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderPreference: Array<AddSalesRepOrderPref>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type AddSalesRepRequestToJoinResponse = AddSalesRepSuccess | AddSalesRepError | InputValidationFailure | AuthorizationFailure;

export type AddSalesRepSuccess = {
  __typename?: 'AddSalesRepSuccess';
  addSalesRepRequestId: Scalars['String']['output'];
  salesRepUserId: Scalars['String']['output'];
};

export type AddSalesRepError = AppsyncResponse & AppsyncError & {
  __typename?: 'AddSalesRepError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  errorCode?: Maybe<AddSalesRepErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AddSalesRepErrorCode {
  GenericError = 'genericError',
  PhoneIsLandlineError = 'phoneIsLandlineError',
  UserExistsAndBelongsToBuyerError = 'userExistsAndBelongsToBuyerError',
  UserExistsAndHasNoOrderPreferenceError = 'userExistsAndHasNoOrderPreferenceError',
  UserExistsAndBelongsToDifferentSupplierError = 'userExistsAndBelongsToDifferentSupplierError'
}

export type BuyerAddSupplierInput = {
  buyerId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  requestType: BuyerAddSupplierRequestType;
};

export enum BuyerAddSupplierRequestType {
  NewCustomer = 'newCustomer',
  ExistingCustomer = 'existingCustomer'
}

export type BuyerAddSupplierResponse = BuyerAddSupplier | BuyerAddSupplierError | InputValidationFailure | AuthorizationFailure;

export type BuyerAddSupplier = {
  __typename?: 'BuyerAddSupplier';
  buyerId: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type BuyerAddSupplierError = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerAddSupplierError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  errorCode?: Maybe<BuyerAddSupplierErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum BuyerAddSupplierErrorCode {
  SupplierNotAcceptingNewCustomers = 'supplierNotAcceptingNewCustomers',
  UserNotMemberOfBuyer = 'userNotMemberOfBuyer',
  DuplicateBuyerAddSupplierRequest = 'duplicateBuyerAddSupplierRequest',
  SupplierAlreadyConnected = 'supplierAlreadyConnected'
}

export type AddSuppliersPaymentAccountInput = {
  /** values: modernTreasury */
  psp: Scalars['String']['input'];
  /** 2-digit ISO-3166 country code */
  country: Scalars['String']['input'];
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['input'];
  /** values: ach, check */
  paymentType: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};

export type AddSuppliersPaymentAccountResponse = SuppliersPaymentAccount | AuthorizationFailure | InputValidationFailure | SupplierNotFound | SupplierPaymentsDisabled | SupplierHasActivePaymentAccountAlready;

export type SupplierPaymentsDisabled = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierPaymentsDisabled';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type AddUsersToGroupInput = {
  groupId: Scalars['ID']['input'];
  users?: InputMaybe<Array<GroupUserInput>>;
};

export type GroupUserInput = {
  userId: Scalars['String']['input'];
  role: GroupUserRole;
};

export type AddUsersToGroupResponse = AddUsersToGroupResponseSuccess | AddUsersToGroupResponseError | AuthorizationFailure;

export type AddUsersToGroupResponseSuccess = AppsyncResponse & {
  __typename?: 'AddUsersToGroupResponseSuccess';
  responseType: ResponseType;
};

export type AddUsersToGroupResponseError = AppsyncError & {
  __typename?: 'AddUsersToGroupResponseError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type AssignOrderToUserForReviewInput = {
  omnichannelOrderId: Scalars['ID']['input'];
};

export type AssignOrderToUserForReviewResponse = AssignOrderToUserForReviewResponseSuccess | AssignOrderToUserForReviewResponseError;

export type AssignOrderToUserForReviewResponseSuccess = {
  __typename?: 'AssignOrderToUserForReviewResponseSuccess';
  omnichannelOrderId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type AssignOrderToUserForReviewResponseError = AppsyncResponse & AppsyncError & {
  __typename?: 'AssignOrderToUserForReviewResponseError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type BatchOrderConfirmResponse = BatchOrderConfirmSuccess | BatchOrderConfirmError;

export type BatchOrderConfirmSuccess = AppsyncResponse & {
  __typename?: 'BatchOrderConfirmSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BatchOrderConfirmError = AppsyncResponse & AppsyncError & {
  __typename?: 'BatchOrderConfirmError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type BatchUpdateOrderSupplierInput = {
  chatId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  supplierRefId: Scalars['String']['input'];
  supplierPhone: Scalars['String']['input'];
};

export type BatchUpdateOrderSupplier = {
  __typename?: 'BatchUpdateOrderSupplier';
  chatId?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  /** Number of orders updated with new supplier */
  orderCount?: Maybe<Scalars['Int']['output']>;
};

export type BroadcastInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endsAt?: InputMaybe<Scalars['AWSDate']['input']>;
  sendToAll?: InputMaybe<Scalars['Boolean']['input']>;
  status: BroadcastStatus;
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  /** name of PDF to be uploaded */
  pdfName?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<OneTimeBroadcastScheduleInput>;
  purpose?: InputMaybe<BroadcastPurposeInput>;
};

export type OneTimeBroadcastScheduleInput = {
  nextScheduledTimestamp: Scalars['AWSTimestamp']['input'];
};

export type BroadcastPurposeInput = {
  predefinedValue: PredefinedBroadcastPurpose;
  customValue?: InputMaybe<Scalars['String']['input']>;
};

export enum PredefinedBroadcastPurpose {
  PromoteProducts = 'promoteProducts',
  OfferDiscounts = 'offerDiscounts',
  ExpiringProducts = 'expiringProducts',
  StockClearance = 'stockClearance',
  Custom = 'custom'
}

export type BroadcastUpdatePurposeResult = {
  __typename?: 'BroadcastUpdatePurposeResult';
  predefinedValue: PredefinedBroadcastPurpose;
  customValue?: Maybe<Scalars['String']['output']>;
};

export type BulkSendInviteTransmissionInput = {
  locale: Scalars['String']['input'];
  channel: InviteChannel;
  message?: InputMaybe<Scalars['String']['input']>;
  invitees: Array<BulkSendInviteInvitee>;
};

export type BulkSendInviteInvitee = {
  invitedToEntityId: Scalars['String']['input'];
  inviteeId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type BulkSendInviteTransmissionResponse = BulkInviteTransmissionSuccess | AuthorizationFailure | InputValidationFailure;

export type BulkInviteTransmissionSuccess = {
  __typename?: 'BulkInviteTransmissionSuccess';
  id: Scalars['ID']['output'];
  failures: Array<BulkInviteTransmissionFailure>;
};

export type BulkInviteTransmissionFailure = {
  __typename?: 'BulkInviteTransmissionFailure';
  inviteeId: Scalars['String']['output'];
};

export type BulkSubmitOrderedProductDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
  deliveryCheckProducts?: InputMaybe<Array<InputMaybe<DeliveryCheckProductInput>>>;
};

export type DeliveryCheckProductInput = {
  productId: Scalars['ID']['input'];
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
};

export type DeliveryCheckProblemInput = {
  problemType?: InputMaybe<OrderedProductDeliveryCheckProblemType>;
  image?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderedProductMetadataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkOrderedProductDeliveryCheckSubmissionResponse = BulkOrderedProductDeliveryCheckSubmissionResult | InputValidationFailure | OrderNotFound | OrderDeliveryItemsMismatched | OrderDeliveryCheckAlreadyCompleted | AuthorizationFailure;

export type BulkOrderedProductDeliveryCheckSubmissionResult = {
  __typename?: 'BulkOrderedProductDeliveryCheckSubmissionResult';
  result: Array<Maybe<OrderedProductDeliveryCheck>>;
};

export type OrderDeliveryItemsMismatched = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryItemsMismatched';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryCheckAlreadyCompleted = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryCheckAlreadyCompleted';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerUserInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type BuyerUserRoleInput = {
  userId: Scalars['ID']['input'];
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type BuyerCreateInput = {
  name: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource: AddressSource;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** set this flag to enroll this buyer as a test buyer on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  createdContext?: InputMaybe<BuyerCreatedContext>;
  status?: InputMaybe<BuyerStatus>;
};

export type BuyerDisableRolesResponse = Buyer | NotFoundError;

export type BuyerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource?: InputMaybe<AddressSource>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  status?: InputMaybe<BuyerStatus>;
};

export type CancelCartOptionsInput = {
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
};

export type CancelCartResponse = CancelCartResult | CartVersionConstraintError | CartNotFoundError | InputValidationFailure | AuthorizationFailure;

export type CancelCartResult = {
  __typename?: 'CancelCartResult';
  /** the cart ID */
  id: Scalars['ID']['output'];
};

export type CartVersionConstraintError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartVersionConstraintError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  latestCartOperation?: Maybe<UserCartItemOperation>;
};

export type UserCartItemOperation = {
  __typename?: 'UserCartItemOperation';
  action: UserCartAction;
  orderId?: Maybe<Scalars['String']['output']>;
};

export enum UserCartAction {
  Add = 'add',
  Remove = 'remove',
  Create = 'create',
  Submit = 'submit',
  Cancel = 'cancel'
}

export type CartNotFoundError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartNotFoundError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

/** Input for the `catalogImportStart` mutation. */
export type CatalogImportStartInput = {
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
  /** The mode of the import, controlling the behavior of the import process. */
  mode: CatalogImportMode;
  /** Indicates whether the import should be a dry run. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job used in dry run mode to upload the input file for the actual import. */
  inputFromJobId?: InputMaybe<Scalars['ID']['input']>;
};

/** The catalog import modes supported. */
export enum CatalogImportMode {
  /** Imports the catalog by marking old items as out of stock and creating new items. */
  Replace = 'Replace',
  /** Imports the catalog by updating existing items and creating new items. */
  Update = 'Update'
}

export type CatalogImportStartResponse = CatalogImportStartResult | InputValidationFailure | AuthorizationFailure;

/** The result of starting a catalog import job. */
export type CatalogImportStartResult = AppsyncResponse & {
  __typename?: 'CatalogImportStartResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The catalog import job created as a result of the mutation. */
  job: CatalogImportJob;
};

export type CategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatCreateInput = {
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ChatStatus>;
  type?: InputMaybe<ChatType>;
  products?: InputMaybe<Array<AdminProductInput>>;
  supplierCustomerName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  createdContext?: InputMaybe<CreatedContext>;
  /** set this flag to enroll this chat as a test chat on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
  addBuyerTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = '135'
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = '135'
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = '1300'
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = '135'
   *    currency = 'GNF'
   *
   * Products with the cost:'135.45' will be considered invalid
   */
  cost?: InputMaybe<Scalars['String']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  variantTypes?: InputMaybe<Scalars['String']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  buyerPrice?: InputMaybe<MoneyInput>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
};

export type ChatUpdateInput = {
  chatName?: InputMaybe<Scalars['String']['input']>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ChatStatus>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<ChatUpdateCreatedByInput>;
  sendBuyerOrderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatUpdateCreatedByInput = {
  createdContext?: InputMaybe<CreatedContext>;
};

export type ClaimOnboardingChecklistRewardResponse = ClaimOnboardingChecklistRewardSuccess | ClaimOnboardingChecklistRewardError | AuthorizationFailure;

export type ClaimOnboardingChecklistRewardSuccess = {
  __typename?: 'ClaimOnboardingChecklistRewardSuccess';
  id: Scalars['ID']['output'];
  isRewardClaimed: Scalars['Boolean']['output'];
};

export type ClaimOnboardingChecklistRewardError = AppsyncResponse & AppsyncError & {
  __typename?: 'ClaimOnboardingChecklistRewardError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  errorCode?: Maybe<ClaimOnboardingChecklistRewardErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ClaimOnboardingChecklistRewardErrorCode {
  GenericError = 'genericError',
  NotFoundChecklist = 'notFoundChecklist',
  NotCompletedChecklist = 'notCompletedChecklist',
  NoMonetizedChatPresent = 'noMonetizedChatPresent',
  RewardAlreadyClaimed = 'rewardAlreadyClaimed'
}

export type ConfirmDeliveryCheckReconciliationResponse = DeliveryCheckReconciliationRequest | InputValidationFailure | DeliveryCheckReconciliationRequestNotFound | DeliveryCheckReconciliationRequestAlreadyConfirmed | OrderDeliveryCheckReconciliationRequestIdNotMatched | AuthorizationFailure;

export type DeliveryCheckReconciliationRequestNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'DeliveryCheckReconciliationRequestNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeliveryCheckReconciliationRequestAlreadyConfirmed = AppsyncResponse & AppsyncError & {
  __typename?: 'DeliveryCheckReconciliationRequestAlreadyConfirmed';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryCheckReconciliationRequestIdNotMatched = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryCheckReconciliationRequestIdNotMatched';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectAccountResponse = ConnectAccountUrl | ConnectAccountError;

export type ConnectAccountUrl = {
  __typename?: 'ConnectAccountUrl';
  url?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type ConnectAccountError = AppsyncResponse & AppsyncError & {
  __typename?: 'ConnectAccountError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ConnectIntegrationAdapterInput = {
  adapterId: Scalars['ID']['input'];
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectIntegrationAdapterResponse = IntegrationAdapterConnectionBaseResult | IntegrationAdapterConnectionAdminResult | ChocoEntityNotFound | UnsupportedIntegrationAdapterType | IntegrationAdapterNotFound | InputValidationFailure | AuthorizationFailure;

export type ChocoEntityNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'ChocoEntityNotFound';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type UnsupportedIntegrationAdapterType = AppsyncResponse & AppsyncError & {
  __typename?: 'UnsupportedIntegrationAdapterType';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type IntegrationAdapterNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'IntegrationAdapterNotFound';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type CreateBuyerReportScheduleInput = {
  supplierIds: Array<Scalars['String']['input']>;
  buyerIds: Array<Scalars['String']['input']>;
  type: BuyerReportType;
  startAt: Scalars['AWSTimestamp']['input'];
  frequency: ScheduledBuyerReportFrequency;
  timeframe: ScheduledBuyerReportFrequency;
  timeframeType: ScheduledBuyerReportTimeframeType;
  emailRecipients: Array<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBuyerReportScheduleResponse = BuyerReportSchedule | InputValidationFailure | AuthorizationFailure;

export type CreateGroupInput = {
  name: Scalars['String']['input'];
};

export type CreateOrderDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
};

export type OrderDeliveryCheckCreationResponse = OrderDeliveryCheckDetails | InputValidationFailure | OrderDeliveryCheckExists | OrderDeliveryCheckAlreadyCompleted | OrderNotFound | AuthorizationFailure;

export type OrderDeliveryCheckExists = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryCheckExists';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryCheckImageUploadUrlResponse = OrderDeliveryCheckImageUploadUrlResult | InputValidationFailure | OrderNotFound | OrderDeliveryCheckImageNotFound | OrderDeliveryCheckAlreadyCompleted | AuthorizationFailure;

export type OrderDeliveryCheckImageUploadUrlResult = {
  __typename?: 'OrderDeliveryCheckImageUploadUrlResult';
  imageId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type OrderDeliveryCheckImageNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryCheckImageNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateOrderDeskEmailList = {
  supplierId: Scalars['ID']['input'];
  emailList: Array<OrderDeskEmail>;
  type: OrderDestEmailListType;
};

export type OrderDeskEmail = {
  email: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailListResponse = EmailListCreated | AuthorizationFailure | InputValidationFailure;

export type EmailListCreated = {
  __typename?: 'EmailListCreated';
  supplierId: Scalars['ID']['output'];
  type: OrderDestEmailListType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateProfileInput = {
  id: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProfileResponse = User | BuyerExists | CreateProfileError;

export type BuyerExists = {
  __typename?: 'BuyerExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateProfileError = AppsyncResponse & AppsyncError & {
  __typename?: 'CreateProfileError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreatePushEndpointInput = {
  type: PushNotificationPlatform;
  /** unique identifier created by the notification service for an app on a device */
  token: Scalars['String']['input'];
  /** indicates whether a user would like to recieve message notifications */
  message: Scalars['Boolean']['input'];
  /** indicates whether a user would like to recieve order notifications */
  order: Scalars['Boolean']['input'];
};

export enum PushNotificationPlatform {
  Android = 'android',
  Ios = 'ios'
}

export type PushEndpointResponse = NotificationPreferences;

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  message?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateReferralInput = {
  referrerUserId: Scalars['ID']['input'];
};

export type CreateReferralResponse = Referral | UserHasReferralCode | ReferralCodeGenerationError | InputValidationFailure | AuthorizationFailure;

export type UserHasReferralCode = AppsyncResponse & AppsyncError & {
  __typename?: 'UserHasReferralCode';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReferralCodeGenerationError = AppsyncResponse & AppsyncError & {
  __typename?: 'ReferralCodeGenerationError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateStorageItemInput = {
  buyerId: Scalars['ID']['input'];
  inventoryItemName: Scalars['String']['input'];
  inventoryItemExternalId?: InputMaybe<Scalars['String']['input']>;
  storageAreaId?: InputMaybe<Scalars['ID']['input']>;
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['String']['input'];
};

export type CreateStorageItemResponse = CreateStorageItemSuccess | CreateStorageItemFailure | InputValidationFailure | AuthorizationFailure;

export type CreateStorageItemSuccess = {
  __typename?: 'CreateStorageItemSuccess';
  responseType?: Maybe<ResponseType>;
  storageItem: StorageItem;
};

export type CreateStorageItemFailure = {
  __typename?: 'CreateStorageItemFailure';
  responseType?: Maybe<ResponseType>;
  message: Scalars['String']['output'];
};

export type CreateSubCatalogResponse = SubCatalog | CreateSubCatalogError;

export type CreateSubCatalogError = AppsyncResponse & AppsyncError & {
  __typename?: 'CreateSubCatalogError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateSupplierContactInput = {
  phoneNumber: Scalars['String']['input'];
  supplierEntityId: Scalars['ID']['input'];
  requireOrderReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateSupplierContactResponse = SupplierContact | AuthorizationFailure | InputValidationFailure;

export type SupplierContact = {
  __typename?: 'SupplierContact';
  supplierEntityId: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  requireOrderReview?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** url to download product image */
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  /** Product variants provided like variant1;variant2;variant3 */
  variantTypes?: InputMaybe<Scalars['String']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUpdateSupplierProductResponse = Product | InputValidationFailure | ProductNotFoundError | DuplicateProductError;

export type DuplicateProductError = AppsyncResponse & AppsyncError & {
  __typename?: 'DuplicateProductError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierProductInput = {
  name: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateSuppliersPaymentAccountInput = {
  supplierId: Scalars['String']['input'];
  paymentAccountId: Scalars['String']['input'];
};

export type DeactivateSuppliersPaymentAccountResponse = SuppliersPaymentAccount | AuthorizationFailure | InputValidationFailure;

export type DeleteBuyerReportScheduleResponse = DeleteBuyerReportScheduleSuccess | BuyerReportScheduleNotFound | DeleteBuyerReportScheduleError | InputValidationFailure | AuthorizationFailure;

export type DeleteBuyerReportScheduleSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerReportScheduleSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BuyerReportScheduleNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerReportScheduleNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteBuyerReportScheduleError = AppsyncResponse & AppsyncError & {
  __typename?: 'DeleteBuyerReportScheduleError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteBuyerStockInventoryProductsInput = {
  stockInventoryProductIds: Array<Scalars['ID']['input']>;
  buyerId: Scalars['ID']['input'];
};

export type DeleteBuyerStockInventoryProductsResponse = DeleteBuyerStockInventoryProductsSuccess | DeleteBuyerStockInventoryProductsFailure | InputValidationFailure | AuthorizationFailure;

export type DeleteBuyerStockInventoryProductsSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerStockInventoryProductsSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type DeleteBuyerStockInventoryProductsFailure = {
  __typename?: 'DeleteBuyerStockInventoryProductsFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeletedChatSetting = {
  __typename?: 'DeletedChatSetting';
  /** chat ID of the deleted deliverySetting */
  id: Scalars['ID']['output'];
};

export type DeleteProductImageInput = {
  productId: Scalars['ID']['input'];
};

export type DeleteSubCatalogResponse = DeleteSubCatalogSuccess | DeleteSubCatalogError;

export type DeleteSubCatalogSuccess = AppsyncResponse & {
  __typename?: 'DeleteSubCatalogSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeleteSubCatalogError = AppsyncResponse & AppsyncError & {
  __typename?: 'DeleteSubCatalogError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeletedSupplierNegotiatedPriceResponse = DeleteSupplierNegotiatedPriceResult | AuthorizationFailure;

export type DeleteSupplierNegotiatedPriceResult = {
  __typename?: 'DeleteSupplierNegotiatedPriceResult';
  success: Scalars['Boolean']['output'];
};

export type DisconnectAccountResponse = DisconnectAccountStatus | DisconnectAccountError;

export type DisconnectAccountStatus = {
  __typename?: 'DisconnectAccountStatus';
  appName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DisconnectAccountError = AppsyncResponse & AppsyncError & {
  __typename?: 'DisconnectAccountError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type DisconnectIntegrationAdapterInput = {
  id: Scalars['ID']['input'];
};

export type DisconnectIntegrationAdapterResponse = IntegrationAdapterConnectionBaseResult | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionNotFound | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterConnectionNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'IntegrationAdapterConnectionNotFound';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type EditBuyerReportScheduleInput = {
  id: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  buyerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<BuyerReportType>;
  title?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  frequency?: InputMaybe<ScheduledBuyerReportFrequency>;
  timeframe?: InputMaybe<ScheduledBuyerReportFrequency>;
  timeframeType?: InputMaybe<ScheduledBuyerReportTimeframeType>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type EditBuyerReportScheduleResponse = BuyerReportSchedule | BuyerReportScheduleNotFound | InputValidationFailure | AuthorizationFailure;

export type GenerateBuyerReportInput = {
  from: Scalars['AWSTimestamp']['input'];
  to: Scalars['AWSTimestamp']['input'];
  supplierIds: Array<Scalars['String']['input']>;
  type: BuyerReportType;
  buyerIds: Array<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateBuyerReportResponse = BuyerReport | InputValidationFailure | AuthorizationFailure;

export type GetClientDebuggableArtifactUploadUrlInput = {
  userId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type GetClientDebuggableArtifactUploadUrlResponse = GetClientDebuggableArtifactUploadUrl | GetClientDebuggableArtifactUploadUrlError;

export type GetClientDebuggableArtifactUploadUrl = {
  __typename?: 'GetClientDebuggableArtifactUploadUrl';
  id: Scalars['ID']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type GetClientDebuggableArtifactUploadUrlError = AppsyncResponse & AppsyncError & {
  __typename?: 'GetClientDebuggableArtifactUploadUrlError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type GetOrderGuideUploadUrlInput = {
  userId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type GetOrderGuideUploadUrlResponse = GetOrderGuideUploadUrl | GetOrderGuideUploadUrlError;

export type GetOrderGuideUploadUrl = {
  __typename?: 'GetOrderGuideUploadUrl';
  id: Scalars['ID']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  buyerId?: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
};

export type GetOrderGuideUploadUrlError = AppsyncResponse & AppsyncError & {
  __typename?: 'GetOrderGuideUploadUrlError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportSupplierProductsReport = {
  __typename?: 'ImportSupplierProductsReport';
  /** Number of products that will be created */
  new?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be disabled */
  disabled?: Maybe<Scalars['Int']['output']>;
  /** Number of products that have failed validation */
  invalid?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be updated */
  updated?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will not be affected */
  unchanged?: Maybe<Scalars['Int']['output']>;
};

export type InitInventoryDownloadInput = {
  buyerId: Scalars['String']['input'];
};

export type InitInventoryDownloadResponse = InitInventoryDownloadSuccess | InitInventoryDownloadFailure | AuthorizationFailure;

export type InitInventoryDownloadSuccess = {
  __typename?: 'InitInventoryDownloadSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  jobId: Scalars['ID']['output'];
};

export type InitInventoryDownloadFailure = {
  __typename?: 'InitInventoryDownloadFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type InitInventoryUploadInput = {
  buyerId: Scalars['ID']['input'];
};

export type InitInventoryUploadResponse = InitInventoryUploadSuccess | InitInventoryUploadFailure | AuthorizationFailure | InputValidationFailure;

export type InitInventoryUploadSuccess = {
  __typename?: 'InitInventoryUploadSuccess';
  responseType?: Maybe<ResponseType>;
  jobId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type InitInventoryUploadFailure = {
  __typename?: 'InitInventoryUploadFailure';
  responseType?: Maybe<ResponseType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type InitiateCheckoutResponse = BalanceCheckoutToken | SupplierPaymentAccountMissing | InvoiceAlreadyPaid | AuthorizationFailure | InputValidationFailure | InvoicePaymentInProgress | InvoiceTotalTooLow;

export type BalanceCheckoutToken = AppsyncResponse & {
  __typename?: 'BalanceCheckoutToken';
  /** Always ResponseType.success */
  responseType: ResponseType;
  /** Token used to open Balance webview */
  token: Scalars['String']['output'];
  /** Whether this is the first time a user has used the balance checkout flow */
  firstTimeCheckout: Scalars['Boolean']['output'];
};

export type SupplierPaymentAccountMissing = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierPaymentAccountMissing';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAlreadyPaid = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoiceAlreadyPaid';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvoicePaymentInProgress = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoicePaymentInProgress';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InvoiceTotalTooLow = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoiceTotalTooLow';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type IntegrationAdapterConnectionAuthInput = {
  loginChallenge: Scalars['String']['input'];
};

export type IntegrationAdapterConnectionAuthResponse = IntegrationAdapterConnectionAuthRedirect | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterConnectionAuthRedirect = {
  __typename?: 'IntegrationAdapterConnectionAuthRedirect';
  redirectUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionConsentInput = {
  consentChallenge: Scalars['String']['input'];
  grantedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationAdapterConnectionConsentResponse = IntegrationAdapterConnectionConsentChallenge | IntegrationAdapterConnectionConsentRedirect | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterConnectionConsentChallenge = {
  __typename?: 'IntegrationAdapterConnectionConsentChallenge';
  consentChallenge: Scalars['String']['output'];
  requestedScopes: Array<Scalars['String']['output']>;
  adapterId: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionConsentRedirect = {
  __typename?: 'IntegrationAdapterConnectionConsentRedirect';
  redirectUrl: Scalars['String']['output'];
  connectionId: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionCreateInput = {
  adapterId: Scalars['ID']['input'];
  chocoEntityId: Scalars['ID']['input'];
  scope: Array<Scalars['String']['input']>;
  chocoEntityType: ChocoEntityType;
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterConnectionCreateResponse = IntegrationAdapterConnectionAdminResult | UnsupportedIntegrationAdapterType | ChocoEntityNotFound | IntegrationAdapterNotFound | IntegrationAdapterScopeInsufficient | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterScopeInsufficient = AppsyncResponse & AppsyncError & {
  __typename?: 'IntegrationAdapterScopeInsufficient';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionUpdateInput = {
  id: Scalars['ID']['input'];
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
};

export type IntegrationAdapterConnectionUpdateResponse = IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionNotFound | IntegrationAdapterScopeInsufficient | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterCreateInput = {
  name: Scalars['String']['input'];
  type: IntegrationAdapterType;
  auth: IntegrationAdapterAuthInput;
  scope: Array<Scalars['String']['input']>;
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  developerName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<IntegrationAdapterCreateWebhookInput>;
};

export type IntegrationAdapterAuthInput = {
  type: IntegrationAdapterAuthenticationType;
  connectUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signoutUrl?: InputMaybe<Scalars['String']['input']>;
  /**  TODO: remove apiKey after MVP  */
  apiKey?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterCreateWebhookInput = {
  deliveryUrl: Scalars['String']['input'];
  auth: WebhookAuthenticationInput;
};

export type WebhookAuthenticationInput = {
  type: WebhookAuthenticationType;
};

export type IntegrationAdapterCreateResponse = IntegrationAdapterAdminResult | IntegrationAdapterExists | InputValidationFailure | AuthorizationFailure;

export type IntegrationAdapterExists = AppsyncResponse & AppsyncError & {
  __typename?: 'IntegrationAdapterExists';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type IntegrationAdapterUpdateInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  auth?: InputMaybe<IntegrationAdapterAuthInput>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  developerName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<IntegrationAdapterUpdateWebhookInput>;
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
};

export type IntegrationAdapterUpdateWebhookInput = {
  deliveryUrl?: InputMaybe<Scalars['String']['input']>;
  auth?: InputMaybe<WebhookAuthenticationInput>;
};

export type IntegrationAdapterUpdateResponse = IntegrationAdapterAdminResult | IntegrationAdapterNotFound | AttemptToChangeAdapterAuthType | AttemptToReduceIntegrationAdapterScope | InputValidationFailure | AuthorizationFailure;

export type AttemptToChangeAdapterAuthType = AppsyncResponse & AppsyncError & {
  __typename?: 'AttemptToChangeAdapterAuthType';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type AttemptToReduceIntegrationAdapterScope = AppsyncResponse & AppsyncError & {
  __typename?: 'AttemptToReduceIntegrationAdapterScope';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type IntegrationWebhookRetryInput = {
  entitySyncActionIds: Array<Scalars['ID']['input']>;
};

export type IntegrationWebhookRetryResponse = IntegrationWebhookRetryResults | InputValidationFailure | AuthorizationFailure;

export type IntegrationWebhookRetryResults = {
  __typename?: 'IntegrationWebhookRetryResults';
  results: Array<IntegrationWebhookRetryResult>;
};

export type IntegrationWebhookRetryResult = IntegrationWebhookRetrySuccess | IntegrationWebhookRetryFailure;

export type IntegrationWebhookRetrySuccess = {
  __typename?: 'IntegrationWebhookRetrySuccess';
  entitySyncActionId: Scalars['ID']['output'];
};

export type IntegrationWebhookRetryFailure = {
  __typename?: 'IntegrationWebhookRetryFailure';
  entitySyncActionId: Scalars['ID']['output'];
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

export type InternalInviteUsersResponse = UsersList | AuthorizationFailure | ValidationError;

export type UsersList = {
  __typename?: 'UsersList';
  userIds: Array<Scalars['String']['output']>;
};

export type InviteUserToBuyerInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type InviteNonChocoUserToBuyerResponse = BuyerUser | BuyerNotFound | InvitorNotFound | ExistingInvitedUser | PuppyValidationFailure;

export type BuyerNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerNotFound';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InvitorNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'InvitorNotFound';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ExistingInvitedUser = AppsyncResponse & AppsyncError & {
  __typename?: 'ExistingInvitedUser';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type PuppyValidationFailure = AppsyncResponse & AppsyncError & {
  __typename?: 'PuppyValidationFailure';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type InviteUserToBuyerInputV2 = {
  phone: Scalars['String']['input'];
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** List of buyer chats to add the user to */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InviteUserToBuyerResponse = BuyerUser | InviteUserToBuyerError | AuthorizationFailure | InputValidationFailure;

export type InviteUserToBuyerError = AppsyncResponse & AppsyncError & {
  __typename?: 'InviteUserToBuyerError';
  responseType: ResponseType;
  errorCode?: Maybe<InviteUserToBuyerErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum InviteUserToBuyerErrorCode {
  GenericError = 'genericError',
  UserIsASupplierError = 'userIsASupplierError',
  UserIsAlreadyConnectedToBuyerError = 'userIsAlreadyConnectedToBuyerError'
}

export type KycCreateInput = {
  buyerId: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  tin: Scalars['String']['input'];
  city: Scalars['String']['input'];
  /** Alpha-2 ISO 3166‑1 */
  country: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  administrativeAreaLevelOne: Scalars['String']['input'];
};

export type KycCreateResponse = KycResponse | KycBuyerNotFound | KycEntryAlreadyExists | InputValidationFailure | AuthorizationFailure;

export type KycResponse = AppsyncResponse & {
  __typename?: 'KycResponse';
  /** Always ResponseType.success */
  responseType: ResponseType;
  id: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  /** pending (open, pending, inReview, inAudit), rejected (rejected), approved (accepted) */
  status: Scalars['String']['output'];
  tin: Scalars['String']['output'];
  city: Scalars['String']['output'];
  /** Alpha-2 ISO 3166‑1 */
  country: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  administrativeAreaLevelOne: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type KycBuyerNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'KycBuyerNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type KycEntryAlreadyExists = AppsyncResponse & AppsyncError & {
  __typename?: 'KycEntryAlreadyExists';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
};

export type MessageInput = {
  id: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  /** Flag to prevent message from sending to chat supplier */
  supplierOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  /** Only infra request can set the value, otherwise it should be undefined */
  type?: InputMaybe<Scalars['String']['input']>;
  broadcastId?: InputMaybe<Scalars['String']['input']>;
  /** Used to group messages, e.g email replies to delivery check reconciliation requests */
  groupIds?: InputMaybe<GroupIdsInput>;
};

export type GroupIdsInput = {
  /** Id representing a delivery check reconciliation request */
  reconciliationRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderProductInput = {
  product: ProductInput;
  amount: Scalars['Int']['input'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  message: Message;
};

export type NotificationPreferencesInput = {
  type: Scalars['String']['input'];
  token: Scalars['String']['input'];
  message: Scalars['Boolean']['input'];
  order: Scalars['Boolean']['input'];
};

export type OrderCreateV2Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  orderedProducts?: InputMaybe<Array<InputMaybe<OrderedProductInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierRefId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
};

export type OrderCreatedResponse = Order | OrderCreatedError | AuthorizationFailure;

export type OrderEditInput = {
  productsList?: InputMaybe<Array<EditedOrderProductsInput>>;
};

/** order editing Input */
export type EditedOrderProductsInput = {
  productId: Scalars['String']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type OrderEditedResponse = Order | OrderEditedError | AuthorizationFailure;

export type OrderEditedError = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderEditedError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderExportConfigCreateInput = {
  orderExportFormat: OrderExportFormatInput;
  orderExportUpload?: InputMaybe<OrderExportUploadInput>;
};

export type OrderExportFormatInput = {
  edi?: InputMaybe<OrderExportEdiFormatInput>;
  csv?: InputMaybe<OrderExportCsvFormatInput>;
  lobster?: InputMaybe<OrderExportLobsterFormatInput>;
};

export type OrderExportEdiFormatInput = {
  template: OrderExportEdiTemplateOptions;
  choco?: InputMaybe<OrderExportChocoEdiFormatInput>;
  supplier?: InputMaybe<OrderExportSupplierEdiFormatInput>;
};

export enum OrderExportEdiTemplateOptions {
  CharliceProduceEdi = 'CharliceProduceEdi',
  UsFoodsEdi = 'UsFoodsEdi',
  CustomEdi = 'CustomEdi'
}

export type OrderExportChocoEdiFormatInput = {
  qualifier: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderExportSupplierEdiFormatInput = {
  qualifier: Scalars['String']['input'];
  value: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIdQualifier?: InputMaybe<Scalars['String']['input']>;
  nameReferenceQualifier?: InputMaybe<Scalars['String']['input']>;
};

export type OrderExportCsvFormatInput = {
  template: OrderExportCsvTemplateOptions;
};

/** ORDER EXPORT CONFIG STARTS HERE .......... */
export enum OrderExportCsvTemplateOptions {
  StandardCsv = 'StandardCsv',
  NecsCsv = 'NECSCsv'
}

export type OrderExportLobsterFormatInput = {
  path: Scalars['String']['input'];
};

export type OrderExportUploadInput = {
  chocoSftp?: InputMaybe<OrderExportChocoSftpUploadInput>;
  externalSftp?: InputMaybe<OrderExportExternalSftpUploadInput>;
};

export type OrderExportChocoSftpUploadInput = {
  path: Scalars['String']['input'];
};

export type OrderExportExternalSftpUploadInput = {
  host: Scalars['String']['input'];
  username: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
  forceIPv4?: InputMaybe<Scalars['Boolean']['input']>;
  readyTimeout?: InputMaybe<Scalars['Int']['input']>;
  forceIPv6?: InputMaybe<Scalars['Boolean']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  passphrase?: InputMaybe<Scalars['String']['input']>;
};

export type OrderExportConfig = {
  __typename?: 'OrderExportConfig';
  orderExportFormat: OrderExportConfigFormat;
  orderExportUpload: OrderExportUploadOption;
};

export type OrderExportConfigUpdateInput = {
  orderExportFormat?: InputMaybe<OrderExportFormatInput>;
  orderExportUpload?: InputMaybe<OrderExportUploadInput>;
};

export type OrderGuideCreatedResponse = OrderGuideCreatedSuccess | OrderGuideCreatedError;

export type OrderGuideCreatedSuccess = AppsyncResponse & {
  __typename?: 'OrderGuideCreatedSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type OrderGuideCreatedError = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderGuideCreatedError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideRequestInput = {
  requestId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
  type: OrderGuideRequestType;
  createOrderGuideMethod: OrderGuideRequestMethod;
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  filesComment?: InputMaybe<Scalars['String']['input']>;
  requestRefId?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderGuideRequestType {
  Create = 'create',
  Update = 'update'
}

export enum OrderGuideRequestMethod {
  PhotoUpload = 'photoUpload',
  EmailChoco = 'emailChoco'
}

export type OrderGuideRequestResponse = OrderGuideRequest | OrderGuideRequestError;

export type OrderGuideRequest = {
  __typename?: 'OrderGuideRequest';
  requestId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  type: OrderGuideRequestType;
  createOrderGuideMethod: OrderGuideRequestMethod;
  uploadedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filesComment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  requestRefId?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideRequestError = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderGuideRequestError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for adding an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsAddInput = {
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  items: Array<OrderGuideV2ItemUnitsAddInputItem>;
};

/**
 * OrderGuideV2ItemUnitsAddInput item
 * If orderGuideCategoryId is provided, the item will be added to the specified category.
 * If orderGuideCategoryName is provided, the item will be added to the category with the provided name (case insensitive).
 * If both orderGuideCategoryId and orderGuideCategoryName are provided, the orderGuideCategoryId takes precedence.
 * If neither is provided, the item will be added as uncategorized.
 */
export type OrderGuideV2ItemUnitsAddInputItem = {
  /** The ID of the vendor item unit to add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
  /**
   * The order guide category to add the vendor item unit to.
   * If not provided, the item will be added as uncategorized.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item is added to it
   * else a new order guide category is created with this name (capitalized) and the item is added to it.,
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuideV2ItemUnitsAddResponse = OrderGuideV2ItemUnitsAddResult | InputValidationFailure | AuthorizationFailure;

/** Success response of the `OrderGuideV2ItemUnitsAdd` query */
export type OrderGuideV2ItemUnitsAddResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsAddResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The added order guide item units. */
  items: Array<OrderGuideV2ItemUnit>;
};

/** Input parameters for removing an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsRemoveInput = {
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type OrderGuideV2ItemUnitsRemoveResponse = OrderGuideV2ItemUnitsRemoveResult | InputValidationFailure | AuthorizationFailure;

/** Success response of the `orderGuideItemUnitsRemove` query */
export type OrderGuideV2ItemUnitsRemoveResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsRemoveResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /**
   * Whether or not the operation was successful.
   * This will always be set to `true`.
   */
  success: Scalars['Boolean']['output'];
};

export type PaymentAuthorizeInput = {
  invoiceId: Scalars['String']['input'];
  scheduledFor: Scalars['AWSTimestamp']['input'];
  paymentAccountId: Scalars['String']['input'];
};

export type PaymentAuthorizeResponse = PostProcessing | PreProcessing | NoFurtherActionNeeded | InputValidationFailure | AuthorizationFailure | PaymentAccountNotFound | PaymentAccountIsInactive | UnexpectedInvoiceState | SupplierDoesNotAcceptOnlinePayments | EntityCurrencyMismatch;

export type PostProcessing = AppsyncResponse & {
  __typename?: 'PostProcessing';
  /** Always ResponseType.success */
  responseType: ResponseType;
  processPaymentToken?: Maybe<Scalars['String']['output']>;
};

export type PreProcessing = AppsyncResponse & {
  __typename?: 'PreProcessing';
  /** Always ResponseType.success */
  responseType: ResponseType;
  redirectURL?: Maybe<Scalars['String']['output']>;
};

export type NoFurtherActionNeeded = AppsyncResponse & {
  __typename?: 'NoFurtherActionNeeded';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type PaymentAccountIsInactive = AppsyncResponse & AppsyncError & {
  __typename?: 'PaymentAccountIsInactive';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UnexpectedInvoiceState = AppsyncResponse & AppsyncError & {
  __typename?: 'UnexpectedInvoiceState';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['String']['output']>;
  expected?: Maybe<Scalars['String']['output']>;
};

export type SupplierDoesNotAcceptOnlinePayments = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierDoesNotAcceptOnlinePayments';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type EntityCurrencyMismatch = AppsyncResponse & AppsyncError & {
  __typename?: 'EntityCurrencyMismatch';
  /** ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdatedCategoryProduct = {
  __typename?: 'UpdatedCategoryProduct';
  categoryId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
};

export type ReferUserInput = {
  referralCode: Scalars['String']['input'];
  chat: ChatCreateInput;
};

export type ReferUserResponse = ReferUserResult | ReferUserChatExists | ReferUserReferralCodeNotFound | InputValidationFailure | AuthorizationFailure;

export type ReferUserResult = {
  __typename?: 'ReferUserResult';
  referredUserId: Scalars['ID']['output'];
  referrerUserId: Scalars['ID']['output'];
  referralCode: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  chat: Chat;
};

export type ReferUserChatExists = AppsyncResponse & AppsyncError & {
  __typename?: 'ReferUserChatExists';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReferUserReferralCodeNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'ReferUserReferralCodeNotFound';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type OmnichannelOrdersSubcriptionResponse = AuthorizationFailure | OrderDeskNotification;

export type OrderDeskNotification = {
  __typename?: 'OrderDeskNotification';
  supplierId: Scalars['ID']['output'];
  omnichannelOrder: OmnichannelOrder;
};

export type RejectOrderInput = {
  id: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type RejectOrderResponse = OrderRejected | AuthorizationFailure | InputValidationFailure;

export type OrderRejected = {
  __typename?: 'OrderRejected';
  id: Scalars['ID']['output'];
};

export type RejectOrdersByIdInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type RejectOrdersByIdResponse = OrdersRejected | AuthorizationFailure | InputValidationFailure;

export type OrdersRejected = {
  __typename?: 'OrdersRejected';
  ids: Array<Scalars['ID']['output']>;
};

export type RemoveCcEmailFromChatsReport = {
  __typename?: 'RemoveCCEmailFromChatsReport';
  numberOfChatsUpdated: Scalars['Int']['output'];
};

export type RemoveEmailFromBuyerReportScheduleResponse = EmailFromBuyerReportScheduleRemoved | InputValidationFailure | AuthorizationFailure | EmailInBuyerReportScheduleNotFound | BuyerReportScheduleNotFound;

export type EmailFromBuyerReportScheduleRemoved = AppsyncResponse & AppsyncError & {
  __typename?: 'EmailFromBuyerReportScheduleRemoved';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type EmailInBuyerReportScheduleNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'EmailInBuyerReportScheduleNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type RemoveEntitiesFromGroupInput = {
  groupId: Scalars['ID']['input'];
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RemoveEntitiesFromGroupResponse = RemoveEntitiesFromGroupResponseSuccess | RemoveEntitiesFromGroupResponseError | AuthorizationFailure;

export type RemoveEntitiesFromGroupResponseSuccess = AppsyncResponse & {
  __typename?: 'RemoveEntitiesFromGroupResponseSuccess';
  responseType: ResponseType;
};

export type RemoveEntitiesFromGroupResponseError = AppsyncError & {
  __typename?: 'RemoveEntitiesFromGroupResponseError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<RemoveEntitiesFromGroupErrorCode>;
};

export enum RemoveEntitiesFromGroupErrorCode {
  Unexpected = 'unexpected'
}

export type RemoveInvoiceResponse = InvoiceRemoved | InputValidationFailure | AuthorizationFailure | InvoiceCannotBeRemoved;

export type InvoiceRemoved = AppsyncResponse & {
  __typename?: 'InvoiceRemoved';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type InvoiceCannotBeRemoved = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoiceCannotBeRemoved';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
};

export type RemoveInvoiceAttachmentResponse = InvoiceAttachmentRemoved | InputValidationFailure | AuthorizationFailure | InvoiceCannotBeUpdated;

export type InvoiceAttachmentRemoved = AppsyncResponse & {
  __typename?: 'InvoiceAttachmentRemoved';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type InvoiceCannotBeUpdated = AppsyncResponse & AppsyncError & {
  __typename?: 'InvoiceCannotBeUpdated';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
};

export type RemoveOrderDeskEmail = {
  supplierId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  type: OrderDestEmailListType;
};

export type OrderDeskRemovedEmailResponse = OrderDeskEmailRemoved | AuthorizationFailure | InputValidationFailure;

export type OrderDeskEmailRemoved = {
  __typename?: 'OrderDeskEmailRemoved';
  supplierId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  type: OrderDestEmailListType;
};

export type RemovePaymentAccountResponse = PaymentAccountRemoved | InputValidationFailure | AuthorizationFailure;

export type PaymentAccountRemoved = AppsyncResponse & {
  __typename?: 'PaymentAccountRemoved';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type RemoveProductsFromOrderGuidesInput = {
  sourceChatId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductsFromOrderGuidesResponse = RemoveProductsFromOrderGuidesResult | InputValidationFailure | AuthorizationFailure;

export type RemoveProductsFromOrderGuidesResult = AppsyncResponse & {
  __typename?: 'RemoveProductsFromOrderGuidesResult';
  responseType: ResponseType;
  transactionId: Scalars['String']['output'];
  locations: Array<LocationProductsResult>;
};

export type RemoveSupplierBuyerMovInput = {
  supplierEntityId: Scalars['String']['input'];
  buyerId: Scalars['String']['input'];
};

export type MinimumOrderValueUpdateResponse = MinimumOrderValueUpdate | MinimumOrderValueFailure | InputValidationFailure | AuthorizationFailure;

export type MinimumOrderValueUpdate = {
  __typename?: 'MinimumOrderValueUpdate';
  success: Scalars['Boolean']['output'];
};

export type RemoveUsersFromGroupInput = {
  groupId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type RemoveUsersFromGroupResponse = RemoveUsersFromGroupSuccess | RemoveUsersFromGroupError | AuthorizationFailure;

export type RemoveUsersFromGroupSuccess = AppsyncResponse & {
  __typename?: 'RemoveUsersFromGroupSuccess';
  responseType: ResponseType;
};

export type RemoveUsersFromGroupError = AppsyncError & {
  __typename?: 'RemoveUsersFromGroupError';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type RequestToJoinBuyerResponse = UserRequestToJoin | RequestToJoinBuyerError | AuthorizationFailure;

export type RequestToJoinBuyerError = AppsyncResponse & AppsyncError & {
  __typename?: 'RequestToJoinBuyerError';
  responseType: ResponseType;
  errorCode?: Maybe<RequestToJoinBuyerErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum RequestToJoinBuyerErrorCode {
  GenericError = 'genericError',
  BuyerNotFoundError = 'buyerNotFoundError',
  UserIsAlreadyConnectedToBuyerError = 'userIsAlreadyConnectedToBuyerError'
}

export type SelectProductForOrderGuideInput = {
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  buyerProduct?: InputMaybe<BuyerProductInput>;
};

export type BuyerProductInput = {
  price?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
};

export type SelectProductForOrderGuideResponse = SelectProductForOrderGuideSuccess | InputValidationFailure | AuthorizationFailure;

export type SelectProductForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductForOrderGuideSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type SelectProductsForOrderGuideInput = {
  chatId: Scalars['ID']['input'];
  products: Array<OrderGuideProductInput>;
};

export type OrderGuideProductInput = {
  productId: Scalars['ID']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectProductsForOrderGuideResponse = SelectProductsForOrderGuideSuccess | AuthorizationFailure;

export type SelectProductsForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductsForOrderGuideSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
};

export type SendInviteTransmissionRequest = {
  inviteeId: Scalars['String']['input'];
  inviteeName?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  invitedToEntityId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  inviteeEntityId?: InputMaybe<Scalars['String']['input']>;
  inviteeEntityName?: InputMaybe<Scalars['String']['input']>;
  invitorId: Scalars['String']['input'];
  invitorUserName: Scalars['String']['input'];
  invitorEntityName: Scalars['String']['input'];
  channel: InviteChannel;
};

export type SendInviteTransmissionResponse = InviteTransmission | AuthorizationFailure | InputValidationFailure;

export type SendSyntheticSmsMessageInput = {
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
  /** Body of the sms to send. */
  body: Scalars['String']['input'];
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticSmsMessageMediaInput>>;
  /** The messageSid of the sms message to send a synthetic response to */
  messageSid?: InputMaybe<Scalars['String']['input']>;
  /** Sender phone number */
  from?: InputMaybe<Scalars['String']['input']>;
  /** AccountSid number */
  accountSid?: InputMaybe<Scalars['String']['input']>;
};

export type SendSyntheticSmsMessageMediaInput = {
  mediaUrl: Scalars['String']['input'];
  mediaContentType: Scalars['String']['input'];
};

export type SendSyntheticSmsMessageResponse = SendSyntheticSmsMessageSuccess | InputValidationFailure | AuthorizationFailure;

export type SendSyntheticSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticSmsMessageSuccess';
  responseType: ResponseType;
  messageSid: Scalars['String']['output'];
};

export type SendSyntheticWhatsAppMessageInput = {
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
  /** Sender phone number */
  from: Scalars['String']['input'];
  /** Body of the WhatsApp message to send. */
  body: Scalars['String']['input'];
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticWhatsAppMessageMediaInput>>;
  /**
   * The messageSid of the WhatsApp message message to send a synthetic response to.
   * Must begin with prefix TEST_.
   */
  messageSid: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageMediaInput = {
  url: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageResponse = SendSyntheticWhatsAppMessageSuccess | InputValidationFailure | AuthorizationFailure;

export type SendSyntheticWhatsAppMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticWhatsAppMessageSuccess';
  responseType: ResponseType;
  messageSid: Scalars['String']['output'];
};

export type SetOrderAsTestResponse = TestOrderResponse | InputValidationFailure;

export type TestOrderResponse = {
  __typename?: 'TestOrderResponse';
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubmitBuyerStockCountInput = {
  buyerId: Scalars['ID']['input'];
};

export type CartSubmissionOptions = {
  /** The id of the order to create from the cart */
  orderId: Scalars['ID']['input'];
  /** The body of the order message */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The requested delivery date for the order */
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** The minimum order value set by the supplier */
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum order value currency */
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The estimated order value */
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  /** The estimated order value currency */
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Is this a test order */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
  /** This parameter determines which order create version to use */
  apiVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type CartSubmissionResponse = CartSubmissionResult | CartSubmissionError | CreateMessageError | CartNotFoundError | CartSubmittedEmptyError | CartVersionConstraintError | CartInvalidProductsError | CartAllProductsUnavailableError | AuthorizationFailure | ForbiddenError | InputValidationFailure | ExistingOrderError | ProductLeadTimeError;

export type CartSubmissionResult = {
  __typename?: 'CartSubmissionResult';
  /** the cart ID */
  id: Scalars['ID']['output'];
  /** the message item created from the cart submission */
  message?: Maybe<Message>;
  cart?: Maybe<Cart>;
};

export type CartSubmissionError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartSubmissionError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type CreateMessageError = AppsyncResponse & AppsyncError & {
  __typename?: 'CreateMessageError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type CartSubmittedEmptyError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartSubmittedEmptyError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type CartInvalidProductsError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartInvalidProductsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  invalidProductCount: Scalars['Int']['output'];
};

export type CartAllProductsUnavailableError = AppsyncResponse & AppsyncError & {
  __typename?: 'CartAllProductsUnavailableError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  unavailableProductCount: Scalars['Int']['output'];
};

export type ForbiddenError = AppsyncResponse & AppsyncError & {
  __typename?: 'ForbiddenError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type ExistingOrderError = AppsyncResponse & AppsyncError & {
  __typename?: 'ExistingOrderError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** ID of Existing Order */
  orderId?: Maybe<Scalars['String']['output']>;
};

export type ProductLeadTimeError = AppsyncResponse & AppsyncError & {
  __typename?: 'ProductLeadTimeError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
  /** IDs of the products that cannot be delivered within the selected delivery date */
  invalidProductIds: Array<Scalars['String']['output']>;
};

export type SubmitOrderDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  deliveryCheckReconciliationRequest?: InputMaybe<DeliveryCheckReconciliationRequestInput>;
};

export type DeliveryCheckReconciliationRequestInput = {
  type: DeliveryCheckReconciliationRequestType;
  comment?: InputMaybe<Scalars['String']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  dateOfDelivery?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type OrderDeliveryCheckSubmissionResponse = OrderDeliveryCheckDetails | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderNotFound | OrderDeliveryItemsMismatched | OrderDeliveryCheckNotFound | AuthorizationFailure;

export type OrderDeliveryCheckNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'OrderDeliveryCheckNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubmitOrderedProductDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
};

export type OrderedProductDeliveryCheckSubmissionResponse = OrderedProductDeliveryCheck | InputValidationFailure | OrderNotFound | OrderDeliveryItemsMismatched | OrderDeliveryCheckAlreadyCompleted | AuthorizationFailure;

export type SubmitStockCountSessionInput = {
  stockCountSessionId: Scalars['ID']['input'];
  buyerId: Scalars['ID']['input'];
};

export type SubmitStockCountSessionResponse = AuthorizationFailure | InputValidationFailure | SubmitStockCountSessionFailure | SubmitStockCountSessionSuccess;

export type SubmitStockCountSessionFailure = {
  __typename?: 'SubmitStockCountSessionFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SubmitStockCountSessionSuccess = {
  __typename?: 'SubmitStockCountSessionSuccess';
  responseType: ResponseType;
};

export type SupplierAddRequestInput = {
  userId: Scalars['String']['input'];
  buyerId: Scalars['String']['input'];
  supplierCompanyName: Scalars['String']['input'];
  existingCustomer: Scalars['Boolean']['input'];
  createOrderGuideMethod: Scalars['String']['input'];
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepName?: InputMaybe<Scalars['String']['input']>;
  salesRepPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepEmailAddress?: InputMaybe<Scalars['String']['input']>;
  salesRepPhoneCallNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepTextNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepWhatsAppNumber?: InputMaybe<Scalars['String']['input']>;
  orderDeskEmailAddress?: InputMaybe<Scalars['String']['input']>;
  orderDeskPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  orderDeskFaxNumber?: InputMaybe<Scalars['String']['input']>;
  ordersUsingWebShop?: InputMaybe<Scalars['Boolean']['input']>;
  filesComment?: InputMaybe<Scalars['String']['input']>;
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
  createChat?: InputMaybe<Scalars['Boolean']['input']>;
  requestRefId?: InputMaybe<Scalars['String']['input']>;
  quietRequest?: InputMaybe<Scalars['Boolean']['input']>;
  addBuyerTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierAddRequestResponse = SupplierAddRequest | SupplierAddRequestError;

export type SupplierAddRequest = {
  __typename?: 'SupplierAddRequest';
  id: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
  buyerId: Scalars['String']['output'];
  supplierCompanyName: Scalars['String']['output'];
  existingCustomer: Scalars['Boolean']['output'];
  createOrderGuideMethod: Scalars['String']['output'];
  customerNumber?: Maybe<Scalars['String']['output']>;
  salesRepName?: Maybe<Scalars['String']['output']>;
  salesRepPhoneNumber?: Maybe<Scalars['String']['output']>;
  salesRepEmailAddress?: Maybe<Scalars['String']['output']>;
  salesRepPhoneCallNumber?: Maybe<Scalars['String']['output']>;
  salesRepTextNumber?: Maybe<Scalars['String']['output']>;
  salesRepWhatsAppNumber?: Maybe<Scalars['String']['output']>;
  orderDeskEmailAddress?: Maybe<Scalars['String']['output']>;
  orderDeskPhoneNumber?: Maybe<Scalars['String']['output']>;
  orderDeskFaxNumber?: Maybe<Scalars['String']['output']>;
  ordersUsingWebShop?: Maybe<Scalars['Boolean']['output']>;
  filesComment?: Maybe<Scalars['String']['output']>;
  uploadedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  supplierRefId?: Maybe<Scalars['String']['output']>;
  createChat?: Maybe<Scalars['Boolean']['output']>;
  /** keeping the chatId for backwards compaitblity */
  chatId?: Maybe<Scalars['String']['output']>;
  requestRefId?: Maybe<Scalars['String']['output']>;
  chat?: Maybe<UserChatEdge>;
};

export type SupplierAddRequestError = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierAddRequestError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierCreateInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  integration: Array<IntegrationOptionInput>;
  locale: Scalars['String']['input'];
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** set this flag to enroll this supplier as a test supplier on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minOrder?: InputMaybe<MinOrderInput>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationOptionInput = {
  sms?: InputMaybe<IntegrationSmsOptionInput>;
  email?: InputMaybe<IntegrationEmailOptionInput>;
  fax?: InputMaybe<IntegrationFaxOptionInput>;
  whatsApp?: InputMaybe<IntegrationWhatsAppOptionInput>;
};

export type IntegrationSmsOptionInput = {
  type: IntegrationType;
  phone: Scalars['String']['input'];
};

export type IntegrationEmailOptionInput = {
  type: IntegrationType;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  xlsx: Scalars['Boolean']['input'];
  pdf: Scalars['Boolean']['input'];
  complaintEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  orderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  messageEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationFaxOptionInput = {
  type: IntegrationType;
  phone: Scalars['String']['input'];
};

export type IntegrationWhatsAppOptionInput = {
  type: IntegrationType;
  phone: Scalars['String']['input'];
};

export type DeliveryZoneInput = {
  name: Scalars['String']['input'];
  points: Array<CoordinateInput>;
};

export type PriceSettingInput = {
  displayInMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  displayToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MinOrderInput = {
  price?: InputMaybe<MoneyInput>;
};

export type SupplierGetInTouchRequestInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGetInTouchRequestResponse = SupplierGetInTouchRequestSuccess | SupplierGetInTouchRequestError;

export type SupplierGetInTouchRequestSuccess = AppsyncResponse & {
  __typename?: 'SupplierGetInTouchRequestSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  errors: Array<SupplierUpdateError>;
};

export type SupplierUpdateError = {
  __typename?: 'SupplierUpdateError';
  message: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
};

export type SupplierGetInTouchRequestError = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierGetInTouchRequestError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type ChatInviteRecipient = {
  phoneNumber: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type ChatInviteInput = {
  userName?: InputMaybe<Scalars['String']['input']>;
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<InviteChannel>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceName?: InputMaybe<Scalars['String']['input']>;
  googlefullAddress?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  teamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /** existing chat id to use, a new chat will be created if not given */
  chatId?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierInviteUserResponse = {
  __typename?: 'SupplierInviteUserResponse';
  chatUsers: Array<Maybe<ChatUser>>;
  inviteResponse: Array<Maybe<SupplierInviteResponseEntity>>;
};

/** ORDER EXPORT CONFIG ENDS HERE ......... */
export type SupplierInviteResponseEntity = User | Chat | InvalidInvitedPhoneNumber | SupplierInviteError;

export type InvalidInvitedPhoneNumber = AppsyncResponse & AppsyncError & {
  __typename?: 'InvalidInvitedPhoneNumber';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  phoneNumber: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierInviteError = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierInviteError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type SupplierUpdateInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Array<IntegrationOptionInput>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only definable for Premium and LeadGen suppliers */
  allowCustomerAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  minOrder?: InputMaybe<MinOrderInput>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierUserCreateInput = {
  id: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierUserRemoveInput = {
  userId: Scalars['String']['input'];
};

export type SupplierUserRemoveResponse = AppsyncResponse & {
  __typename?: 'SupplierUserRemoveResponse';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type TriggerProductMatchingInput = {
  omnichannelOrderId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerProductMatchingResponse = OmnichannelOrder | AuthorizationFailure | InputValidationFailure;

export type UnassignUserFromOrderToReviewInput = {
  omnichannelOrderId: Scalars['ID']['input'];
};

export type UnassignUserFromOrderToReviewResponse = UnassignUserFromOrderToReviewResponseSuccess | UnassignUserFromOrderToReviewResponseError;

export type UnassignUserFromOrderToReviewResponseSuccess = {
  __typename?: 'UnassignUserFromOrderToReviewResponseSuccess';
  omnichannelOrderId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type UnassignUserFromOrderToReviewResponseError = AppsyncResponse & AppsyncError & {
  __typename?: 'UnassignUserFromOrderToReviewResponseError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UndoMultiLocationOrderGuideTransactionInput = {
  transactionId: Scalars['ID']['input'];
};

export type UndoMultiLocationOrderGuideTransactionResponse = UndoMultiLocationOrderGuideTransactionResult | InputValidationFailure | AuthorizationFailure;

export type UndoMultiLocationOrderGuideTransactionResult = AppsyncResponse & {
  __typename?: 'UndoMultiLocationOrderGuideTransactionResult';
  responseType: ResponseType;
  succeededLocationIds: Array<Maybe<Scalars['ID']['output']>>;
  failedLocationIds: Array<Maybe<Scalars['ID']['output']>>;
};

export type UpdateBuyerInventoryProductInput = {
  productId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  price?: InputMaybe<MoneyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuyerInventoryProductResponse = BuyerInventoryProduct | InputValidationFailure | AuthorizationFailure;

export type UpdateBuyerStockInventoryProductInput = {
  id: Scalars['ID']['input'];
  buyerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
};

export type UpdateBuyerStockInventoryProductResponse = AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound | UpdateBuyerStockInventoryProductFailure;

export type UpdateBuyerStockInventoryProductFailure = {
  __typename?: 'UpdateBuyerStockInventoryProductFailure';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type CartLineItemUpdateInput = {
  /** The id of the product */
  productId: Scalars['ID']['input'];
  /** The amounts of products items to add or remove from the cart */
  amount: Scalars['Float']['input'];
  /** is this an operation to add or remove a product item */
  action: UserCartAction;
  /** The meta data of the product */
  productMeta?: InputMaybe<CartProductMetadataInput>;
};

export type CartProductMetadataInput = {
  /** The name of the product */
  name: Scalars['String']['input'];
  /** The external id of the product */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The unit of measurement of the product item */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CartUpdateResponse = Cart | CartNotFoundError | NegativeAmountError | AuthorizationFailure | InputValidationFailure;

export type NegativeAmountError = AppsyncResponse & AppsyncError & {
  __typename?: 'NegativeAmountError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type ChatNotificationInput = {
  /** chat ID */
  id: Scalars['ID']['input'];
  newOrder?: InputMaybe<ChatNotificationUserListsInput>;
  newMessage?: InputMaybe<ChatNotificationUserListsInput>;
};

export type ChatNotificationUserListsInput = {
  deselectedUsersList: Array<Scalars['ID']['input']>;
  extraUsersList?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateInventoryItemInput = {
  buyerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  patch: UpdateInventoryItemInputPatch;
};

export type UpdateInventoryItemInputPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInventoryItemResponse = UpdateInventoryItemSuccess | UpdateInventoryItemFailure | InputValidationFailure | AuthorizationFailure;

export type UpdateInventoryItemSuccess = {
  __typename?: 'UpdateInventoryItemSuccess';
  responseType?: Maybe<ResponseType>;
  inventoryItem: InventoryItem;
};

export type UpdateInventoryItemFailure = {
  __typename?: 'UpdateInventoryItemFailure';
  /** Always ResponseType.Error */
  responseType?: Maybe<ResponseType>;
  message: Scalars['String']['output'];
};

export type UpdateInvoiceInput = {
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** total amount of invoice in cents */
  total?: InputMaybe<Scalars['Int']['input']>;
  issueDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceResponse = Invoice | InputValidationFailure | AuthorizationFailure | InvoiceCannotBeUpdated;

export type InvoicedProductInput = {
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoicedPrice?: InputMaybe<MoneyInput>;
};

export type UpdateInvoicedProductResponse = InvoicedProducts | InputValidationFailure | AuthorizationFailure;

export type InvoicedProducts = AppsyncResponse & {
  __typename?: 'InvoicedProducts';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  invoicedProducts: Array<InvoicedProduct>;
};

export type UpdatePendingUserInput = {
  chatId: Scalars['String']['input'];
  user: PendingUserInput;
};

export type PendingUserInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdatePendingUserResponse = User | AuthorizationFailure;

export type UpdateProductVariantsInOrderGuideInput = {
  chatId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  selectedVariantIds: Array<Scalars['ID']['input']>;
  /** The variant which the user was navigated from while changing the unit in OG */
  sourceVariantId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductVariantsInOrderGuideResponse = UpdateProductVariantsInOrderGuideSuccess | InputValidationFailure | AuthorizationFailure;

export type UpdateProductVariantsInOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'UpdateProductVariantsInOrderGuideSuccess';
  responseType: ResponseType;
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateJoinRequestInput = {
  id: Scalars['ID']['input'];
  status: JoinRequestAllowedUpdateStatus;
};

export enum JoinRequestAllowedUpdateStatus {
  Approved = 'approved',
  Denied = 'denied'
}

export type UpdateJoinRequestResponse = UpdateJoinRequestSuccess | UpdateJoinRequestError | InputValidationFailure | AuthorizationFailure;

export type UpdateJoinRequestSuccess = {
  __typename?: 'UpdateJoinRequestSuccess';
  id: Scalars['String']['output'];
  status: JoinRequestAllowedUpdateStatus;
};

export type UpdateJoinRequestError = AppsyncResponse & AppsyncError & {
  __typename?: 'UpdateJoinRequestError';
  responseType: ResponseType;
  errorCode?: Maybe<UpdateJoinRequestErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum UpdateJoinRequestErrorCode {
  NotFoundJoinRequest = 'notFoundJoinRequest',
  GenericError = 'genericError',
  NotAllowedJoinRequestUpdate = 'notAllowedJoinRequestUpdate'
}

export type UpdateStorageItemInput = {
  buyerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  patch: UpdateStorageItemInputPatch;
};

export type UpdateStorageItemInputPatch = {
  storageAreaId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<PatchStorageItemPrice>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type PatchStorageItemPrice = {
  priceInCents: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
};

export type UpdateStorageItemResponse = UpdateStorageItemSuccess | UpdateStorageItemFailure | InputValidationFailure | AuthorizationFailure;

export type UpdateStorageItemSuccess = {
  __typename?: 'UpdateStorageItemSuccess';
  responseType?: Maybe<ResponseType>;
  storageItem: StorageItem;
};

export type UpdateStorageItemFailure = {
  __typename?: 'UpdateStorageItemFailure';
  /** Always ResponseType.Error */
  responseType?: Maybe<ResponseType>;
  message: Scalars['String']['output'];
};

export type UpdateSubCatalogResponse = SubCatalog | UpdateSubCatalogError;

export type UpdateSubCatalogError = AppsyncResponse & AppsyncError & {
  __typename?: 'UpdateSubCatalogError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubCatalogChatInput = {
  subCatalogId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};

export type UpdateSubCatalogChatsResponse = UpdateSubCatalogChatsResult | AuthorizationFailure;

export type UpdateSubCatalogChatsResult = {
  __typename?: 'UpdateSubCatalogChatsResult';
  subCatalogChats?: Maybe<UpdateSubCatalogChatsSummary>;
  errors: Array<InvalidSubCatalogChat>;
};

export type UpdateSubCatalogChatsSummary = {
  __typename?: 'UpdateSubCatalogChatsSummary';
  created: Array<SubCatalogChat>;
  removed: Array<SubCatalogChat>;
};

export type SubCatalogChat = {
  __typename?: 'SubCatalogChat';
  subCatalogId: Scalars['ID']['output'];
  chatId: Scalars['ID']['output'];
  createdBy?: Maybe<EntityIdentity>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type EntityIdentity = IntegrationEntityIdentity | InternalEntityIdentity;

export type IntegrationEntityIdentity = {
  __typename?: 'IntegrationEntityIdentity';
  integrationId: Scalars['String']['output'];
  type: IntegrationEntityIdentityType;
  appName: Scalars['String']['output'];
};

export enum IntegrationEntityIdentityType {
  Integration = 'integration'
}

export type InternalEntityIdentity = {
  __typename?: 'InternalEntityIdentity';
  userId: Scalars['String']['output'];
  type?: Maybe<InternalEntityIdentityType>;
};

export enum InternalEntityIdentityType {
  User = 'user'
}

export type InvalidSubCatalogChat = {
  __typename?: 'InvalidSubCatalogChat';
  subCatalogId: Scalars['ID']['output'];
  chatId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type SupplierUpdateAccessPackageInput = {
  supplierId: Scalars['String']['input'];
  accessPackage: AccessPackage;
};

export type SupplierUpdateAccessPackageResponse = SupplierUpdateAccessPackageSuccess | SupplierUpdateAccessPackageError;

export type SupplierUpdateAccessPackageSuccess = AppsyncResponse & {
  __typename?: 'SupplierUpdateAccessPackageSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  errors: Array<SupplierUpdateError>;
};

export type SupplierUpdateAccessPackageError = AppsyncResponse & AppsyncError & {
  __typename?: 'SupplierUpdateAccessPackageError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateSupplierBuyerMovInput = {
  supplierEntityId: Scalars['String']['input'];
  buyerId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
};

export type SupplierDeliverySettingInput = {
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['input'];
  cutOffTime?: InputMaybe<CutOffTimeInput>;
  /** Sunday - Saturday : 0 - 6 */
  deliveryDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: SupplierDeliverySettingType;
  scope?: InputMaybe<SupplierDeliverySettingScope>;
  /** Please provide either cutoffTimes or exceptions */
  cutoffTimes?: InputMaybe<WeekdayBasedCutoffSettingsInput>;
  exceptions?: InputMaybe<Array<DeliveryExceptionInput>>;
};

export type CutOffTimeInput = {
  type: CutOffTimeType;
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['input'];
};

export type WeekdayBasedCutoffSettingsInput = {
  mon?: InputMaybe<CutoffSettingInput>;
  tue?: InputMaybe<CutoffSettingInput>;
  wed?: InputMaybe<CutoffSettingInput>;
  thu?: InputMaybe<CutoffSettingInput>;
  fri?: InputMaybe<CutoffSettingInput>;
  sat?: InputMaybe<CutoffSettingInput>;
  sun?: InputMaybe<CutoffSettingInput>;
};

export type CutoffSettingInput = {
  type: CutOffTimeType;
  /** in days */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime?: InputMaybe<Scalars['AWSTime']['input']>;
};

export type DeliveryExceptionInput = {
  type: DeliveryExceptionInputType;
  date: Scalars['AWSDate']['input'];
  cutoff?: InputMaybe<DeliveryExceptionCutoffSettingInput>;
};

export enum DeliveryExceptionInputType {
  NoDeliveryException = 'noDeliveryException',
  SingleDayDeliveryException = 'singleDayDeliveryException'
}

export type DeliveryExceptionCutoffSettingInput = {
  type: CutOffTimeType;
  leadTimeAdjustedCutoff?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateSupplierProductV2Input = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierUserUpdateChatsInput = {
  userId: Scalars['String']['input'];
  addTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SupplierUserUpdateChatsResponse = {
  __typename?: 'SupplierUserUpdateChatsResponse';
  userId: Scalars['String']['output'];
  addedTo: Array<Maybe<Scalars['String']['output']>>;
  removedFrom: Array<Maybe<Scalars['String']['output']>>;
};

export type UpdateSupplierUserRolesInput = {
  userId: Scalars['String']['input'];
  /** Only one role is allowed. */
  rolesToAdd: Array<Role>;
  /** All existing roles are overridden by the one specified in rolesToAdd. */
  rolesToRemove?: InputMaybe<Array<Role>>;
};

export type UploadSubCatalogProductsResponse = UploadSubCatalogProductsResult | UploadSubCatalogProductsError;

export type UploadSubCatalogProductsResult = {
  __typename?: 'UploadSubCatalogProductsResult';
  success: Scalars['Boolean']['output'];
  submittedProductsCount: Scalars['Int']['output'];
};

export type UploadSubCatalogProductsError = AppsyncResponse & AppsyncError & {
  __typename?: 'UploadSubCatalogProductsError';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type UpsertStockCountSessionItemsInput = {
  items: Array<StockCountItemInput>;
  buyerId: Scalars['ID']['input'];
};

export type StockCountItemInput = {
  storageItemId: Scalars['ID']['input'];
  /** The negative value (e.g. -1) will cause the item to be removed from the session. */
  quantity: Scalars['Float']['input'];
};

export type UpsertStockCountSessionItemsResponse = UpsertStockCountSessionItemsSuccess | UpsertStockCountSessionItemsError | InputValidationFailure | AuthorizationFailure;

export type UpsertStockCountSessionItemsSuccess = {
  __typename?: 'UpsertStockCountSessionItemsSuccess';
  responseType: ResponseType;
  stockCountSessionId: Scalars['ID']['output'];
};

export type UpsertStockCountSessionItemsError = {
  __typename?: 'UpsertStockCountSessionItemsError';
  responseType: ResponseType;
  message: Scalars['String']['output'];
};

export type UserCreateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  botUser?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  chocoUser: Scalars['Boolean']['input'];
  createdContext?: InputMaybe<UserCreatedContext>;
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPreferenceInput = {
  fax?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['String']['input']>;
  welcomeNotificationSent?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  whatsApp?: InputMaybe<Scalars['String']['input']>;
  xlsx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLeadInput = {
  phoneNumber: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export type UserLead = {
  __typename?: 'UserLead';
  phoneNumber: Scalars['String']['output'];
  requests?: Maybe<Array<Maybe<UserLeadRequest>>>;
  requestCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLeadRequest = {
  __typename?: 'UserLeadRequest';
  createdAt: Scalars['AWSTimestamp']['output'];
  name?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
};

export type UserRequestToDeleteInput = {
  userId: Scalars['ID']['input'];
};

export type UserRequestToDeleteResponse = UserRequestToDeleteDetails | AuthorizationFailure;

export type UserRequestToDeleteDetails = {
  __typename?: 'UserRequestToDeleteDetails';
  success: Scalars['Boolean']['output'];
};

export type UserUpdateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  challengeByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  chocoUser?: InputMaybe<Scalars['Boolean']['input']>;
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Changes may be provided partially
 * If a field is omitted, it will not be touched
 */
export type VendorItemUnitUpdateInput = {
  vendorItemUnitId: Scalars['ID']['input'];
  stockStatus?: InputMaybe<VendorItemUnitStockStatus>;
};

export type VendorItemUnitUpdateResponse = VendorItemUnitUpdateResult | InputValidationFailure | AuthorizationFailure;

export type VendorItemUnitUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitUpdateResult';
  unit: VendorItemUnit;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type Subscription = {
  __typename?: 'Subscription';
  omnichannelOrdersSubcription?: Maybe<OmnichannelOrdersSubcriptionResponse>;
  onNotificationCreate?: Maybe<Notification>;
};


export type SubscriptionOmnichannelOrdersSubcriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOnNotificationCreateArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ActivateChatResponse = Chat;

export type BuyerChatsNotFound = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerChatsNotFound';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerChatsProductListEmpty = AppsyncResponse & AppsyncError & {
  __typename?: 'BuyerChatsProductListEmpty';
  /** Always ResponseType.Error */
  responseType: ResponseType;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerChatsResponse = BuyerChatConnection | InvalidCursor;

export type BuyerStockCountProductInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  stockQuantity: Scalars['Float']['input'];
  stockInventoryProductId: Scalars['ID']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
};

export type Contact = {
  __typename?: 'Contact';
  phone: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  user: User;
  Image?: Maybe<Scalars['String']['output']>;
};

export type OrderResult = Node & {
  __typename?: 'OrderResult';
  id: Scalars['ID']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  orderProducts?: Maybe<Array<Maybe<OrderProduct>>>;
  body?: Maybe<Scalars['String']['output']>;
  orderSupplierStatus?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  supplierId: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  restaurant?: Maybe<OrderRestaurant>;
  user?: Maybe<User>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
};

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductMatchData = {
  __typename?: 'ProductMatchData';
  products: Array<OmnichannelOrderProduct>;
  chatId: Scalars['ID']['output'];
};

export type SupplierContactAlreadyCreated = {
  __typename?: 'SupplierContactAlreadyCreated';
  message?: Maybe<Scalars['String']['output']>;
};

export type SupplierProductFilter = {
  supplierId?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinateInput>;
};



export type ResolverTypeWrapper<T> = PartialDeep<T>;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<RefType extends Record<string, unknown>> = {
  MinimumOrderValueResponse: ( MinimumOrderValue ) | ( MinimumOrderValueFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  CutoffSetting: ( NoCutoffSetting ) | ( WithCutoffSetting );
  DeliverySettingException: ( SingleDayDeliveryExceptionWithCutoff ) | ( SingleDayDeliveryExceptionWithoutCutoff ) | ( NoDeliveryException );
  IntegrationOption: ( IntegrationSmsOption ) | ( IntegrationEmailOption ) | ( IntegrationFaxOption ) | ( IntegrationWhatsAppOption );
  OrderExportConfigFormat: ( OrderExportConfigCsvFormat ) | ( OrderExportConfigEdiFormat ) | ( OrderExportConfigLobsterFormat );
  OrderExportUploadOption: ( OrderExportChocoSftpUpload ) | ( OrderExportExternalSftpUpload ) | ( OrderExportLobsterUpload );
  ListPaymentAccountsResponse: ( PaymentAccountsList ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  PaymentAccountDetails: ( BankAccountDetails ) | ( CreditCardDetails ) | ( BalanceVendorBankDetails ) | ( BalanceBuyerBankDetails ) | ( WalletDetails ) | ( PayoutDetails );
  GetReferralResponse: ( Referral ) | ( NotFoundError );
  DerivedPriceForOrderGuideResponse: ( AuthorizationFailure ) | ( DerivedPriceForOrderGuide ) | ( InputValidationFailure );
  IsSelectedInOrderGuideResponse: ( IsSelectedInOrderGuide ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrderInvoice: ( Omit<Invoice, 'currentPayment'> & { currentPayment: RefType['CurrentPaymentResponse'] } ) | ( OrderHasNoInvoice ) | ( OrderHasOnlyAttachment ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CurrentPaymentResponse: ( Omit<PaymentResponse, 'paymentAccount'> & { paymentAccount: RefType['PaymentAccountResponse'] } ) | ( InvoiceHasNoPayment ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  PaymentAccountResponse: ( Omit<SecuredPaymentAccount, 'details'> & { details: RefType['PaymentAccountDetails'] } ) | ( PaymentAccountNotFound ) | ( AuthorizationFailure );
  OrderChangeResponse: ( OrderChange ) | ( NoOrderChange ) | ( OrderChangeReverted ) | ( OrderChangeError );
  GetOrderDeliveryCheckResponse: ( OrderDeliveryCheckDetails ) | ( InputValidationFailure ) | ( CreatedOrCompletedByNotFound ) | ( AuthorizationFailure );
  Attachment: ( Omit<Event, 'chatEventType' | 'target'> & { chatEventType: RefType['ChatEventTypes'], target?: Maybe<Array<Maybe<RefType['EventTarget']>>> } ) | ( Media ) | ( BroadcastAttachment );
  ChatEventTypes: ( RequestedChatCreated ) | ( RequestedChatActivated ) | ( UserAddedToChat ) | ( ChatNameUpdated ) | ( UserRemovedFromChat ) | ( ChatCreated ) | ( CartOpened ) | ( CartUpdated ) | ( CartSubmitted ) | ( CartCanceled ) | ( OrderEdited ) | ( OrderGuideRequested ) | ( OrderGuideCreated ) | ( ReconciliationRequestConfirmed );
  EventTarget: ( EventUser ) | ( EventChat ) | ( EventOrder ) | ( EventDeliveryCheckReconciliationRequest );
  BrowseCatalogResponse: ( CatalogProductsConnection ) | ( AuthorizationFailure );
  BrowseCatalogForChatResponse: ( CatalogProductsConnection ) | ( CatalogNotFound ) | ( AuthorizationFailure );
  BuyerStockCountResponse: ( BuyerStockCountSuccess ) | ( BuyerStockCountFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  BuyerStockCountsResponse: ( BuyerStockCountsSuccess ) | ( BuyerStockCountsFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  BuyerStockInventoryResponse: ( BuyerStockInventory ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( BuyerStockInventoryNotFound ) | ( BuyerStockInventoryFailure );
  BuyerStockInventoryExportUrlResponse: ( BuyerStockInventoryExportUrlSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( BuyerStockInventoryNotFound ) | ( BuyerStockInventoryExportUrlFailure );
  CartResponse: ( Cart ) | ( AuthorizationFailure );
  CatalogImportStatusResponse: ( Omit<CatalogImportStatusResult, 'job'> & { job: RefType['CatalogImportJob'] } ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CatalogImportJob: ( JobWaitingForInput ) | ( JobInProgress ) | ( JobFailed ) | ( CatalogImportJobSucceeded );
  CatalogImportTemplateResponse: ( CatalogImportTemplateResult ) | ( AuthorizationFailure );
  CatalogImportsResponse: ( CatalogImportsResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ChatHasSupplierEmailSupportResponse: ( ChatHasSupplierEmailSupportResult ) | ( ChatNotFoundError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ChatSubCatalogProductsResponse: ( ChatNotFoundError ) | ( ValidationError ) | ( ChatSubCatalogProductsError ) | ( ProductSearchResult );
  FetchBuyerReportDownloadUrlResponse: ( BuyerReport ) | ( BuyerReportGenerationError ) | ( BuyerReportNotFoundError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  FetchCatalogCategoriesForChatResponse: ( CatalogCategoriesResponse ) | ( CatalogNotFound );
  OrderGuideResponse: ( OrderGuide ) | ( OrderGuideFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  GetAllBuyerReportSchedulesResponse: ( BuyerReportSchedules ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  AppliedChatDeliverySettingResponse: ( Omit<AppliedChatDeliverySetting, 'exceptions'> & { exceptions?: Maybe<Array<RefType['DeliverySettingException']>> } ) | ( NotFoundError );
  SuggestedProductResult: ( SuggestedProductSuccessResponse ) | ( GetSuggestedProductsErrorResponse ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  GetCatalogUploadUrlResponse: ( SupplierNotFound ) | ( GetCatalogUploadUrlResult );
  GetChatCountByCCEmailResponse: ( GetChatCountByCcEmailReport ) | ( AuthorizationFailure );
  GetChatSuppliersByLocationsResponse: ( ChatSuppliersByLocations ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetChatsForSubCatalogResponse: ( GetChatsForSubCatalogResult ) | ( SubCatalogNotFoundError ) | ( AuthorizationFailure );
  GetConnectedAccountsResponse: ( ConnectedAccountConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetConnectedIntegrationAdaptersResponse: ( IntegrationAdapterConnectionBaseResultConnection ) | ( IntegrationAdapterConnectionAdminResultConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetEmailListsResponse: ( EmailLists ) | ( AuthorizationFailure );
  GetFeatureFlagsResponse: ( FeatureFlags ) | ( AuthorizationFailure );
  GroupResponse: ( GroupResponseSuccess ) | ( GroupResponseError ) | ( AuthorizationFailure );
  GetGroupEntitiesResponse: ( GetGroupEntitiesSuccessResponse ) | ( GetGroupEntitiesErrorResponse ) | ( AuthorizationFailure );
  GroupEntityNode: ( GroupEntityBuyer ) | ( GroupEntitySupplier );
  GetGroupUsersResponse: ( GetGroupUsersSuccessResponse ) | ( GetGroupUsersErrorResponse ) | ( AuthorizationFailure );
  GetIntegrationAdaptersResponse: ( IntegrationAdapterBaseResultConnection ) | ( IntegrationAdapterAdminResultConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterAuthBase: ( IntegrationAdapterAuthorizationCodeAuthBase ) | ( IntegrationAdapterClientCredentialsAuthBase ) | ( IntegrationAdapterApiKeyAuthBase );
  IntegrationAdapterAuth: ( IntegrationAdapterAuthorizationCodeAuth ) | ( IntegrationAdapterClientCredentialsAuth ) | ( IntegrationAdapterApiKeyAuth );
  IntegrationAdapterWebhookAuth: ( IntegrationAdapterWebhookBasicAuth ) | ( IntegrationAdapterWebhookSignatureAuth );
  GetInviteTransmissionStatusResponse: ( InviteTransmissionStatus ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  GetInviteeBuyersResponse: ( InviteeNotFound ) | ( InviteeBuyers );
  LocationsBySupplierResponse: ( LocationsBySupplierSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  MarketingMessageSuggestionsResult: ( MarketingMessageSuggestionsSuccess ) | ( MarketingMessageSuggestionsError ) | ( MarketingMessageSuggestionsErrorNoSuggestions ) | ( MarketingMessageSuggestionsErrorThrottling ) | ( InputValidationFailure );
  GetOmniChannelOrderResponse: ( OmnichannelOrder ) | ( NotFoundError ) | ( AuthorizationFailure );
  GetOnboardingChecklistResponse: ( OnboardingChecklist ) | ( AuthorizationFailure );
  OnboardingChecklistItemValue: ( OnboardingChecklistBooleanValue ) | ( OnboardingChecklistNumericValue );
  GetProductsForChatResponse: ( GetProductsForChatResult ) | ( ChatNotFoundError ) | ( AuthorizationFailure ) | ( SupplierNotFound );
  GetQboCustomersAndOrderGuidesToImportResponse: ( QboCustomersAndOrderGuidesToImport ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetReconciliationRequestPlanBySupplierIdResponse: ( ReconciliationRequestPlan ) | ( InputValidationFailure ) | ( ReconciliationRequestPlanBySupplierIdNotFound );
  GetRequestsToJoinResponse: ( RequestsToJoinConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetSmsMessageByMessageSidResponse: ( GetSmsMessageByMessageSidSuccess ) | ( AuthorizationFailure );
  GetSmsMessagesFromPhoneNumberResponse: ( GetSmsMessagesFromPhoneNumberSuccess ) | ( AuthorizationFailure );
  GetSubCatalogResponse: ( SubCatalog ) | ( NotFoundError );
  GetSubCatalogsForChatResponse: ( GetSubCatalogsForChatResult ) | ( ChatNotFoundError ) | ( AuthorizationFailure );
  GetSupplierApplicationsResponse: ( SupplierApplications ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CredentialsData: ( QbdCredentials );
  GetSupplierProductsResponse: ( GetSupplierProductsResult ) | ( AuthorizationFailure );
  GetUnconnectedBuyerIdsResult: ( UnconnectedBuyers ) | ( NoUnconnectedBuyers );
  UserIntercomCredentialsResponse: ( UserIntercomCredentialsSuccess ) | ( UserIntercomCredentialsFailure );
  GetWhatsAppMessageByMessageSidResponse: ( GetWhatsAppMessageByMessageSidSuccess ) | ( AuthorizationFailure );
  HasUserCompletedDeliveryCheckResponse: ( HasCompletedDeliveryCheckResult ) | ( OrderNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  InventoryDownloadJobsResponse: ( InventoryDownloadJobsSuccess ) | ( InventoryDownloadJobsFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  InventoryDownloadJobReport: ( InventoryDownloadJobCompleted ) | ( InventoryDownloadJobFailed );
  InventorySuppliersResponse: ( InventorySuppliersSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( InventorySuppliersFailure );
  InventoryUploadJobResponse: ( InventoryUploadJobSuccess ) | ( InventoryUploadJobFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  InventoryUploadTemplateResponse: ( InventoryUploadTemplateResponseSuccess ) | ( InventoryUploadTemplateResponseFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  ListSubCatalogProductsResponse: ( ProductSearchResult ) | ( ListSubCatalogProductsError );
  ListSubCatalogsResponse: ( SubCatalogConnection ) | ( ValidationError );
  LookupPhoneNumbersResponse: ( Omit<LookupPhoneNumbersSuccess, 'lookups'> & { lookups: Array<RefType['PhoneNumberLookup']> } ) | ( LookupPhoneNumbersError );
  PhoneNumberLookup: ( PhoneNumberLookupSuccess ) | ( PhoneNumberLookupError );
  MetaLobbyResponse: ( MetaLobbyResult ) | ( InvalidCursor );
  OrderGuideV2CategoriesResponse: ( OrderGuideV2CategoriesResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrderGuideV2ItemUnitsResponse: ( OrderGuideV2ItemUnitsResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrdersToReviewResponse: ( OrdersToReviewConnection ) | ( InputValidationFailure );
  PaymentOptionsResponse: ( PublicToken ) | ( Redirect ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SearchEntity: ( Omit<User, 'referral'> & { referral?: Maybe<RefType['GetReferralResponse']> } ) | ( Chat ) | ( Omit<Message, 'attachment'> & { attachment?: Maybe<RefType['Attachment']> } ) | ( Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: RefType['OrderInvoice'], orderChanges?: Maybe<RefType['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<RefType['GetOrderDeliveryCheckResponse']> } ) | ( Omit<Supplier, 'appliedMinimumOrderValue' | 'integration' | 'orderExportFormat' | 'orderExportUpload' | 'paymentAccounts'> & { appliedMinimumOrderValue?: Maybe<RefType['MinimumOrderValueResponse']>, integration: Array<RefType['IntegrationOption']>, orderExportFormat?: Maybe<RefType['OrderExportConfigFormat']>, orderExportUpload?: Maybe<RefType['OrderExportUploadOption']>, paymentAccounts: RefType['ListPaymentAccountsResponse'] } ) | ( Omit<Product, 'derivedPriceForOrderGuide' | 'isSelectedInOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<RefType['DerivedPriceForOrderGuideResponse']>, isSelectedInOrderGuide?: Maybe<RefType['IsSelectedInOrderGuideResponse']> } ) | ( Broadcast ) | ( Buyer );
  SearchBuyerResponse: ( SearchBuyerConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SearchGroupsResponse: ( SearchGroupsSuccessResponse ) | ( SearchGroupsErrorResponse ) | ( AuthorizationFailure );
  SearchOrderResponse: ( SearchOrderConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SearchOrderDeskCustomerResponse: ( OrderDeskChatsConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SearchProductsResponse: ( SearchProductsConnection ) | ( SearchProductsError );
  SearchTaxonomyLabelsResponse: ( SearchTaxonomyLabelsConnection ) | ( SearchTaxonomyLabelsError );
  SendSampleSmsMessageResponse: ( SendSampleSmsMessageSuccess ) | ( SendSampleSmsMessageFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  StockCountSessionsResponse: ( AuthorizationFailure ) | ( InputValidationFailure ) | ( StockCountSessionsSuccess );
  StockCountUsersResponse: ( StockCountUsersSuccess ) | ( AuthorizationFailure );
  StorageAreasResponse: ( StorageAreasSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ItemVendor: ( ChocoVendor ) | ( BuyerExternalVendor );
  SupplierDeliveryDateSettingsResponse: ( SupplierDeliveryDateSettings ) | ( SupplierNotFound ) | ( SupplierDeliverySettingsNotFound );
  SupplierSearchResponse: ( SearchSupplierConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UserChatsResponse: ( UserChatConnection ) | ( UserChatsError );
  UserSearchResponse: ( UserSearchConnection ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ValidateProductsAvailabilityResponse: ( ValidateProductsAvailabilityResult ) | ( ChatNotFoundError ) | ( SupplierNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  VendorItemCategoriesForChatResponse: ( VendorItemCategoriesForChatSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  VendorItemsResponse: ( VendorItemsSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  VendorItemsCountForChatResponse: ( VendorItemsCountForChatSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  VendorItemsForChatResponse: ( VendorItemsForChatSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  VendorItemsForVendorResponse: ( VendorItemsForVendorResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  AcceptOrderResponse: ( Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: RefType['OrderInvoice'], orderChanges?: Maybe<RefType['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<RefType['GetOrderDeliveryCheckResponse']> } ) | ( OrderAlreadyAccepted ) | ( OrderCreatedError ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  ActivateSuppliersPaymentAccountResponse: ( SuppliersPaymentAccount ) | ( AuthorizationFailure ) | ( InputValidationFailure ) | ( PaymentAccountNotFound ) | ( ExternalAccountDetailsMissed ) | ( ExternalAccountNotFound ) | ( SupplierHasActivePaymentAccountAlready );
  AddBuyerStockInventoryProductResponse: ( AddBuyerStockInventoryProductFailure ) | ( AuthorizationFailure ) | ( BuyerStockInventoryProduct ) | ( InputValidationFailure ) | ( ProductNotFoundError ) | ( SupplierNotFound );
  AddEntitiesToGroupResponse: ( AddEntitiesToGroupResponseSuccess ) | ( AddEntitiesToGroupResponseError ) | ( AuthorizationFailure );
  AddInvoiceResponse: ( Omit<Invoice, 'currentPayment'> & { currentPayment: RefType['CurrentPaymentResponse'] } ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( ChatHasNoSupplierEntity ) | ( OrderAlreadyHasInvoice );
  AddMarketingProductsToCartResponse: ( Omit<AddMarketingProductsToCartSuccess, 'teamCartData'> & { teamCartData: RefType['AddMarketingProductsToCartTeamCartData'] } ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  AddMarketingProductsToCartTeamCartData: ( TeamCartExists ) | ( TeamCartNotFound );
  AddPaymentAccountResponse: ( Omit<PaymentAccount, 'details'> & { details: RefType['PaymentAccountDetails'] } ) | ( PaymentMethodNotAvailableForUser ) | ( SupplierPaymentAccountAlreadyExists ) | ( AuthorizationFailure ) | ( InputValidationFailure ) | ( PaymentAccountAlreadyExists );
  AddProductsToOrderGuidesResponse: ( AddProductsToOrderGuidesResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  AddSalesRepRequestToJoinResponse: ( AddSalesRepSuccess ) | ( AddSalesRepError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  BuyerAddSupplierResponse: ( BuyerAddSupplier ) | ( BuyerAddSupplierError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  AddSuppliersPaymentAccountResponse: ( SuppliersPaymentAccount ) | ( AuthorizationFailure ) | ( InputValidationFailure ) | ( SupplierNotFound ) | ( SupplierPaymentsDisabled ) | ( SupplierHasActivePaymentAccountAlready );
  AddUsersToGroupResponse: ( AddUsersToGroupResponseSuccess ) | ( AddUsersToGroupResponseError ) | ( AuthorizationFailure );
  AssignOrderToUserForReviewResponse: ( AssignOrderToUserForReviewResponseSuccess ) | ( AssignOrderToUserForReviewResponseError );
  BatchOrderConfirmResponse: ( BatchOrderConfirmSuccess ) | ( BatchOrderConfirmError );
  BulkSendInviteTransmissionResponse: ( BulkInviteTransmissionSuccess ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  BulkOrderedProductDeliveryCheckSubmissionResponse: ( BulkOrderedProductDeliveryCheckSubmissionResult ) | ( InputValidationFailure ) | ( OrderNotFound ) | ( OrderDeliveryItemsMismatched ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( AuthorizationFailure );
  BuyerDisableRolesResponse: ( Buyer ) | ( NotFoundError );
  CancelCartResponse: ( CancelCartResult ) | ( CartVersionConstraintError ) | ( CartNotFoundError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CatalogImportStartResponse: ( Omit<CatalogImportStartResult, 'job'> & { job: RefType['CatalogImportJob'] } ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ClaimOnboardingChecklistRewardResponse: ( ClaimOnboardingChecklistRewardSuccess ) | ( ClaimOnboardingChecklistRewardError ) | ( AuthorizationFailure );
  ConfirmDeliveryCheckReconciliationResponse: ( DeliveryCheckReconciliationRequest ) | ( InputValidationFailure ) | ( DeliveryCheckReconciliationRequestNotFound ) | ( DeliveryCheckReconciliationRequestAlreadyConfirmed ) | ( OrderDeliveryCheckReconciliationRequestIdNotMatched ) | ( AuthorizationFailure );
  ConnectAccountResponse: ( ConnectAccountUrl ) | ( ConnectAccountError );
  ConnectIntegrationAdapterResponse: ( IntegrationAdapterConnectionBaseResult ) | ( IntegrationAdapterConnectionAdminResult ) | ( ChocoEntityNotFound ) | ( UnsupportedIntegrationAdapterType ) | ( IntegrationAdapterNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CreateBuyerReportScheduleResponse: ( BuyerReportSchedule ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrderDeliveryCheckCreationResponse: ( OrderDeliveryCheckDetails ) | ( InputValidationFailure ) | ( OrderDeliveryCheckExists ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( OrderNotFound ) | ( AuthorizationFailure );
  OrderDeliveryCheckImageUploadUrlResponse: ( OrderDeliveryCheckImageUploadUrlResult ) | ( InputValidationFailure ) | ( OrderNotFound ) | ( OrderDeliveryCheckImageNotFound ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( AuthorizationFailure );
  CreateEmailListResponse: ( EmailListCreated ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  CreateProfileResponse: ( Omit<User, 'referral'> & { referral?: Maybe<RefType['GetReferralResponse']> } ) | ( BuyerExists ) | ( CreateProfileError );
  PushEndpointResponse: ( NotificationPreferences );
  CreateReferralResponse: ( Referral ) | ( UserHasReferralCode ) | ( ReferralCodeGenerationError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  CreateStorageItemResponse: ( CreateStorageItemSuccess ) | ( CreateStorageItemFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  createSubCatalogResponse: ( SubCatalog ) | ( CreateSubCatalogError );
  CreateSupplierContactResponse: ( SupplierContact ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  CreateUpdateSupplierProductResponse: ( Omit<Product, 'derivedPriceForOrderGuide' | 'isSelectedInOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<RefType['DerivedPriceForOrderGuideResponse']>, isSelectedInOrderGuide?: Maybe<RefType['IsSelectedInOrderGuideResponse']> } ) | ( InputValidationFailure ) | ( ProductNotFoundError ) | ( DuplicateProductError );
  DeactivateSuppliersPaymentAccountResponse: ( SuppliersPaymentAccount ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  DeleteBuyerReportScheduleResponse: ( DeleteBuyerReportScheduleSuccess ) | ( BuyerReportScheduleNotFound ) | ( DeleteBuyerReportScheduleError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  DeleteBuyerStockInventoryProductsResponse: ( DeleteBuyerStockInventoryProductsSuccess ) | ( DeleteBuyerStockInventoryProductsFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  deleteSubCatalogResponse: ( DeleteSubCatalogSuccess ) | ( DeleteSubCatalogError );
  DeletedSupplierNegotiatedPriceResponse: ( DeleteSupplierNegotiatedPriceResult ) | ( AuthorizationFailure );
  DisconnectAccountResponse: ( DisconnectAccountStatus ) | ( DisconnectAccountError );
  DisconnectIntegrationAdapterResponse: ( IntegrationAdapterConnectionBaseResult ) | ( IntegrationAdapterConnectionAdminResult ) | ( IntegrationAdapterConnectionNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  EditBuyerReportScheduleResponse: ( BuyerReportSchedule ) | ( BuyerReportScheduleNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GenerateBuyerReportResponse: ( BuyerReport ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  GetClientDebuggableArtifactUploadUrlResponse: ( GetClientDebuggableArtifactUploadUrl ) | ( GetClientDebuggableArtifactUploadUrlError );
  GetOrderGuideUploadUrlResponse: ( GetOrderGuideUploadUrl ) | ( GetOrderGuideUploadUrlError );
  InitInventoryDownloadResponse: ( InitInventoryDownloadSuccess ) | ( InitInventoryDownloadFailure ) | ( AuthorizationFailure );
  InitInventoryUploadResponse: ( InitInventoryUploadSuccess ) | ( InitInventoryUploadFailure ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  InitiateCheckoutResponse: ( BalanceCheckoutToken ) | ( SupplierPaymentAccountMissing ) | ( InvoiceAlreadyPaid ) | ( AuthorizationFailure ) | ( InputValidationFailure ) | ( InvoicePaymentInProgress ) | ( InvoiceTotalTooLow );
  IntegrationAdapterConnectionAuthResponse: ( IntegrationAdapterConnectionAuthRedirect ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterConnectionConsentResponse: ( IntegrationAdapterConnectionConsentChallenge ) | ( IntegrationAdapterConnectionConsentRedirect ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterConnectionCreateResponse: ( IntegrationAdapterConnectionAdminResult ) | ( UnsupportedIntegrationAdapterType ) | ( ChocoEntityNotFound ) | ( IntegrationAdapterNotFound ) | ( IntegrationAdapterScopeInsufficient ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterConnectionUpdateResponse: ( IntegrationAdapterConnectionAdminResult ) | ( IntegrationAdapterConnectionNotFound ) | ( IntegrationAdapterScopeInsufficient ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterCreateResponse: ( Omit<IntegrationAdapterAdminResult, 'auth'> & { auth: RefType['IntegrationAdapterAuth'] } ) | ( IntegrationAdapterExists ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationAdapterUpdateResponse: ( Omit<IntegrationAdapterAdminResult, 'auth'> & { auth: RefType['IntegrationAdapterAuth'] } ) | ( IntegrationAdapterNotFound ) | ( AttemptToChangeAdapterAuthType ) | ( AttemptToReduceIntegrationAdapterScope ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationWebhookRetryResponse: ( Omit<IntegrationWebhookRetryResults, 'results'> & { results: Array<RefType['IntegrationWebhookRetryResult']> } ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  IntegrationWebhookRetryResult: ( IntegrationWebhookRetrySuccess ) | ( IntegrationWebhookRetryFailure );
  InternalInviteUsersResponse: ( UsersList ) | ( AuthorizationFailure ) | ( ValidationError );
  inviteNonChocoUserToBuyerResponse: ( BuyerUser ) | ( BuyerNotFound ) | ( InvitorNotFound ) | ( ExistingInvitedUser ) | ( PuppyValidationFailure );
  InviteUserToBuyerResponse: ( BuyerUser ) | ( InviteUserToBuyerError ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  KycCreateResponse: ( KycResponse ) | ( KycBuyerNotFound ) | ( KycEntryAlreadyExists ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrderCreatedResponse: ( Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: RefType['OrderInvoice'], orderChanges?: Maybe<RefType['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<RefType['GetOrderDeliveryCheckResponse']> } ) | ( OrderCreatedError ) | ( AuthorizationFailure );
  OrderEditedResponse: ( Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: RefType['OrderInvoice'], orderChanges?: Maybe<RefType['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<RefType['GetOrderDeliveryCheckResponse']> } ) | ( OrderEditedError ) | ( AuthorizationFailure );
  OrderGuideCreatedResponse: ( OrderGuideCreatedSuccess ) | ( OrderGuideCreatedError );
  OrderGuideRequestResponse: ( OrderGuideRequest ) | ( OrderGuideRequestError );
  OrderGuideV2ItemUnitsAddResponse: ( OrderGuideV2ItemUnitsAddResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OrderGuideV2ItemUnitsRemoveResponse: ( OrderGuideV2ItemUnitsRemoveResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  PaymentAuthorizeResponse: ( PostProcessing ) | ( PreProcessing ) | ( NoFurtherActionNeeded ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( PaymentAccountNotFound ) | ( PaymentAccountIsInactive ) | ( UnexpectedInvoiceState ) | ( SupplierDoesNotAcceptOnlinePayments ) | ( EntityCurrencyMismatch );
  ReferUserResponse: ( ReferUserResult ) | ( ReferUserChatExists ) | ( ReferUserReferralCodeNotFound ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  OmnichannelOrdersSubcriptionResponse: ( AuthorizationFailure ) | ( OrderDeskNotification );
  RejectOrderResponse: ( OrderRejected ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  RejectOrdersByIdResponse: ( OrdersRejected ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  RemoveEmailFromBuyerReportScheduleResponse: ( EmailFromBuyerReportScheduleRemoved ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( EmailInBuyerReportScheduleNotFound ) | ( BuyerReportScheduleNotFound );
  RemoveEntitiesFromGroupResponse: ( RemoveEntitiesFromGroupResponseSuccess ) | ( RemoveEntitiesFromGroupResponseError ) | ( AuthorizationFailure );
  RemoveInvoiceResponse: ( InvoiceRemoved ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( InvoiceCannotBeRemoved );
  RemoveInvoiceAttachmentResponse: ( InvoiceAttachmentRemoved ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( InvoiceCannotBeUpdated );
  OrderDeskRemovedEmailResponse: ( OrderDeskEmailRemoved ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  RemovePaymentAccountResponse: ( PaymentAccountRemoved ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  RemoveProductsFromOrderGuidesResponse: ( RemoveProductsFromOrderGuidesResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  MinimumOrderValueUpdateResponse: ( MinimumOrderValueUpdate ) | ( MinimumOrderValueFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  RemoveUsersFromGroupResponse: ( RemoveUsersFromGroupSuccess ) | ( RemoveUsersFromGroupError ) | ( AuthorizationFailure );
  RequestToJoinBuyerResponse: ( UserRequestToJoin ) | ( RequestToJoinBuyerError ) | ( AuthorizationFailure );
  SelectProductForOrderGuideResponse: ( SelectProductForOrderGuideSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SelectProductsForOrderGuideResponse: ( SelectProductsForOrderGuideSuccess ) | ( AuthorizationFailure );
  SendInviteTransmissionResponse: ( InviteTransmission ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  SendSyntheticSmsMessageResponse: ( SendSyntheticSmsMessageSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SendSyntheticWhatsAppMessageResponse: ( SendSyntheticWhatsAppMessageSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  SetOrderAsTestResponse: ( TestOrderResponse ) | ( InputValidationFailure );
  CartSubmissionResponse: ( CartSubmissionResult ) | ( CartSubmissionError ) | ( CreateMessageError ) | ( CartNotFoundError ) | ( CartSubmittedEmptyError ) | ( CartVersionConstraintError ) | ( CartInvalidProductsError ) | ( CartAllProductsUnavailableError ) | ( AuthorizationFailure ) | ( ForbiddenError ) | ( InputValidationFailure ) | ( ExistingOrderError ) | ( ProductLeadTimeError );
  OrderDeliveryCheckSubmissionResponse: ( OrderDeliveryCheckDetails ) | ( InputValidationFailure ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( OrderNotFound ) | ( OrderDeliveryItemsMismatched ) | ( OrderDeliveryCheckNotFound ) | ( AuthorizationFailure );
  OrderedProductDeliveryCheckSubmissionResponse: ( OrderedProductDeliveryCheck ) | ( InputValidationFailure ) | ( OrderNotFound ) | ( OrderDeliveryItemsMismatched ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( AuthorizationFailure );
  SubmitStockCountSessionResponse: ( AuthorizationFailure ) | ( InputValidationFailure ) | ( SubmitStockCountSessionFailure ) | ( SubmitStockCountSessionSuccess );
  SupplierAddRequestResponse: ( SupplierAddRequest ) | ( SupplierAddRequestError );
  SupplierGetInTouchRequestResponse: ( SupplierGetInTouchRequestSuccess ) | ( SupplierGetInTouchRequestError );
  SupplierInviteResponseEntity: ( Omit<User, 'referral'> & { referral?: Maybe<RefType['GetReferralResponse']> } ) | ( Chat ) | ( InvalidInvitedPhoneNumber ) | ( SupplierInviteError );
  TriggerProductMatchingResponse: ( OmnichannelOrder ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  UnassignUserFromOrderToReviewResponse: ( UnassignUserFromOrderToReviewResponseSuccess ) | ( UnassignUserFromOrderToReviewResponseError );
  UndoMultiLocationOrderGuideTransactionResponse: ( UndoMultiLocationOrderGuideTransactionResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdateBuyerInventoryProductResponse: ( BuyerInventoryProduct ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdateBuyerStockInventoryProductResponse: ( AuthorizationFailure ) | ( BuyerStockInventoryProduct ) | ( InputValidationFailure ) | ( ProductNotFoundError ) | ( SupplierNotFound ) | ( UpdateBuyerStockInventoryProductFailure );
  CartUpdateResponse: ( Cart ) | ( CartNotFoundError ) | ( NegativeAmountError ) | ( AuthorizationFailure ) | ( InputValidationFailure );
  UpdateInventoryItemResponse: ( UpdateInventoryItemSuccess ) | ( UpdateInventoryItemFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdateInvoiceResponse: ( Omit<Invoice, 'currentPayment'> & { currentPayment: RefType['CurrentPaymentResponse'] } ) | ( InputValidationFailure ) | ( AuthorizationFailure ) | ( InvoiceCannotBeUpdated );
  UpdateInvoicedProductResponse: ( InvoicedProducts ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdatePendingUserResponse: ( Omit<User, 'referral'> & { referral?: Maybe<RefType['GetReferralResponse']> } ) | ( AuthorizationFailure );
  UpdateProductVariantsInOrderGuideResponse: ( UpdateProductVariantsInOrderGuideSuccess ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdateJoinRequestResponse: ( UpdateJoinRequestSuccess ) | ( UpdateJoinRequestError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UpdateStorageItemResponse: ( UpdateStorageItemSuccess ) | ( UpdateStorageItemFailure ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  updateSubCatalogResponse: ( SubCatalog ) | ( UpdateSubCatalogError );
  UpdateSubCatalogChatsResponse: ( UpdateSubCatalogChatsResult ) | ( AuthorizationFailure );
  EntityIdentity: ( IntegrationEntityIdentity ) | ( InternalEntityIdentity );
  SupplierUpdateAccessPackageResponse: ( SupplierUpdateAccessPackageSuccess ) | ( SupplierUpdateAccessPackageError );
  UploadSubCatalogProductsResponse: ( UploadSubCatalogProductsResult ) | ( UploadSubCatalogProductsError );
  UpsertStockCountSessionItemsResponse: ( UpsertStockCountSessionItemsSuccess ) | ( UpsertStockCountSessionItemsError ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  UserRequestToDeleteResponse: ( UserRequestToDeleteDetails ) | ( AuthorizationFailure );
  VendorItemUnitUpdateResponse: ( VendorItemUnitUpdateResult ) | ( InputValidationFailure ) | ( AuthorizationFailure );
  ActivateChatResponse: ( Chat );
  BuyerChatsResponse: ( BuyerChatConnection ) | ( InvalidCursor );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<RefType extends Record<string, unknown>> = {
  Node: ( BlockedEmail ) | ( Broadcast ) | ( Chat ) | ( Buyer ) | ( Omit<User, 'referral'> & { referral?: Maybe<RefType['GetReferralResponse']> } ) | ( Omit<Supplier, 'appliedMinimumOrderValue' | 'integration' | 'orderExportFormat' | 'orderExportUpload' | 'paymentAccounts'> & { appliedMinimumOrderValue?: Maybe<RefType['MinimumOrderValueResponse']>, integration: Array<RefType['IntegrationOption']>, orderExportFormat?: Maybe<RefType['OrderExportConfigFormat']>, orderExportUpload?: Maybe<RefType['OrderExportUploadOption']>, paymentAccounts: RefType['ListPaymentAccountsResponse'] } ) | ( Omit<PaymentAccount, 'details'> & { details: RefType['PaymentAccountDetails'] } ) | ( InviteTransmission ) | ( TransmissionEvent ) | ( Omit<Product, 'derivedPriceForOrderGuide' | 'isSelectedInOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<RefType['DerivedPriceForOrderGuideResponse']>, isSelectedInOrderGuide?: Maybe<RefType['IsSelectedInOrderGuideResponse']> } ) | ( ProductCategory ) | ( Omit<Message, 'attachment'> & { attachment?: Maybe<RefType['Attachment']> } ) | ( Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: RefType['OrderInvoice'], orderChanges?: Maybe<RefType['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<RefType['GetOrderDeliveryCheckResponse']> } ) | ( Omit<Invoice, 'currentPayment'> & { currentPayment: RefType['CurrentPaymentResponse'] } ) | ( OmnichannelOrder ) | ( OmnichannelOrderAttachment ) | ( OrderChange ) | ( OrderRestaurant ) | ( OrderGuideV2 ) | ( SubCatalog ) | ( BuyerStockCount ) | ( BuyerStockInventoryProduct ) | ( Omit<CatalogImportNode, 'job'> & { job: RefType['CatalogImportJob'] } ) | ( CategoryProducts ) | ( OrderGuideCategory ) | ( Omit<OrderGuideProductItem, 'derivedPriceForOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<RefType['DerivedPriceForOrderGuideResponse']> } ) | ( SuggestedProduct ) | ( ConnectedAccount ) | ( IntegrationAdapterConnectionBaseResult ) | ( IntegrationAdapterConnectionAdminResult ) | ( Group ) | ( GroupUser ) | ( Omit<IntegrationAdapterBaseResult, 'auth'> & { auth: RefType['IntegrationAdapterAuthBase'] } ) | ( Omit<IntegrationAdapterAdminResult, 'auth'> & { auth: RefType['IntegrationAdapterAuth'] } ) | ( UserRequestToJoin ) | ( LobbyBuyer ) | ( OrderGuideV2Category ) | ( OrderGuideV2ItemUnit ) | ( VendorItemUnit ) | ( VendorItemUnitPriceSet ) | ( VendorItem ) | ( VendorItemVariantGroup ) | ( VendorItemCategory ) | ( TaxonomyLabel ) | ( SuppliersPaymentAccount ) | ( Notification ) | ( OrderResult );
  Connection: ( BlockedEmailConnection ) | ( BuyerUserConnection ) | ( UserBuyerConnection ) | ( UserChatConnection ) | ( UserUserConnection ) | ( SupplierUserConnection ) | ( BuyerChatConnection ) | ( ChatMessageConnection ) | ( ChatUserConnection ) | ( CatalogProductsConnection ) | ( BuyerStockCountConnection ) | ( BuyerStockInventoryProductConnection ) | ( CatalogImportsResult ) | ( SuggestedProductConnection ) | ( ConnectedAccountConnection ) | ( IntegrationAdapterConnectionBaseResultConnection ) | ( IntegrationAdapterConnectionAdminResultConnection ) | ( GroupUserConnection ) | ( IntegrationAdapterBaseResultConnection ) | ( IntegrationAdapterAdminResultConnection ) | ( RequestsToJoinConnection ) | ( SubCatalogConnection ) | ( UserLobbyBuyerConnection ) | ( OrderGuideV2CategoriesResult ) | ( OrderGuideV2ItemUnitsResult ) | ( OrdersToReviewConnection ) | ( SearchBuyerConnection ) | ( GroupConnection ) | ( SearchOrderConnection ) | ( OrderDeskChatsConnection ) | ( SearchProductsConnection ) | ( SearchTaxonomyLabelsConnection ) | ( SearchSupplierConnection ) | ( UserSearchConnection ) | ( VendorItemCategoriesForChatSuccess ) | ( VendorItemsForChatSuccess ) | ( VendorItemsForVendorResult ) | ( ProductConnection );
  Edge: ( BlockedEmailEdge ) | ( BuyerUserEdge ) | ( UserBuyerEdge ) | ( UserChatEdge ) | ( UserUserEdge ) | ( SupplierUserEdge ) | ( BuyerChatEdge ) | ( ChatMessageEdge ) | ( ChatUserEdge ) | ( CatalogProductsEdge ) | ( BuyerStockCountEdge ) | ( BuyerStockInventoryProductEdge ) | ( CatalogImportsResultEdge ) | ( SuggestedProductEdge ) | ( ConnectedAccountEdge ) | ( IntegrationAdapterConnectionBaseResultEdge ) | ( IntegrationAdapterConnectionAdminResultEdge ) | ( GroupUserEdge ) | ( IntegrationAdapterBaseResultEdge ) | ( IntegrationAdapterAdminResultEdge ) | ( UserRequestToJoinEdge ) | ( SubCatalogEdge ) | ( UserLobbyBuyerEdge ) | ( OrderGuideV2CategoriesResultEdge ) | ( OrderGuideV2ItemUnitsResultEdge ) | ( OrdersToReviewEdge ) | ( BuyerEdge ) | ( GroupEdge ) | ( SearchOrderEdge ) | ( OrderDeskChatsEdge ) | ( SearchProductsEdge ) | ( SearchTaxonomyLabelsEdge ) | ( SupplierSearchEdge ) | ( UserSearchEdge ) | ( VendorItemCategoriesForChatResultEdge ) | ( VendorItemsForChatResultEdge ) | ( VendorItemsForVendorResultEdge ) | ( ProductEdge );
  AppsyncResponse: ( AuthorizationFailure ) | ( InputValidationFailure ) | ( PaymentAccountsList ) | ( NotFoundError ) | ( Omit<PaymentResponse, 'paymentAccount'> & { paymentAccount: RefType['PaymentAccountResponse'] } ) | ( PaymentAccountNotFound ) | ( InvoiceHasNoPayment ) | ( OrderHasNoInvoice ) | ( OrderHasOnlyAttachment ) | ( OrderChangeError ) | ( CreatedOrCompletedByNotFound ) | ( CatalogNotFound ) | ( BuyerStockInventoryNotFound ) | ( Omit<CatalogImportStatusResult, 'job'> & { job: RefType['CatalogImportJob'] } ) | ( CatalogImportTemplateResult ) | ( CatalogImportsResult ) | ( ChatNotFoundError ) | ( ValidationError ) | ( ChatSubCatalogProductsError ) | ( BuyerReportGenerationError ) | ( BuyerReportNotFoundError ) | ( SuggestedProductSuccessResponse ) | ( SupplierNotFound ) | ( SubCatalogNotFoundError ) | ( GroupResponseSuccess ) | ( GetGroupEntitiesSuccessResponse ) | ( GetGroupUsersSuccessResponse ) | ( InviteeNotFound ) | ( MarketingMessageSuggestionsSuccess ) | ( ReconciliationRequestPlanBySupplierIdNotFound ) | ( GetSmsMessageByMessageSidSuccess ) | ( GetSmsMessagesFromPhoneNumberSuccess ) | ( NoUnconnectedBuyers ) | ( UserIntercomCredentialsFailure ) | ( GetWhatsAppMessageByMessageSidSuccess ) | ( OrderNotFound ) | ( ListSubCatalogProductsError ) | ( LookupPhoneNumbersError ) | ( InvalidCursor ) | ( OrderGuideV2CategoriesResult ) | ( OrderGuideV2ItemUnitsResult ) | ( PublicToken ) | ( Redirect ) | ( SearchGroupsSuccessResponse ) | ( SearchProductsError ) | ( SearchTaxonomyLabelsError ) | ( SendSampleSmsMessageSuccess ) | ( SendSampleSmsMessageFailure ) | ( SupplierDeliverySettingsNotFound ) | ( UserChatsError ) | ( VendorItemCategoriesForChatSuccess ) | ( VendorItemsSuccess ) | ( VendorItemsCountForChatSuccess ) | ( VendorItemsForChatSuccess ) | ( VendorItemsForVendorResult ) | ( OrderCreatedError ) | ( ExternalAccountDetailsMissed ) | ( ExternalAccountNotFound ) | ( SupplierHasActivePaymentAccountAlready ) | ( ProductNotFoundError ) | ( AddEntitiesToGroupResponseSuccess ) | ( ChatHasNoSupplierEntity ) | ( OrderAlreadyHasInvoice ) | ( PaymentMethodNotAvailableForUser ) | ( SupplierPaymentAccountAlreadyExists ) | ( PaymentAccountAlreadyExists ) | ( AddProductsToOrderGuidesResult ) | ( AddSalesRepError ) | ( BuyerAddSupplierError ) | ( SupplierPaymentsDisabled ) | ( AddUsersToGroupResponseSuccess ) | ( AssignOrderToUserForReviewResponseError ) | ( BatchOrderConfirmSuccess ) | ( BatchOrderConfirmError ) | ( OrderDeliveryItemsMismatched ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( CartVersionConstraintError ) | ( CartNotFoundError ) | ( Omit<CatalogImportStartResult, 'job'> & { job: RefType['CatalogImportJob'] } ) | ( ClaimOnboardingChecklistRewardError ) | ( DeliveryCheckReconciliationRequestNotFound ) | ( DeliveryCheckReconciliationRequestAlreadyConfirmed ) | ( OrderDeliveryCheckReconciliationRequestIdNotMatched ) | ( ConnectAccountError ) | ( ChocoEntityNotFound ) | ( UnsupportedIntegrationAdapterType ) | ( IntegrationAdapterNotFound ) | ( OrderDeliveryCheckExists ) | ( OrderDeliveryCheckImageNotFound ) | ( CreateProfileError ) | ( UserHasReferralCode ) | ( ReferralCodeGenerationError ) | ( CreateSubCatalogError ) | ( DuplicateProductError ) | ( DeleteBuyerReportScheduleSuccess ) | ( BuyerReportScheduleNotFound ) | ( DeleteBuyerReportScheduleError ) | ( DeleteBuyerStockInventoryProductsSuccess ) | ( DeleteSubCatalogSuccess ) | ( DeleteSubCatalogError ) | ( DisconnectAccountError ) | ( IntegrationAdapterConnectionNotFound ) | ( GetClientDebuggableArtifactUploadUrlError ) | ( GetOrderGuideUploadUrlError ) | ( BalanceCheckoutToken ) | ( SupplierPaymentAccountMissing ) | ( InvoiceAlreadyPaid ) | ( InvoicePaymentInProgress ) | ( InvoiceTotalTooLow ) | ( IntegrationAdapterScopeInsufficient ) | ( IntegrationAdapterExists ) | ( AttemptToChangeAdapterAuthType ) | ( AttemptToReduceIntegrationAdapterScope ) | ( BuyerNotFound ) | ( InvitorNotFound ) | ( ExistingInvitedUser ) | ( PuppyValidationFailure ) | ( InviteUserToBuyerError ) | ( KycResponse ) | ( KycBuyerNotFound ) | ( KycEntryAlreadyExists ) | ( OrderEditedError ) | ( OrderGuideCreatedSuccess ) | ( OrderGuideCreatedError ) | ( OrderGuideRequestError ) | ( OrderGuideV2ItemUnitsAddResult ) | ( OrderGuideV2ItemUnitsRemoveResult ) | ( PostProcessing ) | ( PreProcessing ) | ( NoFurtherActionNeeded ) | ( PaymentAccountIsInactive ) | ( UnexpectedInvoiceState ) | ( SupplierDoesNotAcceptOnlinePayments ) | ( EntityCurrencyMismatch ) | ( ReferUserChatExists ) | ( ReferUserReferralCodeNotFound ) | ( EmailFromBuyerReportScheduleRemoved ) | ( EmailInBuyerReportScheduleNotFound ) | ( RemoveEntitiesFromGroupResponseSuccess ) | ( InvoiceRemoved ) | ( InvoiceCannotBeRemoved ) | ( InvoiceAttachmentRemoved ) | ( InvoiceCannotBeUpdated ) | ( PaymentAccountRemoved ) | ( RemoveProductsFromOrderGuidesResult ) | ( RemoveUsersFromGroupSuccess ) | ( RequestToJoinBuyerError ) | ( SelectProductForOrderGuideSuccess ) | ( SelectProductsForOrderGuideSuccess ) | ( SendSyntheticSmsMessageSuccess ) | ( SendSyntheticWhatsAppMessageSuccess ) | ( CartSubmissionError ) | ( CreateMessageError ) | ( CartSubmittedEmptyError ) | ( CartInvalidProductsError ) | ( CartAllProductsUnavailableError ) | ( ForbiddenError ) | ( ExistingOrderError ) | ( ProductLeadTimeError ) | ( OrderDeliveryCheckNotFound ) | ( SupplierAddRequestError ) | ( SupplierGetInTouchRequestSuccess ) | ( SupplierGetInTouchRequestError ) | ( InvalidInvitedPhoneNumber ) | ( SupplierInviteError ) | ( SupplierUserRemoveResponse ) | ( UnassignUserFromOrderToReviewResponseError ) | ( UndoMultiLocationOrderGuideTransactionResult ) | ( NegativeAmountError ) | ( InvoicedProducts ) | ( UpdateProductVariantsInOrderGuideSuccess ) | ( UpdateJoinRequestError ) | ( UpdateSubCatalogError ) | ( SupplierUpdateAccessPackageSuccess ) | ( SupplierUpdateAccessPackageError ) | ( UploadSubCatalogProductsError ) | ( VendorItemUnitUpdateResult ) | ( BuyerChatsNotFound ) | ( BuyerChatsProductListEmpty );
  AppsyncError: ( AuthorizationFailure ) | ( InputValidationFailure ) | ( NotFoundError ) | ( PaymentAccountNotFound ) | ( InvoiceHasNoPayment ) | ( OrderHasNoInvoice ) | ( OrderChangeError ) | ( CreatedOrCompletedByNotFound ) | ( CatalogNotFound ) | ( BuyerStockInventoryNotFound ) | ( ChatNotFoundError ) | ( ValidationError ) | ( ChatSubCatalogProductsError ) | ( BuyerReportGenerationError ) | ( BuyerReportNotFoundError ) | ( GetSuggestedProductsErrorResponse ) | ( SupplierNotFound ) | ( SubCatalogNotFoundError ) | ( GroupResponseError ) | ( GetGroupEntitiesErrorResponse ) | ( GetGroupUsersErrorResponse ) | ( InviteeNotFound ) | ( MarketingMessageSuggestionsError ) | ( MarketingMessageSuggestionsErrorNoSuggestions ) | ( MarketingMessageSuggestionsErrorThrottling ) | ( ReconciliationRequestPlanBySupplierIdNotFound ) | ( NoUnconnectedBuyers ) | ( UserIntercomCredentialsFailure ) | ( OrderNotFound ) | ( ListSubCatalogProductsError ) | ( LookupPhoneNumbersError ) | ( InvalidCursor ) | ( SearchGroupsErrorResponse ) | ( SearchProductsError ) | ( SearchTaxonomyLabelsError ) | ( SupplierDeliverySettingsNotFound ) | ( UserChatsError ) | ( OrderCreatedError ) | ( ExternalAccountDetailsMissed ) | ( ExternalAccountNotFound ) | ( SupplierHasActivePaymentAccountAlready ) | ( ProductNotFoundError ) | ( AddEntitiesToGroupResponseError ) | ( ChatHasNoSupplierEntity ) | ( OrderAlreadyHasInvoice ) | ( PaymentMethodNotAvailableForUser ) | ( SupplierPaymentAccountAlreadyExists ) | ( PaymentAccountAlreadyExists ) | ( AddSalesRepError ) | ( BuyerAddSupplierError ) | ( SupplierPaymentsDisabled ) | ( AddUsersToGroupResponseError ) | ( AssignOrderToUserForReviewResponseError ) | ( BatchOrderConfirmError ) | ( OrderDeliveryItemsMismatched ) | ( OrderDeliveryCheckAlreadyCompleted ) | ( CartVersionConstraintError ) | ( CartNotFoundError ) | ( ClaimOnboardingChecklistRewardError ) | ( DeliveryCheckReconciliationRequestNotFound ) | ( DeliveryCheckReconciliationRequestAlreadyConfirmed ) | ( OrderDeliveryCheckReconciliationRequestIdNotMatched ) | ( ConnectAccountError ) | ( ChocoEntityNotFound ) | ( UnsupportedIntegrationAdapterType ) | ( IntegrationAdapterNotFound ) | ( OrderDeliveryCheckExists ) | ( OrderDeliveryCheckImageNotFound ) | ( CreateProfileError ) | ( UserHasReferralCode ) | ( ReferralCodeGenerationError ) | ( CreateSubCatalogError ) | ( DuplicateProductError ) | ( BuyerReportScheduleNotFound ) | ( DeleteBuyerReportScheduleError ) | ( DeleteSubCatalogError ) | ( DisconnectAccountError ) | ( IntegrationAdapterConnectionNotFound ) | ( GetClientDebuggableArtifactUploadUrlError ) | ( GetOrderGuideUploadUrlError ) | ( SupplierPaymentAccountMissing ) | ( InvoiceAlreadyPaid ) | ( InvoicePaymentInProgress ) | ( InvoiceTotalTooLow ) | ( IntegrationAdapterScopeInsufficient ) | ( IntegrationAdapterExists ) | ( AttemptToChangeAdapterAuthType ) | ( AttemptToReduceIntegrationAdapterScope ) | ( BuyerNotFound ) | ( InvitorNotFound ) | ( ExistingInvitedUser ) | ( PuppyValidationFailure ) | ( InviteUserToBuyerError ) | ( KycBuyerNotFound ) | ( KycEntryAlreadyExists ) | ( OrderEditedError ) | ( OrderGuideCreatedError ) | ( OrderGuideRequestError ) | ( PaymentAccountIsInactive ) | ( UnexpectedInvoiceState ) | ( SupplierDoesNotAcceptOnlinePayments ) | ( EntityCurrencyMismatch ) | ( ReferUserChatExists ) | ( ReferUserReferralCodeNotFound ) | ( EmailFromBuyerReportScheduleRemoved ) | ( EmailInBuyerReportScheduleNotFound ) | ( RemoveEntitiesFromGroupResponseError ) | ( InvoiceCannotBeRemoved ) | ( InvoiceCannotBeUpdated ) | ( RemoveUsersFromGroupError ) | ( RequestToJoinBuyerError ) | ( CartSubmissionError ) | ( CreateMessageError ) | ( CartSubmittedEmptyError ) | ( CartInvalidProductsError ) | ( CartAllProductsUnavailableError ) | ( ForbiddenError ) | ( ExistingOrderError ) | ( ProductLeadTimeError ) | ( OrderDeliveryCheckNotFound ) | ( SupplierAddRequestError ) | ( SupplierGetInTouchRequestError ) | ( InvalidInvitedPhoneNumber ) | ( SupplierInviteError ) | ( UnassignUserFromOrderToReviewResponseError ) | ( NegativeAmountError ) | ( UpdateJoinRequestError ) | ( UpdateSubCatalogError ) | ( SupplierUpdateAccessPackageError ) | ( UploadSubCatalogProductsError ) | ( BuyerChatsNotFound ) | ( BuyerChatsProductListEmpty );
  RefEdge: ( OrderGuideV2Ref ) | ( OrderGuideV2CategoryRef ) | ( VendorItemUnitRef ) | ( VendorItemRef ) | ( VendorItemCategoryRef );
  Page: ( CatalogImportsResult ) | ( OrderGuideV2CategoriesResult ) | ( OrderGuideV2ItemUnitsResult ) | ( VendorItemCategoriesForChatSuccess ) | ( VendorItemsForChatSuccess ) | ( VendorItemsForVendorResult );
  GroupEntity: ( GroupEntityBuyer ) | ( GroupEntitySupplier );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  BlockedEmail: ResolverTypeWrapper<BlockedEmail>;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  BlockedEmailConnection: ResolverTypeWrapper<BlockedEmailConnection>;
  Connection: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Connection']>;
  Edge: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Edge']>;
  BlockedEmailEdge: ResolverTypeWrapper<BlockedEmailEdge>;
  Broadcast: ResolverTypeWrapper<Broadcast>;
  BroadcastAnalytics: ResolverTypeWrapper<BroadcastAnalytics>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  BroadcastMediaAttachment: ResolverTypeWrapper<BroadcastMediaAttachment>;
  BroadcastMedia: ResolverTypeWrapper<BroadcastMedia>;
  BroadcastPdfMedia: ResolverTypeWrapper<BroadcastPdfMedia>;
  Chat: ResolverTypeWrapper<Chat>;
  Buyer: ResolverTypeWrapper<Buyer>;
  AddressSource: AddressSource;
  BuyerUserConnection: ResolverTypeWrapper<BuyerUserConnection>;
  BuyerUserEdge: ResolverTypeWrapper<BuyerUserEdge>;
  User: ResolverTypeWrapper<Omit<User, 'referral'> & { referral?: Maybe<ResolversTypes['GetReferralResponse']> }>;
  UserBuyerConnection: ResolverTypeWrapper<UserBuyerConnection>;
  UserBuyerEdge: ResolverTypeWrapper<UserBuyerEdge>;
  ChatStatus: ChatStatus;
  UserChatConnection: ResolverTypeWrapper<UserChatConnection>;
  UserChatEdge: ResolverTypeWrapper<UserChatEdge>;
  UserUserConnection: ResolverTypeWrapper<UserUserConnection>;
  UserUserEdge: ResolverTypeWrapper<UserUserEdge>;
  OrderPreference: ResolverTypeWrapper<OrderPreference>;
  ProfileImage: ResolverTypeWrapper<ProfileImage>;
  Role: Role;
  Supplier: ResolverTypeWrapper<Omit<Supplier, 'appliedMinimumOrderValue' | 'integration' | 'orderExportFormat' | 'orderExportUpload' | 'paymentAccounts'> & { appliedMinimumOrderValue?: Maybe<ResolversTypes['MinimumOrderValueResponse']>, integration: Array<ResolversTypes['IntegrationOption']>, orderExportFormat?: Maybe<ResolversTypes['OrderExportConfigFormat']>, orderExportUpload?: Maybe<ResolversTypes['OrderExportUploadOption']>, paymentAccounts: ResolversTypes['ListPaymentAccountsResponse'] }>;
  AccessPackage: AccessPackage;
  MinimumOrderValueResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MinimumOrderValueResponse']>;
  MinimumOrderValue: ResolverTypeWrapper<MinimumOrderValue>;
  MinimumOrderValueType: MinimumOrderValueType;
  MinOrder: ResolverTypeWrapper<MinOrder>;
  Money: ResolverTypeWrapper<Money>;
  MinimumOrderValueFailure: ResolverTypeWrapper<MinimumOrderValueFailure>;
  ResponseType: ResponseType;
  AuthorizationFailure: ResolverTypeWrapper<AuthorizationFailure>;
  AppsyncResponse: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AppsyncResponse']>;
  AppsyncError: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AppsyncError']>;
  InputValidationFailure: ResolverTypeWrapper<InputValidationFailure>;
  FieldValidationError: ResolverTypeWrapper<FieldValidationError>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  SupplierDeliverySetting: ResolverTypeWrapper<Omit<SupplierDeliverySetting, 'exceptions'> & { exceptions?: Maybe<Array<ResolversTypes['DeliverySettingException']>> }>;
  CutOffTime: ResolverTypeWrapper<CutOffTime>;
  CutOffTimeType: CutOffTimeType;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  SupplierDeliverySettingType: SupplierDeliverySettingType;
  SupplierDeliverySettingScope: SupplierDeliverySettingScope;
  WeekdayBasedCutoffSettings: ResolverTypeWrapper<Omit<WeekdayBasedCutoffSettings, 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'> & { mon?: Maybe<ResolversTypes['CutoffSetting']>, tue?: Maybe<ResolversTypes['CutoffSetting']>, wed?: Maybe<ResolversTypes['CutoffSetting']>, thu?: Maybe<ResolversTypes['CutoffSetting']>, fri?: Maybe<ResolversTypes['CutoffSetting']>, sat?: Maybe<ResolversTypes['CutoffSetting']>, sun?: Maybe<ResolversTypes['CutoffSetting']> }>;
  CutoffSetting: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CutoffSetting']>;
  NoCutoffSetting: ResolverTypeWrapper<NoCutoffSetting>;
  NoCutoffType: NoCutoffType;
  WithCutoffSetting: ResolverTypeWrapper<WithCutoffSetting>;
  WithCutoffType: WithCutoffType;
  DeliverySettingException: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DeliverySettingException']>;
  SingleDayDeliveryExceptionWithCutoff: ResolverTypeWrapper<SingleDayDeliveryExceptionWithCutoff>;
  SingleDayDeliveryExceptionType: SingleDayDeliveryExceptionType;
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  DeliverySettingExceptionUpdateBehavior: DeliverySettingExceptionUpdateBehavior;
  SingleDayDeliveryExceptionWithoutCutoff: ResolverTypeWrapper<SingleDayDeliveryExceptionWithoutCutoff>;
  NoDeliveryException: ResolverTypeWrapper<NoDeliveryException>;
  NoDeliveryExceptionType: NoDeliveryExceptionType;
  DeliveryZone: ResolverTypeWrapper<DeliveryZone>;
  Coordinate: ResolverTypeWrapper<Coordinate>;
  IntegrationOption: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationOption']>;
  IntegrationSmsOption: ResolverTypeWrapper<IntegrationSmsOption>;
  IntegrationType: IntegrationType;
  IntegrationEmailOption: ResolverTypeWrapper<IntegrationEmailOption>;
  IntegrationFaxOption: ResolverTypeWrapper<IntegrationFaxOption>;
  IntegrationWhatsAppOption: ResolverTypeWrapper<IntegrationWhatsAppOption>;
  OrderExportConfigFormat: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderExportConfigFormat']>;
  OrderExportConfigCsvFormat: ResolverTypeWrapper<OrderExportConfigCsvFormat>;
  OrderExportConfigEdiFormat: ResolverTypeWrapper<OrderExportConfigEdiFormat>;
  OrderExportChocoEdiFormat: ResolverTypeWrapper<OrderExportChocoEdiFormat>;
  OrderExportSupplierEdiFormat: ResolverTypeWrapper<OrderExportSupplierEdiFormat>;
  OrderExportConfigLobsterFormat: ResolverTypeWrapper<OrderExportConfigLobsterFormat>;
  OrderExportUploadOption: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderExportUploadOption']>;
  OrderExportChocoSftpUpload: ResolverTypeWrapper<OrderExportChocoSftpUpload>;
  OrderExportExternalSftpUpload: ResolverTypeWrapper<OrderExportExternalSftpUpload>;
  OrderExportLobsterUpload: ResolverTypeWrapper<OrderExportLobsterUpload>;
  ListPaymentAccountsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ListPaymentAccountsResponse']>;
  PaymentAccountsList: ResolverTypeWrapper<PaymentAccountsList>;
  PaymentAccount: ResolverTypeWrapper<Omit<PaymentAccount, 'details'> & { details: ResolversTypes['PaymentAccountDetails'] }>;
  PaymentMethod: PaymentMethod;
  PaymentAccountPsp: ResolverTypeWrapper<PaymentAccountPsp>;
  PaymentAccountDetails: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PaymentAccountDetails']>;
  BankAccountDetails: ResolverTypeWrapper<BankAccountDetails>;
  CreditCardDetails: ResolverTypeWrapper<CreditCardDetails>;
  CardType: CardType;
  BalanceVendorBankDetails: ResolverTypeWrapper<BalanceVendorBankDetails>;
  BalanceBuyerBankDetails: ResolverTypeWrapper<BalanceBuyerBankDetails>;
  WalletDetails: ResolverTypeWrapper<WalletDetails>;
  PayoutDetails: ResolverTypeWrapper<PayoutDetails>;
  PriceSetting: ResolverTypeWrapper<PriceSetting>;
  SupplierUserConnection: ResolverTypeWrapper<SupplierUserConnection>;
  SupplierUserEdge: ResolverTypeWrapper<SupplierUserEdge>;
  InviteInfo: ResolverTypeWrapper<InviteInfo>;
  GetReferralResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetReferralResponse']>;
  Referral: ResolverTypeWrapper<Referral>;
  NotFoundError: ResolverTypeWrapper<NotFoundError>;
  UserCreatedContext: UserCreatedContext;
  InviteTransmission: ResolverTypeWrapper<InviteTransmission>;
  InviteChannel: InviteChannel;
  InviteStatus: InviteStatus;
  TransmissionEvent: ResolverTypeWrapper<TransmissionEvent>;
  TransmissionOfType: TransmissionOfType;
  TransmissionToType: TransmissionToType;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  UserPhoneType: UserPhoneType;
  BuyerChatConnection: ResolverTypeWrapper<BuyerChatConnection>;
  BuyerChatEdge: ResolverTypeWrapper<BuyerChatEdge>;
  Kyc: ResolverTypeWrapper<Kyc>;
  BuyerCreatedContext: BuyerCreatedContext;
  BuyerStatus: BuyerStatus;
  Cart: ResolverTypeWrapper<Cart>;
  CartLineItem: ResolverTypeWrapper<CartLineItem>;
  Product: ResolverTypeWrapper<Omit<Product, 'derivedPriceForOrderGuide' | 'isSelectedInOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<ResolversTypes['DerivedPriceForOrderGuideResponse']>, isSelectedInOrderGuide?: Maybe<ResolversTypes['IsSelectedInOrderGuideResponse']> }>;
  ProductCategory: ResolverTypeWrapper<ProductCategory>;
  ProductDeliveryDateCondition: ResolverTypeWrapper<ProductDeliveryDateCondition>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  ProductImage: ResolverTypeWrapper<ProductImage>;
  BuyerInventoryProduct: ResolverTypeWrapper<BuyerInventoryProduct>;
  SupplierNegotiatedPrice: ResolverTypeWrapper<SupplierNegotiatedPrice>;
  DerivedPriceForOrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DerivedPriceForOrderGuideResponse']>;
  DerivedPriceForOrderGuide: ResolverTypeWrapper<DerivedPriceForOrderGuide>;
  IsSelectedInOrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IsSelectedInOrderGuideResponse']>;
  IsSelectedInOrderGuide: ResolverTypeWrapper<IsSelectedInOrderGuide>;
  CartProductMetadata: ResolverTypeWrapper<CartProductMetadata>;
  ChatChurn: ResolverTypeWrapper<ChatChurn>;
  ChatChurnStatus: ChatChurnStatus;
  CreatedBy: ResolverTypeWrapper<CreatedBy>;
  CreatedContext: CreatedContext;
  SupplierDeliveryDateSettings: ResolverTypeWrapper<SupplierDeliveryDateSettings>;
  AvailableDeliveryDate: ResolverTypeWrapper<AvailableDeliveryDate>;
  MessageGroupFilter: MessageGroupFilter;
  ChatMessageConnection: ResolverTypeWrapper<ChatMessageConnection>;
  ChatMessageEdge: ResolverTypeWrapper<ChatMessageEdge>;
  Message: ResolverTypeWrapper<Omit<Message, 'attachment'> & { attachment?: Maybe<ResolversTypes['Attachment']> }>;
  Order: ResolverTypeWrapper<Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: ResolversTypes['OrderInvoice'], orderChanges?: Maybe<ResolversTypes['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<ResolversTypes['GetOrderDeliveryCheckResponse']> }>;
  ConfirmationSource: ConfirmationSource;
  OrderInvoice: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderInvoice']>;
  Invoice: ResolverTypeWrapper<Omit<Invoice, 'currentPayment'> & { currentPayment: ResolversTypes['CurrentPaymentResponse'] }>;
  InvoiceFileUrls: ResolverTypeWrapper<InvoiceFileUrls>;
  InvoiceAttachment: ResolverTypeWrapper<InvoiceAttachment>;
  AttachmentStatus: AttachmentStatus;
  AttachmentState: AttachmentState;
  CurrentPaymentResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CurrentPaymentResponse']>;
  PaymentResponse: ResolverTypeWrapper<Omit<PaymentResponse, 'paymentAccount'> & { paymentAccount: ResolversTypes['PaymentAccountResponse'] }>;
  PaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PaymentAccountResponse']>;
  SecuredPaymentAccount: ResolverTypeWrapper<Omit<SecuredPaymentAccount, 'details'> & { details: ResolversTypes['PaymentAccountDetails'] }>;
  PaymentAccountNotFound: ResolverTypeWrapper<PaymentAccountNotFound>;
  InvoiceHasNoPayment: ResolverTypeWrapper<InvoiceHasNoPayment>;
  OrderHasNoInvoice: ResolverTypeWrapper<OrderHasNoInvoice>;
  OrderHasOnlyAttachment: ResolverTypeWrapper<OrderHasOnlyAttachment>;
  InvoicedProduct: ResolverTypeWrapper<InvoicedProduct>;
  OmnichannelOrder: ResolverTypeWrapper<OmnichannelOrder>;
  OmnichannelOrderStatus: OmnichannelOrderStatus;
  ParsedOrder: ResolverTypeWrapper<ParsedOrder>;
  ReviewReason: ReviewReason;
  OmnichannelProduct: ResolverTypeWrapper<OmnichannelProduct>;
  OmnichannelOrderProduct: ResolverTypeWrapper<OmnichannelOrderProduct>;
  OmnichannelOrderAttachment: ResolverTypeWrapper<OmnichannelOrderAttachment>;
  AudioTranscript: ResolverTypeWrapper<AudioTranscript>;
  Word: ResolverTypeWrapper<Word>;
  StartOffSet: ResolverTypeWrapper<StartOffSet>;
  OrderDeskReviewer: ResolverTypeWrapper<OrderDeskReviewer>;
  OrderChangeResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderChangeResponse']>;
  OrderChange: ResolverTypeWrapper<OrderChange>;
  OrderChangeData: ResolverTypeWrapper<OrderChangeData>;
  OrderProduct: ResolverTypeWrapper<OrderProduct>;
  NoOrderChange: ResolverTypeWrapper<NoOrderChange>;
  OrderChangeReverted: ResolverTypeWrapper<OrderChangeReverted>;
  OrderChangeError: ResolverTypeWrapper<OrderChangeError>;
  GetOrderDeliveryCheckResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetOrderDeliveryCheckResponse']>;
  OrderDeliveryCheckDetails: ResolverTypeWrapper<OrderDeliveryCheckDetails>;
  OrderDeliveryCheckStatus: OrderDeliveryCheckStatus;
  OrderedProductDeliveryCheck: ResolverTypeWrapper<OrderedProductDeliveryCheck>;
  OrderDeliveryCheckImage: ResolverTypeWrapper<OrderDeliveryCheckImage>;
  OrderDeliveryCheckImageUploadStatus: OrderDeliveryCheckImageUploadStatus;
  OrderedProductMetadata: ResolverTypeWrapper<OrderedProductMetadata>;
  DeliveryCheckProblem: ResolverTypeWrapper<DeliveryCheckProblem>;
  OrderedProductDeliveryCheckProblemType: OrderedProductDeliveryCheckProblemType;
  DeliveryCheckReconciliationRequest: ResolverTypeWrapper<DeliveryCheckReconciliationRequest>;
  DeliveryCheckReconciliationRequestType: DeliveryCheckReconciliationRequestType;
  DeliveryCheckReconciliationRequestStatus: DeliveryCheckReconciliationRequestStatus;
  DeliveryCheckReconciliationRequestStatusHistory: ResolverTypeWrapper<DeliveryCheckReconciliationRequestStatusHistory>;
  CreatedOrCompletedByNotFound: ResolverTypeWrapper<CreatedOrCompletedByNotFound>;
  OrderedProduct: ResolverTypeWrapper<OrderedProduct>;
  OrderRestaurant: ResolverTypeWrapper<OrderRestaurant>;
  OrderStatus: OrderStatus;
  Attachment: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Attachment']>;
  Event: ResolverTypeWrapper<Omit<Event, 'chatEventType' | 'target'> & { chatEventType: ResolversTypes['ChatEventTypes'], target?: Maybe<Array<Maybe<ResolversTypes['EventTarget']>>> }>;
  EventType: EventType;
  ChatEventTypes: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ChatEventTypes']>;
  RequestedChatCreated: ResolverTypeWrapper<RequestedChatCreated>;
  RequestedChatActivated: ResolverTypeWrapper<RequestedChatActivated>;
  UserAddedToChat: ResolverTypeWrapper<UserAddedToChat>;
  ChatNameUpdated: ResolverTypeWrapper<ChatNameUpdated>;
  UserRemovedFromChat: ResolverTypeWrapper<UserRemovedFromChat>;
  ChatCreated: ResolverTypeWrapper<ChatCreated>;
  CartOpened: ResolverTypeWrapper<CartOpened>;
  EventUser: ResolverTypeWrapper<EventUser>;
  CartUpdated: ResolverTypeWrapper<CartUpdated>;
  CartSubmitted: ResolverTypeWrapper<CartSubmitted>;
  CartCanceled: ResolverTypeWrapper<CartCanceled>;
  OrderEdited: ResolverTypeWrapper<OrderEdited>;
  OrderGuideRequested: ResolverTypeWrapper<OrderGuideRequested>;
  OrderGuideCreated: ResolverTypeWrapper<OrderGuideCreated>;
  ReconciliationRequestConfirmed: ResolverTypeWrapper<ReconciliationRequestConfirmed>;
  EventTarget: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['EventTarget']>;
  EventChat: ResolverTypeWrapper<EventChat>;
  EventOrder: ResolverTypeWrapper<EventOrder>;
  EventDeliveryCheckReconciliationRequest: ResolverTypeWrapper<EventDeliveryCheckReconciliationRequest>;
  Media: ResolverTypeWrapper<Media>;
  BroadcastAttachment: ResolverTypeWrapper<BroadcastAttachment>;
  OrderGuideV2Ref: ResolverTypeWrapper<OrderGuideV2Ref>;
  RefEdge: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RefEdge']>;
  OrderGuideV2: ResolverTypeWrapper<OrderGuideV2>;
  SubCatalog: ResolverTypeWrapper<SubCatalog>;
  ChatType: ChatType;
  ChatUserConnection: ResolverTypeWrapper<ChatUserConnection>;
  ChatUserEdge: ResolverTypeWrapper<ChatUserEdge>;
  Sort: Sort;
  SortOrder: SortOrder;
  BroadcastCustomerPerformanceFilterInput: BroadcastCustomerPerformanceFilterInput;
  PaginationInput: PaginationInput;
  BroadcastCustomerPerformanceResult: ResolverTypeWrapper<BroadcastCustomerPerformanceResult>;
  BroadcastCustomerPerformance: ResolverTypeWrapper<BroadcastCustomerPerformance>;
  BroadCastEndsAt: ResolverTypeWrapper<BroadCastEndsAt>;
  BroadcastProductPerformanceResult: ResolverTypeWrapper<BroadcastProductPerformanceResult>;
  BroadcastProductPerformance: ResolverTypeWrapper<BroadcastProductPerformance>;
  OneTimeBroadcastSchedule: ResolverTypeWrapper<OneTimeBroadcastSchedule>;
  BroadcastScheduleType: BroadcastScheduleType;
  BroadcastStatus: BroadcastStatus;
  BrowseCatalogInput: BrowseCatalogInput;
  BrowseCatalogFilterInput: BrowseCatalogFilterInput;
  BrowseCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BrowseCatalogResponse']>;
  CatalogProductsConnection: ResolverTypeWrapper<CatalogProductsConnection>;
  CatalogProductsEdge: ResolverTypeWrapper<CatalogProductsEdge>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  BrowseCatalogForChatInput: BrowseCatalogForChatInput;
  BrowseCatalogForChatFilterInput: BrowseCatalogForChatFilterInput;
  BrowseCatalogForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BrowseCatalogForChatResponse']>;
  CatalogNotFound: ResolverTypeWrapper<CatalogNotFound>;
  BuyerFacetsResponse: ResolverTypeWrapper<BuyerFacetsResponse>;
  CityWithOffsets: ResolverTypeWrapper<CityWithOffsets>;
  GetBuyerStockCountInput: GetBuyerStockCountInput;
  BuyerStockCountStatus: BuyerStockCountStatus;
  BuyerStockCountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerStockCountResponse']>;
  BuyerStockCountSuccess: ResolverTypeWrapper<BuyerStockCountSuccess>;
  BuyerStockCountProduct: ResolverTypeWrapper<BuyerStockCountProduct>;
  BuyerStockCountFailure: ResolverTypeWrapper<BuyerStockCountFailure>;
  GetBuyerStockCountsInput: GetBuyerStockCountsInput;
  GetBuyerStockCountFilterInput: GetBuyerStockCountFilterInput;
  BuyerStockCountsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerStockCountsResponse']>;
  BuyerStockCountsSuccess: ResolverTypeWrapper<BuyerStockCountsSuccess>;
  BuyerStockCountConnection: ResolverTypeWrapper<BuyerStockCountConnection>;
  BuyerStockCountEdge: ResolverTypeWrapper<BuyerStockCountEdge>;
  BuyerStockCount: ResolverTypeWrapper<BuyerStockCount>;
  BuyerStockCountsFailure: ResolverTypeWrapper<BuyerStockCountsFailure>;
  GetBuyerStockInventoryProductsFilterInput: GetBuyerStockInventoryProductsFilterInput;
  BuyerStockInventoryResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerStockInventoryResponse']>;
  BuyerStockInventory: ResolverTypeWrapper<BuyerStockInventory>;
  BuyerStockInventoryGenerationStatus: BuyerStockInventoryGenerationStatus;
  BuyerStockInventoryProductConnection: ResolverTypeWrapper<BuyerStockInventoryProductConnection>;
  BuyerStockInventoryProductEdge: ResolverTypeWrapper<BuyerStockInventoryProductEdge>;
  BuyerStockInventoryProduct: ResolverTypeWrapper<BuyerStockInventoryProduct>;
  BuyerStockInventoryProductType: BuyerStockInventoryProductType;
  BuyerStockInventoryNotFound: ResolverTypeWrapper<BuyerStockInventoryNotFound>;
  BuyerStockInventoryFailure: ResolverTypeWrapper<BuyerStockInventoryFailure>;
  GetBuyerStockInventoryExportUrlInput: GetBuyerStockInventoryExportUrlInput;
  BuyerStockInventoryExportUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerStockInventoryExportUrlResponse']>;
  BuyerStockInventoryExportUrlSuccess: ResolverTypeWrapper<BuyerStockInventoryExportUrlSuccess>;
  BuyerStockInventoryExportUrlFailure: ResolverTypeWrapper<BuyerStockInventoryExportUrlFailure>;
  BuyerUser: ResolverTypeWrapper<BuyerUser>;
  CartResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CartResponse']>;
  CatalogImportStatusResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CatalogImportStatusResponse']>;
  CatalogImportStatusResult: ResolverTypeWrapper<Omit<CatalogImportStatusResult, 'job'> & { job: ResolversTypes['CatalogImportJob'] }>;
  CatalogImportJob: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CatalogImportJob']>;
  JobWaitingForInput: ResolverTypeWrapper<JobWaitingForInput>;
  JobInProgress: ResolverTypeWrapper<JobInProgress>;
  JobFailed: ResolverTypeWrapper<JobFailed>;
  JobFailure: ResolverTypeWrapper<JobFailure>;
  CatalogImportJobSucceeded: ResolverTypeWrapper<CatalogImportJobSucceeded>;
  CatalogImportJobResponse: ResolverTypeWrapper<CatalogImportJobResponse>;
  CatalogImportTemplateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CatalogImportTemplateResponse']>;
  CatalogImportTemplateResult: ResolverTypeWrapper<CatalogImportTemplateResult>;
  CatalogImportsInput: CatalogImportsInput;
  CatalogImportsFilter: CatalogImportsFilter;
  JobStatus: JobStatus;
  PaginationInputV2: PaginationInputV2;
  PaginationDirection: PaginationDirection;
  CatalogImportsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CatalogImportsResponse']>;
  CatalogImportsResult: ResolverTypeWrapper<CatalogImportsResult>;
  Page: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Page']>;
  CatalogImportsResultEdge: ResolverTypeWrapper<CatalogImportsResultEdge>;
  CatalogImportNode: ResolverTypeWrapper<Omit<CatalogImportNode, 'job'> & { job: ResolversTypes['CatalogImportJob'] }>;
  CategoryProducts: ResolverTypeWrapper<CategoryProducts>;
  ChatHasSupplierEmailSupportResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ChatHasSupplierEmailSupportResponse']>;
  ChatHasSupplierEmailSupportResult: ResolverTypeWrapper<ChatHasSupplierEmailSupportResult>;
  ChatNotFoundError: ResolverTypeWrapper<ChatNotFoundError>;
  ChatNotificationPreferences: ResolverTypeWrapper<ChatNotificationPreferences>;
  ChatNotificationUserLists: ResolverTypeWrapper<ChatNotificationUserLists>;
  ChatSubCatalogProductsInput: ChatSubCatalogProductsInput;
  ProductFilter: ProductFilter;
  ChatSubCatalogProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ChatSubCatalogProductsResponse']>;
  ValidationError: ResolverTypeWrapper<ValidationError>;
  ChatSubCatalogProductsError: ResolverTypeWrapper<ChatSubCatalogProductsError>;
  ProductSearchResult: ResolverTypeWrapper<ProductSearchResult>;
  ChatUser: ResolverTypeWrapper<ChatUser>;
  FetchBuyerReportDownloadUrlInput: FetchBuyerReportDownloadUrlInput;
  FetchBuyerReportDownloadUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FetchBuyerReportDownloadUrlResponse']>;
  BuyerReport: ResolverTypeWrapper<BuyerReport>;
  BuyerReportType: BuyerReportType;
  BuyerReportUploadStatus: BuyerReportUploadStatus;
  BuyerReportGenerationError: ResolverTypeWrapper<BuyerReportGenerationError>;
  BuyerReportNotFoundError: ResolverTypeWrapper<BuyerReportNotFoundError>;
  CatalogCategory: ResolverTypeWrapper<CatalogCategory>;
  FetchCatalogCategoriesForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FetchCatalogCategoriesForChatResponse']>;
  CatalogCategoriesResponse: ResolverTypeWrapper<CatalogCategoriesResponse>;
  OrderGuideProductArgs: OrderGuideProductArgs;
  OrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideResponse']>;
  OrderGuide: ResolverTypeWrapper<OrderGuide>;
  OrderGuideCategory: ResolverTypeWrapper<OrderGuideCategory>;
  OrderGuideProduct: ResolverTypeWrapper<OrderGuideProduct>;
  OrderGuideProductItem: ResolverTypeWrapper<Omit<OrderGuideProductItem, 'derivedPriceForOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<ResolversTypes['DerivedPriceForOrderGuideResponse']> }>;
  OrderGuideFailure: ResolverTypeWrapper<OrderGuideFailure>;
  EmbedDashboardUrlResponse: ResolverTypeWrapper<EmbedDashboardUrlResponse>;
  GetAllBuyerReportSchedulesInput: GetAllBuyerReportSchedulesInput;
  GetAllBuyerReportSchedulesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetAllBuyerReportSchedulesResponse']>;
  BuyerReportSchedules: ResolverTypeWrapper<BuyerReportSchedules>;
  BuyerReportSchedule: ResolverTypeWrapper<BuyerReportSchedule>;
  ScheduledBuyerReportFrequency: ScheduledBuyerReportFrequency;
  ScheduledBuyerReportTimeframeType: ScheduledBuyerReportTimeframeType;
  AppliedChatDeliverySettingResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AppliedChatDeliverySettingResponse']>;
  AppliedChatDeliverySetting: ResolverTypeWrapper<Omit<AppliedChatDeliverySetting, 'exceptions'> & { exceptions?: Maybe<Array<ResolversTypes['DeliverySettingException']>> }>;
  SuggestedProductResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SuggestedProductResult']>;
  SuggestedProductSuccessResponse: ResolverTypeWrapper<SuggestedProductSuccessResponse>;
  SuggestedProductConnection: ResolverTypeWrapper<SuggestedProductConnection>;
  SuggestedProductEdge: ResolverTypeWrapper<SuggestedProductEdge>;
  SuggestedProduct: ResolverTypeWrapper<SuggestedProduct>;
  GetSuggestedProductsErrorResponse: ResolverTypeWrapper<GetSuggestedProductsErrorResponse>;
  GetCatalogUploadUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetCatalogUploadUrlResponse']>;
  SupplierNotFound: ResolverTypeWrapper<SupplierNotFound>;
  GetCatalogUploadUrlResult: ResolverTypeWrapper<GetCatalogUploadUrlResult>;
  GetChatCountByCCEmailResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetChatCountByCCEmailResponse']>;
  GetChatCountByCCEmailReport: ResolverTypeWrapper<GetChatCountByCcEmailReport>;
  GetChatSuppliersByLocationsInput: GetChatSuppliersByLocationsInput;
  GetChatSuppliersByLocationsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetChatSuppliersByLocationsResponse']>;
  ChatSuppliersByLocations: ResolverTypeWrapper<ChatSuppliersByLocations>;
  SupplierDetails: ResolverTypeWrapper<SupplierDetails>;
  GetChatsForSubCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetChatsForSubCatalogResponse']>;
  GetChatsForSubCatalogResult: ResolverTypeWrapper<GetChatsForSubCatalogResult>;
  SubCatalogNotFoundError: ResolverTypeWrapper<SubCatalogNotFoundError>;
  ConnectedAccountInput: ConnectedAccountInput;
  GetConnectedAccountsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetConnectedAccountsResponse']>;
  ConnectedAccountConnection: ResolverTypeWrapper<ConnectedAccountConnection>;
  ConnectedAccountEdge: ResolverTypeWrapper<ConnectedAccountEdge>;
  ConnectedAccount: ResolverTypeWrapper<ConnectedAccount>;
  GetConnectedIntegrationAdaptersInput: GetConnectedIntegrationAdaptersInput;
  ChocoEntityType: ChocoEntityType;
  GetConnectedIntegrationAdaptersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetConnectedIntegrationAdaptersResponse']>;
  IntegrationAdapterConnectionBaseResultConnection: ResolverTypeWrapper<IntegrationAdapterConnectionBaseResultConnection>;
  IntegrationAdapterConnectionBaseResultEdge: ResolverTypeWrapper<IntegrationAdapterConnectionBaseResultEdge>;
  IntegrationAdapterConnectionBaseResult: ResolverTypeWrapper<IntegrationAdapterConnectionBaseResult>;
  IntegrationAdapterConnectionStatus: IntegrationAdapterConnectionStatus;
  ActionExportMethod: ActionExportMethod;
  IntegrationAdapterConnectionAdminResultConnection: ResolverTypeWrapper<IntegrationAdapterConnectionAdminResultConnection>;
  IntegrationAdapterConnectionAdminResultEdge: ResolverTypeWrapper<IntegrationAdapterConnectionAdminResultEdge>;
  IntegrationAdapterConnectionAdminResult: ResolverTypeWrapper<IntegrationAdapterConnectionAdminResult>;
  IntegrationAdapterConnectionWebhook: ResolverTypeWrapper<IntegrationAdapterConnectionWebhook>;
  GetEmailListsInput: GetEmailListsInput;
  OrderDestEmailListType: OrderDestEmailListType;
  GetEmailListsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetEmailListsResponse']>;
  EmailLists: ResolverTypeWrapper<EmailLists>;
  EmailList: ResolverTypeWrapper<EmailList>;
  GetFeatureFlagsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetFeatureFlagsResponse']>;
  FeatureFlags: ResolverTypeWrapper<FeatureFlags>;
  FeatureFlag: ResolverTypeWrapper<FeatureFlag>;
  GroupResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GroupResponse']>;
  GroupResponseSuccess: ResolverTypeWrapper<GroupResponseSuccess>;
  Group: ResolverTypeWrapper<Group>;
  GroupCreatedContext: GroupCreatedContext;
  GroupCreatedBy: ResolverTypeWrapper<GroupCreatedBy>;
  GroupResponseError: ResolverTypeWrapper<GroupResponseError>;
  GetGroupEntitiesInput: GetGroupEntitiesInput;
  GetGroupEntitiesFilterInput: GetGroupEntitiesFilterInput;
  GroupEntityType: GroupEntityType;
  GetGroupEntitiesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetGroupEntitiesResponse']>;
  GetGroupEntitiesSuccessResponse: ResolverTypeWrapper<GetGroupEntitiesSuccessResponse>;
  GroupEntityConnection: ResolverTypeWrapper<GroupEntityConnection>;
  GroupEntityEdge: ResolverTypeWrapper<Omit<GroupEntityEdge, 'node'> & { node: ResolversTypes['GroupEntityNode'] }>;
  GroupEntityNode: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GroupEntityNode']>;
  GroupEntityBuyer: ResolverTypeWrapper<GroupEntityBuyer>;
  GroupEntity: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['GroupEntity']>;
  GroupEntitySupplier: ResolverTypeWrapper<GroupEntitySupplier>;
  GetGroupEntitiesErrorResponse: ResolverTypeWrapper<GetGroupEntitiesErrorResponse>;
  GetGroupEntitiesErrorCode: GetGroupEntitiesErrorCode;
  GetGroupUsersInput: GetGroupUsersInput;
  GetGroupUsersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetGroupUsersResponse']>;
  GetGroupUsersSuccessResponse: ResolverTypeWrapper<GetGroupUsersSuccessResponse>;
  GroupUserConnection: ResolverTypeWrapper<GroupUserConnection>;
  GroupUserEdge: ResolverTypeWrapper<GroupUserEdge>;
  GroupUser: ResolverTypeWrapper<GroupUser>;
  GroupUserRole: GroupUserRole;
  GetGroupUsersErrorResponse: ResolverTypeWrapper<GetGroupUsersErrorResponse>;
  GetIntegrationAdaptersInput: GetIntegrationAdaptersInput;
  IntegrationAdapterType: IntegrationAdapterType;
  GetIntegrationAdaptersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetIntegrationAdaptersResponse']>;
  IntegrationAdapterBaseResultConnection: ResolverTypeWrapper<IntegrationAdapterBaseResultConnection>;
  IntegrationAdapterBaseResultEdge: ResolverTypeWrapper<IntegrationAdapterBaseResultEdge>;
  IntegrationAdapterBaseResult: ResolverTypeWrapper<Omit<IntegrationAdapterBaseResult, 'auth'> & { auth: ResolversTypes['IntegrationAdapterAuthBase'] }>;
  IntegrationAdapterAuthBase: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterAuthBase']>;
  IntegrationAdapterAuthorizationCodeAuthBase: ResolverTypeWrapper<IntegrationAdapterAuthorizationCodeAuthBase>;
  IntegrationAdapterAuthenticationType: IntegrationAdapterAuthenticationType;
  IntegrationAdapterClientCredentialsAuthBase: ResolverTypeWrapper<IntegrationAdapterClientCredentialsAuthBase>;
  IntegrationAdapterAPIKeyAuthBase: ResolverTypeWrapper<IntegrationAdapterApiKeyAuthBase>;
  IntegrationAdapterAdminResultConnection: ResolverTypeWrapper<IntegrationAdapterAdminResultConnection>;
  IntegrationAdapterAdminResultEdge: ResolverTypeWrapper<IntegrationAdapterAdminResultEdge>;
  IntegrationAdapterAdminResult: ResolverTypeWrapper<Omit<IntegrationAdapterAdminResult, 'auth'> & { auth: ResolversTypes['IntegrationAdapterAuth'] }>;
  IntegrationAdapterAuth: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterAuth']>;
  IntegrationAdapterAuthorizationCodeAuth: ResolverTypeWrapper<IntegrationAdapterAuthorizationCodeAuth>;
  IntegrationAdapterClientCredentialsAuth: ResolverTypeWrapper<IntegrationAdapterClientCredentialsAuth>;
  IntegrationAdapterAPIKeyAuth: ResolverTypeWrapper<IntegrationAdapterApiKeyAuth>;
  IntegrationAdapterWebhook: ResolverTypeWrapper<Omit<IntegrationAdapterWebhook, 'auth'> & { auth: ResolversTypes['IntegrationAdapterWebhookAuth'] }>;
  IntegrationAdapterWebhookAuth: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterWebhookAuth']>;
  IntegrationAdapterWebhookBasicAuth: ResolverTypeWrapper<IntegrationAdapterWebhookBasicAuth>;
  WebhookAuthenticationType: WebhookAuthenticationType;
  IntegrationAdapterWebhookSignatureAuth: ResolverTypeWrapper<IntegrationAdapterWebhookSignatureAuth>;
  GetInviteTransmissionStatus: GetInviteTransmissionStatus;
  GetInviteTransmissionStatusResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetInviteTransmissionStatusResponse']>;
  InviteTransmissionStatus: ResolverTypeWrapper<InviteTransmissionStatus>;
  GetInviteeBuyersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetInviteeBuyersResponse']>;
  InviteeNotFound: ResolverTypeWrapper<InviteeNotFound>;
  InviteeBuyers: ResolverTypeWrapper<InviteeBuyers>;
  MessagesFromChatResult: ResolverTypeWrapper<MessagesFromChatResult>;
  MessageStatus: MessageStatus;
  MessageType: MessageType;
  MessageEvent: ResolverTypeWrapper<Omit<MessageEvent, 'target'> & { target?: Maybe<Array<Maybe<ResolversTypes['EventTarget']>>> }>;
  LocationsBySupplierResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LocationsBySupplierResponse']>;
  LocationsBySupplierSuccess: ResolverTypeWrapper<LocationsBySupplierSuccess>;
  LocationBySupplier: ResolverTypeWrapper<LocationBySupplier>;
  MarketingMessageSuggestionsResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MarketingMessageSuggestionsResult']>;
  MarketingMessageSuggestionsSuccess: ResolverTypeWrapper<MarketingMessageSuggestionsSuccess>;
  MarketingMessageRefinementTip: ResolverTypeWrapper<MarketingMessageRefinementTip>;
  MarketingMessageSuggestionsError: ResolverTypeWrapper<MarketingMessageSuggestionsError>;
  MarketingMessageSuggestionsErrorNoSuggestions: ResolverTypeWrapper<MarketingMessageSuggestionsErrorNoSuggestions>;
  MarketingMessageSuggestionsErrorThrottling: ResolverTypeWrapper<MarketingMessageSuggestionsErrorThrottling>;
  GetOmniChannelOrderInput: GetOmniChannelOrderInput;
  GetOmniChannelOrderResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetOmniChannelOrderResponse']>;
  GetOnboardingChecklistResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetOnboardingChecklistResponse']>;
  OnboardingChecklist: ResolverTypeWrapper<OnboardingChecklist>;
  OnboardingChecklistItem: ResolverTypeWrapper<Omit<OnboardingChecklistItem, 'value'> & { value: ResolversTypes['OnboardingChecklistItemValue'] }>;
  OnboardingChecklistItemValue: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OnboardingChecklistItemValue']>;
  OnboardingChecklistBooleanValue: ResolverTypeWrapper<OnboardingChecklistBooleanValue>;
  OnboardingChecklistNumericValue: ResolverTypeWrapper<OnboardingChecklistNumericValue>;
  GetProductsForChatInput: GetProductsForChatInput;
  GetProductsForChatFilter: GetProductsForChatFilter;
  GetProductsForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetProductsForChatResponse']>;
  GetProductsForChatResult: ResolverTypeWrapper<GetProductsForChatResult>;
  InvalidProduct: ResolverTypeWrapper<InvalidProduct>;
  GetQboCustomersAndOrderGuidesToImportResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetQboCustomersAndOrderGuidesToImportResponse']>;
  QboCustomersAndOrderGuidesToImport: ResolverTypeWrapper<QboCustomersAndOrderGuidesToImport>;
  GetReconciliationRequestPlanBySupplierIdResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetReconciliationRequestPlanBySupplierIdResponse']>;
  ReconciliationRequestPlan: ResolverTypeWrapper<ReconciliationRequestPlan>;
  ReconciliationRequestPlanType: ReconciliationRequestPlanType;
  ReconciliationRequestPlanBySupplierIdNotFound: ResolverTypeWrapper<ReconciliationRequestPlanBySupplierIdNotFound>;
  GetReferralInput: GetReferralInput;
  GetRequestsToJoinInput: GetRequestsToJoinInput;
  GetRequestsToJoinFilter: GetRequestsToJoinFilter;
  JoinRequestStatus: JoinRequestStatus;
  GetRequestsToJoinResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetRequestsToJoinResponse']>;
  RequestsToJoinConnection: ResolverTypeWrapper<RequestsToJoinConnection>;
  UserRequestToJoinEdge: ResolverTypeWrapper<UserRequestToJoinEdge>;
  UserRequestToJoin: ResolverTypeWrapper<UserRequestToJoin>;
  UserRequestToJoinType: UserRequestToJoinType;
  SalesRepDetails: ResolverTypeWrapper<SalesRepDetails>;
  AddSalesRepOrderPref: AddSalesRepOrderPref;
  GetSmsMessageByMessageSidResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSmsMessageByMessageSidResponse']>;
  GetSmsMessageByMessageSidSuccess: ResolverTypeWrapper<GetSmsMessageByMessageSidSuccess>;
  SmsMessage: ResolverTypeWrapper<SmsMessage>;
  SmsMessageMedia: ResolverTypeWrapper<SmsMessageMedia>;
  GetSmsMessagesFromPhoneNumberResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSmsMessagesFromPhoneNumberResponse']>;
  GetSmsMessagesFromPhoneNumberSuccess: ResolverTypeWrapper<GetSmsMessagesFromPhoneNumberSuccess>;
  GetSubCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSubCatalogResponse']>;
  GetSubCatalogsForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSubCatalogsForChatResponse']>;
  GetSubCatalogsForChatResult: ResolverTypeWrapper<GetSubCatalogsForChatResult>;
  GetSupplierApplicationsInput: GetSupplierApplicationsInput;
  GetSupplierApplicationsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSupplierApplicationsResponse']>;
  SupplierApplications: ResolverTypeWrapper<SupplierApplications>;
  ApplicationData: ResolverTypeWrapper<Omit<ApplicationData, 'data'> & { data?: Maybe<ResolversTypes['CredentialsData']> }>;
  CredentialsData: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CredentialsData']>;
  QbdCredentials: ResolverTypeWrapper<QbdCredentials>;
  GetSupplierProductsInput: GetSupplierProductsInput;
  GetSupplierProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetSupplierProductsResponse']>;
  GetSupplierProductsResult: ResolverTypeWrapper<GetSupplierProductsResult>;
  GetUnconnectedBuyerIdsResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetUnconnectedBuyerIdsResult']>;
  UnconnectedBuyers: ResolverTypeWrapper<UnconnectedBuyers>;
  NoUnconnectedBuyers: ResolverTypeWrapper<NoUnconnectedBuyers>;
  UserIntercomCredentialsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UserIntercomCredentialsResponse']>;
  UserIntercomCredentialsSuccess: ResolverTypeWrapper<UserIntercomCredentialsSuccess>;
  UserIntercomCredentialsFailure: ResolverTypeWrapper<UserIntercomCredentialsFailure>;
  GetWhatsAppMessageByMessageSidResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetWhatsAppMessageByMessageSidResponse']>;
  GetWhatsAppMessageByMessageSidSuccess: ResolverTypeWrapper<GetWhatsAppMessageByMessageSidSuccess>;
  WhatsAppMessage: ResolverTypeWrapper<WhatsAppMessage>;
  WhatsAppMessageMedia: ResolverTypeWrapper<WhatsAppMessageMedia>;
  HasUserCompletedDeliveryCheckResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['HasUserCompletedDeliveryCheckResponse']>;
  HasCompletedDeliveryCheckResult: ResolverTypeWrapper<HasCompletedDeliveryCheckResult>;
  OrderNotFound: ResolverTypeWrapper<OrderNotFound>;
  InventoryDownloadJobsInput: InventoryDownloadJobsInput;
  InventoryDownloadJobsFilter: InventoryDownloadJobsFilter;
  InventoryDownloadJobStatus: InventoryDownloadJobStatus;
  InventoryDownloadJobsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InventoryDownloadJobsResponse']>;
  InventoryDownloadJobsSuccess: ResolverTypeWrapper<InventoryDownloadJobsSuccess>;
  InventoryDownloadJob: ResolverTypeWrapper<Omit<InventoryDownloadJob, 'report'> & { report?: Maybe<ResolversTypes['InventoryDownloadJobReport']> }>;
  InventoryDownloadJobReport: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InventoryDownloadJobReport']>;
  InventoryDownloadJobCompleted: ResolverTypeWrapper<InventoryDownloadJobCompleted>;
  InventoryDownloadJobFailed: ResolverTypeWrapper<InventoryDownloadJobFailed>;
  InventoryDownloadJobsFailure: ResolverTypeWrapper<InventoryDownloadJobsFailure>;
  InventorySuppliersInput: InventorySuppliersInput;
  InventorySuppliersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InventorySuppliersResponse']>;
  InventorySuppliersSuccess: ResolverTypeWrapper<InventorySuppliersSuccess>;
  InventorySupplier: ResolverTypeWrapper<InventorySupplier>;
  InventorySuppliersFailure: ResolverTypeWrapper<InventorySuppliersFailure>;
  InventoryUploadJobInput: InventoryUploadJobInput;
  InventoryUploadJobResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InventoryUploadJobResponse']>;
  InventoryUploadJobSuccess: ResolverTypeWrapper<InventoryUploadJobSuccess>;
  InventoryUploadJobStatus: InventoryUploadJobStatus;
  InventoryUploadJobFailure: ResolverTypeWrapper<InventoryUploadJobFailure>;
  InventoryUploadTemplateInput: InventoryUploadTemplateInput;
  InventoryUploadTemplateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InventoryUploadTemplateResponse']>;
  InventoryUploadTemplateResponseSuccess: ResolverTypeWrapper<InventoryUploadTemplateResponseSuccess>;
  InventoryUploadTemplateResponseFailure: ResolverTypeWrapper<InventoryUploadTemplateResponseFailure>;
  PaymentAccountOwnerInput: PaymentAccountOwnerInput;
  ListSubCatalogProductsInput: ListSubCatalogProductsInput;
  ListSubCatalogProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ListSubCatalogProductsResponse']>;
  ListSubCatalogProductsError: ResolverTypeWrapper<ListSubCatalogProductsError>;
  ListSubCatalogsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ListSubCatalogsResponse']>;
  SubCatalogConnection: ResolverTypeWrapper<SubCatalogConnection>;
  SubCatalogEdge: ResolverTypeWrapper<SubCatalogEdge>;
  LookupPhoneNumbersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LookupPhoneNumbersResponse']>;
  LookupPhoneNumbersSuccess: ResolverTypeWrapper<Omit<LookupPhoneNumbersSuccess, 'lookups'> & { lookups: Array<ResolversTypes['PhoneNumberLookup']> }>;
  PhoneNumberLookup: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PhoneNumberLookup']>;
  PhoneNumberLookupSuccess: ResolverTypeWrapper<PhoneNumberLookupSuccess>;
  PhoneNumberLineType: PhoneNumberLineType;
  PhoneNumberLookupError: ResolverTypeWrapper<PhoneNumberLookupError>;
  PhoneNumberLookupErrorCode: PhoneNumberLookupErrorCode;
  LookupPhoneNumbersError: ResolverTypeWrapper<LookupPhoneNumbersError>;
  LookupPhoneNumbersErrorCode: LookupPhoneNumbersErrorCode;
  MetaLobbyResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MetaLobbyResponse']>;
  MetaLobbyResult: ResolverTypeWrapper<MetaLobbyResult>;
  UserLobbyBuyerConnection: ResolverTypeWrapper<UserLobbyBuyerConnection>;
  UserLobbyBuyerEdge: ResolverTypeWrapper<UserLobbyBuyerEdge>;
  LobbyBuyer: ResolverTypeWrapper<LobbyBuyer>;
  InvalidCursor: ResolverTypeWrapper<InvalidCursor>;
  OrderGuideV2CategoriesInput: OrderGuideV2CategoriesInput;
  OrderGuideV2CategoriesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideV2CategoriesResponse']>;
  OrderGuideV2CategoriesResult: ResolverTypeWrapper<OrderGuideV2CategoriesResult>;
  OrderGuideV2CategoriesResultEdge: ResolverTypeWrapper<OrderGuideV2CategoriesResultEdge>;
  OrderGuideV2Category: ResolverTypeWrapper<OrderGuideV2Category>;
  OrderGuideV2ItemUnitsInput: OrderGuideV2ItemUnitsInput;
  OrderGuideV2ItemUnitsFilter: OrderGuideV2ItemUnitsFilter;
  OrderGuideV2ItemUnitsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideV2ItemUnitsResponse']>;
  OrderGuideV2ItemUnitsResult: ResolverTypeWrapper<OrderGuideV2ItemUnitsResult>;
  OrderGuideV2ItemUnitsResultEdge: ResolverTypeWrapper<OrderGuideV2ItemUnitsResultEdge>;
  OrderGuideV2ItemUnit: ResolverTypeWrapper<OrderGuideV2ItemUnit>;
  OrderGuideV2CategoryRef: ResolverTypeWrapper<OrderGuideV2CategoryRef>;
  VendorItemUnitRef: ResolverTypeWrapper<VendorItemUnitRef>;
  VendorItemUnit: ResolverTypeWrapper<VendorItemUnit>;
  VendorItemUnitAvailabilityStatus: VendorItemUnitAvailabilityStatus;
  Rational: ResolverTypeWrapper<Rational>;
  VendorItemUnitImage: ResolverTypeWrapper<VendorItemUnitImage>;
  ImageAsset: ResolverTypeWrapper<ImageAsset>;
  ImageAssetUrl: ResolverTypeWrapper<ImageAssetUrl>;
  VendorItemUnitPriceInput: VendorItemUnitPriceInput;
  VendorItemUnitPriceSet: ResolverTypeWrapper<VendorItemUnitPriceSet>;
  MoneyV2: ResolverTypeWrapper<MoneyV2>;
  VendorItemUnitStockStatus: VendorItemUnitStockStatus;
  VendorItemRef: ResolverTypeWrapper<VendorItemRef>;
  VendorItem: ResolverTypeWrapper<VendorItem>;
  VendorItemVariantGroup: ResolverTypeWrapper<VendorItemVariantGroup>;
  VendorItemUnitsFilter: VendorItemUnitsFilter;
  VendorItemCategory: ResolverTypeWrapper<VendorItemCategory>;
  VendorItemCategoryRef: ResolverTypeWrapper<VendorItemCategoryRef>;
  VendorItemCategoryImage: ResolverTypeWrapper<VendorItemCategoryImage>;
  OrdersToReviewInput: OrdersToReviewInput;
  OrdersToReviewResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrdersToReviewResponse']>;
  OrdersToReviewConnection: ResolverTypeWrapper<OrdersToReviewConnection>;
  OrdersToReviewEdge: ResolverTypeWrapper<OrdersToReviewEdge>;
  PaymentOptionsInput: PaymentOptionsInput;
  PaymentOptionsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PaymentOptionsResponse']>;
  PublicToken: ResolverTypeWrapper<PublicToken>;
  Redirect: ResolverTypeWrapper<Redirect>;
  SearchInput: SearchInput;
  SearchEntityType: SearchEntityType;
  SearchFilter: SearchFilter;
  UserFilter: UserFilter;
  ChatFilter: ChatFilter;
  BroadcastFilter: BroadcastFilter;
  OrderFilter: OrderFilter;
  BuyerFilter: BuyerFilter;
  SupplierFilter: SupplierFilter;
  CoordinateInput: CoordinateInput;
  SearchResult: ResolverTypeWrapper<SearchResult>;
  SearchItem: ResolverTypeWrapper<Omit<SearchItem, 'entity'> & { entity?: Maybe<ResolversTypes['SearchEntity']> }>;
  SearchEntity: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchEntity']>;
  SearchBuyerInput: SearchBuyerInput;
  SearchBuyerFilter: SearchBuyerFilter;
  GooglePlaceEstablishment: GooglePlaceEstablishment;
  SearchBuyerFilterV2: SearchBuyerFilterV2;
  SearchBuyerResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchBuyerResponse']>;
  SearchBuyerConnection: ResolverTypeWrapper<SearchBuyerConnection>;
  BuyerEdge: ResolverTypeWrapper<BuyerEdge>;
  SearchGroupsInput: SearchGroupsInput;
  SearchGroupsFilterInput: SearchGroupsFilterInput;
  SearchGroupsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchGroupsResponse']>;
  SearchGroupsSuccessResponse: ResolverTypeWrapper<SearchGroupsSuccessResponse>;
  GroupConnection: ResolverTypeWrapper<GroupConnection>;
  GroupEdge: ResolverTypeWrapper<GroupEdge>;
  SearchGroupsErrorResponse: ResolverTypeWrapper<SearchGroupsErrorResponse>;
  SearchGroupsErrorCode: SearchGroupsErrorCode;
  SearchOrderInput: SearchOrderInput;
  SearchOrderResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchOrderResponse']>;
  SearchOrderConnection: ResolverTypeWrapper<SearchOrderConnection>;
  SearchOrderEdge: ResolverTypeWrapper<SearchOrderEdge>;
  SearchOrderDeskCustomerInput: SearchOrderDeskCustomerInput;
  SearchOrderDeskCustomerResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchOrderDeskCustomerResponse']>;
  OrderDeskChatsConnection: ResolverTypeWrapper<OrderDeskChatsConnection>;
  OrderDeskChatsEdge: ResolverTypeWrapper<OrderDeskChatsEdge>;
  SearchProductsInput: SearchProductsInput;
  SearchProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchProductsResponse']>;
  SearchProductsConnection: ResolverTypeWrapper<SearchProductsConnection>;
  SearchProductsEdge: ResolverTypeWrapper<SearchProductsEdge>;
  SearchProductsError: ResolverTypeWrapper<SearchProductsError>;
  SearchTaxonomyLabelsInput: SearchTaxonomyLabelsInput;
  SearchTaxonomyLabelsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SearchTaxonomyLabelsResponse']>;
  SearchTaxonomyLabelsConnection: ResolverTypeWrapper<SearchTaxonomyLabelsConnection>;
  SearchTaxonomyLabelsEdge: ResolverTypeWrapper<SearchTaxonomyLabelsEdge>;
  TaxonomyLabel: ResolverTypeWrapper<TaxonomyLabel>;
  SearchTaxonomyLabelsError: ResolverTypeWrapper<SearchTaxonomyLabelsError>;
  SendSampleSmsMessageInput: SendSampleSmsMessageInput;
  SendSampleSmsMessageMediaInput: SendSampleSmsMessageMediaInput;
  SendSampleSmsMessageResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SendSampleSmsMessageResponse']>;
  SendSampleSmsMessageSuccess: ResolverTypeWrapper<SendSampleSmsMessageSuccess>;
  SendSampleSmsMessageFailure: ResolverTypeWrapper<SendSampleSmsMessageFailure>;
  SharedBroadcastProducts: ResolverTypeWrapper<SharedBroadcastProducts>;
  StockCountSessionsInput: StockCountSessionsInput;
  StockCountSessionsFilter: StockCountSessionsFilter;
  StockCountSessionEnum: StockCountSessionEnum;
  StockCountSessionsPaginationInput: StockCountSessionsPaginationInput;
  StockCountSessionsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['StockCountSessionsResponse']>;
  StockCountSessionsSuccess: ResolverTypeWrapper<StockCountSessionsSuccess>;
  StockCountSession: ResolverTypeWrapper<StockCountSession>;
  CountDetails: ResolverTypeWrapper<CountDetails>;
  StockItemPrice: ResolverTypeWrapper<StockItemPrice>;
  StockItem: ResolverTypeWrapper<StockItem>;
  StockCountSessionsPaginationInfo: ResolverTypeWrapper<StockCountSessionsPaginationInfo>;
  StockCountUsersInput: StockCountUsersInput;
  StockCountUsersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['StockCountUsersResponse']>;
  StockCountUsersSuccess: ResolverTypeWrapper<StockCountUsersSuccess>;
  StockCountUser: ResolverTypeWrapper<StockCountUser>;
  StorageAreasInput: StorageAreasInput;
  StorageAreasResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['StorageAreasResponse']>;
  StorageAreasSuccess: ResolverTypeWrapper<StorageAreasSuccess>;
  StorageArea: ResolverTypeWrapper<StorageArea>;
  StorageAreaStorageItemsInput: StorageAreaStorageItemsInput;
  StorageItemsFilter: StorageItemsFilter;
  StorageItem: ResolverTypeWrapper<StorageItem>;
  InventoryItem: ResolverTypeWrapper<Omit<InventoryItem, 'vendor'> & { vendor?: Maybe<ResolversTypes['ItemVendor']> }>;
  ItemVendor: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ItemVendor']>;
  ChocoVendor: ResolverTypeWrapper<ChocoVendor>;
  BuyerExternalVendor: ResolverTypeWrapper<BuyerExternalVendor>;
  ItemPrice: ResolverTypeWrapper<ItemPrice>;
  ItemUnit: ResolverTypeWrapper<ItemUnit>;
  StorageItemCount: ResolverTypeWrapper<StorageItemCount>;
  supplierAssortments: ResolverTypeWrapper<SupplierAssortments>;
  ChatLabelsResult: ResolverTypeWrapper<ChatLabelsResult>;
  SupplierDeliveryDateSettingsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierDeliveryDateSettingsResponse']>;
  SupplierDeliverySettingsNotFound: ResolverTypeWrapper<SupplierDeliverySettingsNotFound>;
  SupplierSearchInput: SupplierSearchInput;
  SupplierSearchFilter: SupplierSearchFilter;
  SupplierSearchResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierSearchResponse']>;
  SearchSupplierConnection: ResolverTypeWrapper<SearchSupplierConnection>;
  SupplierSearchEdge: ResolverTypeWrapper<SupplierSearchEdge>;
  SupplierSearchV2Filter: SupplierSearchV2Filter;
  UserChatsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UserChatsResponse']>;
  UserChatsError: ResolverTypeWrapper<UserChatsError>;
  UserSearchInput: UserSearchInput;
  UserSearchFilter: UserSearchFilter;
  UserSearchResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UserSearchResponse']>;
  UserSearchConnection: ResolverTypeWrapper<UserSearchConnection>;
  UserSearchEdge: ResolverTypeWrapper<UserSearchEdge>;
  ValidateProductsAvailabilityInput: ValidateProductsAvailabilityInput;
  ValidateProductsAvailabilityResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ValidateProductsAvailabilityResponse']>;
  ValidateProductsAvailabilityResult: ResolverTypeWrapper<ValidateProductsAvailabilityResult>;
  VendorItemCategoriesForChatInput: VendorItemCategoriesForChatInput;
  VendorItemCategoriesForChatFilter: VendorItemCategoriesForChatFilter;
  VendorItemCategoriesForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemCategoriesForChatResponse']>;
  VendorItemCategoriesForChatSuccess: ResolverTypeWrapper<VendorItemCategoriesForChatSuccess>;
  VendorItemCategoriesForChatResultEdge: ResolverTypeWrapper<VendorItemCategoriesForChatResultEdge>;
  VendorItemsInput: VendorItemsInput;
  VendorItemsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemsResponse']>;
  VendorItemsSuccess: ResolverTypeWrapper<VendorItemsSuccess>;
  VendorItemsCountForChatInput: VendorItemsCountForChatInput;
  VendorItemsCountForChatFilter: VendorItemsCountForChatFilter;
  VendorItemsCountForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemsCountForChatResponse']>;
  VendorItemsCountForChatSuccess: ResolverTypeWrapper<VendorItemsCountForChatSuccess>;
  VendorItemsForChatInput: VendorItemsForChatInput;
  VendorItemsForChatFilterInput: VendorItemsForChatFilterInput;
  VendorItemsForChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemsForChatResponse']>;
  VendorItemsForChatSuccess: ResolverTypeWrapper<VendorItemsForChatSuccess>;
  VendorItemsForChatResultEdge: ResolverTypeWrapper<VendorItemsForChatResultEdge>;
  VendorItemsForVendorInput: VendorItemsForVendorInput;
  VendorItemsForVendorFilter: VendorItemsForVendorFilter;
  VendorItemsForVendorSort: VendorItemsForVendorSort;
  VendorItemsForVendorSortField: VendorItemsForVendorSortField;
  VendorItemsForVendorResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemsForVendorResponse']>;
  VendorItemsForVendorResult: ResolverTypeWrapper<VendorItemsForVendorResult>;
  VendorItemsForVendorResultEdge: ResolverTypeWrapper<VendorItemsForVendorResultEdge>;
  Mutation: ResolverTypeWrapper<{}>;
  AcceptOrderInput: AcceptOrderInput;
  OrderedProductInput: OrderedProductInput;
  AcceptedProductInput: AcceptedProductInput;
  AcceptOrderResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AcceptOrderResponse']>;
  OrderAlreadyAccepted: ResolverTypeWrapper<OrderAlreadyAccepted>;
  OrderCreatedError: ResolverTypeWrapper<OrderCreatedError>;
  UnavailableProductType: ResolverTypeWrapper<UnavailableProductType>;
  ActivateSuppliersPaymentAccountInput: ActivateSuppliersPaymentAccountInput;
  ActivateSuppliersPaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ActivateSuppliersPaymentAccountResponse']>;
  SuppliersPaymentAccount: ResolverTypeWrapper<SuppliersPaymentAccount>;
  ExternalAccountDetailsMissed: ResolverTypeWrapper<ExternalAccountDetailsMissed>;
  ExternalAccountNotFound: ResolverTypeWrapper<ExternalAccountNotFound>;
  SupplierHasActivePaymentAccountAlready: ResolverTypeWrapper<SupplierHasActivePaymentAccountAlready>;
  AddBuyerStockInventoryProductInput: AddBuyerStockInventoryProductInput;
  MoneyInput: MoneyInput;
  AddBuyerStockInventoryProductResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddBuyerStockInventoryProductResponse']>;
  AddBuyerStockInventoryProductFailure: ResolverTypeWrapper<AddBuyerStockInventoryProductFailure>;
  ProductNotFoundError: ResolverTypeWrapper<ProductNotFoundError>;
  ProductsCategoryInput: ProductsCategoryInput;
  AddEntitiesToGroupInput: AddEntitiesToGroupInput;
  GroupEntityInput: GroupEntityInput;
  AddEntitiesToGroupResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddEntitiesToGroupResponse']>;
  AddEntitiesToGroupResponseSuccess: ResolverTypeWrapper<AddEntitiesToGroupResponseSuccess>;
  AddEntitiesToGroupResponseError: ResolverTypeWrapper<AddEntitiesToGroupResponseError>;
  AddEntitiesToGroupErrorCode: AddEntitiesToGroupErrorCode;
  AddInvoiceInput: AddInvoiceInput;
  AddInvoiceResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddInvoiceResponse']>;
  ChatHasNoSupplierEntity: ResolverTypeWrapper<ChatHasNoSupplierEntity>;
  OrderAlreadyHasInvoice: ResolverTypeWrapper<OrderAlreadyHasInvoice>;
  AddMarketingProductsToCartInput: AddMarketingProductsToCartInput;
  AddMarketingProductsToCartResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddMarketingProductsToCartResponse']>;
  AddMarketingProductsToCartSuccess: ResolverTypeWrapper<Omit<AddMarketingProductsToCartSuccess, 'teamCartData'> & { teamCartData: ResolversTypes['AddMarketingProductsToCartTeamCartData'] }>;
  AddMarketingProductsToCartTeamCartData: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddMarketingProductsToCartTeamCartData']>;
  TeamCartExists: ResolverTypeWrapper<TeamCartExists>;
  TeamCartNotFound: ResolverTypeWrapper<TeamCartNotFound>;
  PaymentAccountInput: PaymentAccountInput;
  CreditCardDetailsInput: CreditCardDetailsInput;
  CreditCardNetwork: CreditCardNetwork;
  BankAccountDetailsInput: BankAccountDetailsInput;
  AddPaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddPaymentAccountResponse']>;
  PaymentMethodNotAvailableForUser: ResolverTypeWrapper<PaymentMethodNotAvailableForUser>;
  PaymentAccountOwnerType: PaymentAccountOwnerType;
  SupplierPaymentAccountAlreadyExists: ResolverTypeWrapper<SupplierPaymentAccountAlreadyExists>;
  PaymentAccountAlreadyExists: ResolverTypeWrapper<PaymentAccountAlreadyExists>;
  AddProductsToOrderGuidesInput: AddProductsToOrderGuidesInput;
  AddProductToOrderGuidesInput: AddProductToOrderGuidesInput;
  AddProductsToOrderGuidesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddProductsToOrderGuidesResponse']>;
  AddProductsToOrderGuidesResult: ResolverTypeWrapper<AddProductsToOrderGuidesResult>;
  LocationProductsResult: ResolverTypeWrapper<LocationProductsResult>;
  LocationProductResult: ResolverTypeWrapper<LocationProductResult>;
  AddSalesRepRequestToJoinInput: AddSalesRepRequestToJoinInput;
  AddSalesRepDetailsInput: AddSalesRepDetailsInput;
  AddSalesRepRequestToJoinResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddSalesRepRequestToJoinResponse']>;
  AddSalesRepSuccess: ResolverTypeWrapper<AddSalesRepSuccess>;
  AddSalesRepError: ResolverTypeWrapper<AddSalesRepError>;
  AddSalesRepErrorCode: AddSalesRepErrorCode;
  BuyerAddSupplierInput: BuyerAddSupplierInput;
  BuyerAddSupplierRequestType: BuyerAddSupplierRequestType;
  BuyerAddSupplierResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerAddSupplierResponse']>;
  BuyerAddSupplier: ResolverTypeWrapper<BuyerAddSupplier>;
  BuyerAddSupplierError: ResolverTypeWrapper<BuyerAddSupplierError>;
  BuyerAddSupplierErrorCode: BuyerAddSupplierErrorCode;
  AddSuppliersPaymentAccountInput: AddSuppliersPaymentAccountInput;
  AddSuppliersPaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddSuppliersPaymentAccountResponse']>;
  SupplierPaymentsDisabled: ResolverTypeWrapper<SupplierPaymentsDisabled>;
  AddUsersToGroupInput: AddUsersToGroupInput;
  GroupUserInput: GroupUserInput;
  AddUsersToGroupResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AddUsersToGroupResponse']>;
  AddUsersToGroupResponseSuccess: ResolverTypeWrapper<AddUsersToGroupResponseSuccess>;
  AddUsersToGroupResponseError: ResolverTypeWrapper<AddUsersToGroupResponseError>;
  AssignOrderToUserForReviewInput: AssignOrderToUserForReviewInput;
  AssignOrderToUserForReviewResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AssignOrderToUserForReviewResponse']>;
  AssignOrderToUserForReviewResponseSuccess: ResolverTypeWrapper<AssignOrderToUserForReviewResponseSuccess>;
  AssignOrderToUserForReviewResponseError: ResolverTypeWrapper<AssignOrderToUserForReviewResponseError>;
  BatchOrderConfirmResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BatchOrderConfirmResponse']>;
  BatchOrderConfirmSuccess: ResolverTypeWrapper<BatchOrderConfirmSuccess>;
  BatchOrderConfirmError: ResolverTypeWrapper<BatchOrderConfirmError>;
  BatchUpdateOrderSupplierInput: BatchUpdateOrderSupplierInput;
  BatchUpdateOrderSupplier: ResolverTypeWrapper<BatchUpdateOrderSupplier>;
  BroadcastInput: BroadcastInput;
  OneTimeBroadcastScheduleInput: OneTimeBroadcastScheduleInput;
  BroadcastPurposeInput: BroadcastPurposeInput;
  PredefinedBroadcastPurpose: PredefinedBroadcastPurpose;
  BroadcastUpdatePurposeResult: ResolverTypeWrapper<BroadcastUpdatePurposeResult>;
  BulkSendInviteTransmissionInput: BulkSendInviteTransmissionInput;
  BulkSendInviteInvitee: BulkSendInviteInvitee;
  BulkSendInviteTransmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BulkSendInviteTransmissionResponse']>;
  BulkInviteTransmissionSuccess: ResolverTypeWrapper<BulkInviteTransmissionSuccess>;
  BulkInviteTransmissionFailure: ResolverTypeWrapper<BulkInviteTransmissionFailure>;
  BulkSubmitOrderedProductDeliveryCheckInput: BulkSubmitOrderedProductDeliveryCheckInput;
  DeliveryCheckProductInput: DeliveryCheckProductInput;
  DeliveryCheckProblemInput: DeliveryCheckProblemInput;
  OrderedProductMetadataInput: OrderedProductMetadataInput;
  BulkOrderedProductDeliveryCheckSubmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BulkOrderedProductDeliveryCheckSubmissionResponse']>;
  BulkOrderedProductDeliveryCheckSubmissionResult: ResolverTypeWrapper<BulkOrderedProductDeliveryCheckSubmissionResult>;
  OrderDeliveryItemsMismatched: ResolverTypeWrapper<OrderDeliveryItemsMismatched>;
  OrderDeliveryCheckAlreadyCompleted: ResolverTypeWrapper<OrderDeliveryCheckAlreadyCompleted>;
  BuyerUserInput: BuyerUserInput;
  BuyerUserRoleInput: BuyerUserRoleInput;
  BuyerCreateInput: BuyerCreateInput;
  BuyerDisableRolesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerDisableRolesResponse']>;
  BuyerUpdateInput: BuyerUpdateInput;
  CancelCartOptionsInput: CancelCartOptionsInput;
  CancelCartResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CancelCartResponse']>;
  CancelCartResult: ResolverTypeWrapper<CancelCartResult>;
  CartVersionConstraintError: ResolverTypeWrapper<CartVersionConstraintError>;
  UserCartItemOperation: ResolverTypeWrapper<UserCartItemOperation>;
  UserCartAction: UserCartAction;
  CartNotFoundError: ResolverTypeWrapper<CartNotFoundError>;
  CatalogImportStartInput: CatalogImportStartInput;
  CatalogImportMode: CatalogImportMode;
  CatalogImportStartResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CatalogImportStartResponse']>;
  CatalogImportStartResult: ResolverTypeWrapper<Omit<CatalogImportStartResult, 'job'> & { job: ResolversTypes['CatalogImportJob'] }>;
  CategoryInput: CategoryInput;
  ChatCreateInput: ChatCreateInput;
  AdminProductInput: AdminProductInput;
  ChatUpdateInput: ChatUpdateInput;
  ChatUpdateCreatedByInput: ChatUpdateCreatedByInput;
  ClaimOnboardingChecklistRewardResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ClaimOnboardingChecklistRewardResponse']>;
  ClaimOnboardingChecklistRewardSuccess: ResolverTypeWrapper<ClaimOnboardingChecklistRewardSuccess>;
  ClaimOnboardingChecklistRewardError: ResolverTypeWrapper<ClaimOnboardingChecklistRewardError>;
  ClaimOnboardingChecklistRewardErrorCode: ClaimOnboardingChecklistRewardErrorCode;
  ConfirmDeliveryCheckReconciliationResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ConfirmDeliveryCheckReconciliationResponse']>;
  DeliveryCheckReconciliationRequestNotFound: ResolverTypeWrapper<DeliveryCheckReconciliationRequestNotFound>;
  DeliveryCheckReconciliationRequestAlreadyConfirmed: ResolverTypeWrapper<DeliveryCheckReconciliationRequestAlreadyConfirmed>;
  OrderDeliveryCheckReconciliationRequestIdNotMatched: ResolverTypeWrapper<OrderDeliveryCheckReconciliationRequestIdNotMatched>;
  ConnectAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ConnectAccountResponse']>;
  ConnectAccountUrl: ResolverTypeWrapper<ConnectAccountUrl>;
  ConnectAccountError: ResolverTypeWrapper<ConnectAccountError>;
  ConnectIntegrationAdapterInput: ConnectIntegrationAdapterInput;
  ConnectIntegrationAdapterResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ConnectIntegrationAdapterResponse']>;
  ChocoEntityNotFound: ResolverTypeWrapper<ChocoEntityNotFound>;
  UnsupportedIntegrationAdapterType: ResolverTypeWrapper<UnsupportedIntegrationAdapterType>;
  IntegrationAdapterNotFound: ResolverTypeWrapper<IntegrationAdapterNotFound>;
  CreateBuyerReportScheduleInput: CreateBuyerReportScheduleInput;
  CreateBuyerReportScheduleResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateBuyerReportScheduleResponse']>;
  CreateGroupInput: CreateGroupInput;
  CreateOrderDeliveryCheckInput: CreateOrderDeliveryCheckInput;
  OrderDeliveryCheckCreationResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderDeliveryCheckCreationResponse']>;
  OrderDeliveryCheckExists: ResolverTypeWrapper<OrderDeliveryCheckExists>;
  OrderDeliveryCheckImageUploadUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderDeliveryCheckImageUploadUrlResponse']>;
  OrderDeliveryCheckImageUploadUrlResult: ResolverTypeWrapper<OrderDeliveryCheckImageUploadUrlResult>;
  OrderDeliveryCheckImageNotFound: ResolverTypeWrapper<OrderDeliveryCheckImageNotFound>;
  CreateOrderDeskEmailList: CreateOrderDeskEmailList;
  OrderDeskEmail: OrderDeskEmail;
  CreateEmailListResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateEmailListResponse']>;
  EmailListCreated: ResolverTypeWrapper<EmailListCreated>;
  CreateProfileInput: CreateProfileInput;
  CreateProfileResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateProfileResponse']>;
  BuyerExists: ResolverTypeWrapper<BuyerExists>;
  CreateProfileError: ResolverTypeWrapper<CreateProfileError>;
  CreatePushEndpointInput: CreatePushEndpointInput;
  PushNotificationPlatform: PushNotificationPlatform;
  PushEndpointResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PushEndpointResponse']>;
  NotificationPreferences: ResolverTypeWrapper<NotificationPreferences>;
  CreateReferralInput: CreateReferralInput;
  CreateReferralResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateReferralResponse']>;
  UserHasReferralCode: ResolverTypeWrapper<UserHasReferralCode>;
  ReferralCodeGenerationError: ResolverTypeWrapper<ReferralCodeGenerationError>;
  CreateStorageItemInput: CreateStorageItemInput;
  CreateStorageItemResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateStorageItemResponse']>;
  CreateStorageItemSuccess: ResolverTypeWrapper<CreateStorageItemSuccess>;
  CreateStorageItemFailure: ResolverTypeWrapper<CreateStorageItemFailure>;
  createSubCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['createSubCatalogResponse']>;
  CreateSubCatalogError: ResolverTypeWrapper<CreateSubCatalogError>;
  CreateSupplierContactInput: CreateSupplierContactInput;
  CreateSupplierContactResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateSupplierContactResponse']>;
  SupplierContact: ResolverTypeWrapper<SupplierContact>;
  ProductInput: ProductInput;
  CreateUpdateSupplierProductResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CreateUpdateSupplierProductResponse']>;
  DuplicateProductError: ResolverTypeWrapper<DuplicateProductError>;
  SupplierProductInput: SupplierProductInput;
  DeactivateSuppliersPaymentAccountInput: DeactivateSuppliersPaymentAccountInput;
  DeactivateSuppliersPaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DeactivateSuppliersPaymentAccountResponse']>;
  DeleteBuyerReportScheduleResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DeleteBuyerReportScheduleResponse']>;
  DeleteBuyerReportScheduleSuccess: ResolverTypeWrapper<DeleteBuyerReportScheduleSuccess>;
  BuyerReportScheduleNotFound: ResolverTypeWrapper<BuyerReportScheduleNotFound>;
  DeleteBuyerReportScheduleError: ResolverTypeWrapper<DeleteBuyerReportScheduleError>;
  DeleteBuyerStockInventoryProductsInput: DeleteBuyerStockInventoryProductsInput;
  DeleteBuyerStockInventoryProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DeleteBuyerStockInventoryProductsResponse']>;
  DeleteBuyerStockInventoryProductsSuccess: ResolverTypeWrapper<DeleteBuyerStockInventoryProductsSuccess>;
  DeleteBuyerStockInventoryProductsFailure: ResolverTypeWrapper<DeleteBuyerStockInventoryProductsFailure>;
  DeletedChatSetting: ResolverTypeWrapper<DeletedChatSetting>;
  DeleteProductImageInput: DeleteProductImageInput;
  deleteSubCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['deleteSubCatalogResponse']>;
  DeleteSubCatalogSuccess: ResolverTypeWrapper<DeleteSubCatalogSuccess>;
  DeleteSubCatalogError: ResolverTypeWrapper<DeleteSubCatalogError>;
  DeletedSupplierNegotiatedPriceResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DeletedSupplierNegotiatedPriceResponse']>;
  DeleteSupplierNegotiatedPriceResult: ResolverTypeWrapper<DeleteSupplierNegotiatedPriceResult>;
  DisconnectAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DisconnectAccountResponse']>;
  DisconnectAccountStatus: ResolverTypeWrapper<DisconnectAccountStatus>;
  DisconnectAccountError: ResolverTypeWrapper<DisconnectAccountError>;
  DisconnectIntegrationAdapterInput: DisconnectIntegrationAdapterInput;
  DisconnectIntegrationAdapterResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DisconnectIntegrationAdapterResponse']>;
  IntegrationAdapterConnectionNotFound: ResolverTypeWrapper<IntegrationAdapterConnectionNotFound>;
  EditBuyerReportScheduleInput: EditBuyerReportScheduleInput;
  EditBuyerReportScheduleResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['EditBuyerReportScheduleResponse']>;
  GenerateBuyerReportInput: GenerateBuyerReportInput;
  GenerateBuyerReportResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GenerateBuyerReportResponse']>;
  GetClientDebuggableArtifactUploadUrlInput: GetClientDebuggableArtifactUploadUrlInput;
  GetClientDebuggableArtifactUploadUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetClientDebuggableArtifactUploadUrlResponse']>;
  GetClientDebuggableArtifactUploadUrl: ResolverTypeWrapper<GetClientDebuggableArtifactUploadUrl>;
  GetClientDebuggableArtifactUploadUrlError: ResolverTypeWrapper<GetClientDebuggableArtifactUploadUrlError>;
  GetOrderGuideUploadUrlInput: GetOrderGuideUploadUrlInput;
  GetOrderGuideUploadUrlResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GetOrderGuideUploadUrlResponse']>;
  GetOrderGuideUploadUrl: ResolverTypeWrapper<GetOrderGuideUploadUrl>;
  GetOrderGuideUploadUrlError: ResolverTypeWrapper<GetOrderGuideUploadUrlError>;
  ImportSupplierProductsReport: ResolverTypeWrapper<ImportSupplierProductsReport>;
  InitInventoryDownloadInput: InitInventoryDownloadInput;
  InitInventoryDownloadResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InitInventoryDownloadResponse']>;
  InitInventoryDownloadSuccess: ResolverTypeWrapper<InitInventoryDownloadSuccess>;
  InitInventoryDownloadFailure: ResolverTypeWrapper<InitInventoryDownloadFailure>;
  InitInventoryUploadInput: InitInventoryUploadInput;
  InitInventoryUploadResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InitInventoryUploadResponse']>;
  InitInventoryUploadSuccess: ResolverTypeWrapper<InitInventoryUploadSuccess>;
  InitInventoryUploadFailure: ResolverTypeWrapper<InitInventoryUploadFailure>;
  InitiateCheckoutResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InitiateCheckoutResponse']>;
  BalanceCheckoutToken: ResolverTypeWrapper<BalanceCheckoutToken>;
  SupplierPaymentAccountMissing: ResolverTypeWrapper<SupplierPaymentAccountMissing>;
  InvoiceAlreadyPaid: ResolverTypeWrapper<InvoiceAlreadyPaid>;
  InvoicePaymentInProgress: ResolverTypeWrapper<InvoicePaymentInProgress>;
  InvoiceTotalTooLow: ResolverTypeWrapper<InvoiceTotalTooLow>;
  IntegrationAdapterConnectionAuthInput: IntegrationAdapterConnectionAuthInput;
  IntegrationAdapterConnectionAuthResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterConnectionAuthResponse']>;
  IntegrationAdapterConnectionAuthRedirect: ResolverTypeWrapper<IntegrationAdapterConnectionAuthRedirect>;
  IntegrationAdapterConnectionConsentInput: IntegrationAdapterConnectionConsentInput;
  IntegrationAdapterConnectionConsentResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterConnectionConsentResponse']>;
  IntegrationAdapterConnectionConsentChallenge: ResolverTypeWrapper<IntegrationAdapterConnectionConsentChallenge>;
  IntegrationAdapterConnectionConsentRedirect: ResolverTypeWrapper<IntegrationAdapterConnectionConsentRedirect>;
  IntegrationAdapterConnectionCreateInput: IntegrationAdapterConnectionCreateInput;
  IntegrationAdapterConnectionCreateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterConnectionCreateResponse']>;
  IntegrationAdapterScopeInsufficient: ResolverTypeWrapper<IntegrationAdapterScopeInsufficient>;
  IntegrationAdapterConnectionUpdateInput: IntegrationAdapterConnectionUpdateInput;
  IntegrationAdapterConnectionUpdateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterConnectionUpdateResponse']>;
  IntegrationAdapterCreateInput: IntegrationAdapterCreateInput;
  IntegrationAdapterAuthInput: IntegrationAdapterAuthInput;
  IntegrationAdapterCreateWebhookInput: IntegrationAdapterCreateWebhookInput;
  WebhookAuthenticationInput: WebhookAuthenticationInput;
  IntegrationAdapterCreateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterCreateResponse']>;
  IntegrationAdapterExists: ResolverTypeWrapper<IntegrationAdapterExists>;
  IntegrationAdapterUpdateInput: IntegrationAdapterUpdateInput;
  IntegrationAdapterUpdateWebhookInput: IntegrationAdapterUpdateWebhookInput;
  IntegrationAdapterUpdateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationAdapterUpdateResponse']>;
  AttemptToChangeAdapterAuthType: ResolverTypeWrapper<AttemptToChangeAdapterAuthType>;
  AttemptToReduceIntegrationAdapterScope: ResolverTypeWrapper<AttemptToReduceIntegrationAdapterScope>;
  IntegrationWebhookRetryInput: IntegrationWebhookRetryInput;
  IntegrationWebhookRetryResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationWebhookRetryResponse']>;
  IntegrationWebhookRetryResults: ResolverTypeWrapper<Omit<IntegrationWebhookRetryResults, 'results'> & { results: Array<ResolversTypes['IntegrationWebhookRetryResult']> }>;
  IntegrationWebhookRetryResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationWebhookRetryResult']>;
  IntegrationWebhookRetrySuccess: ResolverTypeWrapper<IntegrationWebhookRetrySuccess>;
  IntegrationWebhookRetryFailure: ResolverTypeWrapper<IntegrationWebhookRetryFailure>;
  InternalInviteUsersResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InternalInviteUsersResponse']>;
  UsersList: ResolverTypeWrapper<UsersList>;
  InviteUserToBuyerInput: InviteUserToBuyerInput;
  inviteNonChocoUserToBuyerResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['inviteNonChocoUserToBuyerResponse']>;
  BuyerNotFound: ResolverTypeWrapper<BuyerNotFound>;
  InvitorNotFound: ResolverTypeWrapper<InvitorNotFound>;
  ExistingInvitedUser: ResolverTypeWrapper<ExistingInvitedUser>;
  PuppyValidationFailure: ResolverTypeWrapper<PuppyValidationFailure>;
  InviteUserToBuyerInputV2: InviteUserToBuyerInputV2;
  InviteUserToBuyerResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['InviteUserToBuyerResponse']>;
  InviteUserToBuyerError: ResolverTypeWrapper<InviteUserToBuyerError>;
  InviteUserToBuyerErrorCode: InviteUserToBuyerErrorCode;
  KycCreateInput: KycCreateInput;
  KycCreateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['KycCreateResponse']>;
  KycResponse: ResolverTypeWrapper<KycResponse>;
  KycBuyerNotFound: ResolverTypeWrapper<KycBuyerNotFound>;
  KycEntryAlreadyExists: ResolverTypeWrapper<KycEntryAlreadyExists>;
  MessageInput: MessageInput;
  GroupIdsInput: GroupIdsInput;
  OrderInput: OrderInput;
  OrderProductInput: OrderProductInput;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationPreferencesInput: NotificationPreferencesInput;
  OrderCreateV2Input: OrderCreateV2Input;
  OrderCreatedResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderCreatedResponse']>;
  OrderEditInput: OrderEditInput;
  EditedOrderProductsInput: EditedOrderProductsInput;
  OrderEditedResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderEditedResponse']>;
  OrderEditedError: ResolverTypeWrapper<OrderEditedError>;
  OrderExportConfigCreateInput: OrderExportConfigCreateInput;
  OrderExportFormatInput: OrderExportFormatInput;
  OrderExportEdiFormatInput: OrderExportEdiFormatInput;
  OrderExportEdiTemplateOptions: OrderExportEdiTemplateOptions;
  OrderExportChocoEdiFormatInput: OrderExportChocoEdiFormatInput;
  OrderExportSupplierEdiFormatInput: OrderExportSupplierEdiFormatInput;
  OrderExportCsvFormatInput: OrderExportCsvFormatInput;
  OrderExportCsvTemplateOptions: OrderExportCsvTemplateOptions;
  OrderExportLobsterFormatInput: OrderExportLobsterFormatInput;
  OrderExportUploadInput: OrderExportUploadInput;
  OrderExportChocoSftpUploadInput: OrderExportChocoSftpUploadInput;
  OrderExportExternalSftpUploadInput: OrderExportExternalSftpUploadInput;
  OrderExportConfig: ResolverTypeWrapper<Omit<OrderExportConfig, 'orderExportFormat' | 'orderExportUpload'> & { orderExportFormat: ResolversTypes['OrderExportConfigFormat'], orderExportUpload: ResolversTypes['OrderExportUploadOption'] }>;
  OrderExportConfigUpdateInput: OrderExportConfigUpdateInput;
  OrderGuideCreatedResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideCreatedResponse']>;
  OrderGuideCreatedSuccess: ResolverTypeWrapper<OrderGuideCreatedSuccess>;
  OrderGuideCreatedError: ResolverTypeWrapper<OrderGuideCreatedError>;
  OrderGuideRequestInput: OrderGuideRequestInput;
  OrderGuideRequestType: OrderGuideRequestType;
  OrderGuideRequestMethod: OrderGuideRequestMethod;
  OrderGuideRequestResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideRequestResponse']>;
  OrderGuideRequest: ResolverTypeWrapper<OrderGuideRequest>;
  OrderGuideRequestError: ResolverTypeWrapper<OrderGuideRequestError>;
  OrderGuideV2ItemUnitsAddInput: OrderGuideV2ItemUnitsAddInput;
  OrderGuideV2ItemUnitsAddInputItem: OrderGuideV2ItemUnitsAddInputItem;
  OrderGuideV2ItemUnitsAddResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideV2ItemUnitsAddResponse']>;
  OrderGuideV2ItemUnitsAddResult: ResolverTypeWrapper<OrderGuideV2ItemUnitsAddResult>;
  OrderGuideV2ItemUnitsRemoveInput: OrderGuideV2ItemUnitsRemoveInput;
  OrderGuideV2ItemUnitsRemoveResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderGuideV2ItemUnitsRemoveResponse']>;
  OrderGuideV2ItemUnitsRemoveResult: ResolverTypeWrapper<OrderGuideV2ItemUnitsRemoveResult>;
  PaymentAuthorizeInput: PaymentAuthorizeInput;
  PaymentAuthorizeResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PaymentAuthorizeResponse']>;
  PostProcessing: ResolverTypeWrapper<PostProcessing>;
  PreProcessing: ResolverTypeWrapper<PreProcessing>;
  NoFurtherActionNeeded: ResolverTypeWrapper<NoFurtherActionNeeded>;
  PaymentAccountIsInactive: ResolverTypeWrapper<PaymentAccountIsInactive>;
  UnexpectedInvoiceState: ResolverTypeWrapper<UnexpectedInvoiceState>;
  SupplierDoesNotAcceptOnlinePayments: ResolverTypeWrapper<SupplierDoesNotAcceptOnlinePayments>;
  EntityCurrencyMismatch: ResolverTypeWrapper<EntityCurrencyMismatch>;
  UpdatedCategoryProduct: ResolverTypeWrapper<UpdatedCategoryProduct>;
  ReferUserInput: ReferUserInput;
  ReferUserResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ReferUserResponse']>;
  ReferUserResult: ResolverTypeWrapper<ReferUserResult>;
  ReferUserChatExists: ResolverTypeWrapper<ReferUserChatExists>;
  ReferUserReferralCodeNotFound: ResolverTypeWrapper<ReferUserReferralCodeNotFound>;
  OmnichannelOrdersSubcriptionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OmnichannelOrdersSubcriptionResponse']>;
  OrderDeskNotification: ResolverTypeWrapper<OrderDeskNotification>;
  RejectOrderInput: RejectOrderInput;
  RejectOrderResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RejectOrderResponse']>;
  OrderRejected: ResolverTypeWrapper<OrderRejected>;
  RejectOrdersByIdInput: RejectOrdersByIdInput;
  RejectOrdersByIdResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RejectOrdersByIdResponse']>;
  OrdersRejected: ResolverTypeWrapper<OrdersRejected>;
  RemoveCCEmailFromChatsReport: ResolverTypeWrapper<RemoveCcEmailFromChatsReport>;
  RemoveEmailFromBuyerReportScheduleResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveEmailFromBuyerReportScheduleResponse']>;
  EmailFromBuyerReportScheduleRemoved: ResolverTypeWrapper<EmailFromBuyerReportScheduleRemoved>;
  EmailInBuyerReportScheduleNotFound: ResolverTypeWrapper<EmailInBuyerReportScheduleNotFound>;
  RemoveEntitiesFromGroupInput: RemoveEntitiesFromGroupInput;
  RemoveEntitiesFromGroupResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveEntitiesFromGroupResponse']>;
  RemoveEntitiesFromGroupResponseSuccess: ResolverTypeWrapper<RemoveEntitiesFromGroupResponseSuccess>;
  RemoveEntitiesFromGroupResponseError: ResolverTypeWrapper<RemoveEntitiesFromGroupResponseError>;
  RemoveEntitiesFromGroupErrorCode: RemoveEntitiesFromGroupErrorCode;
  RemoveInvoiceResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveInvoiceResponse']>;
  InvoiceRemoved: ResolverTypeWrapper<InvoiceRemoved>;
  InvoiceCannotBeRemoved: ResolverTypeWrapper<InvoiceCannotBeRemoved>;
  RemoveInvoiceAttachmentResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveInvoiceAttachmentResponse']>;
  InvoiceAttachmentRemoved: ResolverTypeWrapper<InvoiceAttachmentRemoved>;
  InvoiceCannotBeUpdated: ResolverTypeWrapper<InvoiceCannotBeUpdated>;
  RemoveOrderDeskEmail: RemoveOrderDeskEmail;
  OrderDeskRemovedEmailResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderDeskRemovedEmailResponse']>;
  OrderDeskEmailRemoved: ResolverTypeWrapper<OrderDeskEmailRemoved>;
  RemovePaymentAccountResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemovePaymentAccountResponse']>;
  PaymentAccountRemoved: ResolverTypeWrapper<PaymentAccountRemoved>;
  RemoveProductsFromOrderGuidesInput: RemoveProductsFromOrderGuidesInput;
  RemoveProductsFromOrderGuidesResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveProductsFromOrderGuidesResponse']>;
  RemoveProductsFromOrderGuidesResult: ResolverTypeWrapper<RemoveProductsFromOrderGuidesResult>;
  RemoveSupplierBuyerMovInput: RemoveSupplierBuyerMovInput;
  MinimumOrderValueUpdateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MinimumOrderValueUpdateResponse']>;
  MinimumOrderValueUpdate: ResolverTypeWrapper<MinimumOrderValueUpdate>;
  RemoveUsersFromGroupInput: RemoveUsersFromGroupInput;
  RemoveUsersFromGroupResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RemoveUsersFromGroupResponse']>;
  RemoveUsersFromGroupSuccess: ResolverTypeWrapper<RemoveUsersFromGroupSuccess>;
  RemoveUsersFromGroupError: ResolverTypeWrapper<RemoveUsersFromGroupError>;
  RequestToJoinBuyerResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RequestToJoinBuyerResponse']>;
  RequestToJoinBuyerError: ResolverTypeWrapper<RequestToJoinBuyerError>;
  RequestToJoinBuyerErrorCode: RequestToJoinBuyerErrorCode;
  SelectProductForOrderGuideInput: SelectProductForOrderGuideInput;
  BuyerProductInput: BuyerProductInput;
  SelectProductForOrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SelectProductForOrderGuideResponse']>;
  SelectProductForOrderGuideSuccess: ResolverTypeWrapper<SelectProductForOrderGuideSuccess>;
  SelectProductsForOrderGuideInput: SelectProductsForOrderGuideInput;
  OrderGuideProductInput: OrderGuideProductInput;
  SelectProductsForOrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SelectProductsForOrderGuideResponse']>;
  SelectProductsForOrderGuideSuccess: ResolverTypeWrapper<SelectProductsForOrderGuideSuccess>;
  SendInviteTransmissionRequest: SendInviteTransmissionRequest;
  SendInviteTransmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SendInviteTransmissionResponse']>;
  SendSyntheticSmsMessageInput: SendSyntheticSmsMessageInput;
  SendSyntheticSmsMessageMediaInput: SendSyntheticSmsMessageMediaInput;
  SendSyntheticSmsMessageResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SendSyntheticSmsMessageResponse']>;
  SendSyntheticSmsMessageSuccess: ResolverTypeWrapper<SendSyntheticSmsMessageSuccess>;
  SendSyntheticWhatsAppMessageInput: SendSyntheticWhatsAppMessageInput;
  SendSyntheticWhatsAppMessageMediaInput: SendSyntheticWhatsAppMessageMediaInput;
  SendSyntheticWhatsAppMessageResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SendSyntheticWhatsAppMessageResponse']>;
  SendSyntheticWhatsAppMessageSuccess: ResolverTypeWrapper<SendSyntheticWhatsAppMessageSuccess>;
  SetOrderAsTestResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SetOrderAsTestResponse']>;
  TestOrderResponse: ResolverTypeWrapper<TestOrderResponse>;
  SubmitBuyerStockCountInput: SubmitBuyerStockCountInput;
  CartSubmissionOptions: CartSubmissionOptions;
  CartSubmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CartSubmissionResponse']>;
  CartSubmissionResult: ResolverTypeWrapper<CartSubmissionResult>;
  CartSubmissionError: ResolverTypeWrapper<CartSubmissionError>;
  CreateMessageError: ResolverTypeWrapper<CreateMessageError>;
  CartSubmittedEmptyError: ResolverTypeWrapper<CartSubmittedEmptyError>;
  CartInvalidProductsError: ResolverTypeWrapper<CartInvalidProductsError>;
  CartAllProductsUnavailableError: ResolverTypeWrapper<CartAllProductsUnavailableError>;
  ForbiddenError: ResolverTypeWrapper<ForbiddenError>;
  ExistingOrderError: ResolverTypeWrapper<ExistingOrderError>;
  ProductLeadTimeError: ResolverTypeWrapper<ProductLeadTimeError>;
  SubmitOrderDeliveryCheckInput: SubmitOrderDeliveryCheckInput;
  DeliveryCheckReconciliationRequestInput: DeliveryCheckReconciliationRequestInput;
  OrderDeliveryCheckSubmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderDeliveryCheckSubmissionResponse']>;
  OrderDeliveryCheckNotFound: ResolverTypeWrapper<OrderDeliveryCheckNotFound>;
  SubmitOrderedProductDeliveryCheckInput: SubmitOrderedProductDeliveryCheckInput;
  OrderedProductDeliveryCheckSubmissionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['OrderedProductDeliveryCheckSubmissionResponse']>;
  SubmitStockCountSessionInput: SubmitStockCountSessionInput;
  SubmitStockCountSessionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SubmitStockCountSessionResponse']>;
  SubmitStockCountSessionFailure: ResolverTypeWrapper<SubmitStockCountSessionFailure>;
  SubmitStockCountSessionSuccess: ResolverTypeWrapper<SubmitStockCountSessionSuccess>;
  SupplierAddRequestInput: SupplierAddRequestInput;
  SupplierAddRequestResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierAddRequestResponse']>;
  SupplierAddRequest: ResolverTypeWrapper<SupplierAddRequest>;
  SupplierAddRequestError: ResolverTypeWrapper<SupplierAddRequestError>;
  SupplierCreateInput: SupplierCreateInput;
  IntegrationOptionInput: IntegrationOptionInput;
  IntegrationSmsOptionInput: IntegrationSmsOptionInput;
  IntegrationEmailOptionInput: IntegrationEmailOptionInput;
  IntegrationFaxOptionInput: IntegrationFaxOptionInput;
  IntegrationWhatsAppOptionInput: IntegrationWhatsAppOptionInput;
  DeliveryZoneInput: DeliveryZoneInput;
  PriceSettingInput: PriceSettingInput;
  MinOrderInput: MinOrderInput;
  SupplierGetInTouchRequestInput: SupplierGetInTouchRequestInput;
  SupplierGetInTouchRequestResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierGetInTouchRequestResponse']>;
  SupplierGetInTouchRequestSuccess: ResolverTypeWrapper<SupplierGetInTouchRequestSuccess>;
  SupplierUpdateError: ResolverTypeWrapper<SupplierUpdateError>;
  SupplierGetInTouchRequestError: ResolverTypeWrapper<SupplierGetInTouchRequestError>;
  ChatInviteRecipient: ChatInviteRecipient;
  ChatInviteInput: ChatInviteInput;
  SupplierInviteUserResponse: ResolverTypeWrapper<Omit<SupplierInviteUserResponse, 'inviteResponse'> & { inviteResponse: Array<Maybe<ResolversTypes['SupplierInviteResponseEntity']>> }>;
  SupplierInviteResponseEntity: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierInviteResponseEntity']>;
  InvalidInvitedPhoneNumber: ResolverTypeWrapper<InvalidInvitedPhoneNumber>;
  SupplierInviteError: ResolverTypeWrapper<SupplierInviteError>;
  SupplierUpdateInput: SupplierUpdateInput;
  SupplierUserCreateInput: SupplierUserCreateInput;
  SupplierUserRemoveInput: SupplierUserRemoveInput;
  SupplierUserRemoveResponse: ResolverTypeWrapper<SupplierUserRemoveResponse>;
  TriggerProductMatchingInput: TriggerProductMatchingInput;
  TriggerProductMatchingResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TriggerProductMatchingResponse']>;
  UnassignUserFromOrderToReviewInput: UnassignUserFromOrderToReviewInput;
  UnassignUserFromOrderToReviewResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UnassignUserFromOrderToReviewResponse']>;
  UnassignUserFromOrderToReviewResponseSuccess: ResolverTypeWrapper<UnassignUserFromOrderToReviewResponseSuccess>;
  UnassignUserFromOrderToReviewResponseError: ResolverTypeWrapper<UnassignUserFromOrderToReviewResponseError>;
  UndoMultiLocationOrderGuideTransactionInput: UndoMultiLocationOrderGuideTransactionInput;
  UndoMultiLocationOrderGuideTransactionResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UndoMultiLocationOrderGuideTransactionResponse']>;
  UndoMultiLocationOrderGuideTransactionResult: ResolverTypeWrapper<UndoMultiLocationOrderGuideTransactionResult>;
  UpdateBuyerInventoryProductInput: UpdateBuyerInventoryProductInput;
  UpdateBuyerInventoryProductResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateBuyerInventoryProductResponse']>;
  UpdateBuyerStockInventoryProductInput: UpdateBuyerStockInventoryProductInput;
  UpdateBuyerStockInventoryProductResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateBuyerStockInventoryProductResponse']>;
  UpdateBuyerStockInventoryProductFailure: ResolverTypeWrapper<UpdateBuyerStockInventoryProductFailure>;
  CartLineItemUpdateInput: CartLineItemUpdateInput;
  CartProductMetadataInput: CartProductMetadataInput;
  CartUpdateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['CartUpdateResponse']>;
  NegativeAmountError: ResolverTypeWrapper<NegativeAmountError>;
  ChatNotificationInput: ChatNotificationInput;
  ChatNotificationUserListsInput: ChatNotificationUserListsInput;
  UpdateInventoryItemInput: UpdateInventoryItemInput;
  UpdateInventoryItemInputPatch: UpdateInventoryItemInputPatch;
  UpdateInventoryItemResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateInventoryItemResponse']>;
  UpdateInventoryItemSuccess: ResolverTypeWrapper<UpdateInventoryItemSuccess>;
  UpdateInventoryItemFailure: ResolverTypeWrapper<UpdateInventoryItemFailure>;
  UpdateInvoiceInput: UpdateInvoiceInput;
  UpdateInvoiceResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateInvoiceResponse']>;
  InvoicedProductInput: InvoicedProductInput;
  UpdateInvoicedProductResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateInvoicedProductResponse']>;
  InvoicedProducts: ResolverTypeWrapper<InvoicedProducts>;
  UpdatePendingUserInput: UpdatePendingUserInput;
  PendingUserInput: PendingUserInput;
  UpdatePendingUserResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdatePendingUserResponse']>;
  UpdateProductVariantsInOrderGuideInput: UpdateProductVariantsInOrderGuideInput;
  UpdateProductVariantsInOrderGuideResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateProductVariantsInOrderGuideResponse']>;
  UpdateProductVariantsInOrderGuideSuccess: ResolverTypeWrapper<UpdateProductVariantsInOrderGuideSuccess>;
  UpdateJoinRequestInput: UpdateJoinRequestInput;
  JoinRequestAllowedUpdateStatus: JoinRequestAllowedUpdateStatus;
  UpdateJoinRequestResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateJoinRequestResponse']>;
  UpdateJoinRequestSuccess: ResolverTypeWrapper<UpdateJoinRequestSuccess>;
  UpdateJoinRequestError: ResolverTypeWrapper<UpdateJoinRequestError>;
  UpdateJoinRequestErrorCode: UpdateJoinRequestErrorCode;
  UpdateStorageItemInput: UpdateStorageItemInput;
  UpdateStorageItemInputPatch: UpdateStorageItemInputPatch;
  PatchStorageItemPrice: PatchStorageItemPrice;
  UpdateStorageItemResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateStorageItemResponse']>;
  UpdateStorageItemSuccess: ResolverTypeWrapper<UpdateStorageItemSuccess>;
  UpdateStorageItemFailure: ResolverTypeWrapper<UpdateStorageItemFailure>;
  updateSubCatalogResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['updateSubCatalogResponse']>;
  UpdateSubCatalogError: ResolverTypeWrapper<UpdateSubCatalogError>;
  SubCatalogChatInput: SubCatalogChatInput;
  UpdateSubCatalogChatsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpdateSubCatalogChatsResponse']>;
  UpdateSubCatalogChatsResult: ResolverTypeWrapper<UpdateSubCatalogChatsResult>;
  UpdateSubCatalogChatsSummary: ResolverTypeWrapper<UpdateSubCatalogChatsSummary>;
  SubCatalogChat: ResolverTypeWrapper<Omit<SubCatalogChat, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['EntityIdentity']> }>;
  EntityIdentity: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['EntityIdentity']>;
  IntegrationEntityIdentity: ResolverTypeWrapper<IntegrationEntityIdentity>;
  IntegrationEntityIdentityType: IntegrationEntityIdentityType;
  InternalEntityIdentity: ResolverTypeWrapper<InternalEntityIdentity>;
  InternalEntityIdentityType: InternalEntityIdentityType;
  InvalidSubCatalogChat: ResolverTypeWrapper<InvalidSubCatalogChat>;
  SupplierUpdateAccessPackageInput: SupplierUpdateAccessPackageInput;
  SupplierUpdateAccessPackageResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SupplierUpdateAccessPackageResponse']>;
  SupplierUpdateAccessPackageSuccess: ResolverTypeWrapper<SupplierUpdateAccessPackageSuccess>;
  SupplierUpdateAccessPackageError: ResolverTypeWrapper<SupplierUpdateAccessPackageError>;
  UpdateSupplierBuyerMovInput: UpdateSupplierBuyerMovInput;
  SupplierDeliverySettingInput: SupplierDeliverySettingInput;
  CutOffTimeInput: CutOffTimeInput;
  WeekdayBasedCutoffSettingsInput: WeekdayBasedCutoffSettingsInput;
  CutoffSettingInput: CutoffSettingInput;
  DeliveryExceptionInput: DeliveryExceptionInput;
  DeliveryExceptionInputType: DeliveryExceptionInputType;
  DeliveryExceptionCutoffSettingInput: DeliveryExceptionCutoffSettingInput;
  UpdateSupplierProductV2Input: UpdateSupplierProductV2Input;
  SupplierUserUpdateChatsInput: SupplierUserUpdateChatsInput;
  SupplierUserUpdateChatsResponse: ResolverTypeWrapper<SupplierUserUpdateChatsResponse>;
  UpdateSupplierUserRolesInput: UpdateSupplierUserRolesInput;
  UploadSubCatalogProductsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UploadSubCatalogProductsResponse']>;
  UploadSubCatalogProductsResult: ResolverTypeWrapper<UploadSubCatalogProductsResult>;
  UploadSubCatalogProductsError: ResolverTypeWrapper<UploadSubCatalogProductsError>;
  UpsertStockCountSessionItemsInput: UpsertStockCountSessionItemsInput;
  StockCountItemInput: StockCountItemInput;
  UpsertStockCountSessionItemsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UpsertStockCountSessionItemsResponse']>;
  UpsertStockCountSessionItemsSuccess: ResolverTypeWrapper<UpsertStockCountSessionItemsSuccess>;
  UpsertStockCountSessionItemsError: ResolverTypeWrapper<UpsertStockCountSessionItemsError>;
  UserCreateInput: UserCreateInput;
  OrderPreferenceInput: OrderPreferenceInput;
  UserLeadInput: UserLeadInput;
  UserLead: ResolverTypeWrapper<UserLead>;
  UserLeadRequest: ResolverTypeWrapper<UserLeadRequest>;
  UserRequestToDeleteInput: UserRequestToDeleteInput;
  UserRequestToDeleteResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['UserRequestToDeleteResponse']>;
  UserRequestToDeleteDetails: ResolverTypeWrapper<UserRequestToDeleteDetails>;
  UserUpdateInput: UserUpdateInput;
  VendorItemUnitUpdateInput: VendorItemUnitUpdateInput;
  VendorItemUnitUpdateResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['VendorItemUnitUpdateResponse']>;
  VendorItemUnitUpdateResult: ResolverTypeWrapper<VendorItemUnitUpdateResult>;
  Subscription: ResolverTypeWrapper<{}>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  ActivateChatResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ActivateChatResponse']>;
  BuyerChatsNotFound: ResolverTypeWrapper<BuyerChatsNotFound>;
  BuyerChatsProductListEmpty: ResolverTypeWrapper<BuyerChatsProductListEmpty>;
  BuyerChatsResponse: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BuyerChatsResponse']>;
  BuyerStockCountProductInput: BuyerStockCountProductInput;
  Contact: ResolverTypeWrapper<Contact>;
  OrderResult: ResolverTypeWrapper<OrderResult>;
  ProductConnection: ResolverTypeWrapper<ProductConnection>;
  ProductEdge: ResolverTypeWrapper<ProductEdge>;
  ProductMatchData: ResolverTypeWrapper<ProductMatchData>;
  SupplierContactAlreadyCreated: ResolverTypeWrapper<SupplierContactAlreadyCreated>;
  SupplierProductFilter: SupplierProductFilter;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {};
  String: Scalars['String']['output'];
  BlockedEmail: BlockedEmail;
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  ID: Scalars['ID']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  Int: Scalars['Int']['output'];
  BlockedEmailConnection: BlockedEmailConnection;
  Connection: ResolversInterfaceTypes<ResolversParentTypes>['Connection'];
  Edge: ResolversInterfaceTypes<ResolversParentTypes>['Edge'];
  BlockedEmailEdge: BlockedEmailEdge;
  Broadcast: Broadcast;
  BroadcastAnalytics: BroadcastAnalytics;
  Boolean: Scalars['Boolean']['output'];
  Float: Scalars['Float']['output'];
  BroadcastMediaAttachment: BroadcastMediaAttachment;
  BroadcastMedia: BroadcastMedia;
  BroadcastPdfMedia: BroadcastPdfMedia;
  Chat: Chat;
  Buyer: Buyer;
  BuyerUserConnection: BuyerUserConnection;
  BuyerUserEdge: BuyerUserEdge;
  User: Omit<User, 'referral'> & { referral?: Maybe<ResolversParentTypes['GetReferralResponse']> };
  UserBuyerConnection: UserBuyerConnection;
  UserBuyerEdge: UserBuyerEdge;
  UserChatConnection: UserChatConnection;
  UserChatEdge: UserChatEdge;
  UserUserConnection: UserUserConnection;
  UserUserEdge: UserUserEdge;
  OrderPreference: OrderPreference;
  ProfileImage: ProfileImage;
  Supplier: Omit<Supplier, 'appliedMinimumOrderValue' | 'integration' | 'orderExportFormat' | 'orderExportUpload' | 'paymentAccounts'> & { appliedMinimumOrderValue?: Maybe<ResolversParentTypes['MinimumOrderValueResponse']>, integration: Array<ResolversParentTypes['IntegrationOption']>, orderExportFormat?: Maybe<ResolversParentTypes['OrderExportConfigFormat']>, orderExportUpload?: Maybe<ResolversParentTypes['OrderExportUploadOption']>, paymentAccounts: ResolversParentTypes['ListPaymentAccountsResponse'] };
  MinimumOrderValueResponse: ResolversUnionTypes<ResolversParentTypes>['MinimumOrderValueResponse'];
  MinimumOrderValue: MinimumOrderValue;
  MinOrder: MinOrder;
  Money: Money;
  MinimumOrderValueFailure: MinimumOrderValueFailure;
  AuthorizationFailure: AuthorizationFailure;
  AppsyncResponse: ResolversInterfaceTypes<ResolversParentTypes>['AppsyncResponse'];
  AppsyncError: ResolversInterfaceTypes<ResolversParentTypes>['AppsyncError'];
  InputValidationFailure: InputValidationFailure;
  FieldValidationError: FieldValidationError;
  AWSEmail: Scalars['AWSEmail']['output'];
  SupplierDeliverySetting: Omit<SupplierDeliverySetting, 'exceptions'> & { exceptions?: Maybe<Array<ResolversParentTypes['DeliverySettingException']>> };
  CutOffTime: CutOffTime;
  AWSTime: Scalars['AWSTime']['output'];
  WeekdayBasedCutoffSettings: Omit<WeekdayBasedCutoffSettings, 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'> & { mon?: Maybe<ResolversParentTypes['CutoffSetting']>, tue?: Maybe<ResolversParentTypes['CutoffSetting']>, wed?: Maybe<ResolversParentTypes['CutoffSetting']>, thu?: Maybe<ResolversParentTypes['CutoffSetting']>, fri?: Maybe<ResolversParentTypes['CutoffSetting']>, sat?: Maybe<ResolversParentTypes['CutoffSetting']>, sun?: Maybe<ResolversParentTypes['CutoffSetting']> };
  CutoffSetting: ResolversUnionTypes<ResolversParentTypes>['CutoffSetting'];
  NoCutoffSetting: NoCutoffSetting;
  WithCutoffSetting: WithCutoffSetting;
  DeliverySettingException: ResolversUnionTypes<ResolversParentTypes>['DeliverySettingException'];
  SingleDayDeliveryExceptionWithCutoff: SingleDayDeliveryExceptionWithCutoff;
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  SingleDayDeliveryExceptionWithoutCutoff: SingleDayDeliveryExceptionWithoutCutoff;
  NoDeliveryException: NoDeliveryException;
  DeliveryZone: DeliveryZone;
  Coordinate: Coordinate;
  IntegrationOption: ResolversUnionTypes<ResolversParentTypes>['IntegrationOption'];
  IntegrationSmsOption: IntegrationSmsOption;
  IntegrationEmailOption: IntegrationEmailOption;
  IntegrationFaxOption: IntegrationFaxOption;
  IntegrationWhatsAppOption: IntegrationWhatsAppOption;
  OrderExportConfigFormat: ResolversUnionTypes<ResolversParentTypes>['OrderExportConfigFormat'];
  OrderExportConfigCsvFormat: OrderExportConfigCsvFormat;
  OrderExportConfigEdiFormat: OrderExportConfigEdiFormat;
  OrderExportChocoEdiFormat: OrderExportChocoEdiFormat;
  OrderExportSupplierEdiFormat: OrderExportSupplierEdiFormat;
  OrderExportConfigLobsterFormat: OrderExportConfigLobsterFormat;
  OrderExportUploadOption: ResolversUnionTypes<ResolversParentTypes>['OrderExportUploadOption'];
  OrderExportChocoSftpUpload: OrderExportChocoSftpUpload;
  OrderExportExternalSftpUpload: OrderExportExternalSftpUpload;
  OrderExportLobsterUpload: OrderExportLobsterUpload;
  ListPaymentAccountsResponse: ResolversUnionTypes<ResolversParentTypes>['ListPaymentAccountsResponse'];
  PaymentAccountsList: PaymentAccountsList;
  PaymentAccount: Omit<PaymentAccount, 'details'> & { details: ResolversParentTypes['PaymentAccountDetails'] };
  PaymentAccountPsp: PaymentAccountPsp;
  PaymentAccountDetails: ResolversUnionTypes<ResolversParentTypes>['PaymentAccountDetails'];
  BankAccountDetails: BankAccountDetails;
  CreditCardDetails: CreditCardDetails;
  BalanceVendorBankDetails: BalanceVendorBankDetails;
  BalanceBuyerBankDetails: BalanceBuyerBankDetails;
  WalletDetails: WalletDetails;
  PayoutDetails: PayoutDetails;
  PriceSetting: PriceSetting;
  SupplierUserConnection: SupplierUserConnection;
  SupplierUserEdge: SupplierUserEdge;
  InviteInfo: InviteInfo;
  GetReferralResponse: ResolversUnionTypes<ResolversParentTypes>['GetReferralResponse'];
  Referral: Referral;
  NotFoundError: NotFoundError;
  InviteTransmission: InviteTransmission;
  TransmissionEvent: TransmissionEvent;
  AWSJSON: Scalars['AWSJSON']['output'];
  BuyerChatConnection: BuyerChatConnection;
  BuyerChatEdge: BuyerChatEdge;
  Kyc: Kyc;
  Cart: Cart;
  CartLineItem: CartLineItem;
  Product: Omit<Product, 'derivedPriceForOrderGuide' | 'isSelectedInOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<ResolversParentTypes['DerivedPriceForOrderGuideResponse']>, isSelectedInOrderGuide?: Maybe<ResolversParentTypes['IsSelectedInOrderGuideResponse']> };
  ProductCategory: ProductCategory;
  ProductDeliveryDateCondition: ProductDeliveryDateCondition;
  AWSURL: Scalars['AWSURL']['output'];
  ProductImage: ProductImage;
  BuyerInventoryProduct: BuyerInventoryProduct;
  SupplierNegotiatedPrice: SupplierNegotiatedPrice;
  DerivedPriceForOrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['DerivedPriceForOrderGuideResponse'];
  DerivedPriceForOrderGuide: DerivedPriceForOrderGuide;
  IsSelectedInOrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['IsSelectedInOrderGuideResponse'];
  IsSelectedInOrderGuide: IsSelectedInOrderGuide;
  CartProductMetadata: CartProductMetadata;
  ChatChurn: ChatChurn;
  CreatedBy: CreatedBy;
  SupplierDeliveryDateSettings: SupplierDeliveryDateSettings;
  AvailableDeliveryDate: AvailableDeliveryDate;
  MessageGroupFilter: MessageGroupFilter;
  ChatMessageConnection: ChatMessageConnection;
  ChatMessageEdge: ChatMessageEdge;
  Message: Omit<Message, 'attachment'> & { attachment?: Maybe<ResolversParentTypes['Attachment']> };
  Order: Omit<Order, 'invoice' | 'orderChanges' | 'orderDeliveryCheck'> & { invoice: ResolversParentTypes['OrderInvoice'], orderChanges?: Maybe<ResolversParentTypes['OrderChangeResponse']>, orderDeliveryCheck?: Maybe<ResolversParentTypes['GetOrderDeliveryCheckResponse']> };
  OrderInvoice: ResolversUnionTypes<ResolversParentTypes>['OrderInvoice'];
  Invoice: Omit<Invoice, 'currentPayment'> & { currentPayment: ResolversParentTypes['CurrentPaymentResponse'] };
  InvoiceFileUrls: InvoiceFileUrls;
  InvoiceAttachment: InvoiceAttachment;
  CurrentPaymentResponse: ResolversUnionTypes<ResolversParentTypes>['CurrentPaymentResponse'];
  PaymentResponse: Omit<PaymentResponse, 'paymentAccount'> & { paymentAccount: ResolversParentTypes['PaymentAccountResponse'] };
  PaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['PaymentAccountResponse'];
  SecuredPaymentAccount: Omit<SecuredPaymentAccount, 'details'> & { details: ResolversParentTypes['PaymentAccountDetails'] };
  PaymentAccountNotFound: PaymentAccountNotFound;
  InvoiceHasNoPayment: InvoiceHasNoPayment;
  OrderHasNoInvoice: OrderHasNoInvoice;
  OrderHasOnlyAttachment: OrderHasOnlyAttachment;
  InvoicedProduct: InvoicedProduct;
  OmnichannelOrder: OmnichannelOrder;
  ParsedOrder: ParsedOrder;
  OmnichannelProduct: OmnichannelProduct;
  OmnichannelOrderProduct: OmnichannelOrderProduct;
  OmnichannelOrderAttachment: OmnichannelOrderAttachment;
  AudioTranscript: AudioTranscript;
  Word: Word;
  StartOffSet: StartOffSet;
  OrderDeskReviewer: OrderDeskReviewer;
  OrderChangeResponse: ResolversUnionTypes<ResolversParentTypes>['OrderChangeResponse'];
  OrderChange: OrderChange;
  OrderChangeData: OrderChangeData;
  OrderProduct: OrderProduct;
  NoOrderChange: NoOrderChange;
  OrderChangeReverted: OrderChangeReverted;
  OrderChangeError: OrderChangeError;
  GetOrderDeliveryCheckResponse: ResolversUnionTypes<ResolversParentTypes>['GetOrderDeliveryCheckResponse'];
  OrderDeliveryCheckDetails: OrderDeliveryCheckDetails;
  OrderedProductDeliveryCheck: OrderedProductDeliveryCheck;
  OrderDeliveryCheckImage: OrderDeliveryCheckImage;
  OrderedProductMetadata: OrderedProductMetadata;
  DeliveryCheckProblem: DeliveryCheckProblem;
  DeliveryCheckReconciliationRequest: DeliveryCheckReconciliationRequest;
  DeliveryCheckReconciliationRequestStatusHistory: DeliveryCheckReconciliationRequestStatusHistory;
  CreatedOrCompletedByNotFound: CreatedOrCompletedByNotFound;
  OrderedProduct: OrderedProduct;
  OrderRestaurant: OrderRestaurant;
  Attachment: ResolversUnionTypes<ResolversParentTypes>['Attachment'];
  Event: Omit<Event, 'chatEventType' | 'target'> & { chatEventType: ResolversParentTypes['ChatEventTypes'], target?: Maybe<Array<Maybe<ResolversParentTypes['EventTarget']>>> };
  ChatEventTypes: ResolversUnionTypes<ResolversParentTypes>['ChatEventTypes'];
  RequestedChatCreated: RequestedChatCreated;
  RequestedChatActivated: RequestedChatActivated;
  UserAddedToChat: UserAddedToChat;
  ChatNameUpdated: ChatNameUpdated;
  UserRemovedFromChat: UserRemovedFromChat;
  ChatCreated: ChatCreated;
  CartOpened: CartOpened;
  EventUser: EventUser;
  CartUpdated: CartUpdated;
  CartSubmitted: CartSubmitted;
  CartCanceled: CartCanceled;
  OrderEdited: OrderEdited;
  OrderGuideRequested: OrderGuideRequested;
  OrderGuideCreated: OrderGuideCreated;
  ReconciliationRequestConfirmed: ReconciliationRequestConfirmed;
  EventTarget: ResolversUnionTypes<ResolversParentTypes>['EventTarget'];
  EventChat: EventChat;
  EventOrder: EventOrder;
  EventDeliveryCheckReconciliationRequest: EventDeliveryCheckReconciliationRequest;
  Media: Media;
  BroadcastAttachment: BroadcastAttachment;
  OrderGuideV2Ref: OrderGuideV2Ref;
  RefEdge: ResolversInterfaceTypes<ResolversParentTypes>['RefEdge'];
  OrderGuideV2: OrderGuideV2;
  SubCatalog: SubCatalog;
  ChatUserConnection: ChatUserConnection;
  ChatUserEdge: ChatUserEdge;
  Sort: Sort;
  BroadcastCustomerPerformanceFilterInput: BroadcastCustomerPerformanceFilterInput;
  PaginationInput: PaginationInput;
  BroadcastCustomerPerformanceResult: BroadcastCustomerPerformanceResult;
  BroadcastCustomerPerformance: BroadcastCustomerPerformance;
  BroadCastEndsAt: BroadCastEndsAt;
  BroadcastProductPerformanceResult: BroadcastProductPerformanceResult;
  BroadcastProductPerformance: BroadcastProductPerformance;
  OneTimeBroadcastSchedule: OneTimeBroadcastSchedule;
  BrowseCatalogInput: BrowseCatalogInput;
  BrowseCatalogFilterInput: BrowseCatalogFilterInput;
  BrowseCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['BrowseCatalogResponse'];
  CatalogProductsConnection: CatalogProductsConnection;
  CatalogProductsEdge: CatalogProductsEdge;
  PageInfo: PageInfo;
  BrowseCatalogForChatInput: BrowseCatalogForChatInput;
  BrowseCatalogForChatFilterInput: BrowseCatalogForChatFilterInput;
  BrowseCatalogForChatResponse: ResolversUnionTypes<ResolversParentTypes>['BrowseCatalogForChatResponse'];
  CatalogNotFound: CatalogNotFound;
  BuyerFacetsResponse: BuyerFacetsResponse;
  CityWithOffsets: CityWithOffsets;
  GetBuyerStockCountInput: GetBuyerStockCountInput;
  BuyerStockCountResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerStockCountResponse'];
  BuyerStockCountSuccess: BuyerStockCountSuccess;
  BuyerStockCountProduct: BuyerStockCountProduct;
  BuyerStockCountFailure: BuyerStockCountFailure;
  GetBuyerStockCountsInput: GetBuyerStockCountsInput;
  GetBuyerStockCountFilterInput: GetBuyerStockCountFilterInput;
  BuyerStockCountsResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerStockCountsResponse'];
  BuyerStockCountsSuccess: BuyerStockCountsSuccess;
  BuyerStockCountConnection: BuyerStockCountConnection;
  BuyerStockCountEdge: BuyerStockCountEdge;
  BuyerStockCount: BuyerStockCount;
  BuyerStockCountsFailure: BuyerStockCountsFailure;
  GetBuyerStockInventoryProductsFilterInput: GetBuyerStockInventoryProductsFilterInput;
  BuyerStockInventoryResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerStockInventoryResponse'];
  BuyerStockInventory: BuyerStockInventory;
  BuyerStockInventoryProductConnection: BuyerStockInventoryProductConnection;
  BuyerStockInventoryProductEdge: BuyerStockInventoryProductEdge;
  BuyerStockInventoryProduct: BuyerStockInventoryProduct;
  BuyerStockInventoryNotFound: BuyerStockInventoryNotFound;
  BuyerStockInventoryFailure: BuyerStockInventoryFailure;
  GetBuyerStockInventoryExportUrlInput: GetBuyerStockInventoryExportUrlInput;
  BuyerStockInventoryExportUrlResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerStockInventoryExportUrlResponse'];
  BuyerStockInventoryExportUrlSuccess: BuyerStockInventoryExportUrlSuccess;
  BuyerStockInventoryExportUrlFailure: BuyerStockInventoryExportUrlFailure;
  BuyerUser: BuyerUser;
  CartResponse: ResolversUnionTypes<ResolversParentTypes>['CartResponse'];
  CatalogImportStatusResponse: ResolversUnionTypes<ResolversParentTypes>['CatalogImportStatusResponse'];
  CatalogImportStatusResult: Omit<CatalogImportStatusResult, 'job'> & { job: ResolversParentTypes['CatalogImportJob'] };
  CatalogImportJob: ResolversUnionTypes<ResolversParentTypes>['CatalogImportJob'];
  JobWaitingForInput: JobWaitingForInput;
  JobInProgress: JobInProgress;
  JobFailed: JobFailed;
  JobFailure: JobFailure;
  CatalogImportJobSucceeded: CatalogImportJobSucceeded;
  CatalogImportJobResponse: CatalogImportJobResponse;
  CatalogImportTemplateResponse: ResolversUnionTypes<ResolversParentTypes>['CatalogImportTemplateResponse'];
  CatalogImportTemplateResult: CatalogImportTemplateResult;
  CatalogImportsInput: CatalogImportsInput;
  CatalogImportsFilter: CatalogImportsFilter;
  PaginationInputV2: PaginationInputV2;
  CatalogImportsResponse: ResolversUnionTypes<ResolversParentTypes>['CatalogImportsResponse'];
  CatalogImportsResult: CatalogImportsResult;
  Page: ResolversInterfaceTypes<ResolversParentTypes>['Page'];
  CatalogImportsResultEdge: CatalogImportsResultEdge;
  CatalogImportNode: Omit<CatalogImportNode, 'job'> & { job: ResolversParentTypes['CatalogImportJob'] };
  CategoryProducts: CategoryProducts;
  ChatHasSupplierEmailSupportResponse: ResolversUnionTypes<ResolversParentTypes>['ChatHasSupplierEmailSupportResponse'];
  ChatHasSupplierEmailSupportResult: ChatHasSupplierEmailSupportResult;
  ChatNotFoundError: ChatNotFoundError;
  ChatNotificationPreferences: ChatNotificationPreferences;
  ChatNotificationUserLists: ChatNotificationUserLists;
  ChatSubCatalogProductsInput: ChatSubCatalogProductsInput;
  ProductFilter: ProductFilter;
  ChatSubCatalogProductsResponse: ResolversUnionTypes<ResolversParentTypes>['ChatSubCatalogProductsResponse'];
  ValidationError: ValidationError;
  ChatSubCatalogProductsError: ChatSubCatalogProductsError;
  ProductSearchResult: ProductSearchResult;
  ChatUser: ChatUser;
  FetchBuyerReportDownloadUrlInput: FetchBuyerReportDownloadUrlInput;
  FetchBuyerReportDownloadUrlResponse: ResolversUnionTypes<ResolversParentTypes>['FetchBuyerReportDownloadUrlResponse'];
  BuyerReport: BuyerReport;
  BuyerReportGenerationError: BuyerReportGenerationError;
  BuyerReportNotFoundError: BuyerReportNotFoundError;
  CatalogCategory: CatalogCategory;
  FetchCatalogCategoriesForChatResponse: ResolversUnionTypes<ResolversParentTypes>['FetchCatalogCategoriesForChatResponse'];
  CatalogCategoriesResponse: CatalogCategoriesResponse;
  OrderGuideProductArgs: OrderGuideProductArgs;
  OrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideResponse'];
  OrderGuide: OrderGuide;
  OrderGuideCategory: OrderGuideCategory;
  OrderGuideProduct: OrderGuideProduct;
  OrderGuideProductItem: Omit<OrderGuideProductItem, 'derivedPriceForOrderGuide'> & { derivedPriceForOrderGuide?: Maybe<ResolversParentTypes['DerivedPriceForOrderGuideResponse']> };
  OrderGuideFailure: OrderGuideFailure;
  EmbedDashboardUrlResponse: EmbedDashboardUrlResponse;
  GetAllBuyerReportSchedulesInput: GetAllBuyerReportSchedulesInput;
  GetAllBuyerReportSchedulesResponse: ResolversUnionTypes<ResolversParentTypes>['GetAllBuyerReportSchedulesResponse'];
  BuyerReportSchedules: BuyerReportSchedules;
  BuyerReportSchedule: BuyerReportSchedule;
  AppliedChatDeliverySettingResponse: ResolversUnionTypes<ResolversParentTypes>['AppliedChatDeliverySettingResponse'];
  AppliedChatDeliverySetting: Omit<AppliedChatDeliverySetting, 'exceptions'> & { exceptions?: Maybe<Array<ResolversParentTypes['DeliverySettingException']>> };
  SuggestedProductResult: ResolversUnionTypes<ResolversParentTypes>['SuggestedProductResult'];
  SuggestedProductSuccessResponse: SuggestedProductSuccessResponse;
  SuggestedProductConnection: SuggestedProductConnection;
  SuggestedProductEdge: SuggestedProductEdge;
  SuggestedProduct: SuggestedProduct;
  GetSuggestedProductsErrorResponse: GetSuggestedProductsErrorResponse;
  GetCatalogUploadUrlResponse: ResolversUnionTypes<ResolversParentTypes>['GetCatalogUploadUrlResponse'];
  SupplierNotFound: SupplierNotFound;
  GetCatalogUploadUrlResult: GetCatalogUploadUrlResult;
  GetChatCountByCCEmailResponse: ResolversUnionTypes<ResolversParentTypes>['GetChatCountByCCEmailResponse'];
  GetChatCountByCCEmailReport: GetChatCountByCcEmailReport;
  GetChatSuppliersByLocationsInput: GetChatSuppliersByLocationsInput;
  GetChatSuppliersByLocationsResponse: ResolversUnionTypes<ResolversParentTypes>['GetChatSuppliersByLocationsResponse'];
  ChatSuppliersByLocations: ChatSuppliersByLocations;
  SupplierDetails: SupplierDetails;
  GetChatsForSubCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['GetChatsForSubCatalogResponse'];
  GetChatsForSubCatalogResult: GetChatsForSubCatalogResult;
  SubCatalogNotFoundError: SubCatalogNotFoundError;
  ConnectedAccountInput: ConnectedAccountInput;
  GetConnectedAccountsResponse: ResolversUnionTypes<ResolversParentTypes>['GetConnectedAccountsResponse'];
  ConnectedAccountConnection: ConnectedAccountConnection;
  ConnectedAccountEdge: ConnectedAccountEdge;
  ConnectedAccount: ConnectedAccount;
  GetConnectedIntegrationAdaptersInput: GetConnectedIntegrationAdaptersInput;
  GetConnectedIntegrationAdaptersResponse: ResolversUnionTypes<ResolversParentTypes>['GetConnectedIntegrationAdaptersResponse'];
  IntegrationAdapterConnectionBaseResultConnection: IntegrationAdapterConnectionBaseResultConnection;
  IntegrationAdapterConnectionBaseResultEdge: IntegrationAdapterConnectionBaseResultEdge;
  IntegrationAdapterConnectionBaseResult: IntegrationAdapterConnectionBaseResult;
  IntegrationAdapterConnectionAdminResultConnection: IntegrationAdapterConnectionAdminResultConnection;
  IntegrationAdapterConnectionAdminResultEdge: IntegrationAdapterConnectionAdminResultEdge;
  IntegrationAdapterConnectionAdminResult: IntegrationAdapterConnectionAdminResult;
  IntegrationAdapterConnectionWebhook: IntegrationAdapterConnectionWebhook;
  GetEmailListsInput: GetEmailListsInput;
  GetEmailListsResponse: ResolversUnionTypes<ResolversParentTypes>['GetEmailListsResponse'];
  EmailLists: EmailLists;
  EmailList: EmailList;
  GetFeatureFlagsResponse: ResolversUnionTypes<ResolversParentTypes>['GetFeatureFlagsResponse'];
  FeatureFlags: FeatureFlags;
  FeatureFlag: FeatureFlag;
  GroupResponse: ResolversUnionTypes<ResolversParentTypes>['GroupResponse'];
  GroupResponseSuccess: GroupResponseSuccess;
  Group: Group;
  GroupCreatedBy: GroupCreatedBy;
  GroupResponseError: GroupResponseError;
  GetGroupEntitiesInput: GetGroupEntitiesInput;
  GetGroupEntitiesFilterInput: GetGroupEntitiesFilterInput;
  GetGroupEntitiesResponse: ResolversUnionTypes<ResolversParentTypes>['GetGroupEntitiesResponse'];
  GetGroupEntitiesSuccessResponse: GetGroupEntitiesSuccessResponse;
  GroupEntityConnection: GroupEntityConnection;
  GroupEntityEdge: Omit<GroupEntityEdge, 'node'> & { node: ResolversParentTypes['GroupEntityNode'] };
  GroupEntityNode: ResolversUnionTypes<ResolversParentTypes>['GroupEntityNode'];
  GroupEntityBuyer: GroupEntityBuyer;
  GroupEntity: ResolversInterfaceTypes<ResolversParentTypes>['GroupEntity'];
  GroupEntitySupplier: GroupEntitySupplier;
  GetGroupEntitiesErrorResponse: GetGroupEntitiesErrorResponse;
  GetGroupUsersInput: GetGroupUsersInput;
  GetGroupUsersResponse: ResolversUnionTypes<ResolversParentTypes>['GetGroupUsersResponse'];
  GetGroupUsersSuccessResponse: GetGroupUsersSuccessResponse;
  GroupUserConnection: GroupUserConnection;
  GroupUserEdge: GroupUserEdge;
  GroupUser: GroupUser;
  GetGroupUsersErrorResponse: GetGroupUsersErrorResponse;
  GetIntegrationAdaptersInput: GetIntegrationAdaptersInput;
  GetIntegrationAdaptersResponse: ResolversUnionTypes<ResolversParentTypes>['GetIntegrationAdaptersResponse'];
  IntegrationAdapterBaseResultConnection: IntegrationAdapterBaseResultConnection;
  IntegrationAdapterBaseResultEdge: IntegrationAdapterBaseResultEdge;
  IntegrationAdapterBaseResult: Omit<IntegrationAdapterBaseResult, 'auth'> & { auth: ResolversParentTypes['IntegrationAdapterAuthBase'] };
  IntegrationAdapterAuthBase: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterAuthBase'];
  IntegrationAdapterAuthorizationCodeAuthBase: IntegrationAdapterAuthorizationCodeAuthBase;
  IntegrationAdapterClientCredentialsAuthBase: IntegrationAdapterClientCredentialsAuthBase;
  IntegrationAdapterAPIKeyAuthBase: IntegrationAdapterApiKeyAuthBase;
  IntegrationAdapterAdminResultConnection: IntegrationAdapterAdminResultConnection;
  IntegrationAdapterAdminResultEdge: IntegrationAdapterAdminResultEdge;
  IntegrationAdapterAdminResult: Omit<IntegrationAdapterAdminResult, 'auth'> & { auth: ResolversParentTypes['IntegrationAdapterAuth'] };
  IntegrationAdapterAuth: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterAuth'];
  IntegrationAdapterAuthorizationCodeAuth: IntegrationAdapterAuthorizationCodeAuth;
  IntegrationAdapterClientCredentialsAuth: IntegrationAdapterClientCredentialsAuth;
  IntegrationAdapterAPIKeyAuth: IntegrationAdapterApiKeyAuth;
  IntegrationAdapterWebhook: Omit<IntegrationAdapterWebhook, 'auth'> & { auth: ResolversParentTypes['IntegrationAdapterWebhookAuth'] };
  IntegrationAdapterWebhookAuth: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterWebhookAuth'];
  IntegrationAdapterWebhookBasicAuth: IntegrationAdapterWebhookBasicAuth;
  IntegrationAdapterWebhookSignatureAuth: IntegrationAdapterWebhookSignatureAuth;
  GetInviteTransmissionStatus: GetInviteTransmissionStatus;
  GetInviteTransmissionStatusResponse: ResolversUnionTypes<ResolversParentTypes>['GetInviteTransmissionStatusResponse'];
  InviteTransmissionStatus: InviteTransmissionStatus;
  GetInviteeBuyersResponse: ResolversUnionTypes<ResolversParentTypes>['GetInviteeBuyersResponse'];
  InviteeNotFound: InviteeNotFound;
  InviteeBuyers: InviteeBuyers;
  MessagesFromChatResult: MessagesFromChatResult;
  MessageEvent: Omit<MessageEvent, 'target'> & { target?: Maybe<Array<Maybe<ResolversParentTypes['EventTarget']>>> };
  LocationsBySupplierResponse: ResolversUnionTypes<ResolversParentTypes>['LocationsBySupplierResponse'];
  LocationsBySupplierSuccess: LocationsBySupplierSuccess;
  LocationBySupplier: LocationBySupplier;
  MarketingMessageSuggestionsResult: ResolversUnionTypes<ResolversParentTypes>['MarketingMessageSuggestionsResult'];
  MarketingMessageSuggestionsSuccess: MarketingMessageSuggestionsSuccess;
  MarketingMessageRefinementTip: MarketingMessageRefinementTip;
  MarketingMessageSuggestionsError: MarketingMessageSuggestionsError;
  MarketingMessageSuggestionsErrorNoSuggestions: MarketingMessageSuggestionsErrorNoSuggestions;
  MarketingMessageSuggestionsErrorThrottling: MarketingMessageSuggestionsErrorThrottling;
  GetOmniChannelOrderInput: GetOmniChannelOrderInput;
  GetOmniChannelOrderResponse: ResolversUnionTypes<ResolversParentTypes>['GetOmniChannelOrderResponse'];
  GetOnboardingChecklistResponse: ResolversUnionTypes<ResolversParentTypes>['GetOnboardingChecklistResponse'];
  OnboardingChecklist: OnboardingChecklist;
  OnboardingChecklistItem: Omit<OnboardingChecklistItem, 'value'> & { value: ResolversParentTypes['OnboardingChecklistItemValue'] };
  OnboardingChecklistItemValue: ResolversUnionTypes<ResolversParentTypes>['OnboardingChecklistItemValue'];
  OnboardingChecklistBooleanValue: OnboardingChecklistBooleanValue;
  OnboardingChecklistNumericValue: OnboardingChecklistNumericValue;
  GetProductsForChatInput: GetProductsForChatInput;
  GetProductsForChatFilter: GetProductsForChatFilter;
  GetProductsForChatResponse: ResolversUnionTypes<ResolversParentTypes>['GetProductsForChatResponse'];
  GetProductsForChatResult: GetProductsForChatResult;
  InvalidProduct: InvalidProduct;
  GetQboCustomersAndOrderGuidesToImportResponse: ResolversUnionTypes<ResolversParentTypes>['GetQboCustomersAndOrderGuidesToImportResponse'];
  QboCustomersAndOrderGuidesToImport: QboCustomersAndOrderGuidesToImport;
  GetReconciliationRequestPlanBySupplierIdResponse: ResolversUnionTypes<ResolversParentTypes>['GetReconciliationRequestPlanBySupplierIdResponse'];
  ReconciliationRequestPlan: ReconciliationRequestPlan;
  ReconciliationRequestPlanBySupplierIdNotFound: ReconciliationRequestPlanBySupplierIdNotFound;
  GetReferralInput: GetReferralInput;
  GetRequestsToJoinInput: GetRequestsToJoinInput;
  GetRequestsToJoinFilter: GetRequestsToJoinFilter;
  GetRequestsToJoinResponse: ResolversUnionTypes<ResolversParentTypes>['GetRequestsToJoinResponse'];
  RequestsToJoinConnection: RequestsToJoinConnection;
  UserRequestToJoinEdge: UserRequestToJoinEdge;
  UserRequestToJoin: UserRequestToJoin;
  SalesRepDetails: SalesRepDetails;
  GetSmsMessageByMessageSidResponse: ResolversUnionTypes<ResolversParentTypes>['GetSmsMessageByMessageSidResponse'];
  GetSmsMessageByMessageSidSuccess: GetSmsMessageByMessageSidSuccess;
  SmsMessage: SmsMessage;
  SmsMessageMedia: SmsMessageMedia;
  GetSmsMessagesFromPhoneNumberResponse: ResolversUnionTypes<ResolversParentTypes>['GetSmsMessagesFromPhoneNumberResponse'];
  GetSmsMessagesFromPhoneNumberSuccess: GetSmsMessagesFromPhoneNumberSuccess;
  GetSubCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['GetSubCatalogResponse'];
  GetSubCatalogsForChatResponse: ResolversUnionTypes<ResolversParentTypes>['GetSubCatalogsForChatResponse'];
  GetSubCatalogsForChatResult: GetSubCatalogsForChatResult;
  GetSupplierApplicationsInput: GetSupplierApplicationsInput;
  GetSupplierApplicationsResponse: ResolversUnionTypes<ResolversParentTypes>['GetSupplierApplicationsResponse'];
  SupplierApplications: SupplierApplications;
  ApplicationData: Omit<ApplicationData, 'data'> & { data?: Maybe<ResolversParentTypes['CredentialsData']> };
  CredentialsData: ResolversUnionTypes<ResolversParentTypes>['CredentialsData'];
  QbdCredentials: QbdCredentials;
  GetSupplierProductsInput: GetSupplierProductsInput;
  GetSupplierProductsResponse: ResolversUnionTypes<ResolversParentTypes>['GetSupplierProductsResponse'];
  GetSupplierProductsResult: GetSupplierProductsResult;
  GetUnconnectedBuyerIdsResult: ResolversUnionTypes<ResolversParentTypes>['GetUnconnectedBuyerIdsResult'];
  UnconnectedBuyers: UnconnectedBuyers;
  NoUnconnectedBuyers: NoUnconnectedBuyers;
  UserIntercomCredentialsResponse: ResolversUnionTypes<ResolversParentTypes>['UserIntercomCredentialsResponse'];
  UserIntercomCredentialsSuccess: UserIntercomCredentialsSuccess;
  UserIntercomCredentialsFailure: UserIntercomCredentialsFailure;
  GetWhatsAppMessageByMessageSidResponse: ResolversUnionTypes<ResolversParentTypes>['GetWhatsAppMessageByMessageSidResponse'];
  GetWhatsAppMessageByMessageSidSuccess: GetWhatsAppMessageByMessageSidSuccess;
  WhatsAppMessage: WhatsAppMessage;
  WhatsAppMessageMedia: WhatsAppMessageMedia;
  HasUserCompletedDeliveryCheckResponse: ResolversUnionTypes<ResolversParentTypes>['HasUserCompletedDeliveryCheckResponse'];
  HasCompletedDeliveryCheckResult: HasCompletedDeliveryCheckResult;
  OrderNotFound: OrderNotFound;
  InventoryDownloadJobsInput: InventoryDownloadJobsInput;
  InventoryDownloadJobsFilter: InventoryDownloadJobsFilter;
  InventoryDownloadJobsResponse: ResolversUnionTypes<ResolversParentTypes>['InventoryDownloadJobsResponse'];
  InventoryDownloadJobsSuccess: InventoryDownloadJobsSuccess;
  InventoryDownloadJob: Omit<InventoryDownloadJob, 'report'> & { report?: Maybe<ResolversParentTypes['InventoryDownloadJobReport']> };
  InventoryDownloadJobReport: ResolversUnionTypes<ResolversParentTypes>['InventoryDownloadJobReport'];
  InventoryDownloadJobCompleted: InventoryDownloadJobCompleted;
  InventoryDownloadJobFailed: InventoryDownloadJobFailed;
  InventoryDownloadJobsFailure: InventoryDownloadJobsFailure;
  InventorySuppliersInput: InventorySuppliersInput;
  InventorySuppliersResponse: ResolversUnionTypes<ResolversParentTypes>['InventorySuppliersResponse'];
  InventorySuppliersSuccess: InventorySuppliersSuccess;
  InventorySupplier: InventorySupplier;
  InventorySuppliersFailure: InventorySuppliersFailure;
  InventoryUploadJobInput: InventoryUploadJobInput;
  InventoryUploadJobResponse: ResolversUnionTypes<ResolversParentTypes>['InventoryUploadJobResponse'];
  InventoryUploadJobSuccess: InventoryUploadJobSuccess;
  InventoryUploadJobFailure: InventoryUploadJobFailure;
  InventoryUploadTemplateInput: InventoryUploadTemplateInput;
  InventoryUploadTemplateResponse: ResolversUnionTypes<ResolversParentTypes>['InventoryUploadTemplateResponse'];
  InventoryUploadTemplateResponseSuccess: InventoryUploadTemplateResponseSuccess;
  InventoryUploadTemplateResponseFailure: InventoryUploadTemplateResponseFailure;
  PaymentAccountOwnerInput: PaymentAccountOwnerInput;
  ListSubCatalogProductsInput: ListSubCatalogProductsInput;
  ListSubCatalogProductsResponse: ResolversUnionTypes<ResolversParentTypes>['ListSubCatalogProductsResponse'];
  ListSubCatalogProductsError: ListSubCatalogProductsError;
  ListSubCatalogsResponse: ResolversUnionTypes<ResolversParentTypes>['ListSubCatalogsResponse'];
  SubCatalogConnection: SubCatalogConnection;
  SubCatalogEdge: SubCatalogEdge;
  LookupPhoneNumbersResponse: ResolversUnionTypes<ResolversParentTypes>['LookupPhoneNumbersResponse'];
  LookupPhoneNumbersSuccess: Omit<LookupPhoneNumbersSuccess, 'lookups'> & { lookups: Array<ResolversParentTypes['PhoneNumberLookup']> };
  PhoneNumberLookup: ResolversUnionTypes<ResolversParentTypes>['PhoneNumberLookup'];
  PhoneNumberLookupSuccess: PhoneNumberLookupSuccess;
  PhoneNumberLookupError: PhoneNumberLookupError;
  LookupPhoneNumbersError: LookupPhoneNumbersError;
  MetaLobbyResponse: ResolversUnionTypes<ResolversParentTypes>['MetaLobbyResponse'];
  MetaLobbyResult: MetaLobbyResult;
  UserLobbyBuyerConnection: UserLobbyBuyerConnection;
  UserLobbyBuyerEdge: UserLobbyBuyerEdge;
  LobbyBuyer: LobbyBuyer;
  InvalidCursor: InvalidCursor;
  OrderGuideV2CategoriesInput: OrderGuideV2CategoriesInput;
  OrderGuideV2CategoriesResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideV2CategoriesResponse'];
  OrderGuideV2CategoriesResult: OrderGuideV2CategoriesResult;
  OrderGuideV2CategoriesResultEdge: OrderGuideV2CategoriesResultEdge;
  OrderGuideV2Category: OrderGuideV2Category;
  OrderGuideV2ItemUnitsInput: OrderGuideV2ItemUnitsInput;
  OrderGuideV2ItemUnitsFilter: OrderGuideV2ItemUnitsFilter;
  OrderGuideV2ItemUnitsResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideV2ItemUnitsResponse'];
  OrderGuideV2ItemUnitsResult: OrderGuideV2ItemUnitsResult;
  OrderGuideV2ItemUnitsResultEdge: OrderGuideV2ItemUnitsResultEdge;
  OrderGuideV2ItemUnit: OrderGuideV2ItemUnit;
  OrderGuideV2CategoryRef: OrderGuideV2CategoryRef;
  VendorItemUnitRef: VendorItemUnitRef;
  VendorItemUnit: VendorItemUnit;
  Rational: Rational;
  VendorItemUnitImage: VendorItemUnitImage;
  ImageAsset: ImageAsset;
  ImageAssetUrl: ImageAssetUrl;
  VendorItemUnitPriceInput: VendorItemUnitPriceInput;
  VendorItemUnitPriceSet: VendorItemUnitPriceSet;
  MoneyV2: MoneyV2;
  VendorItemRef: VendorItemRef;
  VendorItem: VendorItem;
  VendorItemVariantGroup: VendorItemVariantGroup;
  VendorItemUnitsFilter: VendorItemUnitsFilter;
  VendorItemCategory: VendorItemCategory;
  VendorItemCategoryRef: VendorItemCategoryRef;
  VendorItemCategoryImage: VendorItemCategoryImage;
  OrdersToReviewInput: OrdersToReviewInput;
  OrdersToReviewResponse: ResolversUnionTypes<ResolversParentTypes>['OrdersToReviewResponse'];
  OrdersToReviewConnection: OrdersToReviewConnection;
  OrdersToReviewEdge: OrdersToReviewEdge;
  PaymentOptionsInput: PaymentOptionsInput;
  PaymentOptionsResponse: ResolversUnionTypes<ResolversParentTypes>['PaymentOptionsResponse'];
  PublicToken: PublicToken;
  Redirect: Redirect;
  SearchInput: SearchInput;
  SearchFilter: SearchFilter;
  UserFilter: UserFilter;
  ChatFilter: ChatFilter;
  BroadcastFilter: BroadcastFilter;
  OrderFilter: OrderFilter;
  BuyerFilter: BuyerFilter;
  SupplierFilter: SupplierFilter;
  CoordinateInput: CoordinateInput;
  SearchResult: SearchResult;
  SearchItem: Omit<SearchItem, 'entity'> & { entity?: Maybe<ResolversParentTypes['SearchEntity']> };
  SearchEntity: ResolversUnionTypes<ResolversParentTypes>['SearchEntity'];
  SearchBuyerInput: SearchBuyerInput;
  SearchBuyerFilter: SearchBuyerFilter;
  GooglePlaceEstablishment: GooglePlaceEstablishment;
  SearchBuyerFilterV2: SearchBuyerFilterV2;
  SearchBuyerResponse: ResolversUnionTypes<ResolversParentTypes>['SearchBuyerResponse'];
  SearchBuyerConnection: SearchBuyerConnection;
  BuyerEdge: BuyerEdge;
  SearchGroupsInput: SearchGroupsInput;
  SearchGroupsFilterInput: SearchGroupsFilterInput;
  SearchGroupsResponse: ResolversUnionTypes<ResolversParentTypes>['SearchGroupsResponse'];
  SearchGroupsSuccessResponse: SearchGroupsSuccessResponse;
  GroupConnection: GroupConnection;
  GroupEdge: GroupEdge;
  SearchGroupsErrorResponse: SearchGroupsErrorResponse;
  SearchOrderInput: SearchOrderInput;
  SearchOrderResponse: ResolversUnionTypes<ResolversParentTypes>['SearchOrderResponse'];
  SearchOrderConnection: SearchOrderConnection;
  SearchOrderEdge: SearchOrderEdge;
  SearchOrderDeskCustomerInput: SearchOrderDeskCustomerInput;
  SearchOrderDeskCustomerResponse: ResolversUnionTypes<ResolversParentTypes>['SearchOrderDeskCustomerResponse'];
  OrderDeskChatsConnection: OrderDeskChatsConnection;
  OrderDeskChatsEdge: OrderDeskChatsEdge;
  SearchProductsInput: SearchProductsInput;
  SearchProductsResponse: ResolversUnionTypes<ResolversParentTypes>['SearchProductsResponse'];
  SearchProductsConnection: SearchProductsConnection;
  SearchProductsEdge: SearchProductsEdge;
  SearchProductsError: SearchProductsError;
  SearchTaxonomyLabelsInput: SearchTaxonomyLabelsInput;
  SearchTaxonomyLabelsResponse: ResolversUnionTypes<ResolversParentTypes>['SearchTaxonomyLabelsResponse'];
  SearchTaxonomyLabelsConnection: SearchTaxonomyLabelsConnection;
  SearchTaxonomyLabelsEdge: SearchTaxonomyLabelsEdge;
  TaxonomyLabel: TaxonomyLabel;
  SearchTaxonomyLabelsError: SearchTaxonomyLabelsError;
  SendSampleSmsMessageInput: SendSampleSmsMessageInput;
  SendSampleSmsMessageMediaInput: SendSampleSmsMessageMediaInput;
  SendSampleSmsMessageResponse: ResolversUnionTypes<ResolversParentTypes>['SendSampleSmsMessageResponse'];
  SendSampleSmsMessageSuccess: SendSampleSmsMessageSuccess;
  SendSampleSmsMessageFailure: SendSampleSmsMessageFailure;
  SharedBroadcastProducts: SharedBroadcastProducts;
  StockCountSessionsInput: StockCountSessionsInput;
  StockCountSessionsFilter: StockCountSessionsFilter;
  StockCountSessionsPaginationInput: StockCountSessionsPaginationInput;
  StockCountSessionsResponse: ResolversUnionTypes<ResolversParentTypes>['StockCountSessionsResponse'];
  StockCountSessionsSuccess: StockCountSessionsSuccess;
  StockCountSession: StockCountSession;
  CountDetails: CountDetails;
  StockItemPrice: StockItemPrice;
  StockItem: StockItem;
  StockCountSessionsPaginationInfo: StockCountSessionsPaginationInfo;
  StockCountUsersInput: StockCountUsersInput;
  StockCountUsersResponse: ResolversUnionTypes<ResolversParentTypes>['StockCountUsersResponse'];
  StockCountUsersSuccess: StockCountUsersSuccess;
  StockCountUser: StockCountUser;
  StorageAreasInput: StorageAreasInput;
  StorageAreasResponse: ResolversUnionTypes<ResolversParentTypes>['StorageAreasResponse'];
  StorageAreasSuccess: StorageAreasSuccess;
  StorageArea: StorageArea;
  StorageAreaStorageItemsInput: StorageAreaStorageItemsInput;
  StorageItemsFilter: StorageItemsFilter;
  StorageItem: StorageItem;
  InventoryItem: Omit<InventoryItem, 'vendor'> & { vendor?: Maybe<ResolversParentTypes['ItemVendor']> };
  ItemVendor: ResolversUnionTypes<ResolversParentTypes>['ItemVendor'];
  ChocoVendor: ChocoVendor;
  BuyerExternalVendor: BuyerExternalVendor;
  ItemPrice: ItemPrice;
  ItemUnit: ItemUnit;
  StorageItemCount: StorageItemCount;
  supplierAssortments: SupplierAssortments;
  ChatLabelsResult: ChatLabelsResult;
  SupplierDeliveryDateSettingsResponse: ResolversUnionTypes<ResolversParentTypes>['SupplierDeliveryDateSettingsResponse'];
  SupplierDeliverySettingsNotFound: SupplierDeliverySettingsNotFound;
  SupplierSearchInput: SupplierSearchInput;
  SupplierSearchFilter: SupplierSearchFilter;
  SupplierSearchResponse: ResolversUnionTypes<ResolversParentTypes>['SupplierSearchResponse'];
  SearchSupplierConnection: SearchSupplierConnection;
  SupplierSearchEdge: SupplierSearchEdge;
  SupplierSearchV2Filter: SupplierSearchV2Filter;
  UserChatsResponse: ResolversUnionTypes<ResolversParentTypes>['UserChatsResponse'];
  UserChatsError: UserChatsError;
  UserSearchInput: UserSearchInput;
  UserSearchFilter: UserSearchFilter;
  UserSearchResponse: ResolversUnionTypes<ResolversParentTypes>['UserSearchResponse'];
  UserSearchConnection: UserSearchConnection;
  UserSearchEdge: UserSearchEdge;
  ValidateProductsAvailabilityInput: ValidateProductsAvailabilityInput;
  ValidateProductsAvailabilityResponse: ResolversUnionTypes<ResolversParentTypes>['ValidateProductsAvailabilityResponse'];
  ValidateProductsAvailabilityResult: ValidateProductsAvailabilityResult;
  VendorItemCategoriesForChatInput: VendorItemCategoriesForChatInput;
  VendorItemCategoriesForChatFilter: VendorItemCategoriesForChatFilter;
  VendorItemCategoriesForChatResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemCategoriesForChatResponse'];
  VendorItemCategoriesForChatSuccess: VendorItemCategoriesForChatSuccess;
  VendorItemCategoriesForChatResultEdge: VendorItemCategoriesForChatResultEdge;
  VendorItemsInput: VendorItemsInput;
  VendorItemsResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemsResponse'];
  VendorItemsSuccess: VendorItemsSuccess;
  VendorItemsCountForChatInput: VendorItemsCountForChatInput;
  VendorItemsCountForChatFilter: VendorItemsCountForChatFilter;
  VendorItemsCountForChatResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemsCountForChatResponse'];
  VendorItemsCountForChatSuccess: VendorItemsCountForChatSuccess;
  VendorItemsForChatInput: VendorItemsForChatInput;
  VendorItemsForChatFilterInput: VendorItemsForChatFilterInput;
  VendorItemsForChatResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemsForChatResponse'];
  VendorItemsForChatSuccess: VendorItemsForChatSuccess;
  VendorItemsForChatResultEdge: VendorItemsForChatResultEdge;
  VendorItemsForVendorInput: VendorItemsForVendorInput;
  VendorItemsForVendorFilter: VendorItemsForVendorFilter;
  VendorItemsForVendorSort: VendorItemsForVendorSort;
  VendorItemsForVendorResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemsForVendorResponse'];
  VendorItemsForVendorResult: VendorItemsForVendorResult;
  VendorItemsForVendorResultEdge: VendorItemsForVendorResultEdge;
  Mutation: {};
  AcceptOrderInput: AcceptOrderInput;
  OrderedProductInput: OrderedProductInput;
  AcceptedProductInput: AcceptedProductInput;
  AcceptOrderResponse: ResolversUnionTypes<ResolversParentTypes>['AcceptOrderResponse'];
  OrderAlreadyAccepted: OrderAlreadyAccepted;
  OrderCreatedError: OrderCreatedError;
  UnavailableProductType: UnavailableProductType;
  ActivateSuppliersPaymentAccountInput: ActivateSuppliersPaymentAccountInput;
  ActivateSuppliersPaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['ActivateSuppliersPaymentAccountResponse'];
  SuppliersPaymentAccount: SuppliersPaymentAccount;
  ExternalAccountDetailsMissed: ExternalAccountDetailsMissed;
  ExternalAccountNotFound: ExternalAccountNotFound;
  SupplierHasActivePaymentAccountAlready: SupplierHasActivePaymentAccountAlready;
  AddBuyerStockInventoryProductInput: AddBuyerStockInventoryProductInput;
  MoneyInput: MoneyInput;
  AddBuyerStockInventoryProductResponse: ResolversUnionTypes<ResolversParentTypes>['AddBuyerStockInventoryProductResponse'];
  AddBuyerStockInventoryProductFailure: AddBuyerStockInventoryProductFailure;
  ProductNotFoundError: ProductNotFoundError;
  ProductsCategoryInput: ProductsCategoryInput;
  AddEntitiesToGroupInput: AddEntitiesToGroupInput;
  GroupEntityInput: GroupEntityInput;
  AddEntitiesToGroupResponse: ResolversUnionTypes<ResolversParentTypes>['AddEntitiesToGroupResponse'];
  AddEntitiesToGroupResponseSuccess: AddEntitiesToGroupResponseSuccess;
  AddEntitiesToGroupResponseError: AddEntitiesToGroupResponseError;
  AddInvoiceInput: AddInvoiceInput;
  AddInvoiceResponse: ResolversUnionTypes<ResolversParentTypes>['AddInvoiceResponse'];
  ChatHasNoSupplierEntity: ChatHasNoSupplierEntity;
  OrderAlreadyHasInvoice: OrderAlreadyHasInvoice;
  AddMarketingProductsToCartInput: AddMarketingProductsToCartInput;
  AddMarketingProductsToCartResponse: ResolversUnionTypes<ResolversParentTypes>['AddMarketingProductsToCartResponse'];
  AddMarketingProductsToCartSuccess: Omit<AddMarketingProductsToCartSuccess, 'teamCartData'> & { teamCartData: ResolversParentTypes['AddMarketingProductsToCartTeamCartData'] };
  AddMarketingProductsToCartTeamCartData: ResolversUnionTypes<ResolversParentTypes>['AddMarketingProductsToCartTeamCartData'];
  TeamCartExists: TeamCartExists;
  TeamCartNotFound: TeamCartNotFound;
  PaymentAccountInput: PaymentAccountInput;
  CreditCardDetailsInput: CreditCardDetailsInput;
  BankAccountDetailsInput: BankAccountDetailsInput;
  AddPaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['AddPaymentAccountResponse'];
  PaymentMethodNotAvailableForUser: PaymentMethodNotAvailableForUser;
  SupplierPaymentAccountAlreadyExists: SupplierPaymentAccountAlreadyExists;
  PaymentAccountAlreadyExists: PaymentAccountAlreadyExists;
  AddProductsToOrderGuidesInput: AddProductsToOrderGuidesInput;
  AddProductToOrderGuidesInput: AddProductToOrderGuidesInput;
  AddProductsToOrderGuidesResponse: ResolversUnionTypes<ResolversParentTypes>['AddProductsToOrderGuidesResponse'];
  AddProductsToOrderGuidesResult: AddProductsToOrderGuidesResult;
  LocationProductsResult: LocationProductsResult;
  LocationProductResult: LocationProductResult;
  AddSalesRepRequestToJoinInput: AddSalesRepRequestToJoinInput;
  AddSalesRepDetailsInput: AddSalesRepDetailsInput;
  AddSalesRepRequestToJoinResponse: ResolversUnionTypes<ResolversParentTypes>['AddSalesRepRequestToJoinResponse'];
  AddSalesRepSuccess: AddSalesRepSuccess;
  AddSalesRepError: AddSalesRepError;
  BuyerAddSupplierInput: BuyerAddSupplierInput;
  BuyerAddSupplierResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerAddSupplierResponse'];
  BuyerAddSupplier: BuyerAddSupplier;
  BuyerAddSupplierError: BuyerAddSupplierError;
  AddSuppliersPaymentAccountInput: AddSuppliersPaymentAccountInput;
  AddSuppliersPaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['AddSuppliersPaymentAccountResponse'];
  SupplierPaymentsDisabled: SupplierPaymentsDisabled;
  AddUsersToGroupInput: AddUsersToGroupInput;
  GroupUserInput: GroupUserInput;
  AddUsersToGroupResponse: ResolversUnionTypes<ResolversParentTypes>['AddUsersToGroupResponse'];
  AddUsersToGroupResponseSuccess: AddUsersToGroupResponseSuccess;
  AddUsersToGroupResponseError: AddUsersToGroupResponseError;
  AssignOrderToUserForReviewInput: AssignOrderToUserForReviewInput;
  AssignOrderToUserForReviewResponse: ResolversUnionTypes<ResolversParentTypes>['AssignOrderToUserForReviewResponse'];
  AssignOrderToUserForReviewResponseSuccess: AssignOrderToUserForReviewResponseSuccess;
  AssignOrderToUserForReviewResponseError: AssignOrderToUserForReviewResponseError;
  BatchOrderConfirmResponse: ResolversUnionTypes<ResolversParentTypes>['BatchOrderConfirmResponse'];
  BatchOrderConfirmSuccess: BatchOrderConfirmSuccess;
  BatchOrderConfirmError: BatchOrderConfirmError;
  BatchUpdateOrderSupplierInput: BatchUpdateOrderSupplierInput;
  BatchUpdateOrderSupplier: BatchUpdateOrderSupplier;
  BroadcastInput: BroadcastInput;
  OneTimeBroadcastScheduleInput: OneTimeBroadcastScheduleInput;
  BroadcastPurposeInput: BroadcastPurposeInput;
  BroadcastUpdatePurposeResult: BroadcastUpdatePurposeResult;
  BulkSendInviteTransmissionInput: BulkSendInviteTransmissionInput;
  BulkSendInviteInvitee: BulkSendInviteInvitee;
  BulkSendInviteTransmissionResponse: ResolversUnionTypes<ResolversParentTypes>['BulkSendInviteTransmissionResponse'];
  BulkInviteTransmissionSuccess: BulkInviteTransmissionSuccess;
  BulkInviteTransmissionFailure: BulkInviteTransmissionFailure;
  BulkSubmitOrderedProductDeliveryCheckInput: BulkSubmitOrderedProductDeliveryCheckInput;
  DeliveryCheckProductInput: DeliveryCheckProductInput;
  DeliveryCheckProblemInput: DeliveryCheckProblemInput;
  OrderedProductMetadataInput: OrderedProductMetadataInput;
  BulkOrderedProductDeliveryCheckSubmissionResponse: ResolversUnionTypes<ResolversParentTypes>['BulkOrderedProductDeliveryCheckSubmissionResponse'];
  BulkOrderedProductDeliveryCheckSubmissionResult: BulkOrderedProductDeliveryCheckSubmissionResult;
  OrderDeliveryItemsMismatched: OrderDeliveryItemsMismatched;
  OrderDeliveryCheckAlreadyCompleted: OrderDeliveryCheckAlreadyCompleted;
  BuyerUserInput: BuyerUserInput;
  BuyerUserRoleInput: BuyerUserRoleInput;
  BuyerCreateInput: BuyerCreateInput;
  BuyerDisableRolesResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerDisableRolesResponse'];
  BuyerUpdateInput: BuyerUpdateInput;
  CancelCartOptionsInput: CancelCartOptionsInput;
  CancelCartResponse: ResolversUnionTypes<ResolversParentTypes>['CancelCartResponse'];
  CancelCartResult: CancelCartResult;
  CartVersionConstraintError: CartVersionConstraintError;
  UserCartItemOperation: UserCartItemOperation;
  CartNotFoundError: CartNotFoundError;
  CatalogImportStartInput: CatalogImportStartInput;
  CatalogImportStartResponse: ResolversUnionTypes<ResolversParentTypes>['CatalogImportStartResponse'];
  CatalogImportStartResult: Omit<CatalogImportStartResult, 'job'> & { job: ResolversParentTypes['CatalogImportJob'] };
  CategoryInput: CategoryInput;
  ChatCreateInput: ChatCreateInput;
  AdminProductInput: AdminProductInput;
  ChatUpdateInput: ChatUpdateInput;
  ChatUpdateCreatedByInput: ChatUpdateCreatedByInput;
  ClaimOnboardingChecklistRewardResponse: ResolversUnionTypes<ResolversParentTypes>['ClaimOnboardingChecklistRewardResponse'];
  ClaimOnboardingChecklistRewardSuccess: ClaimOnboardingChecklistRewardSuccess;
  ClaimOnboardingChecklistRewardError: ClaimOnboardingChecklistRewardError;
  ConfirmDeliveryCheckReconciliationResponse: ResolversUnionTypes<ResolversParentTypes>['ConfirmDeliveryCheckReconciliationResponse'];
  DeliveryCheckReconciliationRequestNotFound: DeliveryCheckReconciliationRequestNotFound;
  DeliveryCheckReconciliationRequestAlreadyConfirmed: DeliveryCheckReconciliationRequestAlreadyConfirmed;
  OrderDeliveryCheckReconciliationRequestIdNotMatched: OrderDeliveryCheckReconciliationRequestIdNotMatched;
  ConnectAccountResponse: ResolversUnionTypes<ResolversParentTypes>['ConnectAccountResponse'];
  ConnectAccountUrl: ConnectAccountUrl;
  ConnectAccountError: ConnectAccountError;
  ConnectIntegrationAdapterInput: ConnectIntegrationAdapterInput;
  ConnectIntegrationAdapterResponse: ResolversUnionTypes<ResolversParentTypes>['ConnectIntegrationAdapterResponse'];
  ChocoEntityNotFound: ChocoEntityNotFound;
  UnsupportedIntegrationAdapterType: UnsupportedIntegrationAdapterType;
  IntegrationAdapterNotFound: IntegrationAdapterNotFound;
  CreateBuyerReportScheduleInput: CreateBuyerReportScheduleInput;
  CreateBuyerReportScheduleResponse: ResolversUnionTypes<ResolversParentTypes>['CreateBuyerReportScheduleResponse'];
  CreateGroupInput: CreateGroupInput;
  CreateOrderDeliveryCheckInput: CreateOrderDeliveryCheckInput;
  OrderDeliveryCheckCreationResponse: ResolversUnionTypes<ResolversParentTypes>['OrderDeliveryCheckCreationResponse'];
  OrderDeliveryCheckExists: OrderDeliveryCheckExists;
  OrderDeliveryCheckImageUploadUrlResponse: ResolversUnionTypes<ResolversParentTypes>['OrderDeliveryCheckImageUploadUrlResponse'];
  OrderDeliveryCheckImageUploadUrlResult: OrderDeliveryCheckImageUploadUrlResult;
  OrderDeliveryCheckImageNotFound: OrderDeliveryCheckImageNotFound;
  CreateOrderDeskEmailList: CreateOrderDeskEmailList;
  OrderDeskEmail: OrderDeskEmail;
  CreateEmailListResponse: ResolversUnionTypes<ResolversParentTypes>['CreateEmailListResponse'];
  EmailListCreated: EmailListCreated;
  CreateProfileInput: CreateProfileInput;
  CreateProfileResponse: ResolversUnionTypes<ResolversParentTypes>['CreateProfileResponse'];
  BuyerExists: BuyerExists;
  CreateProfileError: CreateProfileError;
  CreatePushEndpointInput: CreatePushEndpointInput;
  PushEndpointResponse: ResolversUnionTypes<ResolversParentTypes>['PushEndpointResponse'];
  NotificationPreferences: NotificationPreferences;
  CreateReferralInput: CreateReferralInput;
  CreateReferralResponse: ResolversUnionTypes<ResolversParentTypes>['CreateReferralResponse'];
  UserHasReferralCode: UserHasReferralCode;
  ReferralCodeGenerationError: ReferralCodeGenerationError;
  CreateStorageItemInput: CreateStorageItemInput;
  CreateStorageItemResponse: ResolversUnionTypes<ResolversParentTypes>['CreateStorageItemResponse'];
  CreateStorageItemSuccess: CreateStorageItemSuccess;
  CreateStorageItemFailure: CreateStorageItemFailure;
  createSubCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['createSubCatalogResponse'];
  CreateSubCatalogError: CreateSubCatalogError;
  CreateSupplierContactInput: CreateSupplierContactInput;
  CreateSupplierContactResponse: ResolversUnionTypes<ResolversParentTypes>['CreateSupplierContactResponse'];
  SupplierContact: SupplierContact;
  ProductInput: ProductInput;
  CreateUpdateSupplierProductResponse: ResolversUnionTypes<ResolversParentTypes>['CreateUpdateSupplierProductResponse'];
  DuplicateProductError: DuplicateProductError;
  SupplierProductInput: SupplierProductInput;
  DeactivateSuppliersPaymentAccountInput: DeactivateSuppliersPaymentAccountInput;
  DeactivateSuppliersPaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['DeactivateSuppliersPaymentAccountResponse'];
  DeleteBuyerReportScheduleResponse: ResolversUnionTypes<ResolversParentTypes>['DeleteBuyerReportScheduleResponse'];
  DeleteBuyerReportScheduleSuccess: DeleteBuyerReportScheduleSuccess;
  BuyerReportScheduleNotFound: BuyerReportScheduleNotFound;
  DeleteBuyerReportScheduleError: DeleteBuyerReportScheduleError;
  DeleteBuyerStockInventoryProductsInput: DeleteBuyerStockInventoryProductsInput;
  DeleteBuyerStockInventoryProductsResponse: ResolversUnionTypes<ResolversParentTypes>['DeleteBuyerStockInventoryProductsResponse'];
  DeleteBuyerStockInventoryProductsSuccess: DeleteBuyerStockInventoryProductsSuccess;
  DeleteBuyerStockInventoryProductsFailure: DeleteBuyerStockInventoryProductsFailure;
  DeletedChatSetting: DeletedChatSetting;
  DeleteProductImageInput: DeleteProductImageInput;
  deleteSubCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['deleteSubCatalogResponse'];
  DeleteSubCatalogSuccess: DeleteSubCatalogSuccess;
  DeleteSubCatalogError: DeleteSubCatalogError;
  DeletedSupplierNegotiatedPriceResponse: ResolversUnionTypes<ResolversParentTypes>['DeletedSupplierNegotiatedPriceResponse'];
  DeleteSupplierNegotiatedPriceResult: DeleteSupplierNegotiatedPriceResult;
  DisconnectAccountResponse: ResolversUnionTypes<ResolversParentTypes>['DisconnectAccountResponse'];
  DisconnectAccountStatus: DisconnectAccountStatus;
  DisconnectAccountError: DisconnectAccountError;
  DisconnectIntegrationAdapterInput: DisconnectIntegrationAdapterInput;
  DisconnectIntegrationAdapterResponse: ResolversUnionTypes<ResolversParentTypes>['DisconnectIntegrationAdapterResponse'];
  IntegrationAdapterConnectionNotFound: IntegrationAdapterConnectionNotFound;
  EditBuyerReportScheduleInput: EditBuyerReportScheduleInput;
  EditBuyerReportScheduleResponse: ResolversUnionTypes<ResolversParentTypes>['EditBuyerReportScheduleResponse'];
  GenerateBuyerReportInput: GenerateBuyerReportInput;
  GenerateBuyerReportResponse: ResolversUnionTypes<ResolversParentTypes>['GenerateBuyerReportResponse'];
  GetClientDebuggableArtifactUploadUrlInput: GetClientDebuggableArtifactUploadUrlInput;
  GetClientDebuggableArtifactUploadUrlResponse: ResolversUnionTypes<ResolversParentTypes>['GetClientDebuggableArtifactUploadUrlResponse'];
  GetClientDebuggableArtifactUploadUrl: GetClientDebuggableArtifactUploadUrl;
  GetClientDebuggableArtifactUploadUrlError: GetClientDebuggableArtifactUploadUrlError;
  GetOrderGuideUploadUrlInput: GetOrderGuideUploadUrlInput;
  GetOrderGuideUploadUrlResponse: ResolversUnionTypes<ResolversParentTypes>['GetOrderGuideUploadUrlResponse'];
  GetOrderGuideUploadUrl: GetOrderGuideUploadUrl;
  GetOrderGuideUploadUrlError: GetOrderGuideUploadUrlError;
  ImportSupplierProductsReport: ImportSupplierProductsReport;
  InitInventoryDownloadInput: InitInventoryDownloadInput;
  InitInventoryDownloadResponse: ResolversUnionTypes<ResolversParentTypes>['InitInventoryDownloadResponse'];
  InitInventoryDownloadSuccess: InitInventoryDownloadSuccess;
  InitInventoryDownloadFailure: InitInventoryDownloadFailure;
  InitInventoryUploadInput: InitInventoryUploadInput;
  InitInventoryUploadResponse: ResolversUnionTypes<ResolversParentTypes>['InitInventoryUploadResponse'];
  InitInventoryUploadSuccess: InitInventoryUploadSuccess;
  InitInventoryUploadFailure: InitInventoryUploadFailure;
  InitiateCheckoutResponse: ResolversUnionTypes<ResolversParentTypes>['InitiateCheckoutResponse'];
  BalanceCheckoutToken: BalanceCheckoutToken;
  SupplierPaymentAccountMissing: SupplierPaymentAccountMissing;
  InvoiceAlreadyPaid: InvoiceAlreadyPaid;
  InvoicePaymentInProgress: InvoicePaymentInProgress;
  InvoiceTotalTooLow: InvoiceTotalTooLow;
  IntegrationAdapterConnectionAuthInput: IntegrationAdapterConnectionAuthInput;
  IntegrationAdapterConnectionAuthResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterConnectionAuthResponse'];
  IntegrationAdapterConnectionAuthRedirect: IntegrationAdapterConnectionAuthRedirect;
  IntegrationAdapterConnectionConsentInput: IntegrationAdapterConnectionConsentInput;
  IntegrationAdapterConnectionConsentResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterConnectionConsentResponse'];
  IntegrationAdapterConnectionConsentChallenge: IntegrationAdapterConnectionConsentChallenge;
  IntegrationAdapterConnectionConsentRedirect: IntegrationAdapterConnectionConsentRedirect;
  IntegrationAdapterConnectionCreateInput: IntegrationAdapterConnectionCreateInput;
  IntegrationAdapterConnectionCreateResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterConnectionCreateResponse'];
  IntegrationAdapterScopeInsufficient: IntegrationAdapterScopeInsufficient;
  IntegrationAdapterConnectionUpdateInput: IntegrationAdapterConnectionUpdateInput;
  IntegrationAdapterConnectionUpdateResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterConnectionUpdateResponse'];
  IntegrationAdapterCreateInput: IntegrationAdapterCreateInput;
  IntegrationAdapterAuthInput: IntegrationAdapterAuthInput;
  IntegrationAdapterCreateWebhookInput: IntegrationAdapterCreateWebhookInput;
  WebhookAuthenticationInput: WebhookAuthenticationInput;
  IntegrationAdapterCreateResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterCreateResponse'];
  IntegrationAdapterExists: IntegrationAdapterExists;
  IntegrationAdapterUpdateInput: IntegrationAdapterUpdateInput;
  IntegrationAdapterUpdateWebhookInput: IntegrationAdapterUpdateWebhookInput;
  IntegrationAdapterUpdateResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationAdapterUpdateResponse'];
  AttemptToChangeAdapterAuthType: AttemptToChangeAdapterAuthType;
  AttemptToReduceIntegrationAdapterScope: AttemptToReduceIntegrationAdapterScope;
  IntegrationWebhookRetryInput: IntegrationWebhookRetryInput;
  IntegrationWebhookRetryResponse: ResolversUnionTypes<ResolversParentTypes>['IntegrationWebhookRetryResponse'];
  IntegrationWebhookRetryResults: Omit<IntegrationWebhookRetryResults, 'results'> & { results: Array<ResolversParentTypes['IntegrationWebhookRetryResult']> };
  IntegrationWebhookRetryResult: ResolversUnionTypes<ResolversParentTypes>['IntegrationWebhookRetryResult'];
  IntegrationWebhookRetrySuccess: IntegrationWebhookRetrySuccess;
  IntegrationWebhookRetryFailure: IntegrationWebhookRetryFailure;
  InternalInviteUsersResponse: ResolversUnionTypes<ResolversParentTypes>['InternalInviteUsersResponse'];
  UsersList: UsersList;
  InviteUserToBuyerInput: InviteUserToBuyerInput;
  inviteNonChocoUserToBuyerResponse: ResolversUnionTypes<ResolversParentTypes>['inviteNonChocoUserToBuyerResponse'];
  BuyerNotFound: BuyerNotFound;
  InvitorNotFound: InvitorNotFound;
  ExistingInvitedUser: ExistingInvitedUser;
  PuppyValidationFailure: PuppyValidationFailure;
  InviteUserToBuyerInputV2: InviteUserToBuyerInputV2;
  InviteUserToBuyerResponse: ResolversUnionTypes<ResolversParentTypes>['InviteUserToBuyerResponse'];
  InviteUserToBuyerError: InviteUserToBuyerError;
  KycCreateInput: KycCreateInput;
  KycCreateResponse: ResolversUnionTypes<ResolversParentTypes>['KycCreateResponse'];
  KycResponse: KycResponse;
  KycBuyerNotFound: KycBuyerNotFound;
  KycEntryAlreadyExists: KycEntryAlreadyExists;
  MessageInput: MessageInput;
  GroupIdsInput: GroupIdsInput;
  OrderInput: OrderInput;
  OrderProductInput: OrderProductInput;
  Notification: Notification;
  NotificationPreferencesInput: NotificationPreferencesInput;
  OrderCreateV2Input: OrderCreateV2Input;
  OrderCreatedResponse: ResolversUnionTypes<ResolversParentTypes>['OrderCreatedResponse'];
  OrderEditInput: OrderEditInput;
  EditedOrderProductsInput: EditedOrderProductsInput;
  OrderEditedResponse: ResolversUnionTypes<ResolversParentTypes>['OrderEditedResponse'];
  OrderEditedError: OrderEditedError;
  OrderExportConfigCreateInput: OrderExportConfigCreateInput;
  OrderExportFormatInput: OrderExportFormatInput;
  OrderExportEdiFormatInput: OrderExportEdiFormatInput;
  OrderExportChocoEdiFormatInput: OrderExportChocoEdiFormatInput;
  OrderExportSupplierEdiFormatInput: OrderExportSupplierEdiFormatInput;
  OrderExportCsvFormatInput: OrderExportCsvFormatInput;
  OrderExportLobsterFormatInput: OrderExportLobsterFormatInput;
  OrderExportUploadInput: OrderExportUploadInput;
  OrderExportChocoSftpUploadInput: OrderExportChocoSftpUploadInput;
  OrderExportExternalSftpUploadInput: OrderExportExternalSftpUploadInput;
  OrderExportConfig: Omit<OrderExportConfig, 'orderExportFormat' | 'orderExportUpload'> & { orderExportFormat: ResolversParentTypes['OrderExportConfigFormat'], orderExportUpload: ResolversParentTypes['OrderExportUploadOption'] };
  OrderExportConfigUpdateInput: OrderExportConfigUpdateInput;
  OrderGuideCreatedResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideCreatedResponse'];
  OrderGuideCreatedSuccess: OrderGuideCreatedSuccess;
  OrderGuideCreatedError: OrderGuideCreatedError;
  OrderGuideRequestInput: OrderGuideRequestInput;
  OrderGuideRequestResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideRequestResponse'];
  OrderGuideRequest: OrderGuideRequest;
  OrderGuideRequestError: OrderGuideRequestError;
  OrderGuideV2ItemUnitsAddInput: OrderGuideV2ItemUnitsAddInput;
  OrderGuideV2ItemUnitsAddInputItem: OrderGuideV2ItemUnitsAddInputItem;
  OrderGuideV2ItemUnitsAddResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideV2ItemUnitsAddResponse'];
  OrderGuideV2ItemUnitsAddResult: OrderGuideV2ItemUnitsAddResult;
  OrderGuideV2ItemUnitsRemoveInput: OrderGuideV2ItemUnitsRemoveInput;
  OrderGuideV2ItemUnitsRemoveResponse: ResolversUnionTypes<ResolversParentTypes>['OrderGuideV2ItemUnitsRemoveResponse'];
  OrderGuideV2ItemUnitsRemoveResult: OrderGuideV2ItemUnitsRemoveResult;
  PaymentAuthorizeInput: PaymentAuthorizeInput;
  PaymentAuthorizeResponse: ResolversUnionTypes<ResolversParentTypes>['PaymentAuthorizeResponse'];
  PostProcessing: PostProcessing;
  PreProcessing: PreProcessing;
  NoFurtherActionNeeded: NoFurtherActionNeeded;
  PaymentAccountIsInactive: PaymentAccountIsInactive;
  UnexpectedInvoiceState: UnexpectedInvoiceState;
  SupplierDoesNotAcceptOnlinePayments: SupplierDoesNotAcceptOnlinePayments;
  EntityCurrencyMismatch: EntityCurrencyMismatch;
  UpdatedCategoryProduct: UpdatedCategoryProduct;
  ReferUserInput: ReferUserInput;
  ReferUserResponse: ResolversUnionTypes<ResolversParentTypes>['ReferUserResponse'];
  ReferUserResult: ReferUserResult;
  ReferUserChatExists: ReferUserChatExists;
  ReferUserReferralCodeNotFound: ReferUserReferralCodeNotFound;
  OmnichannelOrdersSubcriptionResponse: ResolversUnionTypes<ResolversParentTypes>['OmnichannelOrdersSubcriptionResponse'];
  OrderDeskNotification: OrderDeskNotification;
  RejectOrderInput: RejectOrderInput;
  RejectOrderResponse: ResolversUnionTypes<ResolversParentTypes>['RejectOrderResponse'];
  OrderRejected: OrderRejected;
  RejectOrdersByIdInput: RejectOrdersByIdInput;
  RejectOrdersByIdResponse: ResolversUnionTypes<ResolversParentTypes>['RejectOrdersByIdResponse'];
  OrdersRejected: OrdersRejected;
  RemoveCCEmailFromChatsReport: RemoveCcEmailFromChatsReport;
  RemoveEmailFromBuyerReportScheduleResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveEmailFromBuyerReportScheduleResponse'];
  EmailFromBuyerReportScheduleRemoved: EmailFromBuyerReportScheduleRemoved;
  EmailInBuyerReportScheduleNotFound: EmailInBuyerReportScheduleNotFound;
  RemoveEntitiesFromGroupInput: RemoveEntitiesFromGroupInput;
  RemoveEntitiesFromGroupResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveEntitiesFromGroupResponse'];
  RemoveEntitiesFromGroupResponseSuccess: RemoveEntitiesFromGroupResponseSuccess;
  RemoveEntitiesFromGroupResponseError: RemoveEntitiesFromGroupResponseError;
  RemoveInvoiceResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveInvoiceResponse'];
  InvoiceRemoved: InvoiceRemoved;
  InvoiceCannotBeRemoved: InvoiceCannotBeRemoved;
  RemoveInvoiceAttachmentResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveInvoiceAttachmentResponse'];
  InvoiceAttachmentRemoved: InvoiceAttachmentRemoved;
  InvoiceCannotBeUpdated: InvoiceCannotBeUpdated;
  RemoveOrderDeskEmail: RemoveOrderDeskEmail;
  OrderDeskRemovedEmailResponse: ResolversUnionTypes<ResolversParentTypes>['OrderDeskRemovedEmailResponse'];
  OrderDeskEmailRemoved: OrderDeskEmailRemoved;
  RemovePaymentAccountResponse: ResolversUnionTypes<ResolversParentTypes>['RemovePaymentAccountResponse'];
  PaymentAccountRemoved: PaymentAccountRemoved;
  RemoveProductsFromOrderGuidesInput: RemoveProductsFromOrderGuidesInput;
  RemoveProductsFromOrderGuidesResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveProductsFromOrderGuidesResponse'];
  RemoveProductsFromOrderGuidesResult: RemoveProductsFromOrderGuidesResult;
  RemoveSupplierBuyerMovInput: RemoveSupplierBuyerMovInput;
  MinimumOrderValueUpdateResponse: ResolversUnionTypes<ResolversParentTypes>['MinimumOrderValueUpdateResponse'];
  MinimumOrderValueUpdate: MinimumOrderValueUpdate;
  RemoveUsersFromGroupInput: RemoveUsersFromGroupInput;
  RemoveUsersFromGroupResponse: ResolversUnionTypes<ResolversParentTypes>['RemoveUsersFromGroupResponse'];
  RemoveUsersFromGroupSuccess: RemoveUsersFromGroupSuccess;
  RemoveUsersFromGroupError: RemoveUsersFromGroupError;
  RequestToJoinBuyerResponse: ResolversUnionTypes<ResolversParentTypes>['RequestToJoinBuyerResponse'];
  RequestToJoinBuyerError: RequestToJoinBuyerError;
  SelectProductForOrderGuideInput: SelectProductForOrderGuideInput;
  BuyerProductInput: BuyerProductInput;
  SelectProductForOrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['SelectProductForOrderGuideResponse'];
  SelectProductForOrderGuideSuccess: SelectProductForOrderGuideSuccess;
  SelectProductsForOrderGuideInput: SelectProductsForOrderGuideInput;
  OrderGuideProductInput: OrderGuideProductInput;
  SelectProductsForOrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['SelectProductsForOrderGuideResponse'];
  SelectProductsForOrderGuideSuccess: SelectProductsForOrderGuideSuccess;
  SendInviteTransmissionRequest: SendInviteTransmissionRequest;
  SendInviteTransmissionResponse: ResolversUnionTypes<ResolversParentTypes>['SendInviteTransmissionResponse'];
  SendSyntheticSmsMessageInput: SendSyntheticSmsMessageInput;
  SendSyntheticSmsMessageMediaInput: SendSyntheticSmsMessageMediaInput;
  SendSyntheticSmsMessageResponse: ResolversUnionTypes<ResolversParentTypes>['SendSyntheticSmsMessageResponse'];
  SendSyntheticSmsMessageSuccess: SendSyntheticSmsMessageSuccess;
  SendSyntheticWhatsAppMessageInput: SendSyntheticWhatsAppMessageInput;
  SendSyntheticWhatsAppMessageMediaInput: SendSyntheticWhatsAppMessageMediaInput;
  SendSyntheticWhatsAppMessageResponse: ResolversUnionTypes<ResolversParentTypes>['SendSyntheticWhatsAppMessageResponse'];
  SendSyntheticWhatsAppMessageSuccess: SendSyntheticWhatsAppMessageSuccess;
  SetOrderAsTestResponse: ResolversUnionTypes<ResolversParentTypes>['SetOrderAsTestResponse'];
  TestOrderResponse: TestOrderResponse;
  SubmitBuyerStockCountInput: SubmitBuyerStockCountInput;
  CartSubmissionOptions: CartSubmissionOptions;
  CartSubmissionResponse: ResolversUnionTypes<ResolversParentTypes>['CartSubmissionResponse'];
  CartSubmissionResult: CartSubmissionResult;
  CartSubmissionError: CartSubmissionError;
  CreateMessageError: CreateMessageError;
  CartSubmittedEmptyError: CartSubmittedEmptyError;
  CartInvalidProductsError: CartInvalidProductsError;
  CartAllProductsUnavailableError: CartAllProductsUnavailableError;
  ForbiddenError: ForbiddenError;
  ExistingOrderError: ExistingOrderError;
  ProductLeadTimeError: ProductLeadTimeError;
  SubmitOrderDeliveryCheckInput: SubmitOrderDeliveryCheckInput;
  DeliveryCheckReconciliationRequestInput: DeliveryCheckReconciliationRequestInput;
  OrderDeliveryCheckSubmissionResponse: ResolversUnionTypes<ResolversParentTypes>['OrderDeliveryCheckSubmissionResponse'];
  OrderDeliveryCheckNotFound: OrderDeliveryCheckNotFound;
  SubmitOrderedProductDeliveryCheckInput: SubmitOrderedProductDeliveryCheckInput;
  OrderedProductDeliveryCheckSubmissionResponse: ResolversUnionTypes<ResolversParentTypes>['OrderedProductDeliveryCheckSubmissionResponse'];
  SubmitStockCountSessionInput: SubmitStockCountSessionInput;
  SubmitStockCountSessionResponse: ResolversUnionTypes<ResolversParentTypes>['SubmitStockCountSessionResponse'];
  SubmitStockCountSessionFailure: SubmitStockCountSessionFailure;
  SubmitStockCountSessionSuccess: SubmitStockCountSessionSuccess;
  SupplierAddRequestInput: SupplierAddRequestInput;
  SupplierAddRequestResponse: ResolversUnionTypes<ResolversParentTypes>['SupplierAddRequestResponse'];
  SupplierAddRequest: SupplierAddRequest;
  SupplierAddRequestError: SupplierAddRequestError;
  SupplierCreateInput: SupplierCreateInput;
  IntegrationOptionInput: IntegrationOptionInput;
  IntegrationSmsOptionInput: IntegrationSmsOptionInput;
  IntegrationEmailOptionInput: IntegrationEmailOptionInput;
  IntegrationFaxOptionInput: IntegrationFaxOptionInput;
  IntegrationWhatsAppOptionInput: IntegrationWhatsAppOptionInput;
  DeliveryZoneInput: DeliveryZoneInput;
  PriceSettingInput: PriceSettingInput;
  MinOrderInput: MinOrderInput;
  SupplierGetInTouchRequestInput: SupplierGetInTouchRequestInput;
  SupplierGetInTouchRequestResponse: ResolversUnionTypes<ResolversParentTypes>['SupplierGetInTouchRequestResponse'];
  SupplierGetInTouchRequestSuccess: SupplierGetInTouchRequestSuccess;
  SupplierUpdateError: SupplierUpdateError;
  SupplierGetInTouchRequestError: SupplierGetInTouchRequestError;
  ChatInviteRecipient: ChatInviteRecipient;
  ChatInviteInput: ChatInviteInput;
  SupplierInviteUserResponse: Omit<SupplierInviteUserResponse, 'inviteResponse'> & { inviteResponse: Array<Maybe<ResolversParentTypes['SupplierInviteResponseEntity']>> };
  SupplierInviteResponseEntity: ResolversUnionTypes<ResolversParentTypes>['SupplierInviteResponseEntity'];
  InvalidInvitedPhoneNumber: InvalidInvitedPhoneNumber;
  SupplierInviteError: SupplierInviteError;
  SupplierUpdateInput: SupplierUpdateInput;
  SupplierUserCreateInput: SupplierUserCreateInput;
  SupplierUserRemoveInput: SupplierUserRemoveInput;
  SupplierUserRemoveResponse: SupplierUserRemoveResponse;
  TriggerProductMatchingInput: TriggerProductMatchingInput;
  TriggerProductMatchingResponse: ResolversUnionTypes<ResolversParentTypes>['TriggerProductMatchingResponse'];
  UnassignUserFromOrderToReviewInput: UnassignUserFromOrderToReviewInput;
  UnassignUserFromOrderToReviewResponse: ResolversUnionTypes<ResolversParentTypes>['UnassignUserFromOrderToReviewResponse'];
  UnassignUserFromOrderToReviewResponseSuccess: UnassignUserFromOrderToReviewResponseSuccess;
  UnassignUserFromOrderToReviewResponseError: UnassignUserFromOrderToReviewResponseError;
  UndoMultiLocationOrderGuideTransactionInput: UndoMultiLocationOrderGuideTransactionInput;
  UndoMultiLocationOrderGuideTransactionResponse: ResolversUnionTypes<ResolversParentTypes>['UndoMultiLocationOrderGuideTransactionResponse'];
  UndoMultiLocationOrderGuideTransactionResult: UndoMultiLocationOrderGuideTransactionResult;
  UpdateBuyerInventoryProductInput: UpdateBuyerInventoryProductInput;
  UpdateBuyerInventoryProductResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateBuyerInventoryProductResponse'];
  UpdateBuyerStockInventoryProductInput: UpdateBuyerStockInventoryProductInput;
  UpdateBuyerStockInventoryProductResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateBuyerStockInventoryProductResponse'];
  UpdateBuyerStockInventoryProductFailure: UpdateBuyerStockInventoryProductFailure;
  CartLineItemUpdateInput: CartLineItemUpdateInput;
  CartProductMetadataInput: CartProductMetadataInput;
  CartUpdateResponse: ResolversUnionTypes<ResolversParentTypes>['CartUpdateResponse'];
  NegativeAmountError: NegativeAmountError;
  ChatNotificationInput: ChatNotificationInput;
  ChatNotificationUserListsInput: ChatNotificationUserListsInput;
  UpdateInventoryItemInput: UpdateInventoryItemInput;
  UpdateInventoryItemInputPatch: UpdateInventoryItemInputPatch;
  UpdateInventoryItemResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateInventoryItemResponse'];
  UpdateInventoryItemSuccess: UpdateInventoryItemSuccess;
  UpdateInventoryItemFailure: UpdateInventoryItemFailure;
  UpdateInvoiceInput: UpdateInvoiceInput;
  UpdateInvoiceResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateInvoiceResponse'];
  InvoicedProductInput: InvoicedProductInput;
  UpdateInvoicedProductResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateInvoicedProductResponse'];
  InvoicedProducts: InvoicedProducts;
  UpdatePendingUserInput: UpdatePendingUserInput;
  PendingUserInput: PendingUserInput;
  UpdatePendingUserResponse: ResolversUnionTypes<ResolversParentTypes>['UpdatePendingUserResponse'];
  UpdateProductVariantsInOrderGuideInput: UpdateProductVariantsInOrderGuideInput;
  UpdateProductVariantsInOrderGuideResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateProductVariantsInOrderGuideResponse'];
  UpdateProductVariantsInOrderGuideSuccess: UpdateProductVariantsInOrderGuideSuccess;
  UpdateJoinRequestInput: UpdateJoinRequestInput;
  UpdateJoinRequestResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateJoinRequestResponse'];
  UpdateJoinRequestSuccess: UpdateJoinRequestSuccess;
  UpdateJoinRequestError: UpdateJoinRequestError;
  UpdateStorageItemInput: UpdateStorageItemInput;
  UpdateStorageItemInputPatch: UpdateStorageItemInputPatch;
  PatchStorageItemPrice: PatchStorageItemPrice;
  UpdateStorageItemResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateStorageItemResponse'];
  UpdateStorageItemSuccess: UpdateStorageItemSuccess;
  UpdateStorageItemFailure: UpdateStorageItemFailure;
  updateSubCatalogResponse: ResolversUnionTypes<ResolversParentTypes>['updateSubCatalogResponse'];
  UpdateSubCatalogError: UpdateSubCatalogError;
  SubCatalogChatInput: SubCatalogChatInput;
  UpdateSubCatalogChatsResponse: ResolversUnionTypes<ResolversParentTypes>['UpdateSubCatalogChatsResponse'];
  UpdateSubCatalogChatsResult: UpdateSubCatalogChatsResult;
  UpdateSubCatalogChatsSummary: UpdateSubCatalogChatsSummary;
  SubCatalogChat: Omit<SubCatalogChat, 'createdBy'> & { createdBy?: Maybe<ResolversParentTypes['EntityIdentity']> };
  EntityIdentity: ResolversUnionTypes<ResolversParentTypes>['EntityIdentity'];
  IntegrationEntityIdentity: IntegrationEntityIdentity;
  InternalEntityIdentity: InternalEntityIdentity;
  InvalidSubCatalogChat: InvalidSubCatalogChat;
  SupplierUpdateAccessPackageInput: SupplierUpdateAccessPackageInput;
  SupplierUpdateAccessPackageResponse: ResolversUnionTypes<ResolversParentTypes>['SupplierUpdateAccessPackageResponse'];
  SupplierUpdateAccessPackageSuccess: SupplierUpdateAccessPackageSuccess;
  SupplierUpdateAccessPackageError: SupplierUpdateAccessPackageError;
  UpdateSupplierBuyerMovInput: UpdateSupplierBuyerMovInput;
  SupplierDeliverySettingInput: SupplierDeliverySettingInput;
  CutOffTimeInput: CutOffTimeInput;
  WeekdayBasedCutoffSettingsInput: WeekdayBasedCutoffSettingsInput;
  CutoffSettingInput: CutoffSettingInput;
  DeliveryExceptionInput: DeliveryExceptionInput;
  DeliveryExceptionCutoffSettingInput: DeliveryExceptionCutoffSettingInput;
  UpdateSupplierProductV2Input: UpdateSupplierProductV2Input;
  SupplierUserUpdateChatsInput: SupplierUserUpdateChatsInput;
  SupplierUserUpdateChatsResponse: SupplierUserUpdateChatsResponse;
  UpdateSupplierUserRolesInput: UpdateSupplierUserRolesInput;
  UploadSubCatalogProductsResponse: ResolversUnionTypes<ResolversParentTypes>['UploadSubCatalogProductsResponse'];
  UploadSubCatalogProductsResult: UploadSubCatalogProductsResult;
  UploadSubCatalogProductsError: UploadSubCatalogProductsError;
  UpsertStockCountSessionItemsInput: UpsertStockCountSessionItemsInput;
  StockCountItemInput: StockCountItemInput;
  UpsertStockCountSessionItemsResponse: ResolversUnionTypes<ResolversParentTypes>['UpsertStockCountSessionItemsResponse'];
  UpsertStockCountSessionItemsSuccess: UpsertStockCountSessionItemsSuccess;
  UpsertStockCountSessionItemsError: UpsertStockCountSessionItemsError;
  UserCreateInput: UserCreateInput;
  OrderPreferenceInput: OrderPreferenceInput;
  UserLeadInput: UserLeadInput;
  UserLead: UserLead;
  UserLeadRequest: UserLeadRequest;
  UserRequestToDeleteInput: UserRequestToDeleteInput;
  UserRequestToDeleteResponse: ResolversUnionTypes<ResolversParentTypes>['UserRequestToDeleteResponse'];
  UserRequestToDeleteDetails: UserRequestToDeleteDetails;
  UserUpdateInput: UserUpdateInput;
  VendorItemUnitUpdateInput: VendorItemUnitUpdateInput;
  VendorItemUnitUpdateResponse: ResolversUnionTypes<ResolversParentTypes>['VendorItemUnitUpdateResponse'];
  VendorItemUnitUpdateResult: VendorItemUnitUpdateResult;
  Subscription: {};
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  ActivateChatResponse: ResolversUnionTypes<ResolversParentTypes>['ActivateChatResponse'];
  BuyerChatsNotFound: BuyerChatsNotFound;
  BuyerChatsProductListEmpty: BuyerChatsProductListEmpty;
  BuyerChatsResponse: ResolversUnionTypes<ResolversParentTypes>['BuyerChatsResponse'];
  BuyerStockCountProductInput: BuyerStockCountProductInput;
  Contact: Contact;
  OrderResult: OrderResult;
  ProductConnection: ProductConnection;
  ProductEdge: ProductEdge;
  ProductMatchData: ProductMatchData;
  SupplierContactAlreadyCreated: SupplierContactAlreadyCreated;
  SupplierProductFilter: SupplierProductFilter;
};

export type Aws_Api_KeyDirectiveArgs = { };

export type Aws_Api_KeyDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_Cognito_User_PoolsDirectiveArgs = { };

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_OidcDirectiveArgs = { };

export type Aws_OidcDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations?: Maybe<Array<Maybe<Scalars['String']['input']>>>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = any, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  blockedEmail?: Resolver<Maybe<ResolversTypes['BlockedEmail']>, ParentType, ContextType, RequireFields<QueryBlockedEmailArgs, 'email'>>;
  blockedEmails?: Resolver<Maybe<ResolversTypes['BlockedEmailConnection']>, ParentType, ContextType, Partial<QueryBlockedEmailsArgs>>;
  broadcast?: Resolver<ResolversTypes['Broadcast'], ParentType, ContextType, RequireFields<QueryBroadcastArgs, 'id'>>;
  browseCatalog?: Resolver<ResolversTypes['BrowseCatalogResponse'], ParentType, ContextType, RequireFields<QueryBrowseCatalogArgs, 'input'>>;
  browseCatalogForChat?: Resolver<ResolversTypes['BrowseCatalogForChatResponse'], ParentType, ContextType, RequireFields<QueryBrowseCatalogForChatArgs, 'input'>>;
  bulkOrderPdf?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryBulkOrderPdfArgs, 'orderIds' | 'downloadable'>>;
  buyer?: Resolver<Maybe<ResolversTypes['Buyer']>, ParentType, ContextType, Partial<QueryBuyerArgs>>;
  buyerFacets?: Resolver<Maybe<Array<ResolversTypes['BuyerFacetsResponse']>>, ParentType, ContextType>;
  buyerStockCount?: Resolver<ResolversTypes['BuyerStockCountResponse'], ParentType, ContextType, RequireFields<QueryBuyerStockCountArgs, 'input'>>;
  buyerStockCounts?: Resolver<ResolversTypes['BuyerStockCountsResponse'], ParentType, ContextType, RequireFields<QueryBuyerStockCountsArgs, 'input'>>;
  buyerStockInventory?: Resolver<ResolversTypes['BuyerStockInventoryResponse'], ParentType, ContextType, RequireFields<QueryBuyerStockInventoryArgs, 'filter'>>;
  buyerStockInventoryExportUrl?: Resolver<ResolversTypes['BuyerStockInventoryExportUrlResponse'], ParentType, ContextType, RequireFields<QueryBuyerStockInventoryExportUrlArgs, 'input'>>;
  buyerUser?: Resolver<Maybe<ResolversTypes['BuyerUser']>, ParentType, ContextType, RequireFields<QueryBuyerUserArgs, 'buyerId' | 'userId'>>;
  buyerUsers?: Resolver<Array<ResolversTypes['BuyerUser']>, ParentType, ContextType, Partial<QueryBuyerUsersArgs>>;
  cart?: Resolver<Maybe<ResolversTypes['CartResponse']>, ParentType, ContextType, RequireFields<QueryCartArgs, 'chatId'>>;
  catalogImportStatus?: Resolver<ResolversTypes['CatalogImportStatusResponse'], ParentType, ContextType, RequireFields<QueryCatalogImportStatusArgs, 'jobId'>>;
  catalogImportTemplate?: Resolver<ResolversTypes['CatalogImportTemplateResponse'], ParentType, ContextType>;
  catalogImports?: Resolver<ResolversTypes['CatalogImportsResponse'], ParentType, ContextType, RequireFields<QueryCatalogImportsArgs, 'input'>>;
  categoryProducts?: Resolver<Array<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<QueryCategoryProductsArgs, 'chatId'>>;
  chat?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType, Partial<QueryChatArgs>>;
  chatHasSupplierEmailSupport?: Resolver<ResolversTypes['ChatHasSupplierEmailSupportResponse'], ParentType, ContextType, RequireFields<QueryChatHasSupplierEmailSupportArgs, 'chatId'>>;
  chatNotificationPreferences?: Resolver<Maybe<ResolversTypes['ChatNotificationPreferences']>, ParentType, ContextType, RequireFields<QueryChatNotificationPreferencesArgs, 'id'>>;
  chatProducts?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType, RequireFields<QueryChatProductsArgs, 'chatId'>>;
  chatSubCatalogProducts?: Resolver<ResolversTypes['ChatSubCatalogProductsResponse'], ParentType, ContextType, Partial<QueryChatSubCatalogProductsArgs>>;
  chatUsers?: Resolver<Array<ResolversTypes['ChatUser']>, ParentType, ContextType, Partial<QueryChatUsersArgs>>;
  chats?: Resolver<ResolversTypes['UserChatConnection'], ParentType, ContextType, Partial<QueryChatsArgs>>;
  checkInviteeGooglePlace?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryCheckInviteeGooglePlaceArgs, 'googlePlaceId'>>;
  countSupplierChats?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryCountSupplierChatsArgs, 'supplierEntityId'>>;
  exportSupplierProducts?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryExportSupplierProductsArgs, 'supplierId'>>;
  fetchBuyerReportDownloadUrl?: Resolver<ResolversTypes['FetchBuyerReportDownloadUrlResponse'], ParentType, ContextType, RequireFields<QueryFetchBuyerReportDownloadUrlArgs, 'input'>>;
  fetchCatalogCategories?: Resolver<Array<ResolversTypes['CatalogCategory']>, ParentType, ContextType, RequireFields<QueryFetchCatalogCategoriesArgs, 'supplierId'>>;
  fetchCatalogCategoriesForChat?: Resolver<ResolversTypes['FetchCatalogCategoriesForChatResponse'], ParentType, ContextType, RequireFields<QueryFetchCatalogCategoriesForChatArgs, 'chatId'>>;
  fetchOrderGuide?: Resolver<ResolversTypes['OrderGuideResponse'], ParentType, ContextType, RequireFields<QueryFetchOrderGuideArgs, 'chatId' | 'product'>>;
  fetchProductVariantsForBuyer?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType, RequireFields<QueryFetchProductVariantsForBuyerArgs, 'chatId' | 'productId'>>;
  generateEmbedDashboardUrl?: Resolver<ResolversTypes['EmbedDashboardUrlResponse'], ParentType, ContextType>;
  getAllBuyerReportSchedules?: Resolver<ResolversTypes['GetAllBuyerReportSchedulesResponse'], ParentType, ContextType, RequireFields<QueryGetAllBuyerReportSchedulesArgs, 'input'>>;
  getAppliedChatDeliverySetting?: Resolver<Maybe<ResolversTypes['AppliedChatDeliverySettingResponse']>, ParentType, ContextType, RequireFields<QueryGetAppliedChatDeliverySettingArgs, 'chatId'>>;
  getBroadcastProductsSuggestions?: Resolver<Maybe<ResolversTypes['SuggestedProductResult']>, ParentType, ContextType, RequireFields<QueryGetBroadcastProductsSuggestionsArgs, 'text'>>;
  getCatalogUploadUrl?: Resolver<ResolversTypes['GetCatalogUploadUrlResponse'], ParentType, ContextType, RequireFields<QueryGetCatalogUploadUrlArgs, 'supplierId'>>;
  getChatCountByCCEmail?: Resolver<ResolversTypes['GetChatCountByCCEmailResponse'], ParentType, ContextType, RequireFields<QueryGetChatCountByCcEmailArgs, 'email'>>;
  getChatSuppliersByLocations?: Resolver<ResolversTypes['GetChatSuppliersByLocationsResponse'], ParentType, ContextType, RequireFields<QueryGetChatSuppliersByLocationsArgs, 'input'>>;
  getChatsForSubCatalog?: Resolver<ResolversTypes['GetChatsForSubCatalogResponse'], ParentType, ContextType, RequireFields<QueryGetChatsForSubCatalogArgs, 'subCatalogId'>>;
  getConnectedAccounts?: Resolver<ResolversTypes['GetConnectedAccountsResponse'], ParentType, ContextType, Partial<QueryGetConnectedAccountsArgs>>;
  getConnectedIntegrationAdapters?: Resolver<ResolversTypes['GetConnectedIntegrationAdaptersResponse'], ParentType, ContextType, RequireFields<QueryGetConnectedIntegrationAdaptersArgs, 'input'>>;
  getCurrentPayment?: Resolver<ResolversTypes['CurrentPaymentResponse'], ParentType, ContextType, Partial<QueryGetCurrentPaymentArgs>>;
  getEmailLists?: Resolver<ResolversTypes['GetEmailListsResponse'], ParentType, ContextType, RequireFields<QueryGetEmailListsArgs, 'input'>>;
  getFeatureFlags?: Resolver<ResolversTypes['GetFeatureFlagsResponse'], ParentType, ContextType>;
  getGroup?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupArgs, 'groupId'>>;
  getGroupEntities?: Resolver<Maybe<ResolversTypes['GetGroupEntitiesResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupEntitiesArgs, 'input'>>;
  getGroupUsers?: Resolver<Maybe<ResolversTypes['GetGroupUsersResponse']>, ParentType, ContextType, RequireFields<QueryGetGroupUsersArgs, 'input'>>;
  getIntegrationAdapters?: Resolver<ResolversTypes['GetIntegrationAdaptersResponse'], ParentType, ContextType, RequireFields<QueryGetIntegrationAdaptersArgs, 'input'>>;
  getInviteTransmissionStatus?: Resolver<ResolversTypes['GetInviteTransmissionStatusResponse'], ParentType, ContextType, RequireFields<QueryGetInviteTransmissionStatusArgs, 'input'>>;
  getInviteeBuyers?: Resolver<Maybe<ResolversTypes['GetInviteeBuyersResponse']>, ParentType, ContextType, RequireFields<QueryGetInviteeBuyersArgs, 'phone'>>;
  getInvoiceAttachment?: Resolver<Maybe<ResolversTypes['InvoiceAttachment']>, ParentType, ContextType, RequireFields<QueryGetInvoiceAttachmentArgs, 'orderId'>>;
  getKyc?: Resolver<Maybe<ResolversTypes['Kyc']>, ParentType, ContextType, RequireFields<QueryGetKycArgs, 'buyerId'>>;
  getLastMessageFromChat?: Resolver<Maybe<ResolversTypes['MessagesFromChatResult']>, ParentType, ContextType, RequireFields<QueryGetLastMessageFromChatArgs, 'chatId'>>;
  getLocationsBySupplier?: Resolver<ResolversTypes['LocationsBySupplierResponse'], ParentType, ContextType, RequireFields<QueryGetLocationsBySupplierArgs, 'supplierEntityId'>>;
  getMarketingMessageSuggestions?: Resolver<ResolversTypes['MarketingMessageSuggestionsResult'], ParentType, ContextType, RequireFields<QueryGetMarketingMessageSuggestionsArgs, 'currentMessage'>>;
  getOmniChannelOrder?: Resolver<ResolversTypes['GetOmniChannelOrderResponse'], ParentType, ContextType, RequireFields<QueryGetOmniChannelOrderArgs, 'input'>>;
  getOmniChannelOrderV2?: Resolver<ResolversTypes['GetOmniChannelOrderResponse'], ParentType, ContextType, RequireFields<QueryGetOmniChannelOrderV2Args, 'input'>>;
  getOnboardingChecklist?: Resolver<ResolversTypes['GetOnboardingChecklistResponse'], ParentType, ContextType, RequireFields<QueryGetOnboardingChecklistArgs, 'buyerId'>>;
  getOrderChanges?: Resolver<Maybe<ResolversTypes['OrderChange']>, ParentType, ContextType, RequireFields<QueryGetOrderChangesArgs, 'id'>>;
  getOrderDeliveryCheck?: Resolver<Maybe<ResolversTypes['GetOrderDeliveryCheckResponse']>, ParentType, ContextType, RequireFields<QueryGetOrderDeliveryCheckArgs, 'orderId'>>;
  getOrderExcelUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetOrderExcelUrlArgs, 'orderId'>>;
  getOrderPreference?: Resolver<Maybe<ResolversTypes['OrderPreference']>, ParentType, ContextType, RequireFields<QueryGetOrderPreferenceArgs, 'id'>>;
  getProductsForChat?: Resolver<ResolversTypes['GetProductsForChatResponse'], ParentType, ContextType, RequireFields<QueryGetProductsForChatArgs, 'input'>>;
  getQboCustomersAndOrderGuidesToImport?: Resolver<ResolversTypes['GetQboCustomersAndOrderGuidesToImportResponse'], ParentType, ContextType, Partial<QueryGetQboCustomersAndOrderGuidesToImportArgs>>;
  getReconciliationRequestPlanBySupplierId?: Resolver<Maybe<ResolversTypes['GetReconciliationRequestPlanBySupplierIdResponse']>, ParentType, ContextType, RequireFields<QueryGetReconciliationRequestPlanBySupplierIdArgs, 'supplierId'>>;
  getReferral?: Resolver<Maybe<ResolversTypes['GetReferralResponse']>, ParentType, ContextType, RequireFields<QueryGetReferralArgs, 'input'>>;
  getRequestsToJoin?: Resolver<ResolversTypes['GetRequestsToJoinResponse'], ParentType, ContextType, RequireFields<QueryGetRequestsToJoinArgs, 'query'>>;
  getSmsMessageByMessageSid?: Resolver<ResolversTypes['GetSmsMessageByMessageSidResponse'], ParentType, ContextType, RequireFields<QueryGetSmsMessageByMessageSidArgs, 'messageSid'>>;
  getSmsMessagesFromPhoneNumber?: Resolver<ResolversTypes['GetSmsMessagesFromPhoneNumberResponse'], ParentType, ContextType, RequireFields<QueryGetSmsMessagesFromPhoneNumberArgs, 'phoneNumber'>>;
  getSubCatalog?: Resolver<Maybe<ResolversTypes['GetSubCatalogResponse']>, ParentType, ContextType, RequireFields<QueryGetSubCatalogArgs, 'id'>>;
  getSubCatalogsForChat?: Resolver<ResolversTypes['GetSubCatalogsForChatResponse'], ParentType, ContextType, RequireFields<QueryGetSubCatalogsForChatArgs, 'chatId'>>;
  getSupplierApplications?: Resolver<ResolversTypes['GetSupplierApplicationsResponse'], ParentType, ContextType, Partial<QueryGetSupplierApplicationsArgs>>;
  getSupplierProducts?: Resolver<ResolversTypes['GetSupplierProductsResponse'], ParentType, ContextType, RequireFields<QueryGetSupplierProductsArgs, 'input'>>;
  getUnconnectedBuyerIds?: Resolver<ResolversTypes['GetUnconnectedBuyerIdsResult'], ParentType, ContextType, RequireFields<QueryGetUnconnectedBuyerIdsArgs, 'buyerIds' | 'supplierId'>>;
  getUserIntercomCredentials?: Resolver<ResolversTypes['UserIntercomCredentialsResponse'], ParentType, ContextType>;
  getWhatsAppMessageByMessageSid?: Resolver<ResolversTypes['GetWhatsAppMessageByMessageSidResponse'], ParentType, ContextType, RequireFields<QueryGetWhatsAppMessageByMessageSidArgs, 'messageSid'>>;
  hasUserCompletedDeliveryCheck?: Resolver<ResolversTypes['HasUserCompletedDeliveryCheckResponse'], ParentType, ContextType, RequireFields<QueryHasUserCompletedDeliveryCheckArgs, 'chatId'>>;
  inventoryDownloadJobs?: Resolver<ResolversTypes['InventoryDownloadJobsResponse'], ParentType, ContextType, RequireFields<QueryInventoryDownloadJobsArgs, 'input'>>;
  inventorySuppliers?: Resolver<ResolversTypes['InventorySuppliersResponse'], ParentType, ContextType, RequireFields<QueryInventorySuppliersArgs, 'input'>>;
  inventoryUploadJob?: Resolver<ResolversTypes['InventoryUploadJobResponse'], ParentType, ContextType, RequireFields<QueryInventoryUploadJobArgs, 'input'>>;
  inventoryUploadTemplate?: Resolver<ResolversTypes['InventoryUploadTemplateResponse'], ParentType, ContextType, RequireFields<QueryInventoryUploadTemplateArgs, 'input'>>;
  isUserInChat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsUserInChatArgs, 'userId' | 'chatId'>>;
  listPaymentAccounts?: Resolver<ResolversTypes['ListPaymentAccountsResponse'], ParentType, ContextType, Partial<QueryListPaymentAccountsArgs>>;
  listSubCatalogProducts?: Resolver<Maybe<ResolversTypes['ListSubCatalogProductsResponse']>, ParentType, ContextType, RequireFields<QueryListSubCatalogProductsArgs, 'input'>>;
  listSubCatalogs?: Resolver<Maybe<ResolversTypes['ListSubCatalogsResponse']>, ParentType, ContextType, Partial<QueryListSubCatalogsArgs>>;
  lookupPhoneNumbers?: Resolver<ResolversTypes['LookupPhoneNumbersResponse'], ParentType, ContextType, RequireFields<QueryLookupPhoneNumbersArgs, 'phoneNumbers'>>;
  message?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryMessageArgs, 'id'>>;
  messages?: Resolver<ResolversTypes['ChatMessageConnection'], ParentType, ContextType, RequireFields<QueryMessagesArgs, 'chatId'>>;
  messagesNotSentViaEmailAndChat?: Resolver<Array<ResolversTypes['MessagesFromChatResult']>, ParentType, ContextType, RequireFields<QueryMessagesNotSentViaEmailAndChatArgs, 'chatId' | 'isSupplier'>>;
  metaLobby?: Resolver<Maybe<ResolversTypes['MetaLobbyResponse']>, ParentType, ContextType, Partial<QueryMetaLobbyArgs>>;
  order?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType, Partial<QueryOrderArgs>>;
  orderGuideV2Categories?: Resolver<ResolversTypes['OrderGuideV2CategoriesResponse'], ParentType, ContextType, RequireFields<QueryOrderGuideV2CategoriesArgs, 'input'>>;
  orderGuideV2ItemUnits?: Resolver<ResolversTypes['OrderGuideV2ItemUnitsResponse'], ParentType, ContextType, RequireFields<QueryOrderGuideV2ItemUnitsArgs, 'input'>>;
  ordersToReview?: Resolver<ResolversTypes['OrdersToReviewResponse'], ParentType, ContextType, RequireFields<QueryOrdersToReviewArgs, 'input'>>;
  paymentOptions?: Resolver<ResolversTypes['PaymentOptionsResponse'], ParentType, ContextType, RequireFields<QueryPaymentOptionsArgs, 'input'>>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType, RequireFields<QueryProductArgs, 'id'>>;
  productListCategories?: Resolver<Maybe<Array<ResolversTypes['ProductCategory']>>, ParentType, ContextType, RequireFields<QueryProductListCategoriesArgs, 'chatId'>>;
  search?: Resolver<ResolversTypes['SearchResult'], ParentType, ContextType, RequireFields<QuerySearchArgs, 'query'>>;
  searchBuyer?: Resolver<ResolversTypes['SearchBuyerResponse'], ParentType, ContextType, RequireFields<QuerySearchBuyerArgs, 'query'>>;
  searchGroups?: Resolver<Maybe<ResolversTypes['SearchGroupsResponse']>, ParentType, ContextType, RequireFields<QuerySearchGroupsArgs, 'input'>>;
  searchOrder?: Resolver<ResolversTypes['SearchOrderResponse'], ParentType, ContextType, RequireFields<QuerySearchOrderArgs, 'query'>>;
  searchOrderDeskCustomer?: Resolver<ResolversTypes['SearchOrderDeskCustomerResponse'], ParentType, ContextType, RequireFields<QuerySearchOrderDeskCustomerArgs, 'input'>>;
  searchProducts?: Resolver<Maybe<ResolversTypes['SearchProductsResponse']>, ParentType, ContextType, RequireFields<QuerySearchProductsArgs, 'input'>>;
  searchTaxonomyLabels?: Resolver<Maybe<ResolversTypes['SearchTaxonomyLabelsResponse']>, ParentType, ContextType, RequireFields<QuerySearchTaxonomyLabelsArgs, 'input'>>;
  sendSampleSmsMessage?: Resolver<ResolversTypes['SendSampleSmsMessageResponse'], ParentType, ContextType, RequireFields<QuerySendSampleSmsMessageArgs, 'input'>>;
  sharedBroadcastProducts?: Resolver<Maybe<ResolversTypes['SharedBroadcastProducts']>, ParentType, ContextType, RequireFields<QuerySharedBroadcastProductsArgs, 'broadcastId' | 'chatId'>>;
  stockCountSessions?: Resolver<ResolversTypes['StockCountSessionsResponse'], ParentType, ContextType, RequireFields<QueryStockCountSessionsArgs, 'input'>>;
  stockCountUsers?: Resolver<ResolversTypes['StockCountUsersResponse'], ParentType, ContextType, RequireFields<QueryStockCountUsersArgs, 'input'>>;
  storageAreas?: Resolver<ResolversTypes['StorageAreasResponse'], ParentType, ContextType, RequireFields<QueryStorageAreasArgs, 'input'>>;
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType, Partial<QuerySupplierArgs>>;
  supplierAssortments?: Resolver<ResolversTypes['supplierAssortments'], ParentType, ContextType>;
  supplierChatLabels?: Resolver<Maybe<Array<ResolversTypes['ChatLabelsResult']>>, ParentType, ContextType, Partial<QuerySupplierChatLabelsArgs>>;
  supplierDeliveryDateSettings?: Resolver<Maybe<ResolversTypes['SupplierDeliveryDateSettingsResponse']>, ParentType, ContextType, RequireFields<QuerySupplierDeliveryDateSettingsArgs, 'chatId'>>;
  supplierDeliverySetting?: Resolver<Maybe<ResolversTypes['SupplierDeliverySetting']>, ParentType, ContextType, RequireFields<QuerySupplierDeliverySettingArgs, 'id'>>;
  supplierSearch?: Resolver<ResolversTypes['SupplierSearchResponse'], ParentType, ContextType, RequireFields<QuerySupplierSearchArgs, 'query'>>;
  supplierSearchV2?: Resolver<ResolversTypes['SupplierSearchResponse'], ParentType, ContextType, RequireFields<QuerySupplierSearchV2Args, 'coordinates'>>;
  transmissionEvents?: Resolver<Array<ResolversTypes['TransmissionEvent']>, ParentType, ContextType, RequireFields<QueryTransmissionEventsArgs, 'ofId'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, Partial<QueryUserArgs>>;
  userChats?: Resolver<ResolversTypes['UserChatsResponse'], ParentType, ContextType, Partial<QueryUserChatsArgs>>;
  userSearch?: Resolver<ResolversTypes['UserSearchResponse'], ParentType, ContextType, RequireFields<QueryUserSearchArgs, 'query'>>;
  validateProductsAvailability?: Resolver<ResolversTypes['ValidateProductsAvailabilityResponse'], ParentType, ContextType, RequireFields<QueryValidateProductsAvailabilityArgs, 'input'>>;
  vendorItemCategoriesForChat?: Resolver<ResolversTypes['VendorItemCategoriesForChatResponse'], ParentType, ContextType, RequireFields<QueryVendorItemCategoriesForChatArgs, 'input'>>;
  vendorItems?: Resolver<ResolversTypes['VendorItemsResponse'], ParentType, ContextType, RequireFields<QueryVendorItemsArgs, 'input'>>;
  vendorItemsCountForChat?: Resolver<ResolversTypes['VendorItemsCountForChatResponse'], ParentType, ContextType, RequireFields<QueryVendorItemsCountForChatArgs, 'input'>>;
  vendorItemsForChat?: Resolver<ResolversTypes['VendorItemsForChatResponse'], ParentType, ContextType, RequireFields<QueryVendorItemsForChatArgs, 'input'>>;
  vendorItemsForVendor?: Resolver<ResolversTypes['VendorItemsForVendorResponse'], ParentType, ContextType, RequireFields<QueryVendorItemsForVendorArgs, 'input'>>;
};

export type BlockedEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedEmail'] = ResolversParentTypes['BlockedEmail']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = {
  __resolveType: TypeResolveFn<'BlockedEmail' | 'Broadcast' | 'Chat' | 'Buyer' | 'User' | 'Supplier' | 'PaymentAccount' | 'InviteTransmission' | 'TransmissionEvent' | 'Product' | 'ProductCategory' | 'Message' | 'Order' | 'Invoice' | 'OmnichannelOrder' | 'OmnichannelOrderAttachment' | 'OrderChange' | 'OrderRestaurant' | 'OrderGuideV2' | 'SubCatalog' | 'BuyerStockCount' | 'BuyerStockInventoryProduct' | 'CatalogImportNode' | 'CategoryProducts' | 'OrderGuideCategory' | 'OrderGuideProductItem' | 'SuggestedProduct' | 'ConnectedAccount' | 'IntegrationAdapterConnectionBaseResult' | 'IntegrationAdapterConnectionAdminResult' | 'Group' | 'GroupUser' | 'IntegrationAdapterBaseResult' | 'IntegrationAdapterAdminResult' | 'UserRequestToJoin' | 'LobbyBuyer' | 'OrderGuideV2Category' | 'OrderGuideV2ItemUnit' | 'VendorItemUnit' | 'VendorItemUnitPriceSet' | 'VendorItem' | 'VendorItemVariantGroup' | 'VendorItemCategory' | 'TaxonomyLabel' | 'SuppliersPaymentAccount' | 'Notification' | 'OrderResult', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export interface AwsTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export type BlockedEmailConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedEmailConnection'] = ResolversParentTypes['BlockedEmailConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BlockedEmailEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  __resolveType: TypeResolveFn<'BlockedEmailConnection' | 'BuyerUserConnection' | 'UserBuyerConnection' | 'UserChatConnection' | 'UserUserConnection' | 'SupplierUserConnection' | 'BuyerChatConnection' | 'ChatMessageConnection' | 'ChatUserConnection' | 'CatalogProductsConnection' | 'BuyerStockCountConnection' | 'BuyerStockInventoryProductConnection' | 'CatalogImportsResult' | 'SuggestedProductConnection' | 'ConnectedAccountConnection' | 'IntegrationAdapterConnectionBaseResultConnection' | 'IntegrationAdapterConnectionAdminResultConnection' | 'GroupUserConnection' | 'IntegrationAdapterBaseResultConnection' | 'IntegrationAdapterAdminResultConnection' | 'RequestsToJoinConnection' | 'SubCatalogConnection' | 'UserLobbyBuyerConnection' | 'OrderGuideV2CategoriesResult' | 'OrderGuideV2ItemUnitsResult' | 'OrdersToReviewConnection' | 'SearchBuyerConnection' | 'GroupConnection' | 'SearchOrderConnection' | 'OrderDeskChatsConnection' | 'SearchProductsConnection' | 'SearchTaxonomyLabelsConnection' | 'SearchSupplierConnection' | 'UserSearchConnection' | 'VendorItemCategoriesForChatSuccess' | 'VendorItemsForChatSuccess' | 'VendorItemsForVendorResult' | 'ProductConnection', ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<ResolversTypes['Edge']>>, ParentType, ContextType>;
};

export type EdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Edge'] = ResolversParentTypes['Edge']> = {
  __resolveType: TypeResolveFn<'BlockedEmailEdge' | 'BuyerUserEdge' | 'UserBuyerEdge' | 'UserChatEdge' | 'UserUserEdge' | 'SupplierUserEdge' | 'BuyerChatEdge' | 'ChatMessageEdge' | 'ChatUserEdge' | 'CatalogProductsEdge' | 'BuyerStockCountEdge' | 'BuyerStockInventoryProductEdge' | 'CatalogImportsResultEdge' | 'SuggestedProductEdge' | 'ConnectedAccountEdge' | 'IntegrationAdapterConnectionBaseResultEdge' | 'IntegrationAdapterConnectionAdminResultEdge' | 'GroupUserEdge' | 'IntegrationAdapterBaseResultEdge' | 'IntegrationAdapterAdminResultEdge' | 'UserRequestToJoinEdge' | 'SubCatalogEdge' | 'UserLobbyBuyerEdge' | 'OrderGuideV2CategoriesResultEdge' | 'OrderGuideV2ItemUnitsResultEdge' | 'OrdersToReviewEdge' | 'BuyerEdge' | 'GroupEdge' | 'SearchOrderEdge' | 'OrderDeskChatsEdge' | 'SearchProductsEdge' | 'SearchTaxonomyLabelsEdge' | 'SupplierSearchEdge' | 'UserSearchEdge' | 'VendorItemCategoriesForChatResultEdge' | 'VendorItemsForChatResultEdge' | 'VendorItemsForVendorResultEdge' | 'ProductEdge', ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Node'], ParentType, ContextType>;
};

export type BlockedEmailEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedEmailEdge'] = ResolversParentTypes['BlockedEmailEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BlockedEmail'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastResolvers<ContextType = any, ParentType extends ResolversParentTypes['Broadcast'] = ResolversParentTypes['Broadcast']> = {
  analytics?: Resolver<Maybe<ResolversTypes['BroadcastAnalytics']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['BroadcastMediaAttachment']>, ParentType, ContextType>;
  chatIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  chatLabels?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  chats?: Resolver<Maybe<Array<ResolversTypes['Chat']>>, ParentType, ContextType, Partial<BroadcastChatsArgs>>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  customerPerformance?: Resolver<Maybe<ResolversTypes['BroadcastCustomerPerformanceResult']>, ParentType, ContextType, Partial<BroadcastCustomerPerformanceArgs>>;
  endsAt?: Resolver<Maybe<ResolversTypes['BroadCastEndsAt']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nextScheduledDispatch?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  pdfName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  productPerformance?: Resolver<Maybe<ResolversTypes['BroadcastProductPerformanceResult']>, ParentType, ContextType, Partial<BroadcastProductPerformanceArgs>>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType, Partial<BroadcastProductsArgs>>;
  recipientCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schedule?: Resolver<Maybe<ResolversTypes['OneTimeBroadcastSchedule']>, ParentType, ContextType>;
  sendToAll?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  senderUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BroadcastStatus'], ParentType, ContextType>;
  supplierEntityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastAnalytics'] = ResolversParentTypes['BroadcastAnalytics']> = {
  numChats?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numChatsOpened?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numChatsClicked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numChatsAddedProductsToOrderGuide?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numChatsProductsOrdered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasProducts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  revenueCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportUpdatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastMediaAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastMediaAttachment'] = ResolversParentTypes['BroadcastMediaAttachment']> = {
  image?: Resolver<Maybe<ResolversTypes['BroadcastMedia']>, ParentType, ContextType>;
  pdf?: Resolver<Maybe<ResolversTypes['BroadcastPdfMedia']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastMedia'] = ResolversParentTypes['BroadcastMedia']> = {
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastPdfMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastPdfMedia'] = ResolversParentTypes['BroadcastPdfMedia']> = {
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chat'] = ResolversParentTypes['Chat']> = {
  activatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  additionalEmails?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  botUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['Buyer']>, ParentType, ContextType>;
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  chatName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  churn?: Resolver<Maybe<ResolversTypes['ChatChurn']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['CreatedBy']>, ParentType, ContextType>;
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDateSettings?: Resolver<Maybe<ResolversTypes['SupplierDeliveryDateSettings']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasMessages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasOrderTransmission?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasRequestedOrderGuide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasVendorCatalog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invite?: Resolver<Maybe<ResolversTypes['InviteTransmission']>, ParentType, ContextType>;
  inviteStatus?: Resolver<Maybe<ResolversTypes['InviteStatus']>, ParentType, ContextType>;
  isPuppy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUserInChat?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<ChatIsUserInChatArgs, 'userId'>>;
  labels?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  messages?: Resolver<ResolversTypes['ChatMessageConnection'], ParentType, ContextType, Partial<ChatMessagesArgs>>;
  orderGuide?: Resolver<Maybe<ResolversTypes['OrderGuideV2Ref']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  restaurantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendBuyerOrderConfirmation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ChatStatus'], ParentType, ContextType>;
  subCatalog?: Resolver<Maybe<ResolversTypes['SubCatalog']>, ParentType, ContextType>;
  subCatalogId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  supplierCustomerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierEntity?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  supplierEntityId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ChatType']>, ParentType, ContextType>;
  users?: Resolver<ResolversTypes['ChatUserConnection'], ParentType, ContextType, Partial<ChatUsersArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Buyer'] = ResolversParentTypes['Buyer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fullAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressSource?: Resolver<ResolversTypes['AddressSource'], ParentType, ContextType>;
  googlePlaceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  googlePlaceAddressId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  utcOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deliveryComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  users?: Resolver<Maybe<ResolversTypes['BuyerUserConnection']>, ParentType, ContextType, Partial<BuyerUsersArgs>>;
  profileImage?: Resolver<Maybe<ResolversTypes['ProfileImage']>, ParentType, ContextType>;
  chats?: Resolver<Maybe<ResolversTypes['BuyerChatConnection']>, ParentType, ContextType, Partial<BuyerChatsArgs>>;
  invoiceRecipientEmails?: Resolver<Maybe<Array<ResolversTypes['AWSEmail']>>, ParentType, ContextType>;
  rolesEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPuppy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  streetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  administrativeAreaLevelOne?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kyc?: Resolver<Maybe<ResolversTypes['Kyc']>, ParentType, ContextType>;
  defaultCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdContext?: Resolver<Maybe<ResolversTypes['BuyerCreatedContext']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BuyerStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerUserConnection'] = ResolversParentTypes['BuyerUserConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BuyerUserEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerUserEdge'] = ResolversParentTypes['BuyerUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  hasAcceptedTermsAndConditions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pending?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buyers?: Resolver<Maybe<ResolversTypes['UserBuyerConnection']>, ParentType, ContextType, Partial<UserBuyersArgs>>;
  chats?: Resolver<ResolversTypes['UserChatConnection'], ParentType, ContextType, Partial<UserChatsArgs>>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryCosts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minOrderAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  supplier?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  chocoUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  suppliers?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  paginatedContacts?: Resolver<ResolversTypes['UserUserConnection'], ParentType, ContextType, Partial<UserPaginatedContactsArgs>>;
  paginatedSuppliers?: Resolver<ResolversTypes['UserUserConnection'], ParentType, ContextType, Partial<UserPaginatedSuppliersArgs>>;
  orderPreference?: Resolver<Maybe<ResolversTypes['OrderPreference']>, ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  botUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profileImage?: Resolver<Maybe<ResolversTypes['ProfileImage']>, ParentType, ContextType>;
  role?: Resolver<Maybe<Array<Maybe<ResolversTypes['Role']>>>, ParentType, ContextType>;
  linkedSupplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  isTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPuppy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inviteData?: Resolver<Maybe<ResolversTypes['InviteInfo']>, ParentType, ContextType>;
  translationLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthdate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  referral?: Resolver<Maybe<ResolversTypes['GetReferralResponse']>, ParentType, ContextType>;
  hasRequestedToBeDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  submittedGetIntouchRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdContext?: Resolver<Maybe<ResolversTypes['UserCreatedContext']>, ParentType, ContextType>;
  inviteTransmissions?: Resolver<Maybe<Array<ResolversTypes['InviteTransmission']>>, ParentType, ContextType>;
  challengeByEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  phoneNumberType?: Resolver<Maybe<ResolversTypes['UserPhoneType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserBuyerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserBuyerConnection'] = ResolversParentTypes['UserBuyerConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserBuyerEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserBuyerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserBuyerEdge'] = ResolversParentTypes['UserBuyerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Buyer'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserChatConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserChatConnection'] = ResolversParentTypes['UserChatConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['UserChatEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserChatEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserChatEdge'] = ResolversParentTypes['UserChatEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserUserConnection'] = ResolversParentTypes['UserUserConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['UserUserEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserUserEdge'] = ResolversParentTypes['UserUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPreference'] = ResolversParentTypes['OrderPreference']> = {
  pdf?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  xlsx?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whatsApp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  welcomeNotificationSent?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileImage'] = ResolversParentTypes['ProfileImage']> = {
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smallSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  largeSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smallThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  largeThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  largeRectangle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumRectangle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smallRectangle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['Supplier'] = ResolversParentTypes['Supplier']> = {
  accessPackage?: Resolver<ResolversTypes['AccessPackage'], ParentType, ContextType>;
  allowCustomProducts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowCustomerAcquisition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  allowOnlyOneActiveVariant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appliedMinimumOrderValue?: Resolver<Maybe<ResolversTypes['MinimumOrderValueResponse']>, ParentType, ContextType, Partial<SupplierAppliedMinimumOrderValueArgs>>;
  botUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  botUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  catalogProductsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactEmails?: Resolver<Maybe<Array<ResolversTypes['AWSEmail']>>, ParentType, ContextType>;
  coverPhoto?: Resolver<Maybe<ResolversTypes['ProfileImage']>, ParentType, ContextType>;
  customerNumberMandatory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultSubCatalog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryCosts?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDateMandatory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deliverySetting?: Resolver<Maybe<ResolversTypes['SupplierDeliverySetting']>, ParentType, ContextType>;
  deliveryZones?: Resolver<Maybe<Array<ResolversTypes['DeliveryZone']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasCoverPhoto?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasEnabledCatalogProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasEnabledFractionalUnits?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasProfilePhoto?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasValidCatalogProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<Array<ResolversTypes['IntegrationOption']>, ParentType, ContextType>;
  isDiscoverable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isInstantInvoiceEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isIntegrated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPaymentEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPuppy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minOrder?: Resolver<Maybe<ResolversTypes['MinOrder']>, ParentType, ContextType>;
  minOrderAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noDefaultCatalog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orderExportFormat?: Resolver<Maybe<ResolversTypes['OrderExportConfigFormat']>, ParentType, ContextType>;
  orderExportUpload?: Resolver<Maybe<ResolversTypes['OrderExportUploadOption']>, ParentType, ContextType>;
  paymentAccounts?: Resolver<ResolversTypes['ListPaymentAccountsResponse'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceSetting?: Resolver<Maybe<ResolversTypes['PriceSetting']>, ParentType, ContextType>;
  primaryAssortment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secondaryAssortments?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  users?: Resolver<Maybe<ResolversTypes['SupplierUserConnection']>, ParentType, ContextType, Partial<SupplierUsersArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MinimumOrderValueResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinimumOrderValueResponse'] = ResolversParentTypes['MinimumOrderValueResponse']> = {
  __resolveType: TypeResolveFn<'MinimumOrderValue' | 'MinimumOrderValueFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type MinimumOrderValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinimumOrderValue'] = ResolversParentTypes['MinimumOrderValue']> = {
  type?: Resolver<Maybe<ResolversTypes['MinimumOrderValueType']>, ParentType, ContextType>;
  minimumOrderValue?: Resolver<Maybe<ResolversTypes['MinOrder']>, ParentType, ContextType>;
  formattedMinimumOrderValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MinOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinOrder'] = ResolversParentTypes['MinOrder']> = {
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decimalPlaces?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MinimumOrderValueFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinimumOrderValueFailure'] = ResolversParentTypes['MinimumOrderValueFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationFailure'] = ResolversParentTypes['AuthorizationFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppsyncResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppsyncResponse'] = ResolversParentTypes['AppsyncResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'InputValidationFailure' | 'PaymentAccountsList' | 'NotFoundError' | 'PaymentResponse' | 'PaymentAccountNotFound' | 'InvoiceHasNoPayment' | 'OrderHasNoInvoice' | 'OrderHasOnlyAttachment' | 'OrderChangeError' | 'CreatedOrCompletedByNotFound' | 'CatalogNotFound' | 'BuyerStockInventoryNotFound' | 'CatalogImportStatusResult' | 'CatalogImportTemplateResult' | 'CatalogImportsResult' | 'ChatNotFoundError' | 'ValidationError' | 'ChatSubCatalogProductsError' | 'BuyerReportGenerationError' | 'BuyerReportNotFoundError' | 'SuggestedProductSuccessResponse' | 'SupplierNotFound' | 'SubCatalogNotFoundError' | 'GroupResponseSuccess' | 'GetGroupEntitiesSuccessResponse' | 'GetGroupUsersSuccessResponse' | 'InviteeNotFound' | 'MarketingMessageSuggestionsSuccess' | 'ReconciliationRequestPlanBySupplierIdNotFound' | 'GetSmsMessageByMessageSidSuccess' | 'GetSmsMessagesFromPhoneNumberSuccess' | 'NoUnconnectedBuyers' | 'UserIntercomCredentialsFailure' | 'GetWhatsAppMessageByMessageSidSuccess' | 'OrderNotFound' | 'ListSubCatalogProductsError' | 'LookupPhoneNumbersError' | 'InvalidCursor' | 'OrderGuideV2CategoriesResult' | 'OrderGuideV2ItemUnitsResult' | 'PublicToken' | 'Redirect' | 'SearchGroupsSuccessResponse' | 'SearchProductsError' | 'SearchTaxonomyLabelsError' | 'SendSampleSmsMessageSuccess' | 'SendSampleSmsMessageFailure' | 'SupplierDeliverySettingsNotFound' | 'UserChatsError' | 'VendorItemCategoriesForChatSuccess' | 'VendorItemsSuccess' | 'VendorItemsCountForChatSuccess' | 'VendorItemsForChatSuccess' | 'VendorItemsForVendorResult' | 'OrderCreatedError' | 'ExternalAccountDetailsMissed' | 'ExternalAccountNotFound' | 'SupplierHasActivePaymentAccountAlready' | 'ProductNotFoundError' | 'AddEntitiesToGroupResponseSuccess' | 'ChatHasNoSupplierEntity' | 'OrderAlreadyHasInvoice' | 'PaymentMethodNotAvailableForUser' | 'SupplierPaymentAccountAlreadyExists' | 'PaymentAccountAlreadyExists' | 'AddProductsToOrderGuidesResult' | 'AddSalesRepError' | 'BuyerAddSupplierError' | 'SupplierPaymentsDisabled' | 'AddUsersToGroupResponseSuccess' | 'AssignOrderToUserForReviewResponseError' | 'BatchOrderConfirmSuccess' | 'BatchOrderConfirmError' | 'OrderDeliveryItemsMismatched' | 'OrderDeliveryCheckAlreadyCompleted' | 'CartVersionConstraintError' | 'CartNotFoundError' | 'CatalogImportStartResult' | 'ClaimOnboardingChecklistRewardError' | 'DeliveryCheckReconciliationRequestNotFound' | 'DeliveryCheckReconciliationRequestAlreadyConfirmed' | 'OrderDeliveryCheckReconciliationRequestIdNotMatched' | 'ConnectAccountError' | 'ChocoEntityNotFound' | 'UnsupportedIntegrationAdapterType' | 'IntegrationAdapterNotFound' | 'OrderDeliveryCheckExists' | 'OrderDeliveryCheckImageNotFound' | 'CreateProfileError' | 'UserHasReferralCode' | 'ReferralCodeGenerationError' | 'CreateSubCatalogError' | 'DuplicateProductError' | 'DeleteBuyerReportScheduleSuccess' | 'BuyerReportScheduleNotFound' | 'DeleteBuyerReportScheduleError' | 'DeleteBuyerStockInventoryProductsSuccess' | 'DeleteSubCatalogSuccess' | 'DeleteSubCatalogError' | 'DisconnectAccountError' | 'IntegrationAdapterConnectionNotFound' | 'GetClientDebuggableArtifactUploadUrlError' | 'GetOrderGuideUploadUrlError' | 'BalanceCheckoutToken' | 'SupplierPaymentAccountMissing' | 'InvoiceAlreadyPaid' | 'InvoicePaymentInProgress' | 'InvoiceTotalTooLow' | 'IntegrationAdapterScopeInsufficient' | 'IntegrationAdapterExists' | 'AttemptToChangeAdapterAuthType' | 'AttemptToReduceIntegrationAdapterScope' | 'BuyerNotFound' | 'InvitorNotFound' | 'ExistingInvitedUser' | 'PuppyValidationFailure' | 'InviteUserToBuyerError' | 'KycResponse' | 'KycBuyerNotFound' | 'KycEntryAlreadyExists' | 'OrderEditedError' | 'OrderGuideCreatedSuccess' | 'OrderGuideCreatedError' | 'OrderGuideRequestError' | 'OrderGuideV2ItemUnitsAddResult' | 'OrderGuideV2ItemUnitsRemoveResult' | 'PostProcessing' | 'PreProcessing' | 'NoFurtherActionNeeded' | 'PaymentAccountIsInactive' | 'UnexpectedInvoiceState' | 'SupplierDoesNotAcceptOnlinePayments' | 'EntityCurrencyMismatch' | 'ReferUserChatExists' | 'ReferUserReferralCodeNotFound' | 'EmailFromBuyerReportScheduleRemoved' | 'EmailInBuyerReportScheduleNotFound' | 'RemoveEntitiesFromGroupResponseSuccess' | 'InvoiceRemoved' | 'InvoiceCannotBeRemoved' | 'InvoiceAttachmentRemoved' | 'InvoiceCannotBeUpdated' | 'PaymentAccountRemoved' | 'RemoveProductsFromOrderGuidesResult' | 'RemoveUsersFromGroupSuccess' | 'RequestToJoinBuyerError' | 'SelectProductForOrderGuideSuccess' | 'SelectProductsForOrderGuideSuccess' | 'SendSyntheticSmsMessageSuccess' | 'SendSyntheticWhatsAppMessageSuccess' | 'CartSubmissionError' | 'CreateMessageError' | 'CartSubmittedEmptyError' | 'CartInvalidProductsError' | 'CartAllProductsUnavailableError' | 'ForbiddenError' | 'ExistingOrderError' | 'ProductLeadTimeError' | 'OrderDeliveryCheckNotFound' | 'SupplierAddRequestError' | 'SupplierGetInTouchRequestSuccess' | 'SupplierGetInTouchRequestError' | 'InvalidInvitedPhoneNumber' | 'SupplierInviteError' | 'SupplierUserRemoveResponse' | 'UnassignUserFromOrderToReviewResponseError' | 'UndoMultiLocationOrderGuideTransactionResult' | 'NegativeAmountError' | 'InvoicedProducts' | 'UpdateProductVariantsInOrderGuideSuccess' | 'UpdateJoinRequestError' | 'UpdateSubCatalogError' | 'SupplierUpdateAccessPackageSuccess' | 'SupplierUpdateAccessPackageError' | 'UploadSubCatalogProductsError' | 'VendorItemUnitUpdateResult' | 'BuyerChatsNotFound' | 'BuyerChatsProductListEmpty', ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
};

export type AppsyncErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppsyncError'] = ResolversParentTypes['AppsyncError']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'InputValidationFailure' | 'NotFoundError' | 'PaymentAccountNotFound' | 'InvoiceHasNoPayment' | 'OrderHasNoInvoice' | 'OrderChangeError' | 'CreatedOrCompletedByNotFound' | 'CatalogNotFound' | 'BuyerStockInventoryNotFound' | 'ChatNotFoundError' | 'ValidationError' | 'ChatSubCatalogProductsError' | 'BuyerReportGenerationError' | 'BuyerReportNotFoundError' | 'GetSuggestedProductsErrorResponse' | 'SupplierNotFound' | 'SubCatalogNotFoundError' | 'GroupResponseError' | 'GetGroupEntitiesErrorResponse' | 'GetGroupUsersErrorResponse' | 'InviteeNotFound' | 'MarketingMessageSuggestionsError' | 'MarketingMessageSuggestionsErrorNoSuggestions' | 'MarketingMessageSuggestionsErrorThrottling' | 'ReconciliationRequestPlanBySupplierIdNotFound' | 'NoUnconnectedBuyers' | 'UserIntercomCredentialsFailure' | 'OrderNotFound' | 'ListSubCatalogProductsError' | 'LookupPhoneNumbersError' | 'InvalidCursor' | 'SearchGroupsErrorResponse' | 'SearchProductsError' | 'SearchTaxonomyLabelsError' | 'SupplierDeliverySettingsNotFound' | 'UserChatsError' | 'OrderCreatedError' | 'ExternalAccountDetailsMissed' | 'ExternalAccountNotFound' | 'SupplierHasActivePaymentAccountAlready' | 'ProductNotFoundError' | 'AddEntitiesToGroupResponseError' | 'ChatHasNoSupplierEntity' | 'OrderAlreadyHasInvoice' | 'PaymentMethodNotAvailableForUser' | 'SupplierPaymentAccountAlreadyExists' | 'PaymentAccountAlreadyExists' | 'AddSalesRepError' | 'BuyerAddSupplierError' | 'SupplierPaymentsDisabled' | 'AddUsersToGroupResponseError' | 'AssignOrderToUserForReviewResponseError' | 'BatchOrderConfirmError' | 'OrderDeliveryItemsMismatched' | 'OrderDeliveryCheckAlreadyCompleted' | 'CartVersionConstraintError' | 'CartNotFoundError' | 'ClaimOnboardingChecklistRewardError' | 'DeliveryCheckReconciliationRequestNotFound' | 'DeliveryCheckReconciliationRequestAlreadyConfirmed' | 'OrderDeliveryCheckReconciliationRequestIdNotMatched' | 'ConnectAccountError' | 'ChocoEntityNotFound' | 'UnsupportedIntegrationAdapterType' | 'IntegrationAdapterNotFound' | 'OrderDeliveryCheckExists' | 'OrderDeliveryCheckImageNotFound' | 'CreateProfileError' | 'UserHasReferralCode' | 'ReferralCodeGenerationError' | 'CreateSubCatalogError' | 'DuplicateProductError' | 'BuyerReportScheduleNotFound' | 'DeleteBuyerReportScheduleError' | 'DeleteSubCatalogError' | 'DisconnectAccountError' | 'IntegrationAdapterConnectionNotFound' | 'GetClientDebuggableArtifactUploadUrlError' | 'GetOrderGuideUploadUrlError' | 'SupplierPaymentAccountMissing' | 'InvoiceAlreadyPaid' | 'InvoicePaymentInProgress' | 'InvoiceTotalTooLow' | 'IntegrationAdapterScopeInsufficient' | 'IntegrationAdapterExists' | 'AttemptToChangeAdapterAuthType' | 'AttemptToReduceIntegrationAdapterScope' | 'BuyerNotFound' | 'InvitorNotFound' | 'ExistingInvitedUser' | 'PuppyValidationFailure' | 'InviteUserToBuyerError' | 'KycBuyerNotFound' | 'KycEntryAlreadyExists' | 'OrderEditedError' | 'OrderGuideCreatedError' | 'OrderGuideRequestError' | 'PaymentAccountIsInactive' | 'UnexpectedInvoiceState' | 'SupplierDoesNotAcceptOnlinePayments' | 'EntityCurrencyMismatch' | 'ReferUserChatExists' | 'ReferUserReferralCodeNotFound' | 'EmailFromBuyerReportScheduleRemoved' | 'EmailInBuyerReportScheduleNotFound' | 'RemoveEntitiesFromGroupResponseError' | 'InvoiceCannotBeRemoved' | 'InvoiceCannotBeUpdated' | 'RemoveUsersFromGroupError' | 'RequestToJoinBuyerError' | 'CartSubmissionError' | 'CreateMessageError' | 'CartSubmittedEmptyError' | 'CartInvalidProductsError' | 'CartAllProductsUnavailableError' | 'ForbiddenError' | 'ExistingOrderError' | 'ProductLeadTimeError' | 'OrderDeliveryCheckNotFound' | 'SupplierAddRequestError' | 'SupplierGetInTouchRequestError' | 'InvalidInvitedPhoneNumber' | 'SupplierInviteError' | 'UnassignUserFromOrderToReviewResponseError' | 'NegativeAmountError' | 'UpdateJoinRequestError' | 'UpdateSubCatalogError' | 'SupplierUpdateAccessPackageError' | 'UploadSubCatalogProductsError' | 'BuyerChatsNotFound' | 'BuyerChatsProductListEmpty', ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type InputValidationFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputValidationFailure'] = ResolversParentTypes['InputValidationFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invalidFields?: Resolver<Maybe<Array<ResolversTypes['FieldValidationError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FieldValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FieldValidationError'] = ResolversParentTypes['FieldValidationError']> = {
  fieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AwsEmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export type SupplierDeliverySettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDeliverySetting'] = ResolversParentTypes['SupplierDeliverySetting']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['CutOffTime']>, ParentType, ContextType>;
  deliveryDays?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SupplierDeliverySettingType'], ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['SupplierDeliverySettingScope'], ParentType, ContextType>;
  cutoffTimes?: Resolver<ResolversTypes['WeekdayBasedCutoffSettings'], ParentType, ContextType>;
  cutoffType?: Resolver<Maybe<ResolversTypes['CutOffTimeType']>, ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exceptions?: Resolver<Maybe<Array<ResolversTypes['DeliverySettingException']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CutOffTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CutOffTime'] = ResolversParentTypes['CutOffTime']> = {
  type?: Resolver<ResolversTypes['CutOffTimeType'], ParentType, ContextType>;
  time?: Resolver<ResolversTypes['AWSTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AwsTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export type WeekdayBasedCutoffSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeekdayBasedCutoffSettings'] = ResolversParentTypes['WeekdayBasedCutoffSettings']> = {
  mon?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  tue?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  wed?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  thu?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  fri?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  sat?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  sun?: Resolver<Maybe<ResolversTypes['CutoffSetting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CutoffSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CutoffSetting'] = ResolversParentTypes['CutoffSetting']> = {
  __resolveType: TypeResolveFn<'NoCutoffSetting' | 'WithCutoffSetting', ParentType, ContextType>;
};

export type NoCutoffSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoCutoffSetting'] = ResolversParentTypes['NoCutoffSetting']> = {
  type?: Resolver<ResolversTypes['NoCutoffType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithCutoffSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['WithCutoffSetting'] = ResolversParentTypes['WithCutoffSetting']> = {
  type?: Resolver<ResolversTypes['WithCutoffType'], ParentType, ContextType>;
  leadTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cutoffTime?: Resolver<ResolversTypes['AWSTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliverySettingExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliverySettingException'] = ResolversParentTypes['DeliverySettingException']> = {
  __resolveType: TypeResolveFn<'SingleDayDeliveryExceptionWithCutoff' | 'SingleDayDeliveryExceptionWithoutCutoff' | 'NoDeliveryException', ParentType, ContextType>;
};

export type SingleDayDeliveryExceptionWithCutoffResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleDayDeliveryExceptionWithCutoff'] = ResolversParentTypes['SingleDayDeliveryExceptionWithCutoff']> = {
  type?: Resolver<ResolversTypes['SingleDayDeliveryExceptionType'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDate'], ParentType, ContextType>;
  cutoffType?: Resolver<ResolversTypes['WithCutoffType'], ParentType, ContextType>;
  leadTimeAdjustedCutoff?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  updateBehavior?: Resolver<ResolversTypes['DeliverySettingExceptionUpdateBehavior'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AwsDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export type SingleDayDeliveryExceptionWithoutCutoffResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleDayDeliveryExceptionWithoutCutoff'] = ResolversParentTypes['SingleDayDeliveryExceptionWithoutCutoff']> = {
  type?: Resolver<ResolversTypes['SingleDayDeliveryExceptionType'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDate'], ParentType, ContextType>;
  cutoffType?: Resolver<ResolversTypes['NoCutoffType'], ParentType, ContextType>;
  updateBehavior?: Resolver<ResolversTypes['DeliverySettingExceptionUpdateBehavior'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoDeliveryExceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoDeliveryException'] = ResolversParentTypes['NoDeliveryException']> = {
  type?: Resolver<ResolversTypes['NoDeliveryExceptionType'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['AWSDate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryZone'] = ResolversParentTypes['DeliveryZone']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  points?: Resolver<Array<ResolversTypes['Coordinate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoordinateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Coordinate'] = ResolversParentTypes['Coordinate']> = {
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationOption'] = ResolversParentTypes['IntegrationOption']> = {
  __resolveType: TypeResolveFn<'IntegrationSmsOption' | 'IntegrationEmailOption' | 'IntegrationFaxOption' | 'IntegrationWhatsAppOption', ParentType, ContextType>;
};

export type IntegrationSmsOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationSmsOption'] = ResolversParentTypes['IntegrationSmsOption']> = {
  type?: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationEmailOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationEmailOption'] = ResolversParentTypes['IntegrationEmailOption']> = {
  type?: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  xlsx?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pdf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  complaintEmails?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  orderEmails?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  messageEmails?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationFaxOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationFaxOption'] = ResolversParentTypes['IntegrationFaxOption']> = {
  type?: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationWhatsAppOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWhatsAppOption'] = ResolversParentTypes['IntegrationWhatsAppOption']> = {
  type?: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportConfigFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportConfigFormat'] = ResolversParentTypes['OrderExportConfigFormat']> = {
  __resolveType: TypeResolveFn<'OrderExportConfigCsvFormat' | 'OrderExportConfigEdiFormat' | 'OrderExportConfigLobsterFormat', ParentType, ContextType>;
};

export type OrderExportConfigCsvFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportConfigCsvFormat'] = ResolversParentTypes['OrderExportConfigCsvFormat']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotedString?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dateFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  delimiter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportConfigEdiFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportConfigEdiFormat'] = ResolversParentTypes['OrderExportConfigEdiFormat']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  template?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  choco?: Resolver<Maybe<ResolversTypes['OrderExportChocoEdiFormat']>, ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['OrderExportSupplierEdiFormat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportChocoEdiFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportChocoEdiFormat'] = ResolversParentTypes['OrderExportChocoEdiFormat']> = {
  qualifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportSupplierEdiFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportSupplierEdiFormat'] = ResolversParentTypes['OrderExportSupplierEdiFormat']> = {
  qualifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productIdQualifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameReferenceQualifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportConfigLobsterFormatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportConfigLobsterFormat'] = ResolversParentTypes['OrderExportConfigLobsterFormat']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportUploadOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportUploadOption'] = ResolversParentTypes['OrderExportUploadOption']> = {
  __resolveType: TypeResolveFn<'OrderExportChocoSftpUpload' | 'OrderExportExternalSftpUpload' | 'OrderExportLobsterUpload', ParentType, ContextType>;
};

export type OrderExportChocoSftpUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportChocoSftpUpload'] = ResolversParentTypes['OrderExportChocoSftpUpload']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportExternalSftpUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportExternalSftpUpload'] = ResolversParentTypes['OrderExportExternalSftpUpload']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  port?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  forceIPv4?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  readyTimeout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  forceIPv6?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  privateKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  passphrase?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportLobsterUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportLobsterUpload'] = ResolversParentTypes['OrderExportLobsterUpload']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListPaymentAccountsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListPaymentAccountsResponse'] = ResolversParentTypes['ListPaymentAccountsResponse']> = {
  __resolveType: TypeResolveFn<'PaymentAccountsList' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type PaymentAccountsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountsList'] = ResolversParentTypes['PaymentAccountsList']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  accounts?: Resolver<Array<Maybe<ResolversTypes['PaymentAccount']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccount'] = ResolversParentTypes['PaymentAccount']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  lastUsedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  expiration?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psp?: Resolver<ResolversTypes['PaymentAccountPsp'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['PaymentAccountDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountPspResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountPsp'] = ResolversParentTypes['PaymentAccountPsp']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountDetails'] = ResolversParentTypes['PaymentAccountDetails']> = {
  __resolveType: TypeResolveFn<'BankAccountDetails' | 'CreditCardDetails' | 'BalanceVendorBankDetails' | 'BalanceBuyerBankDetails' | 'WalletDetails' | 'PayoutDetails', ParentType, ContextType>;
};

export type BankAccountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccountDetails'] = ResolversParentTypes['BankAccountDetails']> = {
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumberType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditCardDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditCardDetails'] = ResolversParentTypes['CreditCardDetails']> = {
  cardNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cardType?: Resolver<Maybe<ResolversTypes['CardType']>, ParentType, ContextType>;
  expMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalanceVendorBankDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceVendorBankDetails'] = ResolversParentTypes['BalanceVendorBankDetails']> = {
  vendorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalanceBuyerBankDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceBuyerBankDetails'] = ResolversParentTypes['BalanceBuyerBankDetails']> = {
  _?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalletDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WalletDetails'] = ResolversParentTypes['WalletDetails']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayoutDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutDetails'] = ResolversParentTypes['PayoutDetails']> = {
  paymentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PriceSetting'] = ResolversParentTypes['PriceSetting']> = {
  displayInMarketplace?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  displayToCustomers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUserConnection'] = ResolversParentTypes['SupplierUserConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['SupplierUserEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUserEdge'] = ResolversParentTypes['SupplierUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteInfo'] = ResolversParentTypes['InviteInfo']> = {
  googlePlaceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviterUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  googlePlaceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  googleFullAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetReferralResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetReferralResponse'] = ResolversParentTypes['GetReferralResponse']> = {
  __resolveType: TypeResolveFn<'Referral' | 'NotFoundError', ParentType, ContextType>;
};

export type ReferralResolvers<ContextType = any, ParentType extends ResolversParentTypes['Referral'] = ResolversParentTypes['Referral']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  referrerUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referralLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotFoundError'] = ResolversParentTypes['NotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteTransmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteTransmission'] = ResolversParentTypes['InviteTransmission']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inviteeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviteeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitedToEntityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviteeEntityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteeEntityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitorUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invitorEntityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['InviteChannel'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InviteStatus'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  transmissionEvents?: Resolver<Array<ResolversTypes['TransmissionEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransmissionEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransmissionEvent'] = ResolversParentTypes['TransmissionEvent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ofId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ofIdType?: Resolver<ResolversTypes['TransmissionOfType'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toType?: Resolver<ResolversTypes['TransmissionToType'], ParentType, ContextType>;
  newState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDeliveryEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFailureEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  metaData?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export type BuyerChatConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerChatConnection'] = ResolversParentTypes['BuyerChatConnection']> = {
  edges?: Resolver<Array<ResolversTypes['BuyerChatEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerChatEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerChatEdge'] = ResolversParentTypes['BuyerChatEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycResolvers<ContextType = any, ParentType extends ResolversParentTypes['Kyc'] = ResolversParentTypes['Kyc']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  businessName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  administrativeAreaLevelOne?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cart'] = ResolversParentTypes['Cart']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<Maybe<ResolversTypes['CartLineItem']>>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  isOpen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLineItem'] = ResolversParentTypes['CartLineItem']> = {
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productMeta?: Resolver<Maybe<ResolversTypes['CartProductMetadata']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  par?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  cost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCatalogCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  inProductList?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leadTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deliveryDateConditions?: Resolver<Maybe<ResolversTypes['ProductDeliveryDateCondition']>, ParentType, ContextType, RequireFields<ProductDeliveryDateConditionsArgs, 'chatId'>>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['AWSTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subCatalogs?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  subCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoiceUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimumFractionalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['AWSURL']>, ParentType, ContextType>;
  variantTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  listPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ean?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayImage?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  buyerInventoryProduct?: Resolver<Maybe<ResolversTypes['BuyerInventoryProduct']>, ParentType, ContextType, RequireFields<ProductBuyerInventoryProductArgs, 'chatId'>>;
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  supplierNegotiatedPrice?: Resolver<Maybe<ResolversTypes['SupplierNegotiatedPrice']>, ParentType, ContextType, Partial<ProductSupplierNegotiatedPriceArgs>>;
  versionTimestamp?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  negotiatedPriceVersionTimestamp?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  discountedPriceVersionTimestamp?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  variantsInCatalog?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  variantsInProductList?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  appliedCatalogPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountedPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  derivedPriceForOrderGuide?: Resolver<Maybe<ResolversTypes['DerivedPriceForOrderGuideResponse']>, ParentType, ContextType, Partial<ProductDerivedPriceForOrderGuideArgs>>;
  basePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  baseUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelectedInOrderGuide?: Resolver<Maybe<ResolversTypes['IsSelectedInOrderGuideResponse']>, ParentType, ContextType, RequireFields<ProductIsSelectedInOrderGuideArgs, 'chatId'>>;
  hasVariantsInCatalog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductCategory'] = ResolversParentTypes['ProductCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductDeliveryDateConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductDeliveryDateCondition'] = ResolversParentTypes['ProductDeliveryDateCondition']> = {
  earliestDeliveryDate?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  showEarliestDeliveryDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AwsurlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type ProductImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductImage'] = ResolversParentTypes['ProductImage']> = {
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smallSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  largeSquare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerInventoryProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerInventoryProduct'] = ResolversParentTypes['BuyerInventoryProduct']> = {
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  versionTimestamp?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierNegotiatedPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierNegotiatedPrice'] = ResolversParentTypes['SupplierNegotiatedPrice']> = {
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  versionTimestamp?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DerivedPriceForOrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DerivedPriceForOrderGuideResponse'] = ResolversParentTypes['DerivedPriceForOrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'DerivedPriceForOrderGuide' | 'InputValidationFailure', ParentType, ContextType>;
};

export type DerivedPriceForOrderGuideResolvers<ContextType = any, ParentType extends ResolversParentTypes['DerivedPriceForOrderGuide'] = ResolversParentTypes['DerivedPriceForOrderGuide']> = {
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  priceBeforeDiscount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IsSelectedInOrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IsSelectedInOrderGuideResponse'] = ResolversParentTypes['IsSelectedInOrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'IsSelectedInOrderGuide' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IsSelectedInOrderGuideResolvers<ContextType = any, ParentType extends ResolversParentTypes['IsSelectedInOrderGuide'] = ResolversParentTypes['IsSelectedInOrderGuide']> = {
  value?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartProductMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartProductMetadata'] = ResolversParentTypes['CartProductMetadata']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatChurnResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatChurn'] = ResolversParentTypes['ChatChurn']> = {
  status?: Resolver<ResolversTypes['ChatChurnStatus'], ParentType, ContextType>;
  lastOrderDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  predictedNextOrderDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  lastOrderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatedByResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatedBy'] = ResolversParentTypes['CreatedBy']> = {
  createdContext?: Resolver<Maybe<ResolversTypes['CreatedContext']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierDeliveryDateSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDeliveryDateSettings'] = ResolversParentTypes['SupplierDeliveryDateSettings']> = {
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['CutOffTime']>, ParentType, ContextType>;
  deliveryDates?: Resolver<Maybe<Array<ResolversTypes['AWSDate']>>, ParentType, ContextType>;
  deliveryDays?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  availableDeliveryDates?: Resolver<Array<ResolversTypes['AvailableDeliveryDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableDeliveryDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableDeliveryDate'] = ResolversParentTypes['AvailableDeliveryDate']> = {
  date?: Resolver<ResolversTypes['AWSDate'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CutOffTimeType'], ParentType, ContextType>;
  leadTimeAdjustedCutoff?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageConnection'] = ResolversParentTypes['ChatMessageConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ChatMessageEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatMessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatMessageEdge'] = ResolversParentTypes['ChatMessageEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>;
  chat?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['Attachment']>, ParentType, ContextType>;
  broadcastId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['Buyer']>, ParentType, ContextType>;
  chat?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confirmationSource?: Resolver<Maybe<ResolversTypes['ConfirmationSource']>, ParentType, ContextType>;
  confirmationTime?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  estimatedOrderTotal?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoice?: Resolver<ResolversTypes['OrderInvoice'], ParentType, ContextType>;
  invoicedProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['InvoicedProduct']>>>, ParentType, ContextType>;
  isTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  numberOfProducts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  omnichannelOrder?: Resolver<Maybe<ResolversTypes['OmnichannelOrder']>, ParentType, ContextType>;
  orderChanges?: Resolver<Maybe<ResolversTypes['OrderChangeResponse']>, ParentType, ContextType>;
  orderDeliveryCheck?: Resolver<Maybe<ResolversTypes['GetOrderDeliveryCheckResponse']>, ParentType, ContextType>;
  orderProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderProduct']>>>, ParentType, ContextType>;
  orderSupplierStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderedProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderedProduct']>>>, ParentType, ContextType>;
  pdf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<OrderPdfArgs, 'downloadable'>>;
  poNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restaurant?: Resolver<Maybe<ResolversTypes['OrderRestaurant']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OrderStatus']>, ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  supplierRefId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderInvoice'] = ResolversParentTypes['OrderInvoice']> = {
  __resolveType: TypeResolveFn<'Invoice' | 'OrderHasNoInvoice' | 'OrderHasOnlyAttachment' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  issueDate?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentTerms?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  pdfAttachment?: Resolver<ResolversTypes['InvoiceFileUrls'], ParentType, ContextType>;
  attachment?: Resolver<ResolversTypes['InvoiceAttachment'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachmentState?: Resolver<ResolversTypes['AttachmentState'], ParentType, ContextType>;
  currentPayment?: Resolver<ResolversTypes['CurrentPaymentResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceFileUrlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceFileUrls'] = ResolversParentTypes['InvoiceFileUrls']> = {
  pdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfUploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceAttachment'] = ResolversParentTypes['InvoiceAttachment']> = {
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AttachmentStatus'], ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentPaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentPaymentResponse'] = ResolversParentTypes['CurrentPaymentResponse']> = {
  __resolveType: TypeResolveFn<'PaymentResponse' | 'InvoiceHasNoPayment' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type PaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentResponse'] = ResolversParentTypes['PaymentResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheduledFor?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  paymentAccount?: Resolver<ResolversTypes['PaymentAccountResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountResponse'] = ResolversParentTypes['PaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'SecuredPaymentAccount' | 'PaymentAccountNotFound' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SecuredPaymentAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuredPaymentAccount'] = ResolversParentTypes['SecuredPaymentAccount']> = {
  method?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  lastUsedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  expiration?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  psp?: Resolver<ResolversTypes['PaymentAccountPsp'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['PaymentAccountDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountNotFound'] = ResolversParentTypes['PaymentAccountNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceHasNoPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceHasNoPayment'] = ResolversParentTypes['InvoiceHasNoPayment']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHasNoInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHasNoInvoice'] = ResolversParentTypes['OrderHasNoInvoice']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['InvoiceAttachment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderHasOnlyAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderHasOnlyAttachment'] = ResolversParentTypes['OrderHasOnlyAttachment']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['InvoiceAttachment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoicedProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoicedProduct'] = ResolversParentTypes['InvoicedProduct']> = {
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoicedPrice?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OmnichannelOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OmnichannelOrder'] = ResolversParentTypes['OmnichannelOrder']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OmnichannelOrderStatus'], ParentType, ContextType>;
  supplier?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType>;
  originalOrderMediaLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  parsedOrder?: Resolver<ResolversTypes['ParsedOrder'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>;
  chat?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['OmnichannelOrderAttachment']>>, ParentType, ContextType>;
  orderDeskReviewer?: Resolver<Maybe<ResolversTypes['OrderDeskReviewer']>, ParentType, ContextType>;
  acceptedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParsedOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ParsedOrder'] = ResolversParentTypes['ParsedOrder']> = {
  deliveryDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  orderReviewReason?: Resolver<Array<ResolversTypes['ReviewReason']>, ParentType, ContextType>;
  matchedProducts?: Resolver<Array<ResolversTypes['OmnichannelProduct']>, ParentType, ContextType>;
  unmatchedProducts?: Resolver<Array<ResolversTypes['OmnichannelProduct']>, ParentType, ContextType>;
  products?: Resolver<Array<Maybe<ResolversTypes['OmnichannelOrderProduct']>>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  PONumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restaurantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restaurantAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OmnichannelProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OmnichannelProduct'] = ResolversParentTypes['OmnichannelProduct']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierProductId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  additionalAttributes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parsedProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  catalogProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  chatProduct?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OmnichannelOrderProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OmnichannelOrderProduct'] = ResolversParentTypes['OmnichannelOrderProduct']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['OmnichannelProduct'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OmnichannelOrderAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OmnichannelOrderAttachment'] = ResolversParentTypes['OmnichannelOrderAttachment']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transcript?: Resolver<Maybe<ResolversTypes['AudioTranscript']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AudioTranscriptResolvers<ContextType = any, ParentType extends ResolversParentTypes['AudioTranscript'] = ResolversParentTypes['AudioTranscript']> = {
  transcript?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  words?: Resolver<Array<ResolversTypes['Word']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WordResolvers<ContextType = any, ParentType extends ResolversParentTypes['Word'] = ResolversParentTypes['Word']> = {
  start?: Resolver<ResolversTypes['StartOffSet'], ParentType, ContextType>;
  word?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartOffSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartOffSet'] = ResolversParentTypes['StartOffSet']> = {
  milliseconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeskReviewerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskReviewer'] = ResolversParentTypes['OrderDeskReviewer']> = {
  reviewer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  reviewerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderChangeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderChangeResponse'] = ResolversParentTypes['OrderChangeResponse']> = {
  __resolveType: TypeResolveFn<'OrderChange' | 'NoOrderChange' | 'OrderChangeReverted' | 'OrderChangeError', ParentType, ContextType>;
};

export type OrderChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderChange'] = ResolversParentTypes['OrderChange']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  editVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  changeData?: Resolver<Maybe<ResolversTypes['OrderChangeData']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderChangeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderChangeData'] = ResolversParentTypes['OrderChangeData']> = {
  orderProducts?: Resolver<Maybe<Array<ResolversTypes['OrderProduct']>>, ParentType, ContextType>;
  removedProducts?: Resolver<Maybe<Array<ResolversTypes['OrderProduct']>>, ParentType, ContextType>;
  addedProducts?: Resolver<Maybe<Array<ResolversTypes['OrderProduct']>>, ParentType, ContextType>;
  originalProductCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderProduct'] = ResolversParentTypes['OrderProduct']> = {
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoOrderChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoOrderChange'] = ResolversParentTypes['NoOrderChange']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderChangeRevertedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderChangeReverted'] = ResolversParentTypes['OrderChangeReverted']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderChangeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderChangeError'] = ResolversParentTypes['OrderChangeError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOrderDeliveryCheckResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrderDeliveryCheckResponse'] = ResolversParentTypes['GetOrderDeliveryCheckResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeliveryCheckDetails' | 'InputValidationFailure' | 'CreatedOrCompletedByNotFound' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeliveryCheckDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckDetails'] = ResolversParentTypes['OrderDeliveryCheckDetails']> = {
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OrderDeliveryCheckStatus']>, ParentType, ContextType>;
  orderedProducts?: Resolver<Array<Maybe<ResolversTypes['OrderedProductDeliveryCheck']>>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  deliveryNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  deliveryCheckReconciliationRequest?: Resolver<Maybe<ResolversTypes['DeliveryCheckReconciliationRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderedProductDeliveryCheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderedProductDeliveryCheck'] = ResolversParentTypes['OrderedProductDeliveryCheck']> = {
  orderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderDeliveryCheckImage']>>>, ParentType, ContextType>;
  amountOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountDelivered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  orderedProductMetadata?: Resolver<Maybe<ResolversTypes['OrderedProductMetadata']>, ParentType, ContextType>;
  deliveryCheckProblems?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryCheckProblem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckImage'] = ResolversParentTypes['OrderDeliveryCheckImage']> = {
  imageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUploadStatus?: Resolver<ResolversTypes['OrderDeliveryCheckImageUploadStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderedProductMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderedProductMetadata'] = ResolversParentTypes['OrderedProductMetadata']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryCheckProblemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCheckProblem'] = ResolversParentTypes['DeliveryCheckProblem']> = {
  problemType?: Resolver<Maybe<ResolversTypes['OrderedProductDeliveryCheckProblemType']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountDelivered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryCheckReconciliationRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCheckReconciliationRequest'] = ResolversParentTypes['DeliveryCheckReconciliationRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DeliveryCheckReconciliationRequestType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DeliveryCheckReconciliationRequestStatus'], ParentType, ContextType>;
  statusHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryCheckReconciliationRequestStatusHistory']>>>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalInvoiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfDelivery?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryCheckReconciliationRequestStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCheckReconciliationRequestStatusHistory'] = ResolversParentTypes['DeliveryCheckReconciliationRequestStatusHistory']> = {
  timestamp?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DeliveryCheckReconciliationRequestStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatedOrCompletedByNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatedOrCompletedByNotFound'] = ResolversParentTypes['CreatedOrCompletedByNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderedProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderedProduct'] = ResolversParentTypes['OrderedProduct']> = {
  productId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoiceUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ean?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierPrice?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  buyerPrice?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  displayPrice?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  displayPriceBeforeDiscount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderRestaurantResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRestaurant'] = ResolversParentTypes['OrderRestaurant']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  restaurantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = {
  __resolveType: TypeResolveFn<'Event' | 'Media' | 'BroadcastAttachment', ParentType, ContextType>;
};

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = {
  eventType?: Resolver<Maybe<ResolversTypes['EventType']>, ParentType, ContextType>;
  chatEventType?: Resolver<ResolversTypes['ChatEventTypes'], ParentType, ContextType>;
  target?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTarget']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatEventTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatEventTypes'] = ResolversParentTypes['ChatEventTypes']> = {
  __resolveType: TypeResolveFn<'RequestedChatCreated' | 'RequestedChatActivated' | 'UserAddedToChat' | 'ChatNameUpdated' | 'UserRemovedFromChat' | 'ChatCreated' | 'CartOpened' | 'CartUpdated' | 'CartSubmitted' | 'CartCanceled' | 'OrderEdited' | 'OrderGuideRequested' | 'OrderGuideCreated' | 'ReconciliationRequestConfirmed', ParentType, ContextType>;
};

export type RequestedChatCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestedChatCreated'] = ResolversParentTypes['RequestedChatCreated']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestedChatActivatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestedChatActivated'] = ResolversParentTypes['RequestedChatActivated']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAddedToChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAddedToChat'] = ResolversParentTypes['UserAddedToChat']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatNameUpdatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatNameUpdated'] = ResolversParentTypes['ChatNameUpdated']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRemovedFromChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRemovedFromChat'] = ResolversParentTypes['UserRemovedFromChat']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatCreated'] = ResolversParentTypes['ChatCreated']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartOpenedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartOpened'] = ResolversParentTypes['CartOpened']> = {
  cartId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['EventUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventUser'] = ResolversParentTypes['EventUser']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartUpdatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartUpdated'] = ResolversParentTypes['CartUpdated']> = {
  cartId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['EventUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartSubmittedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSubmitted'] = ResolversParentTypes['CartSubmitted']> = {
  cartId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['EventUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartCanceledResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartCanceled'] = ResolversParentTypes['CartCanceled']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderEditedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderEdited'] = ResolversParentTypes['OrderEdited']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideRequestedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideRequested'] = ResolversParentTypes['OrderGuideRequested']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideCreated'] = ResolversParentTypes['OrderGuideCreated']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReconciliationRequestConfirmedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReconciliationRequestConfirmed'] = ResolversParentTypes['ReconciliationRequestConfirmed']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventTarget'] = ResolversParentTypes['EventTarget']> = {
  __resolveType: TypeResolveFn<'EventUser' | 'EventChat' | 'EventOrder' | 'EventDeliveryCheckReconciliationRequest', ParentType, ContextType>;
};

export type EventChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventChat'] = ResolversParentTypes['EventChat']> = {
  chatId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  restaurantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['EventUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventOrder'] = ResolversParentTypes['EventOrder']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderCreatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventDeliveryCheckReconciliationRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventDeliveryCheckReconciliationRequest'] = ResolversParentTypes['EventDeliveryCheckReconciliationRequest']> = {
  orderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  orderReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reconciliationRequestType?: Resolver<Maybe<ResolversTypes['DeliveryCheckReconciliationRequestType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastAttachment'] = ResolversParentTypes['BroadcastAttachment']> = {
  media?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['BroadcastMediaAttachment']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  broadcastId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2RefResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2Ref'] = ResolversParentTypes['OrderGuideV2Ref']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrderGuideV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefEdge'] = ResolversParentTypes['RefEdge']> = {
  __resolveType: TypeResolveFn<'OrderGuideV2Ref' | 'OrderGuideV2CategoryRef' | 'VendorItemUnitRef' | 'VendorItemRef' | 'VendorItemCategoryRef', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Node']>, ParentType, ContextType>;
};

export type OrderGuideV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2'] = ResolversParentTypes['OrderGuideV2']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubCatalogResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCatalog'] = ResolversParentTypes['SubCatalog']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplierEntityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatUserConnection'] = ResolversParentTypes['ChatUserConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ChatUserEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatUserEdge'] = ResolversParentTypes['ChatUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastCustomerPerformanceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastCustomerPerformanceResult'] = ResolversParentTypes['BroadcastCustomerPerformanceResult']> = {
  data?: Resolver<Array<ResolversTypes['BroadcastCustomerPerformance']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastCustomerPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastCustomerPerformance'] = ResolversParentTypes['BroadcastCustomerPerformance']> = {
  chat?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countOrdersWithProducts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isChatFirstOrder?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isClicked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOpened?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReactivatedChat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  revenueCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sumProductAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadCastEndsAtResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadCastEndsAt'] = ResolversParentTypes['BroadCastEndsAt']> = {
  date?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastProductPerformanceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastProductPerformanceResult'] = ResolversParentTypes['BroadcastProductPerformanceResult']> = {
  data?: Resolver<Array<ResolversTypes['BroadcastProductPerformance']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastProductPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastProductPerformance'] = ResolversParentTypes['BroadcastProductPerformance']> = {
  countOrdersWithProducts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  revenueCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sumProductAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OneTimeBroadcastScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OneTimeBroadcastSchedule'] = ResolversParentTypes['OneTimeBroadcastSchedule']> = {
  nextScheduledTimestamp?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  broadcastScheduleType?: Resolver<ResolversTypes['BroadcastScheduleType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrowseCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrowseCatalogResponse'] = ResolversParentTypes['BrowseCatalogResponse']> = {
  __resolveType: TypeResolveFn<'CatalogProductsConnection' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogProductsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogProductsConnection'] = ResolversParentTypes['CatalogProductsConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['CatalogProductsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogProductsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogProductsEdge'] = ResolversParentTypes['CatalogProductsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endCursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrowseCatalogForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrowseCatalogForChatResponse'] = ResolversParentTypes['BrowseCatalogForChatResponse']> = {
  __resolveType: TypeResolveFn<'CatalogProductsConnection' | 'CatalogNotFound' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogNotFound'] = ResolversParentTypes['CatalogNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerFacetsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerFacetsResponse'] = ResolversParentTypes['BuyerFacetsResponse']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cities?: Resolver<Maybe<Array<ResolversTypes['CityWithOffsets']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CityWithOffsetsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CityWithOffsets'] = ResolversParentTypes['CityWithOffsets']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  utcOffsets?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountResponse'] = ResolversParentTypes['BuyerStockCountResponse']> = {
  __resolveType: TypeResolveFn<'BuyerStockCountSuccess' | 'BuyerStockCountFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BuyerStockCountSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountSuccess'] = ResolversParentTypes['BuyerStockCountSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['BuyerStockCountProduct']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountProduct'] = ResolversParentTypes['BuyerStockCountProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  buyerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  stockQuantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  stockInventoryProductId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BuyerStockCountStatus'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayImage?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  stockCountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  estimatedTotalValue?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountFailure'] = ResolversParentTypes['BuyerStockCountFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountsResponse'] = ResolversParentTypes['BuyerStockCountsResponse']> = {
  __resolveType: TypeResolveFn<'BuyerStockCountsSuccess' | 'BuyerStockCountsFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BuyerStockCountsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountsSuccess'] = ResolversParentTypes['BuyerStockCountsSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  stockCounts?: Resolver<ResolversTypes['BuyerStockCountConnection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountConnection'] = ResolversParentTypes['BuyerStockCountConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BuyerStockCountEdge']>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountEdge'] = ResolversParentTypes['BuyerStockCountEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BuyerStockCount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCount'] = ResolversParentTypes['BuyerStockCount']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdById?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  countedProducts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalProducts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BuyerStockCountStatus']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockCountsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockCountsFailure'] = ResolversParentTypes['BuyerStockCountsFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryResponse'] = ResolversParentTypes['BuyerStockInventoryResponse']> = {
  __resolveType: TypeResolveFn<'BuyerStockInventory' | 'InputValidationFailure' | 'AuthorizationFailure' | 'BuyerStockInventoryNotFound' | 'BuyerStockInventoryFailure', ParentType, ContextType>;
};

export type BuyerStockInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventory'] = ResolversParentTypes['BuyerStockInventory']> = {
  buyerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalProducts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastCountedById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastCountedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lastCountDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BuyerStockInventoryGenerationStatus']>, ParentType, ContextType>;
  products?: Resolver<ResolversTypes['BuyerStockInventoryProductConnection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryProductConnection'] = ResolversParentTypes['BuyerStockInventoryProductConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BuyerStockInventoryProductEdge']>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryProductEdge'] = ResolversParentTypes['BuyerStockInventoryProductEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BuyerStockInventoryProduct'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryProduct'] = ResolversParentTypes['BuyerStockInventoryProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  stockQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCountDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  displayImage?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  estimatedTotalValue?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  orderGuideCategories?: Resolver<Array<ResolversTypes['ProductCategory']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BuyerStockInventoryProductType'], ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryNotFound'] = ResolversParentTypes['BuyerStockInventoryNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryFailure'] = ResolversParentTypes['BuyerStockInventoryFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryExportUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryExportUrlResponse'] = ResolversParentTypes['BuyerStockInventoryExportUrlResponse']> = {
  __resolveType: TypeResolveFn<'BuyerStockInventoryExportUrlSuccess' | 'InputValidationFailure' | 'AuthorizationFailure' | 'BuyerStockInventoryNotFound' | 'BuyerStockInventoryExportUrlFailure', ParentType, ContextType>;
};

export type BuyerStockInventoryExportUrlSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryExportUrlSuccess'] = ResolversParentTypes['BuyerStockInventoryExportUrlSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerStockInventoryExportUrlFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerStockInventoryExportUrlFailure'] = ResolversParentTypes['BuyerStockInventoryExportUrlFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerUser'] = ResolversParentTypes['BuyerUser']> = {
  buyerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['Buyer']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartResponse'] = ResolversParentTypes['CartResponse']> = {
  __resolveType: TypeResolveFn<'Cart' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogImportStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportStatusResponse'] = ResolversParentTypes['CatalogImportStatusResponse']> = {
  __resolveType: TypeResolveFn<'CatalogImportStatusResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogImportStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportStatusResult'] = ResolversParentTypes['CatalogImportStatusResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  job?: Resolver<ResolversTypes['CatalogImportJob'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportJobResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportJob'] = ResolversParentTypes['CatalogImportJob']> = {
  __resolveType: TypeResolveFn<'JobWaitingForInput' | 'JobInProgress' | 'JobFailed' | 'CatalogImportJobSucceeded', ParentType, ContextType>;
};

export type JobWaitingForInputResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobWaitingForInput'] = ResolversParentTypes['JobWaitingForInput']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputUploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobInProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobInProgress'] = ResolversParentTypes['JobInProgress']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobFailedResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobFailed'] = ResolversParentTypes['JobFailed']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failure?: Resolver<ResolversTypes['JobFailure'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobFailure'] = ResolversParentTypes['JobFailure']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extra?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportJobSucceededResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportJobSucceeded'] = ResolversParentTypes['CatalogImportJobSucceeded']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPartialSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  outputDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  response?: Resolver<ResolversTypes['CatalogImportJobResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportJobResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportJobResponse'] = ResolversParentTypes['CatalogImportJobResponse']> = {
  itemsCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsMarkedOutOfStock?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsUpdated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsWithErrors?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportTemplateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportTemplateResponse'] = ResolversParentTypes['CatalogImportTemplateResponse']> = {
  __resolveType: TypeResolveFn<'CatalogImportTemplateResult' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogImportTemplateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportTemplateResult'] = ResolversParentTypes['CatalogImportTemplateResult']> = {
  url?: Resolver<ResolversTypes['AWSURL'], ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportsResponse'] = ResolversParentTypes['CatalogImportsResponse']> = {
  __resolveType: TypeResolveFn<'CatalogImportsResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogImportsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportsResult'] = ResolversParentTypes['CatalogImportsResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['CatalogImportsResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = {
  __resolveType: TypeResolveFn<'CatalogImportsResult' | 'OrderGuideV2CategoriesResult' | 'OrderGuideV2ItemUnitsResult' | 'VendorItemCategoriesForChatSuccess' | 'VendorItemsForChatSuccess' | 'VendorItemsForVendorResult', ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['Edge']>, ParentType, ContextType>;
};

export type CatalogImportsResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportsResultEdge'] = ResolversParentTypes['CatalogImportsResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CatalogImportNode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportNodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportNode'] = ResolversParentTypes['CatalogImportNode']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  job?: Resolver<ResolversTypes['CatalogImportJob'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategoryProducts'] = ResolversParentTypes['CategoryProducts']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatHasSupplierEmailSupportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHasSupplierEmailSupportResponse'] = ResolversParentTypes['ChatHasSupplierEmailSupportResponse']> = {
  __resolveType: TypeResolveFn<'ChatHasSupplierEmailSupportResult' | 'ChatNotFoundError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ChatHasSupplierEmailSupportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHasSupplierEmailSupportResult'] = ResolversParentTypes['ChatHasSupplierEmailSupportResult']> = {
  hasEmailSupport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatNotFoundError'] = ResolversParentTypes['ChatNotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatNotificationPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatNotificationPreferences'] = ResolversParentTypes['ChatNotificationPreferences']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newOrder?: Resolver<Maybe<ResolversTypes['ChatNotificationUserLists']>, ParentType, ContextType>;
  newMessage?: Resolver<Maybe<ResolversTypes['ChatNotificationUserLists']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatNotificationUserListsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatNotificationUserLists'] = ResolversParentTypes['ChatNotificationUserLists']> = {
  deselectedUsersList?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  deselectedUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  extraUsersList?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  extraUsers?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatSubCatalogProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSubCatalogProductsResponse'] = ResolversParentTypes['ChatSubCatalogProductsResponse']> = {
  __resolveType: TypeResolveFn<'ChatNotFoundError' | 'ValidationError' | 'ChatSubCatalogProductsError' | 'ProductSearchResult', ParentType, ContextType>;
};

export type ValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidationError'] = ResolversParentTypes['ValidationError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invalidFields?: Resolver<Maybe<Array<ResolversTypes['FieldValidationError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatSubCatalogProductsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSubCatalogProductsError'] = ResolversParentTypes['ChatSubCatalogProductsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductSearchResult'] = ResolversParentTypes['ProductSearchResult']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatUser'] = ResolversParentTypes['ChatUser']> = {
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FetchBuyerReportDownloadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FetchBuyerReportDownloadUrlResponse'] = ResolversParentTypes['FetchBuyerReportDownloadUrlResponse']> = {
  __resolveType: TypeResolveFn<'BuyerReport' | 'BuyerReportGenerationError' | 'BuyerReportNotFoundError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BuyerReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReport'] = ResolversParentTypes['BuyerReport']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BuyerReportType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  reportDownloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerReportUploadStatus?: Resolver<ResolversTypes['BuyerReportUploadStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerReportGenerationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReportGenerationError'] = ResolversParentTypes['BuyerReportGenerationError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerReportNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReportNotFoundError'] = ResolversParentTypes['BuyerReportNotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogCategory'] = ResolversParentTypes['CatalogCategory']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientImageKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryCatalogCategories?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FetchCatalogCategoriesForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['FetchCatalogCategoriesForChatResponse'] = ResolversParentTypes['FetchCatalogCategoriesForChatResponse']> = {
  __resolveType: TypeResolveFn<'CatalogCategoriesResponse' | 'CatalogNotFound', ParentType, ContextType>;
};

export type CatalogCategoriesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogCategoriesResponse'] = ResolversParentTypes['CatalogCategoriesResponse']> = {
  catalogCategories?: Resolver<Array<ResolversTypes['CatalogCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideResponse'] = ResolversParentTypes['OrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuide' | 'OrderGuideFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrderGuideResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuide'] = ResolversParentTypes['OrderGuide']> = {
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  hasProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<ResolversTypes['OrderGuideCategory']>>, ParentType, ContextType>;
  products?: Resolver<ResolversTypes['OrderGuideProduct'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideCategory'] = ResolversParentTypes['OrderGuideCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideProduct'] = ResolversParentTypes['OrderGuideProduct']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['OrderGuideProductItem']>>, ParentType, ContextType>;
  nextCursors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideProductItem'] = ResolversParentTypes['OrderGuideProductItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  par?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayImage?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  leadTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cutOffTime?: Resolver<Maybe<ResolversTypes['AWSTime']>, ParentType, ContextType>;
  buyerInventoryProduct?: Resolver<Maybe<ResolversTypes['BuyerInventoryProduct']>, ParentType, ContextType, RequireFields<OrderGuideProductItemBuyerInventoryProductArgs, 'chatId'>>;
  derivedPriceForOrderGuide?: Resolver<Maybe<ResolversTypes['DerivedPriceForOrderGuideResponse']>, ParentType, ContextType, RequireFields<OrderGuideProductItemDerivedPriceForOrderGuideArgs, 'chatId'>>;
  deliveryDateConditions?: Resolver<Maybe<ResolversTypes['ProductDeliveryDateCondition']>, ParentType, ContextType, RequireFields<OrderGuideProductItemDeliveryDateConditionsArgs, 'chatId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideFailure'] = ResolversParentTypes['OrderGuideFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmbedDashboardUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmbedDashboardUrlResponse'] = ResolversParentTypes['EmbedDashboardUrlResponse']> = {
  embedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetAllBuyerReportSchedulesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetAllBuyerReportSchedulesResponse'] = ResolversParentTypes['GetAllBuyerReportSchedulesResponse']> = {
  __resolveType: TypeResolveFn<'BuyerReportSchedules' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BuyerReportSchedulesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReportSchedules'] = ResolversParentTypes['BuyerReportSchedules']> = {
  result?: Resolver<Array<ResolversTypes['BuyerReportSchedule']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerReportScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReportSchedule'] = ResolversParentTypes['BuyerReportSchedule']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplierIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  buyerIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BuyerReportType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  nextExecutionAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['ScheduledBuyerReportFrequency'], ParentType, ContextType>;
  timeframe?: Resolver<ResolversTypes['ScheduledBuyerReportFrequency'], ParentType, ContextType>;
  timeframeType?: Resolver<ResolversTypes['ScheduledBuyerReportTimeframeType'], ParentType, ContextType>;
  emailRecipients?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppliedChatDeliverySettingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedChatDeliverySettingResponse'] = ResolversParentTypes['AppliedChatDeliverySettingResponse']> = {
  __resolveType: TypeResolveFn<'AppliedChatDeliverySetting' | 'NotFoundError', ParentType, ContextType>;
};

export type AppliedChatDeliverySettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppliedChatDeliverySetting'] = ResolversParentTypes['AppliedChatDeliverySetting']> = {
  cutoffTimes?: Resolver<ResolversTypes['WeekdayBasedCutoffSettings'], ParentType, ContextType>;
  timezone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exceptions?: Resolver<Maybe<Array<ResolversTypes['DeliverySettingException']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedProductResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedProductResult'] = ResolversParentTypes['SuggestedProductResult']> = {
  __resolveType: TypeResolveFn<'SuggestedProductSuccessResponse' | 'GetSuggestedProductsErrorResponse' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type SuggestedProductSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedProductSuccessResponse'] = ResolversParentTypes['SuggestedProductSuccessResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  products?: Resolver<ResolversTypes['SuggestedProductConnection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedProductConnection'] = ResolversParentTypes['SuggestedProductConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<ResolversTypes['SuggestedProductEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedProductEdge'] = ResolversParentTypes['SuggestedProductEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SuggestedProduct'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedProduct'] = ResolversParentTypes['SuggestedProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSuggestedProductsErrorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSuggestedProductsErrorResponse'] = ResolversParentTypes['GetSuggestedProductsErrorResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCatalogUploadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCatalogUploadUrlResponse'] = ResolversParentTypes['GetCatalogUploadUrlResponse']> = {
  __resolveType: TypeResolveFn<'SupplierNotFound' | 'GetCatalogUploadUrlResult', ParentType, ContextType>;
};

export type SupplierNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierNotFound'] = ResolversParentTypes['SupplierNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetCatalogUploadUrlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetCatalogUploadUrlResult'] = ResolversParentTypes['GetCatalogUploadUrlResult']> = {
  catalogUploadToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetChatCountByCcEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetChatCountByCCEmailResponse'] = ResolversParentTypes['GetChatCountByCCEmailResponse']> = {
  __resolveType: TypeResolveFn<'GetChatCountByCCEmailReport' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetChatCountByCcEmailReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetChatCountByCCEmailReport'] = ResolversParentTypes['GetChatCountByCCEmailReport']> = {
  numberOfChats?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetChatSuppliersByLocationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetChatSuppliersByLocationsResponse'] = ResolversParentTypes['GetChatSuppliersByLocationsResponse']> = {
  __resolveType: TypeResolveFn<'ChatSuppliersByLocations' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ChatSuppliersByLocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatSuppliersByLocations'] = ResolversParentTypes['ChatSuppliersByLocations']> = {
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supplierIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  result?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupplierDetails']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDetails'] = ResolversParentTypes['SupplierDetails']> = {
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetChatsForSubCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetChatsForSubCatalogResponse'] = ResolversParentTypes['GetChatsForSubCatalogResponse']> = {
  __resolveType: TypeResolveFn<'GetChatsForSubCatalogResult' | 'SubCatalogNotFoundError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetChatsForSubCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetChatsForSubCatalogResult'] = ResolversParentTypes['GetChatsForSubCatalogResult']> = {
  chatIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubCatalogNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCatalogNotFoundError'] = ResolversParentTypes['SubCatalogNotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetConnectedAccountsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetConnectedAccountsResponse'] = ResolversParentTypes['GetConnectedAccountsResponse']> = {
  __resolveType: TypeResolveFn<'ConnectedAccountConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ConnectedAccountConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectedAccountConnection'] = ResolversParentTypes['ConnectedAccountConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ConnectedAccountEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectedAccountEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectedAccountEdge'] = ResolversParentTypes['ConnectedAccountEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ConnectedAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectedAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectedAccount'] = ResolversParentTypes['ConnectedAccount']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  appName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetConnectedIntegrationAdaptersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetConnectedIntegrationAdaptersResponse'] = ResolversParentTypes['GetConnectedIntegrationAdaptersResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionBaseResultConnection' | 'IntegrationAdapterConnectionAdminResultConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterConnectionBaseResultConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionBaseResultConnection'] = ResolversParentTypes['IntegrationAdapterConnectionBaseResultConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrationAdapterConnectionBaseResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionBaseResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionBaseResultEdge'] = ResolversParentTypes['IntegrationAdapterConnectionBaseResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrationAdapterConnectionBaseResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionBaseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionBaseResult'] = ResolversParentTypes['IntegrationAdapterConnectionBaseResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  adapterId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntegrationAdapterConnectionStatus'], ParentType, ContextType>;
  scope?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  authorizationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  actionExportDeadlineMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  actionExportMethod?: Resolver<Maybe<ResolversTypes['ActionExportMethod']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionAdminResultConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionAdminResultConnection'] = ResolversParentTypes['IntegrationAdapterConnectionAdminResultConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrationAdapterConnectionAdminResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionAdminResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionAdminResultEdge'] = ResolversParentTypes['IntegrationAdapterConnectionAdminResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrationAdapterConnectionAdminResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionAdminResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionAdminResult'] = ResolversParentTypes['IntegrationAdapterConnectionAdminResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  adapterId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IntegrationAdapterConnectionStatus'], ParentType, ContextType>;
  scope?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  chocoEntityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  chocoEntityType?: Resolver<ResolversTypes['ChocoEntityType'], ParentType, ContextType>;
  creatorUserId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  webhook?: Resolver<Maybe<ResolversTypes['IntegrationAdapterConnectionWebhook']>, ParentType, ContextType>;
  actionExportDeadlineMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  actionExportMethod?: Resolver<Maybe<ResolversTypes['ActionExportMethod']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionWebhook'] = ResolversParentTypes['IntegrationAdapterConnectionWebhook']> = {
  deliveryUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetEmailListsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetEmailListsResponse'] = ResolversParentTypes['GetEmailListsResponse']> = {
  __resolveType: TypeResolveFn<'EmailLists' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type EmailListsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailLists'] = ResolversParentTypes['EmailLists']> = {
  emailLists?: Resolver<Array<ResolversTypes['EmailList']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailListResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailList'] = ResolversParentTypes['EmailList']> = {
  type?: Resolver<ResolversTypes['OrderDestEmailListType'], ParentType, ContextType>;
  emails?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetFeatureFlagsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetFeatureFlagsResponse'] = ResolversParentTypes['GetFeatureFlagsResponse']> = {
  __resolveType: TypeResolveFn<'FeatureFlags' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type FeatureFlagsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlags'] = ResolversParentTypes['FeatureFlags']> = {
  flags?: Resolver<Array<Maybe<ResolversTypes['FeatureFlag']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureFlag'] = ResolversParentTypes['FeatureFlag']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupResponse'] = ResolversParentTypes['GroupResponse']> = {
  __resolveType: TypeResolveFn<'GroupResponseSuccess' | 'GroupResponseError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GroupResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupResponseSuccess'] = ResolversParentTypes['GroupResponseSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  group?: Resolver<ResolversTypes['Group'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdContext?: Resolver<Maybe<ResolversTypes['GroupCreatedContext']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['GroupCreatedBy']>, ParentType, ContextType>;
  buyers?: Resolver<Maybe<Array<ResolversTypes['Buyer']>>, ParentType, ContextType>;
  suppliers?: Resolver<Maybe<Array<ResolversTypes['Supplier']>>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupCreatedByResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupCreatedBy'] = ResolversParentTypes['GroupCreatedBy']> = {
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupResponseError'] = ResolversParentTypes['GroupResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetGroupEntitiesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupEntitiesResponse'] = ResolversParentTypes['GetGroupEntitiesResponse']> = {
  __resolveType: TypeResolveFn<'GetGroupEntitiesSuccessResponse' | 'GetGroupEntitiesErrorResponse' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetGroupEntitiesSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupEntitiesSuccessResponse'] = ResolversParentTypes['GetGroupEntitiesSuccessResponse']> = {
  entities?: Resolver<ResolversTypes['GroupEntityConnection'], ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEntityConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntityConnection'] = ResolversParentTypes['GroupEntityConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['GroupEntityEdge']>>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEntityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntityEdge'] = ResolversParentTypes['GroupEntityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GroupEntityNode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEntityNodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntityNode'] = ResolversParentTypes['GroupEntityNode']> = {
  __resolveType: TypeResolveFn<'GroupEntityBuyer' | 'GroupEntitySupplier', ParentType, ContextType>;
};

export type GroupEntityBuyerResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntityBuyer'] = ResolversParentTypes['GroupEntityBuyer']> = {
  buyer?: Resolver<Maybe<ResolversTypes['Buyer']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntity'] = ResolversParentTypes['GroupEntity']> = {
  __resolveType: TypeResolveFn<'GroupEntityBuyer' | 'GroupEntitySupplier', ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
};

export type GroupEntitySupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEntitySupplier'] = ResolversParentTypes['GroupEntitySupplier']> = {
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  entityId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  supplier?: Resolver<Maybe<ResolversTypes['Supplier']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetGroupEntitiesErrorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupEntitiesErrorResponse'] = ResolversParentTypes['GetGroupEntitiesErrorResponse']> = {
  errorCode?: Resolver<Maybe<ResolversTypes['GetGroupEntitiesErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetGroupUsersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupUsersResponse'] = ResolversParentTypes['GetGroupUsersResponse']> = {
  __resolveType: TypeResolveFn<'GetGroupUsersSuccessResponse' | 'GetGroupUsersErrorResponse' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetGroupUsersSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupUsersSuccessResponse'] = ResolversParentTypes['GetGroupUsersSuccessResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  users?: Resolver<ResolversTypes['GroupUserConnection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupUserConnection'] = ResolversParentTypes['GroupUserConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<ResolversTypes['GroupUserEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupUserEdge'] = ResolversParentTypes['GroupUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['GroupUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupUser'] = ResolversParentTypes['GroupUser']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['GroupUserRole'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetGroupUsersErrorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetGroupUsersErrorResponse'] = ResolversParentTypes['GetGroupUsersErrorResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetIntegrationAdaptersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetIntegrationAdaptersResponse'] = ResolversParentTypes['GetIntegrationAdaptersResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterBaseResultConnection' | 'IntegrationAdapterAdminResultConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterBaseResultConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterBaseResultConnection'] = ResolversParentTypes['IntegrationAdapterBaseResultConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrationAdapterBaseResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterBaseResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterBaseResultEdge'] = ResolversParentTypes['IntegrationAdapterBaseResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrationAdapterBaseResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterBaseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterBaseResult'] = ResolversParentTypes['IntegrationAdapterBaseResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IntegrationAdapterType'], ParentType, ContextType>;
  scope?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  auth?: Resolver<ResolversTypes['IntegrationAdapterAuthBase'], ParentType, ContextType>;
  actionExportDeadlineMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  actionExportMethod?: Resolver<Maybe<ResolversTypes['ActionExportMethod']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterAuthBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAuthBase'] = ResolversParentTypes['IntegrationAdapterAuthBase']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterAuthorizationCodeAuthBase' | 'IntegrationAdapterClientCredentialsAuthBase' | 'IntegrationAdapterAPIKeyAuthBase', ParentType, ContextType>;
};

export type IntegrationAdapterAuthorizationCodeAuthBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAuthorizationCodeAuthBase'] = ResolversParentTypes['IntegrationAdapterAuthorizationCodeAuthBase']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  connectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redirectUrls?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  signoutUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterClientCredentialsAuthBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterClientCredentialsAuthBase'] = ResolversParentTypes['IntegrationAdapterClientCredentialsAuthBase']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterApiKeyAuthBaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAPIKeyAuthBase'] = ResolversParentTypes['IntegrationAdapterAPIKeyAuthBase']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterAdminResultConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAdminResultConnection'] = ResolversParentTypes['IntegrationAdapterAdminResultConnection']> = {
  edges?: Resolver<Array<ResolversTypes['IntegrationAdapterAdminResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterAdminResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAdminResultEdge'] = ResolversParentTypes['IntegrationAdapterAdminResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['IntegrationAdapterAdminResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterAdminResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAdminResult'] = ResolversParentTypes['IntegrationAdapterAdminResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IntegrationAdapterType'], ParentType, ContextType>;
  scope?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  auth?: Resolver<ResolversTypes['IntegrationAdapterAuth'], ParentType, ContextType>;
  webhook?: Resolver<Maybe<ResolversTypes['IntegrationAdapterWebhook']>, ParentType, ContextType>;
  actionExportDeadlineMinutes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  actionExportMethod?: Resolver<Maybe<ResolversTypes['ActionExportMethod']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAuth'] = ResolversParentTypes['IntegrationAdapterAuth']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterAuthorizationCodeAuth' | 'IntegrationAdapterClientCredentialsAuth' | 'IntegrationAdapterAPIKeyAuth', ParentType, ContextType>;
};

export type IntegrationAdapterAuthorizationCodeAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAuthorizationCodeAuth'] = ResolversParentTypes['IntegrationAdapterAuthorizationCodeAuth']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redirectUrls?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  signoutUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterClientCredentialsAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterClientCredentialsAuth'] = ResolversParentTypes['IntegrationAdapterClientCredentialsAuth']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterApiKeyAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterAPIKeyAuth'] = ResolversParentTypes['IntegrationAdapterAPIKeyAuth']> = {
  type?: Resolver<ResolversTypes['IntegrationAdapterAuthenticationType'], ParentType, ContextType>;
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterWebhookResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterWebhook'] = ResolversParentTypes['IntegrationAdapterWebhook']> = {
  deliveryUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  auth?: Resolver<ResolversTypes['IntegrationAdapterWebhookAuth'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterWebhookAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterWebhookAuth'] = ResolversParentTypes['IntegrationAdapterWebhookAuth']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterWebhookBasicAuth' | 'IntegrationAdapterWebhookSignatureAuth', ParentType, ContextType>;
};

export type IntegrationAdapterWebhookBasicAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterWebhookBasicAuth'] = ResolversParentTypes['IntegrationAdapterWebhookBasicAuth']> = {
  type?: Resolver<ResolversTypes['WebhookAuthenticationType'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterWebhookSignatureAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterWebhookSignatureAuth'] = ResolversParentTypes['IntegrationAdapterWebhookSignatureAuth']> = {
  type?: Resolver<ResolversTypes['WebhookAuthenticationType'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetInviteTransmissionStatusResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetInviteTransmissionStatusResponse'] = ResolversParentTypes['GetInviteTransmissionStatusResponse']> = {
  __resolveType: TypeResolveFn<'InviteTransmissionStatus' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InviteTransmissionStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteTransmissionStatus'] = ResolversParentTypes['InviteTransmissionStatus']> = {
  inviteStatus?: Resolver<Maybe<ResolversTypes['InviteStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetInviteeBuyersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetInviteeBuyersResponse'] = ResolversParentTypes['GetInviteeBuyersResponse']> = {
  __resolveType: TypeResolveFn<'InviteeNotFound' | 'InviteeBuyers', ParentType, ContextType>;
};

export type InviteeNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteeNotFound'] = ResolversParentTypes['InviteeNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteeBuyersResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteeBuyers'] = ResolversParentTypes['InviteeBuyers']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  unconnectedBuyers?: Resolver<ResolversTypes['UserBuyerConnection'], ParentType, ContextType, Partial<InviteeBuyersUnconnectedBuyersArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagesFromChatResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagesFromChatResult'] = ResolversParentTypes['MessagesFromChatResult']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierOptIn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MessageStatus']>, ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recipients?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  mediaContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['MessageType']>, ParentType, ContextType>;
  event?: Resolver<Maybe<ResolversTypes['MessageEvent']>, ParentType, ContextType>;
  broadcastId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEvent'] = ResolversParentTypes['MessageEvent']> = {
  eventType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target?: Resolver<Maybe<Array<Maybe<ResolversTypes['EventTarget']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationsBySupplierResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationsBySupplierResponse'] = ResolversParentTypes['LocationsBySupplierResponse']> = {
  __resolveType: TypeResolveFn<'LocationsBySupplierSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type LocationsBySupplierSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationsBySupplierSuccess'] = ResolversParentTypes['LocationsBySupplierSuccess']> = {
  result?: Resolver<Maybe<Array<Maybe<ResolversTypes['LocationBySupplier']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationBySupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationBySupplier'] = ResolversParentTypes['LocationBySupplier']> = {
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyerEntityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  locationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingMessageSuggestionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageSuggestionsResult'] = ResolversParentTypes['MarketingMessageSuggestionsResult']> = {
  __resolveType: TypeResolveFn<'MarketingMessageSuggestionsSuccess' | 'MarketingMessageSuggestionsError' | 'MarketingMessageSuggestionsErrorNoSuggestions' | 'MarketingMessageSuggestionsErrorThrottling' | 'InputValidationFailure', ParentType, ContextType>;
};

export type MarketingMessageSuggestionsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageSuggestionsSuccess'] = ResolversParentTypes['MarketingMessageSuggestionsSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  tips?: Resolver<Array<ResolversTypes['MarketingMessageRefinementTip']>, ParentType, ContextType>;
  improvedText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingMessageRefinementTipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageRefinementTip'] = ResolversParentTypes['MarketingMessageRefinementTip']> = {
  tip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingMessageSuggestionsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageSuggestionsError'] = ResolversParentTypes['MarketingMessageSuggestionsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingMessageSuggestionsErrorNoSuggestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageSuggestionsErrorNoSuggestions'] = ResolversParentTypes['MarketingMessageSuggestionsErrorNoSuggestions']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarketingMessageSuggestionsErrorThrottlingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarketingMessageSuggestionsErrorThrottling'] = ResolversParentTypes['MarketingMessageSuggestionsErrorThrottling']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOmniChannelOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOmniChannelOrderResponse'] = ResolversParentTypes['GetOmniChannelOrderResponse']> = {
  __resolveType: TypeResolveFn<'OmnichannelOrder' | 'NotFoundError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetOnboardingChecklistResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOnboardingChecklistResponse'] = ResolversParentTypes['GetOnboardingChecklistResponse']> = {
  __resolveType: TypeResolveFn<'OnboardingChecklist' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OnboardingChecklistResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingChecklist'] = ResolversParentTypes['OnboardingChecklist']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardClaimedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OnboardingChecklistItem']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingChecklistItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingChecklistItem'] = ResolversParentTypes['OnboardingChecklistItem']> = {
  fallbackTranslation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  articleId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['OnboardingChecklistItemValue'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingChecklistItemValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingChecklistItemValue'] = ResolversParentTypes['OnboardingChecklistItemValue']> = {
  __resolveType: TypeResolveFn<'OnboardingChecklistBooleanValue' | 'OnboardingChecklistNumericValue', ParentType, ContextType>;
};

export type OnboardingChecklistBooleanValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingChecklistBooleanValue'] = ResolversParentTypes['OnboardingChecklistBooleanValue']> = {
  booleanCurrent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingChecklistNumericValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingChecklistNumericValue'] = ResolversParentTypes['OnboardingChecklistNumericValue']> = {
  numericCurrent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetProductsForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetProductsForChatResponse'] = ResolversParentTypes['GetProductsForChatResponse']> = {
  __resolveType: TypeResolveFn<'GetProductsForChatResult' | 'ChatNotFoundError' | 'AuthorizationFailure' | 'SupplierNotFound', ParentType, ContextType>;
};

export type GetProductsForChatResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetProductsForChatResult'] = ResolversParentTypes['GetProductsForChatResult']> = {
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  productsNotFound?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  invalidProducts?: Resolver<Maybe<Array<ResolversTypes['InvalidProduct']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidProduct'] = ResolversParentTypes['InvalidProduct']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetQboCustomersAndOrderGuidesToImportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetQboCustomersAndOrderGuidesToImportResponse'] = ResolversParentTypes['GetQboCustomersAndOrderGuidesToImportResponse']> = {
  __resolveType: TypeResolveFn<'QboCustomersAndOrderGuidesToImport' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type QboCustomersAndOrderGuidesToImportResolvers<ContextType = any, ParentType extends ResolversParentTypes['QboCustomersAndOrderGuidesToImport'] = ResolversParentTypes['QboCustomersAndOrderGuidesToImport']> = {
  fileUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetReconciliationRequestPlanBySupplierIdResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetReconciliationRequestPlanBySupplierIdResponse'] = ResolversParentTypes['GetReconciliationRequestPlanBySupplierIdResponse']> = {
  __resolveType: TypeResolveFn<'ReconciliationRequestPlan' | 'InputValidationFailure' | 'ReconciliationRequestPlanBySupplierIdNotFound', ParentType, ContextType>;
};

export type ReconciliationRequestPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReconciliationRequestPlan'] = ResolversParentTypes['ReconciliationRequestPlan']> = {
  supplierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['ReconciliationRequestPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReconciliationRequestPlanBySupplierIdNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReconciliationRequestPlanBySupplierIdNotFound'] = ResolversParentTypes['ReconciliationRequestPlanBySupplierIdNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetRequestsToJoinResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetRequestsToJoinResponse'] = ResolversParentTypes['GetRequestsToJoinResponse']> = {
  __resolveType: TypeResolveFn<'RequestsToJoinConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type RequestsToJoinConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestsToJoinConnection'] = ResolversParentTypes['RequestsToJoinConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['UserRequestToJoinEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRequestToJoinEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRequestToJoinEdge'] = ResolversParentTypes['UserRequestToJoinEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserRequestToJoin'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRequestToJoinResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRequestToJoin'] = ResolversParentTypes['UserRequestToJoin']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  requestType?: Resolver<Maybe<ResolversTypes['UserRequestToJoinType']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierEntityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JoinRequestStatus'], ParentType, ContextType>;
  salesRepInput?: Resolver<Maybe<ResolversTypes['SalesRepDetails']>, ParentType, ContextType>;
  reviewerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isReviewerAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  requestedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesRepDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesRepDetails'] = ResolversParentTypes['SalesRepDetails']> = {
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderPreference?: Resolver<Array<ResolversTypes['AddSalesRepOrderPref']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSmsMessageByMessageSidResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSmsMessageByMessageSidResponse'] = ResolversParentTypes['GetSmsMessageByMessageSidResponse']> = {
  __resolveType: TypeResolveFn<'GetSmsMessageByMessageSidSuccess' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetSmsMessageByMessageSidSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSmsMessageByMessageSidSuccess'] = ResolversParentTypes['GetSmsMessageByMessageSidSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  smsMessage?: Resolver<Maybe<ResolversTypes['SmsMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SmsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SmsMessage'] = ResolversParentTypes['SmsMessage']> = {
  smsMessageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messagingServiceSid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numMedia?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numSegments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceApiVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mediaElements?: Resolver<Maybe<Array<ResolversTypes['SmsMessageMedia']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  fromCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SmsMessageMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['SmsMessageMedia'] = ResolversParentTypes['SmsMessageMedia']> = {
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSmsMessagesFromPhoneNumberResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSmsMessagesFromPhoneNumberResponse'] = ResolversParentTypes['GetSmsMessagesFromPhoneNumberResponse']> = {
  __resolveType: TypeResolveFn<'GetSmsMessagesFromPhoneNumberSuccess' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetSmsMessagesFromPhoneNumberSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSmsMessagesFromPhoneNumberSuccess'] = ResolversParentTypes['GetSmsMessagesFromPhoneNumberSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<ResolversTypes['SmsMessage']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSubCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSubCatalogResponse'] = ResolversParentTypes['GetSubCatalogResponse']> = {
  __resolveType: TypeResolveFn<'SubCatalog' | 'NotFoundError', ParentType, ContextType>;
};

export type GetSubCatalogsForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSubCatalogsForChatResponse'] = ResolversParentTypes['GetSubCatalogsForChatResponse']> = {
  __resolveType: TypeResolveFn<'GetSubCatalogsForChatResult' | 'ChatNotFoundError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetSubCatalogsForChatResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSubCatalogsForChatResult'] = ResolversParentTypes['GetSubCatalogsForChatResult']> = {
  subCatalogs?: Resolver<Array<ResolversTypes['SubCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSupplierApplicationsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSupplierApplicationsResponse'] = ResolversParentTypes['GetSupplierApplicationsResponse']> = {
  __resolveType: TypeResolveFn<'SupplierApplications' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SupplierApplicationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierApplications'] = ResolversParentTypes['SupplierApplications']> = {
  apps?: Resolver<Array<ResolversTypes['ApplicationData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationData'] = ResolversParentTypes['ApplicationData']> = {
  appName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['CredentialsData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CredentialsDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CredentialsData'] = ResolversParentTypes['CredentialsData']> = {
  __resolveType: TypeResolveFn<'QbdCredentials', ParentType, ContextType>;
};

export type QbdCredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QbdCredentials'] = ResolversParentTypes['QbdCredentials']> = {
  fileUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetSupplierProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSupplierProductsResponse'] = ResolversParentTypes['GetSupplierProductsResponse']> = {
  __resolveType: TypeResolveFn<'GetSupplierProductsResult' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetSupplierProductsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetSupplierProductsResult'] = ResolversParentTypes['GetSupplierProductsResult']> = {
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  productsNotFound?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  invalidProducts?: Resolver<Maybe<Array<ResolversTypes['InvalidProduct']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetUnconnectedBuyerIdsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetUnconnectedBuyerIdsResult'] = ResolversParentTypes['GetUnconnectedBuyerIdsResult']> = {
  __resolveType: TypeResolveFn<'UnconnectedBuyers' | 'NoUnconnectedBuyers', ParentType, ContextType>;
};

export type UnconnectedBuyersResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnconnectedBuyers'] = ResolversParentTypes['UnconnectedBuyers']> = {
  buyerIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoUnconnectedBuyersResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoUnconnectedBuyers'] = ResolversParentTypes['NoUnconnectedBuyers']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserIntercomCredentialsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIntercomCredentialsResponse'] = ResolversParentTypes['UserIntercomCredentialsResponse']> = {
  __resolveType: TypeResolveFn<'UserIntercomCredentialsSuccess' | 'UserIntercomCredentialsFailure', ParentType, ContextType>;
};

export type UserIntercomCredentialsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIntercomCredentialsSuccess'] = ResolversParentTypes['UserIntercomCredentialsSuccess']> = {
  webHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iosHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  androidHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserIntercomCredentialsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIntercomCredentialsFailure'] = ResolversParentTypes['UserIntercomCredentialsFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetWhatsAppMessageByMessageSidResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetWhatsAppMessageByMessageSidResponse'] = ResolversParentTypes['GetWhatsAppMessageByMessageSidResponse']> = {
  __resolveType: TypeResolveFn<'GetWhatsAppMessageByMessageSidSuccess' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetWhatsAppMessageByMessageSidSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetWhatsAppMessageByMessageSidSuccess'] = ResolversParentTypes['GetWhatsAppMessageByMessageSidSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  whatsAppMessage?: Resolver<Maybe<ResolversTypes['WhatsAppMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WhatsAppMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['WhatsAppMessage'] = ResolversParentTypes['WhatsAppMessage']> = {
  whatsAppMessageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messagingServiceSid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numMedia?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numSegments?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceApiVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mediaElements?: Resolver<Maybe<Array<ResolversTypes['WhatsAppMessageMedia']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  fromCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toZip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whatsappId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  forwarded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  frequentlyForwarded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  buttonText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalRepliedMessageSender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalRepliedMessageSid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  whatsAppStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WhatsAppMessageMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['WhatsAppMessageMedia'] = ResolversParentTypes['WhatsAppMessageMedia']> = {
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HasUserCompletedDeliveryCheckResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['HasUserCompletedDeliveryCheckResponse'] = ResolversParentTypes['HasUserCompletedDeliveryCheckResponse']> = {
  __resolveType: TypeResolveFn<'HasCompletedDeliveryCheckResult' | 'OrderNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type HasCompletedDeliveryCheckResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['HasCompletedDeliveryCheckResult'] = ResolversParentTypes['HasCompletedDeliveryCheckResult']> = {
  hasCompletedDeliveryCheck?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latestOrderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  earliestOrderId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderNotFound'] = ResolversParentTypes['OrderNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryDownloadJobsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobsResponse'] = ResolversParentTypes['InventoryDownloadJobsResponse']> = {
  __resolveType: TypeResolveFn<'InventoryDownloadJobsSuccess' | 'InventoryDownloadJobsFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InventoryDownloadJobsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobsSuccess'] = ResolversParentTypes['InventoryDownloadJobsSuccess']> = {
  jobs?: Resolver<Array<ResolversTypes['InventoryDownloadJob']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryDownloadJobResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJob'] = ResolversParentTypes['InventoryDownloadJob']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InventoryDownloadJobStatus'], ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['InventoryDownloadJobReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryDownloadJobReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobReport'] = ResolversParentTypes['InventoryDownloadJobReport']> = {
  __resolveType: TypeResolveFn<'InventoryDownloadJobCompleted' | 'InventoryDownloadJobFailed', ParentType, ContextType>;
};

export type InventoryDownloadJobCompletedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobCompleted'] = ResolversParentTypes['InventoryDownloadJobCompleted']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryDownloadJobFailedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobFailed'] = ResolversParentTypes['InventoryDownloadJobFailed']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryDownloadJobsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryDownloadJobsFailure'] = ResolversParentTypes['InventoryDownloadJobsFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventorySuppliersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventorySuppliersResponse'] = ResolversParentTypes['InventorySuppliersResponse']> = {
  __resolveType: TypeResolveFn<'InventorySuppliersSuccess' | 'InputValidationFailure' | 'AuthorizationFailure' | 'InventorySuppliersFailure', ParentType, ContextType>;
};

export type InventorySuppliersSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventorySuppliersSuccess'] = ResolversParentTypes['InventorySuppliersSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  suppliers?: Resolver<Array<ResolversTypes['InventorySupplier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventorySupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventorySupplier'] = ResolversParentTypes['InventorySupplier']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventorySuppliersFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventorySuppliersFailure'] = ResolversParentTypes['InventorySuppliersFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryUploadJobResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadJobResponse'] = ResolversParentTypes['InventoryUploadJobResponse']> = {
  __resolveType: TypeResolveFn<'InventoryUploadJobSuccess' | 'InventoryUploadJobFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InventoryUploadJobSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadJobSuccess'] = ResolversParentTypes['InventoryUploadJobSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InventoryUploadJobStatus'], ParentType, ContextType>;
  rawReport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryUploadJobFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadJobFailure'] = ResolversParentTypes['InventoryUploadJobFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryUploadTemplateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadTemplateResponse'] = ResolversParentTypes['InventoryUploadTemplateResponse']> = {
  __resolveType: TypeResolveFn<'InventoryUploadTemplateResponseSuccess' | 'InventoryUploadTemplateResponseFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InventoryUploadTemplateResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadTemplateResponseSuccess'] = ResolversParentTypes['InventoryUploadTemplateResponseSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryUploadTemplateResponseFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryUploadTemplateResponseFailure'] = ResolversParentTypes['InventoryUploadTemplateResponseFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListSubCatalogProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListSubCatalogProductsResponse'] = ResolversParentTypes['ListSubCatalogProductsResponse']> = {
  __resolveType: TypeResolveFn<'ProductSearchResult' | 'ListSubCatalogProductsError', ParentType, ContextType>;
};

export type ListSubCatalogProductsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListSubCatalogProductsError'] = ResolversParentTypes['ListSubCatalogProductsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListSubCatalogsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListSubCatalogsResponse'] = ResolversParentTypes['ListSubCatalogsResponse']> = {
  __resolveType: TypeResolveFn<'SubCatalogConnection' | 'ValidationError', ParentType, ContextType>;
};

export type SubCatalogConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCatalogConnection'] = ResolversParentTypes['SubCatalogConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SubCatalogEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubCatalogEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCatalogEdge'] = ResolversParentTypes['SubCatalogEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SubCatalog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupPhoneNumbersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupPhoneNumbersResponse'] = ResolversParentTypes['LookupPhoneNumbersResponse']> = {
  __resolveType: TypeResolveFn<'LookupPhoneNumbersSuccess' | 'LookupPhoneNumbersError', ParentType, ContextType>;
};

export type LookupPhoneNumbersSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupPhoneNumbersSuccess'] = ResolversParentTypes['LookupPhoneNumbersSuccess']> = {
  lookups?: Resolver<Array<ResolversTypes['PhoneNumberLookup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneNumberLookupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberLookup'] = ResolversParentTypes['PhoneNumberLookup']> = {
  __resolveType: TypeResolveFn<'PhoneNumberLookupSuccess' | 'PhoneNumberLookupError', ParentType, ContextType>;
};

export type PhoneNumberLookupSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberLookupSuccess'] = ResolversParentTypes['PhoneNumberLookupSuccess']> = {
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lineType?: Resolver<ResolversTypes['PhoneNumberLineType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneNumberLookupErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumberLookupError'] = ResolversParentTypes['PhoneNumberLookupError']> = {
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorCode?: Resolver<ResolversTypes['PhoneNumberLookupErrorCode'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupPhoneNumbersErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupPhoneNumbersError'] = ResolversParentTypes['LookupPhoneNumbersError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['LookupPhoneNumbersErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetaLobbyResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetaLobbyResponse'] = ResolversParentTypes['MetaLobbyResponse']> = {
  __resolveType: TypeResolveFn<'MetaLobbyResult' | 'InvalidCursor', ParentType, ContextType>;
};

export type MetaLobbyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetaLobbyResult'] = ResolversParentTypes['MetaLobbyResult']> = {
  buyers?: Resolver<ResolversTypes['UserLobbyBuyerConnection'], ParentType, ContextType>;
  others?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLobbyBuyerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLobbyBuyerConnection'] = ResolversParentTypes['UserLobbyBuyerConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['UserLobbyBuyerEdge']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLobbyBuyerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLobbyBuyerEdge'] = ResolversParentTypes['UserLobbyBuyerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['LobbyBuyer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LobbyBuyerResolvers<ContextType = any, ParentType extends ResolversParentTypes['LobbyBuyer'] = ResolversParentTypes['LobbyBuyer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyer?: Resolver<ResolversTypes['Buyer'], ParentType, ContextType>;
  chatIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidCursor'] = ResolversParentTypes['InvalidCursor']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2CategoriesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2CategoriesResponse'] = ResolversParentTypes['OrderGuideV2CategoriesResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideV2CategoriesResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderGuideV2CategoriesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2CategoriesResult'] = ResolversParentTypes['OrderGuideV2CategoriesResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['OrderGuideV2CategoriesResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2CategoriesResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2CategoriesResultEdge'] = ResolversParentTypes['OrderGuideV2CategoriesResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OrderGuideV2Category'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2CategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2Category'] = ResolversParentTypes['OrderGuideV2Category']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsResponse'] = ResolversParentTypes['OrderGuideV2ItemUnitsResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideV2ItemUnitsResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsResult'] = ResolversParentTypes['OrderGuideV2ItemUnitsResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['OrderGuideV2ItemUnitsResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsResultEdge'] = ResolversParentTypes['OrderGuideV2ItemUnitsResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OrderGuideV2ItemUnit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnit'] = ResolversParentTypes['OrderGuideV2ItemUnit']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  orderGuideCategory?: Resolver<Maybe<ResolversTypes['OrderGuideV2CategoryRef']>, ParentType, ContextType>;
  vendorItemUnit?: Resolver<ResolversTypes['VendorItemUnitRef'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2CategoryRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2CategoryRef'] = ResolversParentTypes['OrderGuideV2CategoryRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrderGuideV2Category']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemUnitRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnitRef'] = ResolversParentTypes['VendorItemUnitRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['VendorItemUnit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnit'] = ResolversParentTypes['VendorItemUnit']> = {
  availabilityStatus?: Resolver<ResolversTypes['VendorItemUnitAvailabilityStatus'], ParentType, ContextType>;
  baseUnit?: Resolver<Maybe<ResolversTypes['VendorItemUnit']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  factor?: Resolver<ResolversTypes['Rational'], ParentType, ContextType>;
  factorDeviation?: Resolver<ResolversTypes['Rational'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  images?: Resolver<Array<ResolversTypes['VendorItemUnitImage']>, ParentType, ContextType>;
  isBase?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isInOrderGuide?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<VendorItemUnitIsInOrderGuideArgs, 'orderGuideId'>>;
  isOrdering?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderGuideItemUnit?: Resolver<Maybe<ResolversTypes['OrderGuideV2ItemUnit']>, ParentType, ContextType, RequireFields<VendorItemUnitOrderGuideItemUnitArgs, 'orderGuideId'>>;
  packagingDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['VendorItemUnitPriceSet']>, ParentType, ContextType, Partial<VendorItemUnitPriceArgs>>;
  stockStatus?: Resolver<ResolversTypes['VendorItemUnitStockStatus'], ParentType, ContextType>;
  vendorItem?: Resolver<ResolversTypes['VendorItemRef'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RationalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rational'] = ResolversParentTypes['Rational']> = {
  numerator?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  denominator?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemUnitImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnitImage'] = ResolversParentTypes['VendorItemUnitImage']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['ImageAsset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageAsset'] = ResolversParentTypes['ImageAsset']> = {
  url?: Resolver<Maybe<ResolversTypes['ImageAssetUrl']>, ParentType, ContextType, Partial<ImageAssetUrlArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageAssetUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageAssetUrl'] = ResolversParentTypes['ImageAssetUrl']> = {
  url?: Resolver<ResolversTypes['AWSURL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemUnitPriceSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnitPriceSet'] = ResolversParentTypes['VendorItemUnitPriceSet']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  displayPrice?: Resolver<ResolversTypes['MoneyV2'], ParentType, ContextType>;
  displayPriceBeforeDiscount?: Resolver<Maybe<ResolversTypes['MoneyV2']>, ParentType, ContextType>;
  displayCatalogPrice?: Resolver<Maybe<ResolversTypes['MoneyV2']>, ParentType, ContextType>;
  displayCatalogPriceBeforeDiscount?: Resolver<Maybe<ResolversTypes['MoneyV2']>, ParentType, ContextType>;
  buyerPrice?: Resolver<Maybe<ResolversTypes['MoneyV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MoneyV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['MoneyV2'] = ResolversParentTypes['MoneyV2']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimalPlaces?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemRef'] = ResolversParentTypes['VendorItemRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['VendorItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItem'] = ResolversParentTypes['VendorItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustomVendorItem?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  variantGroup?: Resolver<Maybe<ResolversTypes['VendorItemVariantGroup']>, ParentType, ContextType>;
  hasVariants?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unitsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  units?: Resolver<Array<ResolversTypes['VendorItemUnit']>, ParentType, ContextType, Partial<VendorItemUnitsArgs>>;
  categories?: Resolver<Array<ResolversTypes['VendorItemCategory']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['VendorItemCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemVariantGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemVariantGroup'] = ResolversParentTypes['VendorItemVariantGroup']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategory'] = ResolversParentTypes['VendorItemCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentCategory?: Resolver<Maybe<ResolversTypes['VendorItemCategoryRef']>, ParentType, ContextType>;
  parentCategoryChain?: Resolver<Array<ResolversTypes['VendorItemCategory']>, ParentType, ContextType>;
  itemsCountForChat?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<VendorItemCategoryItemsCountForChatArgs, 'chatId'>>;
  image?: Resolver<Maybe<ResolversTypes['VendorItemCategoryImage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemCategoryRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategoryRef'] = ResolversParentTypes['VendorItemCategoryRef']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['VendorItemCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemCategoryImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategoryImage'] = ResolversParentTypes['VendorItemCategoryImage']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['ImageAsset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersToReviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersToReviewResponse'] = ResolversParentTypes['OrdersToReviewResponse']> = {
  __resolveType: TypeResolveFn<'OrdersToReviewConnection' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrdersToReviewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersToReviewConnection'] = ResolversParentTypes['OrdersToReviewConnection']> = {
  edges?: Resolver<Array<ResolversTypes['OrdersToReviewEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersToReviewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersToReviewEdge'] = ResolversParentTypes['OrdersToReviewEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['OmnichannelOrder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentOptionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentOptionsResponse'] = ResolversParentTypes['PaymentOptionsResponse']> = {
  __resolveType: TypeResolveFn<'PublicToken' | 'Redirect' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type PublicTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicToken'] = ResolversParentTypes['PublicToken']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  paymentToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Redirect'] = ResolversParentTypes['Redirect']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  redirectURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResult'] = ResolversParentTypes['SearchResult']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['SearchItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchItem'] = ResolversParentTypes['SearchItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SearchEntityType'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity?: Resolver<Maybe<ResolversTypes['SearchEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchEntity'] = ResolversParentTypes['SearchEntity']> = {
  __resolveType: TypeResolveFn<'User' | 'Chat' | 'Message' | 'Order' | 'Supplier' | 'Product' | 'Broadcast' | 'Buyer', ParentType, ContextType>;
};

export type SearchBuyerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchBuyerResponse'] = ResolversParentTypes['SearchBuyerResponse']> = {
  __resolveType: TypeResolveFn<'SearchBuyerConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SearchBuyerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchBuyerConnection'] = ResolversParentTypes['SearchBuyerConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['BuyerEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerEdge'] = ResolversParentTypes['BuyerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Buyer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchGroupsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchGroupsResponse'] = ResolversParentTypes['SearchGroupsResponse']> = {
  __resolveType: TypeResolveFn<'SearchGroupsSuccessResponse' | 'SearchGroupsErrorResponse' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SearchGroupsSuccessResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchGroupsSuccessResponse'] = ResolversParentTypes['SearchGroupsSuccessResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  groups?: Resolver<ResolversTypes['GroupConnection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupConnection'] = ResolversParentTypes['GroupConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['GroupEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupEdge'] = ResolversParentTypes['GroupEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Group'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchGroupsErrorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchGroupsErrorResponse'] = ResolversParentTypes['SearchGroupsErrorResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['SearchGroupsErrorCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOrderResponse'] = ResolversParentTypes['SearchOrderResponse']> = {
  __resolveType: TypeResolveFn<'SearchOrderConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SearchOrderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOrderConnection'] = ResolversParentTypes['SearchOrderConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['SearchOrderEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchOrderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOrderEdge'] = ResolversParentTypes['SearchOrderEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchOrderDeskCustomerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOrderDeskCustomerResponse'] = ResolversParentTypes['SearchOrderDeskCustomerResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeskChatsConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeskChatsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskChatsConnection'] = ResolversParentTypes['OrderDeskChatsConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['OrderDeskChatsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeskChatsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskChatsEdge'] = ResolversParentTypes['OrderDeskChatsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProductsResponse'] = ResolversParentTypes['SearchProductsResponse']> = {
  __resolveType: TypeResolveFn<'SearchProductsConnection' | 'SearchProductsError', ParentType, ContextType>;
};

export type SearchProductsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProductsConnection'] = ResolversParentTypes['SearchProductsConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['SearchProductsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProductsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProductsEdge'] = ResolversParentTypes['SearchProductsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProductsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProductsError'] = ResolversParentTypes['SearchProductsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTaxonomyLabelsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTaxonomyLabelsResponse'] = ResolversParentTypes['SearchTaxonomyLabelsResponse']> = {
  __resolveType: TypeResolveFn<'SearchTaxonomyLabelsConnection' | 'SearchTaxonomyLabelsError', ParentType, ContextType>;
};

export type SearchTaxonomyLabelsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTaxonomyLabelsConnection'] = ResolversParentTypes['SearchTaxonomyLabelsConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['SearchTaxonomyLabelsEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTaxonomyLabelsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTaxonomyLabelsEdge'] = ResolversParentTypes['SearchTaxonomyLabelsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TaxonomyLabel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxonomyLabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxonomyLabel'] = ResolversParentTypes['TaxonomyLabel']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchTaxonomyLabelsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchTaxonomyLabelsError'] = ResolversParentTypes['SearchTaxonomyLabelsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendSampleSmsMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSampleSmsMessageResponse'] = ResolversParentTypes['SendSampleSmsMessageResponse']> = {
  __resolveType: TypeResolveFn<'SendSampleSmsMessageSuccess' | 'SendSampleSmsMessageFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SendSampleSmsMessageSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSampleSmsMessageSuccess'] = ResolversParentTypes['SendSampleSmsMessageSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  messageSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendSampleSmsMessageFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSampleSmsMessageFailure'] = ResolversParentTypes['SendSampleSmsMessageFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedBroadcastProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedBroadcastProducts'] = ResolversParentTypes['SharedBroadcastProducts']> = {
  categories?: Resolver<Maybe<Array<ResolversTypes['ProductCategory']>>, ParentType, ContextType>;
  productCountInProductList?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['Product']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockCountSessionsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountSessionsResponse'] = ResolversParentTypes['StockCountSessionsResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'InputValidationFailure' | 'StockCountSessionsSuccess', ParentType, ContextType>;
};

export type StockCountSessionsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountSessionsSuccess'] = ResolversParentTypes['StockCountSessionsSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  stockCountSessions?: Resolver<Array<ResolversTypes['StockCountSession']>, ParentType, ContextType>;
  paginationInfo?: Resolver<ResolversTypes['StockCountSessionsPaginationInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockCountSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountSession'] = ResolversParentTypes['StockCountSession']> = {
  countDetails?: Resolver<Maybe<ResolversTypes['CountDetails']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemsCounted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StockCountSessionEnum'], ParentType, ContextType>;
  submittedById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  submittedDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountDetails'] = ResolversParentTypes['CountDetails']> = {
  estimatedValues?: Resolver<Array<ResolversTypes['StockItemPrice']>, ParentType, ContextType>;
  stockCountItems?: Resolver<Array<ResolversTypes['StockItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockItemPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockItemPrice'] = ResolversParentTypes['StockItemPrice']> = {
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockItem'] = ResolversParentTypes['StockItem']> = {
  estimatedValueInCents?: Resolver<Maybe<ResolversTypes['StockItemPrice']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['StockItemPrice']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  storageItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockCountSessionsPaginationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountSessionsPaginationInfo'] = ResolversParentTypes['StockCountSessionsPaginationInfo']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lastPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockCountUsersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountUsersResponse'] = ResolversParentTypes['StockCountUsersResponse']> = {
  __resolveType: TypeResolveFn<'StockCountUsersSuccess' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type StockCountUsersSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountUsersSuccess'] = ResolversParentTypes['StockCountUsersSuccess']> = {
  users?: Resolver<Array<ResolversTypes['StockCountUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockCountUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockCountUser'] = ResolversParentTypes['StockCountUser']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorageAreasResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorageAreasResponse'] = ResolversParentTypes['StorageAreasResponse']> = {
  __resolveType: TypeResolveFn<'StorageAreasSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type StorageAreasSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorageAreasSuccess'] = ResolversParentTypes['StorageAreasSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  storageAreas?: Resolver<Array<ResolversTypes['StorageArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorageAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorageArea'] = ResolversParentTypes['StorageArea']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  storageItems?: Resolver<Array<ResolversTypes['StorageItem']>, ParentType, ContextType, Partial<StorageAreaStorageItemsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorageItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorageItem'] = ResolversParentTypes['StorageItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inventoryItem?: Resolver<ResolversTypes['InventoryItem'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ItemPrice']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['ItemUnit']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['StorageItemCount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InventoryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['InventoryItem'] = ResolversParentTypes['InventoryItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['ItemVendor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemVendorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemVendor'] = ResolversParentTypes['ItemVendor']> = {
  __resolveType: TypeResolveFn<'ChocoVendor' | 'BuyerExternalVendor', ParentType, ContextType>;
};

export type ChocoVendorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChocoVendor'] = ResolversParentTypes['ChocoVendor']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerExternalVendorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerExternalVendor'] = ResolversParentTypes['BuyerExternalVendor']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemPrice'] = ResolversParentTypes['ItemPrice']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  priceInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemUnitResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemUnit'] = ResolversParentTypes['ItemUnit']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StorageItemCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['StorageItemCount'] = ResolversParentTypes['StorageItemCount']> = {
  inStock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dateCounted?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierAssortmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['supplierAssortments'] = ResolversParentTypes['supplierAssortments']> = {
  assortments?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatLabelsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatLabelsResult'] = ResolversParentTypes['ChatLabelsResult']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierDeliveryDateSettingsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDeliveryDateSettingsResponse'] = ResolversParentTypes['SupplierDeliveryDateSettingsResponse']> = {
  __resolveType: TypeResolveFn<'SupplierDeliveryDateSettings' | 'SupplierNotFound' | 'SupplierDeliverySettingsNotFound', ParentType, ContextType>;
};

export type SupplierDeliverySettingsNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDeliverySettingsNotFound'] = ResolversParentTypes['SupplierDeliverySettingsNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierSearchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierSearchResponse'] = ResolversParentTypes['SupplierSearchResponse']> = {
  __resolveType: TypeResolveFn<'SearchSupplierConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SearchSupplierConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchSupplierConnection'] = ResolversParentTypes['SearchSupplierConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['SupplierSearchEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierSearchEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierSearchEdge'] = ResolversParentTypes['SupplierSearchEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserChatsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserChatsResponse'] = ResolversParentTypes['UserChatsResponse']> = {
  __resolveType: TypeResolveFn<'UserChatConnection' | 'UserChatsError', ParentType, ContextType>;
};

export type UserChatsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserChatsError'] = ResolversParentTypes['UserChatsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSearchResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSearchResponse'] = ResolversParentTypes['UserSearchResponse']> = {
  __resolveType: TypeResolveFn<'UserSearchConnection' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UserSearchConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSearchConnection'] = ResolversParentTypes['UserSearchConnection']> = {
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['UserSearchEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSearchEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSearchEdge'] = ResolversParentTypes['UserSearchEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateProductsAvailabilityResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateProductsAvailabilityResponse'] = ResolversParentTypes['ValidateProductsAvailabilityResponse']> = {
  __resolveType: TypeResolveFn<'ValidateProductsAvailabilityResult' | 'ChatNotFoundError' | 'SupplierNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ValidateProductsAvailabilityResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateProductsAvailabilityResult'] = ResolversParentTypes['ValidateProductsAvailabilityResult']> = {
  unavailableForSupplier?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  unavailableForChat?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  notFound?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemCategoriesForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategoriesForChatResponse'] = ResolversParentTypes['VendorItemCategoriesForChatResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemCategoriesForChatSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemCategoriesForChatSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategoriesForChatSuccess'] = ResolversParentTypes['VendorItemCategoriesForChatSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['VendorItemCategoriesForChatResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemCategoriesForChatResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemCategoriesForChatResultEdge'] = ResolversParentTypes['VendorItemCategoriesForChatResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['VendorItemCategory'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsResponse'] = ResolversParentTypes['VendorItemsResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemsSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsSuccess'] = ResolversParentTypes['VendorItemsSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['VendorItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsCountForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsCountForChatResponse'] = ResolversParentTypes['VendorItemsCountForChatResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemsCountForChatSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemsCountForChatSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsCountForChatSuccess'] = ResolversParentTypes['VendorItemsCountForChatSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsForChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForChatResponse'] = ResolversParentTypes['VendorItemsForChatResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemsForChatSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemsForChatSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForChatSuccess'] = ResolversParentTypes['VendorItemsForChatSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['VendorItemsForChatResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsForChatResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForChatResultEdge'] = ResolversParentTypes['VendorItemsForChatResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['VendorItemUnit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsForVendorResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForVendorResponse'] = ResolversParentTypes['VendorItemsForVendorResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemsForVendorResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemsForVendorResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForVendorResult'] = ResolversParentTypes['VendorItemsForVendorResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['VendorItemsForVendorResultEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemsForVendorResultEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemsForVendorResultEdge'] = ResolversParentTypes['VendorItemsForVendorResultEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['VendorItemUnit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptOrder?: Resolver<ResolversTypes['AcceptOrderResponse'], ParentType, ContextType, RequireFields<MutationAcceptOrderArgs, 'id' | 'acceptedOrder'>>;
  activateSuppliersPaymentAccount?: Resolver<ResolversTypes['ActivateSuppliersPaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationActivateSuppliersPaymentAccountArgs, 'input'>>;
  addBuyerStockInventoryProduct?: Resolver<ResolversTypes['AddBuyerStockInventoryProductResponse'], ParentType, ContextType, RequireFields<MutationAddBuyerStockInventoryProductArgs, 'input'>>;
  addCatalogProductsToProductList?: Resolver<Array<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<MutationAddCatalogProductsToProductListArgs, 'chatId' | 'catalogProductList'>>;
  addEntitiesToGroup?: Resolver<Maybe<ResolversTypes['AddEntitiesToGroupResponse']>, ParentType, ContextType, RequireFields<MutationAddEntitiesToGroupArgs, 'input'>>;
  addInvoice?: Resolver<ResolversTypes['AddInvoiceResponse'], ParentType, ContextType, RequireFields<MutationAddInvoiceArgs, 'input'>>;
  addLabelToChats?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddLabelToChatsArgs, 'label' | 'chatIds'>>;
  addMarketingProductsToCart?: Resolver<Maybe<ResolversTypes['AddMarketingProductsToCartResponse']>, ParentType, ContextType, RequireFields<MutationAddMarketingProductsToCartArgs, 'chatId' | 'products'>>;
  addPaymentAccount?: Resolver<ResolversTypes['AddPaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationAddPaymentAccountArgs, 'account'>>;
  addProductsToOrderGuides?: Resolver<ResolversTypes['AddProductsToOrderGuidesResponse'], ParentType, ContextType, RequireFields<MutationAddProductsToOrderGuidesArgs, 'input'>>;
  addSalesRep?: Resolver<ResolversTypes['AddSalesRepRequestToJoinResponse'], ParentType, ContextType, Partial<MutationAddSalesRepArgs>>;
  addSupplierRequest?: Resolver<ResolversTypes['BuyerAddSupplierResponse'], ParentType, ContextType, RequireFields<MutationAddSupplierRequestArgs, 'input'>>;
  addSuppliersPaymentAccount?: Resolver<ResolversTypes['AddSuppliersPaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationAddSuppliersPaymentAccountArgs, 'input'>>;
  addUserToChats?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationAddUserToChatsArgs, 'userId' | 'chatIds'>>;
  addUsersToGroup?: Resolver<Maybe<ResolversTypes['AddUsersToGroupResponse']>, ParentType, ContextType, RequireFields<MutationAddUsersToGroupArgs, 'input'>>;
  adminAddPaymentAccount?: Resolver<ResolversTypes['AddPaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationAdminAddPaymentAccountArgs, 'account' | 'owner'>>;
  assignOrderToUserForReview?: Resolver<ResolversTypes['AssignOrderToUserForReviewResponse'], ParentType, ContextType, RequireFields<MutationAssignOrderToUserForReviewArgs, 'input'>>;
  batchOrderConfirm?: Resolver<Maybe<ResolversTypes['BatchOrderConfirmResponse']>, ParentType, ContextType, RequireFields<MutationBatchOrderConfirmArgs, 'ids'>>;
  batchUpdateOrderSupplier?: Resolver<Maybe<ResolversTypes['BatchUpdateOrderSupplier']>, ParentType, ContextType, RequireFields<MutationBatchUpdateOrderSupplierArgs, 'input'>>;
  broadcastCreate?: Resolver<ResolversTypes['Broadcast'], ParentType, ContextType, RequireFields<MutationBroadcastCreateArgs, 'broadcastInput'>>;
  broadcastUpdate?: Resolver<ResolversTypes['Broadcast'], ParentType, ContextType, RequireFields<MutationBroadcastUpdateArgs, 'id' | 'broadcastInput'>>;
  broadcastUpdatePurpose?: Resolver<Maybe<ResolversTypes['BroadcastUpdatePurposeResult']>, ParentType, ContextType, RequireFields<MutationBroadcastUpdatePurposeArgs, 'id' | 'purpose'>>;
  bulkSendInviteTransmission?: Resolver<ResolversTypes['BulkSendInviteTransmissionResponse'], ParentType, ContextType, RequireFields<MutationBulkSendInviteTransmissionArgs, 'input'>>;
  bulkSubmitOrderedProductDeliveryCheck?: Resolver<Maybe<ResolversTypes['BulkOrderedProductDeliveryCheckSubmissionResponse']>, ParentType, ContextType, Partial<MutationBulkSubmitOrderedProductDeliveryCheckArgs>>;
  buyerAddUser?: Resolver<ResolversTypes['BuyerUser'], ParentType, ContextType, RequireFields<MutationBuyerAddUserArgs, 'buyerId' | 'userId'>>;
  buyerBulkAddUser?: Resolver<Array<Maybe<ResolversTypes['BuyerUser']>>, ParentType, ContextType, RequireFields<MutationBuyerBulkAddUserArgs, 'buyerId' | 'userRoles'>>;
  buyerCreate?: Resolver<ResolversTypes['Buyer'], ParentType, ContextType, RequireFields<MutationBuyerCreateArgs, 'buyer'>>;
  buyerDisableRoles?: Resolver<ResolversTypes['BuyerDisableRolesResponse'], ParentType, ContextType, RequireFields<MutationBuyerDisableRolesArgs, 'buyerId'>>;
  buyerRemoveUser?: Resolver<ResolversTypes['BuyerUser'], ParentType, ContextType, RequireFields<MutationBuyerRemoveUserArgs, 'buyerId' | 'userId'>>;
  buyerUpdate?: Resolver<ResolversTypes['Buyer'], ParentType, ContextType, RequireFields<MutationBuyerUpdateArgs, 'id' | 'buyer'>>;
  cancelCart?: Resolver<Maybe<ResolversTypes['CancelCartResponse']>, ParentType, ContextType, RequireFields<MutationCancelCartArgs, 'chatId' | 'options'>>;
  catalogImportStart?: Resolver<ResolversTypes['CatalogImportStartResponse'], ParentType, ContextType, RequireFields<MutationCatalogImportStartArgs, 'input'>>;
  categoryCreate?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType, RequireFields<MutationCategoryCreateArgs, 'chatId' | 'category'>>;
  categoryDelete?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType, RequireFields<MutationCategoryDeleteArgs, 'chatId' | 'categoryIds'>>;
  categoryProductSort?: Resolver<Array<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<MutationCategoryProductSortArgs, 'chatId' | 'categorizedProductList'>>;
  categoryUpdate?: Resolver<ResolversTypes['ProductCategory'], ParentType, ContextType, RequireFields<MutationCategoryUpdateArgs, 'chatId' | 'category'>>;
  chatCreate?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<MutationChatCreateArgs, 'chat'>>;
  chatDisable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChatDisableArgs, 'id'>>;
  chatInviteUsers?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<MutationChatInviteUsersArgs, 'id' | 'userIds'>>;
  chatLeave?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationChatLeaveArgs, 'id'>>;
  chatMainSupplierMigrate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChatMainSupplierMigrateArgs, 'chatId' | 'supplierUserId'>>;
  chatRemoveUsers?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<MutationChatRemoveUsersArgs, 'id' | 'userIds'>>;
  chatUpdate?: Resolver<ResolversTypes['Chat'], ParentType, ContextType, RequireFields<MutationChatUpdateArgs, 'id' | 'chat'>>;
  chatUpdateMainSupplier?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationChatUpdateMainSupplierArgs, 'chatId' | 'supplierId'>>;
  claimOnboardingChecklistReward?: Resolver<ResolversTypes['ClaimOnboardingChecklistRewardResponse'], ParentType, ContextType, RequireFields<MutationClaimOnboardingChecklistRewardArgs, 'id'>>;
  confirmDeliveryCheckReconciliationRequest?: Resolver<Maybe<ResolversTypes['ConfirmDeliveryCheckReconciliationResponse']>, ParentType, ContextType, RequireFields<MutationConfirmDeliveryCheckReconciliationRequestArgs, 'orderId' | 'deliveryCheckReconciliationRequestId'>>;
  connectAccount?: Resolver<ResolversTypes['ConnectAccountResponse'], ParentType, ContextType, RequireFields<MutationConnectAccountArgs, 'appName'>>;
  connectIntegrationAdapter?: Resolver<ResolversTypes['ConnectIntegrationAdapterResponse'], ParentType, ContextType, RequireFields<MutationConnectIntegrationAdapterArgs, 'input'>>;
  contactsCreate?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType, Partial<MutationContactsCreateArgs>>;
  createBuyerReportSchedule?: Resolver<ResolversTypes['CreateBuyerReportScheduleResponse'], ParentType, ContextType, RequireFields<MutationCreateBuyerReportScheduleArgs, 'input'>>;
  createGroup?: Resolver<Maybe<ResolversTypes['GroupResponse']>, ParentType, ContextType, RequireFields<MutationCreateGroupArgs, 'input'>>;
  createOrderDeliveryCheck?: Resolver<Maybe<ResolversTypes['OrderDeliveryCheckCreationResponse']>, ParentType, ContextType, RequireFields<MutationCreateOrderDeliveryCheckArgs, 'input'>>;
  createOrderDeliveryCheckImageUploadUrl?: Resolver<Maybe<ResolversTypes['OrderDeliveryCheckImageUploadUrlResponse']>, ParentType, ContextType, RequireFields<MutationCreateOrderDeliveryCheckImageUploadUrlArgs, 'orderId'>>;
  createOrderDeskEmailList?: Resolver<ResolversTypes['CreateEmailListResponse'], ParentType, ContextType, RequireFields<MutationCreateOrderDeskEmailListArgs, 'input'>>;
  createProfile?: Resolver<ResolversTypes['CreateProfileResponse'], ParentType, ContextType, RequireFields<MutationCreateProfileArgs, 'user'>>;
  createPushEndpoint?: Resolver<Maybe<ResolversTypes['PushEndpointResponse']>, ParentType, ContextType, Partial<MutationCreatePushEndpointArgs>>;
  createReferral?: Resolver<Maybe<ResolversTypes['CreateReferralResponse']>, ParentType, ContextType, RequireFields<MutationCreateReferralArgs, 'input'>>;
  createStorageItem?: Resolver<ResolversTypes['CreateStorageItemResponse'], ParentType, ContextType, RequireFields<MutationCreateStorageItemArgs, 'input'>>;
  createSubCatalog?: Resolver<Maybe<ResolversTypes['createSubCatalogResponse']>, ParentType, ContextType, RequireFields<MutationCreateSubCatalogArgs, 'name'>>;
  createSupplierContact?: Resolver<ResolversTypes['CreateSupplierContactResponse'], ParentType, ContextType, RequireFields<MutationCreateSupplierContactArgs, 'supplierContact'>>;
  createSupplierProduct?: Resolver<ResolversTypes['CreateUpdateSupplierProductResponse'], ParentType, ContextType, RequireFields<MutationCreateSupplierProductArgs, 'product'>>;
  createSupplierProductV2?: Resolver<ResolversTypes['CreateUpdateSupplierProductResponse'], ParentType, ContextType, RequireFields<MutationCreateSupplierProductV2Args, 'product'>>;
  deactivateSuppliersPaymentAccount?: Resolver<ResolversTypes['DeactivateSuppliersPaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationDeactivateSuppliersPaymentAccountArgs, 'input'>>;
  deleteBuyerReportSchedule?: Resolver<ResolversTypes['DeleteBuyerReportScheduleResponse'], ParentType, ContextType, RequireFields<MutationDeleteBuyerReportScheduleArgs, 'scheduleId'>>;
  deleteBuyerStockInventoryProducts?: Resolver<ResolversTypes['DeleteBuyerStockInventoryProductsResponse'], ParentType, ContextType, RequireFields<MutationDeleteBuyerStockInventoryProductsArgs, 'input'>>;
  deleteChatDeliverySetting?: Resolver<Maybe<ResolversTypes['DeletedChatSetting']>, ParentType, ContextType, RequireFields<MutationDeleteChatDeliverySettingArgs, 'chatId'>>;
  deleteEntireSupplierProduct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteEntireSupplierProductArgs, 'id'>>;
  deleteProductImage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteProductImageArgs, 'input'>>;
  deleteProfileImage?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationDeleteProfileImageArgs, 'userId'>>;
  deleteSubCatalog?: Resolver<Maybe<ResolversTypes['deleteSubCatalogResponse']>, ParentType, ContextType, RequireFields<MutationDeleteSubCatalogArgs, 'id'>>;
  deleteSupplierNegotiatedPrices?: Resolver<Maybe<ResolversTypes['DeletedSupplierNegotiatedPriceResponse']>, ParentType, ContextType, RequireFields<MutationDeleteSupplierNegotiatedPricesArgs, 'buyerId'>>;
  deleteSupplierProduct?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType, Partial<MutationDeleteSupplierProductArgs>>;
  disconnectAccount?: Resolver<ResolversTypes['DisconnectAccountResponse'], ParentType, ContextType, RequireFields<MutationDisconnectAccountArgs, 'appName'>>;
  disconnectIntegrationAdapter?: Resolver<ResolversTypes['DisconnectIntegrationAdapterResponse'], ParentType, ContextType, RequireFields<MutationDisconnectIntegrationAdapterArgs, 'input'>>;
  editBuyerReportSchedule?: Resolver<ResolversTypes['EditBuyerReportScheduleResponse'], ParentType, ContextType, RequireFields<MutationEditBuyerReportScheduleArgs, 'input'>>;
  generateBuyerReport?: Resolver<ResolversTypes['GenerateBuyerReportResponse'], ParentType, ContextType, RequireFields<MutationGenerateBuyerReportArgs, 'input'>>;
  getClientDebuggableArtifactUploadUrl?: Resolver<ResolversTypes['GetClientDebuggableArtifactUploadUrlResponse'], ParentType, ContextType, RequireFields<MutationGetClientDebuggableArtifactUploadUrlArgs, 'getClientDebuggableArtifactUploadUrl'>>;
  getOrderGuideUploadUrl?: Resolver<ResolversTypes['GetOrderGuideUploadUrlResponse'], ParentType, ContextType, RequireFields<MutationGetOrderGuideUploadUrlArgs, 'getOrderGuideUploadUrl'>>;
  importSupplierProducts?: Resolver<ResolversTypes['ImportSupplierProductsReport'], ParentType, ContextType, RequireFields<MutationImportSupplierProductsArgs, 'supplierId' | 'dryRun'>>;
  importSupplierProductsV2?: Resolver<ResolversTypes['ImportSupplierProductsReport'], ParentType, ContextType, RequireFields<MutationImportSupplierProductsV2Args, 'supplierId' | 'dryRun'>>;
  initInventoryDownload?: Resolver<ResolversTypes['InitInventoryDownloadResponse'], ParentType, ContextType, RequireFields<MutationInitInventoryDownloadArgs, 'input'>>;
  initInventoryUpload?: Resolver<ResolversTypes['InitInventoryUploadResponse'], ParentType, ContextType, RequireFields<MutationInitInventoryUploadArgs, 'input'>>;
  initiateCheckout?: Resolver<ResolversTypes['InitiateCheckoutResponse'], ParentType, ContextType, RequireFields<MutationInitiateCheckoutArgs, 'invoiceId' | 'paymentAccountId'>>;
  integrationAdapterConnectionAuth?: Resolver<ResolversTypes['IntegrationAdapterConnectionAuthResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterConnectionAuthArgs, 'input'>>;
  integrationAdapterConnectionConsent?: Resolver<ResolversTypes['IntegrationAdapterConnectionConsentResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterConnectionConsentArgs, 'input'>>;
  integrationAdapterConnectionCreate?: Resolver<ResolversTypes['IntegrationAdapterConnectionCreateResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterConnectionCreateArgs, 'input'>>;
  integrationAdapterConnectionUpdate?: Resolver<ResolversTypes['IntegrationAdapterConnectionUpdateResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterConnectionUpdateArgs, 'input'>>;
  integrationAdapterCreate?: Resolver<ResolversTypes['IntegrationAdapterCreateResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterCreateArgs, 'input'>>;
  integrationAdapterUpdate?: Resolver<ResolversTypes['IntegrationAdapterUpdateResponse'], ParentType, ContextType, RequireFields<MutationIntegrationAdapterUpdateArgs, 'input'>>;
  integrationWebhookRetry?: Resolver<ResolversTypes['IntegrationWebhookRetryResponse'], ParentType, ContextType, RequireFields<MutationIntegrationWebhookRetryArgs, 'input'>>;
  internalInviteUsers?: Resolver<ResolversTypes['InternalInviteUsersResponse'], ParentType, ContextType, RequireFields<MutationInternalInviteUsersArgs, 'phoneNumbers' | 'invitorUserId'>>;
  inviteNonChocoUserToBuyer?: Resolver<Maybe<ResolversTypes['inviteNonChocoUserToBuyerResponse']>, ParentType, ContextType, RequireFields<MutationInviteNonChocoUserToBuyerArgs, 'phone' | 'buyerId'>>;
  inviteNonChocoUserToChat?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType, RequireFields<MutationInviteNonChocoUserToChatArgs, 'phoneNumbers' | 'chatId'>>;
  inviteUserToBuyer?: Resolver<ResolversTypes['InviteUserToBuyerResponse'], ParentType, ContextType, RequireFields<MutationInviteUserToBuyerArgs, 'buyerId' | 'input'>>;
  kycCreate?: Resolver<ResolversTypes['KycCreateResponse'], ParentType, ContextType, RequireFields<MutationKycCreateArgs, 'input'>>;
  messageCreate?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<MutationMessageCreateArgs, 'chatId' | 'message'>>;
  notificationCreate?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType, RequireFields<MutationNotificationCreateArgs, 'userId' | 'messageId'>>;
  notificationPreferencesUpdate?: Resolver<Maybe<ResolversTypes['NotificationPreferences']>, ParentType, ContextType, Partial<MutationNotificationPreferencesUpdateArgs>>;
  orderConfirm?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationOrderConfirmArgs, 'id'>>;
  orderCreate?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<MutationOrderCreateArgs, 'chatId' | 'order'>>;
  orderCreateV2?: Resolver<Maybe<ResolversTypes['OrderCreatedResponse']>, ParentType, ContextType, RequireFields<MutationOrderCreateV2Args, 'chatId' | 'order'>>;
  orderEdit?: Resolver<Maybe<ResolversTypes['OrderEditedResponse']>, ParentType, ContextType, RequireFields<MutationOrderEditArgs, 'orderId' | 'editedOrderInput'>>;
  orderExportConfigCreate?: Resolver<ResolversTypes['OrderExportConfig'], ParentType, ContextType, RequireFields<MutationOrderExportConfigCreateArgs, 'supplierId' | 'orderConfig'>>;
  orderExportConfigDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationOrderExportConfigDeleteArgs, 'supplierId'>>;
  orderExportConfigUpdate?: Resolver<ResolversTypes['OrderExportConfig'], ParentType, ContextType, RequireFields<MutationOrderExportConfigUpdateArgs, 'supplierId' | 'orderConfig'>>;
  orderGuideCreated?: Resolver<ResolversTypes['OrderGuideCreatedResponse'], ParentType, ContextType, RequireFields<MutationOrderGuideCreatedArgs, 'chatId'>>;
  orderGuideRequest?: Resolver<ResolversTypes['OrderGuideRequestResponse'], ParentType, ContextType, RequireFields<MutationOrderGuideRequestArgs, 'orderGuideRequest'>>;
  orderGuideV2ItemUnitsAdd?: Resolver<ResolversTypes['OrderGuideV2ItemUnitsAddResponse'], ParentType, ContextType, RequireFields<MutationOrderGuideV2ItemUnitsAddArgs, 'input'>>;
  orderGuideV2ItemUnitsRemove?: Resolver<ResolversTypes['OrderGuideV2ItemUnitsRemoveResponse'], ParentType, ContextType, RequireFields<MutationOrderGuideV2ItemUnitsRemoveArgs, 'input'>>;
  paymentAuthorize?: Resolver<ResolversTypes['PaymentAuthorizeResponse'], ParentType, ContextType, RequireFields<MutationPaymentAuthorizeArgs, 'input'>>;
  productBatchCreate?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationProductBatchCreateArgs, 'chatId'>>;
  productCreate?: Resolver<ResolversTypes['Product'], ParentType, ContextType, RequireFields<MutationProductCreateArgs, 'chatId' | 'product'>>;
  productDelete?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType, RequireFields<MutationProductDeleteArgs, 'ids'>>;
  productSort?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType, RequireFields<MutationProductSortArgs, 'chatId' | 'ids'>>;
  productUpdate?: Resolver<ResolversTypes['Product'], ParentType, ContextType, RequireFields<MutationProductUpdateArgs, 'id' | 'fieldName' | 'fieldValue'>>;
  productUpdateCategory?: Resolver<ResolversTypes['UpdatedCategoryProduct'], ParentType, ContextType, RequireFields<MutationProductUpdateCategoryArgs, 'chatId' | 'productId' | 'categoryId'>>;
  productUpdateExternalId?: Resolver<ResolversTypes['Product'], ParentType, ContextType, RequireFields<MutationProductUpdateExternalIdArgs, 'id' | 'externalId'>>;
  referUser?: Resolver<Maybe<ResolversTypes['ReferUserResponse']>, ParentType, ContextType, RequireFields<MutationReferUserArgs, 'input'>>;
  refreshOrderDesk?: Resolver<ResolversTypes['OmnichannelOrdersSubcriptionResponse'], ParentType, ContextType, RequireFields<MutationRefreshOrderDeskArgs, 'supplierId' | 'omnichannelOrderId'>>;
  rejectOrder?: Resolver<ResolversTypes['RejectOrderResponse'], ParentType, ContextType, RequireFields<MutationRejectOrderArgs, 'input'>>;
  rejectOrdersById?: Resolver<ResolversTypes['RejectOrdersByIdResponse'], ParentType, ContextType, RequireFields<MutationRejectOrdersByIdArgs, 'input'>>;
  removeBlockedEmail?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationRemoveBlockedEmailArgs, 'email'>>;
  removeCCEmailFromChats?: Resolver<ResolversTypes['RemoveCCEmailFromChatsReport'], ParentType, ContextType, RequireFields<MutationRemoveCcEmailFromChatsArgs, 'email'>>;
  removeEmailFromBuyerReportSchedule?: Resolver<Maybe<ResolversTypes['RemoveEmailFromBuyerReportScheduleResponse']>, ParentType, ContextType, RequireFields<MutationRemoveEmailFromBuyerReportScheduleArgs, 'emailToRemove'>>;
  removeEntitiesFromGroup?: Resolver<Maybe<ResolversTypes['RemoveEntitiesFromGroupResponse']>, ParentType, ContextType, RequireFields<MutationRemoveEntitiesFromGroupArgs, 'input'>>;
  removeInvoice?: Resolver<ResolversTypes['RemoveInvoiceResponse'], ParentType, ContextType, RequireFields<MutationRemoveInvoiceArgs, 'orderId'>>;
  removeInvoiceAttachment?: Resolver<ResolversTypes['RemoveInvoiceAttachmentResponse'], ParentType, ContextType, RequireFields<MutationRemoveInvoiceAttachmentArgs, 'orderId'>>;
  removeLabelFromChats?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveLabelFromChatsArgs, 'label' | 'chatIds'>>;
  removeOrderDeskEmail?: Resolver<ResolversTypes['OrderDeskRemovedEmailResponse'], ParentType, ContextType, RequireFields<MutationRemoveOrderDeskEmailArgs, 'input'>>;
  removePaymentAccount?: Resolver<ResolversTypes['RemovePaymentAccountResponse'], ParentType, ContextType, RequireFields<MutationRemovePaymentAccountArgs, 'id'>>;
  removeProductsFromOrderGuides?: Resolver<ResolversTypes['RemoveProductsFromOrderGuidesResponse'], ParentType, ContextType, RequireFields<MutationRemoveProductsFromOrderGuidesArgs, 'input'>>;
  removeSupplierBuyerMov?: Resolver<Maybe<ResolversTypes['MinimumOrderValueUpdateResponse']>, ParentType, ContextType, RequireFields<MutationRemoveSupplierBuyerMovArgs, 'input'>>;
  removeUserFromChats?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveUserFromChatsArgs, 'userId' | 'chatIds'>>;
  removeUsersFromGroup?: Resolver<Maybe<ResolversTypes['RemoveUsersFromGroupResponse']>, ParentType, ContextType, Partial<MutationRemoveUsersFromGroupArgs>>;
  requestToJoinBuyer?: Resolver<ResolversTypes['RequestToJoinBuyerResponse'], ParentType, ContextType, RequireFields<MutationRequestToJoinBuyerArgs, 'buyerId'>>;
  selectProductForOrderGuide?: Resolver<ResolversTypes['SelectProductForOrderGuideResponse'], ParentType, ContextType, RequireFields<MutationSelectProductForOrderGuideArgs, 'input'>>;
  selectProductsForOrderGuide?: Resolver<ResolversTypes['SelectProductsForOrderGuideResponse'], ParentType, ContextType, RequireFields<MutationSelectProductsForOrderGuideArgs, 'input'>>;
  sendInviteTransmission?: Resolver<ResolversTypes['SendInviteTransmissionResponse'], ParentType, ContextType, RequireFields<MutationSendInviteTransmissionArgs, 'input'>>;
  sendSyntheticSmsMessage?: Resolver<ResolversTypes['SendSyntheticSmsMessageResponse'], ParentType, ContextType, RequireFields<MutationSendSyntheticSmsMessageArgs, 'input'>>;
  sendSyntheticWhatsAppMessage?: Resolver<ResolversTypes['SendSyntheticWhatsAppMessageResponse'], ParentType, ContextType, RequireFields<MutationSendSyntheticWhatsAppMessageArgs, 'input'>>;
  setOrderAsTest?: Resolver<ResolversTypes['SetOrderAsTestResponse'], ParentType, ContextType, RequireFields<MutationSetOrderAsTestArgs, 'orderId'>>;
  shortenUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationShortenUrlArgs, 'longUrl'>>;
  submitBuyerStockCount?: Resolver<ResolversTypes['BuyerStockCountResponse'], ParentType, ContextType, RequireFields<MutationSubmitBuyerStockCountArgs, 'input'>>;
  submitCart?: Resolver<Maybe<ResolversTypes['CartSubmissionResponse']>, ParentType, ContextType, RequireFields<MutationSubmitCartArgs, 'chatId' | 'options'>>;
  submitOrderDeliveryCheck?: Resolver<Maybe<ResolversTypes['OrderDeliveryCheckSubmissionResponse']>, ParentType, ContextType, RequireFields<MutationSubmitOrderDeliveryCheckArgs, 'input'>>;
  submitOrderedProductDeliveryCheck?: Resolver<Maybe<ResolversTypes['OrderedProductDeliveryCheckSubmissionResponse']>, ParentType, ContextType, Partial<MutationSubmitOrderedProductDeliveryCheckArgs>>;
  submitStockCountSession?: Resolver<ResolversTypes['SubmitStockCountSessionResponse'], ParentType, ContextType, RequireFields<MutationSubmitStockCountSessionArgs, 'input'>>;
  supplierAddRequest?: Resolver<ResolversTypes['SupplierAddRequestResponse'], ParentType, ContextType, RequireFields<MutationSupplierAddRequestArgs, 'supplierAddRequest'>>;
  supplierCreate?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType, RequireFields<MutationSupplierCreateArgs, 'supplier'>>;
  supplierGetInTouchRequest?: Resolver<Maybe<ResolversTypes['SupplierGetInTouchRequestResponse']>, ParentType, ContextType, RequireFields<MutationSupplierGetInTouchRequestArgs, 'input'>>;
  supplierInviteUser?: Resolver<ResolversTypes['SupplierInviteUserResponse'], ParentType, ContextType, RequireFields<MutationSupplierInviteUserArgs, 'invitee' | 'chat'>>;
  supplierInviteUsers?: Resolver<ResolversTypes['SupplierInviteUserResponse'], ParentType, ContextType, RequireFields<MutationSupplierInviteUsersArgs, 'phoneNumbers' | 'chat'>>;
  supplierRemoveUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSupplierRemoveUserArgs, 'userId'>>;
  supplierUpdate?: Resolver<ResolversTypes['Supplier'], ParentType, ContextType, RequireFields<MutationSupplierUpdateArgs, 'supplier'>>;
  supplierUserCreate?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationSupplierUserCreateArgs, 'input'>>;
  supplierUserRemove?: Resolver<ResolversTypes['SupplierUserRemoveResponse'], ParentType, ContextType, RequireFields<MutationSupplierUserRemoveArgs, 'input'>>;
  triggerProductMatching?: Resolver<ResolversTypes['TriggerProductMatchingResponse'], ParentType, ContextType, RequireFields<MutationTriggerProductMatchingArgs, 'input'>>;
  unassignUserFromOrderToReview?: Resolver<ResolversTypes['UnassignUserFromOrderToReviewResponse'], ParentType, ContextType, RequireFields<MutationUnassignUserFromOrderToReviewArgs, 'input'>>;
  undoMultiLocationOrderGuideTransaction?: Resolver<ResolversTypes['UndoMultiLocationOrderGuideTransactionResponse'], ParentType, ContextType, RequireFields<MutationUndoMultiLocationOrderGuideTransactionArgs, 'input'>>;
  updateBuyerInventoryProduct?: Resolver<ResolversTypes['UpdateBuyerInventoryProductResponse'], ParentType, ContextType, RequireFields<MutationUpdateBuyerInventoryProductArgs, 'input'>>;
  updateBuyerStockInventoryProduct?: Resolver<ResolversTypes['UpdateBuyerStockInventoryProductResponse'], ParentType, ContextType, RequireFields<MutationUpdateBuyerStockInventoryProductArgs, 'input'>>;
  updateCart?: Resolver<Maybe<ResolversTypes['CartUpdateResponse']>, ParentType, ContextType, RequireFields<MutationUpdateCartArgs, 'chatId' | 'lineItems'>>;
  updateChatEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateChatEnabledArgs, 'id' | 'enabled'>>;
  updateChatNotificationPreferences?: Resolver<Maybe<ResolversTypes['ChatNotificationPreferences']>, ParentType, ContextType, Partial<MutationUpdateChatNotificationPreferencesArgs>>;
  updateInventoryItem?: Resolver<ResolversTypes['UpdateInventoryItemResponse'], ParentType, ContextType, RequireFields<MutationUpdateInventoryItemArgs, 'input'>>;
  updateInvoice?: Resolver<ResolversTypes['UpdateInvoiceResponse'], ParentType, ContextType, RequireFields<MutationUpdateInvoiceArgs, 'input'>>;
  updateInvoicedProduct?: Resolver<ResolversTypes['UpdateInvoicedProductResponse'], ParentType, ContextType, RequireFields<MutationUpdateInvoicedProductArgs, 'input'>>;
  updateNotificationUserId?: Resolver<Maybe<ResolversTypes['NotificationPreferences']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationUserIdArgs, 'oldUserId' | 'newUserId'>>;
  updatePendingUser?: Resolver<ResolversTypes['UpdatePendingUserResponse'], ParentType, ContextType, RequireFields<MutationUpdatePendingUserArgs, 'input'>>;
  updateProductVariantsInOrderGuide?: Resolver<ResolversTypes['UpdateProductVariantsInOrderGuideResponse'], ParentType, ContextType, RequireFields<MutationUpdateProductVariantsInOrderGuideArgs, 'input'>>;
  updateRequestToJoin?: Resolver<ResolversTypes['UpdateJoinRequestResponse'], ParentType, ContextType, RequireFields<MutationUpdateRequestToJoinArgs, 'input'>>;
  updateStorageItem?: Resolver<ResolversTypes['UpdateStorageItemResponse'], ParentType, ContextType, RequireFields<MutationUpdateStorageItemArgs, 'input'>>;
  updateSubCatalog?: Resolver<Maybe<ResolversTypes['updateSubCatalogResponse']>, ParentType, ContextType, RequireFields<MutationUpdateSubCatalogArgs, 'id' | 'name'>>;
  updateSubCatalogChats?: Resolver<ResolversTypes['UpdateSubCatalogChatsResponse'], ParentType, ContextType, RequireFields<MutationUpdateSubCatalogChatsArgs, 'create' | 'remove'>>;
  updateSupplierAccessPackage?: Resolver<ResolversTypes['SupplierUpdateAccessPackageResponse'], ParentType, ContextType, RequireFields<MutationUpdateSupplierAccessPackageArgs, 'suppliers'>>;
  updateSupplierBuyerMov?: Resolver<Maybe<ResolversTypes['MinimumOrderValueUpdateResponse']>, ParentType, ContextType, RequireFields<MutationUpdateSupplierBuyerMovArgs, 'input'>>;
  updateSupplierDeliverySetting?: Resolver<Maybe<ResolversTypes['SupplierDeliverySetting']>, ParentType, ContextType, RequireFields<MutationUpdateSupplierDeliverySettingArgs, 'input'>>;
  updateSupplierProduct?: Resolver<ResolversTypes['CreateUpdateSupplierProductResponse'], ParentType, ContextType, RequireFields<MutationUpdateSupplierProductArgs, 'id' | 'fieldName' | 'fieldValue'>>;
  updateSupplierProductV2?: Resolver<ResolversTypes['CreateUpdateSupplierProductResponse'], ParentType, ContextType, RequireFields<MutationUpdateSupplierProductV2Args, 'product'>>;
  updateSupplierUserChats?: Resolver<ResolversTypes['SupplierUserUpdateChatsResponse'], ParentType, ContextType, RequireFields<MutationUpdateSupplierUserChatsArgs, 'input'>>;
  updateSupplierUserRoles?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, Partial<MutationUpdateSupplierUserRolesArgs>>;
  uploadSubCatalogProducts?: Resolver<ResolversTypes['UploadSubCatalogProductsResponse'], ParentType, ContextType, RequireFields<MutationUploadSubCatalogProductsArgs, 'subCatalogId' | 'csv'>>;
  uploadSubCatalogProductsV2?: Resolver<ResolversTypes['UploadSubCatalogProductsResponse'], ParentType, ContextType, RequireFields<MutationUploadSubCatalogProductsV2Args, 'subCatalogId' | 'csv'>>;
  upsertStockCountSessionItems?: Resolver<Maybe<ResolversTypes['UpsertStockCountSessionItemsResponse']>, ParentType, ContextType, RequireFields<MutationUpsertStockCountSessionItemsArgs, 'input'>>;
  userAddRole?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUserAddRoleArgs, 'userId' | 'role'>>;
  userConfirm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUserConfirmArgs, 'phone' | 'newUserPool'>>;
  userCreate?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUserCreateArgs, 'user'>>;
  userLeadCreate?: Resolver<Maybe<ResolversTypes['UserLead']>, ParentType, ContextType, RequireFields<MutationUserLeadCreateArgs, 'userLead'>>;
  userRemoveRole?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUserRemoveRoleArgs, 'userId' | 'role'>>;
  userRequestToDelete?: Resolver<ResolversTypes['UserRequestToDeleteResponse'], ParentType, ContextType, RequireFields<MutationUserRequestToDeleteArgs, 'input'>>;
  userUpdate?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUserUpdateArgs, 'user'>>;
  vendorItemUnitUpdate?: Resolver<ResolversTypes['VendorItemUnitUpdateResponse'], ParentType, ContextType, RequireFields<MutationVendorItemUnitUpdateArgs, 'input'>>;
};

export type AcceptOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcceptOrderResponse'] = ResolversParentTypes['AcceptOrderResponse']> = {
  __resolveType: TypeResolveFn<'Order' | 'OrderAlreadyAccepted' | 'OrderCreatedError' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrderAlreadyAcceptedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAlreadyAccepted'] = ResolversParentTypes['OrderAlreadyAccepted']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  acceptedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCreatedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCreatedError'] = ResolversParentTypes['OrderCreatedError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableProducts?: Resolver<Maybe<Array<ResolversTypes['UnavailableProductType']>>, ParentType, ContextType>;
  invalidProductIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  invalidBuyerProductIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnavailableProductTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnavailableProductType'] = ResolversParentTypes['UnavailableProductType']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availability?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivateSuppliersPaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateSuppliersPaymentAccountResponse'] = ResolversParentTypes['ActivateSuppliersPaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'SuppliersPaymentAccount' | 'AuthorizationFailure' | 'InputValidationFailure' | 'PaymentAccountNotFound' | 'ExternalAccountDetailsMissed' | 'ExternalAccountNotFound' | 'SupplierHasActivePaymentAccountAlready', ParentType, ContextType>;
};

export type SuppliersPaymentAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuppliersPaymentAccount'] = ResolversParentTypes['SuppliersPaymentAccount']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redirectUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountDetailsMissedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountDetailsMissed'] = ResolversParentTypes['ExternalAccountDetailsMissed']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExternalAccountNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalAccountNotFound'] = ResolversParentTypes['ExternalAccountNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierHasActivePaymentAccountAlreadyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierHasActivePaymentAccountAlready'] = ResolversParentTypes['SupplierHasActivePaymentAccountAlready']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddBuyerStockInventoryProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddBuyerStockInventoryProductResponse'] = ResolversParentTypes['AddBuyerStockInventoryProductResponse']> = {
  __resolveType: TypeResolveFn<'AddBuyerStockInventoryProductFailure' | 'AuthorizationFailure' | 'BuyerStockInventoryProduct' | 'InputValidationFailure' | 'ProductNotFoundError' | 'SupplierNotFound', ParentType, ContextType>;
};

export type AddBuyerStockInventoryProductFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddBuyerStockInventoryProductFailure'] = ResolversParentTypes['AddBuyerStockInventoryProductFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductNotFoundError'] = ResolversParentTypes['ProductNotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddEntitiesToGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddEntitiesToGroupResponse'] = ResolversParentTypes['AddEntitiesToGroupResponse']> = {
  __resolveType: TypeResolveFn<'AddEntitiesToGroupResponseSuccess' | 'AddEntitiesToGroupResponseError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type AddEntitiesToGroupResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddEntitiesToGroupResponseSuccess'] = ResolversParentTypes['AddEntitiesToGroupResponseSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddEntitiesToGroupResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddEntitiesToGroupResponseError'] = ResolversParentTypes['AddEntitiesToGroupResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['AddEntitiesToGroupErrorCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddInvoiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddInvoiceResponse'] = ResolversParentTypes['AddInvoiceResponse']> = {
  __resolveType: TypeResolveFn<'Invoice' | 'InputValidationFailure' | 'AuthorizationFailure' | 'ChatHasNoSupplierEntity' | 'OrderAlreadyHasInvoice', ParentType, ContextType>;
};

export type ChatHasNoSupplierEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatHasNoSupplierEntity'] = ResolversParentTypes['ChatHasNoSupplierEntity']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderAlreadyHasInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderAlreadyHasInvoice'] = ResolversParentTypes['OrderAlreadyHasInvoice']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddMarketingProductsToCartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddMarketingProductsToCartResponse'] = ResolversParentTypes['AddMarketingProductsToCartResponse']> = {
  __resolveType: TypeResolveFn<'AddMarketingProductsToCartSuccess' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type AddMarketingProductsToCartSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddMarketingProductsToCartSuccess'] = ResolversParentTypes['AddMarketingProductsToCartSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  teamCartData?: Resolver<ResolversTypes['AddMarketingProductsToCartTeamCartData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddMarketingProductsToCartTeamCartDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddMarketingProductsToCartTeamCartData'] = ResolversParentTypes['AddMarketingProductsToCartTeamCartData']> = {
  __resolveType: TypeResolveFn<'TeamCartExists' | 'TeamCartNotFound', ParentType, ContextType>;
};

export type TeamCartExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamCartExists'] = ResolversParentTypes['TeamCartExists']> = {
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TeamCartNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['TeamCartNotFound'] = ResolversParentTypes['TeamCartNotFound']> = {
  dummyMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddPaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddPaymentAccountResponse'] = ResolversParentTypes['AddPaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'PaymentAccount' | 'PaymentMethodNotAvailableForUser' | 'SupplierPaymentAccountAlreadyExists' | 'AuthorizationFailure' | 'InputValidationFailure' | 'PaymentAccountAlreadyExists', ParentType, ContextType>;
};

export type PaymentMethodNotAvailableForUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethodNotAvailableForUser'] = ResolversParentTypes['PaymentMethodNotAvailableForUser']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  userType?: Resolver<ResolversTypes['PaymentAccountOwnerType'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierPaymentAccountAlreadyExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierPaymentAccountAlreadyExists'] = ResolversParentTypes['SupplierPaymentAccountAlreadyExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountAlreadyExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountAlreadyExists'] = ResolversParentTypes['PaymentAccountAlreadyExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddProductsToOrderGuidesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddProductsToOrderGuidesResponse'] = ResolversParentTypes['AddProductsToOrderGuidesResponse']> = {
  __resolveType: TypeResolveFn<'AddProductsToOrderGuidesResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type AddProductsToOrderGuidesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddProductsToOrderGuidesResult'] = ResolversParentTypes['AddProductsToOrderGuidesResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['LocationProductsResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationProductsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationProductsResult'] = ResolversParentTypes['LocationProductsResult']> = {
  locationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  products?: Resolver<Array<ResolversTypes['LocationProductResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationProductResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationProductResult'] = ResolversParentTypes['LocationProductResult']> = {
  productId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  successfulOperation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSalesRepRequestToJoinResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSalesRepRequestToJoinResponse'] = ResolversParentTypes['AddSalesRepRequestToJoinResponse']> = {
  __resolveType: TypeResolveFn<'AddSalesRepSuccess' | 'AddSalesRepError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type AddSalesRepSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSalesRepSuccess'] = ResolversParentTypes['AddSalesRepSuccess']> = {
  addSalesRepRequestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salesRepUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSalesRepErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSalesRepError'] = ResolversParentTypes['AddSalesRepError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['AddSalesRepErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerAddSupplierResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerAddSupplierResponse'] = ResolversParentTypes['BuyerAddSupplierResponse']> = {
  __resolveType: TypeResolveFn<'BuyerAddSupplier' | 'BuyerAddSupplierError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BuyerAddSupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerAddSupplier'] = ResolversParentTypes['BuyerAddSupplier']> = {
  buyerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerAddSupplierErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerAddSupplierError'] = ResolversParentTypes['BuyerAddSupplierError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['BuyerAddSupplierErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddSuppliersPaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddSuppliersPaymentAccountResponse'] = ResolversParentTypes['AddSuppliersPaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'SuppliersPaymentAccount' | 'AuthorizationFailure' | 'InputValidationFailure' | 'SupplierNotFound' | 'SupplierPaymentsDisabled' | 'SupplierHasActivePaymentAccountAlready', ParentType, ContextType>;
};

export type SupplierPaymentsDisabledResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierPaymentsDisabled'] = ResolversParentTypes['SupplierPaymentsDisabled']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddUsersToGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddUsersToGroupResponse'] = ResolversParentTypes['AddUsersToGroupResponse']> = {
  __resolveType: TypeResolveFn<'AddUsersToGroupResponseSuccess' | 'AddUsersToGroupResponseError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type AddUsersToGroupResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddUsersToGroupResponseSuccess'] = ResolversParentTypes['AddUsersToGroupResponseSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddUsersToGroupResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddUsersToGroupResponseError'] = ResolversParentTypes['AddUsersToGroupResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssignOrderToUserForReviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignOrderToUserForReviewResponse'] = ResolversParentTypes['AssignOrderToUserForReviewResponse']> = {
  __resolveType: TypeResolveFn<'AssignOrderToUserForReviewResponseSuccess' | 'AssignOrderToUserForReviewResponseError', ParentType, ContextType>;
};

export type AssignOrderToUserForReviewResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignOrderToUserForReviewResponseSuccess'] = ResolversParentTypes['AssignOrderToUserForReviewResponseSuccess']> = {
  omnichannelOrderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssignOrderToUserForReviewResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignOrderToUserForReviewResponseError'] = ResolversParentTypes['AssignOrderToUserForReviewResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchOrderConfirmResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchOrderConfirmResponse'] = ResolversParentTypes['BatchOrderConfirmResponse']> = {
  __resolveType: TypeResolveFn<'BatchOrderConfirmSuccess' | 'BatchOrderConfirmError', ParentType, ContextType>;
};

export type BatchOrderConfirmSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchOrderConfirmSuccess'] = ResolversParentTypes['BatchOrderConfirmSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchOrderConfirmErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchOrderConfirmError'] = ResolversParentTypes['BatchOrderConfirmError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchUpdateOrderSupplierResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchUpdateOrderSupplier'] = ResolversParentTypes['BatchUpdateOrderSupplier']> = {
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BroadcastUpdatePurposeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BroadcastUpdatePurposeResult'] = ResolversParentTypes['BroadcastUpdatePurposeResult']> = {
  predefinedValue?: Resolver<ResolversTypes['PredefinedBroadcastPurpose'], ParentType, ContextType>;
  customValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkSendInviteTransmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkSendInviteTransmissionResponse'] = ResolversParentTypes['BulkSendInviteTransmissionResponse']> = {
  __resolveType: TypeResolveFn<'BulkInviteTransmissionSuccess' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type BulkInviteTransmissionSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkInviteTransmissionSuccess'] = ResolversParentTypes['BulkInviteTransmissionSuccess']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  failures?: Resolver<Array<ResolversTypes['BulkInviteTransmissionFailure']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkInviteTransmissionFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkInviteTransmissionFailure'] = ResolversParentTypes['BulkInviteTransmissionFailure']> = {
  inviteeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkOrderedProductDeliveryCheckSubmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkOrderedProductDeliveryCheckSubmissionResponse'] = ResolversParentTypes['BulkOrderedProductDeliveryCheckSubmissionResponse']> = {
  __resolveType: TypeResolveFn<'BulkOrderedProductDeliveryCheckSubmissionResult' | 'InputValidationFailure' | 'OrderNotFound' | 'OrderDeliveryItemsMismatched' | 'OrderDeliveryCheckAlreadyCompleted' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type BulkOrderedProductDeliveryCheckSubmissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkOrderedProductDeliveryCheckSubmissionResult'] = ResolversParentTypes['BulkOrderedProductDeliveryCheckSubmissionResult']> = {
  result?: Resolver<Array<Maybe<ResolversTypes['OrderedProductDeliveryCheck']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryItemsMismatchedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryItemsMismatched'] = ResolversParentTypes['OrderDeliveryItemsMismatched']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckAlreadyCompletedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckAlreadyCompleted'] = ResolversParentTypes['OrderDeliveryCheckAlreadyCompleted']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerDisableRolesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerDisableRolesResponse'] = ResolversParentTypes['BuyerDisableRolesResponse']> = {
  __resolveType: TypeResolveFn<'Buyer' | 'NotFoundError', ParentType, ContextType>;
};

export type CancelCartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelCartResponse'] = ResolversParentTypes['CancelCartResponse']> = {
  __resolveType: TypeResolveFn<'CancelCartResult' | 'CartVersionConstraintError' | 'CartNotFoundError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CancelCartResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelCartResult'] = ResolversParentTypes['CancelCartResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartVersionConstraintErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartVersionConstraintError'] = ResolversParentTypes['CartVersionConstraintError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestCartOperation?: Resolver<Maybe<ResolversTypes['UserCartItemOperation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCartItemOperationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCartItemOperation'] = ResolversParentTypes['UserCartItemOperation']> = {
  action?: Resolver<ResolversTypes['UserCartAction'], ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartNotFoundErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartNotFoundError'] = ResolversParentTypes['CartNotFoundError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CatalogImportStartResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportStartResponse'] = ResolversParentTypes['CatalogImportStartResponse']> = {
  __resolveType: TypeResolveFn<'CatalogImportStartResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CatalogImportStartResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CatalogImportStartResult'] = ResolversParentTypes['CatalogImportStartResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  job?: Resolver<ResolversTypes['CatalogImportJob'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimOnboardingChecklistRewardResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimOnboardingChecklistRewardResponse'] = ResolversParentTypes['ClaimOnboardingChecklistRewardResponse']> = {
  __resolveType: TypeResolveFn<'ClaimOnboardingChecklistRewardSuccess' | 'ClaimOnboardingChecklistRewardError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ClaimOnboardingChecklistRewardSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimOnboardingChecklistRewardSuccess'] = ResolversParentTypes['ClaimOnboardingChecklistRewardSuccess']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRewardClaimed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClaimOnboardingChecklistRewardErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClaimOnboardingChecklistRewardError'] = ResolversParentTypes['ClaimOnboardingChecklistRewardError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['ClaimOnboardingChecklistRewardErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmDeliveryCheckReconciliationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmDeliveryCheckReconciliationResponse'] = ResolversParentTypes['ConfirmDeliveryCheckReconciliationResponse']> = {
  __resolveType: TypeResolveFn<'DeliveryCheckReconciliationRequest' | 'InputValidationFailure' | 'DeliveryCheckReconciliationRequestNotFound' | 'DeliveryCheckReconciliationRequestAlreadyConfirmed' | 'OrderDeliveryCheckReconciliationRequestIdNotMatched' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type DeliveryCheckReconciliationRequestNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCheckReconciliationRequestNotFound'] = ResolversParentTypes['DeliveryCheckReconciliationRequestNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeliveryCheckReconciliationRequestAlreadyConfirmedResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeliveryCheckReconciliationRequestAlreadyConfirmed'] = ResolversParentTypes['DeliveryCheckReconciliationRequestAlreadyConfirmed']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckReconciliationRequestIdNotMatchedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckReconciliationRequestIdNotMatched'] = ResolversParentTypes['OrderDeliveryCheckReconciliationRequestIdNotMatched']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectAccountResponse'] = ResolversParentTypes['ConnectAccountResponse']> = {
  __resolveType: TypeResolveFn<'ConnectAccountUrl' | 'ConnectAccountError', ParentType, ContextType>;
};

export type ConnectAccountUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectAccountUrl'] = ResolversParentTypes['ConnectAccountUrl']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectAccountErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectAccountError'] = ResolversParentTypes['ConnectAccountError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectIntegrationAdapterResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectIntegrationAdapterResponse'] = ResolversParentTypes['ConnectIntegrationAdapterResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionBaseResult' | 'IntegrationAdapterConnectionAdminResult' | 'ChocoEntityNotFound' | 'UnsupportedIntegrationAdapterType' | 'IntegrationAdapterNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ChocoEntityNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChocoEntityNotFound'] = ResolversParentTypes['ChocoEntityNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnsupportedIntegrationAdapterTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnsupportedIntegrationAdapterType'] = ResolversParentTypes['UnsupportedIntegrationAdapterType']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterNotFound'] = ResolversParentTypes['IntegrationAdapterNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateBuyerReportScheduleResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBuyerReportScheduleResponse'] = ResolversParentTypes['CreateBuyerReportScheduleResponse']> = {
  __resolveType: TypeResolveFn<'BuyerReportSchedule' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeliveryCheckCreationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckCreationResponse'] = ResolversParentTypes['OrderDeliveryCheckCreationResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeliveryCheckDetails' | 'InputValidationFailure' | 'OrderDeliveryCheckExists' | 'OrderDeliveryCheckAlreadyCompleted' | 'OrderNotFound' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeliveryCheckExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckExists'] = ResolversParentTypes['OrderDeliveryCheckExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckImageUploadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckImageUploadUrlResponse'] = ResolversParentTypes['OrderDeliveryCheckImageUploadUrlResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeliveryCheckImageUploadUrlResult' | 'InputValidationFailure' | 'OrderNotFound' | 'OrderDeliveryCheckImageNotFound' | 'OrderDeliveryCheckAlreadyCompleted' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeliveryCheckImageUploadUrlResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckImageUploadUrlResult'] = ResolversParentTypes['OrderDeliveryCheckImageUploadUrlResult']> = {
  imageId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckImageNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckImageNotFound'] = ResolversParentTypes['OrderDeliveryCheckImageNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateEmailListResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateEmailListResponse'] = ResolversParentTypes['CreateEmailListResponse']> = {
  __resolveType: TypeResolveFn<'EmailListCreated' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type EmailListCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailListCreated'] = ResolversParentTypes['EmailListCreated']> = {
  supplierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderDestEmailListType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProfileResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProfileResponse'] = ResolversParentTypes['CreateProfileResponse']> = {
  __resolveType: TypeResolveFn<'User' | 'BuyerExists' | 'CreateProfileError', ParentType, ContextType>;
};

export type BuyerExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerExists'] = ResolversParentTypes['BuyerExists']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProfileErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProfileError'] = ResolversParentTypes['CreateProfileError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PushEndpointResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PushEndpointResponse'] = ResolversParentTypes['PushEndpointResponse']> = {
  __resolveType: TypeResolveFn<'NotificationPreferences', ParentType, ContextType>;
};

export type NotificationPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPreferences'] = ResolversParentTypes['NotificationPreferences']> = {
  message?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateReferralResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateReferralResponse'] = ResolversParentTypes['CreateReferralResponse']> = {
  __resolveType: TypeResolveFn<'Referral' | 'UserHasReferralCode' | 'ReferralCodeGenerationError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UserHasReferralCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserHasReferralCode'] = ResolversParentTypes['UserHasReferralCode']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferralCodeGenerationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferralCodeGenerationError'] = ResolversParentTypes['ReferralCodeGenerationError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateStorageItemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateStorageItemResponse'] = ResolversParentTypes['CreateStorageItemResponse']> = {
  __resolveType: TypeResolveFn<'CreateStorageItemSuccess' | 'CreateStorageItemFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type CreateStorageItemSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateStorageItemSuccess'] = ResolversParentTypes['CreateStorageItemSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  storageItem?: Resolver<ResolversTypes['StorageItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateStorageItemFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateStorageItemFailure'] = ResolversParentTypes['CreateStorageItemFailure']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSubCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['createSubCatalogResponse'] = ResolversParentTypes['createSubCatalogResponse']> = {
  __resolveType: TypeResolveFn<'SubCatalog' | 'CreateSubCatalogError', ParentType, ContextType>;
};

export type CreateSubCatalogErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSubCatalogError'] = ResolversParentTypes['CreateSubCatalogError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSupplierContactResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSupplierContactResponse'] = ResolversParentTypes['CreateSupplierContactResponse']> = {
  __resolveType: TypeResolveFn<'SupplierContact' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type SupplierContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierContact'] = ResolversParentTypes['SupplierContact']> = {
  supplierEntityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requireOrderReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUpdateSupplierProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUpdateSupplierProductResponse'] = ResolversParentTypes['CreateUpdateSupplierProductResponse']> = {
  __resolveType: TypeResolveFn<'Product' | 'InputValidationFailure' | 'ProductNotFoundError' | 'DuplicateProductError', ParentType, ContextType>;
};

export type DuplicateProductErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DuplicateProductError'] = ResolversParentTypes['DuplicateProductError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeactivateSuppliersPaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateSuppliersPaymentAccountResponse'] = ResolversParentTypes['DeactivateSuppliersPaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'SuppliersPaymentAccount' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type DeleteBuyerReportScheduleResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerReportScheduleResponse'] = ResolversParentTypes['DeleteBuyerReportScheduleResponse']> = {
  __resolveType: TypeResolveFn<'DeleteBuyerReportScheduleSuccess' | 'BuyerReportScheduleNotFound' | 'DeleteBuyerReportScheduleError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type DeleteBuyerReportScheduleSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerReportScheduleSuccess'] = ResolversParentTypes['DeleteBuyerReportScheduleSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerReportScheduleNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerReportScheduleNotFound'] = ResolversParentTypes['BuyerReportScheduleNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteBuyerReportScheduleErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerReportScheduleError'] = ResolversParentTypes['DeleteBuyerReportScheduleError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteBuyerStockInventoryProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerStockInventoryProductsResponse'] = ResolversParentTypes['DeleteBuyerStockInventoryProductsResponse']> = {
  __resolveType: TypeResolveFn<'DeleteBuyerStockInventoryProductsSuccess' | 'DeleteBuyerStockInventoryProductsFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type DeleteBuyerStockInventoryProductsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerStockInventoryProductsSuccess'] = ResolversParentTypes['DeleteBuyerStockInventoryProductsSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteBuyerStockInventoryProductsFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteBuyerStockInventoryProductsFailure'] = ResolversParentTypes['DeleteBuyerStockInventoryProductsFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedChatSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletedChatSetting'] = ResolversParentTypes['DeletedChatSetting']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSubCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['deleteSubCatalogResponse'] = ResolversParentTypes['deleteSubCatalogResponse']> = {
  __resolveType: TypeResolveFn<'DeleteSubCatalogSuccess' | 'DeleteSubCatalogError', ParentType, ContextType>;
};

export type DeleteSubCatalogSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSubCatalogSuccess'] = ResolversParentTypes['DeleteSubCatalogSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSubCatalogErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSubCatalogError'] = ResolversParentTypes['DeleteSubCatalogError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedSupplierNegotiatedPriceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletedSupplierNegotiatedPriceResponse'] = ResolversParentTypes['DeletedSupplierNegotiatedPriceResponse']> = {
  __resolveType: TypeResolveFn<'DeleteSupplierNegotiatedPriceResult' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type DeleteSupplierNegotiatedPriceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteSupplierNegotiatedPriceResult'] = ResolversParentTypes['DeleteSupplierNegotiatedPriceResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisconnectAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisconnectAccountResponse'] = ResolversParentTypes['DisconnectAccountResponse']> = {
  __resolveType: TypeResolveFn<'DisconnectAccountStatus' | 'DisconnectAccountError', ParentType, ContextType>;
};

export type DisconnectAccountStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisconnectAccountStatus'] = ResolversParentTypes['DisconnectAccountStatus']> = {
  appName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisconnectAccountErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisconnectAccountError'] = ResolversParentTypes['DisconnectAccountError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisconnectIntegrationAdapterResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisconnectIntegrationAdapterResponse'] = ResolversParentTypes['DisconnectIntegrationAdapterResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionBaseResult' | 'IntegrationAdapterConnectionAdminResult' | 'IntegrationAdapterConnectionNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterConnectionNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionNotFound'] = ResolversParentTypes['IntegrationAdapterConnectionNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EditBuyerReportScheduleResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditBuyerReportScheduleResponse'] = ResolversParentTypes['EditBuyerReportScheduleResponse']> = {
  __resolveType: TypeResolveFn<'BuyerReportSchedule' | 'BuyerReportScheduleNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GenerateBuyerReportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateBuyerReportResponse'] = ResolversParentTypes['GenerateBuyerReportResponse']> = {
  __resolveType: TypeResolveFn<'BuyerReport' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type GetClientDebuggableArtifactUploadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetClientDebuggableArtifactUploadUrlResponse'] = ResolversParentTypes['GetClientDebuggableArtifactUploadUrlResponse']> = {
  __resolveType: TypeResolveFn<'GetClientDebuggableArtifactUploadUrl' | 'GetClientDebuggableArtifactUploadUrlError', ParentType, ContextType>;
};

export type GetClientDebuggableArtifactUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetClientDebuggableArtifactUploadUrl'] = ResolversParentTypes['GetClientDebuggableArtifactUploadUrl']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetClientDebuggableArtifactUploadUrlErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetClientDebuggableArtifactUploadUrlError'] = ResolversParentTypes['GetClientDebuggableArtifactUploadUrlError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOrderGuideUploadUrlResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrderGuideUploadUrlResponse'] = ResolversParentTypes['GetOrderGuideUploadUrlResponse']> = {
  __resolveType: TypeResolveFn<'GetOrderGuideUploadUrl' | 'GetOrderGuideUploadUrlError', ParentType, ContextType>;
};

export type GetOrderGuideUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrderGuideUploadUrl'] = ResolversParentTypes['GetOrderGuideUploadUrl']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetOrderGuideUploadUrlErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetOrderGuideUploadUrlError'] = ResolversParentTypes['GetOrderGuideUploadUrlError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportSupplierProductsReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportSupplierProductsReport'] = ResolversParentTypes['ImportSupplierProductsReport']> = {
  new?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invalid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unchanged?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitInventoryDownloadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryDownloadResponse'] = ResolversParentTypes['InitInventoryDownloadResponse']> = {
  __resolveType: TypeResolveFn<'InitInventoryDownloadSuccess' | 'InitInventoryDownloadFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type InitInventoryDownloadSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryDownloadSuccess'] = ResolversParentTypes['InitInventoryDownloadSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitInventoryDownloadFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryDownloadFailure'] = ResolversParentTypes['InitInventoryDownloadFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitInventoryUploadResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryUploadResponse'] = ResolversParentTypes['InitInventoryUploadResponse']> = {
  __resolveType: TypeResolveFn<'InitInventoryUploadSuccess' | 'InitInventoryUploadFailure' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InitInventoryUploadSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryUploadSuccess'] = ResolversParentTypes['InitInventoryUploadSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  jobId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitInventoryUploadFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitInventoryUploadFailure'] = ResolversParentTypes['InitInventoryUploadFailure']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiateCheckoutResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiateCheckoutResponse'] = ResolversParentTypes['InitiateCheckoutResponse']> = {
  __resolveType: TypeResolveFn<'BalanceCheckoutToken' | 'SupplierPaymentAccountMissing' | 'InvoiceAlreadyPaid' | 'AuthorizationFailure' | 'InputValidationFailure' | 'InvoicePaymentInProgress' | 'InvoiceTotalTooLow', ParentType, ContextType>;
};

export type BalanceCheckoutTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['BalanceCheckoutToken'] = ResolversParentTypes['BalanceCheckoutToken']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstTimeCheckout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierPaymentAccountMissingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierPaymentAccountMissing'] = ResolversParentTypes['SupplierPaymentAccountMissing']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceAlreadyPaidResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceAlreadyPaid'] = ResolversParentTypes['InvoiceAlreadyPaid']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoicePaymentInProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoicePaymentInProgress'] = ResolversParentTypes['InvoicePaymentInProgress']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceTotalTooLowResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceTotalTooLow'] = ResolversParentTypes['InvoiceTotalTooLow']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionAuthResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionAuthResponse'] = ResolversParentTypes['IntegrationAdapterConnectionAuthResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionAuthRedirect' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterConnectionAuthRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionAuthRedirect'] = ResolversParentTypes['IntegrationAdapterConnectionAuthRedirect']> = {
  redirectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionConsentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionConsentResponse'] = ResolversParentTypes['IntegrationAdapterConnectionConsentResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionConsentChallenge' | 'IntegrationAdapterConnectionConsentRedirect' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterConnectionConsentChallengeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionConsentChallenge'] = ResolversParentTypes['IntegrationAdapterConnectionConsentChallenge']> = {
  consentChallenge?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestedScopes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  adapterId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionConsentRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionConsentRedirect'] = ResolversParentTypes['IntegrationAdapterConnectionConsentRedirect']> = {
  redirectUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connectionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionCreateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionCreateResponse'] = ResolversParentTypes['IntegrationAdapterConnectionCreateResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionAdminResult' | 'UnsupportedIntegrationAdapterType' | 'ChocoEntityNotFound' | 'IntegrationAdapterNotFound' | 'IntegrationAdapterScopeInsufficient' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterScopeInsufficientResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterScopeInsufficient'] = ResolversParentTypes['IntegrationAdapterScopeInsufficient']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterConnectionUpdateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterConnectionUpdateResponse'] = ResolversParentTypes['IntegrationAdapterConnectionUpdateResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterConnectionAdminResult' | 'IntegrationAdapterConnectionNotFound' | 'IntegrationAdapterScopeInsufficient' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterCreateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterCreateResponse'] = ResolversParentTypes['IntegrationAdapterCreateResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterAdminResult' | 'IntegrationAdapterExists' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationAdapterExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterExists'] = ResolversParentTypes['IntegrationAdapterExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationAdapterUpdateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationAdapterUpdateResponse'] = ResolversParentTypes['IntegrationAdapterUpdateResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationAdapterAdminResult' | 'IntegrationAdapterNotFound' | 'AttemptToChangeAdapterAuthType' | 'AttemptToReduceIntegrationAdapterScope' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type AttemptToChangeAdapterAuthTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttemptToChangeAdapterAuthType'] = ResolversParentTypes['AttemptToChangeAdapterAuthType']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttemptToReduceIntegrationAdapterScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttemptToReduceIntegrationAdapterScope'] = ResolversParentTypes['AttemptToReduceIntegrationAdapterScope']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationWebhookRetryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWebhookRetryResponse'] = ResolversParentTypes['IntegrationWebhookRetryResponse']> = {
  __resolveType: TypeResolveFn<'IntegrationWebhookRetryResults' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type IntegrationWebhookRetryResultsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWebhookRetryResults'] = ResolversParentTypes['IntegrationWebhookRetryResults']> = {
  results?: Resolver<Array<ResolversTypes['IntegrationWebhookRetryResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationWebhookRetryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWebhookRetryResult'] = ResolversParentTypes['IntegrationWebhookRetryResult']> = {
  __resolveType: TypeResolveFn<'IntegrationWebhookRetrySuccess' | 'IntegrationWebhookRetryFailure', ParentType, ContextType>;
};

export type IntegrationWebhookRetrySuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWebhookRetrySuccess'] = ResolversParentTypes['IntegrationWebhookRetrySuccess']> = {
  entitySyncActionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntegrationWebhookRetryFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationWebhookRetryFailure'] = ResolversParentTypes['IntegrationWebhookRetryFailure']> = {
  entitySyncActionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  errorCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalInviteUsersResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalInviteUsersResponse'] = ResolversParentTypes['InternalInviteUsersResponse']> = {
  __resolveType: TypeResolveFn<'UsersList' | 'AuthorizationFailure' | 'ValidationError', ParentType, ContextType>;
};

export type UsersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersList'] = ResolversParentTypes['UsersList']> = {
  userIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteNonChocoUserToBuyerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['inviteNonChocoUserToBuyerResponse'] = ResolversParentTypes['inviteNonChocoUserToBuyerResponse']> = {
  __resolveType: TypeResolveFn<'BuyerUser' | 'BuyerNotFound' | 'InvitorNotFound' | 'ExistingInvitedUser' | 'PuppyValidationFailure', ParentType, ContextType>;
};

export type BuyerNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerNotFound'] = ResolversParentTypes['BuyerNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitorNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvitorNotFound'] = ResolversParentTypes['InvitorNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExistingInvitedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingInvitedUser'] = ResolversParentTypes['ExistingInvitedUser']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PuppyValidationFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['PuppyValidationFailure'] = ResolversParentTypes['PuppyValidationFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InviteUserToBuyerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteUserToBuyerResponse'] = ResolversParentTypes['InviteUserToBuyerResponse']> = {
  __resolveType: TypeResolveFn<'BuyerUser' | 'InviteUserToBuyerError' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type InviteUserToBuyerErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteUserToBuyerError'] = ResolversParentTypes['InviteUserToBuyerError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['InviteUserToBuyerErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycCreateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycCreateResponse'] = ResolversParentTypes['KycCreateResponse']> = {
  __resolveType: TypeResolveFn<'KycResponse' | 'KycBuyerNotFound' | 'KycEntryAlreadyExists' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type KycResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycResponse'] = ResolversParentTypes['KycResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  businessName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streetNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  administrativeAreaLevelOne?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycBuyerNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycBuyerNotFound'] = ResolversParentTypes['KycBuyerNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KycEntryAlreadyExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['KycEntryAlreadyExists'] = ResolversParentTypes['KycEntryAlreadyExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['Message'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCreatedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCreatedResponse'] = ResolversParentTypes['OrderCreatedResponse']> = {
  __resolveType: TypeResolveFn<'Order' | 'OrderCreatedError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderEditedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderEditedResponse'] = ResolversParentTypes['OrderEditedResponse']> = {
  __resolveType: TypeResolveFn<'Order' | 'OrderEditedError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderEditedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderEditedError'] = ResolversParentTypes['OrderEditedError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableProducts?: Resolver<Maybe<Array<ResolversTypes['UnavailableProductType']>>, ParentType, ContextType>;
  invalidProductIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  invalidBuyerProductIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderExportConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderExportConfig'] = ResolversParentTypes['OrderExportConfig']> = {
  orderExportFormat?: Resolver<ResolversTypes['OrderExportConfigFormat'], ParentType, ContextType>;
  orderExportUpload?: Resolver<ResolversTypes['OrderExportUploadOption'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideCreatedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideCreatedResponse'] = ResolversParentTypes['OrderGuideCreatedResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideCreatedSuccess' | 'OrderGuideCreatedError', ParentType, ContextType>;
};

export type OrderGuideCreatedSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideCreatedSuccess'] = ResolversParentTypes['OrderGuideCreatedSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideCreatedErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideCreatedError'] = ResolversParentTypes['OrderGuideCreatedError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideRequestResponse'] = ResolversParentTypes['OrderGuideRequestResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideRequest' | 'OrderGuideRequestError', ParentType, ContextType>;
};

export type OrderGuideRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideRequest'] = ResolversParentTypes['OrderGuideRequest']> = {
  requestId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderGuideRequestType'], ParentType, ContextType>;
  createOrderGuideMethod?: Resolver<ResolversTypes['OrderGuideRequestMethod'], ParentType, ContextType>;
  uploadedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  filesComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  requestRefId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideRequestErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideRequestError'] = ResolversParentTypes['OrderGuideRequestError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsAddResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsAddResponse'] = ResolversParentTypes['OrderGuideV2ItemUnitsAddResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideV2ItemUnitsAddResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsAddResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsAddResult'] = ResolversParentTypes['OrderGuideV2ItemUnitsAddResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderGuideV2ItemUnit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsRemoveResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsRemoveResponse'] = ResolversParentTypes['OrderGuideV2ItemUnitsRemoveResponse']> = {
  __resolveType: TypeResolveFn<'OrderGuideV2ItemUnitsRemoveResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderGuideV2ItemUnitsRemoveResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderGuideV2ItemUnitsRemoveResult'] = ResolversParentTypes['OrderGuideV2ItemUnitsRemoveResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAuthorizeResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAuthorizeResponse'] = ResolversParentTypes['PaymentAuthorizeResponse']> = {
  __resolveType: TypeResolveFn<'PostProcessing' | 'PreProcessing' | 'NoFurtherActionNeeded' | 'InputValidationFailure' | 'AuthorizationFailure' | 'PaymentAccountNotFound' | 'PaymentAccountIsInactive' | 'UnexpectedInvoiceState' | 'SupplierDoesNotAcceptOnlinePayments' | 'EntityCurrencyMismatch', ParentType, ContextType>;
};

export type PostProcessingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostProcessing'] = ResolversParentTypes['PostProcessing']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  processPaymentToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreProcessingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreProcessing'] = ResolversParentTypes['PreProcessing']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  redirectURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoFurtherActionNeededResolvers<ContextType = any, ParentType extends ResolversParentTypes['NoFurtherActionNeeded'] = ResolversParentTypes['NoFurtherActionNeeded']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentAccountIsInactiveResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountIsInactive'] = ResolversParentTypes['PaymentAccountIsInactive']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnexpectedInvoiceStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnexpectedInvoiceState'] = ResolversParentTypes['UnexpectedInvoiceState']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  current?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierDoesNotAcceptOnlinePaymentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierDoesNotAcceptOnlinePayments'] = ResolversParentTypes['SupplierDoesNotAcceptOnlinePayments']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityCurrencyMismatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityCurrencyMismatch'] = ResolversParentTypes['EntityCurrencyMismatch']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatedCategoryProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatedCategoryProduct'] = ResolversParentTypes['UpdatedCategoryProduct']> = {
  categoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferUserResponse'] = ResolversParentTypes['ReferUserResponse']> = {
  __resolveType: TypeResolveFn<'ReferUserResult' | 'ReferUserChatExists' | 'ReferUserReferralCodeNotFound' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type ReferUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferUserResult'] = ResolversParentTypes['ReferUserResult']> = {
  referredUserId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referrerUserId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referralCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chat?: Resolver<ResolversTypes['Chat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferUserChatExistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferUserChatExists'] = ResolversParentTypes['ReferUserChatExists']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReferUserReferralCodeNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReferUserReferralCodeNotFound'] = ResolversParentTypes['ReferUserReferralCodeNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OmnichannelOrdersSubcriptionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OmnichannelOrdersSubcriptionResponse'] = ResolversParentTypes['OmnichannelOrdersSubcriptionResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'OrderDeskNotification', ParentType, ContextType>;
};

export type OrderDeskNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskNotification'] = ResolversParentTypes['OrderDeskNotification']> = {
  supplierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  omnichannelOrder?: Resolver<ResolversTypes['OmnichannelOrder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RejectOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RejectOrderResponse'] = ResolversParentTypes['RejectOrderResponse']> = {
  __resolveType: TypeResolveFn<'OrderRejected' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrderRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderRejected'] = ResolversParentTypes['OrderRejected']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RejectOrdersByIdResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RejectOrdersByIdResponse'] = ResolversParentTypes['RejectOrdersByIdResponse']> = {
  __resolveType: TypeResolveFn<'OrdersRejected' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrdersRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRejected'] = ResolversParentTypes['OrdersRejected']> = {
  ids?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCcEmailFromChatsReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCCEmailFromChatsReport'] = ResolversParentTypes['RemoveCCEmailFromChatsReport']> = {
  numberOfChatsUpdated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveEmailFromBuyerReportScheduleResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveEmailFromBuyerReportScheduleResponse'] = ResolversParentTypes['RemoveEmailFromBuyerReportScheduleResponse']> = {
  __resolveType: TypeResolveFn<'EmailFromBuyerReportScheduleRemoved' | 'InputValidationFailure' | 'AuthorizationFailure' | 'EmailInBuyerReportScheduleNotFound' | 'BuyerReportScheduleNotFound', ParentType, ContextType>;
};

export type EmailFromBuyerReportScheduleRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailFromBuyerReportScheduleRemoved'] = ResolversParentTypes['EmailFromBuyerReportScheduleRemoved']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailInBuyerReportScheduleNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailInBuyerReportScheduleNotFound'] = ResolversParentTypes['EmailInBuyerReportScheduleNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveEntitiesFromGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveEntitiesFromGroupResponse'] = ResolversParentTypes['RemoveEntitiesFromGroupResponse']> = {
  __resolveType: TypeResolveFn<'RemoveEntitiesFromGroupResponseSuccess' | 'RemoveEntitiesFromGroupResponseError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type RemoveEntitiesFromGroupResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveEntitiesFromGroupResponseSuccess'] = ResolversParentTypes['RemoveEntitiesFromGroupResponseSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveEntitiesFromGroupResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveEntitiesFromGroupResponseError'] = ResolversParentTypes['RemoveEntitiesFromGroupResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['RemoveEntitiesFromGroupErrorCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveInvoiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveInvoiceResponse'] = ResolversParentTypes['RemoveInvoiceResponse']> = {
  __resolveType: TypeResolveFn<'InvoiceRemoved' | 'InputValidationFailure' | 'AuthorizationFailure' | 'InvoiceCannotBeRemoved', ParentType, ContextType>;
};

export type InvoiceRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceRemoved'] = ResolversParentTypes['InvoiceRemoved']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceCannotBeRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceCannotBeRemoved'] = ResolversParentTypes['InvoiceCannotBeRemoved']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveInvoiceAttachmentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveInvoiceAttachmentResponse'] = ResolversParentTypes['RemoveInvoiceAttachmentResponse']> = {
  __resolveType: TypeResolveFn<'InvoiceAttachmentRemoved' | 'InputValidationFailure' | 'AuthorizationFailure' | 'InvoiceCannotBeUpdated', ParentType, ContextType>;
};

export type InvoiceAttachmentRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceAttachmentRemoved'] = ResolversParentTypes['InvoiceAttachmentRemoved']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceCannotBeUpdatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoiceCannotBeUpdated'] = ResolversParentTypes['InvoiceCannotBeUpdated']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeskRemovedEmailResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskRemovedEmailResponse'] = ResolversParentTypes['OrderDeskRemovedEmailResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeskEmailRemoved' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type OrderDeskEmailRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeskEmailRemoved'] = ResolversParentTypes['OrderDeskEmailRemoved']> = {
  supplierId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrderDestEmailListType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemovePaymentAccountResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemovePaymentAccountResponse'] = ResolversParentTypes['RemovePaymentAccountResponse']> = {
  __resolveType: TypeResolveFn<'PaymentAccountRemoved' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type PaymentAccountRemovedResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentAccountRemoved'] = ResolversParentTypes['PaymentAccountRemoved']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveProductsFromOrderGuidesResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveProductsFromOrderGuidesResponse'] = ResolversParentTypes['RemoveProductsFromOrderGuidesResponse']> = {
  __resolveType: TypeResolveFn<'RemoveProductsFromOrderGuidesResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type RemoveProductsFromOrderGuidesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveProductsFromOrderGuidesResult'] = ResolversParentTypes['RemoveProductsFromOrderGuidesResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['LocationProductsResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MinimumOrderValueUpdateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinimumOrderValueUpdateResponse'] = ResolversParentTypes['MinimumOrderValueUpdateResponse']> = {
  __resolveType: TypeResolveFn<'MinimumOrderValueUpdate' | 'MinimumOrderValueFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type MinimumOrderValueUpdateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MinimumOrderValueUpdate'] = ResolversParentTypes['MinimumOrderValueUpdate']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveUsersFromGroupResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUsersFromGroupResponse'] = ResolversParentTypes['RemoveUsersFromGroupResponse']> = {
  __resolveType: TypeResolveFn<'RemoveUsersFromGroupSuccess' | 'RemoveUsersFromGroupError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type RemoveUsersFromGroupSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUsersFromGroupSuccess'] = ResolversParentTypes['RemoveUsersFromGroupSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveUsersFromGroupErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveUsersFromGroupError'] = ResolversParentTypes['RemoveUsersFromGroupError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestToJoinBuyerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestToJoinBuyerResponse'] = ResolversParentTypes['RequestToJoinBuyerResponse']> = {
  __resolveType: TypeResolveFn<'UserRequestToJoin' | 'RequestToJoinBuyerError' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type RequestToJoinBuyerErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestToJoinBuyerError'] = ResolversParentTypes['RequestToJoinBuyerError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['RequestToJoinBuyerErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectProductForOrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectProductForOrderGuideResponse'] = ResolversParentTypes['SelectProductForOrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'SelectProductForOrderGuideSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SelectProductForOrderGuideSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectProductForOrderGuideSuccess'] = ResolversParentTypes['SelectProductForOrderGuideSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelectProductsForOrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectProductsForOrderGuideResponse'] = ResolversParentTypes['SelectProductsForOrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'SelectProductsForOrderGuideSuccess' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SelectProductsForOrderGuideSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelectProductsForOrderGuideSuccess'] = ResolversParentTypes['SelectProductsForOrderGuideSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  invalidProducts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendInviteTransmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendInviteTransmissionResponse'] = ResolversParentTypes['SendInviteTransmissionResponse']> = {
  __resolveType: TypeResolveFn<'InviteTransmission' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type SendSyntheticSmsMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSyntheticSmsMessageResponse'] = ResolversParentTypes['SendSyntheticSmsMessageResponse']> = {
  __resolveType: TypeResolveFn<'SendSyntheticSmsMessageSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SendSyntheticSmsMessageSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSyntheticSmsMessageSuccess'] = ResolversParentTypes['SendSyntheticSmsMessageSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  messageSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendSyntheticWhatsAppMessageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSyntheticWhatsAppMessageResponse'] = ResolversParentTypes['SendSyntheticWhatsAppMessageResponse']> = {
  __resolveType: TypeResolveFn<'SendSyntheticWhatsAppMessageSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SendSyntheticWhatsAppMessageSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSyntheticWhatsAppMessageSuccess'] = ResolversParentTypes['SendSyntheticWhatsAppMessageSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  messageSid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetOrderAsTestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetOrderAsTestResponse'] = ResolversParentTypes['SetOrderAsTestResponse']> = {
  __resolveType: TypeResolveFn<'TestOrderResponse' | 'InputValidationFailure', ParentType, ContextType>;
};

export type TestOrderResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestOrderResponse'] = ResolversParentTypes['TestOrderResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartSubmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSubmissionResponse'] = ResolversParentTypes['CartSubmissionResponse']> = {
  __resolveType: TypeResolveFn<'CartSubmissionResult' | 'CartSubmissionError' | 'CreateMessageError' | 'CartNotFoundError' | 'CartSubmittedEmptyError' | 'CartVersionConstraintError' | 'CartInvalidProductsError' | 'CartAllProductsUnavailableError' | 'AuthorizationFailure' | 'ForbiddenError' | 'InputValidationFailure' | 'ExistingOrderError' | 'ProductLeadTimeError', ParentType, ContextType>;
};

export type CartSubmissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSubmissionResult'] = ResolversParentTypes['CartSubmissionResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartSubmissionErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSubmissionError'] = ResolversParentTypes['CartSubmissionError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMessageErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMessageError'] = ResolversParentTypes['CreateMessageError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartSubmittedEmptyErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartSubmittedEmptyError'] = ResolversParentTypes['CartSubmittedEmptyError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartInvalidProductsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartInvalidProductsError'] = ResolversParentTypes['CartInvalidProductsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invalidProductCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartAllProductsUnavailableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartAllProductsUnavailableError'] = ResolversParentTypes['CartAllProductsUnavailableError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableProductCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForbiddenErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForbiddenError'] = ResolversParentTypes['ForbiddenError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExistingOrderErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExistingOrderError'] = ResolversParentTypes['ExistingOrderError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductLeadTimeErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductLeadTimeError'] = ResolversParentTypes['ProductLeadTimeError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invalidProductIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDeliveryCheckSubmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckSubmissionResponse'] = ResolversParentTypes['OrderDeliveryCheckSubmissionResponse']> = {
  __resolveType: TypeResolveFn<'OrderDeliveryCheckDetails' | 'InputValidationFailure' | 'OrderDeliveryCheckAlreadyCompleted' | 'OrderNotFound' | 'OrderDeliveryItemsMismatched' | 'OrderDeliveryCheckNotFound' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type OrderDeliveryCheckNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDeliveryCheckNotFound'] = ResolversParentTypes['OrderDeliveryCheckNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderedProductDeliveryCheckSubmissionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderedProductDeliveryCheckSubmissionResponse'] = ResolversParentTypes['OrderedProductDeliveryCheckSubmissionResponse']> = {
  __resolveType: TypeResolveFn<'OrderedProductDeliveryCheck' | 'InputValidationFailure' | 'OrderNotFound' | 'OrderDeliveryItemsMismatched' | 'OrderDeliveryCheckAlreadyCompleted' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type SubmitStockCountSessionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitStockCountSessionResponse'] = ResolversParentTypes['SubmitStockCountSessionResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'InputValidationFailure' | 'SubmitStockCountSessionFailure' | 'SubmitStockCountSessionSuccess', ParentType, ContextType>;
};

export type SubmitStockCountSessionFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitStockCountSessionFailure'] = ResolversParentTypes['SubmitStockCountSessionFailure']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmitStockCountSessionSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmitStockCountSessionSuccess'] = ResolversParentTypes['SubmitStockCountSessionSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierAddRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierAddRequestResponse'] = ResolversParentTypes['SupplierAddRequestResponse']> = {
  __resolveType: TypeResolveFn<'SupplierAddRequest' | 'SupplierAddRequestError', ParentType, ContextType>;
};

export type SupplierAddRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierAddRequest'] = ResolversParentTypes['SupplierAddRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  buyerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplierCompanyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  existingCustomer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createOrderGuideMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepPhoneCallNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepTextNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRepWhatsAppNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderDeskEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderDeskPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderDeskFaxNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordersUsingWebShop?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  filesComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  supplierRefId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createChat?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestRefId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chat?: Resolver<Maybe<ResolversTypes['UserChatEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierAddRequestErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierAddRequestError'] = ResolversParentTypes['SupplierAddRequestError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierGetInTouchRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierGetInTouchRequestResponse'] = ResolversParentTypes['SupplierGetInTouchRequestResponse']> = {
  __resolveType: TypeResolveFn<'SupplierGetInTouchRequestSuccess' | 'SupplierGetInTouchRequestError', ParentType, ContextType>;
};

export type SupplierGetInTouchRequestSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierGetInTouchRequestSuccess'] = ResolversParentTypes['SupplierGetInTouchRequestSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['SupplierUpdateError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUpdateErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUpdateError'] = ResolversParentTypes['SupplierUpdateError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierGetInTouchRequestErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierGetInTouchRequestError'] = ResolversParentTypes['SupplierGetInTouchRequestError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierInviteUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierInviteUserResponse'] = ResolversParentTypes['SupplierInviteUserResponse']> = {
  chatUsers?: Resolver<Array<Maybe<ResolversTypes['ChatUser']>>, ParentType, ContextType>;
  inviteResponse?: Resolver<Array<Maybe<ResolversTypes['SupplierInviteResponseEntity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierInviteResponseEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierInviteResponseEntity'] = ResolversParentTypes['SupplierInviteResponseEntity']> = {
  __resolveType: TypeResolveFn<'User' | 'Chat' | 'InvalidInvitedPhoneNumber' | 'SupplierInviteError', ParentType, ContextType>;
};

export type InvalidInvitedPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidInvitedPhoneNumber'] = ResolversParentTypes['InvalidInvitedPhoneNumber']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierInviteErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierInviteError'] = ResolversParentTypes['SupplierInviteError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUserRemoveResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUserRemoveResponse'] = ResolversParentTypes['SupplierUserRemoveResponse']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TriggerProductMatchingResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TriggerProductMatchingResponse'] = ResolversParentTypes['TriggerProductMatchingResponse']> = {
  __resolveType: TypeResolveFn<'OmnichannelOrder' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type UnassignUserFromOrderToReviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnassignUserFromOrderToReviewResponse'] = ResolversParentTypes['UnassignUserFromOrderToReviewResponse']> = {
  __resolveType: TypeResolveFn<'UnassignUserFromOrderToReviewResponseSuccess' | 'UnassignUserFromOrderToReviewResponseError', ParentType, ContextType>;
};

export type UnassignUserFromOrderToReviewResponseSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnassignUserFromOrderToReviewResponseSuccess'] = ResolversParentTypes['UnassignUserFromOrderToReviewResponseSuccess']> = {
  omnichannelOrderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnassignUserFromOrderToReviewResponseErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnassignUserFromOrderToReviewResponseError'] = ResolversParentTypes['UnassignUserFromOrderToReviewResponseError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UndoMultiLocationOrderGuideTransactionResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndoMultiLocationOrderGuideTransactionResponse'] = ResolversParentTypes['UndoMultiLocationOrderGuideTransactionResponse']> = {
  __resolveType: TypeResolveFn<'UndoMultiLocationOrderGuideTransactionResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UndoMultiLocationOrderGuideTransactionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UndoMultiLocationOrderGuideTransactionResult'] = ResolversParentTypes['UndoMultiLocationOrderGuideTransactionResult']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  succeededLocationIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  failedLocationIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateBuyerInventoryProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBuyerInventoryProductResponse'] = ResolversParentTypes['UpdateBuyerInventoryProductResponse']> = {
  __resolveType: TypeResolveFn<'BuyerInventoryProduct' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateBuyerStockInventoryProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBuyerStockInventoryProductResponse'] = ResolversParentTypes['UpdateBuyerStockInventoryProductResponse']> = {
  __resolveType: TypeResolveFn<'AuthorizationFailure' | 'BuyerStockInventoryProduct' | 'InputValidationFailure' | 'ProductNotFoundError' | 'SupplierNotFound' | 'UpdateBuyerStockInventoryProductFailure', ParentType, ContextType>;
};

export type UpdateBuyerStockInventoryProductFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBuyerStockInventoryProductFailure'] = ResolversParentTypes['UpdateBuyerStockInventoryProductFailure']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartUpdateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartUpdateResponse'] = ResolversParentTypes['CartUpdateResponse']> = {
  __resolveType: TypeResolveFn<'Cart' | 'CartNotFoundError' | 'NegativeAmountError' | 'AuthorizationFailure' | 'InputValidationFailure', ParentType, ContextType>;
};

export type NegativeAmountErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['NegativeAmountError'] = ResolversParentTypes['NegativeAmountError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateInventoryItemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateInventoryItemResponse'] = ResolversParentTypes['UpdateInventoryItemResponse']> = {
  __resolveType: TypeResolveFn<'UpdateInventoryItemSuccess' | 'UpdateInventoryItemFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateInventoryItemSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateInventoryItemSuccess'] = ResolversParentTypes['UpdateInventoryItemSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  inventoryItem?: Resolver<ResolversTypes['InventoryItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateInventoryItemFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateInventoryItemFailure'] = ResolversParentTypes['UpdateInventoryItemFailure']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateInvoiceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateInvoiceResponse'] = ResolversParentTypes['UpdateInvoiceResponse']> = {
  __resolveType: TypeResolveFn<'Invoice' | 'InputValidationFailure' | 'AuthorizationFailure' | 'InvoiceCannotBeUpdated', ParentType, ContextType>;
};

export type UpdateInvoicedProductResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateInvoicedProductResponse'] = ResolversParentTypes['UpdateInvoicedProductResponse']> = {
  __resolveType: TypeResolveFn<'InvoicedProducts' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type InvoicedProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvoicedProducts'] = ResolversParentTypes['InvoicedProducts']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  invoicedProducts?: Resolver<Array<ResolversTypes['InvoicedProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePendingUserResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePendingUserResponse'] = ResolversParentTypes['UpdatePendingUserResponse']> = {
  __resolveType: TypeResolveFn<'User' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateProductVariantsInOrderGuideResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProductVariantsInOrderGuideResponse'] = ResolversParentTypes['UpdateProductVariantsInOrderGuideResponse']> = {
  __resolveType: TypeResolveFn<'UpdateProductVariantsInOrderGuideSuccess' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateProductVariantsInOrderGuideSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProductVariantsInOrderGuideSuccess'] = ResolversParentTypes['UpdateProductVariantsInOrderGuideSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  invalidProducts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateJoinRequestResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateJoinRequestResponse'] = ResolversParentTypes['UpdateJoinRequestResponse']> = {
  __resolveType: TypeResolveFn<'UpdateJoinRequestSuccess' | 'UpdateJoinRequestError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateJoinRequestSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateJoinRequestSuccess'] = ResolversParentTypes['UpdateJoinRequestSuccess']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JoinRequestAllowedUpdateStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateJoinRequestErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateJoinRequestError'] = ResolversParentTypes['UpdateJoinRequestError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['UpdateJoinRequestErrorCode']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateStorageItemResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStorageItemResponse'] = ResolversParentTypes['UpdateStorageItemResponse']> = {
  __resolveType: TypeResolveFn<'UpdateStorageItemSuccess' | 'UpdateStorageItemFailure' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateStorageItemSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStorageItemSuccess'] = ResolversParentTypes['UpdateStorageItemSuccess']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  storageItem?: Resolver<ResolversTypes['StorageItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateStorageItemFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateStorageItemFailure'] = ResolversParentTypes['UpdateStorageItemFailure']> = {
  responseType?: Resolver<Maybe<ResolversTypes['ResponseType']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSubCatalogResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['updateSubCatalogResponse'] = ResolversParentTypes['updateSubCatalogResponse']> = {
  __resolveType: TypeResolveFn<'SubCatalog' | 'UpdateSubCatalogError', ParentType, ContextType>;
};

export type UpdateSubCatalogErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSubCatalogError'] = ResolversParentTypes['UpdateSubCatalogError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSubCatalogChatsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSubCatalogChatsResponse'] = ResolversParentTypes['UpdateSubCatalogChatsResponse']> = {
  __resolveType: TypeResolveFn<'UpdateSubCatalogChatsResult' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpdateSubCatalogChatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSubCatalogChatsResult'] = ResolversParentTypes['UpdateSubCatalogChatsResult']> = {
  subCatalogChats?: Resolver<Maybe<ResolversTypes['UpdateSubCatalogChatsSummary']>, ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['InvalidSubCatalogChat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateSubCatalogChatsSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSubCatalogChatsSummary'] = ResolversParentTypes['UpdateSubCatalogChatsSummary']> = {
  created?: Resolver<Array<ResolversTypes['SubCatalogChat']>, ParentType, ContextType>;
  removed?: Resolver<Array<ResolversTypes['SubCatalogChat']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubCatalogChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCatalogChat'] = ResolversParentTypes['SubCatalogChat']> = {
  subCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['EntityIdentity']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EntityIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['EntityIdentity'] = ResolversParentTypes['EntityIdentity']> = {
  __resolveType: TypeResolveFn<'IntegrationEntityIdentity' | 'InternalEntityIdentity', ParentType, ContextType>;
};

export type IntegrationEntityIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationEntityIdentity'] = ResolversParentTypes['IntegrationEntityIdentity']> = {
  integrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IntegrationEntityIdentityType'], ParentType, ContextType>;
  appName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalEntityIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalEntityIdentity'] = ResolversParentTypes['InternalEntityIdentity']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['InternalEntityIdentityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidSubCatalogChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidSubCatalogChat'] = ResolversParentTypes['InvalidSubCatalogChat']> = {
  subCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUpdateAccessPackageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUpdateAccessPackageResponse'] = ResolversParentTypes['SupplierUpdateAccessPackageResponse']> = {
  __resolveType: TypeResolveFn<'SupplierUpdateAccessPackageSuccess' | 'SupplierUpdateAccessPackageError', ParentType, ContextType>;
};

export type SupplierUpdateAccessPackageSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUpdateAccessPackageSuccess'] = ResolversParentTypes['SupplierUpdateAccessPackageSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['SupplierUpdateError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUpdateAccessPackageErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUpdateAccessPackageError'] = ResolversParentTypes['SupplierUpdateAccessPackageError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierUserUpdateChatsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierUserUpdateChatsResponse'] = ResolversParentTypes['SupplierUserUpdateChatsResponse']> = {
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addedTo?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  removedFrom?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadSubCatalogProductsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSubCatalogProductsResponse'] = ResolversParentTypes['UploadSubCatalogProductsResponse']> = {
  __resolveType: TypeResolveFn<'UploadSubCatalogProductsResult' | 'UploadSubCatalogProductsError', ParentType, ContextType>;
};

export type UploadSubCatalogProductsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSubCatalogProductsResult'] = ResolversParentTypes['UploadSubCatalogProductsResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  submittedProductsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadSubCatalogProductsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadSubCatalogProductsError'] = ResolversParentTypes['UploadSubCatalogProductsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpsertStockCountSessionItemsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertStockCountSessionItemsResponse'] = ResolversParentTypes['UpsertStockCountSessionItemsResponse']> = {
  __resolveType: TypeResolveFn<'UpsertStockCountSessionItemsSuccess' | 'UpsertStockCountSessionItemsError' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UpsertStockCountSessionItemsSuccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertStockCountSessionItemsSuccess'] = ResolversParentTypes['UpsertStockCountSessionItemsSuccess']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  stockCountSessionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpsertStockCountSessionItemsErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertStockCountSessionItemsError'] = ResolversParentTypes['UpsertStockCountSessionItemsError']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLeadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLead'] = ResolversParentTypes['UserLead']> = {
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requests?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserLeadRequest']>>>, ParentType, ContextType>;
  requestCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLeadRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLeadRequest'] = ResolversParentTypes['UserLeadRequest']> = {
  createdAt?: Resolver<ResolversTypes['AWSTimestamp'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referrer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRequestToDeleteResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRequestToDeleteResponse'] = ResolversParentTypes['UserRequestToDeleteResponse']> = {
  __resolveType: TypeResolveFn<'UserRequestToDeleteDetails' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type UserRequestToDeleteDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRequestToDeleteDetails'] = ResolversParentTypes['UserRequestToDeleteDetails']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorItemUnitUpdateResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnitUpdateResponse'] = ResolversParentTypes['VendorItemUnitUpdateResponse']> = {
  __resolveType: TypeResolveFn<'VendorItemUnitUpdateResult' | 'InputValidationFailure' | 'AuthorizationFailure', ParentType, ContextType>;
};

export type VendorItemUnitUpdateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorItemUnitUpdateResult'] = ResolversParentTypes['VendorItemUnitUpdateResult']> = {
  unit?: Resolver<ResolversTypes['VendorItemUnit'], ParentType, ContextType>;
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  omnichannelOrdersSubcription?: SubscriptionResolver<Maybe<ResolversTypes['OmnichannelOrdersSubcriptionResponse']>, "omnichannelOrdersSubcription", ParentType, ContextType, RequireFields<SubscriptionOmnichannelOrdersSubcriptionArgs, 'supplierId'>>;
  onNotificationCreate?: SubscriptionResolver<Maybe<ResolversTypes['Notification']>, "onNotificationCreate", ParentType, ContextType, Partial<SubscriptionOnNotificationCreateArgs>>;
};

export interface AwsipAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface AwsPhoneScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export type ActivateChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateChatResponse'] = ResolversParentTypes['ActivateChatResponse']> = {
  __resolveType: TypeResolveFn<'Chat', ParentType, ContextType>;
};

export type BuyerChatsNotFoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerChatsNotFound'] = ResolversParentTypes['BuyerChatsNotFound']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerChatsProductListEmptyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerChatsProductListEmpty'] = ResolversParentTypes['BuyerChatsProductListEmpty']> = {
  responseType?: Resolver<ResolversTypes['ResponseType'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyerChatsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyerChatsResponse'] = ResolversParentTypes['BuyerChatsResponse']> = {
  __resolveType: TypeResolveFn<'BuyerChatConnection' | 'InvalidCursor', ParentType, ContextType>;
};

export type ContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = {
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  Image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderResult'] = ResolversParentTypes['OrderResult']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderProduct']>>>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderSupplierStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['AWSTimestamp']>, ParentType, ContextType>;
  supplierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  restaurant?: Resolver<Maybe<ResolversTypes['OrderRestaurant']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConnection'] = ResolversParentTypes['ProductConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProductEdge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductEdge'] = ResolversParentTypes['ProductEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Product'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductMatchDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductMatchData'] = ResolversParentTypes['ProductMatchData']> = {
  products?: Resolver<Array<ResolversTypes['OmnichannelOrderProduct']>, ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupplierContactAlreadyCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupplierContactAlreadyCreated'] = ResolversParentTypes['SupplierContactAlreadyCreated']> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Query?: QueryResolvers<ContextType>;
  BlockedEmail?: BlockedEmailResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  AWSTimestamp?: GraphQLScalarType;
  BlockedEmailConnection?: BlockedEmailConnectionResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  Edge?: EdgeResolvers<ContextType>;
  BlockedEmailEdge?: BlockedEmailEdgeResolvers<ContextType>;
  Broadcast?: BroadcastResolvers<ContextType>;
  BroadcastAnalytics?: BroadcastAnalyticsResolvers<ContextType>;
  BroadcastMediaAttachment?: BroadcastMediaAttachmentResolvers<ContextType>;
  BroadcastMedia?: BroadcastMediaResolvers<ContextType>;
  BroadcastPdfMedia?: BroadcastPdfMediaResolvers<ContextType>;
  Chat?: ChatResolvers<ContextType>;
  Buyer?: BuyerResolvers<ContextType>;
  BuyerUserConnection?: BuyerUserConnectionResolvers<ContextType>;
  BuyerUserEdge?: BuyerUserEdgeResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserBuyerConnection?: UserBuyerConnectionResolvers<ContextType>;
  UserBuyerEdge?: UserBuyerEdgeResolvers<ContextType>;
  UserChatConnection?: UserChatConnectionResolvers<ContextType>;
  UserChatEdge?: UserChatEdgeResolvers<ContextType>;
  UserUserConnection?: UserUserConnectionResolvers<ContextType>;
  UserUserEdge?: UserUserEdgeResolvers<ContextType>;
  OrderPreference?: OrderPreferenceResolvers<ContextType>;
  ProfileImage?: ProfileImageResolvers<ContextType>;
  Supplier?: SupplierResolvers<ContextType>;
  MinimumOrderValueResponse?: MinimumOrderValueResponseResolvers<ContextType>;
  MinimumOrderValue?: MinimumOrderValueResolvers<ContextType>;
  MinOrder?: MinOrderResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  MinimumOrderValueFailure?: MinimumOrderValueFailureResolvers<ContextType>;
  AuthorizationFailure?: AuthorizationFailureResolvers<ContextType>;
  AppsyncResponse?: AppsyncResponseResolvers<ContextType>;
  AppsyncError?: AppsyncErrorResolvers<ContextType>;
  InputValidationFailure?: InputValidationFailureResolvers<ContextType>;
  FieldValidationError?: FieldValidationErrorResolvers<ContextType>;
  AWSEmail?: GraphQLScalarType;
  SupplierDeliverySetting?: SupplierDeliverySettingResolvers<ContextType>;
  CutOffTime?: CutOffTimeResolvers<ContextType>;
  AWSTime?: GraphQLScalarType;
  WeekdayBasedCutoffSettings?: WeekdayBasedCutoffSettingsResolvers<ContextType>;
  CutoffSetting?: CutoffSettingResolvers<ContextType>;
  NoCutoffSetting?: NoCutoffSettingResolvers<ContextType>;
  WithCutoffSetting?: WithCutoffSettingResolvers<ContextType>;
  DeliverySettingException?: DeliverySettingExceptionResolvers<ContextType>;
  SingleDayDeliveryExceptionWithCutoff?: SingleDayDeliveryExceptionWithCutoffResolvers<ContextType>;
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  SingleDayDeliveryExceptionWithoutCutoff?: SingleDayDeliveryExceptionWithoutCutoffResolvers<ContextType>;
  NoDeliveryException?: NoDeliveryExceptionResolvers<ContextType>;
  DeliveryZone?: DeliveryZoneResolvers<ContextType>;
  Coordinate?: CoordinateResolvers<ContextType>;
  IntegrationOption?: IntegrationOptionResolvers<ContextType>;
  IntegrationSmsOption?: IntegrationSmsOptionResolvers<ContextType>;
  IntegrationEmailOption?: IntegrationEmailOptionResolvers<ContextType>;
  IntegrationFaxOption?: IntegrationFaxOptionResolvers<ContextType>;
  IntegrationWhatsAppOption?: IntegrationWhatsAppOptionResolvers<ContextType>;
  OrderExportConfigFormat?: OrderExportConfigFormatResolvers<ContextType>;
  OrderExportConfigCsvFormat?: OrderExportConfigCsvFormatResolvers<ContextType>;
  OrderExportConfigEdiFormat?: OrderExportConfigEdiFormatResolvers<ContextType>;
  OrderExportChocoEdiFormat?: OrderExportChocoEdiFormatResolvers<ContextType>;
  OrderExportSupplierEdiFormat?: OrderExportSupplierEdiFormatResolvers<ContextType>;
  OrderExportConfigLobsterFormat?: OrderExportConfigLobsterFormatResolvers<ContextType>;
  OrderExportUploadOption?: OrderExportUploadOptionResolvers<ContextType>;
  OrderExportChocoSftpUpload?: OrderExportChocoSftpUploadResolvers<ContextType>;
  OrderExportExternalSftpUpload?: OrderExportExternalSftpUploadResolvers<ContextType>;
  OrderExportLobsterUpload?: OrderExportLobsterUploadResolvers<ContextType>;
  ListPaymentAccountsResponse?: ListPaymentAccountsResponseResolvers<ContextType>;
  PaymentAccountsList?: PaymentAccountsListResolvers<ContextType>;
  PaymentAccount?: PaymentAccountResolvers<ContextType>;
  PaymentAccountPsp?: PaymentAccountPspResolvers<ContextType>;
  PaymentAccountDetails?: PaymentAccountDetailsResolvers<ContextType>;
  BankAccountDetails?: BankAccountDetailsResolvers<ContextType>;
  CreditCardDetails?: CreditCardDetailsResolvers<ContextType>;
  BalanceVendorBankDetails?: BalanceVendorBankDetailsResolvers<ContextType>;
  BalanceBuyerBankDetails?: BalanceBuyerBankDetailsResolvers<ContextType>;
  WalletDetails?: WalletDetailsResolvers<ContextType>;
  PayoutDetails?: PayoutDetailsResolvers<ContextType>;
  PriceSetting?: PriceSettingResolvers<ContextType>;
  SupplierUserConnection?: SupplierUserConnectionResolvers<ContextType>;
  SupplierUserEdge?: SupplierUserEdgeResolvers<ContextType>;
  InviteInfo?: InviteInfoResolvers<ContextType>;
  GetReferralResponse?: GetReferralResponseResolvers<ContextType>;
  Referral?: ReferralResolvers<ContextType>;
  NotFoundError?: NotFoundErrorResolvers<ContextType>;
  InviteTransmission?: InviteTransmissionResolvers<ContextType>;
  TransmissionEvent?: TransmissionEventResolvers<ContextType>;
  AWSJSON?: GraphQLScalarType;
  BuyerChatConnection?: BuyerChatConnectionResolvers<ContextType>;
  BuyerChatEdge?: BuyerChatEdgeResolvers<ContextType>;
  Kyc?: KycResolvers<ContextType>;
  Cart?: CartResolvers<ContextType>;
  CartLineItem?: CartLineItemResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductCategory?: ProductCategoryResolvers<ContextType>;
  ProductDeliveryDateCondition?: ProductDeliveryDateConditionResolvers<ContextType>;
  AWSURL?: GraphQLScalarType;
  ProductImage?: ProductImageResolvers<ContextType>;
  BuyerInventoryProduct?: BuyerInventoryProductResolvers<ContextType>;
  SupplierNegotiatedPrice?: SupplierNegotiatedPriceResolvers<ContextType>;
  DerivedPriceForOrderGuideResponse?: DerivedPriceForOrderGuideResponseResolvers<ContextType>;
  DerivedPriceForOrderGuide?: DerivedPriceForOrderGuideResolvers<ContextType>;
  IsSelectedInOrderGuideResponse?: IsSelectedInOrderGuideResponseResolvers<ContextType>;
  IsSelectedInOrderGuide?: IsSelectedInOrderGuideResolvers<ContextType>;
  CartProductMetadata?: CartProductMetadataResolvers<ContextType>;
  ChatChurn?: ChatChurnResolvers<ContextType>;
  CreatedBy?: CreatedByResolvers<ContextType>;
  SupplierDeliveryDateSettings?: SupplierDeliveryDateSettingsResolvers<ContextType>;
  AvailableDeliveryDate?: AvailableDeliveryDateResolvers<ContextType>;
  ChatMessageConnection?: ChatMessageConnectionResolvers<ContextType>;
  ChatMessageEdge?: ChatMessageEdgeResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderInvoice?: OrderInvoiceResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  InvoiceFileUrls?: InvoiceFileUrlsResolvers<ContextType>;
  InvoiceAttachment?: InvoiceAttachmentResolvers<ContextType>;
  CurrentPaymentResponse?: CurrentPaymentResponseResolvers<ContextType>;
  PaymentResponse?: PaymentResponseResolvers<ContextType>;
  PaymentAccountResponse?: PaymentAccountResponseResolvers<ContextType>;
  SecuredPaymentAccount?: SecuredPaymentAccountResolvers<ContextType>;
  PaymentAccountNotFound?: PaymentAccountNotFoundResolvers<ContextType>;
  InvoiceHasNoPayment?: InvoiceHasNoPaymentResolvers<ContextType>;
  OrderHasNoInvoice?: OrderHasNoInvoiceResolvers<ContextType>;
  OrderHasOnlyAttachment?: OrderHasOnlyAttachmentResolvers<ContextType>;
  InvoicedProduct?: InvoicedProductResolvers<ContextType>;
  OmnichannelOrder?: OmnichannelOrderResolvers<ContextType>;
  ParsedOrder?: ParsedOrderResolvers<ContextType>;
  OmnichannelProduct?: OmnichannelProductResolvers<ContextType>;
  OmnichannelOrderProduct?: OmnichannelOrderProductResolvers<ContextType>;
  OmnichannelOrderAttachment?: OmnichannelOrderAttachmentResolvers<ContextType>;
  AudioTranscript?: AudioTranscriptResolvers<ContextType>;
  Word?: WordResolvers<ContextType>;
  StartOffSet?: StartOffSetResolvers<ContextType>;
  OrderDeskReviewer?: OrderDeskReviewerResolvers<ContextType>;
  OrderChangeResponse?: OrderChangeResponseResolvers<ContextType>;
  OrderChange?: OrderChangeResolvers<ContextType>;
  OrderChangeData?: OrderChangeDataResolvers<ContextType>;
  OrderProduct?: OrderProductResolvers<ContextType>;
  NoOrderChange?: NoOrderChangeResolvers<ContextType>;
  OrderChangeReverted?: OrderChangeRevertedResolvers<ContextType>;
  OrderChangeError?: OrderChangeErrorResolvers<ContextType>;
  GetOrderDeliveryCheckResponse?: GetOrderDeliveryCheckResponseResolvers<ContextType>;
  OrderDeliveryCheckDetails?: OrderDeliveryCheckDetailsResolvers<ContextType>;
  OrderedProductDeliveryCheck?: OrderedProductDeliveryCheckResolvers<ContextType>;
  OrderDeliveryCheckImage?: OrderDeliveryCheckImageResolvers<ContextType>;
  OrderedProductMetadata?: OrderedProductMetadataResolvers<ContextType>;
  DeliveryCheckProblem?: DeliveryCheckProblemResolvers<ContextType>;
  DeliveryCheckReconciliationRequest?: DeliveryCheckReconciliationRequestResolvers<ContextType>;
  DeliveryCheckReconciliationRequestStatusHistory?: DeliveryCheckReconciliationRequestStatusHistoryResolvers<ContextType>;
  CreatedOrCompletedByNotFound?: CreatedOrCompletedByNotFoundResolvers<ContextType>;
  OrderedProduct?: OrderedProductResolvers<ContextType>;
  OrderRestaurant?: OrderRestaurantResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  ChatEventTypes?: ChatEventTypesResolvers<ContextType>;
  RequestedChatCreated?: RequestedChatCreatedResolvers<ContextType>;
  RequestedChatActivated?: RequestedChatActivatedResolvers<ContextType>;
  UserAddedToChat?: UserAddedToChatResolvers<ContextType>;
  ChatNameUpdated?: ChatNameUpdatedResolvers<ContextType>;
  UserRemovedFromChat?: UserRemovedFromChatResolvers<ContextType>;
  ChatCreated?: ChatCreatedResolvers<ContextType>;
  CartOpened?: CartOpenedResolvers<ContextType>;
  EventUser?: EventUserResolvers<ContextType>;
  CartUpdated?: CartUpdatedResolvers<ContextType>;
  CartSubmitted?: CartSubmittedResolvers<ContextType>;
  CartCanceled?: CartCanceledResolvers<ContextType>;
  OrderEdited?: OrderEditedResolvers<ContextType>;
  OrderGuideRequested?: OrderGuideRequestedResolvers<ContextType>;
  OrderGuideCreated?: OrderGuideCreatedResolvers<ContextType>;
  ReconciliationRequestConfirmed?: ReconciliationRequestConfirmedResolvers<ContextType>;
  EventTarget?: EventTargetResolvers<ContextType>;
  EventChat?: EventChatResolvers<ContextType>;
  EventOrder?: EventOrderResolvers<ContextType>;
  EventDeliveryCheckReconciliationRequest?: EventDeliveryCheckReconciliationRequestResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  BroadcastAttachment?: BroadcastAttachmentResolvers<ContextType>;
  OrderGuideV2Ref?: OrderGuideV2RefResolvers<ContextType>;
  RefEdge?: RefEdgeResolvers<ContextType>;
  OrderGuideV2?: OrderGuideV2Resolvers<ContextType>;
  SubCatalog?: SubCatalogResolvers<ContextType>;
  ChatUserConnection?: ChatUserConnectionResolvers<ContextType>;
  ChatUserEdge?: ChatUserEdgeResolvers<ContextType>;
  BroadcastCustomerPerformanceResult?: BroadcastCustomerPerformanceResultResolvers<ContextType>;
  BroadcastCustomerPerformance?: BroadcastCustomerPerformanceResolvers<ContextType>;
  BroadCastEndsAt?: BroadCastEndsAtResolvers<ContextType>;
  BroadcastProductPerformanceResult?: BroadcastProductPerformanceResultResolvers<ContextType>;
  BroadcastProductPerformance?: BroadcastProductPerformanceResolvers<ContextType>;
  OneTimeBroadcastSchedule?: OneTimeBroadcastScheduleResolvers<ContextType>;
  BrowseCatalogResponse?: BrowseCatalogResponseResolvers<ContextType>;
  CatalogProductsConnection?: CatalogProductsConnectionResolvers<ContextType>;
  CatalogProductsEdge?: CatalogProductsEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  BrowseCatalogForChatResponse?: BrowseCatalogForChatResponseResolvers<ContextType>;
  CatalogNotFound?: CatalogNotFoundResolvers<ContextType>;
  BuyerFacetsResponse?: BuyerFacetsResponseResolvers<ContextType>;
  CityWithOffsets?: CityWithOffsetsResolvers<ContextType>;
  BuyerStockCountResponse?: BuyerStockCountResponseResolvers<ContextType>;
  BuyerStockCountSuccess?: BuyerStockCountSuccessResolvers<ContextType>;
  BuyerStockCountProduct?: BuyerStockCountProductResolvers<ContextType>;
  BuyerStockCountFailure?: BuyerStockCountFailureResolvers<ContextType>;
  BuyerStockCountsResponse?: BuyerStockCountsResponseResolvers<ContextType>;
  BuyerStockCountsSuccess?: BuyerStockCountsSuccessResolvers<ContextType>;
  BuyerStockCountConnection?: BuyerStockCountConnectionResolvers<ContextType>;
  BuyerStockCountEdge?: BuyerStockCountEdgeResolvers<ContextType>;
  BuyerStockCount?: BuyerStockCountResolvers<ContextType>;
  BuyerStockCountsFailure?: BuyerStockCountsFailureResolvers<ContextType>;
  BuyerStockInventoryResponse?: BuyerStockInventoryResponseResolvers<ContextType>;
  BuyerStockInventory?: BuyerStockInventoryResolvers<ContextType>;
  BuyerStockInventoryProductConnection?: BuyerStockInventoryProductConnectionResolvers<ContextType>;
  BuyerStockInventoryProductEdge?: BuyerStockInventoryProductEdgeResolvers<ContextType>;
  BuyerStockInventoryProduct?: BuyerStockInventoryProductResolvers<ContextType>;
  BuyerStockInventoryNotFound?: BuyerStockInventoryNotFoundResolvers<ContextType>;
  BuyerStockInventoryFailure?: BuyerStockInventoryFailureResolvers<ContextType>;
  BuyerStockInventoryExportUrlResponse?: BuyerStockInventoryExportUrlResponseResolvers<ContextType>;
  BuyerStockInventoryExportUrlSuccess?: BuyerStockInventoryExportUrlSuccessResolvers<ContextType>;
  BuyerStockInventoryExportUrlFailure?: BuyerStockInventoryExportUrlFailureResolvers<ContextType>;
  BuyerUser?: BuyerUserResolvers<ContextType>;
  CartResponse?: CartResponseResolvers<ContextType>;
  CatalogImportStatusResponse?: CatalogImportStatusResponseResolvers<ContextType>;
  CatalogImportStatusResult?: CatalogImportStatusResultResolvers<ContextType>;
  CatalogImportJob?: CatalogImportJobResolvers<ContextType>;
  JobWaitingForInput?: JobWaitingForInputResolvers<ContextType>;
  JobInProgress?: JobInProgressResolvers<ContextType>;
  JobFailed?: JobFailedResolvers<ContextType>;
  JobFailure?: JobFailureResolvers<ContextType>;
  CatalogImportJobSucceeded?: CatalogImportJobSucceededResolvers<ContextType>;
  CatalogImportJobResponse?: CatalogImportJobResponseResolvers<ContextType>;
  CatalogImportTemplateResponse?: CatalogImportTemplateResponseResolvers<ContextType>;
  CatalogImportTemplateResult?: CatalogImportTemplateResultResolvers<ContextType>;
  CatalogImportsResponse?: CatalogImportsResponseResolvers<ContextType>;
  CatalogImportsResult?: CatalogImportsResultResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  CatalogImportsResultEdge?: CatalogImportsResultEdgeResolvers<ContextType>;
  CatalogImportNode?: CatalogImportNodeResolvers<ContextType>;
  CategoryProducts?: CategoryProductsResolvers<ContextType>;
  ChatHasSupplierEmailSupportResponse?: ChatHasSupplierEmailSupportResponseResolvers<ContextType>;
  ChatHasSupplierEmailSupportResult?: ChatHasSupplierEmailSupportResultResolvers<ContextType>;
  ChatNotFoundError?: ChatNotFoundErrorResolvers<ContextType>;
  ChatNotificationPreferences?: ChatNotificationPreferencesResolvers<ContextType>;
  ChatNotificationUserLists?: ChatNotificationUserListsResolvers<ContextType>;
  ChatSubCatalogProductsResponse?: ChatSubCatalogProductsResponseResolvers<ContextType>;
  ValidationError?: ValidationErrorResolvers<ContextType>;
  ChatSubCatalogProductsError?: ChatSubCatalogProductsErrorResolvers<ContextType>;
  ProductSearchResult?: ProductSearchResultResolvers<ContextType>;
  ChatUser?: ChatUserResolvers<ContextType>;
  FetchBuyerReportDownloadUrlResponse?: FetchBuyerReportDownloadUrlResponseResolvers<ContextType>;
  BuyerReport?: BuyerReportResolvers<ContextType>;
  BuyerReportGenerationError?: BuyerReportGenerationErrorResolvers<ContextType>;
  BuyerReportNotFoundError?: BuyerReportNotFoundErrorResolvers<ContextType>;
  CatalogCategory?: CatalogCategoryResolvers<ContextType>;
  FetchCatalogCategoriesForChatResponse?: FetchCatalogCategoriesForChatResponseResolvers<ContextType>;
  CatalogCategoriesResponse?: CatalogCategoriesResponseResolvers<ContextType>;
  OrderGuideResponse?: OrderGuideResponseResolvers<ContextType>;
  OrderGuide?: OrderGuideResolvers<ContextType>;
  OrderGuideCategory?: OrderGuideCategoryResolvers<ContextType>;
  OrderGuideProduct?: OrderGuideProductResolvers<ContextType>;
  OrderGuideProductItem?: OrderGuideProductItemResolvers<ContextType>;
  OrderGuideFailure?: OrderGuideFailureResolvers<ContextType>;
  EmbedDashboardUrlResponse?: EmbedDashboardUrlResponseResolvers<ContextType>;
  GetAllBuyerReportSchedulesResponse?: GetAllBuyerReportSchedulesResponseResolvers<ContextType>;
  BuyerReportSchedules?: BuyerReportSchedulesResolvers<ContextType>;
  BuyerReportSchedule?: BuyerReportScheduleResolvers<ContextType>;
  AppliedChatDeliverySettingResponse?: AppliedChatDeliverySettingResponseResolvers<ContextType>;
  AppliedChatDeliverySetting?: AppliedChatDeliverySettingResolvers<ContextType>;
  SuggestedProductResult?: SuggestedProductResultResolvers<ContextType>;
  SuggestedProductSuccessResponse?: SuggestedProductSuccessResponseResolvers<ContextType>;
  SuggestedProductConnection?: SuggestedProductConnectionResolvers<ContextType>;
  SuggestedProductEdge?: SuggestedProductEdgeResolvers<ContextType>;
  SuggestedProduct?: SuggestedProductResolvers<ContextType>;
  GetSuggestedProductsErrorResponse?: GetSuggestedProductsErrorResponseResolvers<ContextType>;
  GetCatalogUploadUrlResponse?: GetCatalogUploadUrlResponseResolvers<ContextType>;
  SupplierNotFound?: SupplierNotFoundResolvers<ContextType>;
  GetCatalogUploadUrlResult?: GetCatalogUploadUrlResultResolvers<ContextType>;
  GetChatCountByCCEmailResponse?: GetChatCountByCcEmailResponseResolvers<ContextType>;
  GetChatCountByCCEmailReport?: GetChatCountByCcEmailReportResolvers<ContextType>;
  GetChatSuppliersByLocationsResponse?: GetChatSuppliersByLocationsResponseResolvers<ContextType>;
  ChatSuppliersByLocations?: ChatSuppliersByLocationsResolvers<ContextType>;
  SupplierDetails?: SupplierDetailsResolvers<ContextType>;
  GetChatsForSubCatalogResponse?: GetChatsForSubCatalogResponseResolvers<ContextType>;
  GetChatsForSubCatalogResult?: GetChatsForSubCatalogResultResolvers<ContextType>;
  SubCatalogNotFoundError?: SubCatalogNotFoundErrorResolvers<ContextType>;
  GetConnectedAccountsResponse?: GetConnectedAccountsResponseResolvers<ContextType>;
  ConnectedAccountConnection?: ConnectedAccountConnectionResolvers<ContextType>;
  ConnectedAccountEdge?: ConnectedAccountEdgeResolvers<ContextType>;
  ConnectedAccount?: ConnectedAccountResolvers<ContextType>;
  GetConnectedIntegrationAdaptersResponse?: GetConnectedIntegrationAdaptersResponseResolvers<ContextType>;
  IntegrationAdapterConnectionBaseResultConnection?: IntegrationAdapterConnectionBaseResultConnectionResolvers<ContextType>;
  IntegrationAdapterConnectionBaseResultEdge?: IntegrationAdapterConnectionBaseResultEdgeResolvers<ContextType>;
  IntegrationAdapterConnectionBaseResult?: IntegrationAdapterConnectionBaseResultResolvers<ContextType>;
  IntegrationAdapterConnectionAdminResultConnection?: IntegrationAdapterConnectionAdminResultConnectionResolvers<ContextType>;
  IntegrationAdapterConnectionAdminResultEdge?: IntegrationAdapterConnectionAdminResultEdgeResolvers<ContextType>;
  IntegrationAdapterConnectionAdminResult?: IntegrationAdapterConnectionAdminResultResolvers<ContextType>;
  IntegrationAdapterConnectionWebhook?: IntegrationAdapterConnectionWebhookResolvers<ContextType>;
  GetEmailListsResponse?: GetEmailListsResponseResolvers<ContextType>;
  EmailLists?: EmailListsResolvers<ContextType>;
  EmailList?: EmailListResolvers<ContextType>;
  GetFeatureFlagsResponse?: GetFeatureFlagsResponseResolvers<ContextType>;
  FeatureFlags?: FeatureFlagsResolvers<ContextType>;
  FeatureFlag?: FeatureFlagResolvers<ContextType>;
  GroupResponse?: GroupResponseResolvers<ContextType>;
  GroupResponseSuccess?: GroupResponseSuccessResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  GroupCreatedBy?: GroupCreatedByResolvers<ContextType>;
  GroupResponseError?: GroupResponseErrorResolvers<ContextType>;
  GetGroupEntitiesResponse?: GetGroupEntitiesResponseResolvers<ContextType>;
  GetGroupEntitiesSuccessResponse?: GetGroupEntitiesSuccessResponseResolvers<ContextType>;
  GroupEntityConnection?: GroupEntityConnectionResolvers<ContextType>;
  GroupEntityEdge?: GroupEntityEdgeResolvers<ContextType>;
  GroupEntityNode?: GroupEntityNodeResolvers<ContextType>;
  GroupEntityBuyer?: GroupEntityBuyerResolvers<ContextType>;
  GroupEntity?: GroupEntityResolvers<ContextType>;
  GroupEntitySupplier?: GroupEntitySupplierResolvers<ContextType>;
  GetGroupEntitiesErrorResponse?: GetGroupEntitiesErrorResponseResolvers<ContextType>;
  GetGroupUsersResponse?: GetGroupUsersResponseResolvers<ContextType>;
  GetGroupUsersSuccessResponse?: GetGroupUsersSuccessResponseResolvers<ContextType>;
  GroupUserConnection?: GroupUserConnectionResolvers<ContextType>;
  GroupUserEdge?: GroupUserEdgeResolvers<ContextType>;
  GroupUser?: GroupUserResolvers<ContextType>;
  GetGroupUsersErrorResponse?: GetGroupUsersErrorResponseResolvers<ContextType>;
  GetIntegrationAdaptersResponse?: GetIntegrationAdaptersResponseResolvers<ContextType>;
  IntegrationAdapterBaseResultConnection?: IntegrationAdapterBaseResultConnectionResolvers<ContextType>;
  IntegrationAdapterBaseResultEdge?: IntegrationAdapterBaseResultEdgeResolvers<ContextType>;
  IntegrationAdapterBaseResult?: IntegrationAdapterBaseResultResolvers<ContextType>;
  IntegrationAdapterAuthBase?: IntegrationAdapterAuthBaseResolvers<ContextType>;
  IntegrationAdapterAuthorizationCodeAuthBase?: IntegrationAdapterAuthorizationCodeAuthBaseResolvers<ContextType>;
  IntegrationAdapterClientCredentialsAuthBase?: IntegrationAdapterClientCredentialsAuthBaseResolvers<ContextType>;
  IntegrationAdapterAPIKeyAuthBase?: IntegrationAdapterApiKeyAuthBaseResolvers<ContextType>;
  IntegrationAdapterAdminResultConnection?: IntegrationAdapterAdminResultConnectionResolvers<ContextType>;
  IntegrationAdapterAdminResultEdge?: IntegrationAdapterAdminResultEdgeResolvers<ContextType>;
  IntegrationAdapterAdminResult?: IntegrationAdapterAdminResultResolvers<ContextType>;
  IntegrationAdapterAuth?: IntegrationAdapterAuthResolvers<ContextType>;
  IntegrationAdapterAuthorizationCodeAuth?: IntegrationAdapterAuthorizationCodeAuthResolvers<ContextType>;
  IntegrationAdapterClientCredentialsAuth?: IntegrationAdapterClientCredentialsAuthResolvers<ContextType>;
  IntegrationAdapterAPIKeyAuth?: IntegrationAdapterApiKeyAuthResolvers<ContextType>;
  IntegrationAdapterWebhook?: IntegrationAdapterWebhookResolvers<ContextType>;
  IntegrationAdapterWebhookAuth?: IntegrationAdapterWebhookAuthResolvers<ContextType>;
  IntegrationAdapterWebhookBasicAuth?: IntegrationAdapterWebhookBasicAuthResolvers<ContextType>;
  IntegrationAdapterWebhookSignatureAuth?: IntegrationAdapterWebhookSignatureAuthResolvers<ContextType>;
  GetInviteTransmissionStatusResponse?: GetInviteTransmissionStatusResponseResolvers<ContextType>;
  InviteTransmissionStatus?: InviteTransmissionStatusResolvers<ContextType>;
  GetInviteeBuyersResponse?: GetInviteeBuyersResponseResolvers<ContextType>;
  InviteeNotFound?: InviteeNotFoundResolvers<ContextType>;
  InviteeBuyers?: InviteeBuyersResolvers<ContextType>;
  MessagesFromChatResult?: MessagesFromChatResultResolvers<ContextType>;
  MessageEvent?: MessageEventResolvers<ContextType>;
  LocationsBySupplierResponse?: LocationsBySupplierResponseResolvers<ContextType>;
  LocationsBySupplierSuccess?: LocationsBySupplierSuccessResolvers<ContextType>;
  LocationBySupplier?: LocationBySupplierResolvers<ContextType>;
  MarketingMessageSuggestionsResult?: MarketingMessageSuggestionsResultResolvers<ContextType>;
  MarketingMessageSuggestionsSuccess?: MarketingMessageSuggestionsSuccessResolvers<ContextType>;
  MarketingMessageRefinementTip?: MarketingMessageRefinementTipResolvers<ContextType>;
  MarketingMessageSuggestionsError?: MarketingMessageSuggestionsErrorResolvers<ContextType>;
  MarketingMessageSuggestionsErrorNoSuggestions?: MarketingMessageSuggestionsErrorNoSuggestionsResolvers<ContextType>;
  MarketingMessageSuggestionsErrorThrottling?: MarketingMessageSuggestionsErrorThrottlingResolvers<ContextType>;
  GetOmniChannelOrderResponse?: GetOmniChannelOrderResponseResolvers<ContextType>;
  GetOnboardingChecklistResponse?: GetOnboardingChecklistResponseResolvers<ContextType>;
  OnboardingChecklist?: OnboardingChecklistResolvers<ContextType>;
  OnboardingChecklistItem?: OnboardingChecklistItemResolvers<ContextType>;
  OnboardingChecklistItemValue?: OnboardingChecklistItemValueResolvers<ContextType>;
  OnboardingChecklistBooleanValue?: OnboardingChecklistBooleanValueResolvers<ContextType>;
  OnboardingChecklistNumericValue?: OnboardingChecklistNumericValueResolvers<ContextType>;
  GetProductsForChatResponse?: GetProductsForChatResponseResolvers<ContextType>;
  GetProductsForChatResult?: GetProductsForChatResultResolvers<ContextType>;
  InvalidProduct?: InvalidProductResolvers<ContextType>;
  GetQboCustomersAndOrderGuidesToImportResponse?: GetQboCustomersAndOrderGuidesToImportResponseResolvers<ContextType>;
  QboCustomersAndOrderGuidesToImport?: QboCustomersAndOrderGuidesToImportResolvers<ContextType>;
  GetReconciliationRequestPlanBySupplierIdResponse?: GetReconciliationRequestPlanBySupplierIdResponseResolvers<ContextType>;
  ReconciliationRequestPlan?: ReconciliationRequestPlanResolvers<ContextType>;
  ReconciliationRequestPlanBySupplierIdNotFound?: ReconciliationRequestPlanBySupplierIdNotFoundResolvers<ContextType>;
  GetRequestsToJoinResponse?: GetRequestsToJoinResponseResolvers<ContextType>;
  RequestsToJoinConnection?: RequestsToJoinConnectionResolvers<ContextType>;
  UserRequestToJoinEdge?: UserRequestToJoinEdgeResolvers<ContextType>;
  UserRequestToJoin?: UserRequestToJoinResolvers<ContextType>;
  SalesRepDetails?: SalesRepDetailsResolvers<ContextType>;
  GetSmsMessageByMessageSidResponse?: GetSmsMessageByMessageSidResponseResolvers<ContextType>;
  GetSmsMessageByMessageSidSuccess?: GetSmsMessageByMessageSidSuccessResolvers<ContextType>;
  SmsMessage?: SmsMessageResolvers<ContextType>;
  SmsMessageMedia?: SmsMessageMediaResolvers<ContextType>;
  GetSmsMessagesFromPhoneNumberResponse?: GetSmsMessagesFromPhoneNumberResponseResolvers<ContextType>;
  GetSmsMessagesFromPhoneNumberSuccess?: GetSmsMessagesFromPhoneNumberSuccessResolvers<ContextType>;
  GetSubCatalogResponse?: GetSubCatalogResponseResolvers<ContextType>;
  GetSubCatalogsForChatResponse?: GetSubCatalogsForChatResponseResolvers<ContextType>;
  GetSubCatalogsForChatResult?: GetSubCatalogsForChatResultResolvers<ContextType>;
  GetSupplierApplicationsResponse?: GetSupplierApplicationsResponseResolvers<ContextType>;
  SupplierApplications?: SupplierApplicationsResolvers<ContextType>;
  ApplicationData?: ApplicationDataResolvers<ContextType>;
  CredentialsData?: CredentialsDataResolvers<ContextType>;
  QbdCredentials?: QbdCredentialsResolvers<ContextType>;
  GetSupplierProductsResponse?: GetSupplierProductsResponseResolvers<ContextType>;
  GetSupplierProductsResult?: GetSupplierProductsResultResolvers<ContextType>;
  GetUnconnectedBuyerIdsResult?: GetUnconnectedBuyerIdsResultResolvers<ContextType>;
  UnconnectedBuyers?: UnconnectedBuyersResolvers<ContextType>;
  NoUnconnectedBuyers?: NoUnconnectedBuyersResolvers<ContextType>;
  UserIntercomCredentialsResponse?: UserIntercomCredentialsResponseResolvers<ContextType>;
  UserIntercomCredentialsSuccess?: UserIntercomCredentialsSuccessResolvers<ContextType>;
  UserIntercomCredentialsFailure?: UserIntercomCredentialsFailureResolvers<ContextType>;
  GetWhatsAppMessageByMessageSidResponse?: GetWhatsAppMessageByMessageSidResponseResolvers<ContextType>;
  GetWhatsAppMessageByMessageSidSuccess?: GetWhatsAppMessageByMessageSidSuccessResolvers<ContextType>;
  WhatsAppMessage?: WhatsAppMessageResolvers<ContextType>;
  WhatsAppMessageMedia?: WhatsAppMessageMediaResolvers<ContextType>;
  HasUserCompletedDeliveryCheckResponse?: HasUserCompletedDeliveryCheckResponseResolvers<ContextType>;
  HasCompletedDeliveryCheckResult?: HasCompletedDeliveryCheckResultResolvers<ContextType>;
  OrderNotFound?: OrderNotFoundResolvers<ContextType>;
  InventoryDownloadJobsResponse?: InventoryDownloadJobsResponseResolvers<ContextType>;
  InventoryDownloadJobsSuccess?: InventoryDownloadJobsSuccessResolvers<ContextType>;
  InventoryDownloadJob?: InventoryDownloadJobResolvers<ContextType>;
  InventoryDownloadJobReport?: InventoryDownloadJobReportResolvers<ContextType>;
  InventoryDownloadJobCompleted?: InventoryDownloadJobCompletedResolvers<ContextType>;
  InventoryDownloadJobFailed?: InventoryDownloadJobFailedResolvers<ContextType>;
  InventoryDownloadJobsFailure?: InventoryDownloadJobsFailureResolvers<ContextType>;
  InventorySuppliersResponse?: InventorySuppliersResponseResolvers<ContextType>;
  InventorySuppliersSuccess?: InventorySuppliersSuccessResolvers<ContextType>;
  InventorySupplier?: InventorySupplierResolvers<ContextType>;
  InventorySuppliersFailure?: InventorySuppliersFailureResolvers<ContextType>;
  InventoryUploadJobResponse?: InventoryUploadJobResponseResolvers<ContextType>;
  InventoryUploadJobSuccess?: InventoryUploadJobSuccessResolvers<ContextType>;
  InventoryUploadJobFailure?: InventoryUploadJobFailureResolvers<ContextType>;
  InventoryUploadTemplateResponse?: InventoryUploadTemplateResponseResolvers<ContextType>;
  InventoryUploadTemplateResponseSuccess?: InventoryUploadTemplateResponseSuccessResolvers<ContextType>;
  InventoryUploadTemplateResponseFailure?: InventoryUploadTemplateResponseFailureResolvers<ContextType>;
  ListSubCatalogProductsResponse?: ListSubCatalogProductsResponseResolvers<ContextType>;
  ListSubCatalogProductsError?: ListSubCatalogProductsErrorResolvers<ContextType>;
  ListSubCatalogsResponse?: ListSubCatalogsResponseResolvers<ContextType>;
  SubCatalogConnection?: SubCatalogConnectionResolvers<ContextType>;
  SubCatalogEdge?: SubCatalogEdgeResolvers<ContextType>;
  LookupPhoneNumbersResponse?: LookupPhoneNumbersResponseResolvers<ContextType>;
  LookupPhoneNumbersSuccess?: LookupPhoneNumbersSuccessResolvers<ContextType>;
  PhoneNumberLookup?: PhoneNumberLookupResolvers<ContextType>;
  PhoneNumberLookupSuccess?: PhoneNumberLookupSuccessResolvers<ContextType>;
  PhoneNumberLookupError?: PhoneNumberLookupErrorResolvers<ContextType>;
  LookupPhoneNumbersError?: LookupPhoneNumbersErrorResolvers<ContextType>;
  MetaLobbyResponse?: MetaLobbyResponseResolvers<ContextType>;
  MetaLobbyResult?: MetaLobbyResultResolvers<ContextType>;
  UserLobbyBuyerConnection?: UserLobbyBuyerConnectionResolvers<ContextType>;
  UserLobbyBuyerEdge?: UserLobbyBuyerEdgeResolvers<ContextType>;
  LobbyBuyer?: LobbyBuyerResolvers<ContextType>;
  InvalidCursor?: InvalidCursorResolvers<ContextType>;
  OrderGuideV2CategoriesResponse?: OrderGuideV2CategoriesResponseResolvers<ContextType>;
  OrderGuideV2CategoriesResult?: OrderGuideV2CategoriesResultResolvers<ContextType>;
  OrderGuideV2CategoriesResultEdge?: OrderGuideV2CategoriesResultEdgeResolvers<ContextType>;
  OrderGuideV2Category?: OrderGuideV2CategoryResolvers<ContextType>;
  OrderGuideV2ItemUnitsResponse?: OrderGuideV2ItemUnitsResponseResolvers<ContextType>;
  OrderGuideV2ItemUnitsResult?: OrderGuideV2ItemUnitsResultResolvers<ContextType>;
  OrderGuideV2ItemUnitsResultEdge?: OrderGuideV2ItemUnitsResultEdgeResolvers<ContextType>;
  OrderGuideV2ItemUnit?: OrderGuideV2ItemUnitResolvers<ContextType>;
  OrderGuideV2CategoryRef?: OrderGuideV2CategoryRefResolvers<ContextType>;
  VendorItemUnitRef?: VendorItemUnitRefResolvers<ContextType>;
  VendorItemUnit?: VendorItemUnitResolvers<ContextType>;
  Rational?: RationalResolvers<ContextType>;
  VendorItemUnitImage?: VendorItemUnitImageResolvers<ContextType>;
  ImageAsset?: ImageAssetResolvers<ContextType>;
  ImageAssetUrl?: ImageAssetUrlResolvers<ContextType>;
  VendorItemUnitPriceSet?: VendorItemUnitPriceSetResolvers<ContextType>;
  MoneyV2?: MoneyV2Resolvers<ContextType>;
  VendorItemRef?: VendorItemRefResolvers<ContextType>;
  VendorItem?: VendorItemResolvers<ContextType>;
  VendorItemVariantGroup?: VendorItemVariantGroupResolvers<ContextType>;
  VendorItemCategory?: VendorItemCategoryResolvers<ContextType>;
  VendorItemCategoryRef?: VendorItemCategoryRefResolvers<ContextType>;
  VendorItemCategoryImage?: VendorItemCategoryImageResolvers<ContextType>;
  OrdersToReviewResponse?: OrdersToReviewResponseResolvers<ContextType>;
  OrdersToReviewConnection?: OrdersToReviewConnectionResolvers<ContextType>;
  OrdersToReviewEdge?: OrdersToReviewEdgeResolvers<ContextType>;
  PaymentOptionsResponse?: PaymentOptionsResponseResolvers<ContextType>;
  PublicToken?: PublicTokenResolvers<ContextType>;
  Redirect?: RedirectResolvers<ContextType>;
  SearchResult?: SearchResultResolvers<ContextType>;
  SearchItem?: SearchItemResolvers<ContextType>;
  SearchEntity?: SearchEntityResolvers<ContextType>;
  SearchBuyerResponse?: SearchBuyerResponseResolvers<ContextType>;
  SearchBuyerConnection?: SearchBuyerConnectionResolvers<ContextType>;
  BuyerEdge?: BuyerEdgeResolvers<ContextType>;
  SearchGroupsResponse?: SearchGroupsResponseResolvers<ContextType>;
  SearchGroupsSuccessResponse?: SearchGroupsSuccessResponseResolvers<ContextType>;
  GroupConnection?: GroupConnectionResolvers<ContextType>;
  GroupEdge?: GroupEdgeResolvers<ContextType>;
  SearchGroupsErrorResponse?: SearchGroupsErrorResponseResolvers<ContextType>;
  SearchOrderResponse?: SearchOrderResponseResolvers<ContextType>;
  SearchOrderConnection?: SearchOrderConnectionResolvers<ContextType>;
  SearchOrderEdge?: SearchOrderEdgeResolvers<ContextType>;
  SearchOrderDeskCustomerResponse?: SearchOrderDeskCustomerResponseResolvers<ContextType>;
  OrderDeskChatsConnection?: OrderDeskChatsConnectionResolvers<ContextType>;
  OrderDeskChatsEdge?: OrderDeskChatsEdgeResolvers<ContextType>;
  SearchProductsResponse?: SearchProductsResponseResolvers<ContextType>;
  SearchProductsConnection?: SearchProductsConnectionResolvers<ContextType>;
  SearchProductsEdge?: SearchProductsEdgeResolvers<ContextType>;
  SearchProductsError?: SearchProductsErrorResolvers<ContextType>;
  SearchTaxonomyLabelsResponse?: SearchTaxonomyLabelsResponseResolvers<ContextType>;
  SearchTaxonomyLabelsConnection?: SearchTaxonomyLabelsConnectionResolvers<ContextType>;
  SearchTaxonomyLabelsEdge?: SearchTaxonomyLabelsEdgeResolvers<ContextType>;
  TaxonomyLabel?: TaxonomyLabelResolvers<ContextType>;
  SearchTaxonomyLabelsError?: SearchTaxonomyLabelsErrorResolvers<ContextType>;
  SendSampleSmsMessageResponse?: SendSampleSmsMessageResponseResolvers<ContextType>;
  SendSampleSmsMessageSuccess?: SendSampleSmsMessageSuccessResolvers<ContextType>;
  SendSampleSmsMessageFailure?: SendSampleSmsMessageFailureResolvers<ContextType>;
  SharedBroadcastProducts?: SharedBroadcastProductsResolvers<ContextType>;
  StockCountSessionsResponse?: StockCountSessionsResponseResolvers<ContextType>;
  StockCountSessionsSuccess?: StockCountSessionsSuccessResolvers<ContextType>;
  StockCountSession?: StockCountSessionResolvers<ContextType>;
  CountDetails?: CountDetailsResolvers<ContextType>;
  StockItemPrice?: StockItemPriceResolvers<ContextType>;
  StockItem?: StockItemResolvers<ContextType>;
  StockCountSessionsPaginationInfo?: StockCountSessionsPaginationInfoResolvers<ContextType>;
  StockCountUsersResponse?: StockCountUsersResponseResolvers<ContextType>;
  StockCountUsersSuccess?: StockCountUsersSuccessResolvers<ContextType>;
  StockCountUser?: StockCountUserResolvers<ContextType>;
  StorageAreasResponse?: StorageAreasResponseResolvers<ContextType>;
  StorageAreasSuccess?: StorageAreasSuccessResolvers<ContextType>;
  StorageArea?: StorageAreaResolvers<ContextType>;
  StorageItem?: StorageItemResolvers<ContextType>;
  InventoryItem?: InventoryItemResolvers<ContextType>;
  ItemVendor?: ItemVendorResolvers<ContextType>;
  ChocoVendor?: ChocoVendorResolvers<ContextType>;
  BuyerExternalVendor?: BuyerExternalVendorResolvers<ContextType>;
  ItemPrice?: ItemPriceResolvers<ContextType>;
  ItemUnit?: ItemUnitResolvers<ContextType>;
  StorageItemCount?: StorageItemCountResolvers<ContextType>;
  supplierAssortments?: SupplierAssortmentsResolvers<ContextType>;
  ChatLabelsResult?: ChatLabelsResultResolvers<ContextType>;
  SupplierDeliveryDateSettingsResponse?: SupplierDeliveryDateSettingsResponseResolvers<ContextType>;
  SupplierDeliverySettingsNotFound?: SupplierDeliverySettingsNotFoundResolvers<ContextType>;
  SupplierSearchResponse?: SupplierSearchResponseResolvers<ContextType>;
  SearchSupplierConnection?: SearchSupplierConnectionResolvers<ContextType>;
  SupplierSearchEdge?: SupplierSearchEdgeResolvers<ContextType>;
  UserChatsResponse?: UserChatsResponseResolvers<ContextType>;
  UserChatsError?: UserChatsErrorResolvers<ContextType>;
  UserSearchResponse?: UserSearchResponseResolvers<ContextType>;
  UserSearchConnection?: UserSearchConnectionResolvers<ContextType>;
  UserSearchEdge?: UserSearchEdgeResolvers<ContextType>;
  ValidateProductsAvailabilityResponse?: ValidateProductsAvailabilityResponseResolvers<ContextType>;
  ValidateProductsAvailabilityResult?: ValidateProductsAvailabilityResultResolvers<ContextType>;
  VendorItemCategoriesForChatResponse?: VendorItemCategoriesForChatResponseResolvers<ContextType>;
  VendorItemCategoriesForChatSuccess?: VendorItemCategoriesForChatSuccessResolvers<ContextType>;
  VendorItemCategoriesForChatResultEdge?: VendorItemCategoriesForChatResultEdgeResolvers<ContextType>;
  VendorItemsResponse?: VendorItemsResponseResolvers<ContextType>;
  VendorItemsSuccess?: VendorItemsSuccessResolvers<ContextType>;
  VendorItemsCountForChatResponse?: VendorItemsCountForChatResponseResolvers<ContextType>;
  VendorItemsCountForChatSuccess?: VendorItemsCountForChatSuccessResolvers<ContextType>;
  VendorItemsForChatResponse?: VendorItemsForChatResponseResolvers<ContextType>;
  VendorItemsForChatSuccess?: VendorItemsForChatSuccessResolvers<ContextType>;
  VendorItemsForChatResultEdge?: VendorItemsForChatResultEdgeResolvers<ContextType>;
  VendorItemsForVendorResponse?: VendorItemsForVendorResponseResolvers<ContextType>;
  VendorItemsForVendorResult?: VendorItemsForVendorResultResolvers<ContextType>;
  VendorItemsForVendorResultEdge?: VendorItemsForVendorResultEdgeResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  AcceptOrderResponse?: AcceptOrderResponseResolvers<ContextType>;
  OrderAlreadyAccepted?: OrderAlreadyAcceptedResolvers<ContextType>;
  OrderCreatedError?: OrderCreatedErrorResolvers<ContextType>;
  UnavailableProductType?: UnavailableProductTypeResolvers<ContextType>;
  ActivateSuppliersPaymentAccountResponse?: ActivateSuppliersPaymentAccountResponseResolvers<ContextType>;
  SuppliersPaymentAccount?: SuppliersPaymentAccountResolvers<ContextType>;
  ExternalAccountDetailsMissed?: ExternalAccountDetailsMissedResolvers<ContextType>;
  ExternalAccountNotFound?: ExternalAccountNotFoundResolvers<ContextType>;
  SupplierHasActivePaymentAccountAlready?: SupplierHasActivePaymentAccountAlreadyResolvers<ContextType>;
  AddBuyerStockInventoryProductResponse?: AddBuyerStockInventoryProductResponseResolvers<ContextType>;
  AddBuyerStockInventoryProductFailure?: AddBuyerStockInventoryProductFailureResolvers<ContextType>;
  ProductNotFoundError?: ProductNotFoundErrorResolvers<ContextType>;
  AddEntitiesToGroupResponse?: AddEntitiesToGroupResponseResolvers<ContextType>;
  AddEntitiesToGroupResponseSuccess?: AddEntitiesToGroupResponseSuccessResolvers<ContextType>;
  AddEntitiesToGroupResponseError?: AddEntitiesToGroupResponseErrorResolvers<ContextType>;
  AddInvoiceResponse?: AddInvoiceResponseResolvers<ContextType>;
  ChatHasNoSupplierEntity?: ChatHasNoSupplierEntityResolvers<ContextType>;
  OrderAlreadyHasInvoice?: OrderAlreadyHasInvoiceResolvers<ContextType>;
  AddMarketingProductsToCartResponse?: AddMarketingProductsToCartResponseResolvers<ContextType>;
  AddMarketingProductsToCartSuccess?: AddMarketingProductsToCartSuccessResolvers<ContextType>;
  AddMarketingProductsToCartTeamCartData?: AddMarketingProductsToCartTeamCartDataResolvers<ContextType>;
  TeamCartExists?: TeamCartExistsResolvers<ContextType>;
  TeamCartNotFound?: TeamCartNotFoundResolvers<ContextType>;
  AddPaymentAccountResponse?: AddPaymentAccountResponseResolvers<ContextType>;
  PaymentMethodNotAvailableForUser?: PaymentMethodNotAvailableForUserResolvers<ContextType>;
  SupplierPaymentAccountAlreadyExists?: SupplierPaymentAccountAlreadyExistsResolvers<ContextType>;
  PaymentAccountAlreadyExists?: PaymentAccountAlreadyExistsResolvers<ContextType>;
  AddProductsToOrderGuidesResponse?: AddProductsToOrderGuidesResponseResolvers<ContextType>;
  AddProductsToOrderGuidesResult?: AddProductsToOrderGuidesResultResolvers<ContextType>;
  LocationProductsResult?: LocationProductsResultResolvers<ContextType>;
  LocationProductResult?: LocationProductResultResolvers<ContextType>;
  AddSalesRepRequestToJoinResponse?: AddSalesRepRequestToJoinResponseResolvers<ContextType>;
  AddSalesRepSuccess?: AddSalesRepSuccessResolvers<ContextType>;
  AddSalesRepError?: AddSalesRepErrorResolvers<ContextType>;
  BuyerAddSupplierResponse?: BuyerAddSupplierResponseResolvers<ContextType>;
  BuyerAddSupplier?: BuyerAddSupplierResolvers<ContextType>;
  BuyerAddSupplierError?: BuyerAddSupplierErrorResolvers<ContextType>;
  AddSuppliersPaymentAccountResponse?: AddSuppliersPaymentAccountResponseResolvers<ContextType>;
  SupplierPaymentsDisabled?: SupplierPaymentsDisabledResolvers<ContextType>;
  AddUsersToGroupResponse?: AddUsersToGroupResponseResolvers<ContextType>;
  AddUsersToGroupResponseSuccess?: AddUsersToGroupResponseSuccessResolvers<ContextType>;
  AddUsersToGroupResponseError?: AddUsersToGroupResponseErrorResolvers<ContextType>;
  AssignOrderToUserForReviewResponse?: AssignOrderToUserForReviewResponseResolvers<ContextType>;
  AssignOrderToUserForReviewResponseSuccess?: AssignOrderToUserForReviewResponseSuccessResolvers<ContextType>;
  AssignOrderToUserForReviewResponseError?: AssignOrderToUserForReviewResponseErrorResolvers<ContextType>;
  BatchOrderConfirmResponse?: BatchOrderConfirmResponseResolvers<ContextType>;
  BatchOrderConfirmSuccess?: BatchOrderConfirmSuccessResolvers<ContextType>;
  BatchOrderConfirmError?: BatchOrderConfirmErrorResolvers<ContextType>;
  BatchUpdateOrderSupplier?: BatchUpdateOrderSupplierResolvers<ContextType>;
  BroadcastUpdatePurposeResult?: BroadcastUpdatePurposeResultResolvers<ContextType>;
  BulkSendInviteTransmissionResponse?: BulkSendInviteTransmissionResponseResolvers<ContextType>;
  BulkInviteTransmissionSuccess?: BulkInviteTransmissionSuccessResolvers<ContextType>;
  BulkInviteTransmissionFailure?: BulkInviteTransmissionFailureResolvers<ContextType>;
  BulkOrderedProductDeliveryCheckSubmissionResponse?: BulkOrderedProductDeliveryCheckSubmissionResponseResolvers<ContextType>;
  BulkOrderedProductDeliveryCheckSubmissionResult?: BulkOrderedProductDeliveryCheckSubmissionResultResolvers<ContextType>;
  OrderDeliveryItemsMismatched?: OrderDeliveryItemsMismatchedResolvers<ContextType>;
  OrderDeliveryCheckAlreadyCompleted?: OrderDeliveryCheckAlreadyCompletedResolvers<ContextType>;
  BuyerDisableRolesResponse?: BuyerDisableRolesResponseResolvers<ContextType>;
  CancelCartResponse?: CancelCartResponseResolvers<ContextType>;
  CancelCartResult?: CancelCartResultResolvers<ContextType>;
  CartVersionConstraintError?: CartVersionConstraintErrorResolvers<ContextType>;
  UserCartItemOperation?: UserCartItemOperationResolvers<ContextType>;
  CartNotFoundError?: CartNotFoundErrorResolvers<ContextType>;
  CatalogImportStartResponse?: CatalogImportStartResponseResolvers<ContextType>;
  CatalogImportStartResult?: CatalogImportStartResultResolvers<ContextType>;
  ClaimOnboardingChecklistRewardResponse?: ClaimOnboardingChecklistRewardResponseResolvers<ContextType>;
  ClaimOnboardingChecklistRewardSuccess?: ClaimOnboardingChecklistRewardSuccessResolvers<ContextType>;
  ClaimOnboardingChecklistRewardError?: ClaimOnboardingChecklistRewardErrorResolvers<ContextType>;
  ConfirmDeliveryCheckReconciliationResponse?: ConfirmDeliveryCheckReconciliationResponseResolvers<ContextType>;
  DeliveryCheckReconciliationRequestNotFound?: DeliveryCheckReconciliationRequestNotFoundResolvers<ContextType>;
  DeliveryCheckReconciliationRequestAlreadyConfirmed?: DeliveryCheckReconciliationRequestAlreadyConfirmedResolvers<ContextType>;
  OrderDeliveryCheckReconciliationRequestIdNotMatched?: OrderDeliveryCheckReconciliationRequestIdNotMatchedResolvers<ContextType>;
  ConnectAccountResponse?: ConnectAccountResponseResolvers<ContextType>;
  ConnectAccountUrl?: ConnectAccountUrlResolvers<ContextType>;
  ConnectAccountError?: ConnectAccountErrorResolvers<ContextType>;
  ConnectIntegrationAdapterResponse?: ConnectIntegrationAdapterResponseResolvers<ContextType>;
  ChocoEntityNotFound?: ChocoEntityNotFoundResolvers<ContextType>;
  UnsupportedIntegrationAdapterType?: UnsupportedIntegrationAdapterTypeResolvers<ContextType>;
  IntegrationAdapterNotFound?: IntegrationAdapterNotFoundResolvers<ContextType>;
  CreateBuyerReportScheduleResponse?: CreateBuyerReportScheduleResponseResolvers<ContextType>;
  OrderDeliveryCheckCreationResponse?: OrderDeliveryCheckCreationResponseResolvers<ContextType>;
  OrderDeliveryCheckExists?: OrderDeliveryCheckExistsResolvers<ContextType>;
  OrderDeliveryCheckImageUploadUrlResponse?: OrderDeliveryCheckImageUploadUrlResponseResolvers<ContextType>;
  OrderDeliveryCheckImageUploadUrlResult?: OrderDeliveryCheckImageUploadUrlResultResolvers<ContextType>;
  OrderDeliveryCheckImageNotFound?: OrderDeliveryCheckImageNotFoundResolvers<ContextType>;
  CreateEmailListResponse?: CreateEmailListResponseResolvers<ContextType>;
  EmailListCreated?: EmailListCreatedResolvers<ContextType>;
  CreateProfileResponse?: CreateProfileResponseResolvers<ContextType>;
  BuyerExists?: BuyerExistsResolvers<ContextType>;
  CreateProfileError?: CreateProfileErrorResolvers<ContextType>;
  PushEndpointResponse?: PushEndpointResponseResolvers<ContextType>;
  NotificationPreferences?: NotificationPreferencesResolvers<ContextType>;
  CreateReferralResponse?: CreateReferralResponseResolvers<ContextType>;
  UserHasReferralCode?: UserHasReferralCodeResolvers<ContextType>;
  ReferralCodeGenerationError?: ReferralCodeGenerationErrorResolvers<ContextType>;
  CreateStorageItemResponse?: CreateStorageItemResponseResolvers<ContextType>;
  CreateStorageItemSuccess?: CreateStorageItemSuccessResolvers<ContextType>;
  CreateStorageItemFailure?: CreateStorageItemFailureResolvers<ContextType>;
  createSubCatalogResponse?: CreateSubCatalogResponseResolvers<ContextType>;
  CreateSubCatalogError?: CreateSubCatalogErrorResolvers<ContextType>;
  CreateSupplierContactResponse?: CreateSupplierContactResponseResolvers<ContextType>;
  SupplierContact?: SupplierContactResolvers<ContextType>;
  CreateUpdateSupplierProductResponse?: CreateUpdateSupplierProductResponseResolvers<ContextType>;
  DuplicateProductError?: DuplicateProductErrorResolvers<ContextType>;
  DeactivateSuppliersPaymentAccountResponse?: DeactivateSuppliersPaymentAccountResponseResolvers<ContextType>;
  DeleteBuyerReportScheduleResponse?: DeleteBuyerReportScheduleResponseResolvers<ContextType>;
  DeleteBuyerReportScheduleSuccess?: DeleteBuyerReportScheduleSuccessResolvers<ContextType>;
  BuyerReportScheduleNotFound?: BuyerReportScheduleNotFoundResolvers<ContextType>;
  DeleteBuyerReportScheduleError?: DeleteBuyerReportScheduleErrorResolvers<ContextType>;
  DeleteBuyerStockInventoryProductsResponse?: DeleteBuyerStockInventoryProductsResponseResolvers<ContextType>;
  DeleteBuyerStockInventoryProductsSuccess?: DeleteBuyerStockInventoryProductsSuccessResolvers<ContextType>;
  DeleteBuyerStockInventoryProductsFailure?: DeleteBuyerStockInventoryProductsFailureResolvers<ContextType>;
  DeletedChatSetting?: DeletedChatSettingResolvers<ContextType>;
  deleteSubCatalogResponse?: DeleteSubCatalogResponseResolvers<ContextType>;
  DeleteSubCatalogSuccess?: DeleteSubCatalogSuccessResolvers<ContextType>;
  DeleteSubCatalogError?: DeleteSubCatalogErrorResolvers<ContextType>;
  DeletedSupplierNegotiatedPriceResponse?: DeletedSupplierNegotiatedPriceResponseResolvers<ContextType>;
  DeleteSupplierNegotiatedPriceResult?: DeleteSupplierNegotiatedPriceResultResolvers<ContextType>;
  DisconnectAccountResponse?: DisconnectAccountResponseResolvers<ContextType>;
  DisconnectAccountStatus?: DisconnectAccountStatusResolvers<ContextType>;
  DisconnectAccountError?: DisconnectAccountErrorResolvers<ContextType>;
  DisconnectIntegrationAdapterResponse?: DisconnectIntegrationAdapterResponseResolvers<ContextType>;
  IntegrationAdapterConnectionNotFound?: IntegrationAdapterConnectionNotFoundResolvers<ContextType>;
  EditBuyerReportScheduleResponse?: EditBuyerReportScheduleResponseResolvers<ContextType>;
  GenerateBuyerReportResponse?: GenerateBuyerReportResponseResolvers<ContextType>;
  GetClientDebuggableArtifactUploadUrlResponse?: GetClientDebuggableArtifactUploadUrlResponseResolvers<ContextType>;
  GetClientDebuggableArtifactUploadUrl?: GetClientDebuggableArtifactUploadUrlResolvers<ContextType>;
  GetClientDebuggableArtifactUploadUrlError?: GetClientDebuggableArtifactUploadUrlErrorResolvers<ContextType>;
  GetOrderGuideUploadUrlResponse?: GetOrderGuideUploadUrlResponseResolvers<ContextType>;
  GetOrderGuideUploadUrl?: GetOrderGuideUploadUrlResolvers<ContextType>;
  GetOrderGuideUploadUrlError?: GetOrderGuideUploadUrlErrorResolvers<ContextType>;
  ImportSupplierProductsReport?: ImportSupplierProductsReportResolvers<ContextType>;
  InitInventoryDownloadResponse?: InitInventoryDownloadResponseResolvers<ContextType>;
  InitInventoryDownloadSuccess?: InitInventoryDownloadSuccessResolvers<ContextType>;
  InitInventoryDownloadFailure?: InitInventoryDownloadFailureResolvers<ContextType>;
  InitInventoryUploadResponse?: InitInventoryUploadResponseResolvers<ContextType>;
  InitInventoryUploadSuccess?: InitInventoryUploadSuccessResolvers<ContextType>;
  InitInventoryUploadFailure?: InitInventoryUploadFailureResolvers<ContextType>;
  InitiateCheckoutResponse?: InitiateCheckoutResponseResolvers<ContextType>;
  BalanceCheckoutToken?: BalanceCheckoutTokenResolvers<ContextType>;
  SupplierPaymentAccountMissing?: SupplierPaymentAccountMissingResolvers<ContextType>;
  InvoiceAlreadyPaid?: InvoiceAlreadyPaidResolvers<ContextType>;
  InvoicePaymentInProgress?: InvoicePaymentInProgressResolvers<ContextType>;
  InvoiceTotalTooLow?: InvoiceTotalTooLowResolvers<ContextType>;
  IntegrationAdapterConnectionAuthResponse?: IntegrationAdapterConnectionAuthResponseResolvers<ContextType>;
  IntegrationAdapterConnectionAuthRedirect?: IntegrationAdapterConnectionAuthRedirectResolvers<ContextType>;
  IntegrationAdapterConnectionConsentResponse?: IntegrationAdapterConnectionConsentResponseResolvers<ContextType>;
  IntegrationAdapterConnectionConsentChallenge?: IntegrationAdapterConnectionConsentChallengeResolvers<ContextType>;
  IntegrationAdapterConnectionConsentRedirect?: IntegrationAdapterConnectionConsentRedirectResolvers<ContextType>;
  IntegrationAdapterConnectionCreateResponse?: IntegrationAdapterConnectionCreateResponseResolvers<ContextType>;
  IntegrationAdapterScopeInsufficient?: IntegrationAdapterScopeInsufficientResolvers<ContextType>;
  IntegrationAdapterConnectionUpdateResponse?: IntegrationAdapterConnectionUpdateResponseResolvers<ContextType>;
  IntegrationAdapterCreateResponse?: IntegrationAdapterCreateResponseResolvers<ContextType>;
  IntegrationAdapterExists?: IntegrationAdapterExistsResolvers<ContextType>;
  IntegrationAdapterUpdateResponse?: IntegrationAdapterUpdateResponseResolvers<ContextType>;
  AttemptToChangeAdapterAuthType?: AttemptToChangeAdapterAuthTypeResolvers<ContextType>;
  AttemptToReduceIntegrationAdapterScope?: AttemptToReduceIntegrationAdapterScopeResolvers<ContextType>;
  IntegrationWebhookRetryResponse?: IntegrationWebhookRetryResponseResolvers<ContextType>;
  IntegrationWebhookRetryResults?: IntegrationWebhookRetryResultsResolvers<ContextType>;
  IntegrationWebhookRetryResult?: IntegrationWebhookRetryResultResolvers<ContextType>;
  IntegrationWebhookRetrySuccess?: IntegrationWebhookRetrySuccessResolvers<ContextType>;
  IntegrationWebhookRetryFailure?: IntegrationWebhookRetryFailureResolvers<ContextType>;
  InternalInviteUsersResponse?: InternalInviteUsersResponseResolvers<ContextType>;
  UsersList?: UsersListResolvers<ContextType>;
  inviteNonChocoUserToBuyerResponse?: InviteNonChocoUserToBuyerResponseResolvers<ContextType>;
  BuyerNotFound?: BuyerNotFoundResolvers<ContextType>;
  InvitorNotFound?: InvitorNotFoundResolvers<ContextType>;
  ExistingInvitedUser?: ExistingInvitedUserResolvers<ContextType>;
  PuppyValidationFailure?: PuppyValidationFailureResolvers<ContextType>;
  InviteUserToBuyerResponse?: InviteUserToBuyerResponseResolvers<ContextType>;
  InviteUserToBuyerError?: InviteUserToBuyerErrorResolvers<ContextType>;
  KycCreateResponse?: KycCreateResponseResolvers<ContextType>;
  KycResponse?: KycResponseResolvers<ContextType>;
  KycBuyerNotFound?: KycBuyerNotFoundResolvers<ContextType>;
  KycEntryAlreadyExists?: KycEntryAlreadyExistsResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  OrderCreatedResponse?: OrderCreatedResponseResolvers<ContextType>;
  OrderEditedResponse?: OrderEditedResponseResolvers<ContextType>;
  OrderEditedError?: OrderEditedErrorResolvers<ContextType>;
  OrderExportConfig?: OrderExportConfigResolvers<ContextType>;
  OrderGuideCreatedResponse?: OrderGuideCreatedResponseResolvers<ContextType>;
  OrderGuideCreatedSuccess?: OrderGuideCreatedSuccessResolvers<ContextType>;
  OrderGuideCreatedError?: OrderGuideCreatedErrorResolvers<ContextType>;
  OrderGuideRequestResponse?: OrderGuideRequestResponseResolvers<ContextType>;
  OrderGuideRequest?: OrderGuideRequestResolvers<ContextType>;
  OrderGuideRequestError?: OrderGuideRequestErrorResolvers<ContextType>;
  OrderGuideV2ItemUnitsAddResponse?: OrderGuideV2ItemUnitsAddResponseResolvers<ContextType>;
  OrderGuideV2ItemUnitsAddResult?: OrderGuideV2ItemUnitsAddResultResolvers<ContextType>;
  OrderGuideV2ItemUnitsRemoveResponse?: OrderGuideV2ItemUnitsRemoveResponseResolvers<ContextType>;
  OrderGuideV2ItemUnitsRemoveResult?: OrderGuideV2ItemUnitsRemoveResultResolvers<ContextType>;
  PaymentAuthorizeResponse?: PaymentAuthorizeResponseResolvers<ContextType>;
  PostProcessing?: PostProcessingResolvers<ContextType>;
  PreProcessing?: PreProcessingResolvers<ContextType>;
  NoFurtherActionNeeded?: NoFurtherActionNeededResolvers<ContextType>;
  PaymentAccountIsInactive?: PaymentAccountIsInactiveResolvers<ContextType>;
  UnexpectedInvoiceState?: UnexpectedInvoiceStateResolvers<ContextType>;
  SupplierDoesNotAcceptOnlinePayments?: SupplierDoesNotAcceptOnlinePaymentsResolvers<ContextType>;
  EntityCurrencyMismatch?: EntityCurrencyMismatchResolvers<ContextType>;
  UpdatedCategoryProduct?: UpdatedCategoryProductResolvers<ContextType>;
  ReferUserResponse?: ReferUserResponseResolvers<ContextType>;
  ReferUserResult?: ReferUserResultResolvers<ContextType>;
  ReferUserChatExists?: ReferUserChatExistsResolvers<ContextType>;
  ReferUserReferralCodeNotFound?: ReferUserReferralCodeNotFoundResolvers<ContextType>;
  OmnichannelOrdersSubcriptionResponse?: OmnichannelOrdersSubcriptionResponseResolvers<ContextType>;
  OrderDeskNotification?: OrderDeskNotificationResolvers<ContextType>;
  RejectOrderResponse?: RejectOrderResponseResolvers<ContextType>;
  OrderRejected?: OrderRejectedResolvers<ContextType>;
  RejectOrdersByIdResponse?: RejectOrdersByIdResponseResolvers<ContextType>;
  OrdersRejected?: OrdersRejectedResolvers<ContextType>;
  RemoveCCEmailFromChatsReport?: RemoveCcEmailFromChatsReportResolvers<ContextType>;
  RemoveEmailFromBuyerReportScheduleResponse?: RemoveEmailFromBuyerReportScheduleResponseResolvers<ContextType>;
  EmailFromBuyerReportScheduleRemoved?: EmailFromBuyerReportScheduleRemovedResolvers<ContextType>;
  EmailInBuyerReportScheduleNotFound?: EmailInBuyerReportScheduleNotFoundResolvers<ContextType>;
  RemoveEntitiesFromGroupResponse?: RemoveEntitiesFromGroupResponseResolvers<ContextType>;
  RemoveEntitiesFromGroupResponseSuccess?: RemoveEntitiesFromGroupResponseSuccessResolvers<ContextType>;
  RemoveEntitiesFromGroupResponseError?: RemoveEntitiesFromGroupResponseErrorResolvers<ContextType>;
  RemoveInvoiceResponse?: RemoveInvoiceResponseResolvers<ContextType>;
  InvoiceRemoved?: InvoiceRemovedResolvers<ContextType>;
  InvoiceCannotBeRemoved?: InvoiceCannotBeRemovedResolvers<ContextType>;
  RemoveInvoiceAttachmentResponse?: RemoveInvoiceAttachmentResponseResolvers<ContextType>;
  InvoiceAttachmentRemoved?: InvoiceAttachmentRemovedResolvers<ContextType>;
  InvoiceCannotBeUpdated?: InvoiceCannotBeUpdatedResolvers<ContextType>;
  OrderDeskRemovedEmailResponse?: OrderDeskRemovedEmailResponseResolvers<ContextType>;
  OrderDeskEmailRemoved?: OrderDeskEmailRemovedResolvers<ContextType>;
  RemovePaymentAccountResponse?: RemovePaymentAccountResponseResolvers<ContextType>;
  PaymentAccountRemoved?: PaymentAccountRemovedResolvers<ContextType>;
  RemoveProductsFromOrderGuidesResponse?: RemoveProductsFromOrderGuidesResponseResolvers<ContextType>;
  RemoveProductsFromOrderGuidesResult?: RemoveProductsFromOrderGuidesResultResolvers<ContextType>;
  MinimumOrderValueUpdateResponse?: MinimumOrderValueUpdateResponseResolvers<ContextType>;
  MinimumOrderValueUpdate?: MinimumOrderValueUpdateResolvers<ContextType>;
  RemoveUsersFromGroupResponse?: RemoveUsersFromGroupResponseResolvers<ContextType>;
  RemoveUsersFromGroupSuccess?: RemoveUsersFromGroupSuccessResolvers<ContextType>;
  RemoveUsersFromGroupError?: RemoveUsersFromGroupErrorResolvers<ContextType>;
  RequestToJoinBuyerResponse?: RequestToJoinBuyerResponseResolvers<ContextType>;
  RequestToJoinBuyerError?: RequestToJoinBuyerErrorResolvers<ContextType>;
  SelectProductForOrderGuideResponse?: SelectProductForOrderGuideResponseResolvers<ContextType>;
  SelectProductForOrderGuideSuccess?: SelectProductForOrderGuideSuccessResolvers<ContextType>;
  SelectProductsForOrderGuideResponse?: SelectProductsForOrderGuideResponseResolvers<ContextType>;
  SelectProductsForOrderGuideSuccess?: SelectProductsForOrderGuideSuccessResolvers<ContextType>;
  SendInviteTransmissionResponse?: SendInviteTransmissionResponseResolvers<ContextType>;
  SendSyntheticSmsMessageResponse?: SendSyntheticSmsMessageResponseResolvers<ContextType>;
  SendSyntheticSmsMessageSuccess?: SendSyntheticSmsMessageSuccessResolvers<ContextType>;
  SendSyntheticWhatsAppMessageResponse?: SendSyntheticWhatsAppMessageResponseResolvers<ContextType>;
  SendSyntheticWhatsAppMessageSuccess?: SendSyntheticWhatsAppMessageSuccessResolvers<ContextType>;
  SetOrderAsTestResponse?: SetOrderAsTestResponseResolvers<ContextType>;
  TestOrderResponse?: TestOrderResponseResolvers<ContextType>;
  CartSubmissionResponse?: CartSubmissionResponseResolvers<ContextType>;
  CartSubmissionResult?: CartSubmissionResultResolvers<ContextType>;
  CartSubmissionError?: CartSubmissionErrorResolvers<ContextType>;
  CreateMessageError?: CreateMessageErrorResolvers<ContextType>;
  CartSubmittedEmptyError?: CartSubmittedEmptyErrorResolvers<ContextType>;
  CartInvalidProductsError?: CartInvalidProductsErrorResolvers<ContextType>;
  CartAllProductsUnavailableError?: CartAllProductsUnavailableErrorResolvers<ContextType>;
  ForbiddenError?: ForbiddenErrorResolvers<ContextType>;
  ExistingOrderError?: ExistingOrderErrorResolvers<ContextType>;
  ProductLeadTimeError?: ProductLeadTimeErrorResolvers<ContextType>;
  OrderDeliveryCheckSubmissionResponse?: OrderDeliveryCheckSubmissionResponseResolvers<ContextType>;
  OrderDeliveryCheckNotFound?: OrderDeliveryCheckNotFoundResolvers<ContextType>;
  OrderedProductDeliveryCheckSubmissionResponse?: OrderedProductDeliveryCheckSubmissionResponseResolvers<ContextType>;
  SubmitStockCountSessionResponse?: SubmitStockCountSessionResponseResolvers<ContextType>;
  SubmitStockCountSessionFailure?: SubmitStockCountSessionFailureResolvers<ContextType>;
  SubmitStockCountSessionSuccess?: SubmitStockCountSessionSuccessResolvers<ContextType>;
  SupplierAddRequestResponse?: SupplierAddRequestResponseResolvers<ContextType>;
  SupplierAddRequest?: SupplierAddRequestResolvers<ContextType>;
  SupplierAddRequestError?: SupplierAddRequestErrorResolvers<ContextType>;
  SupplierGetInTouchRequestResponse?: SupplierGetInTouchRequestResponseResolvers<ContextType>;
  SupplierGetInTouchRequestSuccess?: SupplierGetInTouchRequestSuccessResolvers<ContextType>;
  SupplierUpdateError?: SupplierUpdateErrorResolvers<ContextType>;
  SupplierGetInTouchRequestError?: SupplierGetInTouchRequestErrorResolvers<ContextType>;
  SupplierInviteUserResponse?: SupplierInviteUserResponseResolvers<ContextType>;
  SupplierInviteResponseEntity?: SupplierInviteResponseEntityResolvers<ContextType>;
  InvalidInvitedPhoneNumber?: InvalidInvitedPhoneNumberResolvers<ContextType>;
  SupplierInviteError?: SupplierInviteErrorResolvers<ContextType>;
  SupplierUserRemoveResponse?: SupplierUserRemoveResponseResolvers<ContextType>;
  TriggerProductMatchingResponse?: TriggerProductMatchingResponseResolvers<ContextType>;
  UnassignUserFromOrderToReviewResponse?: UnassignUserFromOrderToReviewResponseResolvers<ContextType>;
  UnassignUserFromOrderToReviewResponseSuccess?: UnassignUserFromOrderToReviewResponseSuccessResolvers<ContextType>;
  UnassignUserFromOrderToReviewResponseError?: UnassignUserFromOrderToReviewResponseErrorResolvers<ContextType>;
  UndoMultiLocationOrderGuideTransactionResponse?: UndoMultiLocationOrderGuideTransactionResponseResolvers<ContextType>;
  UndoMultiLocationOrderGuideTransactionResult?: UndoMultiLocationOrderGuideTransactionResultResolvers<ContextType>;
  UpdateBuyerInventoryProductResponse?: UpdateBuyerInventoryProductResponseResolvers<ContextType>;
  UpdateBuyerStockInventoryProductResponse?: UpdateBuyerStockInventoryProductResponseResolvers<ContextType>;
  UpdateBuyerStockInventoryProductFailure?: UpdateBuyerStockInventoryProductFailureResolvers<ContextType>;
  CartUpdateResponse?: CartUpdateResponseResolvers<ContextType>;
  NegativeAmountError?: NegativeAmountErrorResolvers<ContextType>;
  UpdateInventoryItemResponse?: UpdateInventoryItemResponseResolvers<ContextType>;
  UpdateInventoryItemSuccess?: UpdateInventoryItemSuccessResolvers<ContextType>;
  UpdateInventoryItemFailure?: UpdateInventoryItemFailureResolvers<ContextType>;
  UpdateInvoiceResponse?: UpdateInvoiceResponseResolvers<ContextType>;
  UpdateInvoicedProductResponse?: UpdateInvoicedProductResponseResolvers<ContextType>;
  InvoicedProducts?: InvoicedProductsResolvers<ContextType>;
  UpdatePendingUserResponse?: UpdatePendingUserResponseResolvers<ContextType>;
  UpdateProductVariantsInOrderGuideResponse?: UpdateProductVariantsInOrderGuideResponseResolvers<ContextType>;
  UpdateProductVariantsInOrderGuideSuccess?: UpdateProductVariantsInOrderGuideSuccessResolvers<ContextType>;
  UpdateJoinRequestResponse?: UpdateJoinRequestResponseResolvers<ContextType>;
  UpdateJoinRequestSuccess?: UpdateJoinRequestSuccessResolvers<ContextType>;
  UpdateJoinRequestError?: UpdateJoinRequestErrorResolvers<ContextType>;
  UpdateStorageItemResponse?: UpdateStorageItemResponseResolvers<ContextType>;
  UpdateStorageItemSuccess?: UpdateStorageItemSuccessResolvers<ContextType>;
  UpdateStorageItemFailure?: UpdateStorageItemFailureResolvers<ContextType>;
  updateSubCatalogResponse?: UpdateSubCatalogResponseResolvers<ContextType>;
  UpdateSubCatalogError?: UpdateSubCatalogErrorResolvers<ContextType>;
  UpdateSubCatalogChatsResponse?: UpdateSubCatalogChatsResponseResolvers<ContextType>;
  UpdateSubCatalogChatsResult?: UpdateSubCatalogChatsResultResolvers<ContextType>;
  UpdateSubCatalogChatsSummary?: UpdateSubCatalogChatsSummaryResolvers<ContextType>;
  SubCatalogChat?: SubCatalogChatResolvers<ContextType>;
  EntityIdentity?: EntityIdentityResolvers<ContextType>;
  IntegrationEntityIdentity?: IntegrationEntityIdentityResolvers<ContextType>;
  InternalEntityIdentity?: InternalEntityIdentityResolvers<ContextType>;
  InvalidSubCatalogChat?: InvalidSubCatalogChatResolvers<ContextType>;
  SupplierUpdateAccessPackageResponse?: SupplierUpdateAccessPackageResponseResolvers<ContextType>;
  SupplierUpdateAccessPackageSuccess?: SupplierUpdateAccessPackageSuccessResolvers<ContextType>;
  SupplierUpdateAccessPackageError?: SupplierUpdateAccessPackageErrorResolvers<ContextType>;
  SupplierUserUpdateChatsResponse?: SupplierUserUpdateChatsResponseResolvers<ContextType>;
  UploadSubCatalogProductsResponse?: UploadSubCatalogProductsResponseResolvers<ContextType>;
  UploadSubCatalogProductsResult?: UploadSubCatalogProductsResultResolvers<ContextType>;
  UploadSubCatalogProductsError?: UploadSubCatalogProductsErrorResolvers<ContextType>;
  UpsertStockCountSessionItemsResponse?: UpsertStockCountSessionItemsResponseResolvers<ContextType>;
  UpsertStockCountSessionItemsSuccess?: UpsertStockCountSessionItemsSuccessResolvers<ContextType>;
  UpsertStockCountSessionItemsError?: UpsertStockCountSessionItemsErrorResolvers<ContextType>;
  UserLead?: UserLeadResolvers<ContextType>;
  UserLeadRequest?: UserLeadRequestResolvers<ContextType>;
  UserRequestToDeleteResponse?: UserRequestToDeleteResponseResolvers<ContextType>;
  UserRequestToDeleteDetails?: UserRequestToDeleteDetailsResolvers<ContextType>;
  VendorItemUnitUpdateResponse?: VendorItemUnitUpdateResponseResolvers<ContextType>;
  VendorItemUnitUpdateResult?: VendorItemUnitUpdateResultResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  AWSIPAddress?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  ActivateChatResponse?: ActivateChatResponseResolvers<ContextType>;
  BuyerChatsNotFound?: BuyerChatsNotFoundResolvers<ContextType>;
  BuyerChatsProductListEmpty?: BuyerChatsProductListEmptyResolvers<ContextType>;
  BuyerChatsResponse?: BuyerChatsResponseResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  OrderResult?: OrderResultResolvers<ContextType>;
  ProductConnection?: ProductConnectionResolvers<ContextType>;
  ProductEdge?: ProductEdgeResolvers<ContextType>;
  ProductMatchData?: ProductMatchDataResolvers<ContextType>;
  SupplierContactAlreadyCreated?: SupplierContactAlreadyCreatedResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  aws_api_key?: Aws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_oidc?: Aws_OidcDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
};

export type ConfirmOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfirmOrderMutation = { __typename?: 'Mutation', orderConfirm?: { __typename?: 'Message', id: string } | null };

export type BuyerEdgesFragment = { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> };

export type BuyerFragment = { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null };

export type NotificationFragment = { __typename: 'Notification', id: string, userId: string, message: { __typename?: 'Message', id: string, body: string, user: { __typename?: 'User', id: string }, order?: { __typename?: 'Order', id: string, body?: string | null, deliveryDate?: number | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string } } | null> | null } | null, chat: { __typename?: 'Chat', id: string, buyer?: { __typename?: 'Buyer', id: string } | null } } };

export type NotificationMessageFragment = { __typename?: 'Message', id: string, body: string, user: { __typename?: 'User', id: string }, order?: { __typename?: 'Order', id: string, body?: string | null, deliveryDate?: number | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string } } | null> | null } | null, chat: { __typename?: 'Chat', id: string, buyer?: { __typename?: 'Buyer', id: string } | null } };

export type SearchBuyerEdgesFragment = { __typename?: 'SearchBuyerConnection', edges: Array<{ __typename?: 'BuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> };

export type SearchBuyerFragment = { __typename?: 'Buyer', id: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null };

export type UserFragment = { __typename: 'User', id: string, name?: string | null, phone: string, businessName?: string | null, supplier: boolean, email?: string | null, chocoUser?: boolean | null, supplierId?: string | null, botUser?: boolean | null, isTest?: boolean | null, isPuppy: boolean, pending?: boolean | null, hasAcceptedTermsAndConditions: boolean, createdContext?: UserCreatedContext | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string, accessPackage: AccessPackage, botUser?: { __typename?: 'User', profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null, integration: Array<{ __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationEmailOption', emailAddress?: string | null, type: IntegrationType } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> } | null };

export type LinkedSupplierFragment = { __typename?: 'Supplier', id: string, name: string, referenceId: string, accessPackage: AccessPackage, botUser?: { __typename?: 'User', profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null, integration: Array<{ __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationEmailOption', emailAddress?: string | null, type: IntegrationType } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationWhatsAppOption' }> };

type SupplierIntegrationsFragment_IntegrationSmsOption_ = { __typename?: 'IntegrationSmsOption' };

type SupplierIntegrationsFragment_IntegrationEmailOption_ = { __typename?: 'IntegrationEmailOption', emailAddress?: string | null, type: IntegrationType };

type SupplierIntegrationsFragment_IntegrationFaxOption_ = { __typename?: 'IntegrationFaxOption' };

type SupplierIntegrationsFragment_IntegrationWhatsAppOption_ = { __typename?: 'IntegrationWhatsAppOption' };

export type SupplierIntegrationsFragment = SupplierIntegrationsFragment_IntegrationSmsOption_ | SupplierIntegrationsFragment_IntegrationEmailOption_ | SupplierIntegrationsFragment_IntegrationFaxOption_ | SupplierIntegrationsFragment_IntegrationWhatsAppOption_;

export type BuyerCreateMutationVariables = Exact<{
  buyer: BuyerCreateInput;
}>;


export type BuyerCreateMutation = { __typename?: 'Mutation', buyerCreate: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } };

export type CreateProfileMutationVariables = Exact<{
  user: CreateProfileInput;
}>;


export type CreateProfileMutation = { __typename?: 'Mutation', createProfile: { __typename: 'User', id: string } | { __typename: 'BuyerExists' } | { __typename: 'CreateProfileError', message?: string | null } };

export type OrderConfirmMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderConfirmMutation = { __typename?: 'Mutation', orderConfirm?: { __typename: 'Message', id: string, body: string, createdAt: number, order?: { __typename?: 'Order', orderSupplierStatus?: string | null } | null } | null };

export type RequestToJoinBuyerMutationVariables = Exact<{
  buyerId: Scalars['String']['input'];
}>;


export type RequestToJoinBuyerMutation = { __typename?: 'Mutation', requestToJoinBuyer: { __typename?: 'UserRequestToJoin', status: JoinRequestStatus } | { __typename?: 'RequestToJoinBuyerError' } | { __typename?: 'AuthorizationFailure' } };

export type SupplierGetInTouchMutationVariables = Exact<{
  input: SupplierGetInTouchRequestInput;
}>;


export type SupplierGetInTouchMutation = { __typename?: 'Mutation', supplierGetInTouchRequest?: { __typename: 'SupplierGetInTouchRequestSuccess' } | { __typename: 'SupplierGetInTouchRequestError', message?: string | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  user: UserUpdateInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', userUpdate?: { __typename: 'User', id: string, name?: string | null, phone: string, businessName?: string | null, supplier: boolean, email?: string | null, chocoUser?: boolean | null, supplierId?: string | null, botUser?: boolean | null, isTest?: boolean | null, isPuppy: boolean, pending?: boolean | null, hasAcceptedTermsAndConditions: boolean, createdContext?: UserCreatedContext | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string, accessPackage: AccessPackage, botUser?: { __typename?: 'User', profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null, integration: Array<{ __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationEmailOption', emailAddress?: string | null, type: IntegrationType } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> } | null } | null };

export type IsUserInChatQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
}>;


export type IsUserInChatQuery = { __typename?: 'Query', isUserInChat: boolean };

export type SearchBuyerQueryVariables = Exact<{
  query: SearchBuyerInput;
}>;


export type SearchBuyerQuery = { __typename?: 'Query', searchBuyer: { __typename?: 'SearchBuyerConnection', edges: Array<{ __typename?: 'BuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> } | { __typename?: 'InputValidationFailure', responseType: ResponseType } | { __typename?: 'AuthorizationFailure' } };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename: 'User', id: string, name?: string | null, phone: string, businessName?: string | null, supplier: boolean, email?: string | null, chocoUser?: boolean | null, supplierId?: string | null, botUser?: boolean | null, isTest?: boolean | null, isPuppy: boolean, pending?: boolean | null, hasAcceptedTermsAndConditions: boolean, createdContext?: UserCreatedContext | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string, accessPackage: AccessPackage, botUser?: { __typename?: 'User', profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null, integration: Array<{ __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationEmailOption', emailAddress?: string | null, type: IntegrationType } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', node: { __typename?: 'Buyer', id: string, name: string, fullAddress: string, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, longitude?: number | null, latitude?: number | null, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } }> } | null } | null };

export type GetUserIntercomCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserIntercomCredentialsQuery = { __typename?: 'Query', getUserIntercomCredentials: { __typename?: 'UserIntercomCredentialsSuccess', webHash: string } | { __typename?: 'UserIntercomCredentialsFailure' } };

export type OnNotificationCreateSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OnNotificationCreateSubscription = { __typename?: 'Subscription', onNotificationCreate?: { __typename: 'Notification', id: string, userId: string, message: { __typename?: 'Message', id: string, body: string, user: { __typename?: 'User', id: string }, order?: { __typename?: 'Order', id: string, body?: string | null, deliveryDate?: number | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string } } | null> | null } | null, chat: { __typename?: 'Chat', id: string, buyer?: { __typename?: 'Buyer', id: string } | null } } } | null };

export type MessageCreateDataMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  senderId?: InputMaybe<Scalars['String']['input']>;
  message: MessageInput;
  order?: InputMaybe<OrderInput>;
}>;


export type MessageCreateDataMutation = { __typename?: 'Mutation', messageCreate: { __typename?: 'Message', id: string } };

export const NotificationMessageFragmentDoc = gql`
    fragment NotificationMessageFragment on Message {
  id
  body
  user {
    id
  }
  order {
    id
    body
    deliveryDate
    orderProducts {
      amount
      product {
        id
      }
    }
  }
  chat {
    id
    buyer {
      id
    }
  }
}
    `;
export const NotificationFragmentDoc = gql`
    fragment NotificationFragment on Notification {
  __typename
  id
  userId
  message {
    ...NotificationMessageFragment
  }
}
    ${NotificationMessageFragmentDoc}`;
export const BuyerFragmentDoc = gql`
    fragment BuyerFragment on Buyer {
  id
  name
  fullAddress
  profileImage {
    smallSquare
  }
  googlePlaceId
  googlePlaceAddressId
  longitude
  latitude
}
    `;
export const SearchBuyerEdgesFragmentDoc = gql`
    fragment SearchBuyerEdgesFragment on SearchBuyerConnection {
  edges {
    ... on BuyerEdge {
      node {
        ...BuyerFragment
      }
    }
  }
}
    ${BuyerFragmentDoc}`;
export const SearchBuyerFragmentDoc = gql`
    fragment SearchBuyerFragment on Buyer {
  id
  googlePlaceId
  googlePlaceAddressId
}
    `;
export const SupplierIntegrationsFragmentDoc = gql`
    fragment SupplierIntegrationsFragment on IntegrationOption {
  ... on IntegrationEmailOption {
    emailAddress
    type
  }
}
    `;
export const LinkedSupplierFragmentDoc = gql`
    fragment LinkedSupplierFragment on Supplier {
  id
  name
  referenceId
  accessPackage
  botUser {
    profileImage {
      smallSquare
    }
  }
  integration {
    ...SupplierIntegrationsFragment
  }
}
    ${SupplierIntegrationsFragmentDoc}`;
export const BuyerEdgesFragmentDoc = gql`
    fragment BuyerEdgesFragment on UserBuyerConnection {
  edges {
    node {
      ...BuyerFragment
    }
  }
}
    ${BuyerFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment UserFragment on User {
  __typename
  id
  name
  phone
  businessName
  supplier
  email
  chocoUser
  supplierId
  botUser
  linkedSupplier {
    ...LinkedSupplierFragment
  }
  isTest
  isPuppy
  pending
  profileImage {
    smallSquare
  }
  buyers {
    ...BuyerEdgesFragment
  }
  hasAcceptedTermsAndConditions
  createdContext
}
    ${LinkedSupplierFragmentDoc}
${BuyerEdgesFragmentDoc}`;
export const ConfirmOrderDocument = gql`
    mutation confirmOrder($id: ID!) {
  orderConfirm(id: $id) {
    id
  }
}
    `;
export type ConfirmOrderMutationFn = ApolloReactCommon.MutationFunction<ConfirmOrderMutation, ConfirmOrderMutationVariables>;

/**
 * __useConfirmOrderMutation__
 *
 * To run a mutation, you first call `useConfirmOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrderMutation, { data, loading, error }] = useConfirmOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmOrderMutation, ConfirmOrderMutationVariables>(ConfirmOrderDocument, options);
      }
export type ConfirmOrderMutationHookResult = ReturnType<typeof useConfirmOrderMutation>;
export type ConfirmOrderMutationResult = ApolloReactCommon.MutationResult<ConfirmOrderMutation>;
export type ConfirmOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfirmOrderMutation, ConfirmOrderMutationVariables>;
export const BuyerCreateDocument = gql`
    mutation BuyerCreate($buyer: BuyerCreateInput!) {
  buyerCreate(buyer: $buyer) {
    ...BuyerFragment
  }
}
    ${BuyerFragmentDoc}`;
export type BuyerCreateMutationFn = ApolloReactCommon.MutationFunction<BuyerCreateMutation, BuyerCreateMutationVariables>;

/**
 * __useBuyerCreateMutation__
 *
 * To run a mutation, you first call `useBuyerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerCreateMutation, { data, loading, error }] = useBuyerCreateMutation({
 *   variables: {
 *      buyer: // value for 'buyer'
 *   },
 * });
 */
export function useBuyerCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerCreateMutation, BuyerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerCreateMutation, BuyerCreateMutationVariables>(BuyerCreateDocument, options);
      }
export type BuyerCreateMutationHookResult = ReturnType<typeof useBuyerCreateMutation>;
export type BuyerCreateMutationResult = ApolloReactCommon.MutationResult<BuyerCreateMutation>;
export type BuyerCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerCreateMutation, BuyerCreateMutationVariables>;
export const CreateProfileDocument = gql`
    mutation CreateProfile($user: CreateProfileInput!) {
  createProfile(user: $user) {
    ... on User {
      __typename
      id
    }
    ... on BuyerExists {
      __typename
    }
    ... on CreateProfileError {
      __typename
      message
    }
  }
}
    `;
export type CreateProfileMutationFn = ApolloReactCommon.MutationFunction<CreateProfileMutation, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProfileMutation, CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProfileMutation, CreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = ApolloReactCommon.MutationResult<CreateProfileMutation>;
export type CreateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProfileMutation, CreateProfileMutationVariables>;
export const OrderConfirmDocument = gql`
    mutation OrderConfirm($id: ID!) {
  orderConfirm(id: $id) {
    __typename
    id
    body
    createdAt
    order {
      orderSupplierStatus
    }
  }
}
    `;
export type OrderConfirmMutationFn = ApolloReactCommon.MutationFunction<OrderConfirmMutation, OrderConfirmMutationVariables>;

/**
 * __useOrderConfirmMutation__
 *
 * To run a mutation, you first call `useOrderConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderConfirmMutation, { data, loading, error }] = useOrderConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrderConfirmMutation, OrderConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrderConfirmMutation, OrderConfirmMutationVariables>(OrderConfirmDocument, options);
      }
export type OrderConfirmMutationHookResult = ReturnType<typeof useOrderConfirmMutation>;
export type OrderConfirmMutationResult = ApolloReactCommon.MutationResult<OrderConfirmMutation>;
export type OrderConfirmMutationOptions = ApolloReactCommon.BaseMutationOptions<OrderConfirmMutation, OrderConfirmMutationVariables>;
export const RequestToJoinBuyerMutationDocument = gql`
    mutation RequestToJoinBuyerMutation($buyerId: String!) {
  requestToJoinBuyer(buyerId: $buyerId) {
    ... on UserRequestToJoin {
      status
    }
  }
}
    `;
export type RequestToJoinBuyerMutationMutationFn = ApolloReactCommon.MutationFunction<RequestToJoinBuyerMutation, RequestToJoinBuyerMutationVariables>;

/**
 * __useRequestToJoinBuyerMutation__
 *
 * To run a mutation, you first call `useRequestToJoinBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestToJoinBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestToJoinBuyerMutation, { data, loading, error }] = useRequestToJoinBuyerMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useRequestToJoinBuyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestToJoinBuyerMutation, RequestToJoinBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestToJoinBuyerMutation, RequestToJoinBuyerMutationVariables>(RequestToJoinBuyerMutationDocument, options);
      }
export type RequestToJoinBuyerMutationHookResult = ReturnType<typeof useRequestToJoinBuyerMutation>;
export type RequestToJoinBuyerMutationMutationResult = ApolloReactCommon.MutationResult<RequestToJoinBuyerMutation>;
export type RequestToJoinBuyerMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestToJoinBuyerMutation, RequestToJoinBuyerMutationVariables>;
export const SupplierGetInTouchDocument = gql`
    mutation supplierGetInTouch($input: SupplierGetInTouchRequestInput!) {
  supplierGetInTouchRequest(input: $input) {
    ... on SupplierGetInTouchRequestSuccess {
      __typename
    }
    ... on SupplierGetInTouchRequestError {
      __typename
      message
    }
  }
}
    `;
export type SupplierGetInTouchMutationFn = ApolloReactCommon.MutationFunction<SupplierGetInTouchMutation, SupplierGetInTouchMutationVariables>;

/**
 * __useSupplierGetInTouchMutation__
 *
 * To run a mutation, you first call `useSupplierGetInTouchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierGetInTouchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierGetInTouchMutation, { data, loading, error }] = useSupplierGetInTouchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupplierGetInTouchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SupplierGetInTouchMutation, SupplierGetInTouchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SupplierGetInTouchMutation, SupplierGetInTouchMutationVariables>(SupplierGetInTouchDocument, options);
      }
export type SupplierGetInTouchMutationHookResult = ReturnType<typeof useSupplierGetInTouchMutation>;
export type SupplierGetInTouchMutationResult = ApolloReactCommon.MutationResult<SupplierGetInTouchMutation>;
export type SupplierGetInTouchMutationOptions = ApolloReactCommon.BaseMutationOptions<SupplierGetInTouchMutation, SupplierGetInTouchMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($user: UserUpdateInput!) {
  userUpdate(user: $user) {
    ...UserFragment
  }
}
    ${UserFragmentDoc}`;
export type UpdateProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = ApolloReactCommon.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const IsUserInChatDocument = gql`
    query isUserInChat($userId: ID!, $chatId: ID!) {
  isUserInChat(userId: $userId, chatId: $chatId)
}
    `;

/**
 * __useIsUserInChatQuery__
 *
 * To run a query within a React component, call `useIsUserInChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserInChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserInChatQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useIsUserInChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IsUserInChatQuery, IsUserInChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsUserInChatQuery, IsUserInChatQueryVariables>(IsUserInChatDocument, options);
      }
export function useIsUserInChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsUserInChatQuery, IsUserInChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsUserInChatQuery, IsUserInChatQueryVariables>(IsUserInChatDocument, options);
        }
export type IsUserInChatQueryHookResult = ReturnType<typeof useIsUserInChatQuery>;
export type IsUserInChatLazyQueryHookResult = ReturnType<typeof useIsUserInChatLazyQuery>;
export type IsUserInChatQueryResult = ApolloReactCommon.QueryResult<IsUserInChatQuery, IsUserInChatQueryVariables>;
export const SearchBuyerDocument = gql`
    query SearchBuyer($query: SearchBuyerInput!) {
  searchBuyer(first: 10, query: $query) {
    ... on SearchBuyerConnection {
      ...SearchBuyerEdgesFragment
    }
    ... on InputValidationFailure {
      responseType
    }
  }
}
    ${SearchBuyerEdgesFragmentDoc}`;

/**
 * __useSearchBuyerQuery__
 *
 * To run a query within a React component, call `useSearchBuyerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyerQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchBuyerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchBuyerQuery, SearchBuyerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchBuyerQuery, SearchBuyerQueryVariables>(SearchBuyerDocument, options);
      }
export function useSearchBuyerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchBuyerQuery, SearchBuyerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchBuyerQuery, SearchBuyerQueryVariables>(SearchBuyerDocument, options);
        }
export type SearchBuyerQueryHookResult = ReturnType<typeof useSearchBuyerQuery>;
export type SearchBuyerLazyQueryHookResult = ReturnType<typeof useSearchBuyerLazyQuery>;
export type SearchBuyerQueryResult = ApolloReactCommon.QueryResult<SearchBuyerQuery, SearchBuyerQueryVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(id: $userId) {
    ...UserFragment
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = ApolloReactCommon.QueryResult<UserQuery, UserQueryVariables>;
export const GetUserIntercomCredentialsDocument = gql`
    query getUserIntercomCredentials {
  getUserIntercomCredentials {
    ... on UserIntercomCredentialsSuccess {
      webHash
    }
  }
}
    `;

/**
 * __useGetUserIntercomCredentialsQuery__
 *
 * To run a query within a React component, call `useGetUserIntercomCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIntercomCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIntercomCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserIntercomCredentialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserIntercomCredentialsQuery, GetUserIntercomCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserIntercomCredentialsQuery, GetUserIntercomCredentialsQueryVariables>(GetUserIntercomCredentialsDocument, options);
      }
export function useGetUserIntercomCredentialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserIntercomCredentialsQuery, GetUserIntercomCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserIntercomCredentialsQuery, GetUserIntercomCredentialsQueryVariables>(GetUserIntercomCredentialsDocument, options);
        }
export type GetUserIntercomCredentialsQueryHookResult = ReturnType<typeof useGetUserIntercomCredentialsQuery>;
export type GetUserIntercomCredentialsLazyQueryHookResult = ReturnType<typeof useGetUserIntercomCredentialsLazyQuery>;
export type GetUserIntercomCredentialsQueryResult = ApolloReactCommon.QueryResult<GetUserIntercomCredentialsQuery, GetUserIntercomCredentialsQueryVariables>;
export const OnNotificationCreateDocument = gql`
    subscription OnNotificationCreate($userId: ID!) {
  onNotificationCreate(userId: $userId) {
    ...NotificationFragment
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useOnNotificationCreateSubscription__
 *
 * To run a query within a React component, call `useOnNotificationCreateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationCreateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationCreateSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOnNotificationCreateSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<OnNotificationCreateSubscription, OnNotificationCreateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnNotificationCreateSubscription, OnNotificationCreateSubscriptionVariables>(OnNotificationCreateDocument, options);
      }
export type OnNotificationCreateSubscriptionHookResult = ReturnType<typeof useOnNotificationCreateSubscription>;
export type OnNotificationCreateSubscriptionResult = ApolloReactCommon.SubscriptionResult<OnNotificationCreateSubscription>;
export const MessageCreateDataMutationDocument = gql`
    mutation MessageCreateDataMutation($chatId: ID!, $senderId: String, $message: MessageInput!, $order: OrderInput) {
  messageCreate(chatId: $chatId, senderId: $senderId, message: $message, order: $order) {
    id
  }
}
    `;
export type MessageCreateDataMutationMutationFn = ApolloReactCommon.MutationFunction<MessageCreateDataMutation, MessageCreateDataMutationVariables>;

/**
 * __useMessageCreateDataMutation__
 *
 * To run a mutation, you first call `useMessageCreateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCreateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCreateDataMutation, { data, loading, error }] = useMessageCreateDataMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      senderId: // value for 'senderId'
 *      message: // value for 'message'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageCreateDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MessageCreateDataMutation, MessageCreateDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MessageCreateDataMutation, MessageCreateDataMutationVariables>(MessageCreateDataMutationDocument, options);
      }
export type MessageCreateDataMutationHookResult = ReturnType<typeof useMessageCreateDataMutation>;
export type MessageCreateDataMutationMutationResult = ApolloReactCommon.MutationResult<MessageCreateDataMutation>;
export type MessageCreateDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<MessageCreateDataMutation, MessageCreateDataMutationVariables>;

type AllObjectMocks = {
  [Name in keyof ResolversTypes]: () => PartialDeep<ResolversTypes[Name]>;
};

export type TypeMocks = Partial<Omit<AllObjectMocks, 'Mutation' | 'Query'>>;

export type TestMocks = {
  Type?: TypeMocks;
  Query?: QueryResolvers;
  Mutation?: MutationResolvers;
};

type FlatTypes =  string | number | bigint | boolean | null | undefined | symbol | Date

export type PartialDeep<T> = T extends FlatTypes
  ? T | undefined
  : T extends Array<infer ArrayType>
  ? Array<PartialDeep<ArrayType>>
  : T extends ReadonlyArray<infer ArrayType>
  ? ReadonlyArray<ArrayType>
  : {
      [K in keyof T]?: PartialDeep<T[K]>;
    };
            